/*! Synot Games (c) 2025, Money Vaults Game, version: 1.0.0 */
(function(e, a) { for(var i in a) e[i] = a[i]; }(this, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	__webpack_require__(10);
	__webpack_require__(7);
	__webpack_require__(11);
	__webpack_require__(76);
	__webpack_require__(35);
	__webpack_require__(112);
	__webpack_require__(77);
	__webpack_require__(84);
	__webpack_require__(126);
	__webpack_require__(44);
	__webpack_require__(36);
	__webpack_require__(30);
	__webpack_require__(24);
	__webpack_require__(39);
	__webpack_require__(47);
	__webpack_require__(50);
	__webpack_require__(51);
	__webpack_require__(45);
	__webpack_require__(48);
	__webpack_require__(52);
	__webpack_require__(53);
	__webpack_require__(49);
	__webpack_require__(37);
	__webpack_require__(40);
	__webpack_require__(38);
	__webpack_require__(56);
	__webpack_require__(63);
	__webpack_require__(58);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(83);
	__webpack_require__(113);
	__webpack_require__(111);
	__webpack_require__(119);
	__webpack_require__(122);
	__webpack_require__(69);
	__webpack_require__(14);
	__webpack_require__(57);
	__webpack_require__(19);
	__webpack_require__(16);
	__webpack_require__(15);
	__webpack_require__(93);
	__webpack_require__(12);
	__webpack_require__(127);
	__webpack_require__(82);
	__webpack_require__(96);
	__webpack_require__(128);
	__webpack_require__(95);
	__webpack_require__(98);
	__webpack_require__(13);
	__webpack_require__(121);
	__webpack_require__(90);
	__webpack_require__(104);
	__webpack_require__(129);
	__webpack_require__(131);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(134);
	__webpack_require__(97);
	__webpack_require__(135);
	__webpack_require__(136);
	__webpack_require__(92);
	__webpack_require__(91);
	__webpack_require__(137);
	__webpack_require__(105);
	__webpack_require__(99);
	__webpack_require__(94);
	__webpack_require__(120);
	__webpack_require__(138);
	__webpack_require__(68);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(65);
	__webpack_require__(34);
	__webpack_require__(20);
	__webpack_require__(67);
	__webpack_require__(139);
	__webpack_require__(66);
	__webpack_require__(33);
	__webpack_require__(106);
	__webpack_require__(6);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(110);
	__webpack_require__(108);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(55);
	__webpack_require__(100);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(59);
	__webpack_require__(117);
	__webpack_require__(107);
	__webpack_require__(85);
	__webpack_require__(43);
	__webpack_require__(86);
	__webpack_require__(114);
	__webpack_require__(118);
	__webpack_require__(115);
	__webpack_require__(79);
	__webpack_require__(78);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(87);
	__webpack_require__(102);
	__webpack_require__(149);
	__webpack_require__(103);
	__webpack_require__(150);
	__webpack_require__(88);
	__webpack_require__(89);
	__webpack_require__(116);
	__webpack_require__(101);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(159);
	__webpack_require__(155);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(74);
	__webpack_require__(163);
	__webpack_require__(164);
	__webpack_require__(75);
	__webpack_require__(165);
	__webpack_require__(166);
	__webpack_require__(31);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(32);
	__webpack_require__(27);
	__webpack_require__(25);
	__webpack_require__(26);
	__webpack_require__(23);
	__webpack_require__(109);
	__webpack_require__(42);
	__webpack_require__(29);
	__webpack_require__(60);
	__webpack_require__(125);
	__webpack_require__(169);
	__webpack_require__(41);
	__webpack_require__(21);
	__webpack_require__(22);
	__webpack_require__(64);
	__webpack_require__(9);
	__webpack_require__(54);
	__webpack_require__(28);
	__webpack_require__(46);
	__webpack_require__(8);
	__webpack_require__(130);
	__webpack_require__(61);
	module.exports = __webpack_require__(62);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	neo_common_1.libraryInitialize();
	var neo_common_2 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var Strings_1 = __webpack_require__(4);
	var StageController_1 = __webpack_require__(6);
	var PreloaderProvider_1 = __webpack_require__(65);
	var Languages_1 = __webpack_require__(28);
	var ClientHostConsumer_1 = __webpack_require__(122);
	var GameDefinition_1 = __webpack_require__(123);
	var GameConfiguration_1 = __webpack_require__(124);
	var AppContext_1 = __webpack_require__(5);
	var GameData_1 = __webpack_require__(24);
	var HtmlController_1 = __webpack_require__(31);
	var GameManager_1 = __webpack_require__(23);
	var DataManager_1 = __webpack_require__(26);
	var PlatformsManager_1 = __webpack_require__(125);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Scaling_1 = __webpack_require__(8);
	var RetentionPanel_1 = __webpack_require__(46);
	var SplashScreen_1 = __webpack_require__(59);
	if (false) {
	    require("./Utils/PerfDebug/PerfDebug");
	    require("./Utils/PerfDebug/PerfDebugWindow");
	}
	var gameApp;
	var GameApp = (function (_super) {
	    __extends(GameApp, _super);
	    function GameApp() {
	        _super.apply(this, arguments);
	    }
	    GameApp.main = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Application", "start main");
	        }
	        var urlInfo = neo_common_2.UriHelper.parseUrl(window.location.href, true, true);
	        if (urlInfo["query"]["lang"] != null) {
	            GameApp.language = urlInfo["query"]["lang"];
	        }
	        RetentionPanel_1.RetentionPanel.initialize();
	        gameApp = new GameApp();
	        gameApp.load();
	    };
	    Object.defineProperty(GameApp, "gameClient", {
	        get: function () {
	            return gameApp._gameClient;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameApp.exit = function () {
	        neo_games_1.Platforms.Platforms.gameClosing();
	        if (AppContext_1.AppContext.gameConfiguration.ExitUrl != "") {
	            neo_games_1.Platforms.Platforms.userAction("exit", { url: AppContext_1.AppContext.gameConfiguration.ExitUrl });
	        }
	        return gameApp.exit();
	    };
	    GameApp.history = function () {
	        return gameApp.history();
	    };
	    GameApp.continue = function () {
	        return gameApp.continue();
	    };
	    GameApp.closeRealityCheck = function () {
	        return gameApp.closeRealityCheck();
	    };
	    GameApp.prototype.createGameClient = function (options) {
	        var gameClient = new neo_games_1.Communication.Game.GameClient(GameApp.key, options);
	        FreeRoundBonus_1.FreeRoundBonus.initialize(gameClient);
	        return gameClient;
	    };
	    GameApp.prototype.pauseAnimations = function () {
	        StageController_1.StageController.pauseAnimations();
	    };
	    GameApp.prototype.resumeAnimations = function () {
	        StageController_1.StageController.resumeAnimations();
	    };
	    GameApp.prototype.createPreloaderProvider = function () {
	        return new PreloaderProvider_1.PreloaderProvider();
	    };
	    GameApp.prototype.createGameDefinition = function (definition) {
	        return new GameDefinition_1.GameDefinition(definition);
	    };
	    GameApp.prototype.createGameConfiguration = function (configuration) {
	        return new GameConfiguration_1.GameConfiguration(configuration);
	    };
	    GameApp.prototype.createAppContext = function () {
	        return new AppContext_1.AppContext(this.gameConfiguration, this.gameDefinition);
	    };
	    GameApp.prototype.createClientHostConsumer = function () {
	        return new ClientHostConsumer_1.GameClientHostConsumer(this);
	    };
	    GameApp.prototype.requireStrings = function () {
	        __webpack_require__(4);
	    };
	    GameApp.prototype.createStage = function (quality, size) {
	        var color = 0x000000;
	        StageController_1.StageController.createStage(size.width, size.height, color, "canvas");
	    };
	    GameApp.prototype.initClientHost = function () {
	        PlatformsManager_1.PlatformsManager.create();
	        return Promise.resolve();
	    };
	    GameApp.prototype.parseLoadResult = function (loadResult) {
	        var result = null;
	        if (loadResult != null) {
	            if (loadResult.status == neo_games_1.GameEngine.Types.AppLoadStatus.Failure) {
	                if (loadResult.error != null) {
	                    result = {
	                        message: loadResult.error.message,
	                        stack: loadResult.error.stack,
	                    };
	                }
	            }
	        }
	        return result;
	    };
	    GameApp.prototype.finalizeLoad = function () {
	        if (this.loadingSucceed) {
	            if (AppContext_1.AppContext != null && AppContext_1.AppContext.current != null) {
	                var volume = AppContext_1.AppContext.current.getVolume();
	                if (!neo_common_1.Utils.isNullOrUndefined(volume)) {
	                    if (!neo_common_1.Utils.isNullOrUndefined(volume.CurrentStepNo)) {
	                        if (false) {
	                            neo_common_1.Logger.debugGroup(this.loggerGroup, "Updating sound volume by step " + volume.CurrentStepNo + ".");
	                        }
	                        HtmlController_1.HtmlController.setSound(volume.CurrentStepNo);
	                    }
	                    else {
	                        if (false) {
	                            neo_common_1.Logger.debugGroup(this.loggerGroup, "client host does not return valid value for volume 'CurrentStepNo'!");
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "client host does not returns volume data, sound volume was not updated.");
	                    }
	                }
	                Scaling_1.Scaling.resizeRoot();
	            }
	            var versionBuild = "";
	            if (false) {
	                var versionBuildValues = neo_common_1.Preloader.getVersionBuild().split("_");
	                versionBuild = neo_common_1.Utils.valueOrDefault(versionBuildValues && versionBuildValues.length > 0
	                    ? versionBuildValues[versionBuildValues.length - 1]
	                    : "", "");
	            }
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBuildVersion, versionBuild);
	            DataManager_1.DataManager.configureGameData();
	            if (neo_games_1.Platforms.Platforms.canPlay) {
	                GameManager_1.GameManager.startGame(this._gameClient, this);
	                neo_games_1.Platforms.Platforms.gameReady();
	            }
	            else {
	                var loadingScreen = document.getElementById("loading");
	                var element = document.getElementById("progressNumber");
	                if (loadingScreen != null) {
	                    loadingScreen.classList.add("_error");
	                }
	                if (element != null) {
	                    element.innerHTML = Strings_1.Strings.loaded
	                        ? Languages_1.Languages.getRid("ERROR_404")
	                        : "Internal error. Please contact support.";
	                    GameApp.gameClient.sendPlayerLogError("ERROR - Loading game", this.parseLoadResult(this._loadResult));
	                }
	                SplashScreen_1.SplashScreen.showError();
	            }
	        }
	        else {
	            neo_games_1.Platforms.Platforms.gameFailed();
	            window.onblur = null;
	            window.onfocus = null;
	            PIXI.sound.muteAll();
	            var loadingScreen = document.getElementById("loading");
	            var element = document.getElementById("progressNumber");
	            if (loadingScreen != null) {
	                loadingScreen.classList.add("_error");
	            }
	            if (element != null) {
	                element.innerHTML = Strings_1.Strings.loaded
	                    ? Languages_1.Languages.getRid("ERROR_404")
	                    : "Internal error. Please contact support.";
	                GameApp.gameClient.sendPlayerLogError("ERROR - Loading game", this.parseLoadResult(this._loadResult));
	            }
	            SplashScreen_1.SplashScreen.showError();
	            if (false) {
	                var err = "";
	                if (!neo_common_1.PreloaderInfo.instance.loadSucceed) {
	                    err += " Preloader does not load successfully!";
	                }
	                neo_common_1.Logger.errorGroup(this.loggerGroup, err);
	            }
	        }
	        if (false) {
	            PerfDebug.setup(StageController_1.StageController.Stage);
	        }
	    };
	    GameApp.openGameRoundHistory = function (isGUI) {
	        if (isGUI === void 0) { isGUI = false; }
	        if (isGUI) {
	            if (!neo_common_2.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl) &&
	                AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl !== "") {
	                if (AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl.toLowerCase() === "userci_historyurl" &&
	                    !neo_common_2.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	                    neo_games_1.Platforms.Platforms.gotoHistory({ target: AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl });
	                    if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                        return;
	                    }
	                    window.open(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl, "_blank");
	                }
	                else if (AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl.toLowerCase() === "userci_historyurl" &&
	                    neo_common_2.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	                    GameApp.openGameRoundHistoryHome();
	                }
	                else {
	                    neo_games_1.Platforms.Platforms.gotoHistory({ target: AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl });
	                    if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                        return;
	                    }
	                    window.open(AppContext_1.AppContext.gameConfiguration.GUIHistoryUrl, "_blank");
	                }
	            }
	            else {
	                GameApp.openGameRoundHistoryHome();
	            }
	        }
	        else {
	            GameApp.openGameRoundHistoryHome();
	        }
	    };
	    GameApp.openGameRoundHistoryHome = function () {
	        var gameKey = neo_common_2.UriHelper.getGameKey();
	        var urlInfo = neo_common_2.UriHelper.parseUrl(window.location.href, true, true);
	        var timeZoneOffset = new Date().getTimezoneOffset();
	        if (gameKey != null && urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
	            var serverUrl = urlInfo["query"]["serverUrl"];
	            var token = urlInfo["hash"].substring(1);
	            var lang = urlInfo["query"]["lang"] ? urlInfo["query"]["lang"] : GameApp.language;
	            var historyUrl = serverUrl + "GameRounds/" + GameApp.key + "?culture=" + lang + "&tzo=" + timeZoneOffset + "&" + token;
	            neo_games_1.Platforms.Platforms.gotoHistory({ target: historyUrl });
	            if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                return;
	            }
	            window.open(historyUrl, "_blank");
	        }
	    };
	    GameApp.openGameRoundHistoryFromUrl = function () {
	        if (!neo_common_2.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	            neo_games_1.Platforms.Platforms.gotoHistory({ target: AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl });
	            if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                return;
	            }
	            window.open(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl, "_blank");
	        }
	        else if (!neo_common_2.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.HistoryUrl)) {
	            neo_games_1.Platforms.Platforms.gotoHistory({ target: AppContext_1.AppContext.gameConfiguration.HistoryUrl });
	            if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                return;
	            }
	            window.open(AppContext_1.AppContext.gameConfiguration.HistoryUrl, "_blank");
	        }
	    };
	    GameApp.prototype.beforeExit = function () {
	        return this._gameClient.leaveGame();
	    };
	    GameApp.prototype.handleStringsLoadCompleted = function (lang) {
	        if (HtmlController_1.HtmlController.RidElements != null && HtmlController_1.HtmlController.RidElements.length > 0) {
	            for (var i = 0; i < HtmlController_1.HtmlController.RidElements.length; i++) {
	                HtmlController_1.HtmlController.RidElements[i].updateText();
	            }
	        }
	        var languageElements = document.querySelectorAll("[language]");
	        for (var i = 0; i < languageElements.length; i++) {
	            languageElements[i].setAttribute("language", lang);
	        }
	    };
	    GameApp.language = "en-US";
	    GameApp.key = "MoneyVaults";
	    return GameApp;
	}(neo_games_1.GameEngine.GameAppBase));
	exports.GameApp = GameApp;
	GameApp.main();


/***/ },
/* 2 */
/***/ function(module, exports) {

	(function() { module.exports = this["NeoCommon"]; }());

/***/ },
/* 3 */
/***/ function(module, exports) {

	(function() { module.exports = this["NeoGames"]; }());

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var AppContext_1 = __webpack_require__(5);
	function checkInitialized() {
	    neo_common_1.StringsFactory.checkInitialized();
	}
	var Strings = (function () {
	    function Strings(json) {
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(json, "json");
	        Strings._json = json;
	    }
	    Object.defineProperty(Strings, "loaded", {
	        get: function () {
	            return !neo_common_1.Utils.isNullOrUndefined(Strings._json);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Strings.get = function (key) {
	        return Strings._json && Strings._json.hasOwnProperty(key) ? Strings._json[key] : "@@" + key + "@@";
	    };
	    Strings.getWithValues = function (key) {
	        var tmpl = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            tmpl[_i - 1] = arguments[_i];
	        }
	        if (Strings._json && Strings._json.hasOwnProperty(key)) {
	            var value = Strings._json[key];
	            var regexFormat = /(\%m|\%s)/gm;
	            var matchCnt = 0;
	            while (regexFormat.exec(value)) {
	                matchCnt++;
	            }
	            var args = tmpl;
	            if (matchCnt !== args.length) {
	                throw "Provided argument count (" + args.length + ") does not match required string params count (" + matchCnt + ")";
	            }
	            var idx = -1;
	            return value.replace(regexFormat, function (match) {
	                var val = args[++idx];
	                if (neo_common_1.StringUtils.equals(match, "%m", true)) {
	                    val = neo_common_1.NumberUtils.valueToNumber(val, AppContext_1.AppContext.gameConfiguration.UseCoins ? 0 : AppContext_1.AppContext.gameConfiguration.ShowDecimalPlaces);
	                }
	                else if (!neo_common_1.StringUtils.equals(match, "%s", true)) {
	                    throw "Unknown formatter \"" + match + " !\"";
	                }
	                return val;
	            });
	        }
	        return "@@" + key + "@@";
	    };
	    return Strings;
	}());
	exports.Strings = Strings;
	window["Strings"] = Strings;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var GameApp_1 = __webpack_require__(1);
	var AppContext = (function (_super) {
	    __extends(AppContext, _super);
	    function AppContext(gameConfiguration, gameDefinition) {
	        _super.call(this, gameConfiguration, gameDefinition, GameApp_1.GameApp.key);
	        AppContext._current = this;
	    }
	    Object.defineProperty(AppContext, "current", {
	        get: function () {
	            return AppContext._current;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContext, "gameConfiguration", {
	        get: function () {
	            return AppContext._current == null ? null : AppContext._current.gameConfiguration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContext, "gameDefinition", {
	        get: function () {
	            return AppContext._current.gameDefinition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContext, "clientHost", {
	        get: function () {
	            return AppContext._current.clientHost;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AppContext.prototype.setHideAmounts = function (hideAmounts) {
	        if (AppContext.clientHost != null) {
	            AppContext.clientHost.updateSharedSetting("HideAmounts", hideAmounts.toString());
	        }
	    };
	    AppContext.prototype.getHideAmounts = function () {
	        if (AppContext.clientHost != null) {
	            if (AppContext.gameConfiguration.HideAmountsEnabled) {
	                var hideAmounts = AppContext.clientHost.getSharedSetting("HideAmounts");
	                if (!neo_common_1.Utils.isNullOrUndefined(hideAmounts)) {
	                    return neo_common_1.StringUtils.parseBoolean(hideAmounts);
	                }
	            }
	        }
	        return false;
	    };
	    AppContext._current = null;
	    return AppContext;
	}(neo_games_1.GameEngine.AppContextBase));
	exports.AppContext = AppContext;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Pool_1 = __webpack_require__(7);
	var Scaling_1 = __webpack_require__(8);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var Focus_1 = __webpack_require__(64);
	var Languages_1 = __webpack_require__(28);
	var PageVisibilityHandler_1 = __webpack_require__(55);
	var DataManager_1 = __webpack_require__(26);
	var HtmlController_1 = __webpack_require__(31);
	var StageController = (function () {
	    function StageController() {
	    }
	    StageController.pauseAnimations = function () {
	        if (false) {
	            StageController._pauseAnimations = true;
	            neo_common_1.Logger.debugGroup("StageController", "Animations was paused");
	        }
	    };
	    StageController.resumeAnimations = function () {
	        if (false) {
	            if (StageController._pauseAnimations) {
	                StageController._pauseAnimations = false;
	                StageController.redrawStage();
	                neo_common_1.Logger.debugGroup("StageController", "Animations was resumed");
	            }
	        }
	    };
	    Object.defineProperty(StageController, "textureManager", {
	        get: function () {
	            return StageController.Renderer.textureManager;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    StageController.updateTexture = function (texture) {
	        return this._noWebGL ? null : StageController.Renderer.textureManager.updateTexture(texture);
	    };
	    StageController.getTextureByResourceId = function (id) {
	        var texture = PIXI.utils.TextureCache[id];
	        var resourcePath = "";
	        if (neo_common_1.Utils.isNullOrUndefined(texture)) {
	            resourcePath = neo_common_1.PreloaderInfo.instance.getResourcePathById(id);
	            if (resourcePath) {
	                texture = PIXI.utils.TextureCache[resourcePath];
	                if (neo_common_1.Utils.isNullOrUndefined(texture)) {
	                    neo_common_1.Logger.errorGroup("StageController", "Could not find texture by id '" + id + "' (resourcePath: " + resourcePath + ")");
	                }
	            }
	            else {
	                neo_common_1.Logger.errorGroup("StageController", "Could not find resource path for id '" + id + "' !");
	            }
	        }
	        return texture;
	    };
	    StageController.handleLostWebGLContext = function () {
	        if (StageController._contextLost) {
	            return;
	        }
	        DataManager_1.DataManager.Autoplay = false;
	        PageVisibilityHandler_1.PageVisibilityHandler.Enabled = false;
	        PageVisibilityHandler_1.PageVisibilityHandler.pauseAll();
	        HtmlController_1.HtmlController.dispatchActionAllowed = false;
	        var modules = neo_games_1.Communication.Game.GameModules;
	        for (var key in modules) {
	            if (modules.hasOwnProperty(key)) {
	                ModuleManager_1.ModuleManager.disableChannelModule(modules[key]);
	            }
	        }
	        GameManager_1.GameManager.gameClient.sendPlayerLogError("ERROR - WebGL");
	        AppContext_1.AppContext.current.showDialog(Languages_1.Languages.getRid("ERROR_WEBGL"), false, "", "", "", { special: true });
	        StageController._contextLost = true;
	    };
	    StageController.createStage = function (width, height, color, canvasId) {
	        StageController.Width = width;
	        StageController.Height = height;
	        var canvas = document.getElementById(canvasId);
	        var loading = document.getElementById("loading");
	        var rendererOptions = { view: canvas, roundPixels: false };
	        rendererOptions.backgroundColor = color;
	        this.Renderer = PIXI.autoDetectRenderer(width, height, rendererOptions, this._noWebGL);
	        if (StageController.Renderer instanceof PIXI.CanvasRenderer) {
	            StageController._noWebGL = true;
	        }
	        PIXI.settings.GC_MODE = PIXI.GC_MODES.AUTO;
	        document.body.appendChild(this.Renderer.view);
	        this.Stage = new PIXI.Container();
	        Scaling_1.Scaling.scale();
	        Focus_1.Focus.focus();
	        PageVisibilityHandler_1.PageVisibilityHandler.handle();
	        loading.style.display = "block";
	        canvas.style.display = "none";
	        canvas.addEventListener("webglcontextlost", StageController.handleLostWebGLContext);
	        window["__PIXI_STAGE__"] = this.Stage;
	        window["__PIXI_RENDERER__"] = this.Renderer;
	        this.redrawStage();
	    };
	    StageController.addChild = function (element) {
	        this.Stage.addChild(element);
	    };
	    StageController.redrawStage = function () {
	        if (StageController._pauseAnimations) {
	            return;
	        }
	        Pool_1.AnimationFramePool.draw();
	        if (StageController.baseStage &&
	            StageController.baseStageContainer != null &&
	            StageController.freespinsStageContainer != null) {
	            StageController.Renderer.render(StageController.Stage);
	        }
	        else if (StageController.baseStage && StageController.baseStageContainer != null) {
	            StageController.Renderer.render(StageController.baseStageContainer);
	        }
	        else if (StageController.bonusStage && StageController.bonusStageContainer != null) {
	            StageController.Renderer.render(StageController.bonusStageContainer);
	        }
	        else {
	            StageController.Renderer.render(StageController.Stage);
	        }
	        requestAnimationFrame(StageController.redrawStage);
	    };
	    StageController.UpdatedTextures = {};
	    StageController.FPS = 60;
	    StageController.baseStage = false;
	    StageController.bonusStage = false;
	    StageController._noWebGL = false;
	    StageController._pauseAnimations = false;
	    StageController._contextLost = false;
	    return StageController;
	}());
	exports.StageController = StageController;


/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	var AnimationFramePool = (function () {
	    function AnimationFramePool() {
	    }
	    AnimationFramePool.registerFrame = function (frame) {
	        var pool = AnimationFramePool.framesPool;
	        for (var i = 0; i < pool.length; i++) {
	            if (pool[i].frame_uid === frame.frame_uid) {
	                return false;
	            }
	        }
	        pool.push(frame);
	        return true;
	    };
	    AnimationFramePool.unregisterFrame = function (frame) {
	        var pool = AnimationFramePool.framesPool;
	        var idx = -1;
	        for (var i = 0; i < pool.length; i++) {
	            if (pool[i].frame_uid === frame.frame_uid) {
	                idx = i;
	                break;
	            }
	        }
	        var result = idx > -1;
	        if (result) {
	            if (pool[idx].frame_uid === frame.frame_uid) {
	                pool.splice(idx, 1);
	            }
	            else {
	                result = false;
	            }
	        }
	        return result;
	    };
	    AnimationFramePool.draw = function () {
	        var pool = AnimationFramePool.framesPool;
	        for (var i = 0; i < pool.length; i++) {
	            var frame = pool[i];
	            frame.frame_draw();
	        }
	    };
	    AnimationFramePool.framesPool = [];
	    return AnimationFramePool;
	}());
	exports.AnimationFramePool = AnimationFramePool;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var StageController_1 = __webpack_require__(6);
	var AppContext_1 = __webpack_require__(5);
	var FrameTimer_1 = __webpack_require__(9);
	var Jackpot_1 = __webpack_require__(36);
	var EventEmitter = PIXI.utils.EventEmitter;
	var Scaling = (function () {
	    function Scaling() {
	    }
	    Scaling.scale = function () {
	        Scaling.Root = document.getElementById("root");
	        Scaling.Screen = document.getElementById("screen");
	        Scaling.IsIOs = /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
	        Scaling.IsIOsTablet = /iPad/.test(navigator.platform);
	        Scaling.IsIOsWebview = Scaling.IsIOs && window.indexedDB !== null;
	        Scaling.IOsResizeTimer = FrameTimer_1.CreateFrameTimer("scalingTimer");
	        Scaling.IOsResizeTimer.on(FrameTimer_1.FrameTimerEvents.Complete, Scaling.resizeRoot.bind(this, true));
	        Scaling.Emitter = new EventEmitter();
	        Scaling.resizeRoot();
	        window.onresize = Scaling.onResizeRoot;
	        document.body.classList.add(window["CHANNEL"] === "mobile" ? "mobile" : "desktop");
	        document.body.classList.add("ui-v" + window["UI-VERSION"]);
	        if (Scaling.isSafari()) {
	            document.body.classList.add("safari");
	        }
	        if (Scaling.isIosChrome()) {
	            document.body.classList.add("iOsChrome");
	        }
	        if (Scaling.IsIOs) {
	            Scaling.setupIOs();
	        }
	        document.addEventListener("touchend", function (event) {
	            if (AppContext_1.AppContext.gameDefinition.ClientHostType !== "Mobile") {
	                return;
	            }
	            var diff = event.timeStamp - Scaling.lastTouch;
	            Scaling.lastTouch = event.timeStamp;
	            if (!diff || diff > 400) {
	                return;
	            }
	            event.preventDefault();
	            event.stopPropagation();
	            var evt = new MouseEvent("click");
	            event.target.dispatchEvent(evt);
	        }, false);
	    };
	    Scaling.onResizeRoot = function () {
	        Scaling.resizeRoot();
	        if (Scaling.IsIOsWebview) {
	            setTimeout(function () { return Scaling.resizeRoot(); }, 500);
	        }
	    };
	    Scaling.resizeRoot = function (delayed, preventEmitEvent) {
	        if (delayed === void 0) { delayed = false; }
	        if (preventEmitEvent === void 0) { preventEmitEvent = true; }
	        if (!delayed && Scaling.IsIOs && Scaling.IOsResizeTimer && (Scaling.inIframe() || Scaling.isIosChrome())) {
	            Scaling.IOsResizeTimer.stop();
	            Scaling.IOsResizeTimer.start(Scaling.IOsResizeDelay);
	        }
	        document.body.style.overflow = "hidden";
	        neo_games_1.Plugins.StatusBar.updateHeight();
	        var sab = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sab") || "0");
	        var innerHeight = window.innerHeight + neo_games_1.Plugins.StatusBar.StatusBarHeight - sab;
	        var innerWidth = window.innerWidth + neo_games_1.Plugins.StatusBar.StatusBarWidth;
	        if (Scaling.IsIOs && neo_games_1.Plugins.StatusBar.StatusBarHeight != 0) {
	            document.documentElement.style.width = sab > 0 ? window.innerWidth + "px" : "";
	            document.documentElement.style.height = sab > 0 ? window.innerHeight - sab + "px" : "";
	            document.documentElement.style.overflow = sab > 0 ? "visible" : "";
	        }
	        var ratioWidth = innerWidth / (StageController_1.StageController.Width + Scaling.LeftPanelWidth);
	        var ratioHeight = innerHeight / (StageController_1.StageController.Height + Jackpot_1.Jackpot.Height);
	        var top = -(StageController_1.StageController.Height + Jackpot_1.Jackpot.Height - innerHeight) / 2;
	        var left = -(StageController_1.StageController.Width - innerWidth) / 2;
	        if (ratioWidth < ratioHeight) {
	            Scaling.Root.style.transform = "scale(" + ratioWidth + ")";
	            left += (Scaling.LeftPanelWidth / 2) * ratioWidth;
	        }
	        else {
	            Scaling.Root.style.transform = "scale(" + ratioHeight + ")";
	            left += (Scaling.LeftPanelWidth / 2) * ratioHeight;
	        }
	        Scaling.Root.style.top = top.toString() + "px";
	        Scaling.Root.style.left = left.toString() + "px";
	        var enabledPortrait = true;
	        if (AppContext_1.AppContext != null && AppContext_1.AppContext.current != null) {
	            enabledPortrait = AppContext_1.AppContext.gameConfiguration.UsePortraitMode;
	            if (Scaling.IsIOsTablet) {
	                enabledPortrait = false;
	            }
	            if (!enabledPortrait) {
	                document.body.classList.remove("portrait", "mobile-xs", "tablet", "tablet-xs");
	                Scaling.Root.style.height = StageController_1.StageController.Height + Jackpot_1.Jackpot.Height + "px";
	            }
	        }
	        if (enabledPortrait && window["CHANNEL"] === "mobile") {
	            var portraitRatio = innerWidth / innerHeight;
	            if (innerHeight > innerWidth && portraitRatio < Scaling.PortraitRatio) {
	                document.body.classList.add("portrait");
	                document.body.classList.remove("mobile-xs", "tablet", "tablet-xs");
	                if (portraitRatio > Scaling.PortraitMobileRatio && portraitRatio < Scaling.PortraitRatio) {
	                    document.body.classList.add("tablet");
	                    if (portraitRatio > 0.85) {
	                        document.body.classList.add("tablet-xs");
	                    }
	                }
	                else {
	                    if (portraitRatio > 0.61) {
	                        document.body.classList.add("mobile-xs");
	                    }
	                }
	                ratioWidth = innerWidth / StageController_1.StageController.Height;
	                left = -(StageController_1.StageController.Height - innerWidth) / 2;
	                Scaling.Root.style.transform = "scale(" + ratioWidth + ")";
	                Scaling.Root.style.top = "0";
	                Scaling.Root.style.left = left.toString() + "px";
	                Scaling.Root.style.height = (StageController_1.StageController.Height / innerWidth) * innerHeight + "px";
	            }
	            else {
	                document.body.classList.remove("portrait", "tablet");
	                Scaling.Root.style.height = StageController_1.StageController.Height + Jackpot_1.Jackpot.Height + "px";
	            }
	            if (document.body.classList.contains("portrait")) {
	                Scaling.Root.classList.remove("gameShadow");
	                Scaling.Screen.classList.add("gameShadow");
	            }
	            else {
	                Scaling.Root.classList.add("gameShadow");
	                Scaling.Screen.classList.remove("gameShadow");
	            }
	        }
	        else {
	            Scaling.Root.style.height = StageController_1.StageController.Height + Jackpot_1.Jackpot.Height + "px";
	            Scaling.Root.classList.add("gameShadow");
	        }
	        if (document.documentElement.scrollTop != 0) {
	            document.documentElement.scrollTop = 0;
	        }
	        document.body.style.overflow = "";
	        if (Scaling.Emitter && preventEmitEvent) {
	            Scaling.Emitter.emit(Scaling.EventResize, Scaling.isPortrait(), innerWidth / (innerHeight - Jackpot_1.Jackpot.Height), innerWidth, innerHeight, ratioWidth, ratioHeight);
	        }
	    };
	    Scaling.setupIOs = function () {
	        document.addEventListener("gesturestart", this.preventPropagation, true);
	        document.addEventListener("gesturechange", this.preventPropagation, true);
	        document.addEventListener("gestureend", this.preventPropagation, true);
	        document.addEventListener("touchmove", this.preventMovePropagation, true);
	    };
	    Scaling.preventPropagation = function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	    };
	    Scaling.preventMovePropagation = function (e) {
	        var target = e.target;
	        while (target) {
	            if (target == document.documentElement) {
	                target = null;
	            }
	            else if (target.classList.contains("mask") || target.classList.contains("dialogContent")) {
	                return;
	            }
	            else {
	                if (target.parentElement != null) {
	                    target = target.parentElement;
	                }
	            }
	        }
	        e.stopPropagation();
	        e.preventDefault();
	    };
	    Scaling.isSafari = function () {
	        var ua = navigator.userAgent;
	        var vendor = navigator.vendor;
	        return /Safari/i.test(ua) && /Apple Computer/.test(vendor);
	    };
	    Scaling.isIosChrome = function () {
	        return !!(Scaling.IsIOs && (navigator.userAgent.match("CriOS") || navigator.userAgent.match("FxiOS")));
	    };
	    Scaling.inIframe = function () {
	        try {
	            return window.self !== window.top;
	        }
	        catch (e) {
	            return true;
	        }
	    };
	    Scaling.onLoadComplete = function () {
	        document.body.classList.add("loaded");
	    };
	    Scaling.isPortrait = function () {
	        return document.body.classList.contains("portrait");
	    };
	    Scaling.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Scaling", s);
	        }
	    };
	    Scaling.EventResize = "eventResize";
	    Scaling.PortraitRatio = 0.9;
	    Scaling.PortraitMobileRatio = 0.72;
	    Scaling.LeftPanelWidth = 0;
	    Scaling.IsIOs = false;
	    Scaling.IsIOsTablet = false;
	    Scaling.IsIOsWebview = false;
	    Scaling.IOsResizeDelay = 60;
	    return Scaling;
	}());
	exports.Scaling = Scaling;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var AnimationFrame_1 = __webpack_require__(10);
	var FrameTimerPool_1 = __webpack_require__(54);
	exports.FrameTimerEvents = {
	    Progress: "progress",
	    Complete: "complete",
	};
	var FrameTimer = (function (_super) {
	    __extends(FrameTimer, _super);
	    function FrameTimer(timerName) {
	        _super.call(this);
	        this._useFrames = false;
	        this._playing = false;
	        this._paused = false;
	        timerName = neo_common_1.Utils.valueOrDefault(timerName, neo_common_1.Utils.generateUuid());
	        this._timerName = "FrameTimer-" + timerName;
	        this._uid = "FrameTimer_" + timerName + "_" + neo_common_1.Utils.generateUuid();
	        this._timerCounter = 0;
	        this._finalTimerCounter = 0;
	    }
	    FrameTimer.prototype.frame_onFrame = function () {
	        if (this._timerCounter === this._finalTimerCounter) {
	            this.stop();
	            this.conclude();
	        }
	        else {
	            this.super2.emit(exports.FrameTimerEvents.Progress);
	            this._timerCounter++;
	        }
	    };
	    Object.defineProperty(FrameTimer.prototype, "frame_name", {
	        get: function () {
	            return this._timerName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    FrameTimer.prototype.start = function (duration) {
	        var _this = this;
	        if (!this._playing) {
	            FrameTimerPool_1.FrameTimerPool.add(this._uid, this);
	        }
	        this._playing = true;
	        if (this._useFrames) {
	            this._timerCounter = 0;
	            this._finalTimerCounter = duration;
	            this.frame_stop();
	            this.count();
	        }
	        else {
	            this._startTime = new Date().getTime();
	            this._finalTimerCounter = duration * 16.7;
	            this._timer = setTimeout(function () { return _this.conclude(); }, this._finalTimerCounter);
	            if (FrameTimerPool_1.FrameTimerPool.paused) {
	                this.pause();
	            }
	        }
	    };
	    FrameTimer.prototype.stop = function () {
	        if (this._playing) {
	            FrameTimerPool_1.FrameTimerPool.remove(this._uid);
	        }
	        this._playing = false;
	        if (this._useFrames) {
	            this.frame_stop();
	        }
	        else {
	            if (this._timer != null) {
	                clearTimeout(this._timer);
	            }
	        }
	    };
	    FrameTimer.prototype.conclude = function () {
	        clearTimeout(this._timer);
	        FrameTimerPool_1.FrameTimerPool.remove(this._uid);
	        this._playing = false;
	        this.super2.emit(exports.FrameTimerEvents.Complete);
	    };
	    FrameTimer.prototype.pause = function () {
	        if (!this._playing || this._paused) {
	            return;
	        }
	        if (this._useFrames) {
	            this.frame_stop();
	        }
	        else {
	            clearTimeout(this._timer);
	            var currentTime = new Date().getTime();
	            this._finalTimerCounter -= currentTime - this._startTime;
	        }
	        this._paused = true;
	    };
	    FrameTimer.prototype.isPlaying = function () {
	        return this._playing;
	    };
	    FrameTimer.prototype.unpause = function () {
	        var _this = this;
	        if (!this._playing || !this._paused) {
	            return;
	        }
	        if (this._useFrames) {
	            this.count();
	        }
	        else {
	            this._startTime = new Date().getTime();
	            window.clearTimeout(this._timer);
	            this._timer = setTimeout(function () { return _this.conclude(); }, this._finalTimerCounter);
	        }
	        this._paused = false;
	    };
	    FrameTimer.prototype.count = function () {
	        this.frame_start();
	    };
	    FrameTimer.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("FrameTimer", s);
	        }
	    };
	    return FrameTimer;
	}(AnimationFrame_1.AnimationFrameEventEmitter));
	exports.FrameTimer = FrameTimer;
	exports.CreateFrameTimer = function (timerName) {
	    return new FrameTimer(timerName);
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var Types_1 = __webpack_require__(11);
	var Pool_1 = __webpack_require__(7);
	function AnimationFrameClass(Superclass) {
	    var sc = (Superclass || Object);
	    return (function (_super) {
	        __extends(AnimationFrame, _super);
	        function AnimationFrame() {
	            _super.call(this);
	            this._frame_stopped = true;
	            this._frame_starting = null;
	            this._frame_stopping = null;
	            this._frame_uid = null;
	            this.frame_draw = this.frame_draw.bind(this);
	        }
	        AnimationFrame.prototype.frame_onFrame = function () {
	            throw new Error("method \"frame_onFrame\" is not implemented!");
	        };
	        Object.defineProperty(AnimationFrame.prototype, "frame_name", {
	            get: function () {
	                throw new Error("property \"frame_name\" is not implemented!");
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AnimationFrame.prototype, "isFrameStopped", {
	            get: function () {
	                return this._frame_stopped;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AnimationFrame.prototype, "frame_uid", {
	            get: function () {
	                if (this._frame_uid === null) {
	                    this._frame_uid = this.frame_name + neo_common_1.Utils.generateUuid();
	                }
	                return this._frame_uid;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        AnimationFrame.prototype.frame_draw = function () {
	            if (this._frame_stopped) {
	                return;
	            }
	            this.frame_onFrame();
	        };
	        AnimationFrame.prototype.frame_log = function (msg, isError) {
	            isError = neo_common_1.Utils.valueOrDefault(isError, false);
	            if (false) {
	                neo_common_1.Logger.debugGroup("AnimationFrame", ("[" + this.frame_name + "-AnimationFrame] ") + msg);
	            }
	            if (isError) {
	                neo_common_1.Logger.errorGroup("AnimationFrame", ("[" + this.frame_name + "-AnimationFrame] ") + msg);
	            }
	        };
	        AnimationFrame.prototype.frame_start = function () {
	            if (!this._frame_stopped) {
	                return;
	            }
	            if (this._frame_starting) {
	                return;
	            }
	            this._frame_starting = true;
	            try {
	                if (Pool_1.AnimationFramePool.registerFrame(this)) {
	                    this._frame_stopped = false;
	                }
	                else {
	                    this.frame_log("failed to start (already registered in stage pool!)", true);
	                }
	            }
	            finally {
	                this._frame_starting = null;
	            }
	            this.frame_draw();
	        };
	        AnimationFrame.prototype.frame_stop = function () {
	            if (this._frame_stopped) {
	                return;
	            }
	            if (this._frame_stopping) {
	                return;
	            }
	            this._frame_stopping = true;
	            try {
	                if (Pool_1.AnimationFramePool.unregisterFrame(this)) {
	                    this._frame_stopped = true;
	                }
	                else {
	                    this.frame_log("failed to stop (not registered in stage pool!)", true);
	                }
	            }
	            finally {
	                this._frame_stopping = null;
	            }
	        };
	        return AnimationFrame;
	    }(sc));
	}
	exports.AnimationFrameClass = AnimationFrameClass;
	var AnimationFrameEventEmitter = (function (_super) {
	    __extends(AnimationFrameEventEmitter, _super);
	    function AnimationFrameEventEmitter() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(AnimationFrameEventEmitter.prototype, "super2", {
	        get: function () {
	            return this;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return AnimationFrameEventEmitter;
	}(AnimationFrameClass(Types_1.EventEmmiterClass())));
	exports.AnimationFrameEventEmitter = AnimationFrameEventEmitter;
	var AnimationFrameBaseElement = (function (_super) {
	    __extends(AnimationFrameBaseElement, _super);
	    function AnimationFrameBaseElement() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(AnimationFrameBaseElement.prototype, "super2", {
	        get: function () {
	            return this;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return AnimationFrameBaseElement;
	}(AnimationFrameClass(Types_1.BaseElementClass())));
	exports.AnimationFrameBaseElement = AnimationFrameBaseElement;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BaseElement_1 = __webpack_require__(12);
	function EventEmmiterClass() {
	    return (function (_super) {
	        __extends(EventEmmiterDescendant, _super);
	        function EventEmmiterDescendant() {
	            _super.apply(this, arguments);
	        }
	        return EventEmmiterDescendant;
	    }(PIXI.utils.EventEmitter));
	}
	exports.EventEmmiterClass = EventEmmiterClass;
	function BaseElementClass() {
	    return (function (_super) {
	        __extends(BaseElementDescendant, _super);
	        function BaseElementDescendant() {
	            _super.apply(this, arguments);
	        }
	        return BaseElementDescendant;
	    }(BaseElement_1.BaseElement));
	}
	exports.BaseElementClass = BaseElementClass;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ShapeElement_1 = __webpack_require__(13);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var Tweens_1 = __webpack_require__(15);
	var Attributes_1 = __webpack_require__(21);
	var BaseElement = (function (_super) {
	    __extends(BaseElement, _super);
	    function BaseElement() {
	        _super.call(this);
	        this._cloned = false;
	        this.__destroyed = false;
	        this._uid = this.componentName + "_" + neo_common_1.Utils.generateUuid();
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                this._uid = PerfDebug.generateElementUID(this);
	                PerfDebug.newElement(this, this.getDebugInfo());
	            }
	        }
	    }
	    BaseElement.prototype.getDebugInfo = function () {
	        if (false) {
	            var debugInfoFn = this.debugInfo;
	            return debugInfoFn ? debugInfoFn.call(this) : this.uid + "\nName: [" + this.name + "]";
	        }
	        return "";
	    };
	    Object.defineProperty(BaseElement.prototype, "tweenEngine", {
	        get: function () {
	            return this._tweenEngine;
	        },
	        set: function (engine) {
	            this._tweenEngine = engine;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElement.prototype, "cloned", {
	        get: function () {
	            return this._cloned;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElement.prototype, "destroyed", {
	        get: function () {
	            return this.__destroyed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElement.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseElement.prototype.destroy = function (options) {
	        this.assertDestroyed("destroy");
	        if (neo_common_1.Utils.isNullOrUndefined(options)) {
	            options = BaseElement._destroyOptions;
	        }
	        this.internalDestroy(options);
	        if (!neo_common_1.Utils.isNullOrUndefined(this.children)) {
	            _super.prototype.destroy.call(this, options);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.destroy(this);
	            }
	        }
	        this.__destroyed = true;
	    };
	    BaseElement.prototype.internalDestroy = function (options) {
	        Tweens_1.Tweens.removeTweens(this);
	    };
	    BaseElement.prototype.clone = function () {
	        throw new Error("Not implemented");
	    };
	    BaseElement.prototype.removeAndDestroyChildren = function () {
	        this._removeAndDestroyChildren();
	    };
	    BaseElement.prototype._removeAndDestroyChildren = function () {
	        this.assertDestroyed("_removeAndDestroyChildren");
	        var destroyOptions = {
	            children: true,
	        };
	        if (this.children != null && this.children.length > 0) {
	            for (var i = this.children.length - 1; i >= 0; i--) {
	                if (this.children[i] != null) {
	                    this.children[i].destroy(destroyOptions);
	                }
	            }
	        }
	        this.removeChildren();
	    };
	    BaseElement.prototype.assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    BaseElement.prototype.markAsCloned = function () {
	        this._markAsCloned();
	    };
	    BaseElement.prototype._markAsCloned = function () {
	        this.assertDestroyed("markAsCloned()");
	        this._cloned = true;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.clone(this);
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    BaseElement.prototype.create = function (node) {
	        this.createByNode(node);
	        this.updateByNode(node);
	    };
	    BaseElement.prototype.createByNode = function (node) {
	        if (false) {
	            if (node.hasAttribute(exports.BaseElementAttributes.DEBUG) &&
	                node.getAttribute(exports.BaseElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        this.assertDestroyed("_create()");
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        this.alpha = Attributes_1.Attributes.assignFloatAttribute(node, exports.BaseElementAttributes.ALPHA, this.alpha);
	        if (node.hasAttribute(exports.BaseElementAttributes.ROTATION)) {
	            this.rotation = this.degrees2radians(parseFloat(node.getAttribute(exports.BaseElementAttributes.ROTATION)));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.START_ROTATION)) {
	            if (node.getAttribute(exports.BaseElementAttributes.START_ROTATION) === exports.BaseElementAttributes.START_ROTATION) {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        this.scale.x = Attributes_1.Attributes.assignFloatAttribute(node, exports.BaseElementAttributes.SCALE_X, this.scale.x);
	        this.scale.y = Attributes_1.Attributes.assignFloatAttribute(node, exports.BaseElementAttributes.SCALE_Y, this.scale.y);
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE));
	        }
	        this.position.x = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.X, this.position.x);
	        this.position.y = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.Y, this.position.y);
	        this.pivot.x = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.PIVOT_X, this.pivot.x);
	        this.pivot.y = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.PIVOT_Y, this.pivot.y);
	        this.visible = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.VISIBLE, this.visible);
	        if (node.hasAttribute(exports.BaseElementAttributes.MASK)) {
	            this.maskGraphics = new ShapeElement_1.ShapeElement();
	            var shapeNode = document.createElement(node.getAttribute(exports.BaseElementAttributes.MASK));
	            shapeNode.setAttribute("FillAlpha", "1");
	            shapeNode.setAttribute("Color", "FF0000");
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_DRAW)) {
	                shapeNode.setAttribute("Draw", node.getAttribute(exports.BaseElementAttributes.MASK_DRAW));
	            }
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_X)) {
	                shapeNode.setAttribute("X", node.getAttribute(exports.BaseElementAttributes.MASK_X));
	            }
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_Y)) {
	                shapeNode.setAttribute("Y", node.getAttribute(exports.BaseElementAttributes.MASK_Y));
	            }
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_WIDTH)) {
	                shapeNode.setAttribute("Width", node.getAttribute(exports.BaseElementAttributes.MASK_WIDTH));
	            }
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_HEIGHT)) {
	                shapeNode.setAttribute("Height", node.getAttribute(exports.BaseElementAttributes.MASK_HEIGHT));
	            }
	            if (node.hasAttribute(exports.BaseElementAttributes.MASK_PATH)) {
	                shapeNode.setAttribute("Path", node.getAttribute(exports.BaseElementAttributes.MASK_PATH));
	            }
	            this.maskGraphics.create(shapeNode);
	            this.mask = this.maskGraphics;
	            this.addChild(this.mask);
	            if (this.mask == null) {
	                if (false) {
	                    this.log("ERROR no element with name: " + node.getAttribute(exports.BaseElementAttributes.MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.BITMAP_MASK)) {
	            var image = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.BaseElementAttributes.BITMAP_MASK));
	            if (image != null) {
	                this.maskSprite = new PIXI.Sprite(image);
	                if (node.hasAttribute(exports.BaseElementAttributes.BITMAP_MASK_X)) {
	                    this.maskSprite.position.x = parseFloat(node.getAttribute(exports.BaseElementAttributes.BITMAP_MASK_X));
	                }
	                if (node.hasAttribute(exports.BaseElementAttributes.BITMAP_MASK_Y)) {
	                    this.maskSprite.position.y = parseFloat(node.getAttribute(exports.BaseElementAttributes.BITMAP_MASK_Y));
	                }
	                if (!node.hasAttribute(exports.BaseElementAttributes.BITMAP_MASK_SHOW)) {
	                    this.addChild(this.maskSprite);
	                    this.mask = this.maskSprite;
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR" +
	                        this.componentName +
	                        " no image with name for mask: " +
	                        node.getAttribute(exports.BaseElementAttributes.BITMAP_MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.TWEEN_ENGINE)) {
	            this._tweenEngine = node.getAttribute(exports.BaseElementAttributes.TWEEN_ENGINE);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.createElement(this, this.getDebugInfo());
	            }
	        }
	    };
	    BaseElement.prototype.updateByNode = function (node) {
	        if (!node) {
	            this.logError("No node specified for element update!");
	            return;
	        }
	        if (false) {
	            if (node.hasAttribute(exports.BaseElementAttributes.DEBUG) &&
	                node.getAttribute(exports.BaseElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (!node.hasAttribute(exports.BaseElementAttributes.SKIP_TWEEN_RESET)) {
	            if (!node.hasAttribute("RemoveTweens") ||
	                neo_common_1.StringUtils.parseBoolean(node.getAttribute("RemoveTweens")) != false) {
	                Tweens_1.Tweens.removeTweens(this);
	            }
	        }
	        this.visible = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.VISIBLE, this.visible);
	        this.alpha = Attributes_1.Attributes.assignFloatAttribute(node, exports.BaseElementAttributes.ALPHA, this.alpha);
	        this.pivot.x = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.PIVOT_X, this.pivot.x);
	        this.pivot.y = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.PIVOT_Y, this.pivot.y);
	        if (node.hasAttribute(exports.BaseElementAttributes.ROTATION)) {
	            this.rotation = this.degrees2radians(parseFloat(node.getAttribute(exports.BaseElementAttributes.ROTATION)));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.START_ROTATION)) {
	            if (node.getAttribute(exports.BaseElementAttributes.START_ROTATION) === exports.BaseElementAttributes.START_ROTATION) {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        this.position.x = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.X, this.position.x);
	        this.position.y = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.Y, this.position.y);
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.BaseElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SKEW_X)) {
	            this.skew.x = parseFloat(node.getAttribute(exports.BaseElementAttributes.SKEW_X));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SKEW_Y)) {
	            this.skew.y = parseFloat(node.getAttribute(exports.BaseElementAttributes.SKEW_Y));
	        }
	        this.runAlphaTween(node);
	        this.runPositionTween(node);
	        this.runRotationTween(node);
	        this.runScaleTween(node);
	        this.runTween(node);
	    };
	    BaseElement.prototype.runAlphaTween = function (node) {
	        if (!node.hasAttribute(exports.BaseElementAttributes.ALPHA_TWEEN)) {
	            return false;
	        }
	        var alphaTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.ALPHA_TWEEN));
	        var alphas = alphaTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.BaseElementAttributes.ALPHA_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.ALPHA_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.ALPHA_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.ALPHA_TWEEN_LOOP, null);
	        Tweens_1.Tweens.alphaTween(this, { alphas: alphas, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    BaseElement.prototype.runPositionTween = function (node) {
	        var _this = this;
	        if (!node.hasAttribute(exports.BaseElementAttributes.POSITION_TWEEN_X) ||
	            !node.hasAttribute(exports.BaseElementAttributes.POSITION_TWEEN_Y)) {
	            return false;
	        }
	        var positionTweenX;
	        var positionTweenY;
	        var positionTweenPosition = Attributes_1.Attributes.assignStringAttribute(node, exports.BaseElementAttributes.POSITION_TWEEN_POSITION, null);
	        if (positionTweenPosition == exports.BaseElementAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.POSITION_TWEEN_X)).map(function (value) { return value + _this.position.x; });
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.POSITION_TWEEN_Y)).map(function (value) { return value + _this.position.y; });
	        }
	        else {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.POSITION_TWEEN_X));
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.POSITION_TWEEN_Y));
	        }
	        var tweenX = positionTweenX || [];
	        var tweenY = positionTweenY || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.BaseElementAttributes.POSITION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.POSITION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.POSITION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.POSITION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.positionTween(this, { tweenX: tweenX, tweenY: tweenY, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    BaseElement.prototype.runRotationTween = function (node) {
	        if (!node.hasAttribute(exports.BaseElementAttributes.ROTATION_TWEEN)) {
	            return false;
	        }
	        var rotationTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.ROTATION_TWEEN));
	        var degrees = rotationTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.BaseElementAttributes.ROTATION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.ROTATION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.ROTATION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.ROTATION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.rotationTween(this, { degrees: degrees, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    BaseElement.prototype.runScaleTween = function (node) {
	        var _this = this;
	        var scaleTweenX;
	        var scaleTweenY;
	        var scaleTween;
	        var tweenValues = [];
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE_TWEEN_X)) {
	            scaleTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.SCALE_TWEEN_X));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE_TWEEN_Y)) {
	            scaleTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BaseElementAttributes.SCALE_TWEEN_Y));
	        }
	        if (node.hasAttribute(exports.BaseElementAttributes.SCALE_TWEEN)) {
	            scaleTween = BaseElement._getPointsFromPointsAttribute(node.getAttribute(exports.BaseElementAttributes.SCALE_TWEEN));
	        }
	        if (scaleTween && scaleTween.length) {
	            tweenValues = scaleTween;
	        }
	        else if (scaleTweenX && scaleTweenY) {
	            if (scaleTweenX.length === scaleTweenY.length) {
	                tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                    return {
	                        x: scaleXValue,
	                        y: scaleTweenY[i],
	                    };
	                });
	            }
	        }
	        else if (scaleTweenX) {
	            tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                return {
	                    x: scaleXValue,
	                    y: _this.scale.y,
	                };
	            });
	        }
	        else if (scaleTweenY) {
	            tweenValues = scaleTweenY.map(function (scaleYValue, i) {
	                return {
	                    x: _this.scale.x,
	                    y: scaleYValue,
	                };
	            });
	        }
	        else {
	            return false;
	        }
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.BaseElementAttributes.SCALE_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.SCALE_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.BaseElementAttributes.SCALE_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.BaseElementAttributes.SCALE_TWEEN_LOOP, null);
	        Tweens_1.Tweens.scaleTween(this, { tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    BaseElement.prototype.runTween = function (node) {
	        if (node.hasAttribute(Tweens_1.TweensAttributes.TWEEN)) {
	            var tweens = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN));
	            for (var i = 0; i < tweens.length; i++) {
	                if (!node.hasAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)) {
	                    return false;
	                }
	                var tween = tweens[i];
	                var tweenValues = this.formatTweenValues(tween, neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)));
	                var tweenDuration = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DURATION + i) || "120");
	                var tweenEase = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_EASE + i) || "linear");
	                var tweenDelay = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DELAY + i) || "0");
	                var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, Tweens_1.TweensAttributes.TWEEN_LOOP + i, null);
	                var tweenProgress = parseFloat(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_PROGRESS + i) || "0");
	                if (tween == "scale") {
	                    tween = "scale.x";
	                    tweens[i] = "scale.y";
	                    i--;
	                }
	                var customTween = Tweens_1.Tweens.customTween(this, {
	                    tween: tween,
	                    tweenValues: tweenValues,
	                    tweenEase: tweenEase,
	                    tweenDuration: tweenDuration,
	                    tweenDelay: tweenDelay,
	                    tweenLoop: tweenLoop,
	                });
	                if (tweenProgress > 0) {
	                    customTween.progress(tweenProgress);
	                }
	            }
	        }
	        return false;
	    };
	    BaseElement.prototype.formatTweenValues = function (tween, values) {
	        var tweenValues = [];
	        if (tween === "scale") {
	            tween = "scale.x";
	        }
	        var property = tween.split(".");
	        var value;
	        for (var i = 0; i < values.length; i++) {
	            var current = values[i];
	            switch (current[current.length - 1]) {
	                case "c":
	                    if (property.length == 1) {
	                        value = this[property[0]];
	                        if (property[0] === "rotation") {
	                            value = this.radians2degrees(value);
	                        }
	                        tweenValues.push(value);
	                    }
	                    else if (property.length == 2) {
	                        tweenValues.push(this[property[0]][property[1]]);
	                    }
	                    break;
	                case "+":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] + value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                case "-":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] - value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                case "~":
	                    value = parseFloat(current.slice(0, -1));
	                    if (property[0] == "position") {
	                        if (property[1] == "x") {
	                            value = this.position.x + (value - this.getGlobalPosition().x);
	                        }
	                        else if (property[1] == "y") {
	                            value = this.position.y + (value - this.getGlobalPosition().y);
	                        }
	                    }
	                    tweenValues.push(value);
	                    break;
	                default:
	                    tweenValues.push(parseFloat(current));
	            }
	        }
	        return tweenValues;
	    };
	    BaseElement._getPointsFromPointsAttribute = function (pointsString) {
	        if (!pointsString) {
	            return [];
	        }
	        return pointsString
	            .replace(/\s/g, "")
	            .split(";")
	            .map(function (valuesPair) {
	            return /\(|\)/.test(valuesPair) ? valuesPair.slice(1, -1).split(",") : [valuesPair, valuesPair];
	        })
	            .map(function (valuesPair) {
	            return { x: parseFloat(valuesPair[0]), y: parseFloat(valuesPair[1]) };
	        });
	    };
	    BaseElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    BaseElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    BaseElement.prototype.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    BaseElement.prototype.radians2degrees = function (radians) {
	        return radians * (180 / Math.PI);
	    };
	    BaseElement.prototype.maskEnabled = function (enable) {
	        if (enable) {
	            if (this.maskGraphics) {
	                this.mask = this.maskGraphics;
	                this.addChild(this.maskGraphics);
	            }
	        }
	        else {
	            this.removeChild(this.maskGraphics);
	            this.mask = null;
	        }
	    };
	    BaseElement._destroyOptions = {
	        children: true,
	    };
	    BaseElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], BaseElement);
	    return BaseElement;
	}(PIXI.Container));
	exports.BaseElement = BaseElement;
	exports.BaseElementAttributes = {
	    ALPHA: "Alpha",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    ALPHA_TWEEN_LOOP: "AlphaTweenLoop",
	    BITMAP_MASK: "BitmapMask",
	    BITMAP_MASK_SHOW: "BitmapMaskShow",
	    BITMAP_MASK_X: "BitmapMaskX",
	    BITMAP_MASK_Y: "BitmapMaskY",
	    DEBUG: "Debug",
	    MASK: "Mask",
	    MASK_X: "MaskX",
	    MASK_Y: "MaskY",
	    MASK_WIDTH: "MaskWidth",
	    MASK_HEIGHT: "MaskHeight",
	    MASK_PATH: "MaskPath",
	    MASK_DRAW: "MaskDraw",
	    PIVOT_X: "PivotX",
	    PIVOT_Y: "PivotY",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_DELAY: "PositionTweenDelay",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    POSITION_TWEEN_LOOP: "PositionTweenLoop",
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_DEGREES: "RotationTweenDegrees",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_LOOP: "RotationTweenLoop",
	    ROTATION: "Rotation",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_DELAY: "ScaleTweenDelay",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_LOOP: "ScaleTweenLoop",
	    SCALE_TWEEN_X: "ScaleTweenX",
	    SCALE_TWEEN_Y: "ScaleTweenY",
	    SCALE: "Scale",
	    SCALE_X: "ScaleX",
	    SCALE_Y: "ScaleY",
	    SKEW_X: "SkewX",
	    SKEW_Y: "SkewY",
	    START_ROTATION: "StartRotation",
	    TWEEN_ENGINE: "TweenEngine",
	    VISIBLE: "Visible",
	    X: "X",
	    Y: "Y",
	    SKIP_TWEEN_RESET: "SkipTweenReset",
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Tweens_1 = __webpack_require__(15);
	var StyleManager_1 = __webpack_require__(20);
	var Attributes_1 = __webpack_require__(21);
	var CustomUtils_1 = __webpack_require__(22);
	var ShapeElement = (function (_super) {
	    __extends(ShapeElement, _super);
	    function ShapeElement() {
	        _super.call(this);
	        this._color = 0xff0000;
	        this._uid = this.componentName + "_" + neo_common_1.Utils.generateUuid();
	    }
	    ShapeElement.prototype.internalDestroy = function (options) {
	        Tweens_1.Tweens.removeTweens(this);
	    };
	    ShapeElement.prototype.create = function (node) {
	        this.createByNode(node);
	        this.updateByNode(node);
	    };
	    ShapeElement.prototype.createByNode = function (node) {
	        if (false) {
	            if (node.hasAttribute(exports.ShapeElementAttributes.DEBUG) &&
	                node.getAttribute(exports.ShapeElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        this._nodeDefinition = node;
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.STYLE)) {
	            this.style = StyleManager_1.StyleManager.Styles[node.getAttribute(exports.ShapeElementAttributes.STYLE)];
	            if (this.style != null) {
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name: " + node.getAttribute(exports.ShapeElementAttributes.STYLE));
	                }
	            }
	        }
	        this._color = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.COLOR, this._color, 16);
	        this._fillAlpha = Attributes_1.Attributes.assignFloatAttribute(node, exports.ShapeElementAttributes.FILL_ALPHA, this._fillAlpha);
	        this._lineWidth = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.LINE_WIDTH, this._lineWidth);
	        this._lineColor = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.LINE_COLOR, this._lineColor, 16);
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.X)) {
	            this.position.x = parseInt(node.getAttribute(exports.ShapeElementAttributes.X));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.Y)) {
	            this.position.y = parseInt(node.getAttribute(exports.ShapeElementAttributes.Y));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.WIDTH)) {
	            this._width = parseInt(node.getAttribute(exports.ShapeElementAttributes.WIDTH));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.HEIGHT)) {
	            this._height = parseInt(node.getAttribute(exports.ShapeElementAttributes.HEIGHT));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.RADIUS)) {
	            this._radius = parseInt(node.getAttribute(exports.ShapeElementAttributes.RADIUS));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.BLEND_MODE)) {
	            this.blendMode = CustomUtils_1.CustomUtils.getBlendMode(parseInt(node.getAttribute(exports.ShapeElementAttributes.BLEND_MODE)));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.DRAW)) {
	            this.clear();
	            this.beginFill(this._color, this._fillAlpha);
	            this.lineStyle(this._lineWidth, this._lineColor);
	            this.draw(node, node.getAttribute(exports.ShapeElementAttributes.DRAW));
	            this.endFill();
	        }
	        else {
	            if (node.hasAttribute(exports.ShapeElementAttributes.WIDTH)) {
	                this._width = parseInt(node.getAttribute(exports.ShapeElementAttributes.WIDTH));
	            }
	            else {
	                if (false) {
	                    this.log("ERROR " + exports.ShapeElementAttributes.WIDTH + " attribute doesn't exits");
	                }
	            }
	            if (node.hasAttribute(exports.ShapeElementAttributes.HEIGHT)) {
	                this._height = parseInt(node.getAttribute(exports.ShapeElementAttributes.HEIGHT));
	            }
	            else {
	                if (false) {
	                    this.log("ERROR " + exports.ShapeElementAttributes.HEIGHT + " attribute doesn't exits");
	                }
	            }
	            if (this._width != null && this._height != null) {
	                this.clear();
	                this.beginFill(this._color, this._fillAlpha);
	                this.lineStyle(this._lineWidth, this._lineColor);
	                this.drawRect(0, 0, this._width, this._height);
	                this.endFill();
	            }
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.VISIBLE)) {
	            this.visible = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ShapeElementAttributes.VISIBLE));
	        }
	    };
	    ShapeElement.prototype.draw = function (node, objectType) {
	        switch (objectType) {
	            case "Circle":
	                this.drawCircle(0, 0, this._radius);
	                break;
	            case "Ellipse":
	                this.drawEllipse(0, 0, this._width, this._height);
	                break;
	            case "Polygon":
	                var path = node.hasAttribute("Path") ? neo_common_1.ArrayUtils.stringArray(node.getAttribute("Path"), "|") : [];
	                var points = [];
	                for (var i = 0; i < path.length; i++) {
	                    var point = neo_common_1.ArrayUtils.numberArray(path[i]);
	                    points.push(new PIXI.Point(point[0], point[1]));
	                }
	                this.drawPolygon(points);
	                break;
	            case "Rect":
	                this.drawRect(0, 0, this._width, this._height);
	                break;
	            case "RoundedRect":
	                this.drawRoundedRect(0, 0, this._width, this._height, this._radius);
	                break;
	            default:
	                if (false) {
	                    this.log("ERROR objectType: " + objectType + " not supported.");
	                }
	                break;
	        }
	    };
	    ShapeElement.prototype.updateByNode = function (node) {
	        if (false) {
	            if (node.hasAttribute(exports.ShapeElementAttributes.DEBUG) &&
	                node.getAttribute(exports.ShapeElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        Tweens_1.Tweens.removeTweens(this);
	        if (node.hasAttribute(exports.ShapeElementAttributes.VISIBLE)) {
	            this.visible = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ShapeElementAttributes.VISIBLE));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.ALPHA)) {
	            this.alpha = parseFloat(node.getAttribute(exports.ShapeElementAttributes.ALPHA));
	        }
	        this.pivot.x = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.PIVOT_X, this.pivot.x);
	        this.pivot.y = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.PIVOT_Y, this.pivot.y);
	        if (node.hasAttribute(exports.ShapeElementAttributes.ROTATION)) {
	            this.rotation = this.degrees2radians(parseFloat(node.getAttribute(exports.ShapeElementAttributes.ROTATION)));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.X)) {
	            this.position.x = parseInt(node.getAttribute(exports.ShapeElementAttributes.X));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.Y)) {
	            this.position.y = parseInt(node.getAttribute(exports.ShapeElementAttributes.Y));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.ShapeElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.MASK)) {
	            var next = node.parentElement.firstElementChild;
	            while (next != null) {
	                if (next.nodeName === node.getAttribute(exports.ShapeElementAttributes.MASK)) {
	                    var shapeElement = new ShapeElement();
	                    shapeElement.create(next);
	                    this.mask = shapeElement;
	                }
	                next = next.nextElementSibling;
	            }
	            if (this.mask == null) {
	                if (false) {
	                    this.log("ERROR no element with name: " + node.getAttribute(exports.ShapeElementAttributes.MASK));
	                }
	            }
	        }
	        this.runAlphaTween(node);
	        this.runPositionTween(node);
	        this.runRotationTween(node);
	        this.runScaleTween(node);
	        this.runTween(node);
	    };
	    ShapeElement.prototype.runAlphaTween = function (node) {
	        if (!node.hasAttribute(exports.ShapeElementAttributes.ALPHA_TWEEN)) {
	            return false;
	        }
	        var alphaTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.ALPHA_TWEEN));
	        var alphas = alphaTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ShapeElementAttributes.ALPHA_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.ALPHA_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.ALPHA_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ShapeElementAttributes.ALPHA_TWEEN_LOOP, null);
	        Tweens_1.Tweens.alphaTween(this, { alphas: alphas, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ShapeElement.prototype.runPositionTween = function (node) {
	        var _this = this;
	        if (!node.hasAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_X) ||
	            !node.hasAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_Y)) {
	            return false;
	        }
	        var positionTweenX;
	        var positionTweenY;
	        var positionTweenPosition = Attributes_1.Attributes.assignStringAttribute(node, exports.ShapeElementAttributes.POSITION_TWEEN_POSITION, null);
	        if (positionTweenPosition == exports.ShapeElementAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_X)).map(function (value) { return value + _this.position.x; });
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_Y)).map(function (value) { return value + _this.position.y; });
	        }
	        else {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_X));
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.POSITION_TWEEN_Y));
	        }
	        var tweenX = positionTweenX || [];
	        var tweenY = positionTweenY || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ShapeElementAttributes.POSITION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.POSITION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.POSITION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ShapeElementAttributes.POSITION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.positionTween(this, { tweenX: tweenX, tweenY: tweenY, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ShapeElement.prototype.runRotationTween = function (node) {
	        if (!node.hasAttribute(exports.ShapeElementAttributes.ROTATION_TWEEN)) {
	            return false;
	        }
	        var rotationTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.ROTATION_TWEEN));
	        var degrees = rotationTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ShapeElementAttributes.ROTATION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.ROTATION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.ROTATION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ShapeElementAttributes.ROTATION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.rotationTween(this, { degrees: degrees, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ShapeElement.prototype.runScaleTween = function (node) {
	        var _this = this;
	        var scaleTweenX;
	        var scaleTweenY;
	        var scaleTween;
	        var tweenValues = [];
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_TWEEN_X)) {
	            scaleTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.SCALE_TWEEN_X));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_TWEEN_Y)) {
	            scaleTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ShapeElementAttributes.SCALE_TWEEN_Y));
	        }
	        if (node.hasAttribute(exports.ShapeElementAttributes.SCALE_TWEEN)) {
	            scaleTween = ShapeElement._getPointsFromPointsAttribute(node.getAttribute(exports.ShapeElementAttributes.SCALE_TWEEN));
	        }
	        if (scaleTween && scaleTween.length) {
	            tweenValues = scaleTween;
	        }
	        else if (scaleTweenX && scaleTweenY) {
	            if (scaleTweenX.length === scaleTweenY.length) {
	                tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                    return {
	                        x: scaleXValue,
	                        y: scaleTweenY[i],
	                    };
	                });
	            }
	        }
	        else if (scaleTweenX) {
	            tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                return {
	                    x: scaleXValue,
	                    y: _this.scale.y,
	                };
	            });
	        }
	        else if (scaleTweenY) {
	            tweenValues = scaleTweenY.map(function (scaleYValue, i) {
	                return {
	                    x: _this.scale.x,
	                    y: scaleYValue,
	                };
	            });
	        }
	        else {
	            return false;
	        }
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ShapeElementAttributes.SCALE_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.SCALE_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ShapeElementAttributes.SCALE_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ShapeElementAttributes.SCALE_TWEEN_LOOP, null);
	        Tweens_1.Tweens.scaleTween(this, { tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ShapeElement.prototype.runTween = function (node) {
	        if (node.hasAttribute(Tweens_1.TweensAttributes.TWEEN)) {
	            var tweens = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN));
	            for (var i = 0; i < tweens.length; i++) {
	                if (!node.hasAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)) {
	                    return false;
	                }
	                var tween = tweens[i];
	                var tweenValues = this.formatTweenValues(tween, neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)));
	                var tweenDuration = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DURATION + i) || "120");
	                var tweenEase = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_EASE + i) || "linear");
	                var tweenDelay = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DELAY + i) || "0");
	                var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, Tweens_1.TweensAttributes.TWEEN_LOOP + i, null);
	                if (tween == "scale") {
	                    tween = "scale.x";
	                    tweens[i] = "scale.y";
	                    i--;
	                }
	                Tweens_1.Tweens.customTween(this, { tween: tween, tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	            }
	        }
	        return false;
	    };
	    ShapeElement.prototype.formatTweenValues = function (tween, values) {
	        var tweenValues = [];
	        if (tween === "scale") {
	            tween = "scale.x";
	        }
	        var property = tween.split(".");
	        var value;
	        for (var i = 0; i < values.length; i++) {
	            var current = values[i];
	            switch (current[current.length - 1]) {
	                case "c":
	                    if (property.length == 1) {
	                        value = this[property[0]];
	                        if (property[0] === "rotation") {
	                            value = this.radians2degrees(value);
	                        }
	                        tweenValues.push(value);
	                    }
	                    else if (property.length == 2) {
	                        tweenValues.push(this[property[0]][property[1]]);
	                    }
	                    break;
	                case "+":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] + value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                case "-":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] - value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                default:
	                    tweenValues.push(parseFloat(current));
	            }
	        }
	        return tweenValues;
	    };
	    ShapeElement._getPointsFromPointsAttribute = function (pointsString) {
	        if (!pointsString) {
	            return [];
	        }
	        return pointsString
	            .replace(/\s/g, "")
	            .split(";")
	            .map(function (valuesPair) {
	            return /\(|\)/.test(valuesPair) ? valuesPair.slice(1, -1).split(",") : [valuesPair, valuesPair];
	        })
	            .map(function (valuesPair) {
	            return { x: parseFloat(valuesPair[0]), y: parseFloat(valuesPair[1]) };
	        });
	    };
	    Object.defineProperty(ShapeElement.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ShapeElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShapeElement.prototype.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    ShapeElement.prototype.radians2degrees = function (radians) {
	        return radians * (180 / Math.PI);
	    };
	    ShapeElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    ShapeElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    ShapeElement.prototype.clone = function () {
	        var element = new ShapeElement();
	        element.create(this._nodeDefinition);
	        return element;
	    };
	    ShapeElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ShapeElement);
	    return ShapeElement;
	}(PIXI.Graphics));
	exports.ShapeElement = ShapeElement;
	exports.ShapeElementAttributes = {
	    ALPHA: "Alpha",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    ALPHA_TWEEN_LOOP: "AlphaTweenLoop",
	    COLOR: "Color",
	    DRAW: "Draw",
	    DEBUG: "Debug",
	    FILL_ALPHA: "FillAlpha",
	    HEIGHT: "Height",
	    LINE_COLOR: "LineColor",
	    LINE_WIDTH: "LineWidth",
	    MASK: "Mask",
	    PIVOT_X: "PivotX",
	    PIVOT_Y: "PivotY",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_DELAY: "PositionTweenDelay",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    POSITION_TWEEN_LOOP: "PositionTweenLoop",
	    ROTATION: "Rotation",
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    ROTATION_TWEEN_LOOP: "RotationTweenLoop",
	    BLEND_MODE: "BlendMode",
	    RADIUS: "Radius",
	    SCALE: "Scale",
	    SCALE_X: "ScaleX",
	    SCALE_Y: "ScaleY",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_DELAY: "ScaleTweenDelay",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_LOOP: "ScaleTweenLoop",
	    SCALE_TWEEN_X: "ScaleTweenX",
	    SCALE_TWEEN_Y: "ScaleTweenY",
	    STYLE: "Style",
	    VISIBLE: "Visible",
	    WIDTH: "Width",
	    X: "X",
	    Y: "Y",
	};


/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	exports.ComponentTypes = {
	    Element: "Element",
	    DisplayObject: "DisplayObject",
	    HtmlElement: "HtmlElement",
	    PlayList: "PlayList",
	    Song: "Song",
	    Style: "Style",
	    HtmlStyle: "HtmlStyle",
	    Controller: "Controller",
	    LinkedElement: "LinkedElement",
	    ActionSet: "ActionSet",
	};


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var GsapEffects_1 = __webpack_require__(16);
	var Tweens = (function () {
	    function Tweens() {
	    }
	    Tweens.registerTween = function (uid, tween) {
	        if (uid != null) {
	            if (Tweens.tweenArray[uid] != null) {
	                Tweens.tweenArray[uid].push(tween);
	            }
	            else {
	                Tweens.tweenArray[uid] = [tween];
	            }
	        }
	    };
	    Tweens.getRegisteredTweens = function (uid) {
	        if (uid != null) {
	            if (Tweens.tweenArray[uid] != null) {
	                return {
	                    tweens: Tweens.tweenArray[uid],
	                    length: Tweens.tweenArray[uid].length,
	                };
	            }
	            return null;
	        }
	        else {
	            return {
	                tweens: Tweens.tweenArray,
	                length: Object.keys(Tweens.tweenArray).length,
	            };
	        }
	    };
	    Tweens.removeTweenFromRegistry = function (uid, property) {
	        if (property === void 0) { property = "all"; }
	        if (uid != null) {
	            if (Tweens.tweenArray[uid] != null) {
	                for (var i = Tweens.tweenArray[uid].length - 1; i >= 0; i--) {
	                    var tween = Tweens.tweenArray[uid][i];
	                    if (tween.name === "alphaTween" && (property === "alpha" || property === "all")) {
	                        Tweens.tweenArray[uid][i] = null;
	                        Tweens.tweenArray[uid].splice(i, 1);
	                    }
	                    if (tween.name === "positionTween" && (property === "position" || property === "all")) {
	                        Tweens.tweenArray[uid][i] = null;
	                        Tweens.tweenArray[uid].splice(i, 1);
	                    }
	                    if (tween.name === "scaleTween" && (property === "scale" || property === "all")) {
	                        Tweens.tweenArray[uid][i] = null;
	                        Tweens.tweenArray[uid].splice(i, 1);
	                    }
	                    if (tween.name === "rotationTween" && (property === "rotation" || property === "all")) {
	                        Tweens.tweenArray[uid][i] = null;
	                        Tweens.tweenArray[uid].splice(i, 1);
	                    }
	                    if (tween.name === property + "Tween" &&
	                        property !== "alpha" &&
	                        property !== "position" &&
	                        property !== "scale" &&
	                        property !== "rotation") {
	                        Tweens.tweenArray[uid][i] = null;
	                        Tweens.tweenArray[uid].splice(i, 1);
	                    }
	                }
	            }
	        }
	    };
	    Tweens.restartTweens = function (uid) {
	        if (Tweens.tweenArray[uid] != null) {
	            for (var i = 0; i < Tweens.tweenArray[uid].length; i++) {
	                Tweens.tweenArray[uid][i].restart();
	            }
	        }
	    };
	    Tweens.removeTweens = function (object, property) {
	        if (property === void 0) { property = "all"; }
	        if (object !== undefined) {
	            if (object.uid != null) {
	                if (Tweens.tweenArray[object.uid] != null) {
	                    if (Tweens.tweenArray[object.uid].length > 0) {
	                        for (var i = Tweens.tweenArray[object.uid].length - 1; i >= 0; i--) {
	                            var tween = Tweens.tweenArray[object.uid][i];
	                            if (tween.name === "alphaTween" && (property === "alpha" || property === "all")) {
	                                tween.kill({ alpha: true }, object);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                            else if (tween.name === "positionTween" &&
	                                (property === "position" || property === "all")) {
	                                tween.kill(null, object.position);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                            else if (tween.name === "scaleTween" && (property === "scale" || property === "all")) {
	                                tween.kill(null, object.scale);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                            else if (tween.name === "rotationTween" &&
	                                (property === "rotation" || property === "all")) {
	                                tween.kill({ rotation: true }, object);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                            else if (tween.name === "skewTween" && (property === "skew" || property === "all")) {
	                                tween.kill(null, object.skew);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                            else if (tween.name === property + "Tween" || property === "all") {
	                                var customProperty = property;
	                                if (property == "all" &&
	                                    Tweens.RemoveAllTweensExclude.indexOf(tween.name.slice(0, -5)) > -1) {
	                                    continue;
	                                }
	                                if (customProperty == "all") {
	                                    customProperty = tween.name.replace("Tween", "");
	                                }
	                                tween.kill((_a = {}, _a[customProperty] = true, _a), object);
	                                Tweens.tweenArray[object.uid][i] = null;
	                                Tweens.tweenArray[object.uid].splice(i, 1);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        var _a;
	    };
	    Tweens.alphaTween = function (object, options) {
	        if (options.alphas.length < 2) {
	            return;
	        }
	        object.alpha = options.alphas.shift();
	        var tween;
	        if (options.alphas.length === 1) {
	            tween = GsapEffects_1.GsapEffects.alphaTween_Tweenlite(object, options);
	        }
	        else if (options.alphas.length > 1) {
	            tween = GsapEffects_1.GsapEffects.alphaTween_TimelineLite(object, options);
	        }
	        tween.name = "alphaTween";
	        tween.objectName = object.name;
	        this.registerTween(object.uid, tween);
	        return tween;
	    };
	    Tweens.positionTween = function (object, options) {
	        if ((!options.tweenX && !options.tweenY) || (options.tweenX.length < 2 && options.tweenY.length < 2)) {
	            if (false) {
	                this.log("ERROR No tweenX or tweenY option for " + (object.name ? object.name : "object"));
	            }
	            return;
	        }
	        if (options.tweenX.length !== options.tweenY.length) {
	            if (options.tweenX.length > options.tweenY.length) {
	                options.tweenY = Array.apply(null, Array(options.tweenX.length)).map(function (value) { return object.position.y || 0; });
	            }
	            else {
	                options.tweenX = Array.apply(null, Array(options.tweenY.length)).map(function (value) { return object.position.x || 0; });
	            }
	        }
	        object.position.x = options.tweenX.shift();
	        object.position.y = options.tweenY.shift();
	        var tween;
	        if (options.tweenX.length === 1) {
	            tween = GsapEffects_1.GsapEffects.positionTween_Tweenlite(object, options);
	        }
	        else if (options.tweenX.length > 1) {
	            tween = GsapEffects_1.GsapEffects.positionTween_TimelineLite(object, options);
	        }
	        tween.name = "positionTween";
	        tween.objectName = object.name;
	        this.registerTween(object.uid, tween);
	        return tween;
	    };
	    Tweens.rotationTween = function (object, options) {
	        if (options.degrees.length < 2) {
	            return;
	        }
	        object.rotation = Tweens.degrees2radians(options.degrees.shift());
	        var tween;
	        if (options.degrees.length === 1) {
	            tween = GsapEffects_1.GsapEffects.rotationTween_Tweenlite(object, options);
	        }
	        else if (options.degrees.length > 1) {
	            tween = GsapEffects_1.GsapEffects.rotationTween_TimelineLite(object, options);
	        }
	        tween.name = "rotationTween";
	        tween.objectName = object.name;
	        this.registerTween(object.uid, tween);
	        return tween;
	    };
	    Tweens.scaleTween = function (object, options) {
	        if (options.tweenValues.length < 2) {
	            if (false) {
	                this.log("ERROR No ScaleTweenX or ScaleTweenY or ScaleTween option for " +
	                    (object.name ? object.name : "object"));
	            }
	            return;
	        }
	        object.scale.x = options.tweenValues[0].x;
	        object.scale.y = options.tweenValues[0].y;
	        options.tweenValues.shift();
	        var tween;
	        if (options.tweenValues.length === 1) {
	            tween = GsapEffects_1.GsapEffects.scaleTween_Tweenlite(object, options);
	        }
	        else if (options.tweenValues.length > 1) {
	            tween = GsapEffects_1.GsapEffects.scaleTween_TimelineLite(object, options);
	        }
	        tween.name = "scaleTween";
	        tween.objectName = object.name;
	        this.registerTween(object.uid, tween);
	        return tween;
	    };
	    Tweens.customTween = function (object, options) {
	        var property = options.tween.split(".");
	        options = Tweens.prepareTweenData(options);
	        if (property.length == 1) {
	            object[property[0]] = options.tweenValues.shift();
	        }
	        else if (property.length == 2) {
	            object[property[0]][property[1]] = options.tweenValues.shift();
	        }
	        var tween;
	        if (options.tweenValues.length === 1) {
	            tween = GsapEffects_1.GsapEffects.tween_Tweenlite(object, options);
	        }
	        else if (options.tweenValues.length > 1) {
	            tween = GsapEffects_1.GsapEffects.tween_TimelineLite(object, options);
	        }
	        tween.name = property[0] + "Tween";
	        tween.objectName = object.name;
	        this.registerTween(object.uid, tween);
	        return tween;
	    };
	    Tweens.prepareTweenData = function (data) {
	        var length = data.tweenValues.length - 1;
	        data.tweenEase = Tweens.stringValueToFormatedArray(length, data.tweenEase, "linear");
	        data.tweenDelay = Tweens.numberValueToFormatedArray(length, data.tweenDelay, 0);
	        data.tweenDelay = data.tweenDelay.map(function (x) {
	            return x * GsapEffects_1.GsapEffects.TickTime;
	        });
	        if (data.tweenDuration != null) {
	            if (data.tweenDuration.length == 1) {
	                var partDuration = data.tweenDuration[0] / length;
	                data.tweenDuration = Tweens.numberValueToFormatedArray(length, null, partDuration);
	            }
	            else {
	                data.tweenDuration = Tweens.numberValueToFormatedArray(length, data.tweenDuration, 30);
	            }
	        }
	        else {
	            var defaultValue = Math.floor(Math.random() * 120 + 120);
	            data.tweenDuration = Tweens.numberValueToFormatedArray(length, null, defaultValue);
	        }
	        data.tweenDuration = data.tweenDuration.map(function (x) {
	            return x * GsapEffects_1.GsapEffects.TickTime;
	        });
	        if (data.tween == "rotation") {
	            data.tweenValues = data.tweenValues.map(function (x) {
	                return Tweens.degrees2radians(x);
	            });
	        }
	        return data;
	    };
	    Tweens.stringValueToFormatedArray = function (length, data, defaultValue) {
	        if (data != null) {
	            if (Array.isArray(data)) {
	                if (data.length == length) {
	                    return data;
	                }
	                if (data.length < length) {
	                    var singleData = data[0];
	                    for (var i = data.length; i < length; i++) {
	                        data.push(singleData);
	                    }
	                    return data;
	                }
	            }
	            else {
	                return Array.apply(null, Array(length)).map(function (value) { return data; });
	            }
	        }
	        else {
	            return Array.apply(null, Array(length)).map(function (value) { return defaultValue; });
	        }
	        return null;
	    };
	    Tweens.numberValueToFormatedArray = function (length, data, defaultValue) {
	        if (data != null) {
	            if (Array.isArray(data)) {
	                if (data.length == length) {
	                    return data;
	                }
	                if (data.length < length) {
	                    var singleData = data[0];
	                    for (var i = data.length; i < length; i++) {
	                        data.push(singleData);
	                    }
	                    return data;
	                }
	            }
	            else {
	                return Array.apply(null, Array(length)).map(function (value) { return data; });
	            }
	        }
	        else {
	            return Array.apply(null, Array(length)).map(function (value) { return defaultValue; });
	        }
	        return null;
	    };
	    Tweens.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    Object.defineProperty(Tweens, "componentName", {
	        get: function () {
	            return "Tweens";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Tweens.log = function (s) {
	        if (false) {
	            var compName = Tweens.componentName;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    Tweens.RemoveAllTweensExclude = ["currentValue", "_frame"];
	    Tweens.tweenArray = [];
	    return Tweens;
	}());
	exports.Tweens = Tweens;
	exports.TweensAttributes = {
	    TWEEN: "Tween",
	    TWEEN_VALUES: "TweenValues",
	    TWEEN_EASE: "TweenEase",
	    TWEEN_DURATION: "TweenDuration",
	    TWEEN_DELAY: "TweenDelay",
	    TWEEN_LOOP: "TweenLoop",
	    TWEEN_PROGRESS: "TweenProgress",
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var gsap_1 = __webpack_require__(17);
	var CustomEase_1 = __webpack_require__(19);
	var GsapEffects = (function () {
	    function GsapEffects() {
	    }
	    GsapEffects.prototype.internalDestroy = function (options) { };
	    GsapEffects.alphaTween_TimelineLite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.alphas.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var alphaTimeline = new gsap_1.TimelineLite({
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            paused: tweenPaused || false,
	        });
	        options.alphas.forEach(function (alpha) {
	            alphaTimeline.to(object, tweenDurationPerPart, {
	                alpha: alpha,
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            alphaTimeline.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            alphaTimeline.eventCallback("onComplete", alphaTimeline.restart);
	        }
	        return alphaTimeline;
	    };
	    GsapEffects.alphaTween_Tweenlite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.alphas.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var alphaTweenLite;
	        alphaTweenLite = gsap_1.TweenLite.to(object, tweenDurationPerPart, {
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            alpha: options.alphas,
	            ease: tweenEase,
	            paused: tweenPaused || false,
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            alphaTweenLite.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            alphaTweenLite.eventCallback("onComplete", alphaTweenLite.restart);
	        }
	        return alphaTweenLite;
	    };
	    GsapEffects.positionTween_TimelineLite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.tweenX.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var positionTimeline = new gsap_1.TimelineLite({
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	        });
	        options.tweenX.forEach(function (tweenX, i) {
	            positionTimeline.to(object.position, tweenDurationPerPart, {
	                useFrames: GsapEffects.UseFrames,
	                x: tweenX,
	                y: options.tweenY[i],
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            positionTimeline.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            positionTimeline.eventCallback("onComplete", positionTimeline.restart);
	        }
	        return positionTimeline;
	    };
	    GsapEffects.positionTween_Tweenlite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.tweenX.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenBezier = options.bezier;
	        var tweenPaused = options.paused;
	        var positionTweenLite;
	        if (tweenBezier != null) {
	            positionTweenLite = gsap_1.TweenLite.to(object.position, tweenDurationPerPart, {
	                bezier: tweenBezier || 0,
	                useFrames: GsapEffects.UseFrames,
	                delay: options.tweenDelay != null && options.tweenDelay > 0
	                    ? options.tweenDelay * GsapEffects.TickTime
	                    : 0,
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        }
	        else {
	            positionTweenLite = gsap_1.TweenLite.to(object.position, tweenDurationPerPart, {
	                useFrames: GsapEffects.UseFrames,
	                delay: options.tweenDelay != null && options.tweenDelay > 0
	                    ? options.tweenDelay * GsapEffects.TickTime
	                    : 0,
	                x: options.tweenX[0],
	                y: options.tweenY[0],
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        }
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            positionTweenLite.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            positionTweenLite.eventCallback("onComplete", positionTweenLite.restart);
	        }
	        return positionTweenLite;
	    };
	    GsapEffects.rotationTween_TimelineLite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.degrees.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var rotationTimeline = new gsap_1.TimelineLite({
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            paused: tweenPaused || false,
	        });
	        options.degrees.map(GsapEffects.degrees2radians).forEach(function (degree) {
	            rotationTimeline.to(object, tweenDurationPerPart, {
	                useFrames: GsapEffects.UseFrames,
	                rotation: degree,
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            rotationTimeline.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            rotationTimeline.eventCallback("onComplete", rotationTimeline.restart);
	        }
	        return rotationTimeline;
	    };
	    GsapEffects.rotationTween_Tweenlite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.degrees.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var rotationTweenLite;
	        rotationTweenLite = gsap_1.TweenLite.to(object, tweenDurationPerPart, {
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            rotation: GsapEffects.degrees2radians(options.degrees[0]),
	            ease: tweenEase,
	            paused: tweenPaused || false,
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            rotationTweenLite.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            rotationTweenLite.eventCallback("onComplete", rotationTweenLite.restart);
	        }
	        return rotationTweenLite;
	    };
	    GsapEffects.scaleTween_TimelineLite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.tweenValues.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var scaleTimeline = new gsap_1.TimelineLite({
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            paused: tweenPaused || false,
	        });
	        options.tweenValues.forEach(function (tweenValue) {
	            scaleTimeline.to(object.scale, tweenDurationPerPart, {
	                useFrames: GsapEffects.UseFrames,
	                x: tweenValue.x,
	                y: tweenValue.y,
	                ease: tweenEase,
	                paused: tweenPaused || false,
	            });
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            scaleTimeline.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            scaleTimeline.eventCallback("onComplete", scaleTimeline.restart);
	        }
	        return scaleTimeline;
	    };
	    GsapEffects.scaleTween_Tweenlite = function (object, options) {
	        var tweenDuration = options.tweenDuration == null || isNaN(options.tweenDuration)
	            ? Math.floor(Math.random() * 120 + 120)
	            : options.tweenDuration;
	        var tweenDurationPerPart = (tweenDuration / options.tweenValues.length) * GsapEffects.TickTime;
	        var tweenEase = GsapEffects.getEaseing(options.tweenEase) || "Linear.easeNone";
	        var tweenPaused = options.paused;
	        var scaleTweenLite;
	        scaleTweenLite = gsap_1.TweenLite.to(object.scale, tweenDurationPerPart, {
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay != null && options.tweenDelay > 0 ? options.tweenDelay * GsapEffects.TickTime : 0,
	            x: options.tweenValues[0].x,
	            y: options.tweenValues[0].y,
	            ease: tweenEase,
	            paused: tweenPaused || false,
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            scaleTweenLite.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            scaleTweenLite.eventCallback("onComplete", scaleTweenLite.restart);
	        }
	        return scaleTweenLite;
	    };
	    GsapEffects.tween_TimelineLite = function (object, options) {
	        var tween = options.tween.split(".");
	        var tweenProperty = tween[tween.length - 1];
	        var tweenPaused = options.paused;
	        var timeline = new gsap_1.TimelineLite({
	            useFrames: GsapEffects.UseFrames,
	            delay: options.tweenDelay[0],
	        });
	        options.tweenValues.forEach(function (value, i) {
	            timeline.to(tween.length == 1 ? object : object[tween[0]], options.tweenDuration[i], (_a = {
	                    useFrames: GsapEffects.UseFrames
	                },
	                _a[tweenProperty] = value,
	                _a.ease = GsapEffects.getEaseing(options.tweenEase[i]) || "Linear.easeNone",
	                _a.paused = tweenPaused || false,
	                _a
	            ));
	            var _a;
	        });
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            timeline.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            timeline.eventCallback("onComplete", timeline.restart);
	        }
	        return timeline;
	    };
	    GsapEffects.tween_Tweenlite = function (object, options) {
	        var tween = options.tween.split(".");
	        var tweenProperty = tween[tween.length - 1];
	        var tweenPaused = options.paused;
	        var tweenlite;
	        tweenlite = gsap_1.TweenLite.to(tween.length == 1 ? object : object[tween[0]], options.tweenDuration[0], (_a = {
	                useFrames: GsapEffects.UseFrames,
	                delay: options.tweenDelay[0]
	            },
	            _a[tweenProperty] = options.tweenValues[0],
	            _a.ease = GsapEffects.getEaseing(options.tweenEase[0]) || "Linear.easeNone",
	            _a.paused = tweenPaused || false,
	            _a
	        ));
	        if (options.callbackFunction != null) {
	            if (options.callbackType == null) {
	                options.callbackType = "onComplete";
	            }
	            tweenlite.eventCallback(options.callbackType, options.callbackFunction, options.callbackParams, options.callbackScope);
	        }
	        if (options.tweenLoop) {
	            tweenlite.eventCallback("onComplete", tweenlite.restart);
	        }
	        return tweenlite;
	        var _a;
	    };
	    GsapEffects.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    GsapEffects.getEaseing = function (ease) {
	        switch ("" + ease) {
	            case "0":
	            case "linear":
	                return "Linear.easeNone";
	            case "1":
	            case "backIn":
	                return "Back.easeIn";
	            case "2":
	            case "backInOut":
	                return "Back.easeInOut";
	            case "3":
	            case "backOut":
	                return "Back.easeOut";
	            case "4":
	            case "bounceIn":
	                return "Bounce.easeIn";
	            case "5":
	            case "bounceInOut":
	                return "Bounce.easeInOut";
	            case "6":
	            case "bounceOut":
	                return "Bounce.easeOut";
	            case "7":
	            case "circIn":
	                return "Circ.easeIn";
	            case "8":
	            case "circInOut":
	                return "Circ.easeInOut";
	            case "9":
	            case "circOut":
	                return "Circ.easeOut";
	            case "10":
	            case "cubicIn":
	                return "Cubic.easeIn";
	            case "11":
	            case "cubicInOut":
	                return "Cubic.easeInOut";
	            case "12":
	            case "cubicOut":
	                return "Cubic.easeOut";
	            case "13":
	            case "elasticIn":
	                return "Elastic.easeIn";
	            case "14":
	            case "elasticInOut":
	                return "Elastic.easeInOut";
	            case "15":
	            case "elasticOut":
	                return "Elastic.easeOut";
	            case "16":
	            case "quadIn":
	                return "Quad.easeIn";
	            case "17":
	            case "quadInOut":
	                return "Quad.easeInOut";
	            case "18":
	            case "quadOut":
	                return "Quad.easeOut";
	            case "19":
	            case "quartIn":
	                return "Quart.easeIn";
	            case "20":
	            case "quartInOut":
	                return "Quart.easeInOut";
	            case "21":
	            case "quartOut":
	                return "Quart.easeOut";
	            case "22":
	            case "quintIn":
	                return "Quint.easeIn";
	            case "23":
	            case "quintInOut":
	                return "Quint.easeInOut";
	            case "24":
	            case "quintOut":
	                return "Quint.easeOut";
	            case "25":
	            case "sineIn":
	                return "Sine.easeIn";
	            case "26":
	            case "sineInOut":
	                return "Sine.easeInOut";
	            case "27":
	            case "sineOut":
	                return "Sine.easeOut";
	            case "power1In":
	                return "Power1.easeIn";
	            case "power2In":
	                return "Power2.easeIn";
	            case "power3In":
	                return "Power3.easeIn";
	            case "power4In":
	                return "Power4.easeIn";
	            case "explodeSlowMo":
	                return new gsap_1.SlowMo().config(0.8, 0.8, false);
	            default:
	                return CustomEase_1.CustomEase.get(ease) != null ? ease : "Linear.easeNone";
	        }
	    };
	    GsapEffects.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__ || "GsapEffects";
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    GsapEffects.UseFrames = false;
	    GsapEffects.TickTime = 0.0167;
	    return GsapEffects;
	}());
	exports.GsapEffects = GsapEffects;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.19.0
	 * DATE: 2016-07-14
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2016, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._dirty = true; //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.19.0";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
	
					if (this._easeType) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val.call(targets[i], i) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.19.0";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						tl.add(tween, tween._startTime - tween._delay);
					}
					tween = next;
				}
				root.add(tl, 0);
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > last._startTime + last._totalDuration / last._timeScale) {
					this._time = this.duration();
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - this.duration() : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = this.duration() + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : this.duration();
				} else if (timeOrLabel == null) {
					timeOrLabel = this.duration();
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this.add(tween, tween._startTime - tween._delay);
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function() {
				return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.19.0";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration()) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale );
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						t._callback("onStart");
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTime = this._time,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (time >= totalDur - 0.0000001) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[(l < -1) ? 0 : 1][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.7",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.19.0";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_doc = document,
				_createElement = function(type) {
					return _doc.createElementNS ? _doc.createElementNS("http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = navigator.userAgent,
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || Number(_agent.substr(i+8, 1)) > 3));
					_isSafariLT6 = (_isSafari && (Number(_agent.substr(_agent.indexOf("Version/")+8, 1)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (window.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || !sfx) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getBBox && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(v[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = colors.length ? "" : s,
						i, color, temp;
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = Math.round(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = r; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i];
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra((hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra((hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = _isSafari || _isFirefox; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = window.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement,
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !window.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
						y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
						xOrigin = decoratee.xOrigin = v[0] = x;
						yOrigin = decoratee.yOrigin = v[1] = y;
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_canGetBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (e) {}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getBBox && e.getCTM && _canGetBBox(e) && (!e.parentNode || (e.parentNode.getBBox && e.parentNode.getCTM)));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (isDefault && _transformProp && ((none = (_getComputedStyle(e).display === "none")) || !e.parentNode)) {
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none".
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getBBox && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							if (m.indexOf("matrix") !== -1) { //just in case there's a "transform" value specified as an attribute instead of CSS style. Accept either a matrix() or simple translate() value though.
								s = m;
								isDefault = 0;
							} else if (m.indexOf("translate") !== -1) {
								s = "matrix(1,0,0,1," + m.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",") + ")";
								isDefault = 0;
							}
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getBBox && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
	
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								a11 = a11*cos+a12*sin;
								t2 = a21*cos+a22*sin;
								a22 = a21*-sin+a22*cos;
								a32 = a31*-sin+a32*cos;
								a21 = t2;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a23 * a23) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a32 * a32 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							if (tm.rotationX || tm.rotationY) {
								tm.skewX = 0;
							} else {
								tm.skewX = (a12 || a22) ? Math.atan2(a12, a22) * _RAD2DEG + tm.rotation : tm.skewX || 0;
								if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
									if (invX) {
										tm.scaleX *= -1;
										tm.skewX += (tm.rotation <= 0) ? 180 : -180;
										tm.rotation += (tm.rotation <= 0) ? 180 : -180;
									} else {
										tm.scaleY *= -1;
										tm.skewX += (tm.skewX <= 0) ? 180 : -180;
									}
								}
							}
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
								if (invX) {
									scaleX *= -1;
									skewX += (rotation <= 0) ? 180 : -180;
									rotation += (rotation <= 0) ? 180 : -180;
								} else {
									scaleY *= -1;
									skewX += (skewX <= 0) ? 180 : -180;
								}
							}
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t1, t2, transform, comma, zero, skew, rnd;
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || t.skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = t.skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - t.skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || t.skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (t.skewX) {
							angle -= t.skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((t.skewX - t.skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(t.skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation - m1.skewY, m1.rotation - m1.skewY, "rotation", endRotations); //see notes below about skewY for why we subtract it from rotation here
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX - m1.skewY); //see notes below about skewY and why we subtract it from skewX here
	
					//note: for performance reasons, we combine all skewing into the skewX and rotation values, ignoring skewY but we must still record it so that we can discern how much of the overall skew is attributed to skewX vs. skewY. Otherwise, if the skewY would always act relative (tween skewY to 10deg, for example, multiple times and if we always combine things into skewX, we can't remember that skewY was 10 from last time). Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of -10 degrees.
					if ((m2.skewY = _parseAngle(v.skewY, m1.skewY))) {
						m2.skewX += m2.skewY;
						m2.rotation += m2.skewY;
					}
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = _useSVGTransformAttr ? null : "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
	
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
	
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = Math.round(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = Math.round(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
						pt.r = 1;
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.6.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_roundLinkedList = function(node) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
					i = rp.length,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					prop, pt, next;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
				i = rp.length;
				while (--i > -1) {
					prop = rp[i];
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === prop) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT);
							} else {
								this._add(pt.t, prop, pt.s, pt.c);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[prop] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c) {
				this._addTween(target, p, s, s + c, p, Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.0",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.0",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? 1 - (p = (p - this._p3) / this._p1) * p : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p);
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + 1;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return ((this._p2 * p) >> 0) * this._p1;
			};
			p.config = SteppedEase.config = function(steps) {
				return new SteppedEase(steps);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl, hasModule;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								hasModule = (typeof(module) !== "undefined" && module.exports);
								if (!hasModule && "function" === "function" && __webpack_require__(18)){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								} else if (hasModule){ //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				_blankArray = [],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && document.visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000) {
						_ticker.wake();
					}
					setTimeout(_checkTimeout, 2000);
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime()) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					var pauseTime = this._pauseTime,
						t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				return this._uncache(false);
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.19.0";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				return (typeof(document) === "undefined") ? e : (document.querySelectorAll ? document.querySelectorAll(e) : document.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m(val, this._target || pt.t);
						} else if (val < min) if (val > -min) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [start, end],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var s = (start === "get") ? target[prop] : start,
						type = typeof(target[prop]),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob, getterName;
					if (type !== "number") {
						if (type === "function" && start === "get") {
							getterName = ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3));
							pt.s = s = funcParam ? target[getterName](funcParam) : target[getterName]();
						}
						if (typeof(s) === "string" && (funcParam || isNaN(s))) {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, end, stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t:blob, p:"setRatio", s:0, c:1, f:2, pg:0, n:overwriteProp || prop, pr:0, m:0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else if (!isRelative) {
							pt.s = parseFloat(s);
							pt.c = (parseFloat(end) - pt.s) || 0;
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					this._startAt = TweenLite.to(this.target, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, suppressEvents, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, suppressEvents, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a;
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 18 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var gsap_1 = __webpack_require__(17);
	var gsap_2 = __webpack_require__(17);
	var CustomEase = (function (_super) {
	    __extends(CustomEase, _super);
	    function CustomEase(id, data, config) {
	        _super.call(this);
	        this._numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi;
	        this._svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi;
	        this._scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/gi;
	        this._needsParsingExp = /[cLlsS]/g;
	        this._bezierError = "CustomEase only accepts Cubic Bezier data.";
	        this.id = id;
	        if (id) {
	            gsap_1.Ease.map[id] = this;
	        }
	        this._calcEnd = true;
	        this.getRatio = this._getRatio;
	        this.setData(data, config);
	    }
	    CustomEase.prototype._bezierToPoints = function (x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
	        var x12 = (x1 + x2) / 2;
	        var y12 = (y1 + y2) / 2;
	        var x23 = (x2 + x3) / 2;
	        var y23 = (y2 + y3) / 2;
	        var x34 = (x3 + x4) / 2;
	        var y34 = (y3 + y4) / 2;
	        var x123 = (x12 + x23) / 2;
	        var y123 = (y12 + y23) / 2;
	        var x234 = (x23 + x34) / 2;
	        var y234 = (y23 + y34) / 2;
	        var x1234 = (x123 + x234) / 2;
	        var y1234 = (y123 + y234) / 2;
	        var dx = x4 - x1;
	        var dy = y4 - y1;
	        var d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx);
	        var d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx);
	        var length;
	        if (!points) {
	            points = [
	                { x: x1, y: y1 },
	                { x: x4, y: y4 },
	            ];
	            index = 1;
	        }
	        points.splice(index || points.length - 1, 0, { x: x1234, y: y1234 });
	        if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
	            length = points.length;
	            this._bezierToPoints(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
	            this._bezierToPoints(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
	        }
	        return points;
	    };
	    CustomEase.prototype._pathDataToBezier = function (d) {
	        var a = (d + "")
	            .replace(this._scientific, function (m) {
	            var n = +m;
	            var result = n < 0.0001 && n > -0.0001 ? 0 : n;
	            return result.toString();
	        })
	            .match(this._svgPathExp) || [];
	        var path = [];
	        var relativeX = 0;
	        var relativeY = 0;
	        var elements = a.length;
	        var l = 2;
	        var i;
	        var x;
	        var y;
	        var command;
	        var isRelative;
	        var segment;
	        var startX;
	        var startY;
	        var prevCommand;
	        var difX;
	        var difY;
	        for (i = 0; i < elements; i++) {
	            prevCommand = command;
	            if (isNaN(parseFloat(a[i]))) {
	                command = a[i].toUpperCase();
	                isRelative = command !== a[i];
	            }
	            else {
	                i--;
	            }
	            x = +a[i + 1];
	            y = +a[i + 2];
	            if (isRelative) {
	                x += relativeX;
	                y += relativeY;
	            }
	            if (!i) {
	                startX = x;
	                startY = y;
	            }
	            if (command === "M") {
	                if (segment && segment.length < 8) {
	                    path.length -= 1;
	                    l = 0;
	                }
	                relativeX = startX = x;
	                relativeY = startY = y;
	                segment = [x, y];
	                l = 2;
	                path.push(segment);
	                i += 2;
	                command = "L";
	            }
	            else if (command === "C") {
	                if (!segment) {
	                    segment = [0, 0];
	                }
	                segment[l++] = x;
	                segment[l++] = y;
	                if (!isRelative) {
	                    relativeX = relativeY = 0;
	                }
	                segment[l++] = relativeX + parseFloat(a[i + 3]);
	                segment[l++] = relativeY + parseFloat(a[i + 4]);
	                segment[l++] = relativeX = relativeX + parseFloat(a[i + 5]);
	                segment[l++] = relativeY = relativeY + parseFloat(a[i + 6]);
	                i += 6;
	            }
	            else if (command === "S") {
	                if (prevCommand === "C" || prevCommand === "S") {
	                    difX = relativeX - segment[l - 4];
	                    difY = relativeY - segment[l - 3];
	                    segment[l++] = relativeX + difX;
	                    segment[l++] = relativeY + difY;
	                }
	                else {
	                    segment[l++] = relativeX;
	                    segment[l++] = relativeY;
	                }
	                segment[l++] = x;
	                segment[l++] = y;
	                if (!isRelative) {
	                    relativeX = relativeY = 0;
	                }
	                segment[l++] = relativeX = relativeX + parseFloat(a[i + 3]);
	                segment[l++] = relativeY = relativeY + parseFloat(a[i + 4]);
	                i += 4;
	            }
	            else if (command === "L" || command === "Z") {
	                if (command === "Z") {
	                    x = startX;
	                    y = startY;
	                    segment.closed = true;
	                }
	                if (command === "L" || Math.abs(relativeX - x) > 0.5 || Math.abs(relativeY - y) > 0.5) {
	                    segment[l++] = relativeX + (x - relativeX) / 3;
	                    segment[l++] = relativeY + (y - relativeY) / 3;
	                    segment[l++] = relativeX + ((x - relativeX) * 2) / 3;
	                    segment[l++] = relativeY + ((y - relativeY) * 2) / 3;
	                    segment[l++] = x;
	                    segment[l++] = y;
	                    if (command === "L") {
	                        i += 2;
	                    }
	                }
	                relativeX = x;
	                relativeY = y;
	            }
	            else {
	                throw this._bezierError;
	            }
	        }
	        return path[0];
	    };
	    CustomEase.prototype._findMinimum = function (values) {
	        var l = values.length, min = 999999999999, i;
	        for (i = 1; i < l; i += 6) {
	            if (+values[i] < min) {
	                min = +values[i];
	            }
	        }
	        return min;
	    };
	    CustomEase.prototype._normalize = function (values, height, originY) {
	        if (!originY && originY !== 0) {
	            originY = Math.max(+values[values.length - 1], +values[1]);
	        }
	        var tx = +values[0] * -1, ty = -originY, l = values.length, sx = 1 / (+values[l - 2] + tx), sy = -height ||
	            (Math.abs(+values[l - 1] - +values[1]) < 0.01 * (+values[l - 2] - +values[0])
	                ? this._findMinimum(values) + ty
	                : +values[l - 1] + ty), i;
	        if (sy) {
	            sy = 1 / sy;
	        }
	        else {
	            sy = -sx;
	        }
	        for (i = 0; i < l; i += 2) {
	            values[i] = (+values[i] + tx) * sx;
	            values[i + 1] = (+values[i + 1] + ty) * sy;
	        }
	    };
	    CustomEase.prototype._getRatio = function (p) {
	        var point = this.lookup[(p * this.l) | 0] || this.lookup[this.l - 1];
	        if (point.nx < p) {
	            point = point.n;
	        }
	        var result = point.y + ((p - point.x) / point.cx) * point.cy;
	        return result;
	    };
	    CustomEase.prototype.setData = function (data, config) {
	        this.data = data || "0,0,1,1";
	        this.points = [];
	        this.lookup = [];
	        var values = neo_common_1.ArrayUtils.numberArray(this.data.match(this._numbersExp).join(";"));
	        var closest = 1;
	        var a1, a2, i, inc, j, point, prevPoint, p, precision;
	        precision = (config && config.precision) || 1;
	        this.fast = precision <= 1;
	        if (this._needsParsingExp.test(data) || (data.indexOf("M") !== -1 && data.indexOf("C") === -1)) {
	            values = this._pathDataToBezier(data);
	        }
	        this.l = values.length;
	        if (this.l === 4) {
	            values.unshift(0, 0);
	            values.push(1, 1);
	            this.l = 8;
	        }
	        else if ((this.l - 2) % 6) {
	            throw this._bezierError;
	        }
	        if (+values[0] !== 0 || +values[this.l - 2] !== 1) {
	            var height = config && config.height ? config.height : null;
	            var originY = config && config.originY ? config.originY : null;
	            this._normalize(values, height, originY);
	        }
	        this.rawBezier = values;
	        for (i = 2; i < this.l; i += 6) {
	            a1 = { x: +values[i - 2], y: +values[i - 1] };
	            a2 = { x: +values[i + 4], y: +values[i + 5] };
	            this.points.push(a1, a2);
	            this._bezierToPoints(a1.x, a1.y, +values[i], +values[i + 1], +values[i + 2], +values[i + 3], a2.x, a2.y, 1 / (precision * 200000), this.points, this.points.length - 1);
	        }
	        this.l = this.points.length;
	        for (i = 0; i < this.l; i++) {
	            point = this.points[i];
	            prevPoint = this.points[i - 1] || point;
	            if (point.x > prevPoint.x || (prevPoint.y !== point.y && prevPoint.x === point.x) || point === prevPoint) {
	                prevPoint.cx = point.x - prevPoint.x;
	                prevPoint.cy = point.y - prevPoint.y;
	                prevPoint.n = point;
	                prevPoint.nx = point.x;
	                if (this.fast &&
	                    i > 1 &&
	                    Math.abs(prevPoint.cy / prevPoint.cx - this.points[i - 2].cy / this.points[i - 2].cx) > 2) {
	                    this.fast = false;
	                }
	                if (prevPoint.cx < closest) {
	                    if (!prevPoint.cx) {
	                        prevPoint.cx = 0.001;
	                        if (i === this.l - 1) {
	                            prevPoint.x -= 0.001;
	                            closest = Math.min(closest, 0.001);
	                            this.fast = false;
	                        }
	                    }
	                    else {
	                        closest = prevPoint.cx;
	                    }
	                }
	            }
	            else {
	                this.points.splice(i--, 1);
	                this.l--;
	            }
	        }
	        this.l = (1 / closest + 1) | 0;
	        inc = 1 / this.l;
	        j = 0;
	        point = this.points[0];
	        if (this.fast) {
	            for (i = 0; i < this.l; i++) {
	                p = i * inc;
	                if (point.nx < p) {
	                    point = this.points[++j];
	                }
	                a1 = point.y + ((p - point.x) / point.cx) * point.cy;
	                this.lookup[i] = { x: p, cx: inc, y: a1, cy: 0, nx: 9 };
	                if (i) {
	                    this.lookup[i - 1].cy = a1 - this.lookup[i - 1].y;
	                }
	            }
	            this.lookup[this.l - 1].cy = this.points[this.points.length - 1].y - a1;
	        }
	        else {
	            for (i = 0; i < this.l; i++) {
	                if (point.nx < i * inc) {
	                    point = this.points[++j];
	                }
	                this.lookup[i] = point;
	            }
	            if (j < this.points.length - 1) {
	                this.lookup[i - 1] = this.points[this.points.length - 2];
	            }
	        }
	        this._calcEnd = this.points[this.points.length - 1].y !== 1 || this.points[0].y !== 0;
	    };
	    CustomEase.create = function (id, data, config) {
	        return new CustomEase(id, data, config);
	    };
	    CustomEase.get = function (id) {
	        return gsap_1.Ease.map[id];
	    };
	    CustomEase._createOwnEasing = function () {
	        var stepEase = new gsap_2.SteppedEase(120);
	        gsap_1.Ease.map["stepEase"] = stepEase;
	        var stepEase_1 = new gsap_2.SteppedEase(20);
	        gsap_1.Ease.map["stepEase_1"] = stepEase_1;
	        var stepEase_2 = new gsap_2.SteppedEase(40);
	        gsap_1.Ease.map["stepEase_2"] = stepEase_2;
	        var stepEase_3 = new gsap_2.SteppedEase(60);
	        gsap_1.Ease.map["stepEase_3"] = stepEase_3;
	        var stepEase_4 = new gsap_2.SteppedEase(80);
	        gsap_1.Ease.map["stepEase_4"] = stepEase_4;
	        var stepEase_5 = new gsap_2.SteppedEase(100);
	        gsap_1.Ease.map["stepEase_5"] = stepEase_5;
	        var stepEaseScale = new gsap_2.SteppedEase(3);
	        gsap_1.Ease.map["stepEaseScale"] = stepEaseScale;
	    };
	    return CustomEase;
	}(gsap_1.Ease));
	exports.CustomEase = CustomEase;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var StyleManager = (function () {
	    function StyleManager() {
	    }
	    StyleManager.cleanup = function () {
	        StyleManager.HtmlStyles = null;
	    };
	    StyleManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("StyleManager", data);
	        }
	    };
	    StyleManager.parseElements = function (startNode) {
	        if (!startNode) {
	            return;
	        }
	        var nodes = StyleManager.getNodesList(startNode.firstElementChild)
	            .reverse()
	            .filter(function (node) { return node.hasAttribute("Class") && node.getAttribute("Class") !== ""; });
	        nodes
	            .filter(function (node) {
	            return neo_common_1.EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes_1.ComponentTypes.Style);
	        })
	            .forEach(function (node) {
	            var style = neo_common_1.EngineComponentFactory.get(node.getAttribute("Class"));
	            style.create(node);
	            StyleManager.Styles[node.nodeName] = style;
	        });
	        nodes
	            .filter(function (node) {
	            return neo_common_1.EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes_1.ComponentTypes.HtmlStyle);
	        })
	            .forEach(function (node) {
	            var style = neo_common_1.EngineComponentFactory.get(node.getAttribute("Class"));
	            style.create(node);
	            StyleManager.HtmlStyles[node.nodeName] = style;
	        });
	    };
	    StyleManager.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = StyleManager.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    StyleManager.Styles = {};
	    StyleManager.HtmlStyles = {};
	    return StyleManager;
	}());
	exports.StyleManager = StyleManager;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Attributes = (function () {
	    function Attributes() {
	    }
	    Attributes.assignIntAttribute = function (node, attribute, defaultValue, radix) {
	        if (!node.hasAttribute(attribute)) {
	            return defaultValue;
	        }
	        return parseInt(node.getAttribute(attribute), radix);
	    };
	    Attributes.assignFloatAttribute = function (node, attribute, defaultValue) {
	        if (!node.hasAttribute(attribute)) {
	            return defaultValue;
	        }
	        return parseFloat(node.getAttribute(attribute));
	    };
	    Attributes.assignBooleanAttribute = function (node, attribute, defaultValue) {
	        if (!node.hasAttribute(attribute)) {
	            return defaultValue;
	        }
	        return neo_common_1.StringUtils.parseBoolean(node.getAttribute(attribute));
	    };
	    Attributes.assignStringAttribute = function (node, attribute, defaultValue) {
	        if (!node.hasAttribute(attribute)) {
	            return defaultValue;
	        }
	        return node.getAttribute(attribute);
	    };
	    return Attributes;
	}());
	exports.Attributes = Attributes;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var GameManager_1 = __webpack_require__(23);
	var DataManager_1 = __webpack_require__(26);
	var Scaling_1 = __webpack_require__(8);
	var CustomUtils = (function () {
	    function CustomUtils() {
	    }
	    CustomUtils.isRespin = function () {
	        return (GameManager_1.GameManager.baseResponse != null &&
	            GameManager_1.GameManager.baseResponse.respin != null &&
	            GameManager_1.GameManager.baseResponse.respin !== 0);
	    };
	    CustomUtils.isRespinEnabled = function () {
	        return (GameManager_1.GameManager.baseResponse != null &&
	            GameManager_1.GameManager.baseResponse.respin != null &&
	            GameManager_1.GameManager.baseResponse.respin !== 0 &&
	            GameManager_1.GameManager.baseResponse.spinId === 0);
	    };
	    CustomUtils.isRespinActive = function () {
	        return (GameManager_1.GameManager.baseResponse != null &&
	            GameManager_1.GameManager.baseResponse.respin != null &&
	            GameManager_1.GameManager.baseResponse.respin !== 0 &&
	            GameManager_1.GameManager.baseResponse.spinId > 0);
	    };
	    CustomUtils.isRespinLast = function () {
	        return (GameManager_1.GameManager.baseResponse != null &&
	            GameManager_1.GameManager.baseResponse.respin != null &&
	            GameManager_1.GameManager.baseResponse.respin === 0 &&
	            GameManager_1.GameManager.baseResponse.spinId > 0);
	    };
	    CustomUtils.isLastBonusSpin = function (limitCallback) {
	        if (DataManager_1.DataManager.GameLimit) {
	            if (limitCallback != null) {
	                limitCallback();
	            }
	            return true;
	        }
	        return (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount === 0 &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin == 0 &&
	            GameManager_1.GameManager.bonusRespinsResponse.spinId > -1);
	    };
	    CustomUtils.getRemainingRespins = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount != null) {
	            return GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount;
	        }
	        return 0;
	    };
	    CustomUtils.isBonusSymbol = function (symbolId) {
	        return symbolId >= CustomUtils.SymbolBonus && symbolId <= CustomUtils.SymbolBonusMajor;
	    };
	    CustomUtils.isBonusSymbolInArray = function (symbolIds) {
	        for (var i = 0; i < symbolIds.length; i++) {
	            if (symbolIds[i] >= CustomUtils.SymbolBonus && symbolIds[i] <= CustomUtils.SymbolBonusMajor) {
	                return true;
	            }
	        }
	        return false;
	    };
	    CustomUtils.isBonusRespin = function () {
	        return (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin !== 0);
	    };
	    CustomUtils.isBonusRespinEnabled = function () {
	        return (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin !== 0 &&
	            GameManager_1.GameManager.bonusRespinsResponse.spinId === 0);
	    };
	    CustomUtils.isBonusRespinActive = function () {
	        return (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin !== 0 &&
	            GameManager_1.GameManager.bonusRespinsResponse.spinId > 0);
	    };
	    CustomUtils.isBonusRespinLast = function () {
	        return (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.respin === 0 &&
	            GameManager_1.GameManager.bonusRespinsResponse.spinId > 0);
	    };
	    CustomUtils.getBlendMode = function (blendMode) {
	        if (Scaling_1.Scaling.IsIOs) {
	            if (blendMode == 1) {
	                blendMode = 3;
	            }
	        }
	        return blendMode;
	    };
	    CustomUtils.updateSpineData = function (spineData) {
	        if (Scaling_1.Scaling.IsIOs) {
	            if (spineData != null) {
	                var spineTextData = JSON.stringify(spineData);
	                spineTextData = spineTextData.split('"blend":"additive"').join('"blend":"screen"');
	                spineData = JSON.parse(spineTextData);
	            }
	        }
	        return spineData;
	    };
	    CustomUtils.swapChilds = function (src, childName, dest) {
	        if (src != null && dest.childs[childName] != null) {
	            dest.addChildAt(src, dest.getChildIndex(dest.childs[childName]));
	        }
	    };
	    CustomUtils.getObjectFrom = function (objName, source, tp) {
	        if (source[objName] != null) {
	            if (tp != null) {
	                if (source[objName] instanceof tp) {
	                    return source[objName];
	                }
	            }
	            else {
	                if (source[objName]) {
	                    return source[objName];
	                }
	            }
	        }
	        return null;
	    };
	    CustomUtils.SymbolBonus = 8;
	    CustomUtils.SymbolBonusMini = 9;
	    CustomUtils.SymbolBonusMinor = 10;
	    CustomUtils.SymbolBonusMajor = 11;
	    CustomUtils.SymbolEmpty = 12;
	    CustomUtils.MultiplierAnimationDuration = 135;
	    return CustomUtils;
	}());
	exports.CustomUtils = CustomUtils;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var AppContext_1 = __webpack_require__(5);
	var GameData_1 = __webpack_require__(24);
	var BetManager_1 = __webpack_require__(25);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var Languages_1 = __webpack_require__(28);
	var GameApp_1 = __webpack_require__(1);
	var ResponsibleDialog1_1 = __webpack_require__(49);
	var MessageManager_1 = __webpack_require__(42);
	var SimilarGames_1 = __webpack_require__(58);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var LimitDialog_1 = __webpack_require__(52);
	var Jackpot_1 = __webpack_require__(36);
	var Scaling_1 = __webpack_require__(8);
	var CustomUtils_1 = __webpack_require__(22);
	var SplashScreen_1 = __webpack_require__(59);
	var NotificationManager_1 = __webpack_require__(60);
	var Paytable_1 = __webpack_require__(56);
	var SessionTimer_1 = __webpack_require__(63);
	var BuyFeature_1 = __webpack_require__(30);
	var StageController_1 = __webpack_require__(6);
	var RetentionPanel_1 = __webpack_require__(46);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var GameManager = (function () {
	    function GameManager() {
	    }
	    Object.defineProperty(GameManager, "gameClient", {
	        get: function () {
	            return GameManager._gameClient;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameManager.startGame = function (gameClient, app) {
	        if (false) {
	            GameManager.log("startGame");
	        }
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(gameClient, "gameClient");
	        GameManager._gameClient = gameClient;
	        GameManager._gameClient.onErrorResponse = GameManager.errorReceived;
	        DataManager_1.DataManager.BackSoundsPlayingFromGame =
	            AppContext_1.AppContext.current.isBackgroundMusicEnabled && AppContext_1.AppContext.current.getBackgroundMusic();
	        NotificationManager_1.NotificationManager.initialize();
	        GameManager._app = app;
	        if (ModuleManager_1.ModuleManager.connectModules()) {
	            if (FreeRoundBonus_1.FreeRoundBonus.wasInitialized) {
	                GameManager.init();
	            }
	            else {
	                setTimeout(function () {
	                    GameManager.init();
	                }, 3000);
	            }
	        }
	        else {
	            if (false) {
	                GameManager.log("ERROR cant connect channel and game modules");
	            }
	        }
	    };
	    GameManager.showGame = function () {
	        if (false) {
	            GameManager.log("showGame");
	        }
	        var loading = document.getElementById("loading");
	        var canvas = document.getElementById("canvas");
	        if (loading != null && canvas != null) {
	            Scaling_1.Scaling.onLoadComplete();
	            Jackpot_1.Jackpot.show();
	            RetentionPanel_1.RetentionPanel.show();
	            Paytable_1.Paytable.openAtStart();
	            if (DataManager_1.DataManager.GameRoundClosed && Jackpot_1.Jackpot.hasMiniGame() && !FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	                FreeRoundBonus_1.FreeRoundBonus.disableUi();
	            }
	            DataManager_1.DataManager.cleanUpElements();
	            loading.style.display = "none";
	            canvas.style.display = "block";
	            DataManager_1.DataManager.updateDataElements();
	        }
	        else {
	            if (false) {
	                GameManager.log("ERROR loading or canvas doesnt exist");
	            }
	        }
	    };
	    GameManager.setupGame = function (response) {
	        if (false) {
	            GameManager.log("setupGame");
	        }
	        GameManager.parseResponses(response);
	        DataManager_1.DataManager.updateResponseData(true);
	        BuyFeature_1.BuyFeature.initialize();
	        ModuleManager_1.ModuleManager.initModules();
	        DataManager_1.DataManager.SimilarGames = new SimilarGames_1.SimilarGames();
	        DataManager_1.DataManager.SimilarGames.initialize();
	        FreeRoundBonus_1.FreeRoundBonus.showFreeRounds();
	    };
	    GameManager.init = function () {
	        if (false) {
	            GameManager.log("init");
	        }
	        if (GameManager.requestSend) {
	            return;
	        }
	        else {
	            GameManager.requestSend = true;
	        }
	        DataManager_1.DataManager.getServerTime();
	        DataManager_1.DataManager.controlAutoplay();
	        FreeRoundBonus_1.FreeRoundBonus.initializeFreeRounds();
	        Jackpot_1.Jackpot.initialize();
	        GameManager._gameClient.init().then(function (response) {
	            GameManager.initReceived(response);
	        });
	    };
	    GameManager.softInit = function (resetScreen) {
	        if (resetScreen === void 0) { resetScreen = false; }
	        if (false) {
	            GameManager.log("soft init");
	        }
	        if (GameManager.requestSend) {
	            return;
	        }
	        else {
	            GameManager.requestSend = true;
	        }
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager._gameClient.init().then(function (response) {
	            GameManager.softInitReceived(response, resetScreen);
	        });
	    };
	    GameManager.collect = function (module) {
	        if (false) {
	            GameManager.log("collect module: " + module);
	        }
	        if (GameManager.requestSend) {
	            return;
	        }
	        else {
	            GameManager.requestSend = true;
	        }
	        if (!AppContext_1.AppContext.gameDefinition.Gamble) {
	            DataManager_1.DataManager.Collectable = true;
	        }
	        GameManager.canExit();
	        this._collectModule = module;
	        DataManager_1.DataManager.controlAutoplay();
	        if (!DataManager_1.DataManager.GameRoundClosed && GameManager.gameResponse.totalWin > 0) {
	            GameManager.gameClient.collect().then(GameManager.collectReceived);
	        }
	    };
	    GameManager.initReceived = function (response) {
	        if (false) {
	            GameManager.log("initReceived");
	        }
	        if (neo_common_1.Utils.isNullOrUndefined(response)) {
	            if (false) {
	                GameManager.log("initReceived NULL response (error in send?)");
	            }
	            return;
	        }
	        DataManager_1.DataManager.showTime();
	        if (!neo_common_1.Utils.isNullOrUndefined(AppContext_1.AppContext.gameConfiguration.GUIShowSessionTimeStartValue)) {
	            DataManager_1.DataManager.showSessionTime(AppContext_1.AppContext.gameConfiguration.GUIShowSessionTimeStartValue);
	        }
	        else {
	            DataManager_1.DataManager.showSessionTime(0);
	        }
	        if (SplashScreen_1.SplashScreen.suspendInitReceived(response)) {
	            return;
	        }
	        MessageManager_1.MessageManager.postpone(GameManager.continueInitReceived, response);
	    };
	    GameManager.continueInitReceived = function (response) {
	        GameManager.setupGame(response);
	        GameManager.showGame();
	        SplashScreen_1.SplashScreen.hideSplashScreen();
	        neo_games_1.Platforms.Platforms.gameDataLoaded({
	            PlayerTokenId: AppContext_1.AppContext.gameConfiguration.PlayerTokenId,
	            HomeUrl: AppContext_1.AppContext.gameConfiguration.ExitUrl,
	            ClientToken: AppContext_1.AppContext.gameConfiguration.ClientToken,
	            GameName: GameApp_1.GameApp.key,
	            SessionData: {
	                SessionBalance: AppContext_1.AppContext.gameConfiguration.SessionBalance,
	                TotalWin: AppContext_1.AppContext.gameConfiguration.TotalWin,
	                TotalBet: AppContext_1.AppContext.gameConfiguration.TotalBet,
	            },
	            CurrencyCode: response.initData.currency != null ? response.initData.currency : "",
	            Balance: GameManager.gameResponse.balance.real,
	            Bet: BetManager_1.BetManager.Bet,
	        });
	        neo_games_1.Platforms.Platforms.rendererType(StageController_1.StageController.Renderer instanceof PIXI.CanvasRenderer ? "canvas" : "webGL");
	        DataManager_1.DataManager.gameState("GameLoaded");
	        GameManager.requestSend = false;
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager.gameResponse.totalWin > 0) {
	                if (!CustomUtils_1.CustomUtils.isRespinEnabled() &&
	                    !CustomUtils_1.CustomUtils.isRespinActive() &&
	                    !ModuleManager_1.ModuleManager.bonusActive() &&
	                    !ModuleManager_1.ModuleManager.bonusEnabled()) {
	                    ModuleManager_1.ModuleManager.collect(GameModules.Base);
	                }
	            }
	        }
	    };
	    GameManager.softInitReceived = function (response, resetScreen) {
	        if (resetScreen === void 0) { resetScreen = false; }
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, "0");
	        LimitDialog_1.LimitDialog.closeDialog();
	        GameManager.parseResponses(response);
	        DataManager_1.DataManager.updateResponseData(true);
	        GameManager.requestSend = false;
	        if (resetScreen) {
	            ModuleManager_1.ModuleManager.resetScreen();
	        }
	        ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	        FreeRoundBonus_1.FreeRoundBonus.openOther();
	    };
	    GameManager.collectReceived = function (response) {
	        if (false) {
	            GameManager.log("collectReceived");
	        }
	        MessageManager_1.MessageManager.postpone(GameManager.continueCollectReceived, response);
	    };
	    GameManager.continueCollectReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            ModuleManager_1.ModuleManager.collectInModule(GameManager._collectModule);
	            GameManager.canExit();
	        }
	        GameManager.requestSend = false;
	    };
	    GameManager.errorReceived = function (apiError) {
	        var requestName = apiError.requestInfo.request.constructor.name;
	        if (requestName === "FreeRoundsOffersRequest") {
	            FreeRoundBonus_1.FreeRoundBonus.wasInitialized = true;
	            return;
	        }
	        if (false) {
	            GameManager.log("errorReceived");
	        }
	        PIXI.sound.muteAll();
	        var localizedText = "";
	        var isError = true;
	        var code = apiError.httpStatusCode.toString();
	        var customData = {
	            special: false,
	            gameRoundId: neo_common_1.Utils.valueOrDefault(DataManager_1.DataManager.getDataById("ROUND_ID"), "0"),
	            errorId: neo_common_1.Utils.isNullOrUndefined(apiError.error) ? "" : apiError.error.errorId,
	            actions: neo_common_1.Utils.isNullOrUndefined(apiError.error) ? [] : apiError.error["actions"],
	        };
	        var ignoreShowDialog = false;
	        var hasMessages = false;
	        var callbackFnc = null;
	        var isFatalError = true;
	        if (apiError.error) {
	            var resource = "ERROR_" + apiError.httpStatusCode + "_" + apiError.error.code;
	            code = [apiError.httpStatusCode.toString(), apiError.error.code].join("-");
	            localizedText = Languages_1.Languages.getRid(resource);
	            hasMessages = apiError.error.messages != null;
	            if (localizedText == null) {
	                resource = "ERROR_" + apiError.httpStatusCode;
	                code = apiError.httpStatusCode.toString();
	                localizedText = Languages_1.Languages.getRid(resource);
	            }
	            if (AppContext_1.AppContext.gameConfiguration.FRBFreeSpins &&
	                (apiError.error.code === 2017 || apiError.error.code === 2018)) {
	                resource += "_SPIN";
	                localizedText = Languages_1.Languages.getRid(resource);
	            }
	            if ((apiError.httpStatusCode === 400 && apiError.error.code === 1009) ||
	                (apiError.httpStatusCode === 400 && apiError.error.code === 1011) ||
	                (apiError.httpStatusCode === 400 && apiError.error.code === 1012) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2005) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2013) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2014) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2016) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2017) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2018)) {
	                customData.special = true;
	                customData.errorId = "";
	                isError = false;
	            }
	            if ((apiError.httpStatusCode === 500 && apiError.error.code === 2001) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2002) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2012)) {
	                customData.ultraSpecial = true;
	            }
	            if ((apiError.httpStatusCode === 500 && apiError.error.code === 2015) ||
	                (apiError.httpStatusCode === 500 && apiError.error.code === 2016)) {
	                code = "";
	                localizedText = apiError.error.message;
	            }
	            if (apiError.httpStatusCode === 500 && apiError.error.code === 2017) {
	                if (FreeRoundBonus_1.FreeRoundBonus.collectPartial) {
	                    localizedText += Languages_1.Languages.getRid(AppContext_1.AppContext.gameConfiguration.FRBFreeSpins
	                        ? "FRB_COLLECT_PARTIAL_ALLOWED_SPIN"
	                        : "FRB_COLLECT_PARTIAL_ALLOWED");
	                }
	                else {
	                    localizedText += Languages_1.Languages.getRid(AppContext_1.AppContext.gameConfiguration.FRBFreeSpins
	                        ? "FRB_COLLECT_PARTIAL_NOT_ALLOWED_SPIN"
	                        : "FRB_COLLECT_PARTIAL_NOT_ALLOWED");
	                }
	            }
	            if (apiError.httpStatusCode === 500 && apiError.error.code === 2018) {
	                localizedText += Languages_1.Languages.getRid(AppContext_1.AppContext.gameConfiguration.FRBFreeSpins
	                    ? "FRB_COLLECT_PARTIAL_NOT_ALLOWED_SPIN"
	                    : "FRB_COLLECT_PARTIAL_NOT_ALLOWED");
	            }
	            if (apiError.httpStatusCode === 500 && apiError.error.code === 2019) {
	                if (!hasMessages) {
	                    ignoreShowDialog = true;
	                }
	                callbackFnc = MessageManager_1.MessageManager.softResetCallbackFnc;
	                isFatalError = false;
	            }
	            if ((apiError.httpStatusCode === 400 && apiError.error.code === 1011) ||
	                (apiError.httpStatusCode === 400 && apiError.error.code === 1012)) {
	                var spbSufix = AppContext_1.AppContext.gameConfiguration.UseJackpotLocalization ? "_J" : "";
	                localizedText = Languages_1.Languages.getRid(resource + spbSufix);
	            }
	            if (apiError.httpStatusCode === 500 && apiError.error.code === 2020) {
	                SessionTimer_1.SessionTimer.postpone(SessionTimer_1.SessionTimer.callbackFnc, SessionTimer_1.SessionTimer.prepareData(apiError.error));
	                return;
	            }
	        }
	        else {
	            if (apiError.httpStatusCode === 401) {
	                customData.ultraSpecial = true;
	            }
	            var resource = "ERROR_" + apiError.httpStatusCode.toString();
	            localizedText = Languages_1.Languages.getRid(resource);
	        }
	        if (false) {
	            neo_common_1.Logger.debugGroup("GameManager", "[errorReceived] calling " +
	                ("AppContext.current.showDialog('" + localizedText + "', " + isError + ", '" + code + "', \n                    " + customData.errorId + ", " + customData.gameRoundId + ", " + JSON.stringify(customData) + ")"));
	        }
	        if (isError) {
	            var error_code_for_platforms = apiError.httpStatusCode.toString();
	            if (apiError.error) {
	                error_code_for_platforms = [apiError.httpStatusCode.toString(), apiError.error.code].join("-");
	            }
	            neo_games_1.Platforms.Platforms.error(error_code_for_platforms, localizedText);
	            if (isFatalError) {
	                window.onblur = null;
	                window.onfocus = null;
	                Jackpot_1.Jackpot.showError();
	                NotificationManager_1.NotificationManager.disconnect();
	            }
	        }
	        if (neo_games_1.Platforms.Platforms.handleShowErrorDialog || ignoreShowDialog) {
	            return;
	        }
	        if (hasMessages) {
	            MessageManager_1.MessageManager.postpone(callbackFnc, apiError.error);
	        }
	        else {
	            AppContext_1.AppContext.current.showDialog(localizedText, isError, code, customData.errorId, customData.gameRoundId, customData);
	        }
	    };
	    GameManager.parseResponses = function (response) {
	        if (false) {
	            GameManager.log("parseResponses");
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager.gameResponse = response;
	            if (response.module(GameModules.Base) != null) {
	                GameManager.baseResponse = response.module(GameModules.Base);
	            }
	            else {
	                GameManager.baseResponse = null;
	            }
	            if (response.module(GameModules.Gamble) != null) {
	                GameManager.gambleResponse = response.module(GameModules.Gamble);
	            }
	            else {
	                GameManager.gambleResponse = null;
	            }
	            if (response.module(GameModules.BonusRespins) != null) {
	                GameManager.bonusRespinsResponse = response.module(GameModules.BonusRespins);
	            }
	            else {
	                GameManager.bonusRespinsResponse = null;
	            }
	        }
	    };
	    GameManager.collectable = function () {
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	            return false;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.endMsgDisplayed) {
	            return false;
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && Jackpot_1.Jackpot.hasMiniGame()) {
	            return false;
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && DataManager_1.DataManager.Collectable) {
	            return true;
	        }
	        return false;
	    };
	    GameManager.canExit = function (exit) {
	        if (exit === void 0) { exit = false; }
	        var canExit = GameManager.collectable();
	        if (false) {
	            console.log("GameManager.canExit(exit: " + exit + ") -> afterCollect: " + canExit);
	        }
	        if (canExit &&
	            !exit &&
	            ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect &&
	            ResponsibleDialog1_1.ResponsibleDialog1.responsibleDialog1Data != null &&
	            !FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	            DataManager_1.DataManager.Autoplay = false;
	            DataManager_1.DataManager.AutoplayAfterGamble = false;
	            ResponsibleDialog1_1.ResponsibleDialog1.openDialog(ResponsibleDialog1_1.ResponsibleDialog1.responsibleDialog1Data);
	            ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect = false;
	            ResponsibleDialog1_1.ResponsibleDialog1.responsibleDialog1Data = null;
	            ModuleManager_1.ModuleManager.disableBase();
	            ModuleManager_1.ModuleManager.disableGamble();
	            ModuleManager_1.ModuleManager.resetWinAnimator(GameModules.Base);
	        }
	        if (GameManager.exitOnCollect && canExit) {
	            if (false) {
	                console.log(("GameManager.canExit(exit: " + exit + ") -> manuall call of GameApp.exit() ") +
	                    ("because of GameManager.exitOnCollect = " + GameManager.exitOnCollect));
	            }
	            GameApp_1.GameApp.exit();
	            return false;
	        }
	        if (canExit && exit) {
	            return canExit;
	        }
	        else {
	            if (!GameManager.exitOnCollect && exit) {
	                if (false) {
	                    console.log(("GameManager.canExit(exit: " + exit + ") -> ") +
	                        ("changing GameManager.exitOnCollect(" + GameManager.exitOnCollect + ") to value '" + exit + "'"));
	                }
	                GameManager.exitOnCollect = true;
	            }
	        }
	        if (false) {
	            console.log("GameManager.canExit(exit: " + exit + ") -> returns: " + canExit);
	        }
	        return canExit;
	    };
	    GameManager.showResponsibleDialog1 = function (data) {
	        if (GameManager.canExit()) {
	            DataManager_1.DataManager.Autoplay = false;
	            DataManager_1.DataManager.AutoplayAfterGamble = false;
	            ResponsibleDialog1_1.ResponsibleDialog1.openDialog(data);
	            ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect = true;
	            ResponsibleDialog1_1.ResponsibleDialog1.responsibleDialog1Data = null;
	            ModuleManager_1.ModuleManager.disableBase();
	            ModuleManager_1.ModuleManager.disableGamble();
	            ModuleManager_1.ModuleManager.resetWinAnimator(GameModules.Base);
	        }
	        else {
	            ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect = true;
	            ResponsibleDialog1_1.ResponsibleDialog1.responsibleDialog1Data = data;
	        }
	    };
	    GameManager.disablePlay = function () {
	        GameManager.disableOnCollect = true;
	        if (GameManager.collectable()) {
	            GameManager.disableGamePlay = true;
	            ModuleManager_1.ModuleManager.disableBase();
	            DataManager_1.DataManager.gameState("GamePlayDisabled");
	        }
	    };
	    GameManager.enablePlay = function () {
	        GameManager.disableOnCollect = false;
	        GameManager.disableGamePlay = false;
	        if (!GameManager.dontEnableGamePlay) {
	            ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	        }
	        DataManager_1.DataManager.gameState("GamePlayEnabled");
	    };
	    GameManager.openConfirmationDialog = function (module, text) {
	        var dialogData = {
	            text: text,
	            actions: [
	                {
	                    type: "restore",
	                    text: Languages_1.Languages.getRid("CONTINUE"),
	                    customData: module,
	                },
	            ],
	            special: true,
	        };
	        ModuleManager_1.ModuleManager.disableChannelModule(module);
	        AppContext_1.AppContext.current.showDialog(text, false, null, null, null, dialogData);
	    };
	    GameManager.closeResponsibleDialog1 = function () {
	        GameManager.requestSend = false;
	        ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect = false;
	        ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	    };
	    GameManager.getBaseInitDataReels = function () {
	        if (GameManager.baseResponse.initData != null && GameManager.baseResponse.initData.reels != null) {
	            return GameManager.baseResponse.initData.reels;
	        }
	        return null;
	    };
	    GameManager.getBaseInitDataCustomAdditionalReelSets = function () {
	        if (GameManager.baseResponse.initData != null &&
	            GameManager.baseResponse.initData.hasOwnProperty("customData") &&
	            GameManager.baseResponse.initData.customData.hasOwnProperty("additionalReelSets") &&
	            GameManager.baseResponse.initData.customData.additionalReelSets != null) {
	            return GameManager.baseResponse.initData.customData.additionalReelSets;
	        }
	        return null;
	    };
	    GameManager.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("GameManager", s);
	        }
	    };
	    GameManager._collectModule = GameModules.Base;
	    GameManager.requestSend = false;
	    GameManager.exitOnCollect = false;
	    GameManager.disableOnCollect = false;
	    GameManager.disableGamePlay = false;
	    GameManager.dontEnableGamePlay = false;
	    return GameManager;
	}());
	exports.GameManager = GameManager;


/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	var GameData = (function () {
	    function GameData() {
	    }
	    GameData.DataTicker = "TICKER";
	    GameData.DataRoundId = "ROUND_ID";
	    GameData.DataBuildVersion = "BUILD_VERSION";
	    GameData.DataBalanceReal = "BALANCE_REAL";
	    GameData.DataBalanceBonus = "BALANCE_BONUS";
	    GameData.DataBalanceTotal = "BALANCE_TOTAL";
	    GameData.DataBalanceRealDenom = "BALANCE_REAL_DENOM";
	    GameData.DataBalanceBonusDenom = "BALANCE_BONUS_DENOM";
	    GameData.DataBalanceTotalDenom = "BALANCE_TOTAL_DENOM";
	    GameData.DataCurrency = "CURRENCY";
	    GameData.DataDenomination = "DENOMINATION";
	    GameData.DataCurrentWin = "CURRENT_WIN";
	    GameData.DataTotalWin = "TOTAL_WIN";
	    GameData.DataTotalWinDenom = "TOTAL_WIN_DENOM";
	    GameData.DataCoinSize = "COIN_SIZE";
	    GameData.DataCointCount = "COIN_COUNT";
	    GameData.DataPaylineCount = "PAYLINE_COUNT";
	    GameData.DataBet = "BET";
	    GameData.DataBetPosition = "BET_POSITION";
	    GameData.DataGambleCurrentWin = "GAMBLE_WIN";
	    GameData.DataGambleColorWin = "GAMBLE_COLOR_WIN";
	    GameData.DataGambleCurrentWinDenom = "GAMBLE_WIN_DENOM";
	    GameData.DataGambleColorWinDenom = "GAMBLE_COLOR_WIN_DENOM";
	    GameData.DataAutoplayCount = "AUTOPLAY_COUNT";
	    GameData.DataFreeSpinTotalWin = "FREESPIN_TOTAL_WIN";
	    GameData.DataFreeSpinTotalWinDenom = "FREESPIN_TOTAL_WIN_DENOM";
	    GameData.DataFreeSpinsCount = "FREESPINS_COUNT";
	    GameData.DataFreeSpinsRemainingCount = "FREESPINS_REMAINING_COUNT";
	    GameData.DataFreeSpinsWonCount = "FREESPINS_WON_COUNT";
	    GameData.DataBonusTotalWin = "BONUS_TOTAL_WIN";
	    GameData.DataBonusTotalWinDenom = "BONUS_TOTAL_WIN_DENOM";
	    GameData.DataBonusSpinCount = "BONUS_SPINS_COUNT";
	    GameData.DataBonusSpinRemainingCount = "BONUS_REMAINING_COUNT";
	    GameData.DataBonusSpinWonCount = "BONUS_WON_COUNT";
	    GameData.DataGambleAttempts = "GAMBLE_ATTEMPTS";
	    GameData.DataHelpGameLimit = "HELP_GAME_LIMIT";
	    GameData.DataHelpGambleLimit = "HELP_GAMBLE_LIMIT";
	    GameData.DataHelpGambleCountLimit = "HELP_GAMBLE_COUNT_LIMIT";
	    GameData.DataHelpRTP = "HELP_RTP";
	    GameData.DataHelpMaxPayoutProbability = "HELP_MAX_PAYOUT_PROBABILITY";
	    GameData.DataHelpMaxPayoutFrequency = "HELP_MAX_PAYOUT_FREQUENCY";
	    GameData.DataHelpMinBet = "HELP_MIN_BET";
	    GameData.DataHelpMaxBet = "HELP_MAX_BET";
	    GameData.DataHelpVersion = "HELP_VERSION";
	    GameData.DataExpirationResolveHours = "EXPIRATION_RESOLVE_HOURS";
	    GameData.DataFrbRemainginCount = "FRB_REMAINING_COUNT";
	    GameData.DataFrbAssignedCount = "FRB_ASSIGNED_COUNT";
	    GameData.DataFrbRulesLink = "FRB_RULES_LINK";
	    GameData.DataFrbValidTo = "FRB_VALID_TO";
	    GameData.DataFrbExpiryTime = "FRB_EXPIRY_TIME";
	    GameData.DataFrbWin = "FRB_WIN";
	    GameData.DataGameTitle = "GAME_TITLE";
	    GameData.DataHelpJackpotVisibleLimit = "HELP_JACKPOT_VISIBLE_LIMIT";
	    GameData.DataHelpJackpotQualifyingBetsMin = "HELP_JACKPOT_QUALIFYING_BETS_MIN";
	    GameData.DataHelpJackpotQualifyingBetsMax = "HELP_JACKPOT_QUALIFYING_BETS_MAX";
	    GameData.DataBuyFeatureCost = "BUY_FEATURE_COST";
	    GameData.DataBuyFeatureCostWithCurrency = "BUY_FEATURE_COST_WITH_CURRENCY";
	    GameData.DataBuyFeatureBet = "BUY_FEATURE_BET";
	    GameData.DataMaxBuyFeatureBetLimit = "MAX_BUY_FEATURE_BET_LIMIT";
	    return GameData;
	}());
	exports.GameData = GameData;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var ModuleManager_1 = __webpack_require__(29);
	var AppContext_1 = __webpack_require__(5);
	var BalanceManager_1 = __webpack_require__(27);
	var HtmlController_1 = __webpack_require__(31);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var SpinBet = neo_games_1.Communication.Game.SpinBet;
	var BetType = neo_games_1.Communication.Game.BetType;
	var BetManager = (function () {
	    function BetManager() {
	    }
	    BetManager.initializeBet = function () {
	        if (AppContext_1.AppContext.current.getHideAmounts()) {
	            this.hideValues(true);
	        }
	        if (GameManager_1.GameManager.baseResponse.initData != null) {
	            if (GameManager_1.GameManager.baseResponse.initData.betSettings != null &&
	                GameManager_1.GameManager.baseResponse.initData.betSettings.totalBets != null) {
	                BetManager.TotalBets = GameManager_1.GameManager.baseResponse.initData.betSettings.totalBets;
	            }
	            if (GameManager_1.GameManager.baseResponse.initData.betSettings != null &&
	                GameManager_1.GameManager.baseResponse.initData.betSettings.coins != null) {
	                BetManager.Coins = GameManager_1.GameManager.baseResponse.initData.betSettings.coins;
	            }
	            if (GameManager_1.GameManager.baseResponse.initData.lastBet != null &&
	                GameManager_1.GameManager.baseResponse.initData.lastBet.betType === BetType.Total) {
	                if (GameManager_1.GameManager.baseResponse.initData.lastBet.totalBet != null &&
	                    !AppContext_1.AppContext.gameConfiguration.UseCoins) {
	                    if (BetManager.Bet != null &&
	                        BetManager.Bet !== GameManager_1.GameManager.baseResponse.initData.lastBet.totalBet) {
	                        ModuleManager_1.ModuleManager.initNewBet();
	                    }
	                    else {
	                        ModuleManager_1.ModuleManager.initNewBet(false);
	                    }
	                    BetManager.Bet = BetHigherThanMinDialog_1.BetHigherThanMinDialog.getGameStartedWithoutFeature()
	                        ? BetManager.TotalBets[0]
	                        : GameManager_1.GameManager.baseResponse.initData.lastBet.totalBet;
	                    BetManager.updateBetPosition();
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                }
	                else {
	                    if (!DataManager_1.DataManager.GameRoundClosed) {
	                        if (GameManager_1.GameManager.baseResponse.initData.lastBet.coinSize != null) {
	                            BetManager.CoinSize = GameManager_1.GameManager.baseResponse.initData.lastBet.coinSize;
	                            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	                        }
	                        if (GameManager_1.GameManager.baseResponse.initData.lastBet.coinCount != null) {
	                            BetManager.CoinCount = parseInt(GameManager_1.GameManager.baseResponse.initData.lastBet.coinCount.toString());
	                            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	                        }
	                        if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
	                            BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	                            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                        }
	                        BalanceManager_1.BalanceManager.recalculateDenomBalance();
	                    }
	                    else if (AppContext_1.AppContext.current.getDenomination() != null && BetManager.Coins != null) {
	                        if (BetManager.Coins[AppContext_1.AppContext.current.getDenomination()] != null) {
	                            BetManager.changeDenom(AppContext_1.AppContext.current.getDenomination(), true);
	                        }
	                        else {
	                            BetManager.changeDefaultDenom();
	                        }
	                    }
	                    else {
	                        BetManager.changeDefaultDenom();
	                    }
	                    if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
	                        BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	                        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                    }
	                }
	            }
	            BetManager.DigitCount = String(parseInt(String(BetManager.Bet * 100))).length;
	            if (BetManager.DenomContainer != null) {
	                BetManager.DenomContainer.addValues();
	            }
	            if (BetManager.CoinCountContainer != null) {
	                BetManager.CoinCountContainer.addValues();
	            }
	            if (BetManager.BetContainer != null) {
	                BetManager.BetContainer.addValues();
	            }
	        }
	    };
	    BetManager.changeBet = function (decrease, max, cycle) {
	        if (decrease === void 0) { decrease = false; }
	        if (max === void 0) { max = false; }
	        if (cycle === void 0) { cycle = false; }
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.closeDialog(true);
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        }
	        BetManager.unHideValues();
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins) {
	            if (cycle) {
	                BetManager.cycleCoinCount();
	                return;
	            }
	            else if (max) {
	                BetManager.maxCoinCount();
	                return;
	            }
	        }
	        var bonus = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceBonus));
	        var real = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal));
	        if (BetManager.Bet != null && BetManager.TotalBets != null && BetManager.TotalBets.length > 0) {
	            var index;
	            for (var i = 0; i < BetManager.TotalBets.length; i++) {
	                if (BetManager.Bet === BetManager.TotalBets[i]) {
	                    index = i;
	                }
	            }
	            if (index != null) {
	                if (decrease) {
	                    if (index === 0) {
	                        if (cycle) {
	                            index = BetManager.TotalBets.length - 1;
	                        }
	                    }
	                    else {
	                        index--;
	                    }
	                }
	                else {
	                    if (max) {
	                        var findMax = false;
	                        if (!findMax) {
	                            for (var jj = BetManager.TotalBets.length - 1; jj >= 0; jj--) {
	                                if (BetManager.TotalBets[jj] <= bonus && findMax === false) {
	                                    findMax = true;
	                                    index = jj;
	                                }
	                                if (BetManager.TotalBets[jj] <= real && findMax === false) {
	                                    findMax = true;
	                                    index = jj;
	                                }
	                            }
	                        }
	                    }
	                    else {
	                        if (index === BetManager.TotalBets.length - 1) {
	                            if (cycle) {
	                                index = 0;
	                            }
	                        }
	                        else {
	                            index++;
	                        }
	                    }
	                }
	                BetManager.Bet = BetManager.TotalBets[index];
	                if (bonus != null) {
	                    if (bonus >= BetManager.Bet) {
	                        ModuleManager_1.ModuleManager.changeBetColor(true);
	                    }
	                    else {
	                        ModuleManager_1.ModuleManager.changeBetColor();
	                    }
	                }
	                BetManager.DigitCount = String(parseInt(String(BetManager.Bet * 100))).length;
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	                neo_games_1.Platforms.Platforms.bet({
	                    totalBet: BetManager.Bet,
	                    maxBetAction: max,
	                    userAction: DataManager_1.DataManager.getTrustedUserAction("BET_CHANGE"),
	                });
	                BetManager.updateBetPosition();
	            }
	        }
	        BalanceManager_1.BalanceManager.poolingBalance();
	    };
	    BetManager.sortNumber = function (a, b) {
	        return a - b;
	    };
	    BetManager.changeDefaultDenom = function () {
	        BetManager.unHideValues();
	        if (BetManager.Coins != null) {
	            var lowestDenom = void 0;
	            for (var key in BetManager.Coins) {
	                if (lowestDenom == null) {
	                    lowestDenom = parseFloat(key);
	                }
	                else {
	                    if (parseFloat(key) < lowestDenom) {
	                        lowestDenom = parseFloat(key);
	                    }
	                }
	            }
	            BetManager.CoinSize = lowestDenom;
	            AppContext_1.AppContext.current.setDenomination(BetManager.CoinSize);
	            BetManager.Coins[lowestDenom].sort(BetManager.sortNumber);
	            BetManager.CoinCount = BetManager.Coins[lowestDenom][0];
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	            BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCoinSize);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCointCount);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	            neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	            if (BetManager.CoinCountContainer != null) {
	                BetManager.CoinCountContainer.addValues();
	            }
	            BalanceManager_1.BalanceManager.recalculateDenomBalance();
	        }
	    };
	    BetManager.changeDenom = function (value, init) {
	        if (init === void 0) { init = false; }
	        BetManager.unHideValues();
	        if (BetManager.Coins != null && BetManager.Coins[value] != null) {
	            BetManager.CoinSize = value;
	            AppContext_1.AppContext.current.setDenomination(BetManager.CoinSize);
	            BetManager.Coins[value].sort(BetManager.sortNumber);
	            if (!init && BetManager.CoinCount != null && !AppContext_1.AppContext.gameConfiguration.ResetCoinCountOnDenomChange) {
	                var found = false;
	                var coinCount = BetManager.CoinCount;
	                for (var i = 0; i < BetManager.Coins[value].length; i++) {
	                    if (BetManager.Coins[value][i] <= BetManager.CoinCount) {
	                        found = true;
	                        coinCount = BetManager.Coins[value][i];
	                    }
	                }
	                if (!found) {
	                    BetManager.CoinCount = BetManager.Coins[value][0];
	                }
	                else {
	                    BetManager.CoinCount = coinCount;
	                }
	            }
	            else {
	                BetManager.CoinCount = BetManager.Coins[value][0];
	            }
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	            BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCoinSize);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCointCount);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	            neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	            if (BetManager.CoinCountContainer != null) {
	                BetManager.CoinCountContainer.addValues();
	            }
	            BalanceManager_1.BalanceManager.recalculateDenomBalance();
	        }
	        if (DataManager_1.DataManager.HelpDataGameLimit != 0) {
	            if (AppContext_1.AppContext != null &&
	                AppContext_1.AppContext.gameConfiguration != null &&
	                AppContext_1.AppContext.gameConfiguration.UseCoins &&
	                BetManager.CoinSize != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGameLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager_1.DataManager.HelpDataGameLimit, BetManager.CoinSize).toString()).toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataHelpGameLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager_1.DataManager.HelpDataGameLimit, BetManager.CoinSize).toString()).toString());
	            }
	        }
	        if (DataManager_1.DataManager.HelpDataGambleLimit != 0) {
	            if (AppContext_1.AppContext != null &&
	                AppContext_1.AppContext.gameConfiguration != null &&
	                AppContext_1.AppContext.gameConfiguration.UseCoins &&
	                BetManager.CoinSize != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGambleLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager_1.DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString()).toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataHelpGambleLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager_1.DataManager.HelpDataGambleLimit, BetManager.CoinSize).toString()).toString());
	            }
	        }
	    };
	    BetManager.changeBetByValue = function (value) {
	        BetManager.unHideValues();
	        var bonus = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceBonus));
	        BetManager.Bet = value;
	        if (bonus != null) {
	            if (bonus >= BetManager.Bet) {
	                ModuleManager_1.ModuleManager.changeBetColor(true);
	            }
	            else {
	                ModuleManager_1.ModuleManager.changeBetColor();
	            }
	        }
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	        neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	        BetManager.updateBetPosition();
	    };
	    BetManager.changeCoinCount = function (value) {
	        BetManager.unHideValues();
	        if (BetManager.Coins != null) {
	            if (BetManager.CoinSize != null) {
	                BetManager.CoinCount = value;
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	                BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCoinSize);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCointCount);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	                neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	            }
	        }
	    };
	    BetManager.cycleCoinCount = function () {
	        BetManager.unHideValues();
	        if (BetManager.Coins != null) {
	            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
	                var index = 0;
	                var coinSizes = [];
	                for (var i = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
	                    coinSizes.push(BetManager.Coins[BetManager.CoinSize][i]);
	                }
	                coinSizes.sort(BetManager.sortNumber);
	                for (var i = 0; i < coinSizes.length; i++) {
	                    if (BetManager.CoinCount === coinSizes[i]) {
	                        index = i;
	                    }
	                }
	                if (coinSizes[index + 1] != null) {
	                    BetManager.CoinCount = coinSizes[index + 1];
	                }
	                else {
	                    BetManager.CoinCount = coinSizes[0];
	                }
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	                BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCoinSize);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCointCount);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	                neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	            }
	        }
	    };
	    BetManager.maxCoinCount = function () {
	        BetManager.unHideValues();
	        if (BetManager.Coins != null) {
	            if (BetManager.CoinSize != null && BetManager.CoinCount != null) {
	                var credit = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal));
	                var coinCount = BetManager.CoinCount;
	                BetManager.Coins[BetManager.CoinSize].sort(BetManager.sortNumber);
	                for (var i = 0; i < BetManager.Coins[BetManager.CoinSize].length; i++) {
	                    var bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.Coins[BetManager.CoinSize][i]));
	                    if (credit >= bet) {
	                        coinCount = BetManager.Coins[BetManager.CoinSize][i];
	                    }
	                }
	                BetManager.CoinCount = coinCount;
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCoinSize, BetManager.CoinSize.toString());
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataCointCount, BetManager.CoinCount.toString());
	                BetManager.Bet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager.CoinSize, BetManager.CoinCount));
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBet, BetManager.Bet.toString());
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCoinSize);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataCointCount);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBet);
	                neo_games_1.Platforms.Platforms.bet({ totalBet: BetManager.Bet });
	            }
	        }
	    };
	    BetManager.updateBetPosition = function () {
	        if (BetManager.TotalBets != null) {
	            for (var i = 0; i < BetManager.TotalBets.length; i++) {
	                if (BetManager.Bet === BetManager.TotalBets[i]) {
	                    if (i <= 0) {
	                        BetManager.minBet = true;
	                        BetManager.maxBet = false;
	                    }
	                    else if (i >= BetManager.TotalBets.length - 1) {
	                        BetManager.minBet = false;
	                        BetManager.maxBet = true;
	                    }
	                    else {
	                        BetManager.minBet = false;
	                        BetManager.maxBet = false;
	                    }
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBetPosition, i + 1 + "/" + BetManager.TotalBets.length);
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBetPosition);
	                }
	            }
	        }
	    };
	    BetManager.unHideValues = function (credit) {
	        if (credit === void 0) { credit = false; }
	        for (var i = 0; i < HtmlController_1.HtmlController.HideButtons.length; i++) {
	            HtmlController_1.HtmlController.HideButtons[i].unHide(credit);
	        }
	    };
	    BetManager.hideValues = function (credit) {
	        if (credit === void 0) { credit = false; }
	        for (var i = 0; i < HtmlController_1.HtmlController.HideButtons.length; i++) {
	            HtmlController_1.HtmlController.HideButtons[i].hide(credit);
	        }
	    };
	    BetManager.createBetForSpin = function () {
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager.CoinSize != null && BetManager.CoinCount != null) {
	            return new SpinBet(BetType.Total, BetManager.CoinSize, BetManager.CoinCount, null, null);
	        }
	        else {
	            return new SpinBet(BetType.Total, null, null, null, BetManager.Bet);
	        }
	    };
	    BetManager.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("BetManager", s);
	        }
	    };
	    BetManager.DigitCount = 1;
	    BetManager.minBet = false;
	    BetManager.maxBet = false;
	    return BetManager;
	}());
	exports.BetManager = BetManager;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var AppContext_1 = __webpack_require__(5);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var BetManager_1 = __webpack_require__(25);
	var BalanceManager_1 = __webpack_require__(27);
	var HtmlController_1 = __webpack_require__(31);
	var ModuleManager_1 = __webpack_require__(29);
	var Languages_1 = __webpack_require__(28);
	var GameApp_1 = __webpack_require__(1);
	var Scaling_1 = __webpack_require__(8);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var UserAction_1 = __webpack_require__(32);
	var QuickspinDialog_1 = __webpack_require__(53);
	var Jackpot_1 = __webpack_require__(36);
	var GameEvents = neo_games_1.ClientHost.GameEvents;
	var DataManager = (function () {
	    function DataManager() {
	    }
	    Object.defineProperty(DataManager, "RulesWindowOpened", {
	        get: function () {
	            return DataManager._rulesWindowOpened;
	        },
	        set: function (value) {
	            if (value === DataManager._rulesWindowOpened) {
	                return;
	            }
	            DataManager._rulesWindowOpened = value;
	            if (!AppContext_1.AppContext.gameConfiguration.AllowPlayFromRules) {
	                if (value) {
	                    ModuleManager_1.ModuleManager.disableActions();
	                    DataManager.AutoplayPaused = true;
	                }
	                else {
	                    ModuleManager_1.ModuleManager.restoreActions();
	                    DataManager.AutoplayPaused = false;
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DataManager, "Autoplay", {
	        get: function () {
	            return DataManager._autoplay;
	        },
	        set: function (value) {
	            if (DataManager._autoplay != value) {
	                if (value) {
	                    DataManager.AutoplayStarted = true;
	                    neo_games_1.Platforms.Platforms.autoplayStarted();
	                }
	                else {
	                    neo_games_1.Platforms.Platforms.autoplayFinished({
	                        autoplayCount: this.AutoplayCount,
	                        autoplayLossLimit: this.AutoplayLossLimit,
	                        autoplayWinLimit: this.AutoplayWinLimit,
	                    });
	                }
	                DataManager._autoplay = value;
	            }
	            else {
	                DataManager.AutoplayStarted = false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DataManager.controlAutoplay = function () {
	        if (GameApp_1.GameApp.gameClient != null) {
	            GameApp_1.GameApp.gameClient.setAutoplay(DataManager.Autoplay);
	        }
	    };
	    DataManager.autoplayEnabled = function () {
	        if (AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled && DataManager.AutoplayEnabled) {
	            return true;
	        }
	        return false;
	    };
	    DataManager.quickspinEnabled = function () {
	        return DataManager.gameEnableQuickSpin() && DataManager.QuickspinEnabled;
	    };
	    DataManager.gameEnableQuickSpin = function () {
	        return (AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop &&
	            AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration == 0 &&
	            AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan == 0 &&
	            AppContext_1.AppContext.gameConfiguration.GameEnableQuickSpin);
	    };
	    DataManager.quickspinSet = function (toValue) {
	        if (DataManager.gameEnableQuickSpin()) {
	            if (typeof toValue === "boolean") {
	                DataManager.QuickspinEnabled = toValue;
	                HtmlController_1.HtmlController.updateDataElement(UserAction_1.UserAction.ActionQuickspinToggle, toValue ? "true" : "false");
	            }
	            else {
	                DataManager.QuickspinEnabled = !DataManager.QuickspinEnabled;
	                HtmlController_1.HtmlController.updateDataElement(UserAction_1.UserAction.ActionQuickspinToggle, DataManager.QuickspinEnabled ? "true" : "false");
	            }
	            if (false) {
	                this.log("Quickspin " + (DataManager.QuickspinEnabled ? "on" : "off"));
	            }
	        }
	        neo_games_1.Platforms.Platforms.quickSpinEnabled(DataManager.QuickspinEnabled);
	        return DataManager.QuickspinEnabled;
	    };
	    DataManager.quickspinStopped = function () {
	        if (DataManager._quickstopTimes != null) {
	            DataManager._quickstopTimes.push(Date.now() * 0.001);
	            if (DataManager._quickstopTimes.length == AppContext_1.AppContext.gameConfiguration.QuickSpinDialogCount) {
	                var timeDiff = DataManager._quickstopTimes[DataManager._quickstopTimes.length - 1] -
	                    DataManager._quickstopTimes[0];
	                if (timeDiff < AppContext_1.AppContext.gameConfiguration.QuickSpinDecayDelay) {
	                    if (DataManager.gameEnableQuickSpin() && !DataManager.QuickspinEnabled) {
	                        QuickspinDialog_1.QuickspinDialog.openDialog();
	                        DataManager._quickstopTimes = null;
	                    }
	                }
	                else {
	                    DataManager._quickstopTimes.shift();
	                }
	            }
	        }
	    };
	    DataManager.vibrationSet = function (toValue) {
	        if (AppContext_1.AppContext.gameConfiguration.GameEnableVibration) {
	            if (typeof toValue === "boolean") {
	                DataManager.VibrationEnabled = toValue;
	                HtmlController_1.HtmlController.updateDataElement(UserAction_1.UserAction.ActionVibrationToggle, toValue ? "true" : "false");
	            }
	            else {
	                DataManager.VibrationEnabled = !DataManager.VibrationEnabled;
	                HtmlController_1.HtmlController.updateDataElement(UserAction_1.UserAction.ActionVibrationToggle, DataManager.VibrationEnabled ? "true" : "false");
	            }
	            if (false) {
	                this.log("Vibration " + (DataManager.VibrationEnabled ? "on" : "off"));
	            }
	        }
	        return DataManager.VibrationEnabled;
	    };
	    DataManager.updateResponseData = function (init) {
	        DataManager.GameRoundClosed = false;
	        if (!neo_common_1.Utils.isNullOrUndefined(GameManager_1.GameManager.gameResponse)) {
	            var status_1 = GameManager_1.GameManager.gameResponse.status;
	            if (status_1 != null && status_1 === "closed") {
	                DataManager.GameRoundClosed = true;
	            }
	            if (GameManager_1.GameManager.gameResponse.limits != null) {
	                DataManager.GameLimit = true;
	            }
	            else {
	                DataManager.GameLimit = false;
	            }
	            if (init || !(FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                BalanceManager_1.BalanceManager.setBalance();
	            }
	            if (init) {
	                var initResponse = GameManager_1.GameManager.gameResponse;
	                if (initResponse.initData != null && initResponse.initData.currency != null) {
	                    DataManager.updateGameDataFromModule(GameData_1.GameData.DataCurrency, initResponse.initData.currency);
	                }
	                BetManager_1.BetManager.initializeBet();
	                DataManager.configureHelpData();
	                if (GameManager_1.GameManager.gameResponse.balance != null &&
	                    GameManager_1.GameManager.gameResponse.balance.bonus != null &&
	                    GameManager_1.GameManager.gameResponse.balance.bonus >= BetManager_1.BetManager.Bet) {
	                    ModuleManager_1.ModuleManager.changeBetColor(true);
	                }
	                DataManager.updateDataElements();
	            }
	            if (GameManager_1.GameManager.gameResponse.roundId != null) {
	                var elements = document.getElementsByClassName("roundId");
	                for (var i = 0; i < elements.length; i++) {
	                    var element = elements[i];
	                    if (element != null) {
	                        if (!AppContext_1.AppContext.gameConfiguration.GameRoundIdVisible) {
	                            element.style.opacity = "0";
	                        }
	                        else if (GameManager_1.GameManager.gameResponse.roundId === -1) {
	                            element.style.opacity = "1";
	                        }
	                    }
	                }
	                DataManager.updateGameDataFromModule(GameData_1.GameData.DataRoundId, GameManager_1.GameManager.gameResponse.roundId === -1 ? "DEMO" : GameManager_1.GameManager.gameResponse.roundId.toString());
	            }
	            DataManager.updateTotalWin();
	        }
	        if (!Jackpot_1.Jackpot.hasMiniGame()) {
	            BalanceManager_1.BalanceManager.poolingBalance();
	        }
	        if (GameManager_1.GameManager.gameResponse["progressiveBonus"] &&
	            GameManager_1.GameManager.gameResponse["progressiveBonus"].offline === true) {
	            Jackpot_1.Jackpot.showError();
	        }
	        else {
	            Jackpot_1.Jackpot.reinitialize();
	        }
	    };
	    DataManager.updateTotalWin = function () {
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (GameManager_1.GameManager.gameResponse["freeRounds"] != null &&
	                GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
	                if (DataManager.GameRoundClosed) {
	                    var totalWin = GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"];
	                    DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, totalWin.toString());
	                    if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                        DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWinDenom, parseInt(neo_common_1.NumberUtils.devide(totalWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	                    }
	                }
	                else {
	                    if (GameManager_1.GameManager.gameResponse.totalWin != null) {
	                        var totalWin = neo_common_1.NumberUtils.add(GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"], GameManager_1.GameManager.gameResponse.totalWin);
	                        DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, totalWin.toString());
	                        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                            DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWinDenom, parseInt(neo_common_1.NumberUtils.devide(totalWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	                        }
	                    }
	                }
	            }
	        }
	        else if (GameManager_1.GameManager.gameResponse.totalWin != null) {
	            DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, GameManager_1.GameManager.gameResponse.totalWin.toString());
	            if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gameResponse.totalWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	            }
	        }
	    };
	    DataManager.updateTotalGain = function (calculate, customWin) {
	        if (calculate === void 0) { calculate = false; }
	        if (customWin === void 0) { customWin = 0; }
	        if (GameManager_1.GameManager.gameResponse.totalGain != null &&
	            AppContext_1.AppContext.gameConfiguration.StatusBar.indexOf(neo_games_1.Plugins.StatusBar.Types.TOTAL_GAIN) > -1) {
	            var totalGain = GameManager_1.GameManager.gameResponse.totalGain;
	            if (calculate) {
	                var bet = FreeRoundBonus_1.FreeRoundBonus.inFrb ? 0 : BetManager_1.BetManager.Bet;
	                totalGain = parseFloat(neo_common_1.NumberUtils.subtract(totalGain, bet));
	                if (GameManager_1.GameManager.gameResponse.totalWin > 0 && !DataManager.GameRoundClosed) {
	                    totalGain = parseFloat(neo_common_1.NumberUtils.add(totalGain, GameManager_1.GameManager.gameResponse.totalWin));
	                }
	            }
	            if (customWin > 0) {
	                totalGain = parseFloat(neo_common_1.NumberUtils.add(totalGain, customWin));
	            }
	            GameManager_1.GameManager.gameResponse.totalGain = totalGain;
	            var statusBar = neo_games_1.Plugins.StatusBar.getInstance();
	            var resize = !statusBar.hasActiveWidget();
	            statusBar.add(neo_games_1.Plugins.StatusBar.Types.TOTAL_GAIN, "totalGain", Languages_1.Languages.getRid("SB_INFO_TOTAL_GAIN", Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, totalGain.toString())) +
	                " " +
	                DataManager.getDataById(GameData_1.GameData.DataCurrency));
	            if (resize) {
	                Scaling_1.Scaling.resizeRoot();
	            }
	        }
	    };
	    DataManager.updateGameDataFromModule = function (dataId, value) {
	        if (dataId === GameData_1.GameData.DataCurrency) {
	            if (neo_common_1.Utils.isNullOrUndefined(DataManager.DisplayCurrencies)) {
	                DataManager.DisplayCurrencies = {};
	                AppContext_1.AppContext.gameConfiguration.DisplayCurrencies.forEach(function (rawPair) {
	                    var parsedPair = neo_common_1.ArrayUtils.stringArray(rawPair);
	                    DataManager.DisplayCurrencies[parsedPair[0]] = parsedPair[1];
	                });
	            }
	            if (DataManager.DisplayCurrencies.hasOwnProperty(value)) {
	                DataManager._gameData[dataId] = DataManager.DisplayCurrencies[value];
	                return;
	            }
	        }
	        DataManager._gameData[dataId] = value;
	    };
	    DataManager.getDataById = function (dataId) {
	        if (DataManager._gameData[dataId] != null) {
	            return DataManager._gameData[dataId];
	        }
	        return null;
	    };
	    DataManager.updateDataElement = function (dataId, customValue) {
	        if (customValue != null) {
	            HtmlController_1.HtmlController.updateDataElement(dataId, customValue);
	        }
	        else {
	            if (DataManager._gameData[dataId] != null) {
	                HtmlController_1.HtmlController.updateDataElement(dataId, DataManager._gameData[dataId]);
	            }
	        }
	    };
	    DataManager.updateDataElements = function () {
	        HtmlController_1.HtmlController.updateDataElements(DataManager._gameData);
	        DataManager.updateTotalGain();
	    };
	    DataManager.getServerTime = function () {
	        if (!AppContext_1.AppContext.gameConfiguration.UseServerTime) {
	            return;
	        }
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient.sendServerTimerRequest().then(function (response) {
	                DataManager.serverTimeReceived(response);
	                if (AppContext_1.AppContext.gameConfiguration.UseServerTime &&
	                    neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.ApplicationGatewayUrl)) {
	                    setTimeout(function () {
	                        DataManager.getServerTime();
	                    }, 30000);
	                }
	            });
	        }
	    };
	    DataManager.serverTimeReceived = function (response) {
	        if (response == null) {
	            return;
	        }
	        if (response.utcTime == null && response.time == null) {
	            return;
	        }
	        DataManager.utcTime = response.utcTime;
	        DataManager.time = response.time;
	        DataManager.serverTimeResponseTimestamp = Date.now();
	        if (DataManager.utcTime != null) {
	            if (DataManager.utcTime.indexOf("Z") == -1) {
	                DataManager.utcTime = DataManager.utcTime + "Z";
	            }
	            neo_games_1.Platforms.Platforms.clockSync(Date.now() - Date.parse(DataManager.utcTime));
	        }
	        if (DataManager.serverTimeOffset === -1) {
	            var currentTime = new Date().getTime();
	            var serverTime = Date.parse(DataManager.utcTime ? DataManager.utcTime.replace("Z", "") : DataManager.time);
	            DataManager.serverTimeOffset = serverTime - currentTime;
	        }
	    };
	    DataManager.getFormattedTime = function (time) {
	        if (time == null) {
	            return null;
	        }
	        var year = time.getFullYear();
	        var month = DataManager.zerosPad(time.getMonth() + 1, 2);
	        var day = DataManager.zerosPad(time.getDate(), 2);
	        var hours = DataManager.zerosPad(time.getHours(), 2);
	        var minutes = DataManager.zerosPad(time.getMinutes(), 2);
	        var seconds = DataManager.zerosPad(time.getSeconds(), 2);
	        var milliseconds = time.getMilliseconds();
	        return year + "-" + month + "-" + day + "T" + hours + ":" + minutes + ":" + seconds + "." + milliseconds;
	    };
	    DataManager.zerosPad = function (num, size) {
	        var s = num + "";
	        while (s.length < size)
	            s = "0" + s;
	        return s;
	    };
	    DataManager.getTimeData = function () {
	        var currentTime = new Date();
	        var utcTime = DataManager.getUTCTime();
	        var machineLocalTimeZone = currentTime.getTimezoneOffset() * -1;
	        return {
	            utcTime: utcTime,
	            machineLocalTimeZone: machineLocalTimeZone,
	        };
	    };
	    DataManager.getUTCTime = function () {
	        if (!neo_common_1.StringUtils.isNullOrEmpty(DataManager.utcTime)) {
	            var currentTime = new Date();
	            var utcResponseTimestamp = Date.parse(DataManager.utcTime);
	            var lastResponseDiff = currentTime.getTime() - DataManager.serverTimeResponseTimestamp;
	            return new Date(utcResponseTimestamp + lastResponseDiff).toISOString();
	        }
	        return new Date().toISOString();
	    };
	    DataManager.getGameTime = function (utcTime) {
	        if (utcTime.indexOf("Z") == -1) {
	            utcTime = utcTime + "Z";
	        }
	        var utcTimestamp = Date.parse(utcTime.replace("Z", ""));
	        if (AppContext_1.AppContext.gameConfiguration.UseServerTime) {
	            var offset = DataManager.utcTime ? DataManager.serverTimeOffset : 0;
	            return DataManager.getFormattedTime(new Date(utcTimestamp - offset));
	        }
	        return DataManager.getFormattedTime(new Date(utcTime));
	    };
	    DataManager.getNonUTCGameTime = function () {
	        if (!AppContext_1.AppContext.gameConfiguration.UseServerTime) {
	            return DataManager.getFormattedTime(new Date());
	        }
	        if (!neo_common_1.StringUtils.isNullOrEmpty(DataManager.time)) {
	            var currentTime = new Date();
	            var utcResponseTimestamp = Date.parse(DataManager.time);
	            var lastResponseDiff = currentTime.getTime() - DataManager.serverTimeResponseTimestamp;
	            return DataManager.getFormattedTime(new Date(utcResponseTimestamp + lastResponseDiff - DataManager.serverTimeOffset));
	        }
	        return DataManager.getFormattedTime(new Date());
	    };
	    DataManager.showTime = function () {
	        if (!AppContext_1.AppContext.gameConfiguration.UIShowTime) {
	            return;
	        }
	        var today = new Date(DataManager.getNonUTCGameTime());
	        if (DataManager.utcTime != null) {
	            var timeData = DataManager.getTimeData();
	            today = new Date(DataManager.getGameTime(timeData.utcTime));
	        }
	        var h = today.getHours();
	        var hFixed = h + "";
	        if (h < 10) {
	            hFixed = "0" + h;
	        }
	        var m = today.getMinutes();
	        var mFixed = m + "";
	        if (m < 10) {
	            mFixed = "0" + m;
	        }
	        DataManager.updateDataElement("TIME", hFixed + ":" + mFixed);
	        setTimeout(function () {
	            DataManager.showTime();
	        }, 1000);
	    };
	    DataManager.showSessionTime = function (time) {
	        if (AppContext_1.AppContext.gameConfiguration.GUIShowSessionTime) {
	            if (time < 0) {
	                time = 0;
	            }
	            var sec_num = time;
	            var hours = Math.floor(sec_num / 3600);
	            var minutes = Math.floor((sec_num - hours * 3600) / 60);
	            var seconds = sec_num - hours * 3600 - minutes * 60;
	            var hoursS = hours.toString();
	            var minutesS = minutes.toString();
	            var secondsS = seconds.toString();
	            if (hours < 10) {
	                hoursS = "0" + hours;
	            }
	            if (minutes < 10) {
	                minutesS = "0" + minutes;
	            }
	            if (seconds < 10) {
	                secondsS = "0" + seconds;
	            }
	            var pre = AppContext_1.AppContext.gameConfiguration.UIShowTime ? "&nbsp;|&nbsp;" : "";
	            DataManager.updateDataElement("SESSION_TIME", pre + hoursS + ":" + minutesS + ":" + secondsS);
	            time++;
	            setTimeout(function () {
	                DataManager.showSessionTime(time);
	            }, 1000);
	        }
	    };
	    DataManager.configureGameData = function () {
	        if (AppContext_1.AppContext.gameConfiguration.StatusBar.indexOf(neo_games_1.Plugins.StatusBar.Types.StatusBarMessage) > -1) {
	            if (AppContext_1.AppContext.gameConfiguration.StatusBarData != null &&
	                AppContext_1.AppContext.gameConfiguration.StatusBarData[neo_games_1.Plugins.StatusBar.Types.StatusBarMessage] != null) {
	                var statusBar = neo_games_1.Plugins.StatusBar.getInstance();
	                statusBar.add(neo_games_1.Plugins.StatusBar.Types.StatusBarMessage, "statusBarMessage", AppContext_1.AppContext.gameConfiguration.StatusBarData[neo_games_1.Plugins.StatusBar.Types.StatusBarMessage]);
	                Scaling_1.Scaling.resizeRoot();
	            }
	        }
	        var gameTitle = document.getElementById("gameTitle");
	        if (gameTitle != null) {
	            DataManager.updateDataElement(GameData_1.GameData.DataGameTitle, gameTitle.innerHTML);
	            var gameHeadline = document.getElementById("gameHeadline");
	            if (gameHeadline != null) {
	                gameHeadline.style.display = "none";
	            }
	        }
	        DataManager.hideDataElements("helpFRBNote");
	        DataManager.hideDataElements("helpFRBNote2");
	        if (AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0 || AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan) {
	            if (AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop) {
	                DataManager.showDataElements(AppContext_1.AppContext.gameConfiguration.GameEnableQuickSpin ? "helpFRBNote" : "helpFRBNote2");
	            }
	        }
	        if (!AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop) {
	            DataManager.hideDataElements("GameEnableReelsStop");
	        }
	        else {
	            DataManager.hideDataElements("GameDisableReelsStop");
	        }
	        if (!DataManager.gameEnableQuickSpin()) {
	            DataManager.hideDataElements("quickSpinSettings");
	        }
	        if (!AppContext_1.AppContext.gameConfiguration.GameEnableVibration) {
	            DataManager.hideDataElements("vibrationSettings");
	        }
	        if (!DataManager.hasSettingsMenu()) {
	            DataManager.hideDataElements("helpGameSettings");
	        }
	    };
	    DataManager.hasSettingsMenu = function () {
	        if (DataManager.gameEnableQuickSpin()) {
	            return true;
	        }
	        return false;
	    };
	    DataManager.configureHelpData = function () {
	        DataManager.showDataElements("gambleAttempts");
	        DataManager.showDataElements("helpGameLimit");
	        DataManager.showDataElements("helpGambleLimit");
	        DataManager.showDataElements("helpGambleCountLimit");
	        DataManager.showDataElements("helpJoker");
	        DataManager.showDataElements("helpRTP");
	        DataManager.showDataElements("totalRTP");
	        DataManager.hideDataElements("helpVersion");
	        DataManager.showDataElements("helpJackpotVisibleLimit");
	        DataManager.showDataElements("helpJackpotContributionAll");
	        DataManager.showDataElements("helpJackpotQualifyingBetsAll");
	        DataManager.showDataElements("helpJackpotQualifyingBetsMin");
	        DataManager.showDataElements("helpJackpotQualifyingBetsMax");
	        DataManager.hideDataElements("helpShowCumulativeWinLimit");
	        DataManager.hideDataElements("helpMPP");
	        DataManager.hideDataElements("helpMPF");
	        if (AppContext_1.AppContext != null) {
	            if (GameManager_1.GameManager.gameResponse != null) {
	                if (GameManager_1.GameManager.gameResponse["helpData"] == null) {
	                    DataManager.hideDataElements("gambleAttempts");
	                    DataManager.hideDataElements("helpGameLimit");
	                    DataManager.hideDataElements("helpGambleLimit");
	                    DataManager.hideDataElements("helpGambleCountLimit");
	                    DataManager.hideDataElements("helpJoker");
	                    DataManager.hideDataElements("helpRTP");
	                    DataManager.hideDataElements("totalRTP");
	                    DataManager.hideDataElements("helpMPP");
	                    DataManager.hideDataElements("helpMPF");
	                }
	                else {
	                    if (GameManager_1.GameManager.gambleResponse == null) {
	                        DataManager.hideDataElements("hlpGambleSection");
	                        DataManager.showDataElements("hlpNoGambleSection", "");
	                    }
	                    else {
	                        DataManager.hideDataElements("hlpNoGambleSection");
	                        DataManager.showDataElements("hlpGambleSection", "");
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gambleCountLimit"] == null) {
	                        DataManager.hideDataElements("gambleAttempts");
	                    }
	                    else {
	                        if (GameManager_1.GameManager.gambleResponse != null &&
	                            GameManager_1.GameManager.gambleResponse["totalCount"] != null &&
	                            GameManager_1.GameManager.gambleResponse["currentCount"] != null) {
	                            DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, (GameManager_1.GameManager.gambleResponse["totalCount"] -
	                                GameManager_1.GameManager.gambleResponse["currentCount"]).toString());
	                        }
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"] != null) {
	                        DataManager.HelpDataGameLimit = GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"];
	                        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                            DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGameLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager_1.BetManager.CoinSize).toString()).toString());
	                            DataManager.updateDataElement(GameData_1.GameData.DataHelpGameLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager.HelpDataGameLimit, BetManager_1.BetManager.CoinSize).toString()).toString());
	                        }
	                        else {
	                            DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGameLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"]) +
	                                " " +
	                                DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                            DataManager.updateDataElement(GameData_1.GameData.DataHelpGameLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"]) +
	                                " " +
	                                DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                        }
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"] == null ||
	                        !AppContext_1.AppContext.gameConfiguration.HelpShowGameLimit) {
	                        DataManager.hideDataElements("helpGameLimit");
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gambleLimit"] != null) {
	                        DataManager.HelpDataGambleLimit = GameManager_1.GameManager.gameResponse["helpData"]["gambleLimit"];
	                        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                            DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGambleLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager_1.BetManager.CoinSize).toString()).toString());
	                            DataManager.updateDataElement(GameData_1.GameData.DataHelpGambleLimit, parseInt(neo_common_1.NumberUtils.devide(DataManager.HelpDataGambleLimit, BetManager_1.BetManager.CoinSize).toString()).toString());
	                        }
	                        else {
	                            DataManager.updateGameDataFromModule(GameData_1.GameData.DataHelpGambleLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, GameManager_1.GameManager.gameResponse["helpData"]["gambleLimit"]) +
	                                " " +
	                                DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                            DataManager.updateDataElement(GameData_1.GameData.DataHelpGambleLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, GameManager_1.GameManager.gameResponse["helpData"]["gambleLimit"]) +
	                                " " +
	                                DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                        }
	                    }
	                    else {
	                        DataManager.hideDataElements("helpGambleLimit");
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gambleCountLimit"] == null) {
	                        DataManager.hideDataElements("helpGambleCountLimit");
	                    }
	                    else {
	                        DataManager.updateDataElement(GameData_1.GameData.DataHelpGambleCountLimit, GameManager_1.GameManager.gameResponse["helpData"]["gambleCountLimit"] + " ");
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["gambleWithJoker"] == null ||
	                        !GameManager_1.GameManager.gameResponse["helpData"]["gambleWithJoker"]) {
	                        DataManager.hideDataElements("helpJoker");
	                    }
	                    var rtp = GameManager_1.GameManager.gameResponse["helpData"]["rtp"];
	                    var totalRtp = GameManager_1.GameManager.gameResponse["helpData"]["totalRtp"];
	                    var progressiveBonusRtp = GameManager_1.GameManager.gameResponse["helpData"]["progressiveBonusRtp"];
	                    var ridTotalRTP = AppContext_1.AppContext.gameConfiguration.UseJackpotLocalization
	                        ? "HLP_AD_INFO_TOTAL_RTP_J"
	                        : "HLP_AD_INFO_TOTAL_RTP";
	                    var statusBarRtp = void 0;
	                    if (totalRtp != null &&
	                        progressiveBonusRtp != null &&
	                        rtp != null &&
	                        AppContext_1.AppContext.gameConfiguration.HelpShowRTP) {
	                        DataManager.hideDataElements("helpRTP");
	                        DataManager.setDataElements("totalRTP", Languages_1.Languages.getRid(ridTotalRTP, totalRtp.toString(), rtp.toString(), progressiveBonusRtp.toString()));
	                        statusBarRtp = totalRtp.toString();
	                    }
	                    else if (rtp != null && AppContext_1.AppContext.gameConfiguration.HelpShowRTP) {
	                        DataManager.hideDataElements("totalRTP");
	                        DataManager.updateDataElement(GameData_1.GameData.DataHelpRTP, rtp.toString());
	                        statusBarRtp = rtp.toString();
	                    }
	                    else {
	                        DataManager.hideDataElements("helpRTP");
	                        DataManager.hideDataElements("totalRTP");
	                    }
	                    if (statusBarRtp != null &&
	                        AppContext_1.AppContext.gameConfiguration.StatusBar.indexOf(neo_games_1.Plugins.StatusBar.Types.RTP) > -1) {
	                        var statusBar = neo_games_1.Plugins.StatusBar.getInstance();
	                        statusBar.add(neo_games_1.Plugins.StatusBar.Types.RTP, "rtp", Languages_1.Languages.getRid("SB_INFO_RTP", statusBarRtp.toString()));
	                        Scaling_1.Scaling.resizeRoot();
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["version"] == null ||
	                        !AppContext_1.AppContext.gameConfiguration.HelpShowGameModuleVersion) {
	                        DataManager.hideDataElements("helpVersion");
	                    }
	                    else {
	                        DataManager.updateDataElement(GameData_1.GameData.DataHelpVersion, GameManager_1.GameManager.gameResponse["helpData"]["version"].toString());
	                        DataManager.showDataElements("helpVersion");
	                    }
	                    if (GameManager_1.GameManager.gameResponse["helpData"]["maxPayoutProbability"] != null) {
	                        if (AppContext_1.AppContext.gameConfiguration.StatusBar.indexOf(neo_games_1.Plugins.StatusBar.Types.MaxPayoutProbability) > -1) {
	                            var statusBar = neo_games_1.Plugins.StatusBar.getInstance();
	                            statusBar.add(neo_games_1.Plugins.StatusBar.Types.MaxPayoutProbability, "maxPayoutProbability", Languages_1.Languages.getRid("SB_INFO_MAX_PAYOUT_PROBABILITY", GameManager_1.GameManager.gameResponse["helpData"]["maxPayoutProbability"]));
	                            Scaling_1.Scaling.resizeRoot();
	                        }
	                        if (AppContext_1.AppContext.gameConfiguration.HelpShowMaxPayoutProbabilityFrequency &&
	                            GameManager_1.GameManager.gameResponse["helpData"]["maxTotalPayoutProbability"] != null) {
	                            DataManager.setDataElements("helpMPF", Languages_1.Languages.getRid("HLP_AD_INFO_MAX_PAYOUT_FREQUENCY", GameManager_1.GameManager.gameResponse["helpData"]["maxPayoutProbability"].toString(), GameManager_1.GameManager.gameResponse["helpData"]["maxTotalPayoutProbability"].toString()));
	                            DataManager.showDataElements("helpMPF");
	                        }
	                        else if (AppContext_1.AppContext.gameConfiguration.HelpShowMaxPayoutProbability) {
	                            DataManager.updateDataElement(GameData_1.GameData.DataHelpMaxPayoutProbability, GameManager_1.GameManager.gameResponse["helpData"]["maxPayoutProbability"].toString());
	                            DataManager.showDataElements("helpMPP");
	                        }
	                    }
	                    if (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusTicketConstraint == "WithinGameRound" &&
	                        AppContext_1.AppContext.gameConfiguration.ProgressiveBonusHelpShowCumulativeWinLimit &&
	                        GameManager_1.GameManager.gameResponse["helpData"]["gameLimit"] != null) {
	                        DataManager.showDataElements("helpShowCumulativeWinLimit");
	                    }
	                }
	            }
	            if (GameManager_1.GameManager.baseResponse.initData != null) {
	                if (GameManager_1.GameManager.baseResponse.initData["customData"] != null &&
	                    GameManager_1.GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"] != null &&
	                    GameManager_1.GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"] > 0) {
	                    HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataMaxBuyFeatureBetLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, GameManager_1.GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"]) +
	                        "\u00A0" +
	                        DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                }
	                else {
	                    DataManager.hideDataElements("helpMaxBuyFeatureBetLimit");
	                }
	            }
	            if (BetManager_1.BetManager.TotalBets.length > 0) {
	                DataManager.updateDataElement(GameData_1.GameData.DataHelpMinBet, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, Math.min.apply(Math, BetManager_1.BetManager.TotalBets).toString()) +
	                    " " +
	                    DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                DataManager.updateDataElement(GameData_1.GameData.DataHelpMaxBet, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, Math.max.apply(Math, BetManager_1.BetManager.TotalBets).toString()) +
	                    " " +
	                    DataManager.getDataById(GameData_1.GameData.DataCurrency));
	            }
	            else {
	                DataManager.hideDataElements("helpMinBet");
	                DataManager.hideDataElements("helpMaxBet");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusContributeOnlyQualified) {
	                DataManager.hideDataElements("helpJackpotContributionAll");
	                DataManager.showDataElements("helpJackpotContributionQualifying");
	            }
	            else {
	                DataManager.showDataElements("helpJackpotContributionAll");
	                DataManager.hideDataElements("helpJackpotContributionQualifying");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusVisibleMax > 0 &&
	                AppContext_1.AppContext.gameConfiguration.ProgressiveBonusHelpShowMaxVisibleLimit) {
	                DataManager.updateDataElement(GameData_1.GameData.DataHelpJackpotVisibleLimit, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, AppContext_1.AppContext.gameConfiguration.ProgressiveBonusVisibleMax.toString()) +
	                    " " +
	                    DataManager.getDataById(GameData_1.GameData.DataCurrency));
	            }
	            else {
	                DataManager.hideDataElements("helpJackpotVisibleLimit");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusMinQualifyingBet > 0) {
	                DataManager.hideDataElements("helpJackpotQualifyingBetsAll");
	                DataManager.updateDataElement(GameData_1.GameData.DataHelpJackpotQualifyingBetsMin, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, AppContext_1.AppContext.gameConfiguration.ProgressiveBonusMinQualifyingBet.toString()) +
	                    " " +
	                    DataManager.getDataById(GameData_1.GameData.DataCurrency));
	            }
	            else {
	                DataManager.hideDataElements("helpJackpotQualifyingBetsMin");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusMaxQualifyingBet > 0) {
	                DataManager.hideDataElements("helpJackpotQualifyingBetsAll");
	                DataManager.updateDataElement(GameData_1.GameData.DataHelpJackpotQualifyingBetsMax, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, AppContext_1.AppContext.gameConfiguration.ProgressiveBonusMaxQualifyingBet.toString()) +
	                    " " +
	                    DataManager.getDataById(GameData_1.GameData.DataCurrency));
	            }
	            else {
	                DataManager.hideDataElements("helpJackpotQualifyingBetsMax");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.AutoplayMode === "simple") {
	                DataManager.hideDataElements("helpAutoplayBasic");
	                DataManager.hideDataElements("helpAutoplayAdvanced");
	            }
	            else if (AppContext_1.AppContext.gameConfiguration.AutoplayMode === "advanced") {
	                DataManager.hideDataElements("helpAutoplayBasic");
	                DataManager.hideDataElements("helpAutoplaySimple");
	            }
	            else {
	                DataManager.hideDataElements("helpAutoplaySimple");
	                DataManager.hideDataElements("helpAutoplayAdvanced");
	            }
	            if (!AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled) {
	                DataManager.hideDataElements("helpAutoplayEnabled");
	            }
	            else {
	                DataManager.hideDataElements("helpAutoplayDisabled");
	            }
	            if (!AppContext_1.AppContext.gameConfiguration.ShowHomeButton) {
	                DataManager.hideDataElements("gameHomeBtn");
	            }
	            if (!AppContext_1.AppContext.gameConfiguration.ShowGameRoundsHistory) {
	                DataManager.hideDataElements("historyBtn");
	                DataManager.hideDataElements("helpHistoryBtn");
	            }
	            if (AppContext_1.AppContext.gameConfiguration.ExpirationResolveHours > 0) {
	                DataManager.updateDataElement(GameData_1.GameData.DataExpirationResolveHours, AppContext_1.AppContext.gameConfiguration.ExpirationResolveHours.toString());
	            }
	            else {
	                DataManager.hideDataElements("expirationResolveHours");
	            }
	        }
	    };
	    DataManager.setDataElements = function (cls, text) {
	        var elements = document.getElementsByClassName(cls);
	        for (var i = 0; i < elements.length; i++) {
	            var element = elements[i];
	            if (element != null) {
	                element.innerHTML = text;
	            }
	        }
	    };
	    DataManager.hideDataElements = function (cls) {
	        var elements = document.getElementsByClassName(cls);
	        for (var i = 0; i < elements.length; i++) {
	            var element = elements[i];
	            if (element != null) {
	                element.style.display = "none";
	            }
	        }
	    };
	    DataManager.showDataElements = function (cls, display) {
	        if (display === void 0) { display = "block"; }
	        var elements = document.getElementsByClassName(cls);
	        for (var i = 0; i < elements.length; i++) {
	            var element = elements[i];
	            if (element != null) {
	                element.style.display = display;
	            }
	        }
	    };
	    DataManager.cleanUpElements = function () {
	        var elements;
	        if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration != null && AppContext_1.AppContext.gameConfiguration.UseCoins) {
	            elements = document.getElementsByClassName("useCoinsFalse");
	        }
	        else {
	            elements = document.getElementsByClassName("useCoinsTrue");
	        }
	        if (elements != null && elements.length > 0) {
	            while (elements.length > 0) {
	                elements[0].parentNode.removeChild(elements[0]);
	            }
	        }
	        if (AppContext_1.AppContext.gameConfiguration.UseJackpotLocalization) {
	            elements = document.getElementsByClassName("helpJackpotB");
	        }
	        else {
	            elements = document.getElementsByClassName("helpJackpotJ");
	        }
	        if (elements != null && elements.length > 0) {
	            while (elements.length > 0) {
	                elements[0].parentNode.removeChild(elements[0]);
	            }
	        }
	        elements = document.getElementsByClassName("settingTabItem");
	        var hideSettingsButton = true;
	        for (var i = 0; i < elements.length; i++) {
	            if (elements[i].style.display != "none") {
	                hideSettingsButton = false;
	            }
	        }
	        if (hideSettingsButton) {
	            elements = document.getElementsByClassName("settingsBtn");
	            if (elements != null && elements.length > 0) {
	                while (elements.length > 0) {
	                    elements[0].parentNode.removeChild(elements[0]);
	                }
	            }
	        }
	    };
	    DataManager.addTrustedUserAction = function (actionId) {
	        if (DataManager.TrustedUserActions.indexOf(actionId) == -1) {
	            var groupActionId = DataManager.getGroupActionId(actionId);
	            DataManager.TrustedUserActions.push(groupActionId);
	        }
	    };
	    DataManager.getTrustedUserAction = function (groupActionId) {
	        var index = DataManager.TrustedUserActions.indexOf(groupActionId);
	        if (index == -1) {
	            return false;
	        }
	        else {
	            DataManager.TrustedUserActions.splice(index, 1);
	            return true;
	        }
	    };
	    DataManager.getGroupActionId = function (actionId) {
	        var result = actionId;
	        switch (actionId) {
	            case "BET_PLUS":
	            case "BET_MINUS":
	            case "BET_CYCLE":
	            case "MAX_BET":
	            case "COIN_SIZE_PLUS":
	            case "COIN_SIZE_PLUS_CYCLE":
	            case "COIN_SIZE_MINUS":
	            case "PAYLINE_COUNT_PLUS":
	            case "PAYLINE_COUNT_PLUS_CYCLE":
	            case "PAYLINE_COUNT_MINUS":
	                result = "BET_CHANGE";
	                break;
	            case "SPIN":
	                result = "SPIN";
	                break;
	            case "SPIN_OR_STOP":
	                if (HtmlController_1.HtmlController.ActionElements["SPIN_STOP"] != null) {
	                    var btn = HtmlController_1.HtmlController.ActionElements["SPIN_STOP"][0];
	                    if (btn != null && btn.instance.classList.contains("_disabled")) {
	                        result = "SPIN";
	                    }
	                }
	        }
	        return result;
	    };
	    DataManager.stopAutoplayIfLossLimit = function () {
	        if (DataManager.AutoplayLossLimit === "∞") {
	            return;
	        }
	        var lossLimit = parseFloat(DataManager.AutoplayLossLimit);
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            lossLimit += GameManager_1.GameManager.baseResponse.totalWin;
	        }
	        if (lossLimit - BetManager_1.BetManager.Bet < 0) {
	            DataManager.Autoplay = false;
	        }
	    };
	    DataManager.updateLossLimit = function (win) {
	        if (win === void 0) { win = 0; }
	        if (DataManager.AutoplayLossLimit === "∞") {
	            return;
	        }
	        var lossLimit = parseFloat(DataManager.AutoplayLossLimit);
	        if (win > 0) {
	            lossLimit += win;
	        }
	        else {
	            if (BetManager_1.BetManager.Bet != null) {
	                lossLimit = neo_common_1.NumberUtils.toNumber(neo_common_1.NumberUtils.subtract(lossLimit, BetManager_1.BetManager.Bet));
	            }
	        }
	        DataManager.AutoplayLossLimit = lossLimit + "";
	    };
	    DataManager.stopAutoplayIfWinLimit = function () {
	        if (!DataManager.Autoplay) {
	            return false;
	        }
	        if (DataManager.AutoplayWinLimit == "∞") {
	            return false;
	        }
	        else {
	            if (GameManager_1.GameManager.gameResponse != null &&
	                GameManager_1.GameManager.gameResponse.totalWin > 0 &&
	                GameManager_1.GameManager.gameResponse.totalWin >= parseFloat(DataManager.AutoplayWinLimit)) {
	                DataManager.Autoplay = false;
	                return true;
	            }
	        }
	    };
	    DataManager.gameState = function (state) {
	        if (AppContext_1.AppContext.clientHost) {
	            var messageId = GameManager_1.GameManager.gameResponse.messageId;
	            var unpaidWin = GameManager_1.GameManager.gameResponse.totalWin;
	            var gameRoundId = GameManager_1.GameManager.gameResponse.roundId;
	            var gameEvent = void 0;
	            switch (state) {
	                case "PrimaryGameEscrow":
	                    gameEvent = GameEvents.PrimaryGameEscrow(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "PrimaryGameStarted":
	                    gameEvent = GameEvents.PrimaryGameStarted(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "PrimaryGameEnded":
	                    gameEvent = GameEvents.PrimaryGameEnded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameEntered":
	                    gameEvent = GameEvents.SecondaryGameEntered(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameEscrow":
	                    gameEvent = GameEvents.SecondaryGameEscrow(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameStarted":
	                    gameEvent = GameEvents.SecondaryGameStarted(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "GameCollectEscrow":
	                    gameEvent = GameEvents.GameCollectEscrow(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameCollectEscrow":
	                    gameEvent = GameEvents.SecondaryGameCollectEscrow(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameEnded":
	                    gameEvent = GameEvents.SecondaryGameEnded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "GameEnded":
	                    gameEvent = GameEvents.GameEnded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "SecondaryGameHalved":
	                    gameEvent = GameEvents.SecondaryGameHalved(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "AutoPlayStarted":
	                    gameEvent = GameEvents.AutoPlayStarted(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "AutoPlayEnded":
	                    gameEvent = GameEvents.AutoPlayEnded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "GamePlayDisabled":
	                    gameEvent = GameEvents.GamePlayDisabled(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "GamePlayEnabled":
	                    gameEvent = GameEvents.GamePlayEnabled(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "GameLoaded":
	                    gameEvent = GameEvents.GameLoaded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "BonusGameEnded":
	                    gameEvent = GameEvents.BonusGameEnded(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "BonusGameEscrow":
	                    gameEvent = GameEvents.BonusGameEscrow(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "BonusGameStarted":
	                    gameEvent = GameEvents.BonusGameStarted(messageId, unpaidWin, gameRoundId);
	                    break;
	                case "BonusGameTriggered":
	                    gameEvent = GameEvents.BonusGameTriggered(messageId, unpaidWin, gameRoundId);
	                    break;
	            }
	            if (gameEvent != null) {
	                AppContext_1.AppContext.clientHost.notifyEventFromGame(gameEvent);
	            }
	        }
	    };
	    DataManager.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("DataManager", s);
	        }
	    };
	    DataManager._gameData = {};
	    DataManager.DisplayCurrencies = null;
	    DataManager.serverTimeOffset = -1;
	    DataManager.time = "";
	    DataManager.utcTime = "";
	    DataManager.serverTimeResponseTimestamp = 0;
	    DataManager.TrustedUserActions = [];
	    DataManager.GameRoundClosed = false;
	    DataManager.Collectable = true;
	    DataManager.GameLimit = false;
	    DataManager.AutoplayCount = "∞";
	    DataManager.AutoplayLossLimit = "∞";
	    DataManager.AutoplayWinLimit = "∞";
	    DataManager._autoplay = false;
	    DataManager.AutoplayPaused = false;
	    DataManager.AutoplayEnabled = true;
	    DataManager.AutoplayAfterGamble = false;
	    DataManager.AutoplaySkipWinAnimationsEnabled = false;
	    DataManager.QuickspinEnabled = false;
	    DataManager._quickstopTimes = [];
	    DataManager.VibrationEnabled = false;
	    DataManager.HelpDataGameLimit = 0;
	    DataManager.HelpDataGambleLimit = 0;
	    DataManager.BackSoundsPlayingFromGame = true;
	    DataManager.AutoplayStarted = false;
	    DataManager._rulesWindowOpened = false;
	    return DataManager;
	}());
	exports.DataManager = DataManager;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var BetManager_1 = __webpack_require__(25);
	var AppContext_1 = __webpack_require__(5);
	var Languages_1 = __webpack_require__(28);
	var ModuleManager_1 = __webpack_require__(29);
	var CashierDialog_1 = __webpack_require__(50);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var BalanceManager = (function () {
	    function BalanceManager() {
	    }
	    BalanceManager.setBalance = function () {
	        if (GameManager_1.GameManager.gameResponse.balance != null) {
	            if (GameManager_1.GameManager.gameResponse.balance.real != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceReal, GameManager_1.GameManager.gameResponse.balance.real.toString());
	                if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceRealDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gameResponse.balance.real, BetManager_1.BetManager.CoinSize)).toString());
	                }
	            }
	            if (GameManager_1.GameManager.gameResponse.balance.bonus != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceBonus, GameManager_1.GameManager.gameResponse.balance.bonus.toString());
	            }
	            if (GameManager_1.GameManager.gameResponse.balance.real != null && GameManager_1.GameManager.gameResponse.balance.bonus != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.add(GameManager_1.GameManager.gameResponse.balance.real, GameManager_1.GameManager.gameResponse.balance.bonus));
	            }
	        }
	    };
	    BalanceManager.fixBalance = function () {
	        var bonus = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceBonus));
	        var real = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal));
	        var realDenom = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceRealDenom));
	        var win = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataTotalWin));
	        var winDenom;
	        var total = parseFloat(neo_common_1.NumberUtils.add(bonus, real));
	        var bet = BetManager_1.BetManager.Bet;
	        var betDenom = BetManager_1.BetManager.CoinCount;
	        var denom = BetManager_1.BetManager.CoinSize;
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            if (AppContext_1.AppContext.gameDefinition.Gamble && FreeRoundBonus_1.FreeRoundBonus.winPayMethod !== "cumulative") {
	                if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.balance != null) {
	                    var totalRealBalance = DataManager_1.DataManager.GameRoundClosed ? real : parseFloat(neo_common_1.NumberUtils.add(real, win));
	                    var totalBalance = DataManager_1.DataManager.GameRoundClosed ? total : parseFloat(neo_common_1.NumberUtils.add(total, win));
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceBonus, bonus.toString());
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceReal, totalRealBalance.toString());
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, totalBalance.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, bonus.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, real.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, totalBalance.toString());
	                }
	            }
	            else if (!AppContext_1.AppContext.gameDefinition.Gamble && !DataManager_1.DataManager.Collectable) {
	                if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.balance != null) {
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceBonus, bonus.toString());
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceReal, real.toString());
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, total.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, bonus.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, real.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, total.toString());
	                }
	            }
	            return;
	        }
	        if (denom != null && win != null) {
	            winDenom = parseFloat(neo_common_1.NumberUtils.devide(win, denom));
	        }
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            if (bonus != null && bonus > 0 && bonus >= bet) {
	                ModuleManager_1.ModuleManager.changeBetColor(true);
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, neo_common_1.NumberUtils.subtract(bonus, bet));
	            }
	            else {
	                ModuleManager_1.ModuleManager.changeBetColor();
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, neo_common_1.NumberUtils.subtract(real, bet));
	                if (denom != null && betDenom != null) {
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, neo_common_1.NumberUtils.subtract(realDenom, betDenom));
	                }
	            }
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.subtract(total, bet));
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.subtract(total, bet));
	        }
	        else {
	            if (win > 0) {
	                if (bonus != null && bonus > 0 && bonus >= bet) {
	                    ModuleManager_1.ModuleManager.changeBetColor(true);
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, neo_common_1.NumberUtils.subtract(bonus, bet));
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, neo_common_1.NumberUtils.add(real, win));
	                    if (denom != null && winDenom != null) {
	                        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, neo_common_1.NumberUtils.add(realDenom, winDenom));
	                    }
	                }
	                else {
	                    ModuleManager_1.ModuleManager.changeBetColor();
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, neo_common_1.NumberUtils.add(neo_common_1.NumberUtils.subtract(real, bet), win));
	                    if (denom != null && winDenom != null && betDenom != null) {
	                        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, neo_common_1.NumberUtils.add(neo_common_1.NumberUtils.subtract(realDenom, betDenom), winDenom));
	                    }
	                }
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.add(neo_common_1.NumberUtils.subtract(total, bet), win));
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.add(neo_common_1.NumberUtils.subtract(total, bet), win));
	            }
	            else {
	                if (bonus != null && bonus > 0 && bonus >= bet) {
	                    ModuleManager_1.ModuleManager.changeBetColor(true);
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, neo_common_1.NumberUtils.subtract(bonus, bet));
	                }
	                else {
	                    ModuleManager_1.ModuleManager.changeBetColor();
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, neo_common_1.NumberUtils.subtract(real, bet));
	                    if (denom != null && betDenom != null) {
	                        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, neo_common_1.NumberUtils.subtract(realDenom, betDenom));
	                    }
	                }
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.subtract(total, bet));
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, neo_common_1.NumberUtils.subtract(total, bet));
	            }
	        }
	    };
	    BalanceManager.hasCredit = function (maxBet, onSpin) {
	        if (maxBet === void 0) { maxBet = false; }
	        if (onSpin === void 0) { onSpin = false; }
	        var bonus = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceBonus));
	        var real = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal));
	        var win = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataTotalWin));
	        var bet = BetManager_1.BetManager.Bet;
	        var canPlay = true;
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            win = 0;
	        }
	        if (bonus != null && bonus > 0) {
	            if (bonus >= bet) {
	                ModuleManager_1.ModuleManager.changeBetColor(true);
	                return true;
	            }
	            else {
	                ModuleManager_1.ModuleManager.changeBetColor();
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            if (AppContext_1.AppContext.current) {
	                AppContext_1.AppContext.current.closeDialog();
	            }
	            if (CashierDialog_1.CashierDialog.opened) {
	                CashierDialog_1.CashierDialog.onClose();
	            }
	            if (onSpin) {
	                FreeRoundBonus_1.FreeRoundBonus.disableUi();
	            }
	            canPlay = true;
	        }
	        else if (real <= 0 || real < bet) {
	            var credit = parseFloat(neo_common_1.NumberUtils.add(real, win));
	            if (credit > 0 && credit >= bet) {
	                if (AppContext_1.AppContext.current) {
	                    AppContext_1.AppContext.current.closeDialog();
	                }
	                if (CashierDialog_1.CashierDialog.opened) {
	                    CashierDialog_1.CashierDialog.onClose();
	                }
	                if (onSpin) {
	                    FreeRoundBonus_1.FreeRoundBonus.disableUi();
	                }
	                canPlay = true;
	            }
	            else {
	                if (AppContext_1.AppContext.current && onSpin) {
	                    ModuleManager_1.ModuleManager.collect(GameModules.Base);
	                    if (AppContext_1.AppContext.gameConfiguration.ShowCashierMessage) {
	                        CashierDialog_1.CashierDialog.openDialog();
	                    }
	                    else {
	                        AppContext_1.AppContext.current.showDialog(Languages_1.Languages.getRid("NOT_ENOUGH_CREDIT"), false);
	                    }
	                    neo_games_1.Platforms.Platforms.clientError("NOT_ENOUGH_CREDIT", Languages_1.Languages.getRid("NOT_ENOUGH_CREDIT"));
	                    GameManager_1.GameManager.requestSend = false;
	                }
	                canPlay = false;
	            }
	        }
	        else {
	            if (AppContext_1.AppContext.current) {
	                AppContext_1.AppContext.current.closeDialog();
	            }
	            if (CashierDialog_1.CashierDialog.opened) {
	                CashierDialog_1.CashierDialog.onClose();
	            }
	            if (onSpin) {
	                FreeRoundBonus_1.FreeRoundBonus.disableUi();
	            }
	            canPlay = true;
	        }
	        return canPlay;
	    };
	    BalanceManager.poolingBalance = function () {
	        if (AppContext_1.AppContext != null &&
	            AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.PollCredit > 0 &&
	            DataManager_1.DataManager.GameRoundClosed) {
	            var balance = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal));
	            if (balance != null && BetManager_1.BetManager.Bet != null && balance >= BetManager_1.BetManager.Bet) {
	                return;
	            }
	            else {
	                if (!BalanceManager._poolBalance) {
	                    setTimeout(function () {
	                        BalanceManager.refreshBalance();
	                    }, AppContext_1.AppContext.gameConfiguration.PollCredit);
	                    BalanceManager._poolBalance = true;
	                }
	            }
	        }
	    };
	    BalanceManager.refreshBalance = function (forced) {
	        if (forced === void 0) { forced = false; }
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient.balance().then(function (response) {
	                BalanceManager.balanceReceived(response, forced);
	            });
	        }
	    };
	    BalanceManager.balanceReceived = function (response, forced) {
	        if (forced === void 0) { forced = false; }
	        BalanceManager._poolBalance = false;
	        var bonus = response.bonus.toString();
	        var real = response.real.toString();
	        var total = neo_common_1.NumberUtils.add(response.bonus, response.real);
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceBonus, bonus);
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceReal, real);
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceTotal, total);
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceRealDenom, parseInt(neo_common_1.NumberUtils.devide(response.real, BetManager_1.BetManager.CoinSize)).toString());
	        }
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus, bonus);
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal, real);
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal, total);
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, parseInt(neo_common_1.NumberUtils.devide(response.real, BetManager_1.BetManager.CoinSize)).toString());
	        }
	        BalanceManager.poolingBalance();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: parseFloat(total), forced: forced });
	    };
	    BalanceManager.recalculateDenomBalance = function () {
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBalanceRealDenom, parseInt(neo_common_1.NumberUtils.devide(parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal)), BetManager_1.BetManager.CoinSize)).toString());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceRealDenom, parseInt(neo_common_1.NumberUtils.devide(parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceReal)), BetManager_1.BetManager.CoinSize)).toString());
	        }
	    };
	    BalanceManager.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("BalanceManager", s);
	        }
	    };
	    BalanceManager._poolBalance = false;
	    return BalanceManager;
	}());
	exports.BalanceManager = BalanceManager;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Strings_1 = __webpack_require__(4);
	var AppContext_1 = __webpack_require__(5);
	var Languages = (function () {
	    function Languages() {
	    }
	    Languages.getRid = function (rid) {
	        var value = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            value[_i - 1] = arguments[_i];
	        }
	        if (value != null && value.length > 0) {
	            return Strings_1.Strings.getWithValues.apply(Strings_1.Strings, [rid].concat(value));
	        }
	        else {
	            return Strings_1.Strings.get(rid);
	        }
	    };
	    Languages.formatText = function (ridType, text) {
	        switch (ridType) {
	            case this.FormatMoney:
	                return neo_common_1.NumberUtils.valueToNumber(text, AppContext_1.AppContext.gameConfiguration.ShowDecimalPlaces);
	            default:
	                if (false) {
	                    this.log("WARNING unknow RidType: " + ridType);
	                }
	        }
	        return text;
	    };
	    Languages.filterText = function (ridFilter, text) {
	        switch (ridFilter) {
	            case this.FilterNoZero:
	                if (parseFloat(text) <= 0) {
	                    return "";
	                }
	                else {
	                    return text;
	                }
	            default:
	                if (false) {
	                    this.log("WARNING unknow RidFilter: " + ridFilter);
	                }
	        }
	        return text;
	    };
	    Languages.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Languages", s);
	        }
	    };
	    Languages.FormatMoney = "MONEY";
	    Languages.FilterNoZero = "NO_ZERO";
	    return Languages;
	}());
	exports.Languages = Languages;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var AppContext_1 = __webpack_require__(5);
	var DataManager_1 = __webpack_require__(26);
	var BuyFeature_1 = __webpack_require__(30);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var GameStatuses = neo_games_1.Communication.Game.GameModuleStatus;
	var ModuleManager = (function () {
	    function ModuleManager() {
	    }
	    ModuleManager.registerGameModule = function (key, module) {
	        if (false) {
	            ModuleManager.log("registerGameModule " + key);
	        }
	        if (ModuleManager._gameModules[key] == null) {
	            ModuleManager._gameModules[key] = module;
	        }
	        else {
	            if (false) {
	                ModuleManager.log("ERROR try to register game module with same key: " + key);
	            }
	        }
	    };
	    ModuleManager.registerChannelModule = function (key, module) {
	        if (false) {
	            ModuleManager.log("registerChannelModule " + key);
	        }
	        if (ModuleManager._channelModules[key] == null) {
	            ModuleManager._channelModules[key] = module;
	        }
	        else {
	            if (false) {
	                ModuleManager.log("ERROR try to register channel module with same key: " + key);
	            }
	        }
	    };
	    ModuleManager.connectModules = function () {
	        if (false) {
	            ModuleManager.log("connectModules");
	        }
	        var allChannelsHaveController = true;
	        for (var key in ModuleManager._channelModules) {
	            if (ModuleManager._gameModules[key] != null) {
	                ModuleManager._channelModules[key].addController(ModuleManager._gameModules[key]);
	                if (false) {
	                    ModuleManager.log("connect module key: " + key);
	                }
	            }
	            else {
	                if (false) {
	                    ModuleManager.log("cant connect module key: " + key);
	                }
	                allChannelsHaveController = false;
	            }
	        }
	        return allChannelsHaveController;
	    };
	    ModuleManager.initModules = function () {
	        if (false) {
	            ModuleManager.log("initModules");
	        }
	        for (var key in ModuleManager._channelModules) {
	            ModuleManager._channelModules[key].initReceived();
	        }
	        if (ModuleManager.gambleActive() && ModuleManager._channelModules[GameModules.Gamble] != null) {
	            ModuleManager._channelModules[GameModules.Gamble].initIntro();
	        }
	        else if (ModuleManager.bonusActive() && ModuleManager._channelModules[GameModules.BonusRespins] != null) {
	            ModuleManager._channelModules[GameModules.BonusRespins].initIntro();
	        }
	        else {
	            if (ModuleManager._channelModules[GameModules.Base] != null) {
	                ModuleManager._channelModules[GameModules.Base].initIntro();
	            }
	        }
	    };
	    ModuleManager.gambleEnabled = function () {
	        if (!AppContext_1.AppContext.gameDefinition.Gamble) {
	            return false;
	        }
	        if (DataManager_1.DataManager.Autoplay && !AppContext_1.AppContext.gameConfiguration.AutoplayGambleEnabled) {
	            return false;
	        }
	        if (BuyFeature_1.BuyFeature.isOpen()) {
	            return false;
	        }
	        if (GameManager_1.GameManager.gambleResponse != null && GameManager_1.GameManager.gambleResponse.status === GameStatuses.Enabled) {
	            return true;
	        }
	        return false;
	    };
	    ModuleManager.gambleActive = function () {
	        if (!AppContext_1.AppContext.gameDefinition.Gamble) {
	            return false;
	        }
	        if (GameManager_1.GameManager.gambleResponse != null && GameManager_1.GameManager.gambleResponse.status === GameStatuses.Active) {
	            return true;
	        }
	        return false;
	    };
	    ModuleManager.bonusEnabled = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.status === GameStatuses.Enabled) {
	            DataManager_1.DataManager.AutoplayCount = "∞";
	            DataManager_1.DataManager.AutoplayLossLimit = "∞";
	            DataManager_1.DataManager.AutoplayWinLimit = "∞";
	            return true;
	        }
	        return false;
	    };
	    ModuleManager.bonusActive = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null &&
	            GameManager_1.GameManager.bonusRespinsResponse.status === GameStatuses.Active) {
	            DataManager_1.DataManager.AutoplayCount = "∞";
	            DataManager_1.DataManager.AutoplayLossLimit = "∞";
	            DataManager_1.DataManager.AutoplayWinLimit = "∞";
	            return true;
	        }
	        return false;
	    };
	    ModuleManager.enableGamble = function () {
	        if (false) {
	            ModuleManager.log("enableGamble");
	        }
	        if (ModuleManager.gambleEnabled() && ModuleManager._channelModules[GameModules.Gamble] != null) {
	            ModuleManager._channelModules[GameModules.Gamble].enable();
	        }
	    };
	    ModuleManager.startGamble = function () {
	        if (false) {
	            ModuleManager.log("startGamble");
	        }
	        if (ModuleManager.gambleActive()) {
	            ModuleManager.outroModule(GameModules.Base);
	        }
	    };
	    ModuleManager.enableBonus = function () {
	        if (false) {
	            ModuleManager.log("enableBonus");
	        }
	        if (ModuleManager._channelModules[GameModules.BonusRespins] != null) {
	            ModuleManager._channelModules[GameModules.BonusRespins].enable();
	        }
	    };
	    ModuleManager.startBonus = function () {
	        if (false) {
	            ModuleManager.log("startBonus");
	        }
	        if (ModuleManager._channelModules[GameModules.BonusRespins] != null) {
	            ModuleManager._channelModules[GameModules.BonusRespins].start();
	        }
	    };
	    ModuleManager.endBonus = function () {
	        if (false) {
	            ModuleManager.log("endBonus");
	        }
	        if (ModuleManager._channelModules[GameModules.BonusRespins] != null) {
	            ModuleManager._channelModules[GameModules.BonusRespins].end();
	        }
	    };
	    ModuleManager.disableGamble = function () {
	        if (false) {
	            ModuleManager.log("disableGamble");
	        }
	        if (ModuleManager._channelModules[GameModules.Gamble] != null) {
	            ModuleManager._channelModules[GameModules.Gamble].disable();
	        }
	    };
	    ModuleManager.disableBase = function () {
	        if (false) {
	            ModuleManager.log("disableBase");
	        }
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].disable();
	        }
	    };
	    ModuleManager.disableChannelModule = function (key) {
	        if (false) {
	            ModuleManager.log("disable" + key);
	        }
	        if (ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].disable();
	        }
	    };
	    ModuleManager.changeBetColor = function (green) {
	        if (green === void 0) { green = false; }
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].changeBetColor(green);
	        }
	    };
	    ModuleManager.initNewBet = function (animate) {
	        if (animate === void 0) { animate = true; }
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].initNewBet(animate);
	        }
	    };
	    ModuleManager.introModule = function (key, long, previousModule) {
	        if (long === void 0) { long = false; }
	        if (false) {
	            ModuleManager.log("introModule key: " + key);
	        }
	        if (ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].intro(long, previousModule);
	        }
	    };
	    ModuleManager.outroModule = function (key) {
	        if (false) {
	            ModuleManager.log("outroModule key: " + key);
	        }
	        if (ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].outro();
	        }
	    };
	    ModuleManager.collect = function (key) {
	        if (key != null && ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].collect();
	        }
	    };
	    ModuleManager.collectInModule = function (key) {
	        if (key != null && ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].collectReceived();
	        }
	    };
	    ModuleManager.disableActions = function () {
	        Object.keys(ModuleManager._channelModules).forEach(function (module) {
	            ModuleManager._channelModules[module].disableActions();
	        });
	    };
	    ModuleManager.restoreActions = function () {
	        Object.keys(ModuleManager._channelModules).forEach(function (module) {
	            ModuleManager._channelModules[module].restoreActions();
	        });
	    };
	    ModuleManager.restoreGameRound = function (key, collect) {
	        if (collect === void 0) { collect = false; }
	        if (key != null && ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].restoreGameRound(collect);
	        }
	        if (AppContext_1.AppContext.gameConfiguration && !AppContext_1.AppContext.gameConfiguration.AllowPlayFromRules) {
	            if (DataManager_1.DataManager.RulesWindowOpened) {
	                ModuleManager.disableActions();
	            }
	        }
	    };
	    ModuleManager.resetScreen = function () {
	        if (false) {
	            ModuleManager.log("resetScreen");
	        }
	        DataManager_1.DataManager.Autoplay = false;
	        ModuleManager._gameModules[GameModules.Base].resetScreen();
	    };
	    ModuleManager.dispatchAction = function (action) {
	        if (false) {
	            ModuleManager.log("dispatchAction action: " + action);
	        }
	        for (var key in ModuleManager._channelModules) {
	            ModuleManager._channelModules[key].dispatchAction(action);
	        }
	    };
	    ModuleManager.cycleHelp = function () {
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].cycleHelp();
	        }
	    };
	    ModuleManager.setAutoplayAfterFeature = function (tf) {
	        if (false) {
	            ModuleManager.log("setAutoplayAfterFeature to " + tf);
	        }
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].setAutoplayAfterFeature(tf);
	        }
	    };
	    ModuleManager.primaryGameEnded = function () {
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            return ModuleManager._channelModules[GameModules.Base].primaryGameEnded();
	        }
	    };
	    ModuleManager.toggleModuleSounds = function (key, enable) {
	        if (ModuleManager._gameModules[key] != null) {
	            ModuleManager._gameModules[key].toggleSounds(enable);
	        }
	    };
	    ModuleManager.resetSceneAsOnCollect = function (key) {
	        if (ModuleManager._gameModules[key] != null) {
	            ModuleManager._gameModules[key].collect();
	        }
	    };
	    ModuleManager.resetWinAnimator = function (key) {
	        if (false) {
	            ModuleManager.log("resetWinAnimator:" + key);
	        }
	        if (ModuleManager._channelModules[key] != null) {
	            ModuleManager._channelModules[key].resetWinAnimator();
	        }
	    };
	    ModuleManager.getActiveGameModules = function () {
	        var activeModulesArray = [];
	        if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.modules != null) {
	            for (var key in GameManager_1.GameManager.gameResponse.modules) {
	                if (GameManager_1.GameManager.gameResponse.modules[key].status !== GameStatuses.Disabled) {
	                    activeModulesArray.push(key);
	                }
	            }
	        }
	        return activeModulesArray;
	    };
	    ModuleManager.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("ModuleManager", s);
	        }
	    };
	    ModuleManager.enableBuyFeature = function () {
	        if (ModuleManager._channelModules[GameModules.Base] != null) {
	            ModuleManager._channelModules[GameModules.Base].enableBuyFeature();
	        }
	    };
	    ModuleManager._gameModules = {};
	    ModuleManager._channelModules = {};
	    return ModuleManager;
	}());
	exports.ModuleManager = ModuleManager;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var BaseActions_1 = __webpack_require__(35);
	var GameData_1 = __webpack_require__(24);
	var BetManager_1 = __webpack_require__(25);
	var ModuleManager_1 = __webpack_require__(29);
	var Languages_1 = __webpack_require__(28);
	var DataManager_1 = __webpack_require__(26);
	var GameManager_1 = __webpack_require__(23);
	var PlayList_1 = __webpack_require__(33);
	var FreeRoundBonusIcon_1 = __webpack_require__(48);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var BuyFeature = (function () {
	    function BuyFeature() {
	    }
	    BuyFeature.initialize = function () {
	        BuyFeature.config();
	        if (AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.BuyFeatureEnabled &&
	            !BuyFeature.isMaxBuyFeatureLimit(0)) {
	            BuyFeature.BuyFeatureConfirmEnabled = AppContext_1.AppContext.gameConfiguration.BuyFeatureConfirmEnabled;
	            BuyFeature.root = document.getElementById("buyFeature");
	            BuyFeature.overlay = document.getElementById("buyFeatureOverlay");
	            BuyFeature.dialog = document.getElementById("buyFeatureDialog");
	            BuyFeature.confirmDialog = document.getElementById("buyFeatureConfirmDialog");
	            BuyFeature.buyBtn = document.getElementById("buyFeatureBuyButton");
	            BuyFeature.betMinusBtn = document.getElementById("buyFeatureBetMinus");
	            BuyFeature.betPlusBtn = document.getElementById("buyFeatureBetPlus");
	            BuyFeature.declineBtn = document.getElementById("buyFeatureDeclineButton");
	            BuyFeature.closeBtn = document.getElementById("buyFeatureCloseButton");
	            BuyFeature.confirmCloseBtn = document.getElementById("buyFeatureConfirmCloseButton");
	            BuyFeature.icon = document.getElementById("buyFeatureIcon");
	            BuyFeature.bindActions();
	            BuyFeature.initialized = true;
	        }
	        else {
	            BuyFeature.clean();
	        }
	    };
	    BuyFeature.config = function () {
	        if (GameManager_1.GameManager.baseResponse.initData != null && GameManager_1.GameManager.baseResponse.initData["customData"] != null) {
	            if (GameManager_1.GameManager.baseResponse.initData["customData"]["buyFeatureConversion"]) {
	                BuyFeature.BetMultiplier = GameManager_1.GameManager.baseResponse.initData["customData"]["buyFeatureConversion"];
	            }
	            if (GameManager_1.GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"]) {
	                BuyFeature.MaxBuyFeatureBetLimit =
	                    GameManager_1.GameManager.baseResponse.initData["customData"]["maxBuyFeatureBetLimit"];
	            }
	        }
	    };
	    BuyFeature.bindActions = function () {
	        if (BuyFeature.closeBtn != null) {
	            BuyFeature.closeBtn.onclick = BuyFeature.onCloseDialog.bind(this);
	        }
	        if (BuyFeature.declineBtn != null) {
	            BuyFeature.declineBtn.onclick = BuyFeature.onCloseConfirmDialog.bind(this);
	        }
	        if (BuyFeature.confirmCloseBtn != null) {
	            BuyFeature.confirmCloseBtn.onclick = BuyFeature.onCloseConfirmDialog.bind(this);
	        }
	        if (BuyFeature.buyBtn != null) {
	            BuyFeature.buyBtn.onclick = BuyFeature.onOpenConfirmDialog.bind(this);
	        }
	        if (BuyFeature.betMinusBtn != null) {
	            BuyFeature.betMinusBtn.onclick = BuyFeature.onBetChange.bind(this, true);
	        }
	        if (BuyFeature.betPlusBtn != null) {
	            BuyFeature.betPlusBtn.onclick = BuyFeature.onBetChange.bind(this, false);
	        }
	        if (BuyFeature.root != null) {
	            BuyFeature.root.addEventListener("webkitAnimationEnd", BuyFeature.removeIntroClass);
	            BuyFeature.root.addEventListener("animationend", BuyFeature.removeIntroClass);
	        }
	        neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.PlatformCloseMenu, function () {
	            BuyFeature.onCloseDialog(true);
	        });
	    };
	    BuyFeature.clean = function () {
	        var buyFeature = document.getElementById("buyFeature");
	        if (buyFeature != null && buyFeature.parentElement != null) {
	            buyFeature.parentElement.removeChild(buyFeature);
	        }
	        var elements = document.getElementsByClassName("helpBuyFeature");
	        if (elements != null && elements.length > 0) {
	            while (elements.length > 0) {
	                elements[0].parentNode.removeChild(elements[0]);
	            }
	        }
	    };
	    BuyFeature.closeConfirmDialog = function () {
	        if (BuyFeature.confirmDialog != null) {
	            BuyFeature.confirmDialog.classList.add("_hidden");
	        }
	        if (BuyFeature.dialog != null) {
	            BuyFeature.dialog.classList.remove("_hidden");
	        }
	    };
	    BuyFeature.openConfirmDialog = function () {
	        if (!BuyFeature.BuyFeatureConfirmEnabled) {
	            HtmlController_1.HtmlController.dispatchAction(BaseActions_1.BaseActions.ActionBuyFeature);
	            return;
	        }
	        if (BuyFeature.confirmDialog != null) {
	            BuyFeature.confirmDialog.classList.remove("_hidden");
	        }
	        if (BuyFeature.dialog != null) {
	            BuyFeature.dialog.classList.add("_hidden");
	        }
	    };
	    BuyFeature.closeDialog = function () {
	        if (BuyFeature.overlay != null) {
	            BuyFeature.overlay.classList.add("_hidden");
	        }
	        if (BuyFeature.dialog != null) {
	            BuyFeature.dialog.classList.add("_hidden");
	        }
	        neo_games_1.Platforms.Platforms.dialogOpened("buyFeature", false);
	        BuyFeature.opened = false;
	        ModuleManager_1.ModuleManager.enableGamble();
	    };
	    BuyFeature.openDialog = function () {
	        BuyFeature.updateBet();
	        BuyFeature.updateData();
	        if (BuyFeature.overlay != null) {
	            BuyFeature.overlay.classList.remove("_hidden");
	        }
	        if (BuyFeature.dialog != null) {
	            BuyFeature.dialog.classList.remove("_hidden");
	        }
	        neo_games_1.Platforms.Platforms.dialogOpened("buyFeature", true);
	        BuyFeature.opened = true;
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.disableActiveIcon();
	        ModuleManager_1.ModuleManager.disableGamble();
	    };
	    BuyFeature.updateBet = function () {
	        BuyFeature.currentBetIndex = BetManager_1.BetManager.TotalBets.indexOf(BetManager_1.BetManager.Bet);
	        while (BuyFeature.isMaxBuyFeatureLimit(BuyFeature.currentBetIndex) && BuyFeature.currentBetIndex > -1) {
	            BuyFeature.currentBetIndex--;
	        }
	    };
	    BuyFeature.updateData = function () {
	        var bet = BetManager_1.BetManager.TotalBets[this.currentBetIndex].toString();
	        HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataBuyFeatureCost, neo_common_1.NumberUtils.multiply(bet, BuyFeature.BetMultiplier));
	        HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataBuyFeatureCostWithCurrency, Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, neo_common_1.NumberUtils.multiply(bet, BuyFeature.BetMultiplier)) +
	            "\u00A0" +
	            DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency));
	        HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataBuyFeatureBet, bet);
	        BuyFeature.checkBetButtons();
	    };
	    BuyFeature.checkBetButtons = function () {
	        BuyFeature.betMinusBtn.classList.remove("_disabled");
	        BuyFeature.betPlusBtn.classList.remove("_disabled");
	        if (BuyFeature.currentBetIndex == 0) {
	            BuyFeature.betMinusBtn.classList.add("_disabled");
	        }
	        if (BuyFeature.currentBetIndex == BetManager_1.BetManager.TotalBets.length - 1 ||
	            BuyFeature.isMaxBuyFeatureLimit(this.currentBetIndex + 1)) {
	            BuyFeature.betPlusBtn.classList.add("_disabled");
	        }
	    };
	    BuyFeature.isMaxBuyFeatureLimit = function (betIndex) {
	        if (BuyFeature.MaxBuyFeatureBetLimit > -1 && betIndex < BetManager_1.BetManager.TotalBets.length) {
	            var nextBet = BetManager_1.BetManager.TotalBets[betIndex];
	            var totalBet = parseFloat(neo_common_1.NumberUtils.multiply(nextBet, BuyFeature.BetMultiplier));
	            if (totalBet > BuyFeature.MaxBuyFeatureBetLimit) {
	                return true;
	            }
	        }
	        return false;
	    };
	    BuyFeature.hasFeatureModuleActive = function () {
	        var featureModules = ["freespinsActive", "bonusActive", "pickActive"];
	        for (var i = 0; i < featureModules.length; i++) {
	            if (ModuleManager_1.ModuleManager[featureModules[i]] && ModuleManager_1.ModuleManager[featureModules[i]]()) {
	                return true;
	            }
	        }
	        return false;
	    };
	    BuyFeature.removeIntroClass = function () {
	        if (BuyFeature.root != null) {
	            BuyFeature.root.classList.remove("buyFeatureIntro");
	        }
	    };
	    BuyFeature.addIntroClass = function () {
	        if (BuyFeature.root != null) {
	            BuyFeature.root.classList.add("buyFeatureIntro");
	        }
	    };
	    BuyFeature.onCloseDialog = function (silent) {
	        if (silent === void 0) { silent = false; }
	        if (!BuyFeature.opened) {
	            return;
	        }
	        if (!silent) {
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        BuyFeature.closeConfirmDialog();
	        BuyFeature.closeDialog();
	        ModuleManager_1.ModuleManager.restoreGameRound(neo_games_1.Communication.Game.GameModules.Base);
	    };
	    BuyFeature.onCloseConfirmDialog = function () {
	        PlayList_1.PlayList.play("SND_Click");
	        BuyFeature.closeConfirmDialog();
	    };
	    BuyFeature.onOpenDialog = function () {
	        PlayList_1.PlayList.play("SND_Click");
	        BuyFeature.openDialog();
	    };
	    BuyFeature.onToggleDialog = function () {
	        if (BuyFeature.opened) {
	            BuyFeature.onCloseDialog();
	        }
	        else {
	            BuyFeature.onOpenDialog();
	        }
	    };
	    BuyFeature.onOpenConfirmDialog = function () {
	        PlayList_1.PlayList.play("SND_Click");
	        BuyFeature.openConfirmDialog();
	    };
	    BuyFeature.onBetChange = function (decrease) {
	        PlayList_1.PlayList.play("SND_Click");
	        if (decrease && BuyFeature.currentBetIndex > 0) {
	            BuyFeature.currentBetIndex--;
	        }
	        else if (!decrease && BuyFeature.currentBetIndex < BetManager_1.BetManager.TotalBets.length - 1) {
	            BuyFeature.currentBetIndex++;
	        }
	        BuyFeature.updateData();
	    };
	    BuyFeature.spin = function () {
	        BuyFeature.closeConfirmDialog();
	        BuyFeature.closeDialog();
	    };
	    BuyFeature.open = function () {
	        BuyFeature.onToggleDialog();
	    };
	    BuyFeature.getBuyfeatureOriginalBet = function () {
	        return BetManager_1.BetManager.TotalBets[BuyFeature.currentBetIndex];
	    };
	    BuyFeature.getBuyFeatureBet = function () {
	        var buyFeatureBet;
	        if (FreeRoundBonus_1.FreeRoundBonus.status !== "active") {
	            buyFeatureBet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager_1.BetManager.TotalBets[BuyFeature.currentBetIndex], BuyFeature.BetMultiplier));
	        }
	        else {
	            buyFeatureBet = parseFloat(neo_common_1.NumberUtils.multiply(BetManager_1.BetManager.Bet, BuyFeature.BetMultiplier));
	        }
	        return new neo_games_1.Communication.Game.SpinBet(neo_games_1.Communication.Game.BetType.Total, null, null, null, buyFeatureBet);
	    };
	    BuyFeature.getBuyFeatureName = function () {
	        if (FreeRoundBonus_1.FreeRoundBonus.dialogType !== null && FreeRoundBonus_1.FreeRoundBonus.dialogType == FreeRoundBonusDialog_1.DialogType.FFR && FreeRoundBonus_1.FreeRoundBonus.featureName !== null) {
	            return FreeRoundBonus_1.FreeRoundBonus.featureName;
	        }
	        return "HoldAndWin";
	    };
	    BuyFeature.hideBuyFeatureIcon = function () {
	        if (BuyFeature.icon != null) {
	            BuyFeature.icon.classList.add("_hidden");
	        }
	        if (BuyFeature.opened) {
	            BuyFeature.closeConfirmDialog();
	            BuyFeature.closeDialog();
	        }
	    };
	    BuyFeature.showBuyFeatureIcon = function (init) {
	        if (init === void 0) { init = false; }
	        if (this.hasFeatureModuleActive()) {
	            return;
	        }
	        if (BuyFeature.icon != null) {
	            BuyFeature.icon.classList.remove("_hidden");
	        }
	        if (!DataManager_1.DataManager.Autoplay) {
	            ModuleManager_1.ModuleManager.enableBuyFeature();
	        }
	        if (init && BuyFeature.icon != null && !BuyFeature.icon.classList.contains("_disabled")) {
	            BuyFeature.addIntroClass();
	        }
	    };
	    BuyFeature.buyFeatureBtnEnabled = function (wasCalculated) {
	        return (AppContext_1.AppContext.gameConfiguration.BuyFeatureEnabled &&
	            !this.hasFeatureModuleActive() &&
	            (DataManager_1.DataManager.GameRoundClosed ||
	                (!DataManager_1.DataManager.GameRoundClosed && !AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) ||
	                (!DataManager_1.DataManager.GameRoundClosed &&
	                    AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin &&
	                    wasCalculated)));
	    };
	    BuyFeature.disable = function () {
	        if (BuyFeature.root != null) {
	            BuyFeature.root.classList.add("_disabled");
	        }
	        BuyFeature.hideBuyFeatureIcon();
	    };
	    BuyFeature.restore = function () {
	        if (BuyFeature.root != null) {
	            BuyFeature.root.classList.remove("_disabled");
	        }
	        BuyFeature.showBuyFeatureIcon();
	    };
	    BuyFeature.isOpen = function () {
	        return BuyFeature.opened;
	    };
	    BuyFeature.BuyFeatureConfirmEnabled = true;
	    BuyFeature.MaxBuyFeatureBetLimit = -1;
	    BuyFeature.BetMultiplier = 100;
	    BuyFeature.initialized = false;
	    BuyFeature.currentBetIndex = -1;
	    BuyFeature.opened = false;
	    return BuyFeature;
	}());
	exports.BuyFeature = BuyFeature;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var UserAction_1 = __webpack_require__(32);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var BetManager_1 = __webpack_require__(25);
	var PlayList_1 = __webpack_require__(33);
	var GameApp_1 = __webpack_require__(1);
	var BaseActions_1 = __webpack_require__(35);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var Jackpot_1 = __webpack_require__(36);
	var QuickspinDialog_1 = __webpack_require__(53);
	var Paytable_1 = __webpack_require__(56);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var HtmlController = (function () {
	    function HtmlController() {
	    }
	    HtmlController.registerActionElement = function (action, element) {
	        if (false) {
	            this.log("registerActionElement action: " + action);
	        }
	        if (this.ActionElements[action] == null) {
	            this.ActionElements[action] = [];
	        }
	        this.ActionElements[action].push(element);
	    };
	    HtmlController.registerUiActionElement = function (action, element) {
	        if (false) {
	            this.log("registerUiActionElement action: " + action);
	        }
	        if (this.UiActionElements[action] == null) {
	            this.UiActionElements[action] = [];
	        }
	        this.UiActionElements[action].push(element);
	    };
	    HtmlController.registerUiDispatchElement = function (action, element) {
	        if (false) {
	            this.log("registerUiDispatchElement action: " + action);
	        }
	        if (this.UiDispatchElements[action] == null) {
	            this.UiDispatchElements[action] = [];
	        }
	        this.UiDispatchElements[action].push(element);
	    };
	    HtmlController.registerActionsHoldersElement = function (action, element) {
	        if (false) {
	            this.log("registerActionsHoldersElement action: " + action);
	        }
	        if (this.ActionsHoldersElements[action] == null) {
	            this.ActionsHoldersElements[action] = [];
	        }
	        this.ActionsHoldersElements[action].push(element);
	    };
	    HtmlController.registerUiActionDispatchElement = function (action, element) {
	        if (false) {
	            this.log("registerUiDispatchElement action: " + action);
	        }
	        if (this.UiActionDispatchElements[action] == null) {
	            this.UiActionDispatchElements[action] = [];
	        }
	        this.UiActionDispatchElements[action].push(element);
	    };
	    HtmlController.registerDataElement = function (data, element) {
	        if (false) {
	            this.log("registerDataElement data: " + data);
	        }
	        if (this.DataElements[data] == null) {
	            this.DataElements[data] = [];
	        }
	        this.DataElements[data].push(element);
	    };
	    HtmlController.dispatchAction = function (action) {
	        if (false) {
	            this.log("dispatchAction action: " + action);
	        }
	        if (!HtmlController.dispatchActionAllowed) {
	            return;
	        }
	        var updateUI = true;
	        if (action === BaseActions_1.BaseActions.ActionDenomSelect) {
	            updateUI = false;
	            if (BetManager_1.BetManager.CoinCountContainer != null) {
	                BetManager_1.BetManager.CoinCountContainer.disable();
	            }
	            if (BetManager_1.BetManager.BetContainer != null) {
	                BetManager_1.BetManager.BetContainer.disable();
	            }
	            if (HtmlController.SoundContainer != null) {
	                HtmlController.SoundContainer.disable();
	            }
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        if (action === BaseActions_1.BaseActions.ActionCoinCountSelect) {
	            updateUI = false;
	            if (BetManager_1.BetManager.DenomContainer != null) {
	                BetManager_1.BetManager.DenomContainer.disable();
	            }
	            if (BetManager_1.BetManager.BetContainer != null) {
	                BetManager_1.BetManager.BetContainer.disable();
	            }
	            if (HtmlController.SoundContainer != null) {
	                HtmlController.SoundContainer.disable();
	            }
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        if (action === BaseActions_1.BaseActions.ActionBetSelect) {
	            updateUI = false;
	            if (BetManager_1.BetManager.DenomContainer != null) {
	                BetManager_1.BetManager.DenomContainer.disable();
	            }
	            if (BetManager_1.BetManager.BetContainer != null) {
	                BetManager_1.BetManager.BetContainer.disable();
	            }
	            if (HtmlController.SoundContainer != null) {
	                HtmlController.SoundContainer.disable();
	            }
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	            switch (action) {
	                case BaseActions_1.BaseActions.ActionBetPlus:
	                    updateUI = false;
	                    break;
	                case BaseActions_1.BaseActions.ActionBetMinus:
	                    updateUI = false;
	                    break;
	            }
	        }
	        if (updateUI) {
	            this.dispatchUiAction("", action);
	        }
	        ModuleManager_1.ModuleManager.dispatchAction(action);
	    };
	    HtmlController.setSound = function (level) {
	        if (HtmlController.SoundContainer != null) {
	            HtmlController.SoundContainer.setLevel(level);
	            return;
	        }
	        for (var i = 0; i < HtmlController.UiActionElements[UserAction_1.UserAction.ActionToggleSound].length; i++) {
	            var ele = HtmlController.UiActionElements[UserAction_1.UserAction.ActionToggleSound][i];
	            if (ele.instance != null) {
	                ele.instance.classList.remove("off");
	                ele.instance.classList.remove("on1");
	                ele.instance.classList.remove("on2");
	                ele.instance.classList.remove("on3");
	                switch (level) {
	                    case 0:
	                        ele.instance.classList.add("off");
	                        PIXI.sound.volumeAll = 0;
	                        neo_games_1.Platforms.Platforms.setVolume(0);
	                        break;
	                    case 1:
	                        ele.instance.classList.add("on1");
	                        PIXI.sound.volumeAll = 0.25;
	                        neo_games_1.Platforms.Platforms.setVolume(1);
	                        break;
	                    case 2:
	                        ele.instance.classList.add("on2");
	                        PIXI.sound.volumeAll = 0.5;
	                        neo_games_1.Platforms.Platforms.setVolume(2);
	                        break;
	                    case 3:
	                    default:
	                        ele.instance.classList.add("on3");
	                        PIXI.sound.volumeAll = 1;
	                        neo_games_1.Platforms.Platforms.setVolume(3);
	                        break;
	                }
	            }
	        }
	    };
	    HtmlController.dispatchUiAction = function (action, originalAction) {
	        if (originalAction === void 0) { originalAction = ""; }
	        if (false) {
	            this.log("dispatchUiAction action: " + action);
	        }
	        if (!HtmlController.dispatchActionAllowed) {
	            return;
	        }
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.closeDialog();
	        Jackpot_1.Jackpot.closeAllHistoryDialogs();
	        neo_games_1.Platforms.Platforms.gameCloseMenu();
	        if (action === "EMPTY") {
	            PlayList_1.PlayList.play("SND_Click");
	            action = "";
	        }
	        var playSound = true;
	        if (HtmlController.ContainerElementsById["autoplaySelector"]) {
	            var autoplaySelector = HtmlController.ContainerElementsById["autoplaySelector"];
	            if (autoplaySelector != null &&
	                autoplaySelector.instance != null &&
	                !autoplaySelector.instance.classList.contains("_disabled")) {
	                if (autoplaySelector.recalculateHeight) {
	                    autoplaySelector.instance.removeAttribute("style");
	                }
	                autoplaySelector.instance.classList.add("_disabled");
	            }
	        }
	        if (HtmlController.ContainerElementsById["autoplayDialog"]) {
	            var autoplayDialog = HtmlController.ContainerElementsById["autoplayDialog"];
	            if (autoplayDialog != null &&
	                autoplayDialog.instance != null &&
	                !autoplayDialog.instance.classList.contains("_disabled")) {
	                autoplayDialog.instance.classList.add("_disabled");
	            }
	        }
	        if (BetManager_1.BetManager.DenomContainer != null) {
	            BetManager_1.BetManager.DenomContainer.disable();
	        }
	        if (BetManager_1.BetManager.CoinCountContainer != null) {
	            BetManager_1.BetManager.CoinCountContainer.disable();
	        }
	        if (action !== UserAction_1.UserAction.ActionExit && DataManager_1.DataManager.SimilarGames != null) {
	            DataManager_1.DataManager.SimilarGames.disable();
	        }
	        switch (action) {
	            case "":
	                DataManager_1.DataManager.RulesWindowOpened = false;
	                Paytable_1.Paytable.close(originalAction);
	                this.disableAllUiDispatchers(action);
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                playSound = false;
	                break;
	            case UserAction_1.UserAction.ActionHelpTerminal:
	                ModuleManager_1.ModuleManager.cycleHelp();
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionGameRoundReport:
	                HtmlController.dispatchUiAction("");
	                GameApp_1.GameApp.openGameRoundHistory(true);
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionExit:
	                this.disableAllUiDispatchers(action);
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                if (DataManager_1.DataManager.SimilarGames != null && DataManager_1.DataManager.SimilarGames.enabled) {
	                    if (DataManager_1.DataManager.SimilarGames.open()) {
	                        Paytable_1.Paytable.close();
	                    }
	                    else {
	                        this.dispatchUiAction("");
	                    }
	                    if (HtmlController.SoundContainer != null) {
	                        HtmlController.SoundContainer.disable();
	                    }
	                }
	                else {
	                    neo_games_1.Platforms.Platforms.exitHandler = "exitBtn";
	                    GameApp_1.GameApp.exit();
	                }
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionExit + "2":
	                neo_games_1.Platforms.Platforms.exitHandler = "similarGamesExitBtn";
	                GameApp_1.GameApp.exit();
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionToggleSound:
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.toggle();
	                }
	                else {
	                    if (HtmlController.UiActionElements[UserAction_1.UserAction.ActionToggleSound] != null) {
	                        for (var i = 0; i < HtmlController.UiActionElements[UserAction_1.UserAction.ActionToggleSound].length; i++) {
	                            var ele = HtmlController.UiActionElements[UserAction_1.UserAction.ActionToggleSound][i];
	                            if (ele.instance != null) {
	                                if (ele.instance.classList.contains("off")) {
	                                    ele.instance.classList.remove("off");
	                                    ele.instance.classList.add("on3");
	                                    PIXI.sound.volumeAll = 1;
	                                    AppContext_1.AppContext.current.setVolume(3);
	                                    neo_games_1.Platforms.Platforms.setVolume(3);
	                                }
	                                else if (ele.instance.classList.contains("on1")) {
	                                    ele.instance.classList.remove("on1");
	                                    ele.instance.classList.add("off");
	                                    playSound = false;
	                                    PIXI.sound.volumeAll = 0;
	                                    AppContext_1.AppContext.current.setVolume(0);
	                                    neo_games_1.Platforms.Platforms.setVolume(0);
	                                }
	                                else if (ele.instance.classList.contains("on2")) {
	                                    ele.instance.classList.remove("on2");
	                                    ele.instance.classList.add("on1");
	                                    PIXI.sound.volumeAll = 0.25;
	                                    AppContext_1.AppContext.current.setVolume(1);
	                                    neo_games_1.Platforms.Platforms.setVolume(1);
	                                }
	                                else if (ele.instance.classList.contains("on3")) {
	                                    ele.instance.classList.remove("on3");
	                                    ele.instance.classList.add("on2");
	                                    PIXI.sound.volumeAll = 0.5;
	                                    AppContext_1.AppContext.current.setVolume(2);
	                                    neo_games_1.Platforms.Platforms.setVolume(2);
	                                }
	                            }
	                        }
	                    }
	                }
	                break;
	            case UserAction_1.UserAction.ActionToggleBet:
	                DataManager_1.DataManager.RulesWindowOpened = false;
	                Paytable_1.Paytable.close();
	                this.disableAllUiDispatchers(action);
	                this.toggleUiAction(action, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                break;
	            case UserAction_1.UserAction.ActionTogglePaytable:
	                this.toggleUiAction(action, "toggle");
	                this.toggleUiAction(UserAction_1.UserAction.ActionHelpOn, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                Paytable_1.Paytable.instance.updateDataValues();
	                break;
	            case UserAction_1.UserAction.ActionToggleMenu:
	                DataManager_1.DataManager.RulesWindowOpened = false;
	                this.toggleUiAction(action, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "remove");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionToggleMenuBack:
	                this.toggleUiAction(UserAction_1.UserAction.ActionToggleMenu, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionHelpOn:
	                DataManager_1.DataManager.RulesWindowOpened = true;
	                this.disableAllUiDispatchers(action);
	                this.toggleUiAction(action, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                neo_games_1.Platforms.Platforms.gotoHelp();
	                break;
	            case UserAction_1.UserAction.ActionHelpOff:
	                DataManager_1.DataManager.RulesWindowOpened = false;
	                this.disableAllUiDispatchers(action);
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionPaytableOn:
	                DataManager_1.DataManager.RulesWindowOpened = true;
	                this.disableAllUiDispatchers(action);
	                this.toggleUiAction(action, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "remove");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                neo_games_1.Platforms.Platforms.gotoPaytable();
	                Paytable_1.Paytable.instance.updateDataValues();
	                break;
	            case UserAction_1.UserAction.ActionPaytableOff:
	                DataManager_1.DataManager.RulesWindowOpened = false;
	                Paytable_1.Paytable.close();
	                this.disableAllUiDispatchers(action);
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionSwitchControls:
	                var body = document.body;
	                if (body.classList.contains("reverse")) {
	                    body.classList.remove("reverse");
	                }
	                else {
	                    body.classList.add("reverse");
	                }
	                break;
	            case UserAction_1.UserAction.ActionSettingsOn:
	                this.disableAllUiDispatchers(action);
	                this.toggleUiAction(action, "toggle");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                neo_games_1.Platforms.Platforms.gotoSettings();
	                break;
	            case UserAction_1.UserAction.ActionSettingsOff:
	                this.disableAllUiDispatchers(action);
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOn, "remove");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionMenuOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionHelpOff, "add");
	                this.changeUiAcionDispatchers(UserAction_1.UserAction.ActionPaytableOff, "add");
	                if (HtmlController.SoundContainer != null) {
	                    HtmlController.SoundContainer.disable();
	                }
	                break;
	            case UserAction_1.UserAction.ActionQuickspinDialogOff:
	                QuickspinDialog_1.QuickspinDialog.closeDialog();
	                break;
	            case UserAction_1.UserAction.ActionQuickspinToggle:
	                DataManager_1.DataManager.quickspinSet();
	                break;
	            case UserAction_1.UserAction.ActionVibrationToggle:
	                DataManager_1.DataManager.vibrationSet();
	                break;
	            default:
	                if (false) {
	                    this.log("No element with ui disptacher: " + action);
	                }
	        }
	        if (playSound) {
	            PlayList_1.PlayList.play("SND_Click");
	        }
	    };
	    HtmlController.disableAllUiDispatchers = function (action) {
	        for (var key in this.UiDispatchElements) {
	            for (var i = 0; i < this.UiDispatchElements[key].length; i++) {
	                if (this.UiDispatchElements[key][i].instance.classList.contains(HtmlController.DisabledClass) ===
	                    false &&
	                    key != action) {
	                    this.UiDispatchElements[key][i].instance.classList.add(HtmlController.DisabledClass);
	                    if (this.UiActionDispatchElements[key] != null) {
	                        for (var j = 0; j < this.UiActionDispatchElements[key].length; j++) {
	                            this.UiActionDispatchElements[key][j].instance.classList.toggle(HtmlController.DisabledClass);
	                        }
	                    }
	                }
	            }
	        }
	    };
	    HtmlController.changeUiAcionDispatchers = function (action, type) {
	        if (this.UiActionDispatchElements[action] != null) {
	            for (var i = 0; i < this.UiActionDispatchElements[action].length; i++) {
	                if (type === "add") {
	                    if (this.UiActionDispatchElements[action][i].instance.classList.contains(HtmlController.DisabledClass) === false) {
	                        this.UiActionDispatchElements[action][i].instance.classList.add(HtmlController.DisabledClass);
	                    }
	                }
	                else if (type === "remove") {
	                    this.UiActionDispatchElements[action][i].instance.classList.remove(HtmlController.DisabledClass);
	                }
	                else {
	                    this.UiActionDispatchElements[action][i].instance.classList.toggle(HtmlController.DisabledClass);
	                }
	            }
	        }
	    };
	    HtmlController.toggleUiAction = function (action, type) {
	        if (this.UiDispatchElements[action] != null) {
	            for (var i = 0; i < this.UiDispatchElements[action].length; i++) {
	                if (type === "add") {
	                    if (this.UiDispatchElements[action][i].instance.classList.contains(HtmlController.DisabledClass) ===
	                        false) {
	                        this.UiDispatchElements[action][i].instance.classList.add(HtmlController.DisabledClass);
	                    }
	                }
	                else if (type === "remove") {
	                    this.UiDispatchElements[action][i].instance.classList.remove(HtmlController.DisabledClass);
	                }
	                else {
	                    this.UiDispatchElements[action][i].instance.classList.toggle(HtmlController.DisabledClass);
	                }
	            }
	        }
	    };
	    HtmlController.updateDataElement = function (data, value) {
	        if (this.DataElements[data] != null) {
	            for (var i = 0; i < this.DataElements[data].length; i++) {
	                HtmlController.currencyNoZero(data, value);
	                this.DataElements[data][i].setText(value);
	            }
	        }
	        else {
	            if (false) {
	                this.log("No element with data id: " + data);
	            }
	        }
	    };
	    HtmlController.updateDataElements = function (gameData) {
	        if (false) {
	            this.log("udpateDataElements");
	        }
	        for (var key in gameData) {
	            if (this.DataElements[key] != null) {
	                for (var i = 0; i < this.DataElements[key].length; i++) {
	                    HtmlController.currencyNoZero(key, gameData[key]);
	                    this.DataElements[key][i].setText(gameData[key]);
	                }
	            }
	            else {
	                if (false) {
	                    this.log("No element with data id: " + key);
	                }
	            }
	        }
	    };
	    HtmlController.currencyNoZero = function (data, value) {
	        var parsedValue;
	        if (value === "") {
	            parsedValue = 0;
	        }
	        else {
	            parsedValue = parseFloat(value);
	        }
	        if (data === GameData_1.GameData.DataTotalWin) {
	            if (parsedValue === 0) {
	                HtmlController.toggleElementsByClass("currencyNoZero");
	            }
	            else {
	                HtmlController.toggleElementsByClass("currencyNoZero", true);
	            }
	        }
	        else if (data === GameData_1.GameData.DataGambleColorWin) {
	            if (parsedValue === 0) {
	                HtmlController.toggleElementsByClass("gambleCurrencyNoZero");
	            }
	            else {
	                HtmlController.toggleElementsByClass("gambleCurrencyNoZero", true);
	            }
	        }
	    };
	    HtmlController.toggleElementsByClass = function (cls, show) {
	        if (show === void 0) { show = false; }
	        var elements = document.getElementsByClassName(cls);
	        for (var i = 0; i < elements.length; i++) {
	            var element = elements[i];
	            if (element != null) {
	                if (show) {
	                    element.style.display = "";
	                }
	                else {
	                    element.style.display = "none";
	                }
	            }
	        }
	    };
	    HtmlController.updateActionElements = function (actionData) {
	        if (false) {
	            this.log("updateActionElements");
	        }
	        for (var key in actionData) {
	            if (this.ActionElements[key] != null) {
	                var i;
	                for (i = 0; i < this.ActionElements[key].length; i++) {
	                    this.ActionElements[key][i].changeState(actionData[key]);
	                }
	                if (this.ActionsHoldersElements[key] != null) {
	                    for (i = 0; i < this.ActionsHoldersElements[key].length; i++) {
	                        this.ActionsHoldersElements[key][i].changeState(actionData[key]);
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    var keys = neo_common_1.lodash.keys(this.ActionElements).join(";");
	                    this.log("No element with data id: " + key + ", current keys: " + keys);
	                }
	            }
	        }
	    };
	    HtmlController.updateActionElement = function (key, value) {
	        var i;
	        if (this.ActionElements[key] != null) {
	            for (i = 0; i < this.ActionElements[key].length; i++) {
	                this.ActionElements[key][i].changeState(value);
	            }
	        }
	        if (this.ActionsHoldersElements[key] != null) {
	            for (i = 0; i < this.ActionsHoldersElements[key].length; i++) {
	                this.ActionsHoldersElements[key][i].changeState(value);
	            }
	        }
	    };
	    HtmlController.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("HtmlController", data);
	        }
	    };
	    HtmlController.Configurations = { SHOW_BONUS_BALANCE: false };
	    HtmlController.ActionElements = {};
	    HtmlController.UiActionElements = {};
	    HtmlController.UiDispatchElements = {};
	    HtmlController.UiActionDispatchElements = {};
	    HtmlController.ActionsHoldersElements = {};
	    HtmlController.ContainerElementsById = {};
	    HtmlController.DataElements = {};
	    HtmlController.RidElements = [];
	    HtmlController.DisabledClass = "_disabled";
	    HtmlController.HideButtons = [];
	    HtmlController.dispatchActionAllowed = true;
	    return HtmlController;
	}());
	exports.HtmlController = HtmlController;


/***/ },
/* 32 */
/***/ function(module, exports) {

	"use strict";
	var UserAction = (function () {
	    function UserAction() {
	    }
	    UserAction.ActionToggleSound = "TOGGLE_SOUND";
	    UserAction.ActionExit = "EXIT";
	    UserAction.ActionTogglePaytable = "TOGGLE_PAYTABLE";
	    UserAction.ActionPaytableOn = "PAYTABLE_ON";
	    UserAction.ActionPaytableOff = "PAYTABLE_OFF";
	    UserAction.ActionMenuOn = "MENU_ON";
	    UserAction.ActionMenuOff = "MENU_OFF";
	    UserAction.ActionToggleMenu = "TOGGLE_MENU";
	    UserAction.ActionToggleMenuBack = "TOGGLE_MENU_BACK";
	    UserAction.ActionSwitchControls = "SWITCH_CONTROLS";
	    UserAction.ActionHelpOn = "HELP_ON";
	    UserAction.ActionHelpOff = "HELP_OFF";
	    UserAction.ActionHelpTerminal = "TERMINAL_HELP_CYCLE";
	    UserAction.ActionToggleBet = "TOGGLE_BET";
	    UserAction.ActionSettingsOn = "SETTINGS_ON";
	    UserAction.ActionSettingsOff = "SETTINGS_OFF";
	    UserAction.ActionQuickspinDialogOff = "QUICKSPIN_DIALOG_OFF";
	    UserAction.ActionQuickspinToggle = "QUICKSPIN_TOGGLE";
	    UserAction.ActionVibrationToggle = "VIBRATION_TOGGLE";
	    UserAction.ActionGameRoundReport = "GAME_ROUND_REPORT";
	    return UserAction;
	}());
	exports.UserAction = UserAction;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var SoundManager_1 = __webpack_require__(34);
	var PlayList = (function () {
	    function PlayList() {
	    }
	    PlayList.addToPlayList = function (song) {
	        PlayList.Songs[song.id] = song;
	    };
	    PlayList.prototype.create = function (node) {
	        SoundManager_1.SoundManager.parseElements(node, node.nodeName);
	    };
	    PlayList.isPlaying = function (song) {
	        if (PlayList.Songs[song] != null) {
	            return PlayList.Songs[song].isPlaying();
	        }
	    };
	    PlayList.play = function (song, fadeIn, reset) {
	        if (fadeIn === void 0) { fadeIn = 0; }
	        if (reset === void 0) { reset = true; }
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].play(false, fadeIn, reset);
	            if (false) {
	                PlayList.log("play song " + song);
	            }
	        }
	    };
	    PlayList.loop = function (song, fadeIn, reset) {
	        if (fadeIn === void 0) { fadeIn = 0; }
	        if (reset === void 0) { reset = false; }
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].play(true, fadeIn, reset);
	            if (false) {
	                PlayList.log("loop song " + song);
	            }
	        }
	    };
	    PlayList.stop = function (song, fadeOut) {
	        if (fadeOut === void 0) { fadeOut = 0; }
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].stop(fadeOut);
	            if (false) {
	                PlayList.log("stop song " + song);
	            }
	        }
	    };
	    PlayList.stopAll = function (fadeOut) {
	        if (fadeOut === void 0) { fadeOut = 0; }
	        if (PlayList.Songs != null) {
	            for (var song in PlayList.Songs) {
	                PlayList.Songs[song].stop(fadeOut);
	            }
	            if (false) {
	                PlayList.log("stopAll songs");
	            }
	        }
	    };
	    PlayList.stopAllInGroup = function (group, toggle) {
	        if (toggle === void 0) { toggle = false; }
	        if (PlayList.Songs != null) {
	            for (var song in PlayList.Songs) {
	                PlayList.Songs[song].toggleGroup(group, toggle);
	            }
	        }
	    };
	    PlayList.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    PlayList.setVolume = function (song, volume) {
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].setVolume(volume);
	        }
	    };
	    PlayList.resetVolume = function (song, fadeDuration) {
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].resetVolume(fadeDuration);
	        }
	    };
	    PlayList.setPanValue = function (song, pan) {
	        if (pan === void 0) { pan = 0; }
	        if (PlayList.Songs[song] != null) {
	            PlayList.Songs[song].setPan(pan);
	        }
	    };
	    PlayList.setPan = function (song, reelCount, reelIndex) {
	        if (PlayList.Songs[song] != null) {
	            var pan = 0;
	            switch (reelCount) {
	                case 3:
	                    switch (reelIndex) {
	                        case 0:
	                            pan = -0.5;
	                            break;
	                        case 1:
	                            pan = 0;
	                            break;
	                        case 2:
	                            pan = 0.5;
	                            break;
	                        default:
	                    }
	                    break;
	                case 4:
	                    switch (reelIndex) {
	                        case 0:
	                            pan = -0.6;
	                            break;
	                        case 1:
	                            pan = -0.3;
	                            break;
	                        case 2:
	                            pan = 0.3;
	                            break;
	                        case 3:
	                            pan = 0.6;
	                            break;
	                        default:
	                    }
	                    break;
	                case 5:
	                    switch (reelIndex) {
	                        case 0:
	                            pan = -0.7;
	                            break;
	                        case 1:
	                            pan = -0.4;
	                            break;
	                        case 2:
	                            pan = 0;
	                            break;
	                        case 3:
	                            pan = 0.4;
	                            break;
	                        case 4:
	                            pan = 0.7;
	                            break;
	                        default:
	                    }
	                    break;
	                case 6:
	                    switch (reelIndex) {
	                        case 0:
	                            pan = -0.8;
	                            break;
	                        case 1:
	                            pan = -0.5;
	                            break;
	                        case 2:
	                            pan = -0.2;
	                            break;
	                        case 3:
	                            pan = 0.2;
	                            break;
	                        case 4:
	                            pan = 0.5;
	                            break;
	                        case 4:
	                            pan = 0.8;
	                            break;
	                        default:
	                    }
	                    break;
	                default:
	            }
	            PlayList.Songs[song].setPan(pan);
	        }
	    };
	    PlayList.Songs = {};
	    PlayList = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.PlayList)
	    ], PlayList);
	    return PlayList;
	}());
	exports.PlayList = PlayList;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var PlayList_1 = __webpack_require__(33);
	var SoundManager = (function () {
	    function SoundManager() {
	    }
	    SoundManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("SoundManager", data);
	        }
	    };
	    SoundManager.parseElements = function (node, playList) {
	        if (playList === void 0) { playList = ""; }
	        if (node != null) {
	            var next = node.firstElementChild;
	            while (next != null) {
	                var cls = "";
	                if (next.hasAttribute("Class")) {
	                    cls = next.getAttribute("Class");
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING element with name: " + next.nodeName + " has no class");
	                    }
	                }
	                if (cls !== "") {
	                    if (neo_common_1.EngineComponentFactory.isTypeOf(cls, ComponentTypes_1.ComponentTypes.PlayList)) {
	                        var element = neo_common_1.EngineComponentFactory.get(cls);
	                        SoundManager.PlayLists[next.nodeName] = element;
	                        element.create(next);
	                    }
	                    else if (neo_common_1.EngineComponentFactory.isTypeOf(cls, ComponentTypes_1.ComponentTypes.Song)) {
	                        var element = neo_common_1.EngineComponentFactory.get(cls);
	                        element.create(next);
	                        if (playList !== "") {
	                            PlayList_1.PlayList.addToPlayList(element);
	                        }
	                    }
	                }
	                next = next.nextElementSibling;
	            }
	        }
	    };
	    SoundManager.PlayLists = {};
	    return SoundManager;
	}());
	exports.SoundManager = SoundManager;


/***/ },
/* 35 */
/***/ function(module, exports) {

	"use strict";
	var BaseActions = (function () {
	    function BaseActions() {
	    }
	    BaseActions.ActionSpin = "SPIN";
	    BaseActions.ActionSpinStop = "SPIN_STOP";
	    BaseActions.ActionAutoplay = "AUTOPLAY";
	    BaseActions.ActionAutoplayStop = "AUTOPLAY_STOP";
	    BaseActions.ActionBetPlus = "BET_PLUS";
	    BaseActions.ActionBetMinus = "BET_MINUS";
	    BaseActions.ActionBetCycle = "BET_CYCLE";
	    BaseActions.ActionMaxBet = "MAX_BET";
	    BaseActions.ActionBaseCollect = "BASE_COLLECT";
	    BaseActions.ActionSelectPayline = "SELECT_PAYLINE_";
	    BaseActions.ActionDenomSelect = "DENOM_SELECT";
	    BaseActions.ActionDenomSelectValue = "DENOM_SELECT_VALUE_";
	    BaseActions.ActionCoinCountSelect = "COIN_COUNT_SELECT";
	    BaseActions.ActionCoinCountSelectValue = "COIN_COUNT_SELECT_VALUE_";
	    BaseActions.ActionBetSelect = "BET_SELECT";
	    BaseActions.ActionBetSelectValue = "BET_SELECT_VALUE_";
	    BaseActions.ActionBuyFeature = "BUY_FEATURE";
	    BaseActions.ActionBuyFeatureDialog = "BUY_FEATURE_DIALOG";
	    BaseActions.ActionSkipWin = "SKIP_WIN";
	    return BaseActions;
	}());
	exports.BaseActions = BaseActions;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var JackpotCounter_1 = __webpack_require__(37);
	var JackpotHistoryDialog_1 = __webpack_require__(38);
	var Scaling_1 = __webpack_require__(8);
	var HtmlController_1 = __webpack_require__(31);
	var JackpotGame_1 = __webpack_require__(40);
	var AppContext_1 = __webpack_require__(5);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var Jackpot = (function () {
	    function Jackpot() {
	    }
	    Jackpot.initialize = function () {
	        if (AppContext_1.AppContext && AppContext_1.AppContext.gameConfiguration.ProgressiveBonusId > -1) {
	            document.body.classList.add("jpt-on");
	            Jackpot.WidgetRoot = document.getElementById("jackpotWidget");
	            Jackpot.GameRoot = document.getElementById("jackpotGame");
	            Jackpot.BonusId = AppContext_1.AppContext.gameConfiguration.ProgressiveBonusId;
	            Jackpot.createCounters();
	            Jackpot.createHistoryDialogs();
	            Jackpot.bindElements();
	            Jackpot.getBonusInfo(Jackpot.initJackpotDataReceived);
	            if (GameManager_1.GameManager.gameClient) {
	                GameManager_1.GameManager.gameClient.setBonusId(Jackpot.BonusId);
	            }
	        }
	        else {
	            Jackpot.clearJackpot();
	        }
	    };
	    Jackpot.reinitialize = function () {
	        if (Jackpot.Offline) {
	            Jackpot.Offline = false;
	            Jackpot.refreshBonusInfo();
	            Jackpot.refreshCounters();
	        }
	    };
	    Jackpot.show = function () {
	        if (Jackpot.WidgetRoot) {
	            if (Jackpot.Counters.length > 0) {
	                for (var i = 0; i < Jackpot.CountersCount; i++) {
	                    Jackpot.Counters[i].createCurrency(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency));
	                    Jackpot.HistoryDialogs[i].updateDataWithCurrency();
	                }
	                Jackpot.Height = Jackpot.Counters[0].getHeight();
	                Scaling_1.Scaling.PortraitMobileRatio = 0.76;
	                Scaling_1.Scaling.resizeRoot();
	            }
	        }
	    };
	    Jackpot.clearJackpot = function () {
	        var jackpotWidget = document.getElementById("jackpotWidget");
	        var jackpotGame = document.getElementById("jackpotGame");
	        if (jackpotWidget && jackpotWidget.parentNode && jackpotGame && jackpotGame.parentNode) {
	            jackpotWidget.parentNode.removeChild(jackpotWidget);
	            jackpotGame.parentNode.removeChild(jackpotGame);
	        }
	    };
	    Jackpot.createCounters = function () {
	        if (Jackpot.WidgetRoot) {
	            Jackpot.getCustomContent("jackpotLogo.jpg", Jackpot.createLogo, Jackpot.createLogo);
	            Jackpot.createElement("div", "jackpotCountersBg", Jackpot.WidgetRoot);
	            var holder = Jackpot.createElement("div", "jackpotCounters", Jackpot.WidgetRoot);
	            holder.id = "jackpotCounters";
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                var counter = new JackpotCounter_1.JackpotCounter(i + 1, holder, Jackpot.refreshCounters);
	                Jackpot.Counters.push(counter);
	            }
	        }
	    };
	    Jackpot.createLogo = function (contentUrl) {
	        if (contentUrl === void 0) { contentUrl = ""; }
	        var logo = Jackpot.createElement("div", "jackpotLogo", Jackpot.WidgetRoot);
	        logo = Jackpot.createElement("div", "", logo);
	        logo.id = "jackpotLogo";
	        if (contentUrl != "") {
	            logo.style.background = "url(" + contentUrl + ")";
	        }
	    };
	    Jackpot.createHistoryDialogs = function () {
	        if (Jackpot.WidgetRoot) {
	            var holder = Jackpot.createElement("div", "jackpotHistory", Jackpot.WidgetRoot);
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                var dialog = new JackpotHistoryDialog_1.JackpotHistoryDialog(i + 1, holder);
	                Jackpot.HistoryDialogs.push(dialog);
	            }
	        }
	    };
	    Jackpot.createBonusGame = function () {
	        if (Jackpot.GameRoot) {
	            var holder = Jackpot.createElement("div", "jackpotGameHolder", Jackpot.GameRoot);
	            Jackpot.Game = new JackpotGame_1.JackpotGame(holder);
	        }
	    };
	    Jackpot.refreshCounters = function () {
	        for (var i = 0; i < Jackpot.CountersCount; i++) {
	            Jackpot.Counters[i].refreshWithReset();
	        }
	    };
	    Jackpot.showError = function (useResetAnim) {
	        if (useResetAnim === void 0) { useResetAnim = false; }
	        clearTimeout(this.RefreshTimerId);
	        if (Jackpot.WidgetRoot) {
	            if (Jackpot.Counters && Jackpot.HistoryDialogs) {
	                Jackpot.Offline = true;
	                for (var i = 0; i < Jackpot.CountersCount; i++) {
	                    Jackpot.Counters[i].error(useResetAnim);
	                    Jackpot.HistoryDialogs[i].error(useResetAnim);
	                }
	            }
	        }
	    };
	    Jackpot.refreshBonusInfo = function () {
	        clearTimeout(this.RefreshTimerId);
	        Jackpot.getBonusInfo(Jackpot.jackpotDataReceive);
	    };
	    Jackpot.refreshBonusInfoInMiniGame = function (overrideLevelData) {
	        clearTimeout(this.RefreshTimerId);
	        Jackpot.getBonusInfo(Jackpot.jackpotDataReceive, { overrideLeveldata: overrideLevelData, priority: true });
	    };
	    Jackpot.refreshBonusInfoWithWinValue = function (overrideLevelData) {
	        clearTimeout(this.RefreshTimerId);
	        Jackpot.getBonusInfo(Jackpot.jackpotDataReceive, {
	            overrideLeveldata: overrideLevelData,
	            priority: true,
	            fromMiniGame: overrideLevelData.code,
	        });
	    };
	    Jackpot.refreshBonusInfoBeforeSpin = function (spinCallback) {
	        clearTimeout(this.RefreshTimerId);
	        Jackpot.getBonusInfoBeforeSpin(spinCallback, { priority: true });
	    };
	    Jackpot.getBonusInfo = function (callback, customData) {
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient
	                .sendProgressiveBonusGetInfoRequest(Jackpot.BonusId)
	                .then(function (response) {
	                callback(response, customData);
	                return null;
	            })
	                .catch(function (error) {
	                Jackpot.showError(true);
	            });
	        }
	    };
	    Jackpot.getBonusInfoBeforeSpin = function (callback, customData) {
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient
	                .sendProgressiveBonusGetInfoRequest(Jackpot.BonusId)
	                .then(function (response) {
	                Jackpot.jackpotDataReceive(response, customData);
	                callback();
	                return null;
	            })
	                .catch(function (error) {
	                Jackpot.showError(true);
	                callback();
	            });
	        }
	    };
	    Jackpot.initJackpotDataReceived = function (response, customData) {
	        if (response != null) {
	            Jackpot.RefreshInterval = response.refreshInterval;
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                Jackpot.Counters[i].initialize(response.levels[i], response.timestamp);
	                Jackpot.HistoryDialogs[i].initialize(response.levels[i]);
	            }
	        }
	        else {
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                Jackpot.Counters[i].error();
	                Jackpot.HistoryDialogs[i].error();
	            }
	        }
	        Jackpot.RefreshTimerId = setTimeout(Jackpot.refreshBonusInfo, Jackpot.RefreshInterval * 1000);
	    };
	    Jackpot.jackpotDataReceive = function (response, customData) {
	        if (response != null) {
	            Jackpot.RefreshInterval = response.refreshInterval;
	            var winOverride = customData != null && customData["overrideLeveldata"] != null;
	            var priority = customData != null && customData["priority"] != null;
	            var fromMiniGame = customData != null && customData["fromMiniGame"] != null ? customData["fromMiniGame"] : "";
	            if (winOverride) {
	                response = Jackpot.updateReponseData(response, customData["overrideLeveldata"]);
	            }
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                Jackpot.Counters[i].assign(response.levels[i], response.timestamp, priority, response.levels[i]["overridedLastWinAmount"], fromMiniGame == response.levels[i].code);
	                Jackpot.HistoryDialogs[i].assign(response.levels[i]);
	            }
	        }
	        else {
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                Jackpot.Counters[i].error();
	                Jackpot.HistoryDialogs[i].error();
	            }
	        }
	        Jackpot.RefreshTimerId = setTimeout(Jackpot.refreshBonusInfo, Jackpot.RefreshInterval * 1000);
	    };
	    Jackpot.updateReponseData = function (response, overrideLevelData) {
	        if (overrideLevelData != null) {
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                if (response.levels[i].code == overrideLevelData.code) {
	                    if (overrideLevelData.lastWinAmount != null) {
	                        response.levels[i]["overridedLastWinAmount"] = overrideLevelData.lastWinAmount;
	                    }
	                    else {
	                        response.levels[i] = overrideLevelData;
	                    }
	                }
	            }
	        }
	        return response;
	    };
	    Jackpot.bindElements = function () {
	        var _loop_1 = function(i) {
	            if (window["CHANNEL"] === "mobile") {
	                Jackpot.Counters[i]
	                    .getRoot()
	                    .addEventListener("click", function (event) { return Jackpot.toggleHistoryDialog(event, i); });
	                for (var i_1 = 0; i_1 < Jackpot.HistoryDialogs.length; i_1++) {
	                    Jackpot.HistoryDialogs[i_1]
	                        .getRoot()
	                        .addEventListener("click", function (event) { return Jackpot.preventDefault(event); });
	                    Jackpot.HistoryDialogs[i_1]
	                        .getRoot()
	                        .addEventListener("touchstart", function (event) { return Jackpot.preventDefault(event); });
	                }
	            }
	            else {
	                Jackpot.Counters[i].getRoot().addEventListener("click", Jackpot.showHistoryDialog.bind(this_1, i));
	                Jackpot.Counters[i].getRoot().addEventListener("mouseover", Jackpot.showHistoryDialog.bind(this_1, i));
	                Jackpot.Counters[i].getRoot().addEventListener("mouseout", Jackpot.hideHistoryDialog.bind(this_1, i));
	            }
	        };
	        var this_1 = this;
	        for (var i = 0; i < Jackpot.Counters.length; i++) {
	            _loop_1(i);
	        }
	    };
	    Jackpot.closeAllHistoryDialogs = function () {
	        if (Jackpot.WidgetRoot) {
	            Jackpot.WidgetRoot.removeEventListener("click", Jackpot.closeAllHistoryDialogs);
	            for (var i = 0; i < Jackpot.HistoryDialogs.length; i++) {
	                Jackpot.HistoryDialogs[i].closeDialog();
	            }
	        }
	    };
	    Jackpot.showHistoryDialog = function (index) {
	        this.closeAllHistoryDialogs();
	        if (Jackpot.HistoryDialogs[index]) {
	            if (window["CHANNEL"] === "mobile") {
	                HtmlController_1.HtmlController.dispatchAction("");
	                Jackpot.WidgetRoot.addEventListener("click", Jackpot.closeAllHistoryDialogs);
	            }
	            Jackpot.TouchEvent = Jackpot.hideHistoryDialog.bind(this, index);
	            document.addEventListener("touchstart", Jackpot.TouchEvent);
	            Jackpot.HistoryDialogs[index].openDialog();
	        }
	    };
	    Jackpot.toggleHistoryDialog = function (event, index) {
	        event.preventDefault();
	        event.stopPropagation();
	        if (Jackpot.HistoryDialogs[index] && !Jackpot.HistoryDialogs[index].isOpen()) {
	            this.showHistoryDialog(index);
	        }
	        else {
	            this.closeAllHistoryDialogs();
	        }
	    };
	    Jackpot.hideHistoryDialog = function (index) {
	        if (Jackpot.HistoryDialogs[index]) {
	            Jackpot.HistoryDialogs[index].closeDialog();
	            document.removeEventListener("touchstart", Jackpot.TouchEvent);
	        }
	    };
	    Jackpot.preventDefault = function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	    };
	    Jackpot.initMiniGame = function (autostart, callback) {
	        if (!Jackpot.Game) {
	            Jackpot.createBonusGame();
	        }
	        Jackpot.Game.init(autostart, callback);
	    };
	    Jackpot.startMiniGame = function () {
	        if (!Jackpot.Game.hasStartedGame()) {
	            Jackpot.Game.start();
	        }
	    };
	    Jackpot.hasActiveGame = function () {
	        if (!Jackpot.Game) {
	            return false;
	        }
	        return Jackpot.Game.hasStartedGame();
	    };
	    Jackpot.hasInitializedGame = function () {
	        return Jackpot.Game && Jackpot.Game.hasInitializedGame();
	    };
	    Jackpot.hasMiniGame = function () {
	        if (Jackpot.Game && Jackpot.Game.hasStartedGame()) {
	            return true;
	        }
	        if (Jackpot.countersInError()) {
	            return false;
	        }
	        if (Jackpot.Game && Jackpot.Game.hasInitializedGame()) {
	            return true;
	        }
	        return GameManager_1.GameManager.gameResponse["progressiveBonus"] && GameManager_1.GameManager.gameResponse["progressiveBonus"].ticket;
	    };
	    Jackpot.disableMiniGameAutostart = function () {
	        if (Jackpot.Game) {
	            Jackpot.Game.disableAutostart();
	        }
	    };
	    Jackpot.waitForMiniGameInitialization = function () {
	        return (AppContext_1.AppContext &&
	            (AppContext_1.AppContext.gameConfiguration.ProgressiveBonusTicketConstraint == "WithinGameRound" ||
	                AppContext_1.AppContext.gameConfiguration.ProgressiveBonusTicketConstraint == "AfterGameRound"));
	    };
	    Jackpot.createElement = function (tag, className, rootElem) {
	        var elem = document.createElement(tag);
	        elem.setAttribute("class", className);
	        if (rootElem) {
	            rootElem.appendChild(elem);
	        }
	        return elem;
	    };
	    Jackpot.countersInError = function () {
	        if (Jackpot.Counters && Jackpot.Counters.length > 0) {
	            for (var i = 0; i < Jackpot.CountersCount; i++) {
	                if (Jackpot.Counters[i].hasError()) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    Jackpot.getCustomContent = function (name, success, error) {
	        if (AppContext_1.AppContext.gameConfiguration == null) {
	            if (error)
	                error();
	            return;
	        }
	        if (AppContext_1.AppContext.gameConfiguration.StaticContentUrl == "") {
	            if (error)
	                error();
	            return;
	        }
	        var theme = AppContext_1.AppContext.gameConfiguration.ProgressiveBonusTheme;
	        if (theme == "") {
	            if (AppContext_1.AppContext.gameConfiguration.UseJackpotLocalization) {
	                theme = Jackpot.JackpotTheme;
	            }
	            else {
	                if (error)
	                    error();
	                return;
	            }
	        }
	        var staticContentUrl = AppContext_1.AppContext.gameConfiguration.StaticContentUrl;
	        var spbFolder = "SynotProgressiveBonus";
	        var url = "" + staticContentUrl + spbFolder + "/" + theme + "/" + window["QUALITY"] + "/" + name;
	        var img = document.createElement("img");
	        img.setAttribute("src", url);
	        img.addEventListener("load", function (ev) {
	            if (success)
	                success(url);
	        });
	        img.addEventListener("error", function (ev) {
	            if (error)
	                error();
	        });
	    };
	    Jackpot.JackpotTheme = "SPJackpot";
	    Jackpot.Height = 0;
	    Jackpot.BonusId = -1;
	    Jackpot.CountersCount = 4;
	    Jackpot.Counters = [];
	    Jackpot.HistoryDialogs = [];
	    Jackpot.RefreshInterval = 15;
	    Jackpot.Offline = false;
	    return Jackpot;
	}());
	exports.Jackpot = Jackpot;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var FrameTimer_1 = __webpack_require__(9);
	var gsap_1 = __webpack_require__(17);
	var Languages_1 = __webpack_require__(28);
	var AppContext_1 = __webpack_require__(5);
	var JackpotCounter = (function () {
	    function JackpotCounter(index, holder, resetCallback) {
	        if (AppContext_1.AppContext.gameConfiguration != null) {
	            JackpotCounter.DecimalPlaces = AppContext_1.AppContext.gameConfiguration.ShowDecimalPlaces;
	        }
	        this.root = this.createBaseLayout(index);
	        holder.appendChild(this.root);
	        this.createDigits();
	        this.createDecimalPoint();
	        this.currentCounterValue = 0;
	        this.previousCounterValue = 0;
	        this.lastWinValue = -1;
	        this.lastWinCount = -1;
	        this.overridedLastWinValue = -1;
	        this.winAnimationDelay = FrameTimer_1.CreateFrameTimer("winAnimationDelayTimer");
	        this.winAnimationDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.winAnimationFinished.bind(this));
	        this.mainTween = null;
	        this.digitTween = null;
	        this.winFromMinigame = false;
	        this.lastUpdateTime = Date.now();
	        this.resetCallback = resetCallback;
	        this.reset();
	    }
	    JackpotCounter.prototype.createBaseLayout = function (index) {
	        var root = this.createElement("div", "jackpotCounter l-" + index);
	        this.createElement("div", "jackpotFrame", root);
	        var level = this.createElement("div", "jackpotLevel", root);
	        this.createElement("div", "jackpotIconError", level);
	        this.createElement("div", "jackpotDigitsHolder", root);
	        this.createElement("div", "jackpotGradient", root);
	        var currency = this.createElement("div", "jackpotCurrency", root);
	        this.createElement("div", "jackpotCurrencyLetter", currency);
	        this.createElement("div", "jackpotCurrencyLetter", currency);
	        this.createElement("div", "jackpotCurrencyLetter", currency);
	        return root;
	    };
	    JackpotCounter.prototype.createCurrency = function (currency) {
	        if (!neo_common_1.StringUtils.isNullOrEmpty(currency)) {
	            var jackpotCurrencyLetters = this.root.getElementsByClassName("jackpotCurrencyLetter");
	            for (var i = 0; i < jackpotCurrencyLetters.length; i++) {
	                if (currency.length > i) {
	                    jackpotCurrencyLetters[i].textContent = currency.charAt(i);
	                }
	            }
	            jackpotCurrencyLetters[0].parentElement.classList.add("ln-" + currency.length);
	        }
	    };
	    JackpotCounter.prototype.createDigits = function () {
	        var digitsHolder = this.root.getElementsByClassName("jackpotDigitsHolder")[0];
	        var digitsArray = [];
	        this.digits = [];
	        var digit;
	        for (var i = 0; i < JackpotCounter.Length; i++) {
	            var className = i == JackpotCounter.Length - JackpotCounter.DecimalPlaces ? "digits decimalOffset" : "digits";
	            digit = this.createElement("div", className, digitsHolder);
	            var from = this.createElement("div", "digit", digit);
	            var to = this.createElement("div", "digit", digit);
	            digitsArray.push(digit);
	            this.digits.push({ from: from, to: to });
	        }
	        if (JackpotCounter.UseThousandsSeparator) {
	            digitsHolder.classList.add("thousandsFormat");
	            for (var i = 0; i < digitsArray.length; i++) {
	                var index = digitsArray.length - 1 - i;
	                var hasThousandsOffset = index > 0 && i > JackpotCounter.DecimalPlaces && (i + 1 - JackpotCounter.DecimalPlaces) % 3 == 0;
	                if (hasThousandsOffset && digitsArray[index] != null) {
	                    digitsArray[index].classList.add("thousandsOffset");
	                }
	            }
	        }
	        this.settings = {
	            width: parseInt(window.getComputedStyle(digit).width),
	            height: parseInt(window.getComputedStyle(digit).height),
	        };
	    };
	    JackpotCounter.prototype.createDecimalPoint = function () {
	        var digitsHolder = this.root.getElementsByClassName("jackpotDigitsHolder")[0];
	        if (JackpotCounter.DecimalPlaces > 0) {
	            this.decimalDot = this.createElement("div", "digit nDot", digitsHolder);
	            this.decimalDot.style.right = JackpotCounter.DecimalPlaces * this.settings.width + "px";
	        }
	    };
	    JackpotCounter.prototype.initialize = function (data, serverTimestamp) {
	        this.assign(data, serverTimestamp);
	    };
	    JackpotCounter.prototype.assign = function (data, serverTimestamp, priority, overridedLastWinValue, winFromMinigame) {
	        if (priority === void 0) { priority = false; }
	        if (overridedLastWinValue === void 0) { overridedLastWinValue = -1; }
	        if (winFromMinigame === void 0) { winFromMinigame = false; }
	        this.currentData = data;
	        this.nextValue = this.normalizeValue(data.nextValue);
	        this.nextDate = Date.now() + (new Date(data.nextTimestamp).getTime() - new Date(serverTimestamp).getTime());
	        this.previousValue = this.normalizeValue(data.previousValue);
	        this.winFromMinigame = winFromMinigame;
	        var oldValuesReset = Date.now() - this.lastUpdateTime > JackpotCounter.MaxNextTimeDiff * 1000;
	        if (overridedLastWinValue > -1) {
	            this.overridedLastWinValue = this.normalizeValue(overridedLastWinValue);
	        }
	        if (oldValuesReset && this.resetCallback != null) {
	            this.resetCallback();
	            return;
	        }
	        if (this.inError) {
	            this.removeError();
	            this.reset();
	            return;
	        }
	        if (!this.isCounting || priority) {
	            this.refresh();
	        }
	    };
	    JackpotCounter.prototype.error = function (useResetAnim) {
	        if (useResetAnim === void 0) { useResetAnim = false; }
	        if (!this.inError) {
	            this.inError = true;
	            this.isCounting = false;
	            if (useResetAnim) {
	                this.resetMainTween();
	                this.resetDigitTween(true);
	                this.errorResetAnim();
	                return;
	            }
	            if (this.decimalDot) {
	                this.decimalDot.style.display = "none";
	            }
	            this.root.classList.add("jackpotError");
	            var oldValue = this.formatValue(this.previousCounterValue > 0 ? this.previousCounterValue.toString() : "", true);
	            var newValue = this.formatValue("OFFLINE", true);
	            this.resetDigitTween(true);
	            this.animateDigits(oldValue, newValue, false, false, JackpotCounter.DigitAnimDuration * 2, 0, "linear", false, null);
	        }
	    };
	    JackpotCounter.prototype.errorResetAnim = function () {
	        this.root.classList.add("jackpotExpired");
	    };
	    JackpotCounter.prototype.checkError = function () {
	        if (this.inError) {
	            this.resetMainTween();
	            this.resetDigitTween();
	            this.isCounting = false;
	            return true;
	        }
	        return false;
	    };
	    JackpotCounter.prototype.removeError = function () {
	        if (this.inError) {
	            this.inError = false;
	            this.root.classList.remove("jackpotError");
	            if (this.decimalDot) {
	                this.decimalDot.style.display = "block";
	            }
	        }
	    };
	    JackpotCounter.prototype.hasError = function () {
	        return this.inError;
	    };
	    JackpotCounter.prototype.refreshWithReset = function () {
	        this.hasWin();
	        this.root.classList.remove("jackpotWin");
	        this.winAnimationDelay.stop();
	        this.resetMainTween();
	        this.resetDigitTween();
	        this.resetDigitsTween();
	        this.isCounting = false;
	        this.removeError();
	        this.reset(JackpotCounter.MinResetAnimCount - 3);
	    };
	    JackpotCounter.prototype.resetDigitsTween = function () {
	        for (var i = 0; i < this.digits.length; i++) {
	            gsap_1.TweenLite.killTweensOf(this.digits[i].to);
	            gsap_1.TweenLite.killTweensOf(this.digits[i].from);
	        }
	    };
	    JackpotCounter.prototype.animateDigits = function (oldValue, newValue, useBitmap, checkFirstDiff, duration, delay, ease, shuffle, callback) {
	        var firstDigitIndex = 0;
	        if (checkFirstDiff) {
	            for (var i = 0; i < JackpotCounter.Length; i++) {
	                var oldDigit = oldValue.charAt(i);
	                var newDigit = newValue.charAt(i);
	                if (oldDigit !== newDigit) {
	                    firstDigitIndex = i;
	                    break;
	                }
	            }
	        }
	        for (var i = firstDigitIndex; i < JackpotCounter.Length; i++) {
	            var oldDigit = oldValue.charAt(i);
	            var newDigit = newValue.charAt(i);
	            this.animateDigit(i, oldDigit, newDigit, duration, delay, ease, useBitmap, shuffle ? (i % 2 === 0 ? 1 : -1) : 1, i === JackpotCounter.Length - 1 ? callback : null);
	        }
	    };
	    JackpotCounter.prototype.animateDigit = function (index, fromValue, toValue, duration, delay, ease, useBitmap, direction, callback) {
	        var from = this.digits[index].from;
	        this.setTransformY(from, 0, delay);
	        this.setDigitValue(from, fromValue, useBitmap, true);
	        gsap_1.TweenLite.fromTo(from, duration, { y: 0 }, { y: this.settings.height * direction * -1, ease: ease, delay: delay });
	        var to = this.digits[index].to;
	        this.setTransformY(to, this.settings.height * direction, delay);
	        this.setDigitValue(to, toValue, useBitmap);
	        gsap_1.TweenLite.killTweensOf(to);
	        var tween = gsap_1.TweenLite.fromTo(to, duration, { y: this.settings.height * direction }, { y: 0, ease: ease, delay: delay });
	        if (!neo_common_1.Utils.isNullOrUndefined(callback)) {
	            this.digitTween = tween;
	            this.digitTween.eventCallback("onComplete", callback, [], this);
	        }
	    };
	    JackpotCounter.prototype.setDigitValue = function (elem, value, useBitmap, fromValue) {
	        if (fromValue === void 0) { fromValue = false; }
	        if (fromValue) {
	            if (useBitmap && elem.classList.contains("letter")) {
	                useBitmap = false;
	            }
	            else if (!useBitmap && !elem.classList.contains("letter")) {
	                useBitmap = true;
	            }
	        }
	        if (value == null || value === JackpotCounter.LeadingZeroLetter) {
	            elem.className = "digit leadingZero";
	        }
	        else {
	            if (!useBitmap) {
	                elem.textContent = value;
	                elem.className = "digit letter";
	            }
	            else {
	                elem.textContent = "";
	                elem.className = "digit n" + value;
	            }
	        }
	    };
	    JackpotCounter.prototype.setTransformY = function (elem, y, delay) {
	        if (delay > 0) {
	            elem.style.transform = "transform3d(0, " + y + "px, 0)";
	        }
	    };
	    JackpotCounter.prototype.refresh = function () {
	        if (this.checkError()) {
	            return;
	        }
	        if (this.hasWin()) {
	            this.isCounting = true;
	            this.initWinAnimation();
	            return;
	        }
	        if (this.currentCounterValue == this.nextValue) {
	            this.resetDigitTween();
	            this.resetDigitsToBasePosition();
	            this.lastUpdateTime = Date.now();
	            var availableTime_1 = (this.nextDate - Date.now()) * 0.001;
	            if (availableTime_1 > 0) {
	                this.resetMainTween();
	                this.mainTween = gsap_1.TweenLite.fromTo(this, availableTime_1, { idleValue: 0 }, { idleValue: 100, ease: "linear" });
	                this.mainTween.eventCallback("onComplete", this.refresh, [], this);
	            }
	            else {
	                this.isCounting = false;
	            }
	            return;
	        }
	        if (this.currentCounterValue > this.nextValue) {
	            this.isCounting = false;
	            return;
	        }
	        var availableTime = (this.nextDate - Date.now()) * 0.001;
	        this.resetMainTween();
	        this.mainTween = gsap_1.TweenLite.fromTo(this, availableTime, { currentCounterValue: this.currentCounterValue }, { currentCounterValue: this.nextValue, ease: "linear", roundProps: "currentCounterValue" });
	        this.mainTween.eventCallback("onComplete", this.refresh, [], this);
	        this.mainTween.eventCallback("onUpdate", this.onRefreshTweenUpdate, [], this);
	        this.isCounting = true;
	    };
	    JackpotCounter.prototype.onRefreshTweenUpdate = function () {
	        if (this.digitTween == null) {
	            this.refreshCounter();
	        }
	    };
	    JackpotCounter.prototype.refreshCounter = function () {
	        if (this.inError) {
	            this.resetDigitTween();
	            return;
	        }
	        if (this.previousCounterValue == this.currentCounterValue) {
	            this.resetDigitTween();
	            return;
	        }
	        var oldValue = this.formatValue(this.previousCounterValue.toString(), true);
	        var newValue = this.formatValue(this.currentCounterValue.toString(), true);
	        this.lastUpdateTime = Date.now();
	        this.animateDigits(oldValue, newValue, true, true, JackpotCounter.DigitAnimDuration * 2, 0, "linear", false, this.refreshCounter);
	        this.previousCounterValue = this.currentCounterValue;
	    };
	    JackpotCounter.prototype.reset = function (resetAnimCount) {
	        if (resetAnimCount === void 0) { resetAnimCount = 0; }
	        this.resetAnimCount = resetAnimCount;
	        this.isCounting = true;
	        this.resetCounter();
	    };
	    JackpotCounter.prototype.resetCounter = function () {
	        if (this.checkError()) {
	            return;
	        }
	        if (this.resetAnimCount >= JackpotCounter.MinResetAnimCount - 1 && this.currentData != null) {
	            if (this.hasWin()) {
	                this.resetDigitTween();
	                this.isCounting = true;
	                this.initWinAnimation();
	                return;
	            }
	            var oldValue = this.formatValue(this.currentCounterValue.toString(), false);
	            var newValue = this.formatValue(this.previousValue.toString(), true);
	            this.currentCounterValue = this.previousValue;
	            this.previousCounterValue = this.previousValue;
	            this.animateDigits(oldValue, newValue, true, false, JackpotCounter.DigitAnimDuration * 10, 0, "Back.easeOut", true, this.resetFinished);
	        }
	        else {
	            this.resetAnimCount++;
	            var random = Math.random();
	            var length_1 = Math.pow(10, JackpotCounter.Length);
	            var value = Math.round(random * length_1);
	            var oldValue = this.formatValue(this.currentCounterValue > 0 ? this.currentCounterValue.toString() : "", false);
	            var newValue = this.formatValue(value.toString(), false);
	            this.animateDigits(oldValue, newValue, true, false, JackpotCounter.DigitAnimDuration, 0, "linear", true, this.resetCounter);
	            this.currentCounterValue = value;
	        }
	    };
	    JackpotCounter.prototype.resetFinished = function () {
	        this.lastUpdateTime = Date.now();
	        this.resetDigitTween();
	        this.isCounting = false;
	        this.refresh();
	    };
	    JackpotCounter.prototype.hasWin = function () {
	        var result = false;
	        if (this.currentData != null && this.currentData.lastWinAmount != null) {
	            var currentLastWin = this.overridedLastWinValue > -1
	                ? this.overridedLastWinValue
	                : this.normalizeValue(this.currentData.lastWinAmount);
	            var currentWinCount = this.currentData.winCount;
	            if (this.lastWinValue > -1) {
	                result = this.lastWinValue != currentLastWin;
	                if (!result && this.lastWinCount > -1 && currentWinCount > -1 && !this.winFromMinigame) {
	                    result = this.lastWinCount != currentWinCount;
	                }
	            }
	            this.lastWinCount = currentWinCount;
	            this.lastWinValue = currentLastWin;
	            this.overridedLastWinValue = -1;
	        }
	        return result || this.winFromMinigame;
	    };
	    JackpotCounter.prototype.initWinAnimation = function () {
	        this.resetMainTween();
	        if (this.digitTween != null) {
	            this.digitTween.eventCallback("onComplete", this.startWinAnimation, [], this);
	        }
	        else {
	            this.startWinAnimation();
	        }
	    };
	    JackpotCounter.prototype.startWinAnimation = function () {
	        if (this.currentCounterValue != this.lastWinValue) {
	            var oldValue = this.formatValue(this.currentCounterValue.toString(), true);
	            var newValue = this.formatValue(this.lastWinValue.toString(), true);
	            this.animateDigits(oldValue, newValue, true, true, JackpotCounter.DigitAnimDuration * 2, 0, "linear", false, this.showWinAnimation);
	            this.previousCounterValue = this.currentCounterValue;
	        }
	        else {
	            this.showWinAnimation();
	        }
	        this.winAnimationDelay.start(this.winFromMinigame ? JackpotCounter.WinFromMinigameAnimDuration : JackpotCounter.WinAnimDuration);
	    };
	    JackpotCounter.prototype.showWinAnimation = function () {
	        this.forceWinValue();
	        this.root.classList.add("jackpotWin");
	        if (this.winFromMinigame) {
	            this.root.classList.add("fromMinigame");
	        }
	    };
	    JackpotCounter.prototype.winAnimationFinished = function () {
	        this.winFromMinigame = false;
	        this.root.classList.remove("jackpotWin", "fromMinigame");
	        this.reset();
	    };
	    JackpotCounter.prototype.getRoot = function () {
	        return this.root;
	    };
	    JackpotCounter.prototype.getHeight = function () {
	        if (this.root.parentElement != null) {
	            this.root.parentElement.classList.add("baseCounterHeight");
	            this.root.parentElement.offsetWidth;
	            var height = parseInt(window.getComputedStyle(this.root.parentElement).height);
	            this.root.parentElement.classList.remove("baseCounterHeight");
	            return height;
	        }
	        return 0;
	    };
	    JackpotCounter.prototype.createElement = function (tag, className, rootElem) {
	        var elem = document.createElement(tag);
	        elem.setAttribute("class", className);
	        if (rootElem) {
	            rootElem.appendChild(elem);
	        }
	        return elem;
	    };
	    JackpotCounter.prototype.normalizeValue = function (value) {
	        var formattedValue = Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, value.toString());
	        formattedValue = formattedValue.replace(".", "");
	        value = parseInt(formattedValue);
	        if (value >= Math.pow(10, JackpotCounter.Length)) {
	            var normalizedValue = "";
	            for (var i = 0; i < JackpotCounter.Length; i++) {
	                normalizedValue = "9" + normalizedValue;
	            }
	            return parseInt(normalizedValue);
	        }
	        return value;
	    };
	    JackpotCounter.prototype.formatValue = function (formattedValue, leading) {
	        if (formattedValue.length > JackpotCounter.Length) {
	            formattedValue = formattedValue.substr(formattedValue.length - JackpotCounter.Length);
	        }
	        else {
	            while (formattedValue.length < JackpotCounter.DecimalPlaces + 1) {
	                formattedValue = "0" + formattedValue;
	            }
	            while (formattedValue.length < JackpotCounter.Length) {
	                formattedValue = "" + (leading ? JackpotCounter.LeadingZeroLetter : "0") + formattedValue;
	            }
	        }
	        return formattedValue;
	    };
	    JackpotCounter.prototype.resetMainTween = function () {
	        if (this.mainTween != null) {
	            this.mainTween.kill();
	            this.mainTween.eventCallback("onComplete", null);
	            this.mainTween.eventCallback("onUpdate", null);
	            this.mainTween = null;
	        }
	    };
	    JackpotCounter.prototype.resetDigitTween = function (onlyCallback) {
	        if (onlyCallback === void 0) { onlyCallback = false; }
	        if (this.digitTween != null) {
	            this.digitTween.eventCallback("onComplete", null);
	            if (!onlyCallback) {
	                this.digitTween.kill();
	            }
	            this.digitTween = null;
	        }
	    };
	    JackpotCounter.prototype.resetDigitsToBasePosition = function () {
	        var currentValue = this.formatValue(this.currentCounterValue.toString(), true);
	        for (var i = 0; i < this.digits.length; i++) {
	            this.setDigitValue(this.digits[i].to, currentValue.charAt(i), true);
	            this.digits[i].from.setAttribute("style", "transform: matrix(1, 0, 0, 1, 0, " + this.settings.height * -1 + ");");
	            this.digits[i].to.setAttribute("style", "transform: matrix(1, 0, 0, 1, 0, 0);");
	        }
	    };
	    JackpotCounter.prototype.forceWinValue = function () {
	        var currentValue = this.formatValue(this.lastWinValue.toString(), true);
	        for (var i = 0; i < this.digits.length; i++) {
	            this.setDigitValue(this.digits[i].to, currentValue.charAt(i), true);
	            this.digits[i].from.setAttribute("style", "transform: matrix(1, 0, 0, 1, 0, " + this.settings.height * -1 + ");");
	            this.digits[i].to.setAttribute("style", "transform: matrix(1, 0, 0, 1, 0, 0);");
	        }
	    };
	    JackpotCounter.LeadingZeroLetter = " ";
	    JackpotCounter.WinAnimDuration = 240;
	    JackpotCounter.WinFromMinigameAnimDuration = 540;
	    JackpotCounter.Length = 10;
	    JackpotCounter.DecimalPlaces = 2;
	    JackpotCounter.DigitAnimDuration = 0.1;
	    JackpotCounter.MinResetAnimCount = 15;
	    JackpotCounter.UseThousandsSeparator = true;
	    JackpotCounter.MaxNextTimeDiff = 2 * 60;
	    return JackpotCounter;
	}());
	exports.JackpotCounter = JackpotCounter;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var JackpotData_1 = __webpack_require__(39);
	var Languages_1 = __webpack_require__(28);
	var Jackpot_1 = __webpack_require__(36);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var JackpotHistoryDialog = (function () {
	    function JackpotHistoryDialog(index, holder) {
	        this.root = this.createBaseLayout(index);
	        this.currency = "";
	        this.historyDataElements = {};
	        holder.appendChild(this.root);
	    }
	    JackpotHistoryDialog.prototype.initialize = function (initData) {
	        this.createDataSections();
	        this.initialized = true;
	        if (initData) {
	            this.assign(initData);
	        }
	    };
	    JackpotHistoryDialog.prototype.createBaseLayout = function (index) {
	        return this.createElement("div", "jackpotHistoryDialog _disabled l-" + index);
	    };
	    JackpotHistoryDialog.prototype.createDataSections = function () {
	        if (this.root) {
	            var section = void 0;
	            var dataHolder = void 0;
	            var closeBtn = this.createElement("div", "jackpotCloseBtn", this.root);
	            closeBtn.addEventListener("touchstart", function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	                Jackpot_1.Jackpot.closeAllHistoryDialogs();
	            });
	            closeBtn.addEventListener("click", function () {
	                Jackpot_1.Jackpot.closeAllHistoryDialogs();
	            });
	            section = this.createElement("div", "jackpotHistorySection", this.root);
	            this.createElement("div", "jackpotLevel", section);
	            this.createDataElement("div", "jackpotTitle", JackpotData_1.JackpotData.DataCode, section);
	            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
	            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
	            this.createTextElement("div", "jackpotHistoryDataLabel", Languages_1.Languages.getRid("PB_HISTORYDIALOG_HIGHEST_WIN"), dataHolder);
	            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData_1.JackpotData.DataHighestWinDate, dataHolder);
	            this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData_1.JackpotData.DataHighestWinAmount, section);
	            this.assingData(JackpotData_1.JackpotData.DataHighestWinDate, "-");
	            this.assingData(JackpotData_1.JackpotData.DataHighestWinAmount, Languages_1.Languages.getRid("PB_HISTORYDIALOG_NODATA"));
	            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
	            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
	            this.createTextElement("div", "jackpotHistoryDataLabel", Languages_1.Languages.getRid("PB_HISTORYDIALOG_NUM_WINS"), dataHolder);
	            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData_1.JackpotData.DataWinCount, dataHolder);
	            this.assingData(JackpotData_1.JackpotData.DataWinCount, "-");
	            section = this.createElement("div", "jackpotHistorySection jackpotHistoryData", this.root);
	            dataHolder = this.createElement("div", "jackpotHistoryDataHolder", section);
	            this.createTextElement("div", "jackpotHistoryDataLabel", Languages_1.Languages.getRid("PB_HISTORYDIALOG_LAST_WIN"), dataHolder);
	            this.createDataElement("div", "jackpotHistoryDataValue", JackpotData_1.JackpotData.DataLastWinDate, dataHolder);
	            this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData_1.JackpotData.DataLastWinAmount, section);
	            this.assingData(JackpotData_1.JackpotData.DataLastWinDate, "-");
	            this.assingData(JackpotData_1.JackpotData.DataLastWinAmount, Languages_1.Languages.getRid("PB_HISTORYDIALOG_NODATA"));
	            this.showWins(false);
	        }
	    };
	    JackpotHistoryDialog.prototype.updateDataWithCurrency = function () {
	        if (this.lastData != null) {
	            this.assign(this.lastData);
	        }
	    };
	    JackpotHistoryDialog.prototype.error = function (useResetAnim) {
	        if (useResetAnim === void 0) { useResetAnim = false; }
	        if (useResetAnim) {
	            this.root.classList.add("jackpotExpired");
	        }
	        else {
	            if (this.initialized) {
	                this.showWins(false);
	                this.assingData(JackpotData_1.JackpotData.DataLastWinAmount, Languages_1.Languages.getRid("PB_HISTORYDIALOG_NODATA"));
	                this.assingData(JackpotData_1.JackpotData.DataLastWinDate, "-");
	                this.assingData(JackpotData_1.JackpotData.DataHighestWinAmount, Languages_1.Languages.getRid("PB_HISTORYDIALOG_NODATA"));
	                this.assingData(JackpotData_1.JackpotData.DataHighestWinDate, "-");
	                this.assingData(JackpotData_1.JackpotData.DataWinCount, "-");
	            }
	            else {
	                this.initialize(null);
	            }
	        }
	    };
	    JackpotHistoryDialog.prototype.assign = function (data) {
	        this.lastData = data;
	        if (this.initialized) {
	            this.assingData(JackpotData_1.JackpotData.DataCode, data.code);
	            this.assingData(JackpotData_1.JackpotData.DataLastWinAmount, data.lastWinAmount ? Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, data.lastWinAmount.toString()) : null, "money");
	            this.assingData(JackpotData_1.JackpotData.DataLastWinDate, data.lastWinDate, "date");
	            this.assingData(JackpotData_1.JackpotData.DataHighestWinAmount, data.highestWinAmount
	                ? Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, data.highestWinAmount.toString())
	                : null, "money");
	            this.assingData(JackpotData_1.JackpotData.DataHighestWinDate, data.highestWinDate, "date");
	            this.assingData(JackpotData_1.JackpotData.DataWinCount, data.winCount ? data.winCount.toString() : null);
	            this.showWins();
	        }
	        else {
	            this.initialize(data);
	        }
	    };
	    JackpotHistoryDialog.prototype.assingData = function (dataId, value, format) {
	        if (format === void 0) { format = ""; }
	        if (this.historyDataElements && this.historyDataElements[dataId] && !neo_common_1.StringUtils.isNullOrEmpty(value)) {
	            if (format != "") {
	                switch (format) {
	                    case "money":
	                        value = value + " " + DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	                        break;
	                    case "date":
	                        var date = new Date(value);
	                        value =
	                            this.zerosPad(date.getDate(), 2) +
	                                ". " +
	                                this.zerosPad(date.getMonth() + 1, 2) +
	                                ". " +
	                                date.getFullYear();
	                }
	            }
	            this.historyDataElements[dataId].textContent = value;
	        }
	    };
	    JackpotHistoryDialog.prototype.zerosPad = function (num, size) {
	        var s = num + "";
	        while (s.length < size)
	            s = "0" + s;
	        return s;
	    };
	    JackpotHistoryDialog.prototype.openDialog = function () {
	        this.root.classList.remove("_disabled");
	    };
	    JackpotHistoryDialog.prototype.closeDialog = function () {
	        this.root.classList.add("_disabled");
	    };
	    JackpotHistoryDialog.prototype.isOpen = function () {
	        return !this.root.classList.contains("_disabled");
	    };
	    JackpotHistoryDialog.prototype.getRoot = function () {
	        return this.root;
	    };
	    JackpotHistoryDialog.prototype.showWins = function (enabled) {
	        if (enabled === void 0) { enabled = true; }
	        var winSections = this.root.getElementsByClassName("jackpotHistoryData");
	        for (var i = 0; i < winSections.length; i++) {
	            var elem = winSections[i];
	            elem.style.display = enabled ? "" : "none";
	        }
	        var titleSections = this.root.getElementsByClassName("jackpotTitle");
	        for (var i = 0; i < titleSections.length; i++) {
	            var elem = titleSections[i];
	            elem.style.display = enabled ? (elem.textContent == "" ? "none" : "") : "none";
	        }
	        var noWinSections = this.root.getElementsByClassName("jackpotHistoryNoWins");
	        if (enabled) {
	            for (var i = 0; i < noWinSections.length; i++) {
	                noWinSections[i].parentNode.removeChild(noWinSections[i]);
	            }
	        }
	        else {
	            if (noWinSections.length == 0) {
	                var section = this.createElement("div", "jackpotHistorySection jackpotHistoryNoWins", this.root);
	                this.createDataElement("div", "jackpotHistoryDataValueBig", JackpotData_1.JackpotData.DataNoWins, section);
	                this.assingData(JackpotData_1.JackpotData.DataNoWins, Languages_1.Languages.getRid("PB_HISTORYDIALOG_NODATA"));
	            }
	        }
	    };
	    JackpotHistoryDialog.prototype.createElement = function (tag, className, rootElem) {
	        var elem = document.createElement(tag);
	        elem.setAttribute("class", className);
	        if (rootElem) {
	            rootElem.appendChild(elem);
	        }
	        return elem;
	    };
	    JackpotHistoryDialog.prototype.createTextElement = function (tag, className, text, rootElem) {
	        var elem = this.createElement(tag, className, rootElem);
	        elem.textContent = text;
	        return elem;
	    };
	    JackpotHistoryDialog.prototype.createDataElement = function (tag, className, dataId, rootElem) {
	        var elem = this.createElement(tag, className, rootElem);
	        if (this.historyDataElements) {
	            this.historyDataElements[dataId] = elem;
	        }
	        return elem;
	    };
	    return JackpotHistoryDialog;
	}());
	exports.JackpotHistoryDialog = JackpotHistoryDialog;


/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	var JackpotData = (function () {
	    function JackpotData() {
	    }
	    JackpotData.DataCode = "code";
	    JackpotData.DataHighestWinDate = "highestWinDate";
	    JackpotData.DataHighestWinAmount = "highestWinAmount";
	    JackpotData.DataWinCount = "winCount";
	    JackpotData.DataLastWinDate = "lastWinDate";
	    JackpotData.DataLastWinAmount = "lastWinAmount";
	    JackpotData.DataNoWins = "noWins";
	    return JackpotData;
	}());
	exports.JackpotData = JackpotData;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var gsap_1 = __webpack_require__(17);
	var GsapEffects_1 = __webpack_require__(16);
	var GameManager_1 = __webpack_require__(23);
	var FrameTimer_1 = __webpack_require__(9);
	var CustomEase_1 = __webpack_require__(19);
	var ModuleManager_1 = __webpack_require__(29);
	var Jackpot_1 = __webpack_require__(36);
	var HtmlController_1 = __webpack_require__(31);
	var BalanceManager_1 = __webpack_require__(27);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var StageController_1 = __webpack_require__(6);
	var AppContext_1 = __webpack_require__(5);
	var PlayList_1 = __webpack_require__(33);
	var AmbientBackground_1 = __webpack_require__(41);
	var Languages_1 = __webpack_require__(28);
	var MessageManager_1 = __webpack_require__(42);
	var LimitDialog_1 = __webpack_require__(52);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var JackpotGame = (function () {
	    function JackpotGame(holder) {
	        this.holder = holder;
	        this.root = this.createBaseLayout();
	        this.holder.appendChild(this.root);
	        var intro = this.createAnimations();
	        this.holder.appendChild(intro);
	        this.stopTimer = FrameTimer_1.CreateFrameTimer("MiniGameSpinStop");
	        this.stopTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.spinStop.bind(this));
	        this.buzzerTimer = FrameTimer_1.CreateFrameTimer("BuzzerTimer");
	        this.buzzerTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.buzzerTimeFinished.bind(this));
	        this.showWinDelay = FrameTimer_1.CreateFrameTimer("BuzzerTimer");
	        this.showWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.updateWin.bind(this));
	        this.gameInitialized = false;
	        this.gameStarted = false;
	        this.autostart = false;
	        this.showHandPayDialog = false;
	        this.assetsLoaded = false;
	        this.startAfterLoad = false;
	        CustomEase_1.CustomEase.create("miniGameSpinStopEase", "M0,0,C0,0,0.212,0.616,0.452,0.842,0.519,0.905,0.627,1.008,0.716,1.026,0.768,1.036,0.819,1.031,0.848,1.028,0.89,1.022,1,1,1,1");
	    }
	    JackpotGame.prototype.createBaseLayout = function () {
	        var root = this.createElement("div", "jackpotGame");
	        this.reel = this.createElement("div", "jackpotReel", root);
	        this.createElement("div", "jackpotTextOverlay", root);
	        var hintContainer = this.createElement("div", "jackpotStartHint", root);
	        this.createTextElement("div", "jackpotStartHintText", Languages_1.Languages.getRid("PB_MINIGAME_SPINSTART"), hintContainer);
	        this.createTextElement("div", "jackpotStartHintText", Languages_1.Languages.getRid("PB_MINIGAME_SPINSTART"), hintContainer);
	        this.createElement("div", "jackpotFrameLeft", root);
	        this.createElement("div", "jackpotFrameRight", root);
	        this.createElement("div", "jackpotGlowLeft", root);
	        this.createElement("div", "jackpotGlowRight", root);
	        var arrows = this.createElement("div", "jackpotArrows", root);
	        var arrow = this.createElement("div", "jackpotArrowLeft", arrows);
	        this.createElement("div", "jackpotArrowBlur", arrow);
	        arrow = this.createElement("div", "jackpotArrowRight", arrows);
	        this.createElement("div", "jackpotArrowBlur", arrow);
	        this.createTextElement("div", "jackpotGameName", document.getElementById("gameTitle").innerHTML, root);
	        return root;
	    };
	    JackpotGame.prototype.createAnimations = function () {
	        var intro = this.createElement("div", "jackpotIntro");
	        for (var i = 0; i < 5; i++) {
	            var firework = this.createElement("div", "jackpotFireworks", intro);
	            for (var j = 0; j < 8; j++) {
	                this.createElement("div", "fireworksPart", firework);
	            }
	        }
	        var titles = this.createElement("div", "jackpotTitles", intro);
	        var _self = this;
	        document.body.classList.add("jpt-loading");
	        Promise.all([
	            this.getCustomContent("jackpotTextSynot", ".png"),
	            this.getCustomContent("jackpotTextProgressive", ".png"),
	            this.getCustomContent("jackpotTextBonus", ".png"),
	        ]).then(function (values) {
	            for (var i = 0; i < values.length; i++) {
	                var elem = _self.createElement("div", values[i][0], titles);
	                if (values[i][1] != "") {
	                    elem.style.background = "url(" + values[i][1] + ") no-repeat";
	                }
	            }
	            document.body.classList.remove("jpt-loading");
	            _self.assetsLoaded = true;
	            if (_self.startAfterLoad) {
	                _self.intro();
	            }
	        });
	        this.createElement("div", "jackpotTextOverlay", intro);
	        this.winContainer = this.createElement("div", "jackpotWinValue", intro);
	        return intro;
	    };
	    JackpotGame.prototype.init = function (autostart, callback) {
	        if (this.ticket == null && GameManager_1.GameManager.gameResponse && GameManager_1.GameManager.gameResponse["progressiveBonus"].ticket) {
	            this.ticket = GameManager_1.GameManager.gameResponse["progressiveBonus"].ticket;
	            this.gameInitialized = false;
	            this.autostart = autostart;
	            this.callback = callback;
	            this.initSymbols();
	            this.createSymbols();
	            this.sendInitBonusGameRequest();
	        }
	    };
	    JackpotGame.prototype.initFinished = function () {
	        this.gameInitialized = true;
	        if (this.autostart) {
	            if (this.callback != null) {
	                this.callback();
	            }
	            this.intro();
	        }
	    };
	    JackpotGame.prototype.start = function () {
	        if (!this.autostart) {
	            this.intro();
	        }
	    };
	    JackpotGame.prototype.startGame = function () {
	        if (this.spinBtn && this.spinBtn.classList.contains("_disabled")) {
	            return;
	        }
	        HtmlController_1.HtmlController.dispatchAction("");
	        Jackpot_1.Jackpot.refreshBonusInfoBeforeSpin(this.sendSpinBonusGameRequest.bind(this));
	        this.spinStart();
	    };
	    JackpotGame.prototype.spinStop = function (fromMachine, fromServer) {
	        if (fromMachine === void 0) { fromMachine = true; }
	        if (fromServer === void 0) { fromServer = false; }
	        if (fromMachine) {
	            this.stoppedFromMachine = true;
	        }
	        if (fromServer) {
	            this.stoppedFromServer = true;
	        }
	        if (this.stoppedFromMachine && this.stoppedFromServer) {
	            this.isStopping = true;
	        }
	    };
	    JackpotGame.prototype.closeMiniGame = function () {
	        if (this.callback != null && this.autostart) {
	            this.callback();
	        }
	        this.outroFinished(false);
	    };
	    JackpotGame.prototype.setBaseGameSound = function (enable) {
	        ModuleManager_1.ModuleManager.toggleModuleSounds(GameModules.Base, enable);
	    };
	    JackpotGame.prototype.hasInitializedGame = function () {
	        return this.gameInitialized;
	    };
	    JackpotGame.prototype.hasStartedGame = function () {
	        return this.gameStarted;
	    };
	    JackpotGame.prototype.disableAutostart = function () {
	        this.autostart = false;
	        this.clearJackpotGameResponse();
	    };
	    JackpotGame.prototype.clearJackpotGame = function () {
	        if (this.holder) {
	            this.holder.classList.remove("outro");
	            this.holder.classList.add("_hidden");
	            this.holder.className = "jackpotGameHolder _hidden";
	        }
	        if (this.root) {
	            this.root.removeEventListener("webkitAnimationEnd", this.lastEvent);
	            this.root.removeEventListener("animationend", this.lastEvent);
	        }
	        if (this.reel) {
	            this.reel.innerHTML = "";
	            this.currentOffset = 0;
	            this.setTransformY(this.reel, this.currentOffset);
	            this.currentSymbols = [];
	            this.currentSymbolsHeight = [];
	        }
	        if (this.winContainer) {
	            this.winContainer.style.transform = "scale(0)";
	            this.winContainer.innerHTML = "";
	            this.winContainer.removeEventListener("webkitAnimationEnd", this.lastEvent);
	            this.winContainer.removeEventListener("animationend", this.lastEvent);
	        }
	        this.ticket = null;
	    };
	    JackpotGame.prototype.clearJackpotGameResponse = function () {
	        if (GameManager_1.GameManager.gameResponse["progressiveBonus"]) {
	            GameManager_1.GameManager.gameResponse["progressiveBonus"] = null;
	        }
	    };
	    JackpotGame.prototype.sendInitBonusGameRequest = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient
	                .sendMaxPowerBonusInitRequest(this.ticket)
	                .then(function (response) {
	                if (response != null && response.status == "Active") {
	                    _this.initFinished();
	                }
	                else {
	                    _this.closeMiniGame();
	                }
	            });
	        }
	    };
	    JackpotGame.prototype.sendSpinBonusGameRequest = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.gameClient) {
	            GameManager_1.GameManager.gameClient
	                .sendMaxPowerBonusSpinRequest(this.ticket)
	                .then(function (response) {
	                _this.setGameData(response);
	            });
	        }
	    };
	    JackpotGame.prototype.setGameData = function (response) {
	        if (response != null) {
	            this.gameData = response;
	            this.spinStop(false, true);
	            if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration.GameRoundIdVisible) {
	                HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataRoundId, this.ticket.id);
	            }
	        }
	        else {
	            Jackpot_1.Jackpot.showError();
	        }
	    };
	    JackpotGame.prototype.intro = function () {
	        var _this = this;
	        if (!this.assetsLoaded) {
	            this.startAfterLoad = true;
	            return;
	        }
	        if (!this.gameStarted) {
	            this.gameStarted = true;
	            PlayList_1.PlayList.loop("SND_JackpotBuzzer");
	            this.bounceCounters(true);
	            this.buzzerTimer.stop();
	            this.buzzerTimer.start(JackpotGame.BuzzerDuration);
	            setTimeout(function () {
	                _this.setBaseGameSound(false);
	            }, 1);
	        }
	    };
	    JackpotGame.prototype.buzzerTimeFinished = function () {
	        this.buzzerTimer.stop();
	        this.bounceCounters(false);
	        PlayList_1.PlayList.stop("SND_JackpotBuzzer");
	        LimitDialog_1.LimitDialog.closeDialog();
	        DataManager_1.DataManager.GameLimit = false;
	        if (this.holder) {
	            this.lastEvent = this.introFinished.bind(this);
	            this.root.addEventListener("webkitAnimationEnd", this.lastEvent);
	            this.root.addEventListener("animationend", this.lastEvent);
	            AmbientBackground_1.AmbientBackground.changeAmbientBackground("jackpotBg", 1000, 5500);
	            PlayList_1.PlayList.play("SND_JackpotIntroHit");
	            PlayList_1.PlayList.loop("SND_JackpotIntroWaitingLoop", 360);
	            this.holder.classList.remove("_hidden");
	            void this.holder.offsetWidth;
	            this.holder.classList.add("start");
	        }
	    };
	    JackpotGame.prototype.introFinished = function () {
	        if (this.holder) {
	            this.root.removeEventListener("webkitAnimationEnd", this.lastEvent);
	            this.root.removeEventListener("animationend", this.lastEvent);
	            PlayList_1.PlayList.stop("SND_JackpotIntroHit");
	            this.holder.classList.add("startFinished");
	            document.body.classList.add("spbStartFinished");
	            this.setStageVisibility(false);
	            this.createSpinBtn();
	        }
	    };
	    JackpotGame.prototype.outro = function () {
	        this.setStageVisibility(true);
	        this.holder.classList.remove("spin");
	        void this.holder.offsetWidth;
	        this.holder.classList.add("outro");
	        AmbientBackground_1.AmbientBackground.changeAmbientBackground("base", 2000, 8000);
	        this.lastEvent = this.outroFinished.bind(this);
	        this.winContainer.addEventListener("webkitAnimationEnd", this.lastEvent);
	        this.winContainer.addEventListener("animationend", this.lastEvent);
	    };
	    JackpotGame.prototype.outroFinished = function (collect) {
	        if (collect === void 0) { collect = true; }
	        if (collect) {
	            this.updateBalance();
	        }
	        this.clearJackpotGame();
	        this.clearJackpotGameResponse();
	        this.setBaseGameSound(true);
	        BalanceManager_1.BalanceManager.refreshBalance();
	        if (this.showHandPayDialog) {
	            this.openHandPayDialog();
	        }
	        else {
	            this.restoreGameRound(collect);
	        }
	        this.autostart = false;
	    };
	    JackpotGame.prototype.updateBalance = function () {
	        if (this.gameData != null) {
	            if (this.gameData.balance != null) {
	                this.showHandPayDialog = false;
	                BalanceManager_1.BalanceManager.balanceReceived(this.gameData.balance);
	                PlayList_1.PlayList.play("SND_BaseCollect");
	                if (this.gameData.game != null && this.gameData.game.win != null) {
	                    DataManager_1.DataManager.updateTotalGain(false, this.gameData.game.win.amount);
	                }
	                if (AppContext_1.AppContext != null && !AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	                    this.updateWin(false, "0");
	                }
	            }
	            else {
	                this.showHandPayDialog = true;
	            }
	        }
	    };
	    JackpotGame.prototype.restoreGameRound = function (collect) {
	        if (collect === void 0) { collect = true; }
	        this.gameInitialized = false;
	        this.gameStarted = false;
	        this.showHandPayDialog = false;
	        ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base, collect);
	    };
	    JackpotGame.prototype.openHandPayDialog = function () {
	        var response = {
	            messages: [
	                {
	                    text: Languages_1.Languages.getRid("HANDPAY_DIALOG", Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, this.gameData.game.win.amount.toString()) +
	                        " " +
	                        DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency)),
	                },
	            ],
	        };
	        MessageManager_1.MessageManager.postpone(this.restoreGameRound.bind(this), response);
	    };
	    JackpotGame.prototype.initSymbols = function () {
	        if (this.reel) {
	            this.currentSymbols = [];
	            this.currentSymbolsHeight = [];
	            this.stripIndex = (JackpotGame.Strip.indexOf(4) + 2 + JackpotGame.Strip.length) % JackpotGame.Strip.length;
	            if (!this.rootHeight) {
	                this.rootHeight = this.getElementHeight(this.root);
	            }
	            var symbolId = void 0;
	            this.symbolsHeight = [];
	            for (var i = 0; i < JackpotGame.SymbolsCount; i++) {
	                symbolId = i + 1;
	                var symbol = this.createElement("div", "jackpotSymbol l-" + symbolId, this.reel);
	                this.symbolsHeight.push(this.getElementHeight(symbol));
	                this.reel.removeChild(symbol);
	            }
	        }
	    };
	    JackpotGame.prototype.createSymbols = function () {
	        if (this.reel) {
	            var symbolId = void 0;
	            for (var i = 0; i < JackpotGame.SpinPreRollSymbolCount; i++) {
	                this.stripIndex = (this.stripIndex - 1 + JackpotGame.Strip.length) % JackpotGame.Strip.length;
	                symbolId = JackpotGame.Strip[this.stripIndex];
	                this.addSymbolToReel(symbolId, false, i > 3);
	            }
	            this.currentOffset = this.getReelOffset(this.currentSymbols.length - 2);
	            this.setTransformY(this.reel, this.currentOffset);
	        }
	    };
	    JackpotGame.prototype.updateSymbols = function () {
	        while (this.currentSymbols.length > 3) {
	            this.currentSymbolsHeight.pop();
	            var symbol = this.currentSymbols.pop();
	            this.reel.removeChild(symbol);
	        }
	        if (this.isStopping) {
	            this.updatePostRollSymbols();
	        }
	        else {
	            this.stripIndex = (this.stripIndex - 1 + JackpotGame.Strip.length) % JackpotGame.Strip.length;
	            var symbolId = JackpotGame.Strip[this.stripIndex];
	            this.addSymbolToReel(symbolId, false, true);
	            this.currentOffset = this.getReelOffset(this.currentSymbols.length - 2);
	            this.setTransformY(this.reel, this.currentOffset);
	            this.spinRoll();
	        }
	    };
	    JackpotGame.prototype.updatePostRollSymbols = function () {
	        if (this.gameData != null) {
	            var winSymbolId = this.gameData.game.symbols[JackpotGame.MiddleSymbolIndex];
	            var finishStripIndex = Math.floor(Math.random() * JackpotGame.Strip.length);
	            while (JackpotGame.Strip[finishStripIndex] != winSymbolId) {
	                finishStripIndex = (finishStripIndex - 1 + JackpotGame.Strip.length) % JackpotGame.Strip.length;
	            }
	            this.stripIndex =
	                (finishStripIndex + (JackpotGame.SpinPostRollSymbolCount - 2) + JackpotGame.Strip.length) %
	                    JackpotGame.Strip.length;
	            for (var i = 0; i < JackpotGame.SpinPostRollSymbolCount; i++) {
	                this.stripIndex = (this.stripIndex - 1 + JackpotGame.Strip.length) % JackpotGame.Strip.length;
	                var symbolId = JackpotGame.Strip[this.stripIndex];
	                this.addSymbolToReel(symbolId, i == JackpotGame.SpinPostRollSymbolCount - 3, i < 8);
	            }
	            this.currentOffset = this.getReelOffset(this.currentSymbols.length - 2);
	            this.setTransformY(this.reel, this.currentOffset);
	            this.spinPostRoll();
	        }
	    };
	    JackpotGame.prototype.removeOffScreenSymbols = function () {
	        while (this.currentSymbols.length > 4) {
	            this.currentSymbolsHeight.pop();
	            var symbol = this.currentSymbols.pop();
	            this.reel.removeChild(symbol);
	        }
	    };
	    JackpotGame.prototype.spinStart = function () {
	        if (this.spinBtn) {
	            this.spinBtn.parentElement.removeChild(this.spinBtn);
	        }
	        document.removeEventListener("keyup", this.lastEvent);
	        this.updateWin(false, "0");
	        PlayList_1.PlayList.stop("SND_JackpotIntroWaitingLoop");
	        PlayList_1.PlayList.play("SND_JackpotStartHit");
	        PlayList_1.PlayList.play("SND_JackpotWheelMusic");
	        this.stoppedFromMachine = false;
	        this.stoppedFromServer = false;
	        if (this.holder) {
	            this.holder.classList.remove("start");
	            this.holder.classList.remove("startFinished");
	            document.body.classList.remove("spbStartFinished");
	            this.holder.classList.add("spin");
	        }
	        this.isStopping = false;
	        this.stopTimer.start(JackpotGame.MinSpinDuration);
	        this.spinPreRoll();
	    };
	    JackpotGame.prototype.spinPreRoll = function () {
	        var nextOffset = this.getReelOffset(1);
	        this.symbolStepOffsets = this.getSymbolStepOffsets(1);
	        this.animate(this.currentOffset, nextOffset, this.updateSymbols, JackpotGame.SpinPreRollDuration, "Power2.easeIn", 0, this.onSpinPostRollUpdate);
	    };
	    JackpotGame.prototype.spinRoll = function () {
	        var nextOffset = this.getReelOffset(1);
	        var duration = this.getSpinRollDuration(nextOffset);
	        this.symbolStepOffsets = this.getSymbolStepOffsets(1);
	        this.animate(this.currentOffset, nextOffset, this.updateSymbols, duration, "linear", 0, this.onSpinPostRollUpdate);
	    };
	    JackpotGame.prototype.spinPostRoll = function () {
	        Jackpot_1.Jackpot.refreshBonusInfoInMiniGame(this.createLevelDataOverride(false));
	        var nextOffset = this.getReelOffset(2);
	        this.symbolStepOffsets = this.getSymbolStepOffsets(2);
	        this.animate(this.currentOffset, nextOffset, this.spinComplete, JackpotGame.SpinPostRollDuration, "miniGameSpinStopEase", 0, this.onSpinPostRollUpdate);
	    };
	    JackpotGame.prototype.onSpinPostRollUpdate = function (tween) {
	        if (this.symbolStepOffsets.length > 0) {
	            if (tween.target._gsTransform.y > this.symbolStepOffsets[0]) {
	                PlayList_1.PlayList.play("SND_JackpotWheelClick1");
	                if (this.holder) {
	                    this.holder.classList.remove("hit");
	                    this.holder.offsetWidth;
	                    this.holder.classList.add("hit");
	                }
	                this.symbolStepOffsets.shift();
	            }
	        }
	    };
	    JackpotGame.prototype.spinComplete = function () {
	        HtmlController_1.HtmlController.dispatchAction("");
	        if (this.gameData != null) {
	            this.showWinDelay.start(135);
	            if (this.gameData.game.limit) {
	                LimitDialog_1.LimitDialog.openDialog();
	            }
	        }
	        this.removeOffScreenSymbols();
	        Jackpot_1.Jackpot.refreshBonusInfoWithWinValue(this.createLevelDataOverride(true));
	        var isHigh = this.createWinValue();
	        PlayList_1.PlayList.stop("SND_JackpotWheelMusic", 30);
	        PlayList_1.PlayList.play("SND_JackpotWinMusic");
	        this.outro();
	    };
	    JackpotGame.prototype.updateWin = function (collected, value) {
	        if (value === void 0) { value = ""; }
	        this.showWinDelay.stop();
	        var uncollectedWin = document.getElementById("uncollectedWin");
	        var collectedWin = document.getElementById("collectedWin");
	        if (uncollectedWin != null && collectedWin != null) {
	            if (!neo_common_1.StringUtils.isNullOrEmpty(value)) {
	                HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataTotalWin, value);
	            }
	            else {
	                HtmlController_1.HtmlController.updateDataElement(GameData_1.GameData.DataTotalWin, this.gameData.game.win.amount.toString());
	            }
	            if (collected) {
	                uncollectedWin.classList.add("_hidden");
	                collectedWin.classList.remove("_hidden");
	            }
	            else {
	                uncollectedWin.classList.remove("_hidden");
	                collectedWin.classList.add("_hidden");
	            }
	        }
	    };
	    JackpotGame.prototype.animate = function (currentOffset, newOffset, callback, duration, ease, delay, updateCallback) {
	        if (ease === void 0) { ease = "linear"; }
	        if (delay === void 0) { delay = 0; }
	        if (updateCallback === void 0) { updateCallback = null; }
	        duration = duration * GsapEffects_1.GsapEffects.TickTime;
	        delay = delay * GsapEffects_1.GsapEffects.TickTime;
	        gsap_1.TweenMax.killTweensOf(this.reel);
	        var tween = gsap_1.TweenMax.fromTo(this.reel, duration, { y: currentOffset, roundProps: "y" }, { y: newOffset, ease: ease, delay: delay, roundProps: "y" });
	        this.currentOffset = newOffset;
	        if (!neo_common_1.Utils.isNullOrUndefined(callback)) {
	            tween.eventCallback("onComplete", callback, [], this);
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(updateCallback)) {
	            tween.eventCallback("onUpdate", updateCallback, ["{self}"], this);
	        }
	    };
	    JackpotGame.prototype.createWinValue = function () {
	        if (this.gameData != null) {
	            var winValue = Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, this.gameData.game.win.amount.toString());
	            if (this.winContainer) {
	                var childs = this.winContainer.children;
	                for (var i = 0; i < winValue.length; i++) {
	                    if (!childs[i]) {
	                        this.createElement("div", "n" + winValue.charCodeAt(i).toString(), this.winContainer);
	                    }
	                    else {
	                        childs[i].className = "n" + winValue.charCodeAt(i).toString();
	                    }
	                }
	            }
	            return this.gameData.game.win.level == "Gold" || this.gameData.game.win.level == "Diamond";
	        }
	        return false;
	    };
	    JackpotGame.prototype.getRoot = function () {
	        return this.root;
	    };
	    JackpotGame.prototype.getElementHeight = function (elem) {
	        return parseInt(window.getComputedStyle(elem).height);
	    };
	    JackpotGame.prototype.getSpinRollDuration = function (newOffset) {
	        var diff = Math.abs(this.currentOffset - newOffset);
	        return Math.round((diff / this.symbolsHeight[0]) * JackpotGame.SpinRollSpeed);
	    };
	    JackpotGame.prototype.getReelOffset = function (middleSymbolIndex) {
	        var offset = Math.round(this.rootHeight * 0.5);
	        if (this.currentSymbols.length > 0) {
	            for (var i = 0; i < middleSymbolIndex; i++) {
	                offset -= this.currentSymbolsHeight[i];
	            }
	            offset -= Math.round(this.currentSymbolsHeight[middleSymbolIndex] * 0.5);
	        }
	        return offset;
	    };
	    JackpotGame.prototype.getSymbolStepOffsets = function (middleSymbolIndex) {
	        var offset = this.currentOffset;
	        var result = [];
	        if (this.currentSymbols.length > 2) {
	            offset += this.currentSymbolsHeight[this.currentSymbols.length - 2] * 0.5;
	            result.push(offset);
	            for (var i = this.currentSymbolsHeight.length - 3; i > middleSymbolIndex; i--) {
	                offset += this.currentSymbolsHeight[i + (1 - middleSymbolIndex)];
	                result.push(offset);
	            }
	        }
	        return result;
	    };
	    JackpotGame.prototype.createElement = function (tag, className, rootElem, appendBefore) {
	        if (appendBefore === void 0) { appendBefore = null; }
	        var elem = document.createElement(tag);
	        elem.setAttribute("class", className);
	        if (rootElem != null) {
	            if (appendBefore != null) {
	                rootElem.insertBefore(elem, appendBefore);
	            }
	            else {
	                rootElem.appendChild(elem);
	            }
	        }
	        return elem;
	    };
	    JackpotGame.prototype.createSymbol = function (tag, className, rootElem, appendBefore) {
	        if (appendBefore === void 0) { appendBefore = null; }
	        var elem = document.createElement(tag);
	        elem.setAttribute("class", className);
	        var symbolHolder = document.createElement(tag);
	        symbolHolder.className = "jackpotSymbolHolder";
	        elem.appendChild(symbolHolder);
	        if (rootElem != null) {
	            if (appendBefore != null) {
	                rootElem.insertBefore(elem, appendBefore);
	            }
	            else {
	                rootElem.appendChild(elem);
	            }
	        }
	        return elem;
	    };
	    JackpotGame.prototype.createTextElement = function (tag, className, text, rootElem) {
	        var elem = this.createElement(tag, className, rootElem);
	        elem.innerHTML = text;
	        return elem;
	    };
	    JackpotGame.prototype.createSpinBtn = function () {
	        var userControls = document.getElementById("userControls");
	        if (userControls) {
	            var spinBtn = userControls.getElementsByClassName("spinBtn")[0];
	            if (spinBtn) {
	                var parent_1 = spinBtn.parentElement;
	                this.spinBtn = this.createElement("div", "btn spinBtn", parent_1);
	                this.spinBtn.id = "jackpotSpinBtn";
	                this.spinBtn.innerHTML = spinBtn.innerHTML;
	                this.spinBtn.addEventListener("click", this.startGame.bind(this));
	                this.lastEvent = this.handleSpaceStart.bind(this);
	                document.addEventListener("keyup", this.lastEvent);
	            }
	        }
	    };
	    JackpotGame.prototype.createLevelDataOverride = function (winData) {
	        var result = {};
	        if (this.gameData != null) {
	            result.code = this.gameData.game.win.level;
	            if (winData) {
	                result.lastWinAmount = this.gameData.game.win.amount;
	            }
	            else {
	                result.nextValue = this.gameData.game.win.amount;
	                result.nextTimestamp = new Date(new Date().getTime() + 8000).toISOString();
	                result.previousValue = this.gameData.game.win.amount;
	            }
	        }
	        return result;
	    };
	    JackpotGame.prototype.setTransformY = function (elem, y) {
	        elem.style.transform = "translate3d(0, " + y + "px, 0)";
	    };
	    JackpotGame.prototype.setStageVisibility = function (visible) {
	        if (StageController_1.StageController.Renderer != null && StageController_1.StageController.Renderer._lastObjectRendered) {
	            StageController_1.StageController.Renderer._lastObjectRendered.visible = visible;
	        }
	    };
	    JackpotGame.prototype.handleSpaceStart = function (event) {
	        if (event.keyCode == 32) {
	            this.startGame();
	        }
	    };
	    JackpotGame.prototype.addSymbolToReel = function (symbolId, winSymbol, blured) {
	        if (winSymbol === void 0) { winSymbol = false; }
	        if (blured === void 0) { blured = false; }
	        var className = "jackpotSymbol l-" + symbolId;
	        if (winSymbol) {
	            className += " jackpotWinSymbol";
	            this.holder.classList.add("win-" + symbolId);
	        }
	        if (blured) {
	            className += " blur";
	        }
	        var symbol = this.createSymbol("div", className, this.reel, this.currentSymbols[0]);
	        this.currentSymbols.unshift(symbol);
	        this.currentSymbolsHeight.unshift(this.symbolsHeight[symbolId - 1]);
	    };
	    JackpotGame.prototype.bounceCounters = function (enable) {
	        var countersHolder = document.getElementById("jackpotCounters");
	        var countersLogo = document.getElementById("jackpotLogo");
	        if (countersHolder != null && countersLogo != null) {
	            if (enable) {
	                countersHolder.classList.add("jackpotBounce");
	                countersLogo.classList.add("jackpotBounce");
	            }
	            else {
	                countersHolder.classList.remove("jackpotBounce");
	                countersLogo.classList.remove("jackpotBounce");
	            }
	        }
	    };
	    JackpotGame.prototype.getCustomContent = function (name, extension) {
	        return new Promise(function (resolve, reject) {
	            if (AppContext_1.AppContext.gameConfiguration == null) {
	                resolve([name, ""]);
	                return;
	            }
	            if (AppContext_1.AppContext.gameConfiguration.StaticContentUrl == "") {
	                resolve([name, ""]);
	                return;
	            }
	            var theme = AppContext_1.AppContext.gameConfiguration.ProgressiveBonusTheme;
	            if (theme == "") {
	                if (AppContext_1.AppContext.gameConfiguration.UseJackpotLocalization) {
	                    theme = Jackpot_1.Jackpot.JackpotTheme;
	                }
	                else {
	                    resolve([name, ""]);
	                    return;
	                }
	            }
	            var staticContentUrl = AppContext_1.AppContext.gameConfiguration.StaticContentUrl;
	            var spbFolder = "SynotProgressiveBonus";
	            var url = "" + staticContentUrl + spbFolder + "/" + theme + "/" + window["QUALITY"] + "/" + name + extension;
	            var img = document.createElement("img");
	            img.setAttribute("src", url);
	            img.addEventListener("load", function (ev) {
	                resolve([name, url]);
	            });
	            img.addEventListener("error", function (ev) {
	                resolve([name, ""]);
	            });
	        });
	    };
	    JackpotGame.Strip = [
	        1, 1, 1, 1, 2, 1, 1, 3, 1, 1, 1, 2, 2, 1, 1, 1, 1, 1, 2, 1, 4, 1, 2, 1, 1, 2, 1, 3, 1, 1, 2, 1, 1, 1, 2, 1, 1,
	        1, 1, 3, 1, 1, 1, 2, 1, 2, 1, 1, 1, 1, 4,
	    ];
	    JackpotGame.SymbolsCount = 4;
	    JackpotGame.BuzzerDuration = 180;
	    JackpotGame.SpinRollSpeed = 8;
	    JackpotGame.MinSpinDuration = 360;
	    JackpotGame.MiddleSymbolIndex = 1;
	    JackpotGame.SpinPreRollDuration = 120;
	    JackpotGame.SpinPreRollSymbolCount = 8;
	    JackpotGame.SpinPostRollDuration = 360;
	    JackpotGame.SpinPostRollSymbolCount = 12;
	    return JackpotGame;
	}());
	exports.JackpotGame = JackpotGame;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var AmbientBackground = (function () {
	    function AmbientBackground() {
	    }
	    AmbientBackground.changeAmbientBackground = function (newBackgroundName, duration, delay) {
	        if (duration === void 0) { duration = 200; }
	        if (delay === void 0) { delay = 0; }
	        var base = document.getElementById("ambientBackgroundBase");
	        var transition = document.getElementById("ambientBackgroundTransition");
	        if (base && transition) {
	            if (!transition.classList.contains(newBackgroundName)) {
	                transition.classList.remove("show");
	                base.className = transition.className;
	                transition.style.transitionDuration = duration + "ms";
	                transition.style.transitionDelay = delay + "ms";
	                transition.className = "";
	                transition.offsetWidth;
	                transition.classList.add(newBackgroundName, "show");
	            }
	        }
	    };
	    AmbientBackground.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Scaling", s);
	        }
	    };
	    return AmbientBackground;
	}());
	exports.AmbientBackground = AmbientBackground;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var PlayList_1 = __webpack_require__(33);
	var Languages_1 = __webpack_require__(28);
	var GameApp_1 = __webpack_require__(1);
	var GameManager_1 = __webpack_require__(23);
	var AppContext_1 = __webpack_require__(5);
	var BaseModel_1 = __webpack_require__(43);
	var MessageManager = (function () {
	    function MessageManager() {
	    }
	    MessageManager.postpone = function (callback, response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response) &&
	            !neo_common_1.Utils.isNullOrUndefined(response.messages) &&
	            response.messages.length > 0) {
	            if (neo_common_1.Utils.isNullOrUndefined(MessageManager.dialog)) {
	                MessageManager.dialog = document.getElementById("messageDialog");
	                if (!neo_common_1.Utils.isNullOrUndefined(MessageManager.dialog)) {
	                    MessageManager.title = MessageManager.dialog.getElementsByTagName("h3")[0];
	                    MessageManager.text = document.getElementById("messageDialogText");
	                    MessageManager.buttonsHolder = document.getElementById("messageDialogButtons");
	                    MessageManager.buttons = [];
	                }
	            }
	            if (neo_common_1.Utils.isNullOrUndefined(MessageManager.dialog)) {
	                callback(response);
	            }
	            else {
	                MessageManager.callback = callback;
	                MessageManager.response = response;
	                MessageManager.step = 0;
	                MessageManager.handle();
	            }
	        }
	        else {
	            callback(response);
	        }
	    };
	    MessageManager.updateDialogData = function (data) {
	        MessageManager.resetDialogData();
	        if (!neo_common_1.Utils.isNullOrUndefined(data["title"])) {
	            MessageManager.title.innerHTML = data["title"];
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(data["text"])) {
	            MessageManager.text.innerHTML = data["text"];
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(data["actions"])) {
	            MessageManager.removeAllButtons();
	            for (var i = 0; i < data["actions"].length; i++) {
	                var action = data["actions"][i];
	                switch (action.type) {
	                    case "continue":
	                        MessageManager.createButton(action["text"], MessageManager.actionContinue.bind(this, action));
	                        break;
	                    case "exit":
	                        MessageManager.createButton(action["text"], MessageManager.actionExit.bind(this, action));
	                        break;
	                    case "history":
	                        MessageManager.createButton(action["text"], MessageManager.actionHistory.bind(this, action));
	                        break;
	                    case "reload":
	                        MessageManager.createButton(action["text"], MessageManager.actionReload.bind(this, action));
	                        break;
	                    case "cashier":
	                        MessageManager.createButton(action["text"], MessageManager.actionCashier.bind(this, action));
	                        break;
	                    case "link":
	                        MessageManager.createButton(action["text"], MessageManager.actionLink.bind(this, action));
	                        break;
	                }
	            }
	        }
	    };
	    MessageManager.resetDialogData = function () {
	        MessageManager.title.innerHTML = Languages_1.Languages.getRid("DLG_INFO");
	        MessageManager.removeAllButtons();
	        MessageManager.createButton(Languages_1.Languages.getRid("CONTINUE"), MessageManager.actionContinue);
	    };
	    MessageManager.removeAllButtons = function () {
	        while (MessageManager.buttons.length > 0) {
	            var button = MessageManager.buttons.pop();
	            MessageManager.buttonsHolder.removeChild(button);
	        }
	    };
	    MessageManager.createButton = function (text, action) {
	        var button = document.createElement("div");
	        button.textContent = text;
	        button.classList.add("dialogBtn", "customDialogBtn");
	        button.onclick = action;
	        MessageManager.buttonsHolder.appendChild(button);
	        MessageManager.buttons.push(button);
	    };
	    MessageManager.actionContinue = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        MessageManager.handle();
	    };
	    MessageManager.actionExit = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        neo_games_1.Platforms.Platforms.exitHandler = "messageDialog";
	        GameApp_1.GameApp.exit();
	    };
	    MessageManager.actionReload = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        neo_games_1.Platforms.Platforms.gameReloading();
	        if (neo_games_1.Platforms.Platforms.handleGameReload) {
	            return;
	        }
	        window.location.reload(true);
	    };
	    MessageManager.actionHistory = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        if (!neo_common_1.Utils.isNullOrUndefined(data["linkUrl"])) {
	            neo_games_1.Platforms.Platforms.gotoHistory({ target: data["linkUrl"] });
	            if (neo_games_1.Platforms.Platforms.handleOpenHistoryPage) {
	                return;
	            }
	            window.open(data["linkUrl"], !neo_common_1.Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_blank");
	        }
	        else if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.HistoryUrl)) {
	            GameApp_1.GameApp.openGameRoundHistoryFromUrl();
	        }
	        else if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	            GameApp_1.GameApp.openGameRoundHistoryFromUrl();
	        }
	        else {
	            GameApp_1.GameApp.openGameRoundHistory();
	        }
	    };
	    MessageManager.actionCashier = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        if (!neo_common_1.Utils.isNullOrUndefined(data["linkUrl"])) {
	            neo_games_1.Platforms.Platforms.gotoCasier({ reason: "InsufficientFunds", target: data["linkUrl"] });
	            if (neo_games_1.Platforms.Platforms.handleOpenCashierPage) {
	                return;
	            }
	            window.open(data["linkUrl"], !neo_common_1.Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_self");
	        }
	        else if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.CashierUrl)) {
	            neo_games_1.Platforms.Platforms.gotoCasier({
	                reason: "InsufficientFunds",
	                target: AppContext_1.AppContext.gameConfiguration.CashierUrl,
	            });
	            if (neo_games_1.Platforms.Platforms.handleOpenCashierPage) {
	                return;
	            }
	            window.open(AppContext_1.AppContext.gameConfiguration.CashierUrl, "_self");
	        }
	    };
	    MessageManager.actionLink = function (data) {
	        PlayList_1.PlayList.play("SND_Click");
	        if (!neo_common_1.Utils.isNullOrUndefined(data["linkUrl"])) {
	            window.open(data["linkUrl"], !neo_common_1.Utils.isNullOrUndefined(data["linkTarget"]) ? data["linkTarget"] : "_blank");
	        }
	    };
	    MessageManager.handle = function () {
	        if (MessageManager.response.messages.length === MessageManager.step) {
	            MessageManager.dialog.classList.add("_disabled");
	            MessageManager.callback(MessageManager.response);
	            neo_games_1.Platforms.Platforms.dialogOpened("default", false);
	        }
	        else {
	            if (MessageManager.response.messages[MessageManager.step].type == "plugin") {
	                neo_games_1.Platforms.Platforms.sendPluginMessage(MessageManager.response.messages[MessageManager.step].text);
	                MessageManager.step++;
	                MessageManager.handle();
	            }
	            else {
	                MessageManager.dialog.classList.remove("_disabled");
	                MessageManager.updateDialogData(MessageManager.response.messages[MessageManager.step]);
	                MessageManager.step++;
	                neo_games_1.Platforms.Platforms.dialogOpened("default", true);
	            }
	        }
	    };
	    MessageManager.callbackFnc = function (response) {
	        BaseModel_1.BaseModel.spinContinue();
	    };
	    MessageManager.softResetCallbackFnc = function (response) {
	        GameManager_1.GameManager.softInit(true);
	    };
	    return MessageManager;
	}());
	exports.MessageManager = MessageManager;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var BetManager_1 = __webpack_require__(25);
	var DataManager_1 = __webpack_require__(26);
	var GameManager_1 = __webpack_require__(23);
	var MessageManager_1 = __webpack_require__(42);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var BaseActions_1 = __webpack_require__(35);
	var BuyFeature_1 = __webpack_require__(30);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var BaseModel = (function () {
	    function BaseModel(controller) {
	        this.controller = controller;
	    }
	    BaseModel.prototype.spin = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.dialogType !== null && FreeRoundBonus_1.FreeRoundBonus.dialogType == FreeRoundBonusDialog_1.DialogType.FFR && FreeRoundBonus_1.FreeRoundBonus.status == "active") {
	            this.buyFeature();
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        BaseModel.GameRequest = {};
	        BaseModel.GameRequest.module = neo_games_1.Communication.Game.GameModules.Base;
	        BaseModel.GameRequest.bet = BetManager_1.BetManager.createBetForSpin();
	        BaseModel.GameRequest.callBackFcn = this.spinReceived.bind(this);
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient
	            .spin(neo_games_1.Communication.Game.GameModules.Base, BetManager_1.BetManager.createBetForSpin())
	            .then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.spinReceived.bind(_this), response);
	        });
	    };
	    BaseModel.spinContinue = function () {
	        if (!GameManager_1.GameManager.requestSend && BaseModel.GameRequest) {
	            GameManager_1.GameManager.requestSend = true;
	            GameManager_1.GameManager.gameClient
	                .spin(BaseModel.GameRequest.module, BaseModel.GameRequest.bet)
	                .then(function (response) {
	                MessageManager_1.MessageManager.postpone(BaseModel.GameRequest.callBackFcn, response);
	            });
	            neo_games_1.Platforms.Platforms.roundStarted({
	                totalBet: BetManager_1.BetManager.Bet,
	                freeRound: FreeRoundBonus_1.FreeRoundBonus.inFrb,
	                userAction: DataManager_1.DataManager.getTrustedUserAction(BaseActions_1.BaseActions.ActionSpin),
	            });
	        }
	    };
	    BaseModel.prototype.buyFeature = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient
	            .buyFeature(neo_games_1.Communication.Game.GameModules.Base, BuyFeature_1.BuyFeature.getBuyFeatureBet(), BetManager_1.BetManager.createBetForSpin(), BuyFeature_1.BuyFeature.getBuyFeatureName())
	            .then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.spinReceived.bind(_this), response);
	        });
	    };
	    BaseModel.prototype.respin = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient
	            .respin(neo_games_1.Communication.Game.GameModules.Base, GameManager_1.GameManager.baseResponse.respin)
	            .then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.respinReceived.bind(_this), response);
	        });
	    };
	    BaseModel.prototype.spinReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            BaseModel.GameRequest = null;
	            this.controller.spinReceived();
	            neo_games_1.Platforms.Platforms.spinReceived({
	                balance: parseFloat(neo_common_1.NumberUtils.add(response.balance.real, response.balance.bonus)),
	                win: GameManager_1.GameManager.baseResponse.currentWin,
	                totalBet: BetManager_1.BetManager.createBetForSpin().totalBet,
	                roundId: response.roundId,
	            });
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    BaseModel.prototype.respinReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.respinReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    BaseModel.GameRequest = null;
	    return BaseModel;
	}());
	exports.BaseModel = BaseModel;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var GameApp_1 = __webpack_require__(1);
	var neo_games_1 = __webpack_require__(3);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var ModuleManager_1 = __webpack_require__(29);
	var GameManager_1 = __webpack_require__(23);
	var FreeRoundBonusIcon_1 = __webpack_require__(48);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var Languages_1 = __webpack_require__(28);
	var ResponsibleDialog1_1 = __webpack_require__(49);
	var PlayList_1 = __webpack_require__(33);
	var CashierDialog_1 = __webpack_require__(50);
	var RetentionPanel_1 = __webpack_require__(46);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var GameStatuses = neo_games_1.Communication.Game.GameModuleStatus;
	var FreeRoundBonus = (function () {
	    function FreeRoundBonus() {
	    }
	    FreeRoundBonus.initialize = function (gameClient) {
	        if (!FreeRoundBonus.wasInitialized && gameClient != null) {
	            gameClient
	                .sendFreeRoundsOffersRequest(GameApp_1.GameApp.key)
	                .then(function (response) {
	                FreeRoundBonus.getCurrentOfferReceived(response);
	            })
	                .catch(function (err) {
	                FreeRoundBonus.wasInitialized = true;
	            });
	        }
	    };
	    FreeRoundBonus.activateOffer = function () {
	        if (FreeRoundBonus.status === "active") {
	            FreeRoundBonus.inFrb = true;
	            neo_games_1.Platforms.Platforms.featureStarted({ type: "FRB" });
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	            ModuleManager_1.ModuleManager.disableBase();
	            if (GameApp_1.GameApp.gameClient != null && FreeRoundBonus.id != null) {
	                GameApp_1.GameApp.gameClient.setOfferId(FreeRoundBonus.id);
	            }
	            GameManager_1.GameManager.softInit();
	        }
	        else {
	            ModuleManager_1.ModuleManager.disableBase();
	            if (GameApp_1.GameApp.gameClient != null && FreeRoundBonus.id != null) {
	                GameApp_1.GameApp.gameClient.setOfferId(FreeRoundBonus.id);
	                GameApp_1.GameApp.gameClient
	                    .sendFreeRoundsActivateOfferRequest(GameApp_1.GameApp.key, FreeRoundBonus.id)
	                    .then(function (response) {
	                    FreeRoundBonus.activateOfferReceived(response);
	                });
	            }
	        }
	    };
	    FreeRoundBonus.declineOffer = function () {
	        if (GameApp_1.GameApp.gameClient != null && FreeRoundBonus.id != null) {
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.hideAllIcons();
	            GameApp_1.GameApp.gameClient
	                .sendFreeRoundsDeclineOfferRequest(GameApp_1.GameApp.key, FreeRoundBonus.id)
	                .then(function (response) {
	                FreeRoundBonus.declineOfferReceived(response);
	                FreeRoundBonus.refreshCurrentOffers();
	            });
	        }
	    };
	    FreeRoundBonus.initializeFreeRounds = function () {
	        FreeRoundBonusDialog_1.FreeRoundBonusDialog.initialize();
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.initialize();
	        if (GameApp_1.GameApp.gameClient != null && FreeRoundBonus.id != null && FreeRoundBonus.status === "active") {
	            GameApp_1.GameApp.gameClient.setOfferId(FreeRoundBonus.id);
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("active");
	            ModuleManager_1.ModuleManager.disableBase();
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	            FreeRoundBonus.inFrb = true;
	            neo_games_1.Platforms.Platforms.featureInit({ type: "FRB" });
	        }
	    };
	    FreeRoundBonus.showFreeRounds = function () {
	        if (FreeRoundBonus.id != null) {
	            FreeRoundBonus.countDown();
	            if (FreeRoundBonus.status !== "active") {
	                if (DataManager_1.DataManager.GameRoundClosed) {
	                    FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("new");
	                    ModuleManager_1.ModuleManager.disableBase();
	                    FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                }
	                else {
	                    if (!FreeRoundBonus.playing) {
	                        FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                        FreeRoundBonus.disableUi();
	                    }
	                }
	            }
	            else {
	                if (!DataManager_1.DataManager.GameRoundClosed) {
	                    FreeRoundBonus.frbSpin();
	                    FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	                    FreeRoundBonus.disableUi();
	                }
	                else {
	                    ModuleManager_1.ModuleManager.disableBase();
	                }
	            }
	        }
	        else {
	            FreeRoundBonus.openOther();
	        }
	    };
	    FreeRoundBonus.reopenFreeRounds = function () {
	        if (DataManager_1.DataManager.GameRoundClosed && FreeRoundBonus.isLastFrb) {
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	            FreeRoundBonus.disableUi();
	            GameApp_1.GameApp.gameClient.setOfferId(null);
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("end");
	            FreeRoundBonus.endMsgDisplayed = true;
	            ModuleManager_1.ModuleManager.disableBase();
	            return;
	        }
	        if (FreeRoundBonus.status === "new" && FreeRoundBonus.state === "new") {
	            BetHigherThanMinDialog_1.BetHigherThanMinDialog.hideDialog();
	            BetHigherThanMinDialog_1.BetHigherThanMinDialog.closeDialog();
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("new");
	            ModuleManager_1.ModuleManager.disableBase();
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	            FreeRoundBonus.enableUi();
	        }
	        if (FreeRoundBonus.state === "active") {
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("active");
	            ModuleManager_1.ModuleManager.disableBase();
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	            FreeRoundBonus.enableUi();
	        }
	        if (FreeRoundBonus.state === "end") {
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	            FreeRoundBonus.disableUi();
	            GameApp_1.GameApp.gameClient.setOfferId(null);
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("end");
	            FreeRoundBonus.endMsgDisplayed = true;
	            ModuleManager_1.ModuleManager.disableBase();
	        }
	        if (FreeRoundBonus.state === "other") {
	            if (FreeRoundBonus.validTo != null) {
	                var countDownDate = new Date(FreeRoundBonus.validTo + "+00:00").getTime();
	                var now = new Date().getTime();
	                var distance = countDownDate - now;
	                if (distance > 0) {
	                    FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("other");
	                    ModuleManager_1.ModuleManager.disableBase();
	                    FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                    FreeRoundBonus.enableUi();
	                }
	            }
	            else if (FreeRoundBonusDialog_1.FreeRoundBonusDialog.revalidateOtherGames()) {
	                FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("other");
	                ModuleManager_1.ModuleManager.disableBase();
	                FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                FreeRoundBonus.enableUi();
	            }
	        }
	        if (FreeRoundBonus.state === "") {
	            FreeRoundBonus.enableUi();
	        }
	    };
	    FreeRoundBonus.openOther = function () {
	        if (FreeRoundBonus.id == null && FreeRoundBonusDialog_1.FreeRoundBonusDialog.revalidateOtherGames()) {
	            FreeRoundBonus.countDownOther();
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                FreeRoundBonus.enableUi();
	            }
	            else {
	                FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("new");
	                FreeRoundBonus.disableUi();
	            }
	        }
	    };
	    FreeRoundBonus.endFreeRounds = function () {
	        if (FreeRoundBonus.id != null) {
	            DataManager_1.DataManager.Collectable = true;
	            FreeRoundBonus.disableUi();
	            if (GameManager_1.GameManager.gameResponse["freeRounds"] != null) {
	                if (GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
	                    FreeRoundBonus.totalWin = GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"];
	                }
	                if (GameManager_1.GameManager.gameResponse["freeRounds"]["status"] != null) {
	                    if (GameManager_1.GameManager.gameResponse["freeRounds"]["status"] === "pending") {
	                        FreeRoundBonus.status = GameManager_1.GameManager.gameResponse["freeRounds"]["status"];
	                    }
	                }
	            }
	            GameApp_1.GameApp.gameClient.setOfferId(null);
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("end");
	            FreeRoundBonus.endMsgDisplayed = true;
	        }
	    };
	    FreeRoundBonus.finishFreeRounds = function () {
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.hideAllIcons();
	        FreeRoundBonus.id = null;
	        FreeRoundBonus.inFrb = false;
	        neo_games_1.Platforms.Platforms.featureFinished({ type: "FRB" });
	        FreeRoundBonus.isLastFrb = false;
	        FreeRoundBonus.endMsgDisplayed = false;
	        FreeRoundBonus.wasInitialized = false;
	        FreeRoundBonus.softInit = false;
	        FreeRoundBonus.remainingFrbCount = null;
	        FreeRoundBonus.roundsAssigned = 0;
	        FreeRoundBonus.roundsPlayed = 0;
	        FreeRoundBonus.roundsStarted = 0;
	        FreeRoundBonus.dialogType = FreeRoundBonusDialog_1.DialogType.Other;
	        FreeRoundBonus.featureName = null;
	        FreeRoundBonus.status = null;
	        if (FreeRoundBonus.winPayMethod === "cumulative") {
	            if (FreeRoundBonus.totalWin != null && FreeRoundBonus.totalWin > 0) {
	                PlayList_1.PlayList.play("SND_BaseCollect");
	                ModuleManager_1.ModuleManager.disableBase();
	                ModuleManager_1.ModuleManager.resetSceneAsOnCollect(GameModules.Base);
	            }
	        }
	        FreeRoundBonus.refreshCurrentOffers();
	    };
	    FreeRoundBonus.refreshCurrentOffers = function () {
	        if (GameApp_1.GameApp.gameClient != null) {
	            GameApp_1.GameApp.gameClient
	                .sendFreeRoundsOffersRequest(GameApp_1.GameApp.key)
	                .then(function (response) {
	                FreeRoundBonus.getCurrentOfferReceived(response);
	                if (FreeRoundBonus.id != null) {
	                    FreeRoundBonus.softInit = true;
	                    if (FreeRoundBonus.status === "active") {
	                        FreeRoundBonus.initializeFreeRounds();
	                    }
	                    else {
	                        FreeRoundBonus.showFreeRounds();
	                    }
	                }
	                else {
	                    GameManager_1.GameManager.softInit();
	                    FreeRoundBonus.disableUi();
	                    if (DataManager_1.DataManager.GameRoundClosed) {
	                        GameManager_1.GameManager.canExit();
	                    }
	                }
	                return null;
	            })
	                .catch(function (err) {
	                FreeRoundBonus.wasInitialized = true;
	                GameManager_1.GameManager.softInit();
	                FreeRoundBonus.disableUi();
	                if (DataManager_1.DataManager.GameRoundClosed) {
	                    GameManager_1.GameManager.canExit();
	                }
	            });
	        }
	    };
	    FreeRoundBonus.expiredFreeRounds = function () {
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.hideAllIcons();
	        FreeRoundBonus.id = null;
	        FreeRoundBonus.inFrb = false;
	        neo_games_1.Platforms.Platforms.featureFinished({ type: "FRB" });
	        FreeRoundBonus.isLastFrb = false;
	        FreeRoundBonus.endMsgDisplayed = false;
	        FreeRoundBonus.softInit = false;
	        FreeRoundBonus.remainingFrbCount = null;
	        FreeRoundBonus.roundsAssigned = 0;
	        FreeRoundBonus.roundsPlayed = 0;
	        FreeRoundBonus.roundsStarted = 0;
	        FreeRoundBonus.dialogType = FreeRoundBonusDialog_1.DialogType.Other;
	        FreeRoundBonus.featureName = null;
	        FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("expired");
	    };
	    FreeRoundBonus.getCurrentOfferReceived = function (response) {
	        FreeRoundBonus.totalWin = 0;
	        FreeRoundBonus.termsUrl = null;
	        if (response != null) {
	            FreeRoundBonus.wasInitialized = true;
	            if (response.currentOffer != null) {
	                if (response.currentOffer.id != null)
	                    FreeRoundBonus.id = response.currentOffer.id;
	                if (response.currentOffer.termsUrl != null)
	                    FreeRoundBonus.termsUrl = response.currentOffer.termsUrl;
	                if (response.currentOffer.roundsAssigned != null)
	                    FreeRoundBonus.roundsAssigned = response.currentOffer.roundsAssigned;
	                if (response.currentOffer.roundsStarted != null)
	                    FreeRoundBonus.roundsStarted = response.currentOffer.roundsStarted;
	                if (response.currentOffer.roundsPlayed != null)
	                    FreeRoundBonus.roundsPlayed = response.currentOffer.roundsPlayed;
	                if (response.currentOffer.remainingCount != null)
	                    FreeRoundBonus.remainingFrbCount = response.currentOffer.remainingCount;
	                if (response.currentOffer.playing != null)
	                    FreeRoundBonus.playing = response.currentOffer.playing;
	                if (response.currentOffer.status != null)
	                    FreeRoundBonus.status = response.currentOffer.status;
	                if (response.currentOffer.winType != null)
	                    FreeRoundBonus.winType = response.currentOffer.winType;
	                if (response.currentOffer.validTo != null)
	                    FreeRoundBonus.validTo = response.currentOffer.validTo;
	                if (response.currentOffer.winPayMethod != null)
	                    FreeRoundBonus.winPayMethod = response.currentOffer.winPayMethod;
	                if (response.currentOffer.collectPartial != null)
	                    FreeRoundBonus.collectPartial = response.currentOffer.collectPartial;
	                if (response.currentOffer.hasBuyFeature != null) {
	                    FreeRoundBonus.dialogType = (response.currentOffer.hasBuyFeature ? FreeRoundBonusDialog_1.DialogType.FFR : FreeRoundBonusDialog_1.DialogType.FRB);
	                }
	                else {
	                    FreeRoundBonus.dialogType = FreeRoundBonusDialog_1.DialogType.Other;
	                }
	                if (response.currentOffer.buyFeatureName != null)
	                    FreeRoundBonus.featureName = response.currentOffer.buyFeatureName;
	                if (FreeRoundBonus.remainingFrbCount == null) {
	                    if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
	                        FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
	                    }
	                }
	                if (FreeRoundBonus.remainingFrbCount != null && FreeRoundBonus.remainingFrbCount === 0) {
	                    FreeRoundBonus.isLastFrb = true;
	                }
	            }
	            FreeRoundBonus.otherOfferes = [];
	            if (response.otherOffers != null) {
	                FreeRoundBonus.otherOfferes = response.otherOffers;
	            }
	        }
	    };
	    FreeRoundBonus.activateOfferReceived = function (response) {
	        FreeRoundBonus.inFrb = true;
	        neo_games_1.Platforms.Platforms.featureStarted({ type: "FRB" });
	        FreeRoundBonus.status = "active";
	        GameManager_1.GameManager.softInit();
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.showIcon("active");
	    };
	    FreeRoundBonus.declineOfferReceived = function (response) {
	        FreeRoundBonus.id = null;
	        FreeRoundBonus.softInit = false;
	        FreeRoundBonus.remainingFrbCount = null;
	        FreeRoundBonus.roundsAssigned = 0;
	        FreeRoundBonus.roundsPlayed = 0;
	        FreeRoundBonus.roundsStarted = 0;
	        FreeRoundBonus.dialogType = FreeRoundBonusDialog_1.DialogType.Other;
	        FreeRoundBonus.featureName = null;
	    };
	    FreeRoundBonus.valid = function () {
	        var str = "";
	        if (FreeRoundBonus.validTo != null) {
	            str = FreeRoundBonus.validTo;
	        }
	        return str;
	    };
	    FreeRoundBonus.assignedCount = function () {
	        var str = "0";
	        if (FreeRoundBonus.roundsAssigned != null) {
	            str = FreeRoundBonus.roundsAssigned.toString();
	        }
	        return str;
	    };
	    FreeRoundBonus.remainingCount = function () {
	        var str = "0";
	        if (FreeRoundBonus.remainingFrbCount == null) {
	            if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
	                FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
	            }
	        }
	        if (FreeRoundBonus.remainingFrbCount != null) {
	            if (FreeRoundBonus.id === -1 && FreeRoundBonus.isLastFrb) {
	                str = "0";
	            }
	            else {
	                str = FreeRoundBonus.remainingFrbCount.toString();
	            }
	        }
	        return str;
	    };
	    FreeRoundBonus.rulesLink = function () {
	        var str = "";
	        if (FreeRoundBonus.termsUrl != null) {
	            str = '<a href="' + FreeRoundBonus.termsUrl + '" target="_blank">' + FreeRoundBonus.termsUrl + "</a>";
	        }
	        return str;
	    };
	    FreeRoundBonus.win = function () {
	        var str = "";
	        if (FreeRoundBonus.totalWin != null && FreeRoundBonus.totalWin > 0) {
	            str =
	                Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, FreeRoundBonus.totalWin.toString()) +
	                    " " +
	                    DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	        }
	        return str;
	    };
	    FreeRoundBonus.frbSpin = function () {
	        if (FreeRoundBonus.id == null && !FreeRoundBonus.inFrb) {
	            return;
	        }
	        FreeRoundBonus.blockFrbExpiration = true;
	        if (FreeRoundBonus.inFrb) {
	            DataManager_1.DataManager.AutoplayLossLimit = "∞";
	        }
	        if (GameManager_1.GameManager.gameResponse["freeRounds"] != null) {
	            if (GameManager_1.GameManager.gameResponse["freeRounds"]["roundsStarted"] != null) {
	                FreeRoundBonus.roundsStarted = GameManager_1.GameManager.gameResponse["freeRounds"]["roundsStarted"];
	            }
	            if (GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
	                FreeRoundBonus.totalWin = GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"];
	            }
	            if (GameManager_1.GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
	                FreeRoundBonus.remainingFrbCount = GameManager_1.GameManager.gameResponse["freeRounds"]["remainingCount"];
	            }
	            else {
	                if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
	                    FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
	                }
	            }
	        }
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
	        if (FreeRoundBonus.remainingFrbCount != null && FreeRoundBonus.remainingFrbCount === 0) {
	            FreeRoundBonus.isLastFrb = true;
	            DataManager_1.DataManager.Autoplay = false;
	            DataManager_1.DataManager.AutoplayCount = "∞";
	            DataManager_1.DataManager.AutoplayLossLimit = "∞";
	            DataManager_1.DataManager.AutoplayWinLimit = "∞";
	        }
	    };
	    FreeRoundBonus.countDown = function () {
	        if (FreeRoundBonus.validTo != null) {
	            var countDownDate = new Date(FreeRoundBonus.validTo + "+00:00").getTime();
	            var now = new Date().getTime();
	            var distance = countDownDate - now;
	            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
	            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
	            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
	            if (!FreeRoundBonus.blockFrbExpiration && distance < 0) {
	                FreeRoundBonus.id = null;
	                FreeRoundBonus.softInit = false;
	                FreeRoundBonus.remainingFrbCount = null;
	                FreeRoundBonus.roundsAssigned = 0;
	                FreeRoundBonus.roundsPlayed = 0;
	                FreeRoundBonus.roundsStarted = 0;
	                FreeRoundBonus.dialogType = FreeRoundBonusDialog_1.DialogType.Other;
	                if (FreeRoundBonus.state !== "end" && FreeRoundBonus.state !== "other") {
	                    if (!FreeRoundBonusDialog_1.FreeRoundBonusDialog.revalidateOtherGames()) {
	                        FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	                        FreeRoundBonusIcon_1.FreeRoundBonusIcon.hideAllIcons();
	                        FreeRoundBonus.state = "expired";
	                        FreeRoundBonus.enableGame();
	                    }
	                    else {
	                        FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	                        FreeRoundBonus.enableGame();
	                    }
	                }
	            }
	            else {
	                if (days > 0) {
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbExpiryTime, days + "d");
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbExpiryTime, days + "d");
	                }
	                else if (hours > 0) {
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbExpiryTime, hours + ":" + minutes + "h");
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbExpiryTime, hours + ":" + minutes + "h");
	                }
	                else if (minutes > 0) {
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbExpiryTime, minutes + ":" + seconds + "s");
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbExpiryTime, minutes + ":" + seconds + "s");
	                }
	                setTimeout(function () {
	                    FreeRoundBonus.countDown();
	                }, 1000);
	            }
	        }
	    };
	    FreeRoundBonus.countDownOther = function () {
	        if (!FreeRoundBonusDialog_1.FreeRoundBonusDialog.revalidateOtherGames()) {
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.hideAllIcons();
	            FreeRoundBonus.enableGame();
	        }
	        else {
	            setTimeout(function () {
	                FreeRoundBonus.countDownOther();
	            }, 2000);
	        }
	    };
	    FreeRoundBonus.hasNewActiveOffer = function () {
	        if (FreeRoundBonus.id == null && FreeRoundBonus.remainingFrbCount > 0) {
	            return true;
	        }
	        return false;
	    };
	    FreeRoundBonus.updateRemainingCount = function (count) {
	        if (FreeRoundBonus.id == null || (FreeRoundBonus.id > -1 && FreeRoundBonus.status != "active")) {
	            if (count > 0) {
	                if (FreeRoundBonus.canInitDynamicFRB()) {
	                    FreeRoundBonus.softInitialize();
	                }
	                else {
	                    if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.status === GameStatuses.Enabled) {
	                        DataManager_1.DataManager.Autoplay = false;
	                    }
	                    FreeRoundBonus.remainingFrbCount = count;
	                }
	            }
	        }
	        else if (FreeRoundBonus.id === -1) {
	            if (count > 0) {
	                if (FreeRoundBonus.remainingFrbCount > 0) {
	                    FreeRoundBonus.isLastFrb = false;
	                    FreeRoundBonus.remainingFrbCount = count;
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbRemainginCount, count.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbRemainginCount, count.toString());
	                }
	                else {
	                    FreeRoundBonus.remainingFrbCount = count;
	                }
	            }
	            else if (count === 0) {
	                if (FreeRoundBonus.remainingFrbCount > 0) {
	                    FreeRoundBonus.remainingFrbCount = count;
	                    DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbRemainginCount, count.toString());
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbRemainginCount, count.toString());
	                    FreeRoundBonus.isLastFrb = true;
	                    if (DataManager_1.DataManager.GameRoundClosed && !DataManager_1.DataManager.Autoplay && FreeRoundBonus.enabledUi) {
	                        FreeRoundBonus.endFreeRounds();
	                    }
	                    else {
	                        DataManager_1.DataManager.Autoplay = false;
	                    }
	                }
	            }
	        }
	    };
	    FreeRoundBonus.canInitDynamicFRB = function () {
	        return (!FreeRoundBonusIcon_1.FreeRoundBonusIcon.isDisabled() &&
	            DataManager_1.DataManager.GameRoundClosed &&
	            !DataManager_1.DataManager.Autoplay &&
	            !ResponsibleDialog1_1.ResponsibleDialog1.opened);
	    };
	    FreeRoundBonus.softInitialize = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        ModuleManager_1.ModuleManager.disableBase();
	        if (!FreeRoundBonus.softInit) {
	            FreeRoundBonus.softInit = true;
	            GameManager_1.GameManager.gameClient
	                .sendFreeRoundsOffersRequest(GameApp_1.GameApp.key)
	                .then(function (response) {
	                FreeRoundBonus.getCurrentOfferReceived(response);
	                FreeRoundBonus.initializeFreeRounds();
	            })
	                .catch(function (err) {
	                FreeRoundBonus.softInit = false;
	                FreeRoundBonus.wasInitialized = true;
	                ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	            });
	        }
	    };
	    FreeRoundBonus.disableUi = function () {
	        FreeRoundBonus.enabledUi = false;
	        FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.disableActiveIcon();
	    };
	    FreeRoundBonus.enableUi = function () {
	        if (!ResponsibleDialog1_1.ResponsibleDialog1.opened && DataManager_1.DataManager.GameRoundClosed && !CashierDialog_1.CashierDialog.opened) {
	            FreeRoundBonus.enabledUi = true;
	            if (FreeRoundBonus.hasNewActiveOffer()) {
	                FreeRoundBonus.softInitialize();
	                return;
	            }
	            if (FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod == "cumulative") {
	                return;
	            }
	            FreeRoundBonusIcon_1.FreeRoundBonusIcon.enableActiveIcon();
	        }
	    };
	    FreeRoundBonus.enableGame = function () {
	        if (FreeRoundBonus.softInit) {
	            GameManager_1.GameManager.softInit();
	            FreeRoundBonus.softInit = false;
	        }
	        else if (ModuleManager_1.ModuleManager.getActiveGameModules().length == 0 ||
	            ModuleManager_1.ModuleManager.getActiveGameModules().indexOf(GameModules.Base) != -1) {
	            ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	        }
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    FreeRoundBonus.enableFrbExpiration = function () {
	        FreeRoundBonus.blockFrbExpiration = false;
	    };
	    FreeRoundBonus.inFrb = false;
	    FreeRoundBonus.isLastFrb = false;
	    FreeRoundBonus.playing = false;
	    FreeRoundBonus.otherOfferes = [];
	    FreeRoundBonus.wasInitialized = false;
	    FreeRoundBonus.state = "";
	    FreeRoundBonus.endMsgDisplayed = false;
	    FreeRoundBonus.softInit = false;
	    FreeRoundBonus.enabledUi = false;
	    FreeRoundBonus.blockFrbExpiration = false;
	    return FreeRoundBonus;
	}());
	exports.FreeRoundBonus = FreeRoundBonus;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var FreeRoundBonus_1 = __webpack_require__(44);
	var DataManager_1 = __webpack_require__(26);
	var GameData_1 = __webpack_require__(24);
	var PlayList_1 = __webpack_require__(33);
	var AppContext_1 = __webpack_require__(5);
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var RetentionPanel_1 = __webpack_require__(46);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var FreeRoundBonusDialog = (function () {
	    function FreeRoundBonusDialog() {
	    }
	    FreeRoundBonusDialog.initialize = function () {
	        FreeRoundBonusDialog.Dialog = document.getElementById("frbDialog");
	        FreeRoundBonusDialog.DialogContentOther = document.getElementById("frbDialogContentOther");
	        FreeRoundBonusDialog.DialogContentOther2 = document.getElementById("frbDialogContentOther2");
	        FreeRoundBonusDialog.DialogContentOtherList = document.getElementById("frbDialogContentOtherList");
	        FreeRoundBonusDialog.DialogContentOtherList2 = document.getElementById("frbDialogContentOtherList2");
	        FreeRoundBonusDialog.DialogContentNew = document.getElementById("frbDialogContentNew");
	        FreeRoundBonusDialog.DialogContentActive = document.getElementById("frbDialogContentActive");
	        FreeRoundBonusDialog.DialogContentEnd = document.getElementById("frbDialogContentEnd");
	        FreeRoundBonusDialog.DialogContentExpired = document.getElementById("frbDialogContentExpired");
	        FreeRoundBonusDialog.ConfirmationDialog = document.getElementById("frbConfirmationDialog");
	        FreeRoundBonusDialog.DialogButtonPlay = document.getElementById("dialogBtnPlay");
	        FreeRoundBonusDialog.DialogButtonPostPone = document.getElementById("dialogBtnPostPone");
	        FreeRoundBonusDialog.DialogButtonDeny = document.getElementById("dialogBtnDeny");
	        FreeRoundBonusDialog.DialogButtonOk = document.getElementById("dialogBtnOk");
	        FreeRoundBonusDialog.DialogButtonYes = document.getElementById("dialogBtnYes");
	        FreeRoundBonusDialog.DialogButtonNo = document.getElementById("dialogBtnNo");
	        FreeRoundBonusDialog.bindEvents();
	        FreeRoundBonusDialog.setupFRBDialogByConfiguration();
	    };
	    FreeRoundBonusDialog.showDialog = function (type) {
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbRemainginCount, FreeRoundBonus_1.FreeRoundBonus.remainingCount());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbAssignedCount, FreeRoundBonus_1.FreeRoundBonus.assignedCount());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbValidTo, FreeRoundBonus_1.FreeRoundBonus.valid());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataFrbWin, FreeRoundBonus_1.FreeRoundBonus.win());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbRemainginCount, FreeRoundBonus_1.FreeRoundBonus.remainingCount());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbAssignedCount, FreeRoundBonus_1.FreeRoundBonus.assignedCount());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbValidTo, FreeRoundBonus_1.FreeRoundBonus.valid());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataFrbWin, FreeRoundBonus_1.FreeRoundBonus.win());
	        FreeRoundBonusDialog.termsUrl();
	        DataManager_1.DataManager.showDataElements("frbRules", "");
	        if (FreeRoundBonus_1.FreeRoundBonus.rulesLink() === "") {
	            DataManager_1.DataManager.hideDataElements("frbRules");
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.win() === "") {
	            DataManager_1.DataManager.hideDataElements("frbWin");
	        }
	        else {
	            DataManager_1.DataManager.showDataElements("frbWin");
	        }
	        FreeRoundBonusDialog.hideAllButtons();
	        FreeRoundBonusDialog.hideAllContents();
	        DataManager_1.DataManager.hideDataElements("frbCumulative");
	        DataManager_1.DataManager.hideDataElements("frbPlatformTransactionFail");
	        neo_games_1.Platforms.Platforms.closeMenu();
	        neo_games_1.Platforms.Platforms.dialogOpened("frb", true);
	        switch (type) {
	            case "new":
	                FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");
	                FreeRoundBonus_1.FreeRoundBonus.state = "new";
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentNew);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonPlay);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonPostPone);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonDeny);
	                if (FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	                    DataManager_1.DataManager.showDataElements("frbCumulative");
	                }
	                if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
	                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.ConfirmationDialog);
	                }
	                break;
	            case "other":
	                FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");
	                FreeRoundBonus_1.FreeRoundBonus.state = "other";
	                FreeRoundBonusDialog.refillOtherGames();
	                if (AppContext_1.AppContext != null &&
	                    AppContext_1.AppContext.gameConfiguration != null &&
	                    AppContext_1.AppContext.gameConfiguration.ShowSimilarGames) {
	                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentOther);
	                }
	                else {
	                    FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentOther2);
	                }
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
	                FreeRoundBonus_1.FreeRoundBonus.openOther();
	                break;
	            case "active":
	                FreeRoundBonus_1.FreeRoundBonus.state = "active";
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentActive);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
	                if (FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	                    DataManager_1.DataManager.showDataElements("frbCumulative");
	                }
	                break;
	            case "end":
	                FreeRoundBonus_1.FreeRoundBonus.state = "end";
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentEnd);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
	                if (FreeRoundBonus_1.FreeRoundBonus.status === "pending" && FreeRoundBonus_1.FreeRoundBonus.totalWin > 0) {
	                    DataManager_1.DataManager.showDataElements("frbPlatformTransactionFail");
	                }
	                break;
	            case "expired":
	                FreeRoundBonus_1.FreeRoundBonus.state = "expired";
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogContentExpired);
	                FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.DialogButtonOk);
	                break;
	        }
	        DataManager_1.DataManager.hideDataElements("frbRegular");
	        DataManager_1.DataManager.hideDataElements("frbFeature");
	        DataManager_1.DataManager.hideDataElements("frbOptionsFrb");
	        DataManager_1.DataManager.hideDataElements("frbOptionsFfr");
	        DataManager_1.DataManager.hideDataElements("frbOptionsMixed");
	        switch (FreeRoundBonusDialog.dialogOtherGamesMessage) {
	            case exports.DialogOtherGamesMessage.FRB:
	                DataManager_1.DataManager.showDataElements("frbOptionsFrb");
	                break;
	            case exports.DialogOtherGamesMessage.FFR:
	                DataManager_1.DataManager.showDataElements("frbOptionsFfr");
	                break;
	            case exports.DialogOtherGamesMessage.MIXED:
	                DataManager_1.DataManager.showDataElements("frbOptionsMixed");
	                break;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.dialogType !== exports.DialogType.Other) {
	            if (FreeRoundBonus_1.FreeRoundBonus.dialogType == exports.DialogType.FFR)
	                FreeRoundBonusDialog.Dialog.classList.add("ffrDialogType");
	            if (FreeRoundBonus_1.FreeRoundBonus.dialogType == exports.DialogType.FRB)
	                FreeRoundBonusDialog.Dialog.classList.add("frbDialogType");
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.state === "new" || FreeRoundBonus_1.FreeRoundBonus.state === "active") {
	            if (FreeRoundBonus_1.FreeRoundBonus.dialogType !== null && FreeRoundBonus_1.FreeRoundBonus.dialogType == exports.DialogType.FFR) {
	                if (FreeRoundBonus_1.FreeRoundBonus.remainingCount() === "1") {
	                    DataManager_1.DataManager.showDataElements("frbFeatureSingle");
	                }
	                else {
	                    DataManager_1.DataManager.showDataElements("frbFeatureMultiple");
	                }
	            }
	            else {
	                if (FreeRoundBonus_1.FreeRoundBonus.remainingCount() === "1") {
	                    DataManager_1.DataManager.showDataElements("frbRegularSingle");
	                }
	                else {
	                    DataManager_1.DataManager.showDataElements("frbRegularMultiple");
	                }
	            }
	        }
	        FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.Dialog);
	    };
	    FreeRoundBonusDialog.setConfirmationDialog = function (value) {
	        FreeRoundBonusDialog.isConfirmationDialogOpened = value;
	    };
	    FreeRoundBonusDialog.setPointerEventsButtons = function (value) {
	        if (value === void 0) { value = ""; }
	        FreeRoundBonusDialog.DialogButtonPlay.style.pointerEvents = value;
	        FreeRoundBonusDialog.DialogButtonPostPone.style.pointerEvents = value;
	        FreeRoundBonusDialog.DialogButtonDeny.style.pointerEvents = value;
	    };
	    FreeRoundBonusDialog.hideDialog = function () {
	        neo_games_1.Platforms.Platforms.dialogOpened("frb", false);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.Dialog);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);
	    };
	    FreeRoundBonusDialog.bindEvents = function () {
	        if (FreeRoundBonusDialog.DialogButtonPlay != null) {
	            FreeRoundBonusDialog.DialogButtonPlay.onclick = FreeRoundBonusDialog.onPlay;
	        }
	        if (FreeRoundBonusDialog.DialogButtonPostPone != null) {
	            FreeRoundBonusDialog.DialogButtonPostPone.onclick = FreeRoundBonusDialog.onPostPone;
	        }
	        if (FreeRoundBonusDialog.DialogButtonDeny != null) {
	            FreeRoundBonusDialog.DialogButtonDeny.onclick = FreeRoundBonusDialog.onDeny;
	        }
	        if (FreeRoundBonusDialog.DialogButtonOk != null) {
	            FreeRoundBonusDialog.DialogButtonOk.onclick = FreeRoundBonusDialog.onOk;
	        }
	        if (FreeRoundBonusDialog.DialogButtonYes != null) {
	            FreeRoundBonusDialog.DialogButtonYes.onclick = FreeRoundBonusDialog.onYes;
	        }
	        if (FreeRoundBonusDialog.DialogButtonNo != null) {
	            FreeRoundBonusDialog.DialogButtonNo.onclick = FreeRoundBonusDialog.onNo;
	        }
	    };
	    FreeRoundBonusDialog.hideAllButtons = function () {
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonPlay);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonPostPone);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonDeny);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogButtonOk);
	    };
	    FreeRoundBonusDialog.hideAllContents = function () {
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentActive);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentNew);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentOther);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentOther2);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentEnd);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.DialogContentExpired);
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);
	    };
	    FreeRoundBonusDialog.showElement = function (element) {
	        if (element != null) {
	            if (element.classList.contains("_disabled")) {
	                element.classList.remove("_disabled");
	            }
	            if (element.classList.contains("_hidden")) {
	                element.classList.remove("_hidden");
	            }
	        }
	    };
	    FreeRoundBonusDialog.hideElement = function (element) {
	        if (element != null) {
	            if (element.classList.contains("_disabled")) {
	                element.classList.remove("_disabled");
	            }
	            if (!element.classList.contains("_hidden")) {
	                element.classList.add("_hidden");
	            }
	        }
	    };
	    FreeRoundBonusDialog.disableElement = function (element) {
	        if (element != null) {
	            if (!element.classList.contains("_disabled")) {
	                element.classList.add("_disabled");
	            }
	            if (element.classList.contains("_hidden")) {
	                element.classList.remove("_hidden");
	            }
	        }
	    };
	    FreeRoundBonusDialog.onPlay = function () {
	        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
	            return;
	        }
	        FreeRoundBonus_1.FreeRoundBonus.state = "";
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.hideDialog();
	        FreeRoundBonus_1.FreeRoundBonus.activateOffer();
	        FreeRoundBonusDialog.setPointerEventsButtons("");
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    FreeRoundBonusDialog.onPostPone = function () {
	        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
	            return;
	        }
	        FreeRoundBonus_1.FreeRoundBonus.state = "";
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.hideDialog();
	        FreeRoundBonus_1.FreeRoundBonus.enableGame();
	        FreeRoundBonusDialog.setPointerEventsButtons("");
	        RetentionPanel_1.RetentionPanel.revalidate();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.restoreDialog();
	    };
	    FreeRoundBonusDialog.onDeny = function () {
	        if (FreeRoundBonusDialog.isConfirmationDialogOpened) {
	            return;
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.showElement(FreeRoundBonusDialog.ConfirmationDialog);
	        FreeRoundBonusDialog.setConfirmationDialog(true);
	        FreeRoundBonusDialog.setPointerEventsButtons("none");
	        RetentionPanel_1.RetentionPanel.revalidate();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.restoreDialog();
	    };
	    FreeRoundBonusDialog.onYes = function () {
	        FreeRoundBonus_1.FreeRoundBonus.state = "";
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.hideDialog();
	        FreeRoundBonus_1.FreeRoundBonus.declineOffer();
	        FreeRoundBonusDialog.setConfirmationDialog(false);
	        FreeRoundBonusDialog.setPointerEventsButtons("");
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    FreeRoundBonusDialog.onNo = function () {
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.hideElement(FreeRoundBonusDialog.ConfirmationDialog);
	        FreeRoundBonusDialog.setConfirmationDialog(false);
	        FreeRoundBonusDialog.setPointerEventsButtons("");
	    };
	    FreeRoundBonusDialog.onOk = function () {
	        FreeRoundBonus_1.FreeRoundBonus.state = "";
	        PlayList_1.PlayList.play("SND_Click");
	        FreeRoundBonusDialog.hideDialog();
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	            FreeRoundBonus_1.FreeRoundBonus.finishFreeRounds();
	        }
	        else {
	            FreeRoundBonus_1.FreeRoundBonus.enableGame();
	        }
	        FreeRoundBonusDialog.Dialog.classList.remove("frbDialogType", "ffrDialogType");
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    FreeRoundBonusDialog.revalidateOtherGames = function () {
	        if (AppContext_1.AppContext != null &&
	            AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.StaticContentUrl === "") {
	            return false;
	        }
	        FreeRoundBonusDialog.otherOffersKeys = [];
	        FreeRoundBonusDialog.otherHasBuyFeatureKeys = [];
	        var hasFrb = false;
	        var hasFfr = false;
	        if (FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0) {
	            var now = new Date().getTime();
	            for (var i = 0; i < FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length; i++) {
	                var offer = FreeRoundBonus_1.FreeRoundBonus.otherOfferes[i];
	                if (offer["validTo"] != null) {
	                    var countDownDate = new Date(offer["validTo"] + "+00:00").getTime();
	                    var distance = countDownDate - now;
	                    if (distance > 0 && offer["gameCode"] != null) {
	                        FreeRoundBonusDialog.otherOffersKeys.push(offer["gameCode"]);
	                    }
	                    if (distance > 0 && offer["hasBuyFeature"] != null) {
	                        var hasBuyFeature = offer["hasBuyFeature"];
	                        FreeRoundBonusDialog.otherHasBuyFeatureKeys.push(hasBuyFeature);
	                        if (hasBuyFeature) {
	                            hasFfr = true;
	                        }
	                        else {
	                            hasFrb = true;
	                        }
	                    }
	                }
	            }
	        }
	        if (hasFfr && hasFrb) {
	            FreeRoundBonusDialog.dialogOtherGamesMessage =
	                exports.DialogOtherGamesMessage.MIXED;
	        }
	        else if (hasFfr) {
	            FreeRoundBonusDialog.dialogOtherGamesMessage = exports.DialogOtherGamesMessage.FFR;
	        }
	        else if (hasFrb) {
	            FreeRoundBonusDialog.dialogOtherGamesMessage = exports.DialogOtherGamesMessage.FRB;
	        }
	        return FreeRoundBonusDialog.otherOffersKeys.length > 0;
	    };
	    FreeRoundBonusDialog.refillOtherGames = function () {
	        if (FreeRoundBonusDialog.DialogContentOtherList != null) {
	            FreeRoundBonusDialog.DialogContentOtherList.innerHTML = "";
	        }
	        if (FreeRoundBonusDialog.DialogContentOtherList2 != null) {
	            FreeRoundBonusDialog.DialogContentOtherList2.innerHTML = "";
	        }
	        for (var i = 0; i < 5; i++) {
	            if (FreeRoundBonusDialog.otherOffersKeys.length > 0 &&
	                FreeRoundBonusDialog.otherOffersKeys[i] != null &&
	                FreeRoundBonusDialog.otherHasBuyFeatureKeys[i] != null) {
	                FreeRoundBonusDialog.createItem(FreeRoundBonusDialog.otherOffersKeys[i], false, FreeRoundBonusDialog.otherHasBuyFeatureKeys[i], FreeRoundBonusDialog.DialogContentOtherList);
	                FreeRoundBonusDialog.createItem(FreeRoundBonusDialog.otherOffersKeys[i], true, FreeRoundBonusDialog.otherHasBuyFeatureKeys[i], FreeRoundBonusDialog.DialogContentOtherList2);
	            }
	        }
	    };
	    FreeRoundBonusDialog.createItem = function (gameCode, noClick, hasBuyFeature, parent) {
	        if (AppContext_1.AppContext != null &&
	            AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.StaticContentUrl === "") {
	            return;
	        }
	        var itemHolder = document.createElement("div");
	        var itemLoading = document.createElement("div");
	        var itemLoadingIcon = document.createElement("div");
	        var itemLogo = document.createElement("div");
	        var itemFeatureType = document.createElement("div");
	        itemHolder.classList.add("frbOfferItem");
	        itemLoading.classList.add("frbGameLoading");
	        itemLoadingIcon.classList.add("loadingIcon");
	        itemLogo.classList.add("frbGameLogo");
	        itemFeatureType.classList.add("cssCommon", "flag");
	        itemFeatureType.classList.add(hasBuyFeature ? "ffrFlag" : "frbFlag");
	        itemLogo.setAttribute("game", gameCode);
	        itemLogo.style.background =
	            "url(" + AppContext_1.AppContext.gameConfiguration.StaticContentUrl + gameCode + "/" + window["QUALITY"] + "/logo.jpg)";
	        itemHolder.appendChild(itemLoading);
	        itemLoading.appendChild(itemLoadingIcon);
	        itemHolder.appendChild(itemLogo);
	        itemHolder.appendChild(itemFeatureType);
	        if (!noClick) {
	            itemLogo.onclick = FreeRoundBonusDialog.selectGame;
	        }
	        if (parent != null) {
	            parent.appendChild(itemHolder);
	        }
	    };
	    FreeRoundBonusDialog.selectGame = function (e) {
	        PlayList_1.PlayList.play("SND_Click");
	        if (e != null && e.target != null && e.target.hasAttribute("game")) {
	            var urlInfo = neo_common_1.UriHelper.parseUrl(window.location.href, true, true);
	            if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
	                var serverUrl = urlInfo["query"]["serverUrl"];
	                var token = urlInfo["hash"].substring(1);
	                var newUrl_1 = serverUrl + "Launch/" + e.target.getAttribute("game") + "?" + token;
	                var root = document.getElementById("root");
	                if (root != null) {
	                    root.style.display = "none";
	                }
	                neo_games_1.Platforms.Platforms.gameChange(e.target.getAttribute("game"));
	                if (neo_games_1.Platforms.Platforms.handleChangeGame) {
	                    return;
	                }
	                setTimeout(function () {
	                    window.location.href = newUrl_1;
	                }, 100);
	            }
	        }
	    };
	    FreeRoundBonusDialog.termsUrl = function () {
	        if (FreeRoundBonus_1.FreeRoundBonus.termsUrl != null && FreeRoundBonus_1.FreeRoundBonus.termsUrl !== "") {
	            var elements = document.getElementsByClassName("termsLink");
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                if (element != null) {
	                    element.setAttribute("href", FreeRoundBonus_1.FreeRoundBonus.termsUrl);
	                    element.addEventListener("click", function (e) {
	                        e.stopPropagation();
	                    });
	                }
	            }
	        }
	    };
	    FreeRoundBonusDialog.setupFRBDialogByConfiguration = function () {
	        if (AppContext_1.AppContext.gameConfiguration) {
	            if (!AppContext_1.AppContext.gameConfiguration.FRBShowDenyButton) {
	                FreeRoundBonusDialog.hideFRBDenyButton();
	            }
	            if (!AppContext_1.AppContext.gameConfiguration.FRBShowPostponeButton) {
	                FreeRoundBonusDialog.hideFRBPostPoneButton();
	            }
	        }
	    };
	    FreeRoundBonusDialog.hideFRBDenyButton = function () {
	        if (FreeRoundBonusDialog.DialogButtonDeny) {
	            FreeRoundBonusDialog.DialogButtonDeny.parentNode.removeChild(FreeRoundBonusDialog.DialogButtonDeny);
	        }
	        var infoMsg = document.getElementById("frbDialogPlayingOptions3");
	        if (infoMsg) {
	            infoMsg.parentNode.removeChild(infoMsg);
	        }
	    };
	    FreeRoundBonusDialog.hideFRBPostPoneButton = function () {
	        if (FreeRoundBonusDialog.DialogButtonPostPone) {
	            FreeRoundBonusDialog.DialogButtonPostPone.parentNode.removeChild(FreeRoundBonusDialog.DialogButtonPostPone);
	        }
	        var infoMsg = document.getElementById("frbDialogPlayingOptions3");
	        if (infoMsg) {
	            infoMsg.parentNode.removeChild(infoMsg);
	        }
	    };
	    FreeRoundBonusDialog.dialogActive = function () {
	        return !FreeRoundBonusDialog.Dialog.classList.contains("_hidden");
	    };
	    FreeRoundBonusDialog.otherOffersKeys = [];
	    FreeRoundBonusDialog.otherHasBuyFeatureKeys = [];
	    FreeRoundBonusDialog.isConfirmationDialogOpened = false;
	    return FreeRoundBonusDialog;
	}());
	exports.FreeRoundBonusDialog = FreeRoundBonusDialog;
	exports.DialogType = {
	    FRB: "FRB",
	    FFR: "FFR",
	    Other: "Other",
	};
	exports.DialogOtherGamesMessage = {
	    FRB: "FRB",
	    FFR: "FFR",
	    MIXED: "MIXED",
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Scaling_1 = __webpack_require__(8);
	var neo_games_1 = __webpack_require__(3);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var RetentionPanel = (function () {
	    function RetentionPanel() {
	        this.screen = null;
	        this.panel = null;
	        this.icons = null;
	        this.lastCount = 0;
	        this.createPanel();
	    }
	    RetentionPanel.prototype.revalidate = function () {
	        if (!RetentionPanel.canShow) {
	            return;
	        }
	        if (this.screen == null) {
	            return;
	        }
	        if (this.panel == null) {
	            return;
	        }
	        this.log("revalidate");
	        if (this.hasActiveIcon()) {
	            document.body.classList.add("retention-panel-active");
	            RetentionPanel.panelWidth = parseInt(window.getComputedStyle(this.panel).width);
	        }
	        else {
	            document.body.classList.remove("retention-panel-active");
	            RetentionPanel.panelWidth = 0;
	        }
	        this.showPeakHelpIcon();
	        Scaling_1.Scaling.LeftPanelWidth = RetentionPanel.panelWidth;
	        Scaling_1.Scaling.resizeRoot(false, false);
	    };
	    RetentionPanel.prototype.showPeakHelpIcon = function () {
	        var _this = this;
	        var peakHelp = document.querySelector(".hlpTournamentsBtn");
	        if (RetentionPanel.peakActive) {
	            var peakHelpIcon = document.querySelector(".btnTournaments");
	            var peakHelpIconBackground = document.getElementById("peakMenuBtn") != null
	                ? window.getComputedStyle(document.getElementById("peakMenuBtn")).backgroundImage
	                : false;
	            var peakHelpIconBackgroundSize = document.querySelector(".hlpMenu") != null
	                ? window.getComputedStyle(document.querySelector(".hlpMenu")).width
	                : false;
	            if (peakHelp != null && peakHelpIcon != null && peakHelpIconBackground && peakHelpIconBackgroundSize) {
	                peakHelpIcon.setAttribute("style", "background-image:" +
	                    peakHelpIconBackground +
	                    "; height:100%; background-position: center; background-size: auto " +
	                    peakHelpIconBackgroundSize +
	                    "; -webkit-transform: scale(0.66); transform: scale(0.66);");
	                peakHelp.classList.remove("_hidden");
	            }
	            else {
	                setTimeout(function () {
	                    _this.showPeakHelpIcon();
	                }, RetentionPanel.initRevalidateTimeout);
	            }
	        }
	        else {
	            peakHelp.classList.add("_hidden");
	        }
	    };
	    RetentionPanel.prototype.createPanel = function () {
	        var root = document.getElementById(RetentionPanel.panelParentId);
	        if (root == null) {
	            if (false) {
	                console.log("ERROR - panel with id " + RetentionPanel.panelParentId + " was not found");
	            }
	            return;
	        }
	        this.screen = this.createElement("div", "retentionScreen", ["screen"]);
	        this.content = this.createElement("div", "retentionContent");
	        this.panel = this.createElement("div", "retentionPanel", ["gameControls"]);
	        this.icons = this.createElement("div", "retentionPanelIcons");
	        this.createContentPlaceholder(this.content);
	        this.createIconsPlaceholder(this.icons);
	        this.screen.appendChild(this.content);
	        this.screen.appendChild(this.panel);
	        this.panel.appendChild(this.icons);
	        root.appendChild(this.screen);
	    };
	    RetentionPanel.prototype.createContentPlaceholder = function (contentHolder) {
	        if (contentHolder == null) {
	            return;
	        }
	        contentHolder.appendChild(this.createElement("div", "peakContentHolder", ["retentionContentHolder"]));
	        contentHolder.appendChild(this.createElement("div", "frbContentHolder", ["retentionContentHolder"]));
	    };
	    RetentionPanel.prototype.createIconsPlaceholder = function (iconsHolder) {
	        if (iconsHolder == null) {
	            return;
	        }
	        iconsHolder.appendChild(this.createElement("div", "peakIconHolder", ["retentionIconHolder"]));
	        iconsHolder.appendChild(this.createElement("div", "frbIconHolder", ["retentionIconHolder"]));
	        for (var i = 0; i < iconsHolder.children.length; i++) {
	            var child = iconsHolder.children[i];
	            child.addEventListener("click", function (event) {
	                BetHigherThanMinDialog_1.BetHigherThanMinDialog.closeDialog();
	            });
	        }
	    };
	    RetentionPanel.prototype.createElement = function (type, id, classList) {
	        if (id === void 0) { id = ""; }
	        if (classList === void 0) { classList = []; }
	        var elem = document.createElement(type);
	        if (!neo_common_1.StringUtils.isNullOrEmpty(id)) {
	            elem.id = id;
	        }
	        if (classList.length > 0) {
	            for (var i = 0; i < classList.length; i++) {
	                elem.classList.add(classList[i]);
	            }
	        }
	        return elem;
	    };
	    RetentionPanel.prototype.updateCount = function (currentCount) {
	        if (currentCount === void 0) { currentCount = -1; }
	        currentCount = currentCount == -1 ? this.lastCount : currentCount;
	        var isPortrait = Scaling_1.Scaling.isPortrait();
	        var slots = isPortrait
	            ? RetentionPanel.portraitMaxIconCount - currentCount
	            : RetentionPanel.landscapeMaxIconCount - currentCount;
	        if (this.iconsSlotsCount != slots) {
	            this.iconsSlotsCount = slots;
	            neo_games_1.Platforms.Platforms.iconsCountAvailable(slots);
	        }
	        var isMultiIcon = this.isMultiIcon(currentCount);
	        this.icons.classList.remove("retention-icon-count-" + this.lastCount, "retention-icon-count-" + this.lastCount + "-m");
	        this.icons.classList.add("retention-icon-count-" + currentCount + (isMultiIcon || RetentionPanel.peakActive ? "-m" : ""));
	        this.lastCount = currentCount;
	    };
	    RetentionPanel.prototype.isMultiIcon = function (count) {
	        if (count == 0 || count > 1) {
	            return false;
	        }
	        var style = window.getComputedStyle(this.icons);
	        var width = parseInt(style.width);
	        var height = parseInt(style.height);
	        return width != 0 ? height / width > 1.5 : false;
	    };
	    RetentionPanel.prototype.hasActiveIcon = function () {
	        if (this.panel == null) {
	            return false;
	        }
	        if (this.icons == null) {
	            return false;
	        }
	        var result = false;
	        var count = 0;
	        var children = this.icons.children;
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            if (child != null) {
	                var iconChildren = child.children;
	                if (child.id == "peakIconHolder") {
	                    RetentionPanel.peakActive = iconChildren.length > 0;
	                }
	                for (var j = 0; j < iconChildren.length; j++) {
	                    var iconChild = iconChildren[j];
	                    if (iconChild.getAttribute("active") == "true") {
	                        result = true;
	                        count++;
	                    }
	                }
	            }
	        }
	        this.updateCount(count);
	        return result;
	    };
	    RetentionPanel.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("RetentionPanel", "RetentionPanel " + s);
	        }
	    };
	    RetentionPanel.getInstance = function () {
	        if (RetentionPanel.instance == null) {
	            RetentionPanel.instance = new RetentionPanel();
	        }
	        return RetentionPanel.instance;
	    };
	    RetentionPanel.initialize = function () {
	        RetentionPanel.getInstance();
	    };
	    RetentionPanel.show = function () {
	        RetentionPanel.canShow = true;
	        RetentionPanel.revalidate();
	        Scaling_1.Scaling.Emitter.on(Scaling_1.Scaling.EventResize, function () {
	            RetentionPanel.getInstance().updateCount();
	            RetentionPanel.getInstance().revalidate();
	        });
	        setTimeout(function () {
	            RetentionPanel.revalidate();
	        }, RetentionPanel.initRevalidateTimeout);
	    };
	    RetentionPanel.revalidate = function () {
	        RetentionPanel.getInstance().revalidate();
	    };
	    RetentionPanel.panelParentId = "root";
	    RetentionPanel.initRevalidateTimeout = 500;
	    RetentionPanel.landscapeMaxIconCount = window["CHANNEL"] === "mobile" ? 4 : 5;
	    RetentionPanel.portraitMaxIconCount = 2;
	    RetentionPanel.panelWidth = 0;
	    RetentionPanel.canShow = false;
	    RetentionPanel.peakActive = false;
	    return RetentionPanel;
	}());
	exports.RetentionPanel = RetentionPanel;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Languages_1 = __webpack_require__(28);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var DataManager_1 = __webpack_require__(26);
	var GameData_1 = __webpack_require__(24);
	var neo_games_1 = __webpack_require__(3);
	var ModuleManager_1 = __webpack_require__(29);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Jackpot_1 = __webpack_require__(36);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var BetHigherThanMinDialog = (function () {
	    function BetHigherThanMinDialog() {
	    }
	    BetHigherThanMinDialog.openDialog = function () {
	        if (!this.canNotifyBetHigherThanMin() ||
	            (this._wasOpened && !this._reopenDialog) ||
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.dialogActive()) {
	            return;
	        }
	        var minBet = Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, this.getMinBet().toString()) +
	            " " +
	            DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	        var message = Languages_1.Languages.getRid("EXCEED_MIN_BET", minBet);
	        var dialogData = {
	            text: message,
	            actions: [
	                {
	                    type: "restore",
	                    text: Languages_1.Languages.getRid("CONTINUE"),
	                    customData: neo_games_1.Communication.Game.GameModules.Base,
	                },
	            ],
	            special: true,
	        };
	        AppContext_1.AppContext.current.showDialog(message, false, null, null, null, dialogData);
	        this._wasOpened = true;
	        this._isOpened = true;
	    };
	    BetHigherThanMinDialog.canOpenDialog = function () {
	        return (AppContext_1.AppContext.gameConfiguration.NotifyBetHigherThanMin &&
	            !this.isMinBet() &&
	            !ModuleManager_1.ModuleManager.gambleActive() &&
	            !(FreeRoundBonus_1.FreeRoundBonus.status && FreeRoundBonus_1.FreeRoundBonus.status === "active") &&
	            !Jackpot_1.Jackpot.hasMiniGame() &&
	            !this._wasOpened &&
	            this._gameStartedWithFeature);
	    };
	    BetHigherThanMinDialog.closeDialog = function (changeBet) {
	        if (this._isOpened) {
	            this._isOpened = false;
	            AppContext_1.AppContext.current.closeDialog();
	        }
	        if (changeBet) {
	            this._wasOpened = true;
	        }
	    };
	    BetHigherThanMinDialog.hideDialog = function () {
	        if (this._isOpened) {
	            this._reopenDialog = true;
	        }
	    };
	    BetHigherThanMinDialog.restoreDialog = function () {
	        if (this._reopenDialog) {
	            this.openDialog();
	            this._reopenDialog = false;
	        }
	    };
	    BetHigherThanMinDialog.setOpenedStatus = function () {
	        if (this._isOpened) {
	            this._isOpened = false;
	        }
	    };
	    BetHigherThanMinDialog.gameFeatureActive = function () {
	        return (ModuleManager_1.ModuleManager.gambleActive() ||
	            (FreeRoundBonus_1.FreeRoundBonus.status && FreeRoundBonus_1.FreeRoundBonus.status === "active") ||
	            Jackpot_1.Jackpot.hasMiniGame() ||
	            !DataManager_1.DataManager.GameRoundClosed);
	    };
	    BetHigherThanMinDialog.isMinBet = function () {
	        BetManager_1.BetManager.updateBetPosition();
	        return BetManager_1.BetManager.minBet;
	    };
	    BetHigherThanMinDialog.canNotifyBetHigherThanMin = function () {
	        return (!this.isMinBet() &&
	            AppContext_1.AppContext.gameConfiguration.NotifyBetHigherThanMin &&
	            this._gameStartedWithFeature &&
	            !this.gameFeatureActive());
	    };
	    BetHigherThanMinDialog.getMinBet = function () {
	        return Math.min.apply(Math, BetManager_1.BetManager.TotalBets);
	    };
	    BetHigherThanMinDialog.getGameStartedWithoutFeature = function () {
	        if (this._gameStarted) {
	            this._gameStartedWithFeature = this.gameFeatureActive();
	            this._gameStarted = false;
	        }
	        return !this._gameStartedWithFeature && AppContext_1.AppContext.gameConfiguration.NotifyBetHigherThanMin;
	    };
	    BetHigherThanMinDialog._wasOpened = false;
	    BetHigherThanMinDialog._isOpened = false;
	    BetHigherThanMinDialog._reopenDialog = false;
	    BetHigherThanMinDialog._gameStartedWithFeature = false;
	    BetHigherThanMinDialog._gameStarted = true;
	    return BetHigherThanMinDialog;
	}());
	exports.BetHigherThanMinDialog = BetHigherThanMinDialog;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_games_1 = __webpack_require__(3);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var ModuleManager_1 = __webpack_require__(29);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var GameApp_1 = __webpack_require__(1);
	var RetentionPanel_1 = __webpack_require__(46);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var FreeRoundBonusIcon = (function () {
	    function FreeRoundBonusIcon() {
	    }
	    FreeRoundBonusIcon.initialize = function () {
	        FreeRoundBonusIcon.IconNew = document.getElementById("frbIconNew");
	        FreeRoundBonusIcon.IconActive = document.getElementById("frbIconActive");
	        FreeRoundBonusIcon.bindEvents();
	    };
	    FreeRoundBonusIcon.showIcon = function (type) {
	        FreeRoundBonusIcon.hideAllIcons();
	        switch (type) {
	            case "new":
	                DataManager_1.DataManager.showDataElements("helpFRB", "block");
	                DataManager_1.DataManager.showDataElements("helpFRB_flex", "flex");
	                FreeRoundBonusIcon.showElement(FreeRoundBonusIcon.IconNew);
	                if (FreeRoundBonusIcon.IconNew != null) {
	                    FreeRoundBonusIcon.IconNew.classList.add("_disabled");
	                }
	                RetentionPanel_1.RetentionPanel.revalidate();
	                break;
	            case "active":
	                DataManager_1.DataManager.showDataElements("helpFRB", "block");
	                DataManager_1.DataManager.showDataElements("helpFRB_flex", "flex");
	                FreeRoundBonusIcon.showElement(FreeRoundBonusIcon.IconActive);
	                if (FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	                    if (FreeRoundBonusIcon.IconActive != null) {
	                        FreeRoundBonusIcon.IconActive.classList.add("_disabled");
	                    }
	                }
	                RetentionPanel_1.RetentionPanel.revalidate();
	                break;
	        }
	        FreeRoundBonusIcon.toggleCumulative();
	    };
	    FreeRoundBonusIcon.toggleCumulative = function () {
	        if (FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (FreeRoundBonusIcon.IconActive != null) {
	                FreeRoundBonusIcon.IconActive.classList.add("cumulativeFrb");
	            }
	        }
	        else {
	            if (FreeRoundBonusIcon.IconActive != null) {
	                FreeRoundBonusIcon.IconActive.classList.remove("cumulativeFrb");
	            }
	        }
	    };
	    FreeRoundBonusIcon.bindEvents = function () {
	        if (FreeRoundBonusIcon.IconNew != null) {
	            FreeRoundBonusIcon.IconNew.onclick = FreeRoundBonusIcon.handleIconClick.bind(this, FreeRoundBonusIcon.onNew);
	        }
	        if (FreeRoundBonusIcon.IconActive != null) {
	            FreeRoundBonusIcon.IconActive.onclick = FreeRoundBonusIcon.handleIconClick.bind(this, FreeRoundBonusIcon.onActive);
	        }
	    };
	    FreeRoundBonusIcon.hideAllIcons = function () {
	        DataManager_1.DataManager.hideDataElements("helpFRB");
	        FreeRoundBonusIcon.hideElement(FreeRoundBonusIcon.IconNew);
	        FreeRoundBonusIcon.hideElement(FreeRoundBonusIcon.IconActive);
	    };
	    FreeRoundBonusIcon.disableActiveIcon = function () {
	        if (FreeRoundBonusIcon.IconNew != null &&
	            !FreeRoundBonusIcon.IconNew.classList.contains("_hidden") &&
	            !FreeRoundBonusIcon.IconNew.classList.contains("_disabled")) {
	            FreeRoundBonusIcon.IconNew.classList.add("_disabled");
	        }
	        if (FreeRoundBonusIcon.IconActive != null &&
	            !FreeRoundBonusIcon.IconActive.classList.contains("_hidden") &&
	            !FreeRoundBonusIcon.IconActive.classList.contains("_disabled")) {
	            FreeRoundBonusIcon.IconActive.classList.add("_disabled");
	        }
	    };
	    FreeRoundBonusIcon.enableActiveIcon = function () {
	        if (DataManager_1.DataManager.Autoplay && (parseFloat(DataManager_1.DataManager.AutoplayCount) > 0 || DataManager_1.DataManager.AutoplayCount === "∞")) {
	            return;
	        }
	        if (FreeRoundBonusIcon.IconNew != null &&
	            !FreeRoundBonusIcon.IconNew.classList.contains("_hidden") &&
	            FreeRoundBonusIcon.IconNew.classList.contains("_disabled") &&
	            !FreeRoundBonusDialog_1.FreeRoundBonusDialog.dialogActive()) {
	            FreeRoundBonusIcon.IconNew.classList.remove("_disabled");
	        }
	        if (FreeRoundBonusIcon.IconActive != null &&
	            !FreeRoundBonusIcon.IconActive.classList.contains("_hidden") &&
	            FreeRoundBonusIcon.IconActive.classList.contains("_disabled")) {
	            FreeRoundBonusIcon.IconActive.classList.remove("_disabled");
	        }
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    FreeRoundBonusIcon.showElement = function (element) {
	        if (element != null) {
	            if (element.classList.contains("_disabled")) {
	                element.classList.remove("_disabled");
	            }
	            if (element.classList.contains("_hidden")) {
	                element.classList.remove("_hidden");
	            }
	            if (element.getAttribute("active") != "true") {
	                element.setAttribute("active", "true");
	            }
	        }
	    };
	    FreeRoundBonusIcon.hideElement = function (element) {
	        if (element != null) {
	            if (element.classList.contains("_disabled")) {
	                element.classList.remove("_disabled");
	            }
	            if (!element.classList.contains("_hidden")) {
	                element.classList.add("_hidden");
	            }
	            if (element.getAttribute("active") != "false") {
	                element.setAttribute("active", "false");
	            }
	        }
	    };
	    FreeRoundBonusIcon.disableElement = function (element) {
	        if (element != null) {
	            if (!element.classList.contains("_disabled")) {
	                element.classList.add("_disabled");
	            }
	            if (element.classList.contains("_hidden")) {
	                element.classList.remove("_hidden");
	            }
	            if (element.getAttribute("active") != "true") {
	                element.setAttribute("active", "true");
	            }
	        }
	    };
	    FreeRoundBonusIcon.isDisabled = function () {
	        var isDis = false;
	        if (FreeRoundBonusIcon.IconNew != null && FreeRoundBonusIcon.IconNew.classList.contains("_disabled")) {
	            isDis = true;
	        }
	        if (FreeRoundBonusIcon.IconActive != null && FreeRoundBonusIcon.IconActive.classList.contains("_disabled")) {
	            isDis = true;
	        }
	        return isDis;
	    };
	    FreeRoundBonusIcon.handleIconClick = function (callback, event) {
	        var element = event.target;
	        if (!FreeRoundBonusIcon.isDisabled() && element != null) {
	            element.classList.add("_loading");
	            GameApp_1.GameApp.gameClient
	                .sendFreeRoundsOffersRequest(GameApp_1.GameApp.key)
	                .then(function (response) {
	                if (response != null) {
	                    if (response.currentOffer != null || response.otherOffers != null) {
	                        callback();
	                    }
	                    else {
	                        FreeRoundBonus_1.FreeRoundBonus.expiredFreeRounds();
	                    }
	                }
	                else {
	                    FreeRoundBonus_1.FreeRoundBonus.expiredFreeRounds();
	                }
	                return null;
	            })
	                .finally(function () {
	                element.classList.remove("_loading");
	            });
	        }
	    };
	    FreeRoundBonusIcon.onNew = function () {
	        if (!FreeRoundBonusIcon.isDisabled()) {
	            PlayList_1.PlayList.play("SND_Click");
	            if (FreeRoundBonus_1.FreeRoundBonus.id != null) {
	                FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("new");
	            }
	            else {
	                if (FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0) {
	                    FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("other");
	                }
	            }
	            ModuleManager_1.ModuleManager.disableBase();
	        }
	    };
	    FreeRoundBonusIcon.onActive = function () {
	        if (!FreeRoundBonusIcon.isDisabled() && parseInt(FreeRoundBonus_1.FreeRoundBonus.remainingCount()) > 0) {
	            PlayList_1.PlayList.play("SND_Click");
	            FreeRoundBonusDialog_1.FreeRoundBonusDialog.showDialog("active");
	            ModuleManager_1.ModuleManager.disableBase();
	            ModuleManager_1.ModuleManager.resetSceneAsOnCollect(GameModules.Base);
	        }
	    };
	    return FreeRoundBonusIcon;
	}());
	exports.FreeRoundBonusIcon = FreeRoundBonusIcon;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var Languages_1 = __webpack_require__(28);
	var AppContext_1 = __webpack_require__(5);
	var GameApp_1 = __webpack_require__(1);
	var DataManager_1 = __webpack_require__(26);
	var GameManager_1 = __webpack_require__(23);
	var PlayList_1 = __webpack_require__(33);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var BetManager_1 = __webpack_require__(25);
	var MessageManager_1 = __webpack_require__(42);
	var Jackpot_1 = __webpack_require__(36);
	var BuyFeature_1 = __webpack_require__(30);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var ResponsibleDialog1 = (function () {
	    function ResponsibleDialog1() {
	    }
	    ResponsibleDialog1.openDialog = function (data) {
	        if (AppContext_1.AppContext.gameConfiguration.RCIInfo) {
	            GameManager_1.GameManager.gameClient.getRealityCheckInfo().then(function (response) {
	                ResponsibleDialog1.openDialogContinue(data, response);
	            });
	        }
	        else {
	            ResponsibleDialog1.openDialogContinue(data);
	        }
	    };
	    ResponsibleDialog1.openDialogContinue = function (data, info) {
	        if (info === void 0) { info = null; }
	        if (ResponsibleDialog1._element == null) {
	            ResponsibleDialog1._element = document.getElementById("responsibleGamingDialog");
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(info) &&
	            !neo_common_1.Utils.isNullOrUndefined(info["messages"]) &&
	            info["messages"].length > 0) {
	            MessageManager_1.MessageManager.postpone(ResponsibleDialog1.onContinue, info);
	            return;
	        }
	        var elementWin = document.getElementById("rciWin");
	        var elementLost = document.getElementById("rciLost");
	        var totalGain = 0;
	        neo_games_1.Platforms.Platforms.dialogOpened("rci", true);
	        if (info != null) {
	            if (info.totalGain <= 0) {
	                elementWin.style.display = "none";
	                elementLost.style.display = "block";
	                totalGain = -1 * info.totalGain;
	            }
	            else {
	                elementWin.style.display = "block";
	                elementLost.style.display = "none";
	                totalGain = info.totalGain;
	            }
	        }
	        else {
	            elementWin.style.display = "none";
	            elementLost.style.display = "none";
	        }
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.hideDialog();
	        AppContext_1.AppContext.current.closeDialog();
	        FreeRoundBonusDialog_1.FreeRoundBonusDialog.hideDialog();
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        Jackpot_1.Jackpot.closeAllHistoryDialogs();
	        ResponsibleDialog1.opened = true;
	        if (ResponsibleDialog1._continueButton == null) {
	            ResponsibleDialog1._continueButton = document.getElementById("continueButton");
	            if (ResponsibleDialog1._continueButton != null) {
	                ResponsibleDialog1._continueButton.onclick = ResponsibleDialog1.onContinue;
	                if (data.continue) {
	                    ResponsibleDialog1._continueButton.style.display = "inline-block";
	                }
	                else {
	                    ResponsibleDialog1._continueButton.style.display = "none";
	                }
	            }
	        }
	        if (ResponsibleDialog1._historyButton == null) {
	            ResponsibleDialog1._historyButton = document.getElementById("historyButton");
	            if (ResponsibleDialog1._historyButton != null) {
	                if (data.history) {
	                    ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onHistory;
	                    ResponsibleDialog1._historyButton.style.display = "inline-block";
	                }
	                else {
	                    if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	                        ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onGameRoundHistory;
	                        ResponsibleDialog1._historyButton.style.display = "inline-block";
	                    }
	                    else {
	                        if (AppContext_1.AppContext.gameConfiguration.RCIShowHistoryButton) {
	                            ResponsibleDialog1._historyButton.onclick = ResponsibleDialog1.onGameRoundHistory;
	                            ResponsibleDialog1._historyButton.style.display = "inline-block";
	                        }
	                        else {
	                            ResponsibleDialog1._historyButton.style.display = "none";
	                        }
	                    }
	                }
	            }
	        }
	        if (ResponsibleDialog1._closeButton == null) {
	            ResponsibleDialog1._closeButton = document.getElementById("closeButton");
	            if (ResponsibleDialog1._closeButton != null) {
	                ResponsibleDialog1._closeButton.onclick = ResponsibleDialog1.onClose;
	                if (data.exit) {
	                    ResponsibleDialog1._closeButton.style.display = "inline-block";
	                }
	                else {
	                    ResponsibleDialog1._closeButton.style.display = "none";
	                }
	            }
	        }
	        var startTime = (Date.now() - data.startTime.getTime()) / 1000;
	        var interval = "";
	        var t = startTime / 60;
	        var h = parseInt(t / 60 + "") + "";
	        if (parseInt(h) < 10) {
	            h = "0" + h;
	        }
	        var m = parseInt((t % 60) + "") + "";
	        if (parseInt(m) < 10) {
	            m = "0" + m;
	        }
	        if (data.interval % 60 === 0) {
	            interval = (data.interval / 60).toFixed(0);
	        }
	        else {
	            interval = (data.interval / 60).toFixed(2);
	        }
	        DataManager_1.DataManager.updateDataElement("RESPONSIBLE_DIALOG_1", Math.floor(t) + "");
	        if (AppContext_1.AppContext.gameConfiguration.RCIInfo) {
	            if (info != null) {
	                if (DataManager_1.DataManager.DisplayCurrencies.hasOwnProperty(info.currency)) {
	                    info.currency = DataManager_1.DataManager.DisplayCurrencies[info.currency];
	                }
	                if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                    DataManager_1.DataManager.updateDataElement("RESPONSIBLE_DIALOG_1_SUM", neo_common_1.NumberUtils.devide(totalGain, BetManager_1.BetManager.CoinSize).toString() + " " + info.currency);
	                }
	                else {
	                    DataManager_1.DataManager.updateDataElement("RESPONSIBLE_DIALOG_1_SUM", Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, totalGain.toString()) + " " + info.currency);
	                }
	            }
	        }
	        DataManager_1.DataManager.updateDataElement("RESPONSIBLE_DIALOG_1_INTERVAL", interval);
	        var elementRciIntervalInfo = document.getElementById("rciIntervalInfo");
	        if (AppContext_1.AppContext.gameConfiguration.RCIIntervalInfo) {
	            if (elementRciIntervalInfo != null) {
	                elementRciIntervalInfo.style.display = "block";
	            }
	        }
	        else {
	            if (elementRciIntervalInfo != null) {
	                elementRciIntervalInfo.style.display = "none";
	            }
	        }
	        if (ResponsibleDialog1._element != null) {
	            if (ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
	                ResponsibleDialog1._element.classList.remove(ResponsibleDialog1.DisabledClass);
	            }
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.errorGroup("ResponsibleDialog1", "ERROR no responsibleDialog1");
	            }
	        }
	    };
	    ResponsibleDialog1.onContinue = function () {
	        neo_games_1.Platforms.Platforms.dialogOpened("rci", false);
	        ResponsibleDialog1.opened = false;
	        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
	            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        GameApp_1.GameApp.continue();
	        GameManager_1.GameManager.closeResponsibleDialog1();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.restoreDialog();
	        FreeRoundBonus_1.FreeRoundBonus.reopenFreeRounds();
	        BuyFeature_1.BuyFeature.restore();
	    };
	    ResponsibleDialog1.onHistory = function () {
	        neo_games_1.Platforms.Platforms.dialogOpened("rci", false);
	        ResponsibleDialog1.opened = false;
	        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
	            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        GameApp_1.GameApp.closeRealityCheck();
	        GameApp_1.GameApp.history();
	        GameManager_1.GameManager.closeResponsibleDialog1();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.restoreDialog();
	        FreeRoundBonus_1.FreeRoundBonus.reopenFreeRounds();
	        BuyFeature_1.BuyFeature.restore();
	    };
	    ResponsibleDialog1.onGameRoundHistory = function () {
	        neo_games_1.Platforms.Platforms.dialogOpened("rci", false);
	        ResponsibleDialog1.opened = false;
	        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
	            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        GameApp_1.GameApp.closeRealityCheck();
	        if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	            GameApp_1.GameApp.openGameRoundHistoryFromUrl();
	        }
	        else {
	            GameApp_1.GameApp.openGameRoundHistory();
	        }
	        GameManager_1.GameManager.closeResponsibleDialog1();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.restoreDialog();
	        FreeRoundBonus_1.FreeRoundBonus.reopenFreeRounds();
	    };
	    ResponsibleDialog1.onClose = function () {
	        neo_games_1.Platforms.Platforms.dialogOpened("rci", false);
	        ResponsibleDialog1.opened = false;
	        if (!ResponsibleDialog1._element.classList.contains(ResponsibleDialog1.DisabledClass)) {
	            ResponsibleDialog1._element.classList.add(ResponsibleDialog1.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        neo_games_1.Platforms.Platforms.exitHandler = "responsibleDialog";
	        GameApp_1.GameApp.exit();
	    };
	    ResponsibleDialog1.opened = false;
	    ResponsibleDialog1.DisabledClass = "_disabled";
	    ResponsibleDialog1.showResponsibleDialog1OnCollect = false;
	    return ResponsibleDialog1;
	}());
	exports.ResponsibleDialog1 = ResponsibleDialog1;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var AppContext_1 = __webpack_require__(5);
	var neo_games_1 = __webpack_require__(3);
	var Dialog_1 = __webpack_require__(51);
	var BalanceManager_1 = __webpack_require__(27);
	var PlayList_1 = __webpack_require__(33);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var BuyFeature_1 = __webpack_require__(30);
	var CashierDialog = (function () {
	    function CashierDialog() {
	    }
	    CashierDialog.openDialog = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("CashierDialog", "openDialog()");
	        }
	        neo_games_1.Platforms.Platforms.dialogOpened("cashier", true);
	        CashierDialog.opened = true;
	        CashierDialog._element = document.getElementById("cashierDialog");
	        if (CashierDialog._element != null) {
	            CashierDialog._cashierButton = document.getElementById("cashierButton");
	            if (CashierDialog._cashierButton != null) {
	                CashierDialog._cashierButton.onclick = CashierDialog.onCashier;
	            }
	            CashierDialog._refreshButton = document.getElementById("refreshButton");
	            if (CashierDialog._refreshButton != null) {
	                if (AppContext_1.AppContext.gameConfiguration.CashierMessageShowRefreshBalanceButton) {
	                    CashierDialog._refreshButton.onclick = CashierDialog.onRefreshBalance;
	                }
	                else {
	                    CashierDialog._refreshButton.style.display = "none";
	                }
	            }
	            CashierDialog._closeButton = document.getElementById("cashierCloseButton");
	            if (CashierDialog._closeButton != null) {
	                CashierDialog._closeButton.onclick = CashierDialog.onClose;
	            }
	            CashierDialog._closeButtonIcon = document.getElementById("cashierCloseButtonIcon");
	            if (CashierDialog._closeButtonIcon != null) {
	                CashierDialog._closeButtonIcon.onclick = CashierDialog.onClose;
	            }
	            if (CashierDialog._element.classList.contains(Dialog_1.Dialog.DisabledClass)) {
	                CashierDialog._element.classList.remove(Dialog_1.Dialog.DisabledClass);
	            }
	        }
	    };
	    CashierDialog.onCashier = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("CashierDialog", "onCashier()");
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.CashierUrl)) {
	            neo_games_1.Platforms.Platforms.gotoCasier({
	                reason: "InsufficientFunds",
	                target: AppContext_1.AppContext.gameConfiguration.CashierUrl,
	            });
	            if (neo_games_1.Platforms.Platforms.handleOpenCashierPage) {
	                return;
	            }
	            window.open(AppContext_1.AppContext.gameConfiguration.CashierUrl, "_self");
	        }
	        else {
	            neo_games_1.Platforms.Platforms.gotoCasier();
	        }
	    };
	    CashierDialog.onRefreshBalance = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("CashierDialog", "onRefreshBalance()");
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        BalanceManager_1.BalanceManager.refreshBalance();
	    };
	    CashierDialog.onClose = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("CashierDialog", "onClose()");
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        CashierDialog.opened = false;
	        neo_games_1.Platforms.Platforms.dialogOpened("cashier", false);
	        if (!CashierDialog._element.classList.contains(Dialog_1.Dialog.DisabledClass)) {
	            CashierDialog._element.classList.add(Dialog_1.Dialog.DisabledClass);
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.id != null || FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        }
	        BuyFeature_1.BuyFeature.restore();
	    };
	    CashierDialog.opened = false;
	    return CashierDialog;
	}());
	exports.CashierDialog = CashierDialog;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var Languages_1 = __webpack_require__(28);
	var FrameTimer_1 = __webpack_require__(9);
	var AppContext_1 = __webpack_require__(5);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var GameApp_1 = __webpack_require__(1);
	var ModuleManager_1 = __webpack_require__(29);
	var BaseModel_1 = __webpack_require__(43);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var Dialog = (function () {
	    function Dialog(app) {
	        this._app = app;
	        this._element = document.getElementById("dialog");
	        this._elementHeading = document.getElementById("dialogHeading");
	        this._elementCode = document.getElementById("errorCode");
	        this._elementText = document.getElementById("dialogText");
	        this._elementButton = document.getElementById("dialogButton");
	        this._elementButtonReload = document.getElementById("dialogReloadButton");
	        this._elementCustomButtons = document.getElementById("dialogCustomButtons");
	        this._elementInfo = document.getElementById("dialogInfo");
	        this._elementError = document.getElementById("dialogError");
	        if (this._element != null && !this._element.classList.contains(Dialog.DisabledClass)) {
	            this._element.classList.add(Dialog.DisabledClass);
	        }
	        if (this._elementInfo != null) {
	            this._elementInfo.style.display = "none";
	        }
	        if (this._elementError != null) {
	            this._elementError.style.display = "none";
	        }
	        this._timer = FrameTimer_1.CreateFrameTimer("dialogTimer");
	        this._timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.closeDialog.bind(this));
	        this.onClickError = this.onClickError.bind(this);
	        this.onClickRefresh = this.onClickRefresh.bind(this);
	        this._customData = null;
	    }
	    Dialog.prototype.openDialog = function (text, code, errorId, error, special, gameRoundId, customData) {
	        if (code === void 0) { code = ""; }
	        if (errorId === void 0) { errorId = ""; }
	        if (error === void 0) { error = false; }
	        if (special === void 0) { special = false; }
	        if (gameRoundId === void 0) { gameRoundId = "0"; }
	        if (customData === void 0) { customData = null; }
	        this._customData = customData;
	        if (false) {
	            neo_common_1.Logger.debugGroup("Dialog", ("openDialog('" + text + "', code: '" + code + "', errorId: '" + errorId + "', error: " + error + ", special: " + special + ", ") +
	                ("gameRoundId: " + gameRoundId + ", customData: " + (customData ? JSON.stringify(customData) : "") + ")"));
	        }
	        neo_games_1.Platforms.Platforms.dialogOpened("default", true);
	        if (this._element != null) {
	            var ultraSpecial = !neo_common_1.Utils.isNullOrUndefined(this._customData) &&
	                !neo_common_1.Utils.isNullOrUndefined(this._customData.data) &&
	                !neo_common_1.Utils.isNullOrUndefined(this._customData.data.ultraSpecial) &&
	                this._customData.data.ultraSpecial === true;
	            if (this._elementText != null) {
	                this._elementText.innerHTML = text;
	            }
	            if (this._elementCode != null) {
	                if (code !== "" && this._elementCode != null && !special) {
	                    if (errorId === "") {
	                        errorId = "0";
	                    }
	                    var errorString = gameRoundId + "-" + errorId;
	                    code = "CODE_" + code.replace("-", "_");
	                    var errorValue = Languages_1.Languages.getRid(code, errorString);
	                    this._elementCode.textContent = errorValue.replace(/ /g, "");
	                    this._elementCode.style.display = "block";
	                }
	                else {
	                    this._elementCode.style.display = "none";
	                }
	            }
	            if (error && !ultraSpecial) {
	                if (this._element.classList.contains(Dialog.InfoClass)) {
	                    this._element.classList.remove(Dialog.InfoClass);
	                }
	                if (!this._element.classList.contains(Dialog.ErrorClass)) {
	                    this._element.classList.add(Dialog.ErrorClass);
	                }
	                if (this._elementInfo != null) {
	                    this._elementInfo.style.display = "none";
	                }
	                if (this._elementError != null) {
	                    this._elementError.style.display = "block";
	                }
	                if (this._elementHeading != null) {
	                    this._elementHeading.textContent = Languages_1.Languages.getRid("DLG_ERROR");
	                }
	                if (this._elementButtonReload != null) {
	                    this._elementButtonReload.style.display = "none";
	                }
	                if (this._elementButton != null) {
	                    this._elementButton.style.display = "block";
	                    this._elementButton.onclick = this.onClickError;
	                }
	            }
	            else {
	                if (!this._element.classList.contains(Dialog.InfoClass)) {
	                    this._element.classList.add(Dialog.InfoClass);
	                }
	                if (this._element.classList.contains(Dialog.ErrorClass)) {
	                    this._element.classList.remove(Dialog.ErrorClass);
	                }
	                if (this._elementInfo != null) {
	                    this._elementInfo.style.display = "block";
	                }
	                if (this._elementError != null) {
	                    this._elementError.style.display = "none";
	                }
	                if (this._elementHeading != null) {
	                    this._elementHeading.textContent = Languages_1.Languages.getRid("DLG_INFO");
	                }
	                if (this._elementButton != null) {
	                    this._elementButton.style.display = "none";
	                }
	                if (this._elementButtonReload) {
	                    this._elementButtonReload.style.display = "none";
	                }
	                if (ultraSpecial) {
	                    if (this._elementCode != null) {
	                        this._elementCode.style.display = "none";
	                    }
	                    if (this._elementButton != null) {
	                        this._elementButton.style.display = "block";
	                        this._elementButton.onclick = this.onClickError;
	                    }
	                }
	                else if (special) {
	                    if (this._elementCode != null) {
	                        this._elementCode.style.display = "none";
	                    }
	                    if (this._elementButtonReload != null) {
	                        this._elementButtonReload.style.display = "block";
	                        this._elementButtonReload.onclick = this.onClickRefresh;
	                    }
	                }
	                else {
	                    if (this._timer.isPlaying()) {
	                        neo_games_1.Platforms.Platforms.dialogOpened("default", false);
	                    }
	                    this._timer.stop();
	                    this._timer.start(180);
	                }
	            }
	            if (!neo_common_1.Utils.isNullOrUndefined(this._customData.data) &&
	                !neo_common_1.Utils.isNullOrUndefined(this._customData.data.actions)) {
	                this.handleCustomActions(this._customData.data.actions);
	            }
	            if (this._element.classList.contains(Dialog.DisabledClass)) {
	                this._element.classList.remove(Dialog.DisabledClass);
	            }
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.errorGroup("Dialog", "ERROR no dialog");
	            }
	        }
	    };
	    Dialog.prototype.closeDialog = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Dialog", "closeDialog()");
	        }
	        this._timer.stop();
	        neo_games_1.Platforms.Platforms.dialogOpened("default", false);
	        if (!this._element.classList.contains(Dialog.DisabledClass)) {
	            this._element.classList.add(Dialog.DisabledClass);
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.id != null || FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        }
	        this.hideAllButtons();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.setOpenedStatus();
	    };
	    Dialog.prototype.onClickError = function () {
	        var clientHost = AppContext_1.AppContext.clientHost;
	        if (clientHost) {
	            var request = null;
	            if (!neo_common_1.Utils.isNullOrUndefined(this._customData)) {
	                var dialogRequest = this._customData;
	                request = dialogRequest.error;
	                request.reason = dialogRequest.error.errorMessageTitle;
	            }
	            if (false) {
	                neo_common_1.Logger.debugGroup("Dialog", "onClickError -> calling client host '" + AppContext_1.AppContext.gameDefinition.ClientHostType + ".endGame()', request: ", request);
	            }
	            neo_games_1.Platforms.Platforms.exitHandler = "dialog";
	            neo_games_1.Platforms.Platforms.gameClosing();
	            clientHost.endGame(this._app, request);
	        }
	    };
	    Dialog.prototype.onClickRefresh = function () {
	        neo_games_1.Platforms.Platforms.gameReloading();
	        if (neo_games_1.Platforms.Platforms.handleGameReload) {
	            return;
	        }
	        window.location.reload(true);
	    };
	    Dialog.prototype.handleCustomActions = function (actions) {
	        if (actions.length > 0) {
	            this.hideAllButtons();
	            var buttons = [];
	            var imageWidthCorrection = 0.82;
	            var baseWidth = 0;
	            var baseFontSize = 0;
	            var maxWidth = 0;
	            for (var i = 0; i < actions.length; i++) {
	                var currentAction = actions[i];
	                if (currentAction && currentAction["type"]) {
	                    var button = document.createElement("div");
	                    button.classList.add("dialogBtn", "customDialogBtn");
	                    this._elementCustomButtons.appendChild(button);
	                    baseWidth =
	                        parseInt(window.getComputedStyle(button).getPropertyValue("width")) * imageWidthCorrection;
	                    baseFontSize = parseInt(window.getComputedStyle(button).getPropertyValue("font-size"));
	                    var currentWidth = 0;
	                    if (currentAction["text"]) {
	                        currentWidth = this.getButtonTextWidth(currentAction["text"], baseFontSize);
	                        button.textContent = currentAction["text"];
	                    }
	                    if (currentWidth > maxWidth) {
	                        maxWidth = currentWidth;
	                    }
	                    switch (currentAction["type"]) {
	                        case "continue":
	                            button.onclick = this.onClickContinue.bind(this);
	                            break;
	                        case "exit":
	                            button.onclick = this.onClickClose;
	                            break;
	                        case "history":
	                            button.onclick = this.onClickHistory;
	                            break;
	                        case "reload":
	                            button.onclick = this.onClickReload;
	                            break;
	                        case "restore":
	                            button.onclick = this.onClickRestore.bind(this, currentAction["customData"]);
	                            break;
	                    }
	                    buttons.push(button);
	                }
	            }
	            if (maxWidth > baseWidth) {
	                var newFontSize = Math.round(baseFontSize * (baseWidth / maxWidth));
	                for (var i = 0; i < buttons.length; i++) {
	                    buttons[i].style.fontSize = newFontSize + "px";
	                }
	            }
	        }
	    };
	    Dialog.prototype.getButtonTextWidth = function (text, fontSize) {
	        var elem = document.createElement("span");
	        elem.textContent = text;
	        elem.style.fontSize = fontSize + "px";
	        document.body.appendChild(elem);
	        var width = elem.offsetWidth;
	        document.body.removeChild(elem);
	        return width;
	    };
	    Dialog.prototype.hideAllButtons = function () {
	        if (this._elementButton != null) {
	            this._elementButton.style.display = "none";
	        }
	        if (this._elementButtonReload != null) {
	            this._elementButtonReload.style.display = "none";
	        }
	        while (this._elementCustomButtons.firstChild) {
	            this._elementCustomButtons.removeChild(this._elementCustomButtons.firstChild);
	        }
	    };
	    Dialog.prototype.onClickClose = function () {
	        neo_games_1.Platforms.Platforms.exitHandler = "dialog";
	        GameApp_1.GameApp.exit();
	    };
	    Dialog.prototype.onClickContinue = function () {
	        this.closeDialog();
	        BaseModel_1.BaseModel.spinContinue();
	    };
	    Dialog.prototype.onClickHistory = function () {
	        if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.HistoryUrl)) {
	            GameApp_1.GameApp.openGameRoundHistoryFromUrl();
	        }
	        else if (!neo_common_1.StringUtils.isNullOrEmpty(AppContext_1.AppContext.gameConfiguration.RCIHistoryUrl)) {
	            GameApp_1.GameApp.openGameRoundHistoryFromUrl();
	        }
	        else {
	            GameApp_1.GameApp.openGameRoundHistory();
	        }
	    };
	    Dialog.prototype.onClickReload = function () {
	        neo_games_1.Platforms.Platforms.gameReloading();
	        if (neo_games_1.Platforms.Platforms.handleGameReload) {
	            return;
	        }
	        window.location.reload(true);
	    };
	    Dialog.prototype.onClickRestore = function (module) {
	        this.closeDialog();
	        ModuleManager_1.ModuleManager.restoreGameRound(module);
	    };
	    Dialog.DisabledClass = "_disabled";
	    Dialog.InfoClass = "info";
	    Dialog.ErrorClass = "error";
	    return Dialog;
	}());
	exports.Dialog = Dialog;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var FrameTimer_1 = __webpack_require__(9);
	var PlayList_1 = __webpack_require__(33);
	var neo_games_1 = __webpack_require__(3);
	var LimitDialog = (function () {
	    function LimitDialog() {
	    }
	    LimitDialog.openDialog = function () {
	        LimitDialog.initializeDialog();
	        if (!LimitDialog._opened) {
	            LimitDialog._openTimer.start(1);
	            if (LimitDialog._limit != null) {
	                LimitDialog._limit.style.display = "block";
	            }
	            LimitDialog._opened = true;
	            neo_games_1.Platforms.Platforms.dialogOpened("limit", true);
	        }
	    };
	    LimitDialog.closeDialog = function () {
	        if (LimitDialog._opened) {
	            LimitDialog.initializeDialog();
	            LimitDialog._closeTimer.start(60);
	            if (LimitDialog._limit != null && !LimitDialog._limit.classList.contains("_disabled")) {
	                LimitDialog._limit.classList.add("_disabled");
	            }
	            neo_games_1.Platforms.Platforms.dialogOpened("limit", false);
	        }
	    };
	    LimitDialog.initializeDialog = function () {
	        if (LimitDialog._limit == null) {
	            LimitDialog._limit = document.getElementById("limitDialog");
	        }
	        if (LimitDialog._openTimer == null) {
	            LimitDialog._openTimer = FrameTimer_1.CreateFrameTimer("openTimer");
	            LimitDialog._openTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.showDialog);
	        }
	        if (LimitDialog._closeTimer == null) {
	            LimitDialog._closeTimer = FrameTimer_1.CreateFrameTimer("closeTimer");
	            LimitDialog._closeTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.hideDialog);
	        }
	    };
	    LimitDialog.showDialog = function () {
	        LimitDialog.initializeDialog();
	        if (LimitDialog._limit != null && LimitDialog._limit.classList.contains("_disabled")) {
	            LimitDialog._limit.classList.remove("_disabled");
	            PlayList_1.PlayList.play("SND_BaseLimit");
	        }
	    };
	    LimitDialog.hideDialog = function () {
	        LimitDialog.initializeDialog();
	        if (LimitDialog._limit != null) {
	            LimitDialog._limit.style.display = "none";
	        }
	        LimitDialog._opened = false;
	    };
	    LimitDialog._opened = false;
	    return LimitDialog;
	}());
	exports.LimitDialog = LimitDialog;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var StageController_1 = __webpack_require__(6);
	var FrameTimerPool_1 = __webpack_require__(54);
	var gsap_1 = __webpack_require__(17);
	var PageVisibilityHandler_1 = __webpack_require__(55);
	var neo_games_1 = __webpack_require__(3);
	var DataManager_1 = __webpack_require__(26);
	var QuickspinDialog = (function () {
	    function QuickspinDialog() {
	    }
	    QuickspinDialog.openDialog = function () {
	        QuickspinDialog.initializeDialog();
	        if (!QuickspinDialog._opened && !QuickspinDialog._wasOpened) {
	            if (QuickspinDialog._container != null && QuickspinDialog._container.classList.contains("_disabled")) {
	                QuickspinDialog._container.classList.remove("_disabled");
	            }
	            PIXI.sound.pauseAll();
	            StageController_1.StageController.pauseAnimations();
	            FrameTimerPool_1.FrameTimerPool.pause();
	            gsap_1.TweenMax.pauseAll();
	            PageVisibilityHandler_1.PageVisibilityHandler.Enabled = false;
	            QuickspinDialog._opened = true;
	            QuickspinDialog._wasOpened = true;
	            neo_games_1.Platforms.Platforms.dialogOpened("quickspin", true);
	        }
	    };
	    QuickspinDialog.closeDialog = function () {
	        if (QuickspinDialog._opened) {
	            QuickspinDialog.initializeDialog();
	            if (QuickspinDialog._container != null && !QuickspinDialog._container.classList.contains("_disabled")) {
	                QuickspinDialog._container.classList.add("_disabled");
	            }
	            PIXI.sound.resumeAll();
	            StageController_1.StageController.resumeAnimations();
	            FrameTimerPool_1.FrameTimerPool.unpause();
	            gsap_1.TweenMax.resumeAll();
	            PageVisibilityHandler_1.PageVisibilityHandler.Enabled = true;
	            QuickspinDialog._opened = false;
	            neo_games_1.Platforms.Platforms.quickSpinDialog(DataManager_1.DataManager.quickspinEnabled());
	            neo_games_1.Platforms.Platforms.dialogOpened("quickspin", false);
	        }
	    };
	    QuickspinDialog.initializeDialog = function () {
	        if (QuickspinDialog._container == null) {
	            QuickspinDialog._container = document.getElementById("quickspinDialog");
	        }
	    };
	    QuickspinDialog._opened = false;
	    QuickspinDialog._wasOpened = false;
	    return QuickspinDialog;
	}());
	exports.QuickspinDialog = QuickspinDialog;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var FrameTimer_1 = __webpack_require__(9);
	var FrameTimerPool = (function () {
	    function FrameTimerPool() {
	    }
	    FrameTimerPool.add = function (key, item) {
	        FrameTimerPool.pool[key] = item;
	    };
	    FrameTimerPool.remove = function (key) {
	        delete FrameTimerPool.pool[key];
	    };
	    FrameTimerPool.pause = function (force) {
	        if (force === void 0) { force = false; }
	        if (FrameTimerPool.paused && !force) {
	            return;
	        }
	        for (var key in FrameTimerPool.pool) {
	            if (FrameTimerPool.pool[key] instanceof FrameTimer_1.FrameTimer) {
	                FrameTimerPool.pool[key].pause();
	            }
	        }
	        FrameTimerPool.paused = true;
	    };
	    FrameTimerPool.unpause = function (force) {
	        if (force === void 0) { force = false; }
	        if (!FrameTimerPool.paused && !force) {
	            return;
	        }
	        for (var key in FrameTimerPool.pool) {
	            if (FrameTimerPool.pool[key] instanceof FrameTimer_1.FrameTimer) {
	                FrameTimerPool.pool[key].unpause();
	            }
	        }
	        FrameTimerPool.paused = false;
	    };
	    FrameTimerPool.pool = {};
	    FrameTimerPool.paused = false;
	    return FrameTimerPool;
	}());
	exports.FrameTimerPool = FrameTimerPool;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var FrameTimerPool_1 = __webpack_require__(54);
	var gsap_1 = __webpack_require__(17);
	var PageVisibilityHandler = (function () {
	    function PageVisibilityHandler() {
	    }
	    PageVisibilityHandler.handle = function () {
	        var hidden;
	        var visibilityChange;
	        if (typeof document.hidden !== "undefined") {
	            hidden = "hidden";
	            visibilityChange = "visibilitychange";
	        }
	        else if (typeof document.mozHidden !== "undefined") {
	            hidden = "mozHidden";
	            visibilityChange = "mozvisibilitychange";
	        }
	        else if (typeof document.msHidden !== "undefined") {
	            hidden = "msHidden";
	            visibilityChange = "msvisibilitychange";
	        }
	        else if (typeof document.webkitHidden !== "undefined") {
	            hidden = "webkitHidden";
	            visibilityChange = "webkitvisibilitychange";
	        }
	        else {
	            return;
	        }
	        document.addEventListener(visibilityChange, function (e) {
	            if (PageVisibilityHandler.Enabled) {
	                var isIos = /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
	                if (document[hidden]) {
	                    PageVisibilityHandler.pauseAll();
	                }
	                else {
	                    if (isIos) {
	                        clearTimeout(PageVisibilityHandler.Timer);
	                        PageVisibilityHandler.Timer = setTimeout(function () {
	                            PageVisibilityHandler.resumeAll();
	                        }, 200);
	                    }
	                    else {
	                        PageVisibilityHandler.resumeAll();
	                    }
	                }
	            }
	        }, false);
	        window.addEventListener("focus", function () {
	            var isIos = /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
	            if (isIos) {
	                var context = PIXI.sound.context.audioContext;
	                if (context.state === "suspended" || context.state === "interrupted") {
	                    context.resume();
	                }
	            }
	        });
	    };
	    PageVisibilityHandler.pauseAll = function () {
	        gsap_1.TweenMax.pauseAll();
	        FrameTimerPool_1.FrameTimerPool.pause();
	        PIXI.sound.pauseAll();
	    };
	    PageVisibilityHandler.resumeAll = function () {
	        gsap_1.TweenMax.resumeAll();
	        FrameTimerPool_1.FrameTimerPool.unpause();
	        PIXI.sound.resumeAll();
	        PIXI.sound.unmuteAll();
	    };
	    PageVisibilityHandler.Enabled = true;
	    return PageVisibilityHandler;
	}());
	exports.PageVisibilityHandler = PageVisibilityHandler;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Configuration_1 = __webpack_require__(57);
	var HtmlController_1 = __webpack_require__(31);
	var PlayList_1 = __webpack_require__(33);
	var neo_common_1 = __webpack_require__(2);
	var BetManager_1 = __webpack_require__(25);
	var Languages_1 = __webpack_require__(28);
	var AppContext_1 = __webpack_require__(5);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var UserAction_1 = __webpack_require__(32);
	var ModuleManager_1 = __webpack_require__(29);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var neo_games_1 = __webpack_require__(3);
	var BaseActions_1 = __webpack_require__(35);
	var Paytable = (function () {
	    function Paytable() {
	        Paytable.instance = this;
	    }
	    Paytable.prototype.initialize = function () {
	        var prewPageButton = document.getElementById("paytableButtonLeft");
	        var nextPageButton = document.getElementById("paytableButtonRight");
	        if (prewPageButton != null) {
	            prewPageButton.onclick = this.prewPage.bind(this);
	        }
	        if (nextPageButton != null) {
	            nextPageButton.onclick = this.nextPage.bind(this);
	        }
	        this._pages = document.getElementsByClassName("paytablePage");
	        this._paginations = document.getElementsByClassName("paytablePageNumber");
	        this.updateDataValues();
	    };
	    Paytable.prototype.updateDataValues = function () {
	        var config = Configuration_1.Configuration.Configurations["PaytableConfiguration"];
	        if (config != null) {
	            var data = {};
	            var next = config.firstElementChild;
	            var maxValue = 0;
	            while (next != null) {
	                if (next.nodeName == "Pages") {
	                    if (next.hasAttribute("Payouts")) {
	                        Paytable.payoutPage = parseInt(next.getAttribute("Payouts")) - 1;
	                    }
	                }
	                else if (next.hasAttribute("Symbol")) {
	                    var id = next.getAttribute("Symbol");
	                    var attrCounts = null;
	                    var attrValues = null;
	                    var i;
	                    if (next.hasAttribute("Counts")) {
	                        attrCounts = next.getAttribute("Counts");
	                        var counts = next.getAttribute("Counts").split(";");
	                        for (i = 0; i < counts.length; i++) {
	                            data["PTB_SYMBOL_" + id + "_COUNT_" + (i + 1)] =
	                                Paytable.Configurations.PAYTABLE_COUNT_PREFIX +
	                                    counts[i] +
	                                    Paytable.Configurations.PAYTABLE_COUNT_POSTFIX;
	                        }
	                    }
	                    if (next.hasAttribute("Values")) {
	                        attrValues = next.getAttribute("Values");
	                        var valueSuffix = next.getAttribute("ValueSuffix");
	                        var values = next.getAttribute("Values").split(";");
	                        for (i = 0; i < values.length; i++) {
	                            if (parseInt(values[i]) > maxValue) {
	                                maxValue = parseInt(values[i]);
	                            }
	                            data["PTB_SYMBOL_" + id + "_VALUE_" + (i + 1)] = this.getPaytableValue(values[i]);
	                        }
	                    }
	                }
	                next = next.nextElementSibling;
	            }
	            if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration.PaytableUseValue) {
	                var elements = document.getElementsByClassName("ptbTotalBetMultiplierDisplay");
	                for (var i_1 = 0; i_1 < elements.length; i_1++) {
	                    elements[i_1].classList.add("_hidden");
	                }
	                elements = document.getElementsByClassName("ptbTotalBetMultiplier");
	                for (var i_2 = 0; i_2 < elements.length; i_2++) {
	                    elements[i_2].classList.add("_invisible");
	                }
	            }
	            if (data != null) {
	                this.updateFontSize(maxValue, data);
	                HtmlController_1.HtmlController.updateDataElements(data);
	            }
	            this.customContent();
	        }
	    };
	    Paytable.prototype.getPaytableValue = function (value, valueSepratator) {
	        if (valueSepratator === void 0) { valueSepratator = "-"; }
	        var valueArray = value.split(valueSepratator);
	        for (var i = 0; i < valueArray.length; i++) {
	            if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration.PaytableUseValue) {
	                valueArray[i] =
	                    Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, neo_common_1.NumberUtils.multiply(valueArray[i], BetManager_1.BetManager.Bet)) +
	                        " " +
	                        DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	            }
	            else {
	                valueArray[i] =
	                    Paytable.Configurations.PAYTABLE_VALUE_PREFIX +
	                        valueArray[i] +
	                        Paytable.Configurations.PAYTABLE_VALUE_POSTFIX;
	            }
	        }
	        return valueArray.join(valueSepratator);
	    };
	    Paytable.prototype.updateFontSize = function (maxValue, data) {
	        if (AppContext_1.AppContext != null && !AppContext_1.AppContext.gameConfiguration.PaytableUseValue) {
	            return;
	        }
	        var elements = HtmlController_1.HtmlController.DataElements["PTB_SYMBOL_1_VALUE_1"];
	        var conversionRate = 1;
	        if (elements != null && elements.length > 0) {
	            var element = elements[0].instance;
	            element.removeAttribute("style");
	            if (this._defaultWidth == undefined) {
	                this._defaultFontSize = parseInt(window.getComputedStyle(element).fontSize);
	                var defaultWidth = window.getComputedStyle(element).width;
	                this._defaultWidth =
	                    defaultWidth.indexOf("%") > -1 ? undefined : parseInt(window.getComputedStyle(element).width);
	                this._maxBet = Math.max.apply(Math, BetManager_1.BetManager.TotalBets);
	            }
	            element.textContent =
	                Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, neo_common_1.NumberUtils.multiply(maxValue, BetManager_1.BetManager.Bet)) +
	                    " " +
	                    DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	            element.style.fontSize = this._defaultFontSize + "px";
	            element.style.width = "auto";
	            element.style.whiteSpace = "nowrap";
	            element.offsetWidth;
	            var currentWidth = parseFloat(window.getComputedStyle(element).width);
	            conversionRate = this._defaultWidth / (currentWidth * 1.1);
	            if (isNaN(conversionRate) || conversionRate > 1) {
	                conversionRate = 1;
	            }
	            element.style.fontSize = "";
	            element.style.width = "";
	        }
	        var fontConversion = window["CHANNEL"] == "mobile" ? 0.9 : 1;
	        var fontSize = Math.floor(this._defaultFontSize * conversionRate * fontConversion) + "px";
	        for (var key in data) {
	            elements = HtmlController_1.HtmlController.DataElements[key];
	            if (elements != null) {
	                for (var i = 0; i < elements.length; i++) {
	                    elements[i].instance.style.fontSize = fontSize;
	                }
	            }
	        }
	    };
	    Paytable.prototype.customContent = function () {
	        var dataIds = [
	            "PTB_SYMBOL_9_VALUE_5",
	            "PTB_SYMBOL_9_VALUE_4",
	            "PTB_SYMBOL_9_VALUE_3",
	            "PTB_SYMBOL_9_VALUE_2",
	            "PTB_SYMBOL_9_VALUE_1",
	        ];
	        dataIds.forEach(function (value) {
	            if (value) {
	                var elements = HtmlController_1.HtmlController.DataElements[value];
	                if (elements != null) {
	                    for (var i = 0; i < elements.length; i++) {
	                        var fontSize = parseInt(elements[i].instance.style.fontSize);
	                        elements[i].instance.style.fontSize = Math.floor(fontSize * 1.7) + "px";
	                    }
	                }
	            }
	        });
	        var dataTotalWinIds = ["PTB_SYMBOL_8_VALUE_1"];
	        dataTotalWinIds.forEach(function (value) {
	            if (value) {
	                var elements = HtmlController_1.HtmlController.DataElements[value];
	                if (elements != null) {
	                    for (var i = 0; i < elements.length; i++) {
	                        elements[i].instance.removeAttribute("style");
	                    }
	                }
	            }
	        });
	    };
	    Paytable.prototype.prewPage = function () {
	        var activeIndex = this.disableElementsAndReturnActive();
	        if (this._pages != null) {
	            if (activeIndex === 0) {
	                this._pages[this._pages.length - 1].classList.remove("_disabled");
	                this._pages[this._pages.length - 1].classList.add("_active");
	            }
	            else {
	                this._pages[activeIndex - 1].classList.remove("_disabled");
	                this._pages[activeIndex - 1].classList.add("_active");
	            }
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        if (this._paginations != null) {
	            if (activeIndex === 0) {
	                this._paginations[this._paginations.length - 1].classList.remove("_disabled");
	                this._paginations[this._paginations.length - 1].classList.add("_active");
	            }
	            else {
	                this._paginations[activeIndex - 1].classList.remove("_disabled");
	                this._paginations[activeIndex - 1].classList.add("_active");
	            }
	        }
	    };
	    Paytable.prototype.nextPage = function () {
	        var activeIndex = this.disableElementsAndReturnActive();
	        if (this._pages != null) {
	            if (activeIndex === this._pages.length - 1) {
	                this._pages[0].classList.remove("_disabled");
	                this._pages[0].classList.add("_active");
	            }
	            else {
	                this._pages[activeIndex + 1].classList.remove("_disabled");
	                this._pages[activeIndex + 1].classList.add("_active");
	            }
	            PlayList_1.PlayList.play("SND_Click");
	        }
	        if (this._paginations != null) {
	            if (activeIndex === this._paginations.length - 1) {
	                this._paginations[0].classList.remove("_disabled");
	                this._paginations[0].classList.add("_active");
	            }
	            else {
	                this._paginations[activeIndex + 1].classList.remove("_disabled");
	                this._paginations[activeIndex + 1].classList.add("_active");
	            }
	        }
	    };
	    Paytable.prototype.setPage = function (page) {
	        if (page < 0 || page > this._pages.length - 1) {
	            return;
	        }
	        this.disableElementsAndReturnActive();
	        if (this._pages != null) {
	            this._pages[page].classList.remove("_disabled");
	            this._pages[page].classList.add("_active");
	            this._pages[page].scrollIntoView();
	        }
	        if (this._paginations != null) {
	            this._paginations[page].classList.remove("_disabled");
	            this._paginations[page].classList.add("_active");
	        }
	    };
	    Paytable.prototype.disableElementsAndReturnActive = function () {
	        var activeIndex = 0;
	        for (var i = 0; i < this._pages.length; i++) {
	            var element = this._pages[i];
	            if (element != null) {
	                if (!element.classList.contains("_disabled")) {
	                    element.classList.add("_disabled");
	                }
	                if (element.classList.contains("_active")) {
	                    activeIndex = i;
	                    element.classList.remove("_active");
	                }
	            }
	        }
	        for (var i = 0; i < this._paginations.length; i++) {
	            var element = this._paginations[i];
	            if (element != null) {
	                if (!element.classList.contains("_disabled")) {
	                    element.classList.add("_disabled");
	                }
	                if (element.classList.contains("_active")) {
	                    element.classList.remove("_active");
	                }
	            }
	        }
	        return activeIndex;
	    };
	    Paytable.openAtStart = function (newGameRound) {
	        if (newGameRound === void 0) { newGameRound = false; }
	        if (Paytable.shouldOpen(newGameRound)) {
	            Paytable.show();
	        }
	    };
	    Paytable.show = function () {
	        Paytable.hasBeenDisplayed = true;
	        var dipatchElementId = UserAction_1.UserAction.ActionPaytableOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionPaytableOn);
	                }
	            }
	        }
	        Paytable.openPayoutPage();
	        window.addEventListener("resize", Paytable.openPayoutPage);
	    };
	    Paytable.close = function (action) {
	        if (action === void 0) { action = ""; }
	        Paytable.clearListeners();
	        var peakApp = document.querySelector("peak-app");
	        var hasPendingNotifications = peakApp && peakApp.hasAttribute("pending-notifications-count") &&
	            parseInt(peakApp.getAttribute("pending-notifications-count")) > 0;
	        if (Paytable.hasBeenDisplayed &&
	            !Paytable.userClosedPaytableAtStart &&
	            AppContext_1.AppContext.gameConfiguration.ShowPaytableAtStart) {
	            Paytable.userClosedPaytableAtStart = true;
	            if (action == BaseActions_1.BaseActions.ActionSpin || action == BaseActions_1.BaseActions.ActionAutoplay) {
	                if (hasPendingNotifications) {
	                    neo_games_1.Platforms.Platforms.gamePlaySupressSpinOnCollect();
	                }
	            }
	            else {
	                neo_games_1.Platforms.Platforms.roundInit();
	            }
	        }
	    };
	    Paytable.openPayoutPage = function () {
	        Paytable.instance.setPage(Paytable.payoutPage);
	    };
	    Paytable.clearListeners = function () {
	        window.removeEventListener("resize", Paytable.openPayoutPage);
	    };
	    Paytable.shouldOpen = function (newGameRound, isSpin) {
	        if (newGameRound === void 0) { newGameRound = false; }
	        if (isSpin === void 0) { isSpin = false; }
	        if (!AppContext_1.AppContext || !AppContext_1.AppContext.gameConfiguration.ShowPaytableAtStart) {
	            return false;
	        }
	        if (Paytable.hasBeenDisplayed && newGameRound) {
	            return false;
	        }
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	            return false;
	        }
	        if (!DataManager_1.DataManager.GameRoundClosed && !isSpin) {
	            return false;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	            return false;
	        }
	        return true;
	    };
	    Paytable.Configurations = {
	        PAYTABLE_COUNT_PREFIX: "",
	        PAYTABLE_COUNT_POSTFIX: "",
	        PAYTABLE_VALUE_PREFIX: "",
	        PAYTABLE_VALUE_POSTFIX: "x",
	    };
	    Paytable.userClosedPaytableAtStart = false;
	    Paytable.hasBeenDisplayed = false;
	    Paytable.payoutPage = -1;
	    return Paytable;
	}());
	exports.Paytable = Paytable;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Configuration = (function () {
	    function Configuration() {
	    }
	    Configuration.Configurations = {};
	    Configuration = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Element)
	    ], Configuration);
	    return Configuration;
	}());
	exports.Configuration = Configuration;
	exports.GeneralConfigurationAttributes = {
	    REEL_COUNT: "ReelCount",
	    REEL_X: "ReelX",
	    REEL_Y: "ReelY",
	    SYMBOL_WIDTH: "SymbolWidth",
	    SYMBOL_HEIGHT: "SymbolHeight",
	    SYMBOL_BOTTOM_COUNT: "SymbolBottomCount",
	    SYMBOL_TOP_COUNT: "SymbolTopCount",
	    VISIBLE_SYMBOL_COUNT: "VisibleSymbolCount",
	    WINS_MULTIPLIERS: "WinsMultipliers",
	    WINS_ANIMATIONS: "WinsAnimations",
	};
	exports.ReelConfigurationAttributes = {
	    FORCE_SPEED: "ForceSpeed",
	    FORCE_SPEED_MULTIPLER: "ForceSpeedMultipler",
	    PRE_ROLL: "PreRoll",
	    PRE_ROLL_SPEED: "PreRollSpeed",
	    POST_ROLL: "PostRoll",
	    POST_ROLL_SPEED: "PostRollSpeed",
	    SPEED: "Speed",
	};
	exports.MachineConfigurationAttributes = {
	    MIN_SPIN_ROTATION: "MinSpinRotation",
	    MIN_SPIN_ROTATION_LONG: "MinSpinRotationLong",
	    START_DELAY: "StartDelay",
	    STOP_DELAY: "StopDelay",
	    REEL_CONFIGURATION: "ReelConfiguration",
	    TEASINGS: "Teasings",
	    TEASING_SYMBOLS: "TeasingSymbols",
	    TEASING_STOP_DELAY: "TeasingStopDelay",
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var PlayList_1 = __webpack_require__(33);
	var AppContext_1 = __webpack_require__(5);
	var neo_common_1 = __webpack_require__(2);
	var GameApp_1 = __webpack_require__(1);
	var neo_games_1 = __webpack_require__(3);
	var SimilarGames = (function () {
	    function SimilarGames() {
	        this.enabled = false;
	        this._pages = [];
	        this._paging = [];
	        this._actualPage = 0;
	    }
	    SimilarGames.prototype.initialize = function () {
	        if (AppContext_1.AppContext != null &&
	            AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.ShowSimilarGames &&
	            AppContext_1.AppContext.gameConfiguration.StaticContentUrl !== "" &&
	            this.getSimilarGamesList().length > 0) {
	            this._holder = document.getElementById("similarGames");
	            this._pagesHolder = document.getElementById("similarGamesPagesContainer");
	            this._pagingHolder = document.getElementById("similarGamesPaging");
	            if (this._holder != null && this._pagesHolder != null) {
	                this.createPages();
	                this.enabled = true;
	            }
	        }
	    };
	    SimilarGames.prototype.getSimilarGamesList = function () {
	        if (AppContext_1.AppContext != null &&
	            AppContext_1.AppContext.gameConfiguration != null &&
	            AppContext_1.AppContext.gameConfiguration.SimilarGamesList.length > 0) {
	            return AppContext_1.AppContext.gameConfiguration.SimilarGamesList.filter(function (e) { return e !== GameApp_1.GameApp.key; });
	        }
	        return [];
	    };
	    SimilarGames.prototype.createPages = function () {
	        if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration != null && this.getSimilarGamesList().length > 0) {
	            var filterArray = this.getSimilarGamesList();
	            var page = 0;
	            for (var i = 0; i < filterArray.length; i++) {
	                if (i % 15 === 0) {
	                    page = this.createNextPage();
	                }
	                this.createPageItem(filterArray[i], page);
	            }
	        }
	        if (this._pages.length > 1) {
	            var prewPageButton = document.getElementById("similarGamesPrewArrow");
	            var nextPageButton = document.getElementById("similarGamesNextArrow");
	            if (prewPageButton != null) {
	                prewPageButton.classList.remove("_hidden");
	                prewPageButton.onclick = this.prewPage.bind(this);
	            }
	            if (nextPageButton != null) {
	                nextPageButton.classList.remove("_hidden");
	                nextPageButton.onclick = this.nextPage.bind(this);
	            }
	            if (this._pagingHolder != null) {
	                this._pagingHolder.classList.remove("_hidden");
	            }
	        }
	        var exitBtn = document.getElementById("exitBtn");
	        if (exitBtn != null) {
	            if (AppContext_1.AppContext != null &&
	                AppContext_1.AppContext.gameConfiguration != null &&
	                AppContext_1.AppContext.gameConfiguration.ShowExitGameButton) {
	                exitBtn.classList.remove("_hidden");
	            }
	            else {
	                exitBtn.classList.add("_hidden");
	            }
	        }
	    };
	    SimilarGames.prototype.createNextPage = function () {
	        var newPage = document.createElement("div");
	        var newPageChild = document.createElement("div");
	        var newPaging = document.createElement("div");
	        newPage.classList.add("similarGamesPage");
	        newPageChild.classList.add("customContent");
	        newPaging.classList.add("similarGamesPageNumber");
	        if (this._pages.length === 0) {
	            newPage.classList.add("_active");
	            newPaging.classList.add("_active");
	        }
	        else {
	            newPage.classList.add("_disabled");
	        }
	        newPage.appendChild(newPageChild);
	        this._pages.push(newPage);
	        this._paging.push(newPaging);
	        if (this._pagesHolder != null) {
	            this._pagesHolder.appendChild(newPage);
	        }
	        if (this._pagingHolder != null) {
	            this._pagingHolder.appendChild(newPaging);
	        }
	        return this._pages.length - 1;
	    };
	    SimilarGames.prototype.createPageItem = function (name, page) {
	        var itemHolder = document.createElement("div");
	        var item = document.createElement("div");
	        var itemLoading = document.createElement("div");
	        var itemLoadingIcon = document.createElement("div");
	        var itemLogo = document.createElement("div");
	        itemHolder.classList.add("similarGameContainer");
	        item.classList.add("similarGameItem");
	        itemLoading.classList.add("similarGameLoading");
	        itemLoadingIcon.classList.add("loadingIcon");
	        itemLogo.classList.add("similarGameLogo");
	        itemLogo.setAttribute("game", name);
	        var img = document.createElement("img");
	        img.setAttribute("src", AppContext_1.AppContext.gameConfiguration.StaticContentUrl + name + "/" + window["QUALITY"] + "/logo.jpg");
	        img.addEventListener("load", this.setItemLogo.bind(this, itemLogo, itemLoading, name));
	        itemHolder.appendChild(item);
	        item.appendChild(itemLoading);
	        itemLoading.appendChild(itemLoadingIcon);
	        item.appendChild(itemLogo);
	        itemLogo.onclick = this.selectGame.bind(this);
	        if (this._pages[page] != null) {
	            this._pages[page].firstChild.appendChild(itemHolder);
	        }
	    };
	    SimilarGames.prototype.setItemLogo = function (itemLogo, itemLoading, name) {
	        itemLoading.parentNode.removeChild(itemLoading);
	        itemLogo.style.background =
	            "url(" + AppContext_1.AppContext.gameConfiguration.StaticContentUrl + name + "/" + window["QUALITY"] + "/logo.jpg)";
	    };
	    SimilarGames.prototype.prewPage = function () {
	        if (!this.enabled) {
	            return;
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        this.disableAllPages();
	        this._actualPage--;
	        if (this._pages[this._actualPage] == null) {
	            this._actualPage = this._pages.length - 1;
	        }
	        if (this._pages[this._actualPage] != null) {
	            this._pages[this._actualPage].classList.remove("_disabled");
	            this._pages[this._actualPage].classList.add("_active");
	        }
	        if (this._paging[this._actualPage] != null) {
	            this._paging[this._actualPage].classList.add("_active");
	        }
	    };
	    SimilarGames.prototype.nextPage = function () {
	        if (!this.enabled) {
	            return;
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        this.disableAllPages();
	        this._actualPage++;
	        if (this._pages[this._actualPage] == null) {
	            this._actualPage = 0;
	        }
	        if (this._pages[this._actualPage] != null) {
	            this._pages[this._actualPage].classList.remove("_disabled");
	            this._pages[this._actualPage].classList.add("_active");
	        }
	        if (this._paging[this._actualPage] != null) {
	            this._paging[this._actualPage].classList.add("_active");
	        }
	    };
	    SimilarGames.prototype.disableAllPages = function () {
	        if (!this.enabled) {
	            return;
	        }
	        for (var i = 0; i < this._pages.length; i++) {
	            if (this._pages[i].classList.contains("_active")) {
	                this._pages[i].classList.remove("_active");
	            }
	            if (!this._pages[i].classList.contains("_disabled")) {
	                this._pages[i].classList.add("_disabled");
	            }
	        }
	        for (var i = 0; i < this._paging.length; i++) {
	            if (this._paging[i].classList.contains("_active")) {
	                this._paging[i].classList.remove("_active");
	            }
	        }
	    };
	    SimilarGames.prototype.selectGame = function (e) {
	        if (!this.enabled) {
	            return;
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        if (e != null && e.target != null && e.target.hasAttribute("game")) {
	            var urlInfo = neo_common_1.UriHelper.parseUrl(window.location.href, true, true);
	            if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
	                var serverUrl = urlInfo["query"]["serverUrl"];
	                var token = urlInfo["hash"].substring(1);
	                var newUrl_1 = serverUrl + "Launch/" + e.target.getAttribute("game") + "?" + token;
	                var root = document.getElementById("root");
	                if (root != null) {
	                    root.style.display = "none";
	                }
	                neo_games_1.Platforms.Platforms.gameChange(e.target.getAttribute("game"));
	                if (neo_games_1.Platforms.Platforms.handleChangeGame) {
	                    return;
	                }
	                setTimeout(function () {
	                    window.location.replace(newUrl_1);
	                }, 100);
	            }
	        }
	    };
	    SimilarGames.prototype.open = function () {
	        if (this.enabled) {
	            if (this._holder.classList.contains("_disabled")) {
	                this._holder.classList.remove("_disabled");
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	        else {
	            return false;
	        }
	    };
	    SimilarGames.prototype.disable = function () {
	        if (!this.enabled) {
	            return;
	        }
	        if (!this._holder.classList.contains("_disabled")) {
	            this._holder.classList.add("_disabled");
	        }
	    };
	    return SimilarGames;
	}());
	exports.SimilarGames = SimilarGames;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var MessageManager_1 = __webpack_require__(42);
	var SplashScreen = (function () {
	    function SplashScreen(htmlInstance) {
	        var _this = this;
	        if (htmlInstance != null) {
	            this._htmlInstance = {};
	            this._htmlInstance["instance"] = htmlInstance;
	            SplashScreen.suspendInit = true;
	            this._autoCloseTimerFinished = false;
	            this._continueEnabled = false;
	            this._timer = setTimeout(function () {
	                _this.autoCloseTimer();
	            }, SplashScreen.AutoCloseDelay * 1000);
	        }
	    }
	    SplashScreen.prototype.onInitReceived = function (initResponse) {
	        this._initResponse = initResponse;
	        if (this._initResponse.status != null && this._initResponse.status == neo_games_1.Communication.Game.GameStatus.Closed) {
	            this.showContinueButton();
	        }
	        else {
	            this.showGame();
	        }
	    };
	    SplashScreen.prototype.autoCloseTimer = function () {
	        this._autoCloseTimerFinished = true;
	        if (this._continueEnabled) {
	            this.showGame();
	        }
	    };
	    SplashScreen.prototype.showContinueButton = function () {
	        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
	            this._continueEnabled = true;
	            if (this._autoCloseTimerFinished) {
	                this.showGame();
	            }
	            else {
	                this._htmlInstance["instance"].showContinueButton(this.showGame.bind(this));
	            }
	        }
	    };
	    SplashScreen.prototype.showGame = function () {
	        clearTimeout(this._timer);
	        SplashScreen.suspendInit = false;
	        MessageManager_1.MessageManager.postpone(GameManager_1.GameManager.continueInitReceived, this._initResponse);
	    };
	    SplashScreen.prototype.hideSplashScreen = function () {
	        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
	            this._htmlInstance["instance"].hideSplashScreen();
	            this._htmlInstance = null;
	        }
	    };
	    SplashScreen.prototype.showError = function () {
	        if (this._htmlInstance != null && this._htmlInstance["instance"] != null) {
	            this._htmlInstance["instance"].showError();
	        }
	    };
	    SplashScreen.createSplashScreen = function (htmlInstance) {
	        if (SplashScreen.instance == null) {
	            SplashScreen.instance = new SplashScreen(htmlInstance);
	        }
	    };
	    SplashScreen.hideSplashScreen = function () {
	        if (SplashScreen.instance != null) {
	            SplashScreen.instance.hideSplashScreen();
	            SplashScreen.instance = null;
	        }
	    };
	    SplashScreen.suspendInitReceived = function (initResponse) {
	        if (SplashScreen.suspendInit && SplashScreen.instance != null) {
	            SplashScreen.instance.onInitReceived(initResponse);
	            return true;
	        }
	        return false;
	    };
	    SplashScreen.showError = function () {
	        if (SplashScreen.instance != null) {
	            SplashScreen.instance.showError();
	        }
	    };
	    SplashScreen.AutoCloseDelay = 15;
	    SplashScreen.suspendInit = false;
	    SplashScreen.instance = null;
	    return SplashScreen;
	}());
	exports.SplashScreen = SplashScreen;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_games_1 = __webpack_require__(3);
	var WebSocketClient_1 = __webpack_require__(61);
	var BalanceManager_1 = __webpack_require__(27);
	var GameManager_1 = __webpack_require__(23);
	var ModuleManager_1 = __webpack_require__(29);
	var PageVisibilityHandler_1 = __webpack_require__(55);
	var HtmlController_1 = __webpack_require__(31);
	var AppContext_1 = __webpack_require__(5);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Scaling_1 = __webpack_require__(8);
	var WebSocketClientHub_1 = __webpack_require__(62);
	var DataManager_1 = __webpack_require__(26);
	var Jackpot_1 = __webpack_require__(36);
	var NotificationManager = (function () {
	    function NotificationManager() {
	        if (AppContext_1.AppContext.gameConfiguration.ApplicationGatewayUrl) {
	            this.webSocketClientHub = new WebSocketClientHub_1.WebSocketClientHub();
	        }
	        else {
	            this.webSocketClient = new WebSocketClient_1.WebSocketClient();
	        }
	        this.bindMessages();
	    }
	    NotificationManager.prototype.bindMessages = function () {
	        if (this.webSocketClient != null) {
	            this.webSocketClient.on("RefreshBalance", this.refreshBalance.bind(this));
	            this.webSocketClient.on("CloseSession", this.closeSession.bind(this));
	            this.webSocketClient.on("UpdateStatusBar", this.updateStatusBar.bind(this));
	        }
	        if (this.webSocketClientHub != null) {
	            this.onReceiveMessage(this.messageReceiver.bind(this));
	        }
	    };
	    NotificationManager.prototype.sendMessage = function (message) {
	        if (this.webSocketClient != null) {
	            var methodName = message.action;
	            var data = message.data;
	            if (methodName == "event/log") {
	                methodName = "LogEvent";
	            }
	            this.webSocketClient.sendMessage(methodName, data);
	        }
	        if (this.webSocketClientHub != null) {
	            if (!this.webSocketClientHub.isConnectionEstablished()) {
	                this.webSocketClientHub.addMessage(this.sendMessage.bind(this, message));
	                return;
	            }
	            this.webSocketClientHub
	                .sendMessage(message)
	                .then(function () {
	                if (false) {
	                    console.log("Message received");
	                }
	            })
	                .catch(function (error) {
	                if (false) {
	                    console.log(error);
	                }
	            });
	        }
	    };
	    NotificationManager.prototype.invokeCommand = function (message) {
	        if (this.webSocketClientHub != null) {
	            return this.webSocketClientHub.invokeCommand(message);
	        }
	        return Promise.reject({ code: "Hub connection not initialized" });
	    };
	    NotificationManager.prototype.onReceiveMessage = function (receiver) {
	        if (this.webSocketClientHub != null) {
	            this.webSocketClientHub.onReceiveMessage(receiver);
	        }
	    };
	    NotificationManager.prototype.disconnect = function () {
	        if (this.webSocketClientHub != null) {
	            this.webSocketClientHub.disconnect();
	        }
	    };
	    NotificationManager.prototype.messageReceiver = function (message) {
	        if (message == null) {
	            if (false) {
	                console.log("ERROR - message object was not received from websocket");
	            }
	            return;
	        }
	        if (message.application.toLowerCase() != "neo") {
	            if (false) {
	                console.log('ERROR - message application was not "NEO"');
	            }
	            return;
	        }
	        if (message.service.toLowerCase() == "notification") {
	            switch (message.action.toLowerCase()) {
	                case "refreshbalance":
	                    this.refreshBalance(message.data);
	                    break;
	                case "closesession":
	                    this.closeSession();
	                    break;
	                case "updatestatusbar":
	                    this.updateStatusBar(message.data);
	                    break;
	            }
	        }
	        if (message.service.toLowerCase() == "servertime") {
	            switch (message.action.toLowerCase()) {
	                case "update":
	                    this.updateServerTime(message.data);
	                    break;
	            }
	        }
	    };
	    NotificationManager.prototype.refreshBalance = function (data) {
	        if (data["freeRounds"] != null) {
	            FreeRoundBonus_1.FreeRoundBonus.updateRemainingCount(data["freeRounds"]);
	        }
	        if (Jackpot_1.Jackpot.hasActiveGame()) {
	            return;
	        }
	        BalanceManager_1.BalanceManager.balanceReceived(data);
	    };
	    NotificationManager.prototype.closeSession = function () {
	        for (var key in neo_games_1.Communication.Game.GameModules) {
	            ModuleManager_1.ModuleManager.disableChannelModule(neo_games_1.Communication.Game.GameModules[key]);
	        }
	        PageVisibilityHandler_1.PageVisibilityHandler.Enabled = false;
	        PageVisibilityHandler_1.PageVisibilityHandler.pauseAll();
	        HtmlController_1.HtmlController.dispatchActionAllowed = false;
	        GameManager_1.GameManager.errorReceived({
	            requestInfo: {
	                request: NotificationManager,
	                url: null,
	                gameKey: null,
	            },
	            httpStatusCode: 401,
	        });
	    };
	    NotificationManager.prototype.updateStatusBar = function (data) {
	        var statusBar = neo_games_1.Plugins.StatusBar.getInstance();
	        if (statusBar.hasActiveWidget("statusBarMessage") && data != null && data["statusBarMessage"]) {
	            statusBar.add(neo_games_1.Plugins.StatusBar.Types.StatusBarMessage, "statusBarMessage", data["statusBarMessage"]);
	            Scaling_1.Scaling.resizeRoot();
	        }
	    };
	    NotificationManager.prototype.updateServerTime = function (data) {
	        if (data == null) {
	            return;
	        }
	        DataManager_1.DataManager.serverTimeReceived(data);
	    };
	    NotificationManager.initialize = function () {
	        if (NotificationManager.instance == null) {
	            NotificationManager.instance = new NotificationManager();
	        }
	    };
	    NotificationManager.sendMessage = function (message) {
	        if (NotificationManager.instance != null) {
	            NotificationManager.instance.sendMessage(message);
	        }
	    };
	    NotificationManager.invokeCommand = function (message) {
	        if (NotificationManager.instance != null) {
	            return NotificationManager.instance.invokeCommand(message);
	        }
	        return Promise.reject({ code: "Hub connection not initialized" });
	    };
	    NotificationManager.onReceiveMessage = function (receiver) {
	        if (NotificationManager.instance != null) {
	            return NotificationManager.instance.onReceiveMessage(receiver);
	        }
	    };
	    NotificationManager.disconnect = function () {
	        if (NotificationManager.instance != null) {
	            NotificationManager.instance.disconnect();
	        }
	    };
	    return NotificationManager;
	}());
	exports.NotificationManager = NotificationManager;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var AppContext_1 = __webpack_require__(5);
	var WebSocketClient = (function () {
	    function WebSocketClient() {
	        this.connected = false;
	        var urlInfo = neo_common_1.UriHelper.parseUrl(window.location.href, true, true);
	        if (urlInfo != null && urlInfo["query"]["serverUrl"] && urlInfo["hash"]) {
	            var serverUrl = urlInfo["query"]["serverUrl"];
	            try {
	                this.hubConnection = new GameClientHub.GameClientHubConnection(serverUrl, this.getToken, AppContext_1.AppContext.gameConfiguration);
	                this.connected = true;
	            }
	            catch (e) {
	                if (false) {
	                    console.log("ERROR websocket connection was not created: " + e);
	                }
	            }
	        }
	    }
	    WebSocketClient.prototype.getToken = function () {
	        var token = "";
	        var urlInfo = neo_common_1.UriHelper.parseUrl(window.location.href, true, true);
	        if (urlInfo != null && urlInfo["hash"]) {
	            token = urlInfo["hash"].substring(1).split("=")[1];
	        }
	        return token;
	    };
	    WebSocketClient.prototype.sendMessage = function (methodName, data) {
	        if (this.hubConnection != null && this.connected) {
	            this.hubConnection.sendMessage(methodName, data);
	        }
	    };
	    WebSocketClient.prototype.on = function (methodName, callbackFn) {
	        if (this.hubConnection != null) {
	            this.hubConnection.on(methodName, callbackFn);
	        }
	    };
	    return WebSocketClient;
	}());
	exports.WebSocketClient = WebSocketClient;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ClientHubConnection = ClientHub.ClientHubConnection;
	var UpdateTokenRequest = ClientHub.UpdateTokenRequest;
	var AppContext_1 = __webpack_require__(5);
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var WebSocketClientHub = (function () {
	    function WebSocketClientHub() {
	        var _this = this;
	        if (AppContext_1.AppContext.gameConfiguration == null) {
	            return;
	        }
	        if (AppContext_1.AppContext.gameConfiguration.ApplicationGatewayUrl === "") {
	            return;
	        }
	        try {
	            this.stackedMessages = [];
	            this.connectionEstablished = false;
	            this.clientHubConnection = new ClientHubConnection(AppContext_1.AppContext.gameConfiguration.ApplicationGatewayUrl, this.getToken, function () {
	                _this.connectionEstablished = true;
	                neo_games_1.Platforms.Platforms.webSocketsInitialized();
	                _this.sendStackedMessages();
	            });
	            this.jwtToken = this.getToken();
	        }
	        catch (e) {
	            if (false) {
	                console.log("ERROR websocket connection was not created: " + e);
	            }
	        }
	    }
	    WebSocketClientHub.prototype.getToken = function () {
	        var token = "";
	        var urlInfo = neo_common_1.UriHelper.parseUrl(window.location.href, true, true);
	        if (urlInfo != null && urlInfo["hash"]) {
	            token = urlInfo["hash"].substring(1).split("=")[1];
	        }
	        return token;
	    };
	    WebSocketClientHub.prototype.tokenChanged = function () {
	        var currentToken = this.getToken();
	        return currentToken != this.jwtToken;
	    };
	    WebSocketClientHub.prototype.updateToken = function () {
	        if (!this.tokenChanged()) {
	            return;
	        }
	        if (!this.clientHubConnection) {
	            return;
	        }
	        var _self = this;
	        var token = this.getToken();
	        this.clientHubConnection
	            .updateToken(new UpdateTokenRequest(token))
	            .then(function () {
	            if (false) {
	                console.log("Websocket connection token was updated successfully.");
	            }
	            _self.jwtToken = token;
	        })
	            .catch(function (e) {
	            if (false) {
	                console.log("ERROR websocket token was not updated: " + e);
	            }
	        });
	    };
	    WebSocketClientHub.prototype.sendStackedMessages = function () {
	        for (var i = 0; i < this.stackedMessages.length; i++) {
	            var fn = this.stackedMessages[i];
	            if (fn) {
	                fn();
	            }
	        }
	        this.stackedMessages = [];
	    };
	    WebSocketClientHub.prototype.addMessage = function (message) {
	        if (this.stackedMessages != null) {
	            this.stackedMessages.push(message);
	        }
	    };
	    WebSocketClientHub.prototype.isConnectionEstablished = function () {
	        return this.connectionEstablished;
	    };
	    WebSocketClientHub.prototype.sendMessage = function (message) {
	        if (!this.clientHubConnection) {
	            return Promise.reject(new Error("Not initialized"));
	        }
	        this.updateToken();
	        return this.clientHubConnection.sendMessage(message);
	    };
	    WebSocketClientHub.prototype.invokeCommand = function (message) {
	        if (!this.clientHubConnection) {
	            return Promise.reject({ code: "Not initialized" });
	        }
	        this.updateToken();
	        return this.clientHubConnection.invokeCommand(message);
	    };
	    WebSocketClientHub.prototype.onReceiveMessage = function (receiver) {
	        if (!this.clientHubConnection) {
	            return;
	        }
	        this.updateToken();
	        this.clientHubConnection.onReceiveMessage(receiver);
	    };
	    WebSocketClientHub.prototype.disconnect = function () {
	        if (!this.clientHubConnection) {
	            return;
	        }
	        this.clientHubConnection.disconnect().catch(function (e) {
	            console.log("ERROR websocket connection was disconnected: " + e);
	        });
	    };
	    return WebSocketClientHub;
	}());
	exports.WebSocketClientHub = WebSocketClientHub;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var PlayList_1 = __webpack_require__(33);
	var GameApp_1 = __webpack_require__(1);
	var GameManager_1 = __webpack_require__(23);
	var neo_games_1 = __webpack_require__(3);
	var BaseModel_1 = __webpack_require__(43);
	var Languages_1 = __webpack_require__(28);
	var neo_common_1 = __webpack_require__(2);
	var SessionTimer = (function () {
	    function SessionTimer() {
	    }
	    SessionTimer.postpone = function (callback, response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response) &&
	            !neo_common_1.Utils.isNullOrUndefined(response.messages) &&
	            response.messages.length > 0) {
	            if (neo_common_1.Utils.isNullOrUndefined(SessionTimer.dialog)) {
	                SessionTimer.dialog = document.getElementById("messageDialog");
	                if (!neo_common_1.Utils.isNullOrUndefined(SessionTimer.dialog)) {
	                    SessionTimer.dialog.classList.add("sessionTimer");
	                    SessionTimer.title = SessionTimer.dialog.getElementsByTagName("h3")[0];
	                    SessionTimer.text = document.getElementById("messageDialogText");
	                    SessionTimer.buttonsHolder = document.getElementById("messageDialogButtons");
	                    SessionTimer.buttons = [];
	                }
	            }
	            if (neo_common_1.Utils.isNullOrUndefined(SessionTimer.dialog)) {
	                callback(response);
	            }
	            else {
	                SessionTimer.callback = callback;
	                SessionTimer.response = response;
	                SessionTimer.step = 0;
	                SessionTimer.handle();
	            }
	        }
	        else {
	            callback(response);
	        }
	    };
	    SessionTimer.updateDialogData = function (data) {
	        SessionTimer.resetDialogData();
	        if (!neo_common_1.Utils.isNullOrUndefined(data["title"])) {
	            SessionTimer.title.innerHTML = data["title"];
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(data["text"])) {
	            SessionTimer.text.innerHTML = data["text"];
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(data["actions"])) {
	            SessionTimer.removeAllButtons();
	            for (var i = 0; i < data["actions"].length; i++) {
	                var action = data["actions"][i];
	                switch (action.type) {
	                    case "continue":
	                        SessionTimer.createButton(action["text"], SessionTimer.actionContinue.bind(this, action));
	                        break;
	                    case "exit":
	                        SessionTimer.createButton(action["text"], SessionTimer.actionExit.bind(this, action));
	                        break;
	                }
	            }
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(data["intervals"])) {
	            SessionTimer.createIntervals(data["intervals"]);
	        }
	    };
	    SessionTimer.resetDialogData = function () {
	        SessionTimer.title.innerHTML = Languages_1.Languages.getRid("DLG_INFO");
	        SessionTimer.removeAllButtons();
	        SessionTimer.createButton(Languages_1.Languages.getRid("CONTINUE"), SessionTimer.actionContinue);
	        if (SessionTimer.intervalHolder != null) {
	            SessionTimer.intervalHolder.parentElement.removeChild(SessionTimer.intervalHolder);
	            SessionTimer.intervalHolder = null;
	        }
	    };
	    SessionTimer.removeAllButtons = function () {
	        while (SessionTimer.buttons.length > 0) {
	            var button = SessionTimer.buttons.pop();
	            SessionTimer.buttonsHolder.removeChild(button);
	        }
	    };
	    SessionTimer.disableAllButtons = function () {
	        for (var i = 0; i < SessionTimer.buttons.length; i++) {
	            var button = SessionTimer.buttons[i];
	            if (button != null) {
	                button.classList.add("_disabled");
	                button.onclick = null;
	            }
	        }
	    };
	    SessionTimer.createButton = function (text, action) {
	        var button = document.createElement("div");
	        button.textContent = text;
	        button.classList.add("dialogBtn", "customDialogBtn");
	        button.onclick = action;
	        SessionTimer.buttonsHolder.appendChild(button);
	        SessionTimer.buttons.push(button);
	    };
	    SessionTimer.actionContinue = function () {
	        var _this = this;
	        PlayList_1.PlayList.play("SND_Click");
	        SessionTimer.disableAllButtons();
	        var interval;
	        if (SessionTimer.intervals != null && SessionTimer.intervalIndex > 0) {
	            interval = SessionTimer.intervals[SessionTimer.intervalIndex];
	        }
	        GameManager_1.GameManager.gameClient.resetRealityCheck(interval).then(function (response) {
	            _this.onActionContinueReceived();
	        });
	    };
	    SessionTimer.onActionContinueReceived = function () {
	        SessionTimer.handle();
	    };
	    SessionTimer.actionExit = function () {
	        var _this = this;
	        PlayList_1.PlayList.play("SND_Click");
	        SessionTimer.disableAllButtons();
	        GameManager_1.GameManager.gameClient.closeRealityCheck().then(function (response) {
	            _this.onActionExitReceived();
	        });
	    };
	    SessionTimer.onActionExitReceived = function () {
	        neo_games_1.Platforms.Platforms.exitHandler = "responsibleDialog";
	        GameApp_1.GameApp.exit();
	    };
	    SessionTimer.handle = function () {
	        if (SessionTimer.response.messages.length === SessionTimer.step) {
	            SessionTimer.dialog.classList.add("_disabled");
	            SessionTimer.callback(SessionTimer.response);
	            neo_games_1.Platforms.Platforms.dialogOpened("sessionTimer", false);
	        }
	        else {
	            if (SessionTimer.response.messages[SessionTimer.step].type == "plugin") {
	                neo_games_1.Platforms.Platforms.sendPluginMessage(SessionTimer.response.messages[SessionTimer.step].text);
	                SessionTimer.step++;
	                SessionTimer.handle();
	            }
	            else {
	                SessionTimer.dialog.classList.remove("_disabled");
	                SessionTimer.updateDialogData(SessionTimer.response.messages[SessionTimer.step]);
	                SessionTimer.step++;
	                neo_games_1.Platforms.Platforms.dialogOpened("sessionTimer", true);
	            }
	        }
	    };
	    SessionTimer.createIntervals = function (intervals) {
	        if (SessionTimer.buttonsHolder != null) {
	            SessionTimer.intervals = intervals;
	            SessionTimer.intervalIndex = 0;
	            SessionTimer.intervalHolder = document.createElement("div");
	            SessionTimer.intervalHolder.setAttribute("class", "sessionIntervals");
	            var buttonMinus = document.createElement("div");
	            buttonMinus.setAttribute("class", "minusBtn");
	            buttonMinus.textContent = "-";
	            var buttonPlus = document.createElement("div");
	            buttonPlus.setAttribute("class", "plusBtn");
	            buttonPlus.textContent = "+";
	            buttonMinus.addEventListener("click", SessionTimer.changeInterval.bind(this, true, buttonMinus, buttonPlus));
	            buttonPlus.addEventListener("click", SessionTimer.changeInterval.bind(this, false, buttonMinus, buttonPlus));
	            SessionTimer.intervalDisplay = document.createElement("div");
	            SessionTimer.intervalDisplay.setAttribute("class", "value");
	            SessionTimer.intervalDisplay.innerText = intervals[0].toString();
	            if (SessionTimer.intervalIndex == SessionTimer.intervals.length - 1) {
	                buttonMinus.classList.add("_disabled");
	            }
	            if (SessionTimer.intervalIndex == 0) {
	                buttonPlus.classList.add("_disabled");
	            }
	            SessionTimer.intervalHolder.appendChild(buttonMinus);
	            SessionTimer.intervalHolder.appendChild(SessionTimer.intervalDisplay);
	            SessionTimer.intervalHolder.appendChild(buttonPlus);
	            SessionTimer.buttonsHolder.parentElement.insertBefore(SessionTimer.intervalHolder, SessionTimer.buttonsHolder);
	        }
	    };
	    SessionTimer.changeInterval = function (increase, buttonMinus, buttonPlus) {
	        if (increase === void 0) { increase = false; }
	        buttonMinus.classList.remove("_disabled");
	        buttonPlus.classList.remove("_disabled");
	        if (increase) {
	            if (SessionTimer.intervalIndex < SessionTimer.intervals.length - 1) {
	                SessionTimer.intervalIndex++;
	            }
	        }
	        else {
	            if (SessionTimer.intervalIndex > 0) {
	                SessionTimer.intervalIndex--;
	            }
	        }
	        if (SessionTimer.intervalIndex == SessionTimer.intervals.length - 1) {
	            buttonMinus.classList.add("_disabled");
	        }
	        if (SessionTimer.intervalIndex == 0) {
	            buttonPlus.classList.add("_disabled");
	        }
	        SessionTimer.intervalDisplay.innerText = SessionTimer.intervals[SessionTimer.intervalIndex].toString();
	    };
	    SessionTimer.callbackFnc = function (response) {
	        SessionTimer.dialog.classList.remove("sessionTimer");
	        BaseModel_1.BaseModel.spinContinue();
	    };
	    SessionTimer.prepareData = function (response) {
	        return {
	            messages: [
	                {
	                    text: response.message,
	                    actions: [
	                        {
	                            type: "continue",
	                            text: Languages_1.Languages.getRid("CONTINUE"),
	                        },
	                        {
	                            type: "exit",
	                            text: Languages_1.Languages.getRid("CLOSE"),
	                        },
	                    ],
	                    intervals: response.intervals,
	                },
	            ],
	        };
	    };
	    return SessionTimer;
	}());
	exports.SessionTimer = SessionTimer;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var AppContext_1 = __webpack_require__(5);
	var Scaling_1 = __webpack_require__(8);
	var Focus = (function () {
	    function Focus() {
	    }
	    Focus.focus = function () {
	        window.onblur = Focus.onBlur;
	        window.onfocus = Focus.onFocus;
	        window.onclick = Focus.onClick;
	        window.addEventListener("fullscreenchange", Focus.onFullscreenChange.bind(this));
	    };
	    Focus.onClick = function () {
	        if (AppContext_1.AppContext.gameConfiguration &&
	            AppContext_1.AppContext.gameConfiguration.FullscreenOnClick &&
	            !Scaling_1.Scaling.IsIOs &&
	            !neo_games_1.Platforms.Platforms.handleFullscreen) {
	            if (document.body.requestFullscreen) {
	                document.body.requestFullscreen();
	            }
	            else if (document.body.webkitRequestFullscreen) {
	                document.body.webkitRequestFullscreen();
	            }
	        }
	        if (!Focus.clicked) {
	            Focus.clicked = true;
	        }
	    };
	    Focus.onFullscreenChange = function (e) {
	        neo_games_1.Platforms.Platforms.fullscreen(document.fullscreenElement != null);
	    };
	    Focus.onFocus = function () {
	        if (AppContext_1.AppContext.gameConfiguration && AppContext_1.AppContext.gameConfiguration.MuteOnLostFocus) {
	            PIXI.sound.unmuteAll();
	        }
	    };
	    Focus.onBlur = function () {
	        if (AppContext_1.AppContext.gameConfiguration && AppContext_1.AppContext.gameConfiguration.MuteOnLostFocus) {
	            PIXI.sound.muteAll();
	        }
	    };
	    Focus.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Focus", s);
	        }
	    };
	    Focus.clicked = false;
	    return Focus;
	}());
	exports.Focus = Focus;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var XmlResource_1 = __webpack_require__(66);
	var SoundManager_1 = __webpack_require__(34);
	var StyleManager_1 = __webpack_require__(20);
	var CanvasManager_1 = __webpack_require__(68);
	var ConfigurationManager_1 = __webpack_require__(70);
	var HtmlManager_1 = __webpack_require__(71);
	var StageController_1 = __webpack_require__(6);
	var ActionManager_1 = __webpack_require__(120);
	var AppContext_1 = __webpack_require__(5);
	var SpineElement_1 = __webpack_require__(121);
	var GameApp_1 = __webpack_require__(1);
	var DOCUMENT_TYPE = "document";
	var PIXI_EVENTS = {
	    Load: "load",
	    Error: "error",
	    Complete: "complete",
	};
	var LOADJS_EVENTS = {
	    FileLoad: "fileload",
	    Complete: "complete",
	    Progress: "progress",
	    Error: "error",
	};
	var RESOURCE_FLAGS = {
	    Gamble: "G",
	};
	var PreloaderProvider = (function (_super) {
	    __extends(PreloaderProvider, _super);
	    function PreloaderProvider() {
	        _super.call(this);
	        this._resourceLoader = new PIXIResourceLoader(false);
	        this._audioResourceLoader = new PIXIResourceLoader(true);
	    }
	    Object.defineProperty(PreloaderProvider.prototype, "resourceLoader", {
	        get: function () {
	            return this._resourceLoader;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PreloaderProvider.prototype, "audioResourceLoader", {
	        get: function () {
	            return this._audioResourceLoader;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PreloaderProvider.addLoadingElementFunction = function (fnc) {
	        PreloaderProvider._loadingElements.push(fnc);
	    };
	    PreloaderProvider.isGroupLoaded = function (group) {
	        return PreloaderProvider._loadedGroups.indexOf(group) != -1;
	    };
	    PreloaderProvider.prototype.cleanup = function () {
	        this._resourceLoader = null;
	        this._audioResourceLoader = null;
	        XmlResource_1.XmlResource.cleanup();
	        StyleManager_1.StyleManager.cleanup();
	    };
	    PreloaderProvider.prototype.prepareFileList = function (resources) {
	        var _this = this;
	        if (resources) {
	            var gambleIsDisabled = !AppContext_1.AppContext.gameDefinition.Gamble;
	            neo_common_1.lodash.remove(resources, function (resource) {
	                var gambleResource = _this.resourceHasFlag(resource, RESOURCE_FLAGS.Gamble);
	                var removeRes = gambleResource && gambleIsDisabled;
	                if (false) {
	                    if (removeRes) {
	                        neo_common_1.Logger.debugGroup("Preloader", "Gamble disabled -> removing resource path '" + resource.path + "' (because has gamble flag) from file list to be loaded.");
	                    }
	                }
	                return removeRes;
	            });
	        }
	    };
	    PreloaderProvider.prototype.loadCompleted = function () {
	        for (var i = 0; i < PreloaderProvider._loadingElements.length; i++) {
	            var fnc = PreloaderProvider._loadingElements[i];
	            if (fnc != null) {
	                fnc.onLoadCompleted(neo_common_1.PreloaderInfo.instance.loadSucceed);
	            }
	        }
	        return new Promise(function (resolve, reject) {
	            resolve();
	        });
	    };
	    PreloaderProvider.prototype.onUpdateProgress = function (progress) {
	        neo_games_1.Platforms.Platforms.loadProgress(progress);
	        for (var i = 0; i < PreloaderProvider._loadingElements.length; i++) {
	            var fnc = PreloaderProvider._loadingElements[i];
	            if (fnc != null) {
	                fnc.onProgressUpdate(progress);
	            }
	        }
	    };
	    PreloaderProvider.prototype.loadGroupCompleted = function (group) {
	        neo_common_1.Logger.debugGroup("loadGroupCompleted", "Loaded group: " + group);
	        if (PreloaderProvider._loadedGroups.indexOf(group) == -1) {
	            PreloaderProvider._loadedGroups.push(group);
	        }
	    };
	    PreloaderProvider.prototype.handleGroupError = function (error, group) {
	    };
	    PreloaderProvider.prototype.parseCurrentElements = function () {
	        var xmlItems = XmlResource_1.XmlResource.Items;
	        if (xmlItems != null && xmlItems.length > 0) {
	            var tempElements = neo_common_1.lodash.map(xmlItems, function (item) {
	                var el = item.documentElement;
	                var prio = el.hasAttribute("Priority") ? parseInt(el.getAttribute("Priority")) : -1;
	                if (prio === -1) {
	                    if (false) {
	                        neo_common_1.Logger.errorGroup("Preloader", "Element does not have \"Priority\" attr!");
	                    }
	                }
	                return { element: el, priority: prio };
	            });
	            var elements = neo_common_1.lodash.map(neo_common_1.lodash.orderBy(tempElements, function (item) { return item.priority; }, "desc"), function (x) { return x.element; });
	            if (false) {
	                neo_common_1.Logger.debugGroup("Preloader", "Parse Elements started: " + new Date().toString());
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                ConfigurationManager_1.ConfigurationManager.parseElements(element);
	                SoundManager_1.SoundManager.parseElements(element);
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                StyleManager_1.StyleManager.parseElements(element);
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                ActionManager_1.ActionManager.parseActionSets(element);
	            }
	            document.body.setAttribute("Language", GameApp_1.GameApp.language);
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                CanvasManager_1.CanvasManager.parseElements(element);
	                HtmlManager_1.HtmlManager.parseElements(element);
	            }
	            if (false) {
	                neo_common_1.Logger.debugGroup("Preloader", "Parse Elements ended: " + new Date().toString());
	            }
	        }
	        XmlResource_1.XmlResource.emptyItems();
	        if (false) {
	            neo_common_1.Logger.debugGroup("Preloader", "Parse xml resources ended.");
	        }
	    };
	    PreloaderProvider.prototype.parseElements = function () {
	        return new Promise(function (resolve, reject) {
	            if (false) {
	                neo_common_1.Logger.debugGroup("Preloader", "Parse xml resources started");
	            }
	            var xmlItems = XmlResource_1.XmlResource.Items;
	            if (xmlItems != null && xmlItems.length > 0) {
	                var tempElements = neo_common_1.lodash.map(xmlItems, function (item) {
	                    var el = item.documentElement;
	                    var prio = el.hasAttribute("Priority") ? parseInt(el.getAttribute("Priority")) : -1;
	                    if (prio === -1) {
	                        if (false) {
	                            neo_common_1.Logger.errorGroup("Preloader", "Element does not have \"Priority\" attr!");
	                        }
	                    }
	                    return { element: el, priority: prio };
	                });
	                var elements = neo_common_1.lodash.map(neo_common_1.lodash.orderBy(tempElements, function (item) { return item.priority; }, "desc"), function (x) { return x.element; });
	                if (false) {
	                    neo_common_1.Logger.debugGroup("Preloader", "Parse Elements started: " + new Date().toString());
	                }
	                for (var i = 0; i < elements.length; i++) {
	                    var element = elements[i];
	                    ConfigurationManager_1.ConfigurationManager.parseElements(element);
	                    SoundManager_1.SoundManager.parseElements(element);
	                }
	                for (var i = 0; i < elements.length; i++) {
	                    var element = elements[i];
	                    StyleManager_1.StyleManager.parseElements(element);
	                }
	                for (var i = 0; i < elements.length; i++) {
	                    var element = elements[i];
	                    ActionManager_1.ActionManager.parseActionSets(element);
	                }
	                document.body.setAttribute("Language", GameApp_1.GameApp.language);
	                for (var i = 0; i < elements.length; i++) {
	                    var element = elements[i];
	                    CanvasManager_1.CanvasManager.parseElements(element);
	                    HtmlManager_1.HtmlManager.parseElements(element);
	                }
	                if (false) {
	                    neo_common_1.Logger.debugGroup("Preloader", "Parse Elements ended: " + new Date().toString());
	                }
	            }
	            if (false) {
	                neo_common_1.Logger.debugGroup("Preloader", "Parse xml resources ended.");
	            }
	            resolve();
	        });
	    };
	    PreloaderProvider._loadingElements = [];
	    PreloaderProvider._loadedGroups = [];
	    return PreloaderProvider;
	}(neo_common_1.PreloaderProviderBase));
	exports.PreloaderProvider = PreloaderProvider;
	var PIXIResourceLoader = (function (_super) {
	    __extends(PIXIResourceLoader, _super);
	    function PIXIResourceLoader(audio) {
	        _super.call(this, audio);
	        this.loader = new PIXI.loaders.Loader();
	        this._hasPreloaderVersionId = null;
	        this._loadingErrorCount = 0;
	        this._loadingErrorFiles = [];
	        this._resourcesWithNoId = {};
	        this.handleBeforeLoad = this.handleBeforeLoad.bind(this);
	        this.handleLoad = this.handleLoad.bind(this);
	        this.handleError = this.handleError.bind(this);
	        this.handleComplete = this.handleComplete.bind(this);
	        this.handleGroupComplete = this.handleGroupComplete.bind(this);
	        this.updateTextureAfterLoad = this.updateTextureAfterLoad.bind(this);
	    }
	    PIXIResourceLoader.prototype.cleanup = function () {
	        this._loadCompletedCallback = null;
	        this._updatedTextures = null;
	        this._preloaderVersionId = null;
	        this._loadingErrorCount = 0;
	        this._loadingErrorFiles = [];
	        this._resourcesWithNoId = null;
	        this.loader.reset();
	    };
	    PIXIResourceLoader.prototype.xmlsResourceLoaded = function (document, resource) {
	        var acceptedAsXmlResource = document && document.documentElement.nodeName === XmlResource_1.XmlResource.Root;
	        if (false) {
	            var extra = acceptedAsXmlResource ? " and is accepted as xml resource for app" : "";
	            neo_common_1.Logger.debugGroup("Preloader", ("Resource \"" + resource.path + "\" is loaded as xml document") + extra);
	        }
	        if (acceptedAsXmlResource) {
	            XmlResource_1.XmlResource.add(document);
	        }
	    };
	    PIXIResourceLoader.prototype.beforeResourcesLoad = function () {
	        this.loader.reset();
	        this._updatedTextures = {};
	        this.loader.use(this.updateTextureAfterLoad);
	    };
	    PIXIResourceLoader.prototype.updateTextureAfterLoad = function (resource, next) {
	        if (resource.data && resource.isImage) {
	            if (resource.texture && resource.texture.baseTexture && resource.texture.baseTexture.hasLoaded) {
	                var imageUrl = resource.texture.baseTexture.imageUrl;
	                var noId = this._resourcesWithNoId.hasOwnProperty(imageUrl);
	                if (!this._updatedTextures.hasOwnProperty(imageUrl)) {
	                    if (noId) {
	                        if (false) {
	                            neo_common_1.Logger.debugGroup("Preloader", "Resource '" + imageUrl + "' has no 'id' assigned and will not be pushed to webgl cache");
	                        }
	                    }
	                    else {
	                        if (resource.name.substr(0, 3) === "ANI" || resource.name.substr(0, 5) === "GROUP") {
	                            StageController_1.StageController.updateTexture(resource.texture.baseTexture);
	                            this._updatedTextures[imageUrl] = true;
	                        }
	                        if (false) {
	                            neo_common_1.Logger.debugGroup("Preloader", "Updated texture '" + imageUrl + "' to webgl cache");
	                        }
	                    }
	                }
	            }
	        }
	        try {
	            next();
	        }
	        catch (e) {
	            this._loadCompletedCallback(e);
	        }
	    };
	    PIXIResourceLoader.prototype.handleBeforeLoad = function (resource, next) {
	        if (this._hasPreloaderVersionId) {
	            var oldurl = resource.url;
	            resource.url = neo_common_1.UriHelper.setTimeStamp(resource.url, this._preloaderVersionId);
	            if (false) {
	                neo_common_1.Logger.debugGroup("Preloader", "Resource url \"" + oldurl + "\" changed to non-cached url \"" + resource.url + "\"");
	            }
	        }
	        try {
	            next();
	        }
	        catch (e) {
	            this._loadCompletedCallback(e);
	        }
	    };
	    PIXIResourceLoader.prototype.handleLoad = function (loader, resource) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Preloader", "Resource \"" + resource.url + "\" [" + resource.xhrType + "] [" + this.preloader.progressPercent + " %]");
	        }
	        if (resource.xhrType === DOCUMENT_TYPE) {
	            var xmlRoot = resource.data.documentElement.nodeName;
	            if (xmlRoot === XmlResource_1.XmlResource.Root) {
	                throw new Error("Should not be there!");
	            }
	        }
	        this._loadSingleCompletedCallback(false);
	    };
	    PIXIResourceLoader.prototype.handleError = function (error, loader, resource) {
	        if (false) {
	            neo_common_1.Logger.errorGroup("Preloader", "Resource load error: " + resource.url);
	        }
	        this._loadingErrorCount++;
	        this._loadingErrorFiles.push(resource.url);
	        this._loadSingleCompletedCallback("Failed to load " + resource.url + " resource!");
	    };
	    PIXIResourceLoader.prototype.handleComplete = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("Preloader", "Completed PIXI resource load");
	        }
	        if (this.audio) {
	            for (var key in this.loader.resources) {
	                if (key.indexOf("_meta") !== -1) {
	                    var sound = key.substr(0, key.length - 5);
	                    if (PIXI.sound.exists(sound)) {
	                        var soundSprite = PIXI.sound.find(sound);
	                        if (neo_common_1.lodash.isEmpty(soundSprite.sprites)) {
	                            soundSprite.addSprites(this.loader.resources[key].data.spritemap);
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            for (var key in this.loader.resources) {
	                if (key.indexOf("SPINE_data") !== -1) {
	                    SpineElement_1.SpineElement.Data = this.loader.resources[key];
	                }
	                if (key.indexOf("SPINE_atlas") !== -1) {
	                    SpineElement_1.SpineElement.Atlas = this.loader.resources[key];
	                }
	            }
	        }
	    };
	    PIXIResourceLoader.prototype.handleGroupComplete = function () {
	        this.loader.removeAllListeners(PIXI_EVENTS.Load);
	        this.loader.removeAllListeners(PIXI_EVENTS.Error);
	        this.handleComplete();
	        var loadError = this._loadingErrorCount === 0
	            ? null
	            : "Failed to load " + this._loadingErrorCount + " resources!: \n" + this._loadingErrorFiles.join(",\n");
	        this._loadingErrorCount = 0;
	        this._loadingErrorFiles = [];
	        this._loadCompletedCallback(loadError);
	    };
	    PIXIResourceLoader.prototype.loadAllGroupsCompleted = function () {
	    };
	    PIXIResourceLoader.prototype.loadResources = function (resources, resolveSingleCallback, resolveCallback) {
	        if (StageController_1.StageController.Renderer instanceof PIXI.CanvasRenderer) {
	            if (!AppContext_1.AppContext.gameConfiguration.CanvasFallback) {
	                var loadingScreen = document.getElementById("loading");
	                var element = document.getElementById("progressNumber");
	                if (loadingScreen != null) {
	                    loadingScreen.classList.add("_error");
	                }
	                if (element != null) {
	                    element.innerHTML = "WebGL error. Please contact support.";
	                }
	                return;
	            }
	        }
	        this._loadSingleCompletedCallback = resolveSingleCallback;
	        this._loadCompletedCallback = resolveCallback;
	        this._preloaderVersionId = this.preloader.versionId;
	        this._hasPreloaderVersionId = !neo_common_1.StringUtils.isNullOrEmpty(this._preloaderVersionId);
	        for (var i = 0; i < resources.length; i++) {
	            var resource = resources[i];
	            if (neo_common_1.StringUtils.isNullOrEmpty(resource.id)) {
	                this.loader.add(resource.path);
	                this._resourcesWithNoId[resource.path] = true;
	            }
	            else {
	                if (resource.id.indexOf("SPINE_data") !== -1) {
	                    var spineLoaderOptions = { metadata: { spineAtlasSuffix: ".txt" } };
	                    this.loader.add(resource.id, resource.path, spineLoaderOptions);
	                }
	                else {
	                    this.loader.add(resource.id, resource.path);
	                }
	            }
	        }
	        this.loader.pre(this.handleBeforeLoad);
	        this.loader.on("load", this.handleLoad);
	        this.loader.on("error", this.handleError);
	        this.loader.once("complete", this.handleGroupComplete);
	        this.loader.load();
	    };
	    return PIXIResourceLoader;
	}(neo_common_1.PreloaderResourceLoader));
	exports.PIXIResourceLoader = PIXIResourceLoader;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Resource_1 = __webpack_require__(67);
	var XmlResource = (function (_super) {
	    __extends(XmlResource, _super);
	    function XmlResource() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(XmlResource, "Items", {
	        get: function () {
	            return XmlResource.items;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    XmlResource.add = function (doc) {
	        XmlResource.items.push(doc);
	    };
	    XmlResource.cleanup = function () {
	        if (XmlResource.items) {
	            XmlResource.items.length = 0;
	            XmlResource.items = null;
	        }
	    };
	    XmlResource.emptyItems = function () {
	        if (XmlResource.items) {
	            XmlResource.items = [];
	        }
	    };
	    XmlResource.Root = "Elements";
	    XmlResource.items = [];
	    return XmlResource;
	}(Resource_1.Resource));
	exports.XmlResource = XmlResource;


/***/ },
/* 67 */
/***/ function(module, exports) {

	"use strict";
	var Resource = (function () {
	    function Resource() {
	    }
	    return Resource;
	}());
	exports.Resource = Resource;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var ActionSet_1 = __webpack_require__(69);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var CanvasManager = (function () {
	    function CanvasManager() {
	    }
	    CanvasManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("CanvasManager", data);
	        }
	    };
	    CanvasManager.parseElements = function (startNode, parent) {
	        if (parent === void 0) { parent = null; }
	        var children = {};
	        if (!startNode) {
	            return children;
	        }
	        CanvasManager.getNodesList(startNode.firstElementChild)
	            .reverse()
	            .filter(function (node) {
	            return node.hasAttribute("Class") &&
	                neo_common_1.EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes_1.ComponentTypes.DisplayObject);
	        })
	            .forEach(function (node) {
	            var element = neo_common_1.EngineComponentFactory.get(node.getAttribute("Class"));
	            element.create(node);
	            if (node.hasAttribute("LinkId")) {
	                ActionSet_1.ActionSet.ElementsToLink[node.getAttribute("LinkId")] = element;
	            }
	            var noGamble = false;
	            if (node.hasAttribute("Key")) {
	                if (node.getAttribute("Key") === "gamble" && !AppContext_1.AppContext.gameDefinition.Gamble) {
	                    noGamble = true;
	                }
	            }
	            if (!noGamble) {
	                CanvasManager._addElementToParent(element, parent);
	                CanvasManager._handleElementController(node, element);
	            }
	            children[node.nodeName] = element;
	        });
	        return children;
	    };
	    CanvasManager.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = CanvasManager.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    CanvasManager._addElementToParent = function (element, parent) {
	        if (parent != null) {
	            parent.addChild(element);
	        }
	        else if (element.children.length > 0) {
	            StageController_1.StageController.addChild(element);
	        }
	    };
	    CanvasManager._handleElementController = function (node, element) {
	        var controllerAttribute = node.hasAttribute("Controller") ? node.getAttribute("Controller") : "";
	        if (controllerAttribute === "") {
	            return;
	        }
	        var elementController = neo_common_1.EngineComponentFactory.get(controllerAttribute);
	        if (elementController != null) {
	            elementController.startInitialization(element);
	            if (node.hasAttribute("Key")) {
	                if (!AppContext_1.AppContext.gameDefinition.Gamble && node.getAttribute("Key") === "gamble") {
	                    return;
	                }
	                ModuleManager_1.ModuleManager.registerGameModule(node.getAttribute("Key"), elementController);
	            }
	        }
	        else {
	            if (false) {
	                CanvasManager.log("ERROR no controller with name: " + controllerAttribute);
	            }
	        }
	    };
	    return CanvasManager;
	}());
	exports.CanvasManager = CanvasManager;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ActionSet = (function () {
	    function ActionSet() {
	        this.actionElements = {};
	        this.cases = {};
	    }
	    ActionSet.prototype.RegisterActionSet = function (node) {
	        var _this = this;
	        ActionSet.getNodesList(node.firstElementChild)
	            .reverse()
	            .forEach(function (actionSetNode) {
	            switch (actionSetNode.nodeName) {
	                case "Elements":
	                    ActionSet.getNodesList(actionSetNode.firstElementChild)
	                        .reverse()
	                        .forEach(function (elementNode) {
	                        _this.actionElements[elementNode.nodeName] = elementNode;
	                    });
	                    break;
	                case "Actions":
	                    ActionSet.getNodesList(actionSetNode.firstElementChild)
	                        .reverse()
	                        .forEach(function (actionCase) {
	                        if (!actionCase.hasAttribute(exports.ActionSetAttributes.CASE)) {
	                            return;
	                        }
	                        if (_this.cases[actionCase.getAttribute(exports.ActionSetAttributes.CASE)] !== null) {
	                            _this.cases[actionCase.getAttribute(exports.ActionSetAttributes.CASE)] = actionCase;
	                        }
	                        else {
	                            if (false) {
	                                _this.log("ERROR case " +
	                                    actionCase.getAttribute("Case") +
	                                    " already exist in ActionSet " +
	                                    node.nodeName);
	                            }
	                        }
	                    });
	                    break;
	            }
	        });
	        ActionSet.ActionSets[node.nodeName] = this;
	    };
	    ActionSet.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = ActionSet.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    ActionSet.prototype.DispatchEvent = function (action) {
	        var _this = this;
	        ActionSet.getNodesList(this.cases[action].firstElementChild)
	            .reverse()
	            .forEach(function (elementNode) {
	            var linkedElement = _this.actionElements[elementNode.nodeName];
	            var classAttribute = linkedElement.hasAttribute("Class") ? linkedElement.getAttribute("Class") : "";
	            if (classAttribute === "") {
	                if (false) {
	                    _this.log("WARNING element with name: " + linkedElement.nodeName + " has no class");
	                }
	                return;
	            }
	            if (!neo_common_1.EngineComponentFactory.isTypeOf(classAttribute, ComponentTypes_1.ComponentTypes.LinkedElement)) {
	                return;
	            }
	            var element = neo_common_1.EngineComponentFactory.get(classAttribute);
	            element.create(linkedElement, elementNode);
	        });
	    };
	    ActionSet.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    ActionSet.ActionSets = {};
	    ActionSet.ElementsToLink = {};
	    ActionSet = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.ActionSet)
	    ], ActionSet);
	    return ActionSet;
	}());
	exports.ActionSet = ActionSet;
	exports.ActionSetAttributes = {
	    CASE: "Case",
	};


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Configuration_1 = __webpack_require__(57);
	var ConfigurationManager = (function () {
	    function ConfigurationManager() {
	    }
	    ConfigurationManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("ConfigurationManager", data);
	        }
	    };
	    ConfigurationManager.parseElements = function (startNode) {
	        if (!startNode) {
	            return;
	        }
	        ConfigurationManager.getNodesList(startNode.firstElementChild)
	            .reverse()
	            .filter(function (node) { return node.hasAttribute("Class") && node.getAttribute("Class") === "Configuration"; })
	            .forEach(function (node) { return (Configuration_1.Configuration.Configurations[node.nodeName] = node); });
	    };
	    ConfigurationManager.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = ConfigurationManager.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    return ConfigurationManager;
	}());
	exports.ConfigurationManager = ConfigurationManager;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ModuleManager_1 = __webpack_require__(29);
	var GambleUserControls_1 = __webpack_require__(72);
	var DesktopBaseUserControls_1 = __webpack_require__(83);
	var MobileBaseUserControls_1 = __webpack_require__(111);
	var AppContext_1 = __webpack_require__(5);
	var DesktopBonusUserControls_1 = __webpack_require__(113);
	var MobileBonusUserControls_1 = __webpack_require__(119);
	var HtmlManager = (function () {
	    function HtmlManager() {
	    }
	    HtmlManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("HtmlManager", data);
	        }
	    };
	    HtmlManager.parseElements = function (startNode, parent) {
	        if (parent === void 0) { parent = null; }
	        var children = {};
	        if (!startNode) {
	            return;
	        }
	        HtmlManager.getNodesList(startNode.firstElementChild, [])
	            .reverse()
	            .filter(function (node) {
	            return node.hasAttribute("Class") &&
	                neo_common_1.EngineComponentFactory.isTypeOf(node.getAttribute("Class"), ComponentTypes_1.ComponentTypes.HtmlElement);
	        })
	            .forEach(function (node) {
	            var element = neo_common_1.EngineComponentFactory.get(node.getAttribute("Class"));
	            var root = document.getElementById("root");
	            var customRoot;
	            if (node.hasAttribute("RootId")) {
	                customRoot = document.getElementById(node.getAttribute("RootId"));
	            }
	            if (node.hasAttribute("Key")) {
	                if (!AppContext_1.AppContext.gameDefinition.Gamble && node.getAttribute("Key") === "gamble") {
	                    return;
	                }
	                if (element instanceof DesktopBaseUserControls_1.DesktopBaseUserControls) {
	                    ModuleManager_1.ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
	                }
	                else if (element instanceof MobileBaseUserControls_1.MobileBaseUserControls) {
	                    ModuleManager_1.ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
	                }
	                else if (element instanceof GambleUserControls_1.GambleUserControls) {
	                    ModuleManager_1.ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
	                }
	                else if (element instanceof DesktopBonusUserControls_1.DesktopBonusUserControls) {
	                    ModuleManager_1.ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
	                }
	                else if (element instanceof MobileBonusUserControls_1.MobileBonusUserControls) {
	                    ModuleManager_1.ModuleManager.registerChannelModule(node.getAttribute("Key"), element);
	                }
	            }
	            if (element.instance != null) {
	                if (parent != null) {
	                    parent.instance.appendChild(element.instance);
	                }
	                else {
	                    if (customRoot != null) {
	                        customRoot.appendChild(element.instance);
	                    }
	                    else if (root != null) {
	                        root.appendChild(element.instance);
	                    }
	                    else {
	                        document.body.appendChild(element.instance);
	                    }
	                }
	                element.create(node);
	            }
	            else {
	                element.create(node);
	                if (parent != null) {
	                    parent.instance.appendChild(element.instance);
	                }
	                else {
	                    if (customRoot != null) {
	                        customRoot.appendChild(element.instance);
	                    }
	                    else if (root != null) {
	                        root.appendChild(element.instance);
	                    }
	                    else {
	                        document.body.appendChild(element.instance);
	                    }
	                }
	            }
	            children[node.nodeName] = element;
	        });
	        return children;
	    };
	    HtmlManager.getNodesList = function (node, nodeList) {
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = HtmlManager.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    return HtmlManager;
	}());
	exports.HtmlManager = HtmlManager;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var UserControls_1 = __webpack_require__(73);
	var GambleActions_1 = __webpack_require__(77);
	var HtmlController_1 = __webpack_require__(31);
	var GambleController_1 = __webpack_require__(78);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var GameData_1 = __webpack_require__(24);
	var GameManager_1 = __webpack_require__(23);
	var LimitDialog_1 = __webpack_require__(52);
	var PlayList_1 = __webpack_require__(33);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var Color = neo_games_1.Communication.Game.Color;
	var GambleUserControls = (function (_super) {
	    __extends(GambleUserControls, _super);
	    function GambleUserControls() {
	        _super.call(this, "gamble");
	        this._collectedWinValue = 0;
	        this._collectDelay = FrameTimer_1.CreateFrameTimer("collectDelay");
	        this._collectDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.outro.bind(this));
	        this._allowStart = true;
	    }
	    GambleUserControls.prototype.ticker = function (state) {
	        if (state === void 0) { state = ""; }
	        if (this._gambleTickerDefault != null) {
	            this._gambleTickerDefault.style.display = "none";
	        }
	        if (this._gambleTickerHalveLimit != null) {
	            this._gambleTickerHalveLimit.style.display = "none";
	        }
	        if (this._gambleTickerSoftLimit != null) {
	            this._gambleTickerSoftLimit.style.display = "none";
	        }
	        if (this._gambleTickerGameLimit != null) {
	            this._gambleTickerGameLimit.style.display = "none";
	        }
	        switch (state) {
	            case "default":
	                if (this._gambleTickerDefault != null) {
	                    this._gambleTickerDefault.style.display = "block";
	                }
	                break;
	            case "halvelimit":
	                if (this._gambleTickerHalveLimit != null) {
	                    this._gambleTickerHalveLimit.style.display = "block";
	                }
	                break;
	            case "softLimit":
	                if (this._gambleTickerSoftLimit != null) {
	                    this._gambleTickerSoftLimit.style.display = "block";
	                }
	                break;
	            case "limit":
	                if (this._gambleTickerGameLimit != null) {
	                    this._gambleTickerGameLimit.style.display = "block";
	                }
	                break;
	        }
	    };
	    GambleUserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.registerActions();
	        this._gambleTickerDefault = document.getElementById("gambleTickerDefault");
	        this._gambleTickerHalveLimit = document.getElementById("gambleTickerHalveLimit");
	        this._gambleTickerSoftLimit = document.getElementById("gambleTickerSoftLimit");
	        this._gambleTickerGameLimit = document.getElementById("gambleTickerGameLimit");
	        this._screen = document.getElementById("screen");
	        this.ticker("default");
	    };
	    GambleUserControls.prototype.addController = function (controller) {
	        this._controller = controller;
	        this._controller.on(GambleController_1.GambleController.StartReceived, this.startReceived.bind(this));
	        this._controller.on(GambleController_1.GambleController.SelectReceived, this.selectReceived.bind(this));
	        this._controller.on(GambleController_1.GambleController.HalveReceived, this.halveReceived.bind(this));
	        this._controller.on(GambleController_1.GambleController.WinCalculationFinished, this.winCalculationFinished.bind(this));
	        this._controller.on(GambleController_1.GambleController.AllWinsFinished, this.allWinsFinished.bind(this));
	        this._controller.on(GambleController_1.GambleController.Lose, this.lose.bind(this));
	        this._controller.on(GambleController_1.GambleController.IntroFinished, this.introFinished.bind(this));
	        this._controller.on(GambleController_1.GambleController.OutroFinished, this.outroFinished.bind(this));
	    };
	    GambleUserControls.prototype.registerActions = function () {
	        this.actions.registerActions((_a = {},
	            _a[GambleActions_1.GambleActions.ActionGambleStart] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleRed] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleBlack] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleHalve] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleCollect] = false,
	            _a
	        ));
	        var _a;
	    };
	    GambleUserControls.prototype.initReceived = function () {
	        _super.prototype.initReceived.call(this);
	        this._controller.initReceived();
	    };
	    GambleUserControls.prototype.collectReceived = function () {
	        this.ticker("");
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, 0 + "");
	        _super.prototype.collectReceived.call(this);
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, "");
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, "");
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, "");
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, "");
	        DataManager_1.DataManager.updateDataElements();
	        neo_games_1.Platforms.Platforms.roundEnded({
	            id: GameManager_1.GameManager.gameResponse.roundId,
	            win: this._collectedWinValue,
	            balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	        });
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: GameManager_1.GameManager.gameResponse.balance.real });
	        this._collectDelay.start(30);
	        if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, this._collectedWinValue.toString());
	        }
	        this.changeWinBox(true);
	    };
	    GambleUserControls.prototype.restoreGameRound = function () {
	        this.prepareNewGameRound();
	    };
	    GambleUserControls.prototype.startReceived = function () {
	        if (GameManager_1.GameManager.gambleResponse != null &&
	            GameManager_1.GameManager.gambleResponse["totalCount"] != null &&
	            GameManager_1.GameManager.gambleResponse["currentCount"] != null) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, (GameManager_1.GameManager.gambleResponse["totalCount"] - GameManager_1.GameManager.gambleResponse["currentCount"]).toString());
	        }
	        ModuleManager_1.ModuleManager.startGamble();
	    };
	    GambleUserControls.prototype.selectReceived = function () {
	        if (GameManager_1.GameManager.gambleResponse["paidWin"] != null) {
	            this._collectedWinValue = parseFloat(neo_common_1.NumberUtils.add(GameManager_1.GameManager.gambleResponse.currentWin, GameManager_1.GameManager.gambleResponse["paidWin"]));
	        }
	        else {
	            this._collectedWinValue = GameManager_1.GameManager.gambleResponse.currentWin;
	        }
	    };
	    GambleUserControls.prototype.halveReceived = function () {
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, GameManager_1.GameManager.gambleResponse.colorWin.toString());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, GameManager_1.GameManager.gambleResponse.currentWin.toString());
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.colorWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.currentWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	        }
	        DataManager_1.DataManager.updateDataElements();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: GameManager_1.GameManager.gameResponse.balance.real });
	        this.prepareNewGameRound();
	    };
	    GambleUserControls.prototype.dispatchAction = function (action) {
	        _super.prototype.dispatchAction.call(this, action);
	        if (this.actions.getActionState(action)) {
	            PlayList_1.PlayList.play("SND_Click");
	            _super.prototype.dispatchAction.call(this, action);
	            switch (action) {
	                case GambleActions_1.GambleActions.ActionGambleStart:
	                    this.start();
	                    break;
	                case GambleActions_1.GambleActions.ActionGambleHalve:
	                    this.halve();
	                    break;
	                case GambleActions_1.GambleActions.ActionGambleBlack:
	                    this.select(Color.Black);
	                    break;
	                case GambleActions_1.GambleActions.ActionGambleRed:
	                    this.select(Color.Red);
	                    break;
	                case GambleActions_1.GambleActions.ActionGambleCollect:
	                    this.collect();
	                    break;
	            }
	        }
	    };
	    GambleUserControls.prototype.collect = function () {
	        if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.gameResponse.totalWin);
	        }
	        if (GameManager_1.GameManager.gambleResponse["paidWin"] != null) {
	            this._collectedWinValue = parseFloat(neo_common_1.NumberUtils.add(GameManager_1.GameManager.gambleResponse.currentWin, GameManager_1.GameManager.gambleResponse["paidWin"]));
	        }
	        else {
	            this._collectedWinValue = GameManager_1.GameManager.gambleResponse.currentWin;
	        }
	        if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	            DataManager_1.DataManager.updateLossLimit(GameManager_1.GameManager.gameResponse.totalWin);
	        }
	        _super.prototype.collect.call(this);
	        this.disable();
	        this.playCollectSound();
	        LimitDialog_1.LimitDialog.closeDialog();
	        GameManager_1.GameManager.collect(GameModules.Gamble);
	    };
	    GambleUserControls.prototype.start = function () {
	        this._allowStart = false;
	        this._collectedWinValue = GameManager_1.GameManager.gameResponse.totalWin;
	        ModuleManager_1.ModuleManager.disableBase();
	        this.disable();
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, GameManager_1.GameManager.gambleResponse.colorWin.toString());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, GameManager_1.GameManager.gambleResponse.currentWin.toString());
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.colorWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.currentWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	        }
	        DataManager_1.DataManager.updateDataElements();
	        this._controller.start();
	    };
	    GambleUserControls.prototype.select = function (color) {
	        this.ticker("");
	        this.disable();
	        this._controller.select(color);
	    };
	    GambleUserControls.prototype.halve = function () {
	        if (GameManager_1.GameManager.gambleResponse.currentWin > 0) {
	            DataManager_1.DataManager.updateLossLimit(GameManager_1.GameManager.gambleResponse.currentWin / 2);
	        }
	        this.disable();
	        this.playCollectSound();
	        this._controller.halve();
	    };
	    GambleUserControls.prototype.winCalculationFinished = function () {
	        if (GameManager_1.GameManager.gambleResponse.currentWin > 0) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, GameManager_1.GameManager.gambleResponse.currentWin.toString());
	            if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.currentWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	            }
	            DataManager_1.DataManager.updateDataElements();
	        }
	        else {
	            if (GameManager_1.GameManager.gambleResponse != null &&
	                GameManager_1.GameManager.gambleResponse["totalCount"] != null &&
	                GameManager_1.GameManager.gambleResponse["currentCount"] != null) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, 0 + "");
	            }
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, "");
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, "");
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, "");
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, "");
	            DataManager_1.DataManager.updateDataElements();
	        }
	    };
	    GambleUserControls.prototype.allWinsFinished = function () {
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, GameManager_1.GameManager.gambleResponse.colorWin.toString());
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.colorWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	        }
	        DataManager_1.DataManager.updateDataElements();
	        if (GameManager_1.GameManager.gambleResponse.currentWin > 0) {
	            this.prepareNewGameRound();
	        }
	    };
	    GambleUserControls.prototype.lose = function () {
	        this.outro();
	        if (this._collectedWinValue > 0) {
	            if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, this._collectedWinValue.toString());
	            }
	            this.changeWinBox(true);
	        }
	        else {
	            this.changeWinBox();
	        }
	        neo_games_1.Platforms.Platforms.roundEnded({
	            id: GameManager_1.GameManager.gameResponse.roundId,
	            win: this._collectedWinValue,
	            balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	        });
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: GameManager_1.GameManager.gameResponse.balance.real });
	    };
	    GambleUserControls.prototype.initIntro = function () {
	        _super.prototype.initIntro.call(this);
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        this.prepareNewGameRound();
	        if (this._screen != null && !this._screen.classList.contains("_inGamble")) {
	            this._screen.classList.add("_inGamble");
	        }
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWin, GameManager_1.GameManager.gambleResponse.colorWin.toString());
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWin, GameManager_1.GameManager.gambleResponse.currentWin.toString());
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleColorWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.colorWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleCurrentWinDenom, parseInt(neo_common_1.NumberUtils.devide(GameManager_1.GameManager.gambleResponse.currentWin, BetManager_1.BetManager.CoinSize).toString()).toString());
	        }
	        DataManager_1.DataManager.updateDataElements();
	        this._controller.initIntro();
	    };
	    GambleUserControls.prototype.intro = function () {
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        if (this._screen != null && !this._screen.classList.contains("_inGamble")) {
	            this._screen.classList.add("_inGamble");
	        }
	        this._controller.intro();
	    };
	    GambleUserControls.prototype.introFinished = function () {
	        this.prepareNewGameRound();
	    };
	    GambleUserControls.prototype.outro = function () {
	        if (this._screen != null && this._screen.classList.contains("_inGamble")) {
	            this._screen.classList.remove("_inGamble");
	        }
	        DataManager_1.DataManager.Collectable = true;
	        this._collectDelay.stop();
	        this._controller.outro();
	    };
	    GambleUserControls.prototype.outroFinished = function () {
	        this._allowStart = true;
	        FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        ModuleManager_1.ModuleManager.introModule(GameModules.Base, true, GameModules.Gamble);
	    };
	    GambleUserControls.prototype.prepareNewGameRound = function () {
	        if (GameManager_1.GameManager.gambleResponse != null &&
	            GameManager_1.GameManager.gambleResponse["totalCount"] != null &&
	            GameManager_1.GameManager.gambleResponse["currentCount"] != null) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, (GameManager_1.GameManager.gambleResponse["totalCount"] - GameManager_1.GameManager.gambleResponse["currentCount"]).toString());
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleAttempts, (GameManager_1.GameManager.gambleResponse["totalCount"] - GameManager_1.GameManager.gambleResponse["currentCount"]).toString());
	        }
	        if (DataManager_1.DataManager.GameLimit) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataGambleAttempts, 0 + "");
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataGambleAttempts, 0 + "");
	            this.limit();
	            this.ticker("limit");
	        }
	        else {
	            var softLimit = false;
	            if (GameManager_1.GameManager.gambleResponse.colorWin === 0) {
	                softLimit = true;
	            }
	            if (softLimit) {
	                if (GameManager_1.GameManager.gambleResponse.halveEnabled) {
	                    this.ticker("softLimit");
	                }
	                else {
	                    this.ticker("limit");
	                }
	            }
	            else if (GameManager_1.GameManager.gambleResponse != null && !GameManager_1.GameManager.gambleResponse.halveEnabled) {
	                this.ticker("halveLimit");
	            }
	            else {
	                this.ticker("default");
	            }
	            this.actions.changeActionStates((_a = {},
	                _a[GambleActions_1.GambleActions.ActionGambleStart] = false,
	                _a[GambleActions_1.GambleActions.ActionGambleRed] = !softLimit,
	                _a[GambleActions_1.GambleActions.ActionGambleBlack] = !softLimit,
	                _a[GambleActions_1.GambleActions.ActionGambleHalve] = GameManager_1.GameManager.gambleResponse.halveEnabled,
	                _a[GambleActions_1.GambleActions.ActionGambleCollect] = true,
	                _a
	            ));
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var _a;
	    };
	    GambleUserControls.prototype.limit = function () {
	        LimitDialog_1.LimitDialog.openDialog();
	        this.actions.changeActionStates((_a = {},
	            _a[GambleActions_1.GambleActions.ActionGambleStart] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleRed] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleBlack] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleHalve] = false,
	            _a[GambleActions_1.GambleActions.ActionGambleCollect] = true,
	            _a
	        ));
	        var _a;
	    };
	    GambleUserControls.prototype.enable = function () {
	        this.actions.changeActionState(GambleActions_1.GambleActions.ActionGambleStart, this._allowStart);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    GambleUserControls.prototype.disable = function () {
	        this._actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    GambleUserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], GambleUserControls);
	    return GambleUserControls;
	}(UserControls_1.UserControls));
	exports.GambleUserControls = GambleUserControls;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var ComponentTypes_1 = __webpack_require__(14);
	var ActionSet_1 = __webpack_require__(76);
	var PlayList_1 = __webpack_require__(33);
	var GameManager_1 = __webpack_require__(23);
	var AppContext_1 = __webpack_require__(5);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var BetManager_1 = __webpack_require__(25);
	var HtmlController_1 = __webpack_require__(31);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var UserControls = (function (_super) {
	    __extends(UserControls, _super);
	    function UserControls(key) {
	        _super.call(this);
	        this._key = "";
	        this._observer = null;
	        this._key = key;
	        this._actions = new ActionSet_1.ActionSet(this._key + ".actions", neo_common_1.EngineComponentFactory.getComponentName(this));
	    }
	    Object.defineProperty(UserControls.prototype, "actions", {
	        get: function () {
	            return this._actions;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    UserControls.prototype.getAllActions = function () {
	        return this._actions.getAllActions();
	    };
	    UserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	    };
	    UserControls.prototype.addController = function (controller) { };
	    UserControls.prototype.initReceived = function () {
	        this._uncollectedWin = document.getElementById("uncollectedWin");
	        this._collectedWin = document.getElementById("collectedWin");
	    };
	    UserControls.prototype.collectReceived = function () { };
	    UserControls.prototype.dispatchAction = function (action) { };
	    UserControls.prototype.collect = function () { };
	    UserControls.prototype.initIntro = function () { };
	    UserControls.prototype.flashBet = function () {
	        var _this = this;
	        if (this._betValue == null) {
	            this._betValue = document.getElementById("betValue");
	        }
	        if (this._betValue != null) {
	            this._betValue.classList.remove("flash");
	            setTimeout(function () { return _this._betValue.classList.add("flash"); }, 33);
	            setTimeout(function () { return _this._betValue.classList.remove("flash"); }, 2000);
	            PlayList_1.PlayList.play("SND_LowCredit");
	        }
	    };
	    UserControls.prototype.initNewBet = function (animate) {
	        var _this = this;
	        if (animate === void 0) { animate = true; }
	        if (this._betLabel == null) {
	            this._betLabel = document.getElementById("betLabel");
	        }
	        if (this._freeBetLabel == null) {
	            this._freeBetLabel = document.getElementById("freeBetLabel");
	        }
	        if (this._betLabelFS == null) {
	            this._betLabelFS = document.getElementById("betLabelFS");
	        }
	        if (this._freeBetLabelFS == null) {
	            this._freeBetLabelFS = document.getElementById("freeBetLabelFS");
	        }
	        if (this._betValue == null) {
	            this._betValue = document.getElementById("betValue");
	        }
	        if (this._betPlus == null) {
	            this._betPlus = document.getElementById("betPlus");
	        }
	        if (this._betMinus == null) {
	            this._betMinus = document.getElementById("betMinus");
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            if (this._betLabel != null && !this._betLabel.classList.contains("_hidden")) {
	                this._betLabel.classList.add("_hidden");
	            }
	            if (this._freeBetLabel != null) {
	                if (this._freeBetLabel.classList.contains("_hidden")) {
	                    this._freeBetLabel.classList.remove("_hidden");
	                }
	                if (animate) {
	                    this._freeBetLabel.classList.remove("flash");
	                    setTimeout(function () { return _this._freeBetLabel.classList.add("flash"); }, 33);
	                    setTimeout(function () { return _this._freeBetLabel.classList.remove("flash"); }, 2000);
	                }
	            }
	            if (this._betLabelFS != null && !this._betLabelFS.classList.contains("_hidden")) {
	                this._betLabelFS.classList.add("_hidden");
	            }
	            if (this._freeBetLabelFS != null) {
	                if (this._freeBetLabelFS.classList.contains("_hidden")) {
	                    this._freeBetLabelFS.classList.remove("_hidden");
	                }
	            }
	        }
	        else {
	            if (this._freeBetLabel != null && !this._freeBetLabel.classList.contains("_hidden")) {
	                this._freeBetLabel.classList.add("_hidden");
	            }
	            if (this._betLabel != null) {
	                if (this._betLabel.classList.contains("_hidden")) {
	                    this._betLabel.classList.remove("_hidden");
	                }
	                if (animate) {
	                    this._betLabel.classList.remove("flash");
	                    setTimeout(function () { return _this._betLabel.classList.add("flash"); }, 33);
	                    setTimeout(function () { return _this._betLabel.classList.remove("flash"); }, 2000);
	                }
	            }
	            if (this._freeBetLabelFS != null && !this._freeBetLabelFS.classList.contains("_hidden")) {
	                this._freeBetLabelFS.classList.add("_hidden");
	            }
	            if (this._betLabelFS != null) {
	                if (this._betLabelFS.classList.contains("_hidden")) {
	                    this._betLabelFS.classList.remove("_hidden");
	                }
	            }
	        }
	        if (this._betValue != null) {
	            if (animate) {
	                this._betValue.classList.remove("flash");
	                setTimeout(function () { return _this._betValue.classList.add("flash"); }, 33);
	                setTimeout(function () { return _this._betValue.classList.remove("flash"); }, 2000);
	            }
	        }
	        if (BetManager_1.BetManager.TotalBets.length > 1) {
	            if (this._betPlus != null && this._betPlus.classList.contains("_invisible")) {
	                this._betPlus.classList.remove("_invisible");
	            }
	            if (this._betMinus != null && this._betMinus.classList.contains("_invisible")) {
	                this._betMinus.classList.remove("_invisible");
	            }
	        }
	        else {
	            if (this._betPlus != null && !this._betPlus.classList.contains("_invisible")) {
	                this._betPlus.classList.add("_invisible");
	            }
	            if (this._betMinus != null && !this._betMinus.classList.contains("_invisible")) {
	                this._betMinus.classList.add("_invisible");
	            }
	        }
	    };
	    UserControls.prototype.changeBetColor = function (green) {
	        if (green === void 0) { green = false; }
	        if (this._betValue == null) {
	            this._betValue = document.getElementById("betValue");
	        }
	        if (this._betValue != null) {
	            if (green) {
	                this._betValue.style.color = "#39ff04";
	            }
	            else {
	                this._betValue.style.color = "#ffffff";
	            }
	        }
	    };
	    UserControls.prototype.playCollectSound = function () {
	        if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	            if (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod !== "cumulative") {
	                PlayList_1.PlayList.play("SND_BaseCollect");
	            }
	            else if (!FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	                PlayList_1.PlayList.play("SND_BaseCollect");
	            }
	        }
	    };
	    UserControls.prototype.cycleHelp = function () { };
	    UserControls.prototype.changeWinBox = function (collect) {
	        if (collect === void 0) { collect = false; }
	        if (AppContext_1.AppContext != null && !AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	            return;
	        }
	        if (this._uncollectedWin != null) {
	            if (collect) {
	                if (!this._uncollectedWin.classList.contains("_hidden")) {
	                    this._uncollectedWin.classList.add("_hidden");
	                }
	            }
	            else {
	                if (this._uncollectedWin.classList.contains("_hidden")) {
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWinDenom, "0");
	                    this._uncollectedWin.classList.remove("_hidden");
	                }
	            }
	        }
	        if (this._collectedWin != null) {
	            if (collect) {
	                if (this._collectedWin.classList.contains("_hidden")) {
	                    this._collectedWin.classList.remove("_hidden");
	                }
	            }
	            else {
	                if (!this._collectedWin.classList.contains("_hidden")) {
	                    this._collectedWin.classList.add("_hidden");
	                }
	            }
	        }
	    };
	    UserControls.prototype.disableActions = function () {
	        var _this = this;
	        var jackpotSpinBtn = document.getElementById("jackpotSpinBtn");
	        if (jackpotSpinBtn) {
	            jackpotSpinBtn.classList.add("_disabled");
	        }
	        if (this._observer) {
	            return;
	        }
	        var whiteListActions = this.getDisableActionsWhiteList();
	        this._actions.setLockActions(true, whiteListActions);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this._observer = new MutationObserver(function (mutations) {
	            _this.handleMutations(mutations);
	        });
	        this._observer.observe(this.instance, {
	            attributes: true,
	            attributeOldValue: true,
	            childList: true,
	            subtree: true,
	        });
	    };
	    UserControls.prototype.getDisableActionsWhiteList = function () {
	        if (DataManager_1.DataManager.RulesWindowOpened) {
	            return ["AUTOPLAY_STOP", "COLLECT", "GAMBLE_"];
	        }
	        return [];
	    };
	    UserControls.prototype.handleMutations = function (mutations) {
	        if (this.instance.classList.contains("_disabled")) {
	            return;
	        }
	        var jackpotSpinBtn = document.getElementById("jackpotSpinBtn");
	        if (jackpotSpinBtn && !jackpotSpinBtn.classList.contains("_disabled")) {
	            jackpotSpinBtn.classList.add("_disabled");
	        }
	        for (var _i = 0, mutations_1 = mutations; _i < mutations_1.length; _i++) {
	            var mutation = mutations_1[_i];
	            if (mutation.type === "attributes" && mutation.attributeName === "class") {
	                var el = mutation.target;
	                var newValue = el.getAttribute("class");
	                if (mutation.oldValue !== newValue) {
	                    this.disableActions();
	                }
	            }
	            else if (mutation.type === "childList") {
	                this.disableActions();
	            }
	        }
	    };
	    UserControls.prototype.restoreActions = function () {
	        this._actions.setLockActions(false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var jackpotSpinBtn = document.getElementById("jackpotSpinBtn");
	        if (jackpotSpinBtn) {
	            jackpotSpinBtn.classList.remove("_disabled");
	        }
	        if (this._observer) {
	            this._observer.disconnect();
	            this._observer = null;
	        }
	    };
	    UserControls.prototype.restoreGameRound = function () { };
	    UserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], UserControls);
	    return UserControls;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.UserControls = UserControls;


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlElement_1 = __webpack_require__(75);
	var StyleManager_1 = __webpack_require__(20);
	var HtmlManager_1 = __webpack_require__(71);
	var HtmlController_1 = __webpack_require__(31);
	var ComponentTypes_1 = __webpack_require__(14);
	var PlayList_1 = __webpack_require__(33);
	var HtmlContainerElement = (function (_super) {
	    __extends(HtmlContainerElement, _super);
	    function HtmlContainerElement() {
	        _super.call(this);
	        this.childrenHolderClass = "";
	        this.childrenClass = "";
	        this.recalculateHeight = false;
	    }
	    HtmlContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute("id")) {
	            HtmlController_1.HtmlController.ContainerElementsById[node.getAttribute("id")] = this;
	        }
	        if (node.hasAttribute("Style")) {
	            this.style = StyleManager_1.StyleManager.HtmlStyles[node.getAttribute("Style")];
	            if (this.style != null) {
	                this.childs = HtmlManager_1.HtmlManager.parseElements(this.style.node, this);
	            }
	            else {
	                if (false) {
	                    this.logError("ERROR no style with name " + node.getAttribute("Style"));
	                }
	            }
	        }
	        else {
	            this.childs = HtmlManager_1.HtmlManager.parseElements(node, this);
	        }
	        if (this.childs == null) {
	            if (false) {
	                this.log("WARNING html container element with name " + node.nodeName + " has no children");
	            }
	        }
	        if (node.hasAttribute("OnOver")) {
	            if (node.hasAttribute("OnOverAction")) {
	                var actionEnabled = HtmlController_1.HtmlController.Configurations[node.getAttribute("OnOverAction")];
	                if (actionEnabled) {
	                    this._overId = node.getAttribute("OnOver");
	                }
	            }
	            else {
	                this._overId = node.getAttribute("OnOver");
	            }
	        }
	        if (node.hasAttribute("ChildrenHolderClass")) {
	            this.childrenHolderClass = node.getAttribute("ChildrenHolderClass");
	        }
	        if (node.hasAttribute("ChildrenClass")) {
	            this.childrenClass = node.getAttribute("ChildrenClass");
	        }
	        if (node.hasAttribute("RecalculateHeight")) {
	            this.recalculateHeight = neo_common_1.StringUtils.parseBoolean(node.getAttribute("RecalculateHeight"));
	        }
	        if (node.hasAttribute("OnClick")) {
	            if (node.hasAttribute("OnClickAction")) {
	                this._clickId = node.getAttribute("OnClick");
	                this.instance.addEventListener(HtmlContainerElement.CustomClick, this.onCustomClick.bind(this));
	            }
	        }
	        if (this._overId != null) {
	            this.instance.addEventListener(HtmlContainerElement.Over, this.onOver.bind(this));
	            this.instance.addEventListener(HtmlContainerElement.Out, this.onOut.bind(this));
	        }
	        if (node.hasAttribute("ActionsHolder")) {
	            HtmlController_1.HtmlController.registerActionsHoldersElement(node.getAttribute("ActionsHolder"), this);
	        }
	        if (node.hasAttribute("Test")) {
	            this.instance.dataset["test"] = node.getAttribute("Test");
	        }
	        if (node.hasAttribute("UIDispatcher")) {
	            HtmlController_1.HtmlController.registerUiDispatchElement(node.getAttribute("UIDispatcher"), this);
	        }
	        if (node.hasAttribute("UIActionDispatcher")) {
	            HtmlController_1.HtmlController.registerUiActionDispatchElement(node.getAttribute("UIActionDispatcher"), this);
	        }
	        var touchScroll = false;
	        if (node.hasAttribute("TouchScroll")) {
	            touchScroll = neo_common_1.StringUtils.parseBoolean(node.getAttribute("TouchScroll"));
	        }
	        if (touchScroll) {
	            this.enableScrollOnTouchmove();
	        }
	    };
	    HtmlContainerElement.prototype.enableScrollOnTouchmove = function () {
	        var allowScrollUp = true;
	        var allowScrollDown = true;
	        var lastY = 0;
	        var self = this;
	        this.instance.addEventListener("touchstart", function (event) {
	            allowScrollUp = this.scrollTop > 0;
	            allowScrollDown = this.scrollTop < this.scrollHeight - this.clientHeight;
	            lastY = event.touches[0].pageY;
	        }, true);
	        this.instance.addEventListener("touchmove", function (event) {
	            if (event.touches.length === 1) {
	                var up = event.touches[0].pageY > lastY;
	                var down = !up;
	                lastY = event.touches[0].pageY;
	                if ((up && allowScrollUp) || (down && allowScrollDown)) {
	                    event.stopPropagation();
	                }
	                else {
	                    event.preventDefault();
	                }
	            }
	        }, true);
	    };
	    HtmlContainerElement.prototype.onOver = function () {
	        if (this._overId != null) {
	            var element = document.getElementById(this._overId);
	            if (element != null) {
	                element.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	    };
	    HtmlContainerElement.prototype.onOut = function () {
	        if (this._overId != null) {
	            var element = document.getElementById(this._overId);
	            if (element != null) {
	                element.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	    };
	    HtmlContainerElement.prototype.onCustomClick = function () {
	        if (this._clickId != null && HtmlController_1.HtmlController.ContainerElementsById[this._clickId] != null) {
	            PlayList_1.PlayList.play("SND_Click");
	            var element = HtmlController_1.HtmlController.ContainerElementsById[this._clickId];
	            if (element != null && element.instance != null) {
	                if (element.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction("");
	                    if (element.recalculateHeight) {
	                        element.recalculateChildrenHeight(element);
	                    }
	                    element.reset();
	                    element.instance.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	                }
	                else {
	                    if (element.recalculateHeight) {
	                        element.instance.removeAttribute("style");
	                    }
	                    element.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                }
	                if (document.getElementById("autoPlayDialogTop") != null) {
	                    document.getElementById("autoPlayDialogTop").scrollTop = 0;
	                }
	            }
	        }
	    };
	    HtmlContainerElement.prototype.recalculateChildrenHeight = function (element) {
	        if (element.instance != null && element.childrenHolderClass != "" && element.childrenClass != "") {
	            var holders = element.instance.getElementsByClassName(element.childrenHolderClass);
	            if (holders[0] != null) {
	                var paddingTop = parseInt(window.getComputedStyle(holders[0], null).getPropertyValue("padding-top"));
	                var paddingBottom = parseInt(window.getComputedStyle(holders[0], null).getPropertyValue("padding-bottom"));
	                var holdersChildren = holders[0].getElementsByClassName(element.childrenClass);
	                if (holdersChildren != null && holdersChildren.length > 0) {
	                    var height = paddingTop + paddingBottom;
	                    for (var i = 0; i < holdersChildren.length; i++) {
	                        var itemHeight = parseInt(window.getComputedStyle(holdersChildren[i], null).getPropertyValue("height"));
	                        height += itemHeight;
	                    }
	                    element.instance.style.height = height + "px";
	                }
	            }
	        }
	    };
	    HtmlContainerElement.prototype.changeState = function (value) {
	        if (this.instance != null) {
	            if (value) {
	                this.instance.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	            }
	            else {
	                this.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                if (this._clickId != null && HtmlController_1.HtmlController.ContainerElementsById[this._clickId] != null) {
	                    var element = HtmlController_1.HtmlController.ContainerElementsById[this._clickId];
	                    if (element != null && element.instance != null) {
	                        if (!element.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                            if (element.recalculateHeight) {
	                                element.instance.removeAttribute("style");
	                            }
	                            element.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                        }
	                    }
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no instance");
	            }
	        }
	    };
	    HtmlContainerElement.prototype.reset = function () { };
	    HtmlContainerElement.Over = "mouseover";
	    HtmlContainerElement.Out = "mouseout";
	    HtmlContainerElement.TouchStart = "touchstart";
	    HtmlContainerElement.TouchEnd = "touchend";
	    HtmlContainerElement.CustomClick = "click";
	    HtmlContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlContainerElement);
	    return HtmlContainerElement;
	}(HtmlElement_1.HtmlElement));
	exports.HtmlContainerElement = HtmlContainerElement;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlController_1 = __webpack_require__(31);
	var Languages_1 = __webpack_require__(28);
	var ComponentTypes_1 = __webpack_require__(14);
	var GameApp_1 = __webpack_require__(1);
	var AppContext_1 = __webpack_require__(5);
	var HtmlElement = (function () {
	    function HtmlElement(tagName) {
	        if (tagName === void 0) { tagName = "div"; }
	        if (tagName !== "") {
	            this.instance = document.createElement(tagName);
	        }
	    }
	    HtmlElement.prototype.create = function (node) {
	        if (node.hasAttribute("id")) {
	            this.instance.id = node.getAttribute("id");
	        }
	        if (node.hasAttribute("RidFilter")) {
	            this.ridFilter = node.getAttribute("RidFilter");
	        }
	        if (node.hasAttribute("RidType")) {
	            this.ridType = node.getAttribute("RidType");
	        }
	        if (node.hasAttribute("Rid")) {
	            this.rid = node.getAttribute("Rid");
	            HtmlController_1.HtmlController.RidElements.push(this);
	            this.setText();
	        }
	        if (node.hasAttribute("CssClass")) {
	            this.instance.className = node.getAttribute("CssClass");
	        }
	        if (node.hasAttribute("Test")) {
	            this.instance.dataset["test"] = node.getAttribute("Test");
	        }
	        if (node.hasAttribute("Data")) {
	            this.data = node.getAttribute("Data");
	            HtmlController_1.HtmlController.registerDataElement(node.getAttribute("Data"), this);
	        }
	        if (node.hasAttribute("Lang") && this.instance != null && GameApp_1.GameApp.language != null) {
	            this.instance.setAttribute("Language", GameApp_1.GameApp.language);
	        }
	        if (node.hasAttribute("ConfigCondition") && AppContext_1.AppContext.gameConfiguration != null) {
	            var condition = node.getAttribute("ConfigCondition").split("|");
	            if (condition.length == 2) {
	                var config = AppContext_1.AppContext.gameConfiguration[condition[0]].toString();
	                if (config != condition[1]) {
	                    this.instance.parentElement.removeChild(this.instance);
	                }
	            }
	        }
	    };
	    HtmlElement.prototype.setText = function (value) {
	        var text = "";
	        if (value != null) {
	            text = value;
	            this.currentValue = value;
	        }
	        if (this.instance != null) {
	            if (this.rid != null) {
	                if (Languages_1.Languages.getRid(this.rid) != null) {
	                    if (!neo_common_1.StringUtils.isNullOrEmpty(text)) {
	                        var texts = text.split(";");
	                        if (texts.length === 2) {
	                            text = Languages_1.Languages.getRid(this.rid, texts[0], texts[1]);
	                        }
	                        else {
	                            text = Languages_1.Languages.getRid(this.rid, text);
	                        }
	                    }
	                    else {
	                        text = Languages_1.Languages.getRid(this.rid);
	                    }
	                }
	            }
	            if (this.ridType != null) {
	                text = Languages_1.Languages.formatText(this.ridType, text);
	            }
	            if (this.ridFilter != null) {
	                text = Languages_1.Languages.filterText(this.ridFilter, text);
	                if (this.ridFilter === Languages_1.Languages.FilterNoZero && this.instance.classList.contains("bonus")) {
	                    if (text === "") {
	                        this.instance.classList.add("_hidden");
	                    }
	                    else {
	                        this.instance.classList.remove("_hidden");
	                    }
	                }
	            }
	            this.instance.innerHTML = text;
	        }
	        else {
	            if (false) {
	                this.log("ERROR no instance");
	            }
	        }
	    };
	    HtmlElement.prototype.updateText = function () {
	        var text = "";
	        if (this.currentValue != null) {
	            text = this.currentValue;
	        }
	        if (this.instance != null) {
	            if (this.rid != null) {
	                if (Languages_1.Languages.getRid(this.rid) != null) {
	                    if (!neo_common_1.StringUtils.isNullOrEmpty(text)) {
	                        var texts = text.split(";");
	                        if (texts.length === 2) {
	                            text = Languages_1.Languages.getRid(this.rid, texts[0], texts[1]);
	                        }
	                        else {
	                            text = Languages_1.Languages.getRid(this.rid, text);
	                        }
	                    }
	                    else {
	                        text = Languages_1.Languages.getRid(this.rid);
	                    }
	                }
	            }
	            if (this.ridType != null) {
	                text = Languages_1.Languages.formatText(this.ridType, text);
	            }
	            if (this.ridFilter != null) {
	                text = Languages_1.Languages.filterText(this.ridFilter, text);
	                if (this.ridFilter === Languages_1.Languages.FilterNoZero && this.instance.classList.contains("bonus")) {
	                    if (text === "") {
	                        this.instance.classList.add("_hidden");
	                    }
	                    else {
	                        this.instance.classList.remove("_hidden");
	                    }
	                }
	            }
	            this.instance.innerHTML = text;
	        }
	        else {
	            if (false) {
	                this.log("ERROR no instance");
	            }
	        }
	    };
	    HtmlElement.prototype.getText = function () {
	        if (this.currentValue != null) {
	            return this.currentValue;
	        }
	        return null;
	    };
	    HtmlElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    HtmlElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    HtmlElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlElement);
	    return HtmlElement;
	}());
	exports.HtmlElement = HtmlElement;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ActionSet = (function () {
	    function ActionSet(setName, owner) {
	        this._actions = {};
	        this._lockedActions = {};
	        this._lockedActionsWhiteList = [];
	        this._setName = setName;
	        this._owner = owner;
	        this._batchUpdatesActive = false;
	        this._readonly = false;
	        this.registerActions = this.registerActions.bind(this);
	        this.registerAction = this.registerAction.bind(this);
	        this.changeActionState = this.changeActionState.bind(this);
	        this.getActionState = this.getActionState.bind(this);
	        this.getAllActions = this.getAllActions.bind(this);
	        this.batchUpdates = this.batchUpdates.bind(this);
	        this.disableAllActions = this.disableAllActions.bind(this);
	        this.invokeOnChange = this.invokeOnChange.bind(this);
	    }
	    Object.defineProperty(ActionSet.prototype, "onChange", {
	        get: function () {
	            return this._onChange;
	        },
	        set: function (value) {
	            this._onChange = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ActionSet.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this._owner, ("[" + this._setName + "] ") + s);
	        }
	    };
	    ActionSet.prototype.logError = function (s, e) {
	        if (false) {
	            neo_common_1.Logger.errorGroup(this._owner, e, ("[" + this._setName + "] ") + s);
	        }
	    };
	    ActionSet.prototype.invokeOnChange = function () {
	        if (this._onChange && !this._batchUpdatesActive) {
	            try {
	                this.onChange();
	            }
	            catch (e) {
	                if (false) {
	                    this.logError("invokeOnChange", e);
	                }
	            }
	        }
	    };
	    ActionSet.prototype.checkForReadonly = function () {
	        if (this._readonly) {
	            throw new Error("ActionSet \"" + this._owner + "\" [" + this._setName + "] is readonly!");
	        }
	    };
	    ActionSet.prototype.beginBatchUpdates = function () {
	        this.checkForReadonly();
	        if (this._batchUpdatesActive) {
	            throw new Error("\"" + this._owner + "\" [" + this._setName + "] Other batch updates is in pending state!");
	        }
	        this._batchUpdatesActive = true;
	    };
	    ActionSet.prototype.endBatchUpdates = function (hasChanges) {
	        this.checkForReadonly();
	        this._batchUpdatesActive = false;
	        if (neo_common_1.Utils.isNullOrUndefined(hasChanges)) {
	            hasChanges = true;
	        }
	        if (hasChanges) {
	            this.invokeOnChange();
	        }
	    };
	    ActionSet.prototype.batchUpdates = function (updateFn) {
	        this.beginBatchUpdates();
	        var hasChanges;
	        try {
	            hasChanges = updateFn(this);
	        }
	        finally {
	            this.endBatchUpdates(hasChanges);
	        }
	    };
	    ActionSet.prototype.registerActions = function (actions) {
	        this.beginBatchUpdates();
	        try {
	            for (var key in actions) {
	                if (actions.hasOwnProperty(key)) {
	                    this.registerAction(key, actions[key]);
	                }
	            }
	        }
	        finally {
	            this.endBatchUpdates(true);
	        }
	    };
	    ActionSet.prototype.registerAction = function (action, value) {
	        if (value === void 0) { value = false; }
	        this.checkForReadonly();
	        var notExist = neo_common_1.Utils.isNullOrUndefined(this._actions[action]);
	        if (notExist) {
	            this._actions[action] = value;
	            this.invokeOnChange();
	        }
	        else {
	            if (false) {
	                this.log(("[changeActionState] Could not register action '" + action + "', action was already registered!") +
	                    (" all actions: " + JSON.stringify(this._actions)));
	            }
	        }
	        return notExist;
	    };
	    ActionSet.prototype.changeActionStates = function (actionsOrValue, actionNames) {
	        this.beginBatchUpdates();
	        try {
	            var hasValue = typeof actionsOrValue === "boolean";
	            if (hasValue) {
	                for (var i = 0; i < actionNames.length; i++) {
	                    var action = actionNames[i];
	                    this.changeActionState(action, actionsOrValue);
	                }
	            }
	            else {
	                for (var key in actionsOrValue) {
	                    if (actionsOrValue.hasOwnProperty(key)) {
	                        this.changeActionState(key, actionsOrValue[key]);
	                    }
	                }
	            }
	        }
	        finally {
	            this.endBatchUpdates(true);
	        }
	    };
	    ActionSet.prototype.changeActionState = function (action, value) {
	        this.checkForReadonly();
	        var exist = !neo_common_1.Utils.isNullOrUndefined(this._actions[action]);
	        if (exist) {
	            if (this._locked && !this._lockedActionsWhiteList.some(function (substring) { return action.indexOf(substring) > -1; })) {
	                this._lockedActions[action] = value;
	            }
	            else {
	                this._actions[action] = value;
	                this.invokeOnChange();
	            }
	        }
	        else {
	            if (false) {
	                this.log(("[changeActionState] Could not change action '" + action + "' value to '" + value + "', action was not registered!") +
	                    (" all actions: " + JSON.stringify(this._actions)));
	            }
	        }
	        return exist;
	    };
	    ActionSet.prototype.getActionState = function (action) {
	        if (this._actions[action] != null) {
	            return this._actions[action];
	        }
	        else {
	            if (false) {
	                this.log(("[changeActionState] Could not get action '" + action + "' value, action was not registered!") +
	                    (" all actions: " + JSON.stringify(this._actions)));
	            }
	        }
	        return false;
	    };
	    ActionSet.prototype.getAllActions = function () {
	        return this._actions;
	    };
	    ActionSet.prototype.clone = function (readonly) {
	        var cloned = new ActionSet(this._setName, this._owner);
	        for (var key in this._actions) {
	            if (this._actions.hasOwnProperty(key)) {
	                cloned.registerAction(key, this._actions[key]);
	            }
	        }
	        cloned._readonly = neo_common_1.Utils.valueOrDefault(readonly, true);
	        return cloned;
	    };
	    ActionSet.prototype.setLockActions = function (locked, whiteList) {
	        this._locked = locked;
	        this._lockedActionsWhiteList = whiteList ? whiteList : [];
	        if (this._locked) {
	            this.lockActions();
	        }
	        else {
	            this.unLockActions();
	        }
	    };
	    ActionSet.prototype.lockActions = function () {
	        this._lockedActions = {};
	        var _loop_1 = function(key) {
	            if (!this_1._lockedActionsWhiteList.some(function (substring) { return key.indexOf(substring) > -1; })) {
	                this_1._lockedActions[key] = this_1._actions[key];
	                this_1._actions[key] = false;
	            }
	        };
	        var this_1 = this;
	        for (var key in this._actions) {
	            _loop_1(key);
	        }
	        this.invokeOnChange();
	    };
	    ActionSet.prototype.unLockActions = function () {
	        for (var key in this._lockedActions) {
	            this._actions[key] = this._lockedActions[key];
	        }
	        this._lockedActions = {};
	        this.invokeOnChange();
	    };
	    ActionSet.prototype.disableAllActions = function () {
	        this.beginBatchUpdates();
	        try {
	            for (var key in this._actions) {
	                this.changeActionState(key, false);
	            }
	        }
	        finally {
	            this.endBatchUpdates(true);
	        }
	    };
	    return ActionSet;
	}());
	exports.ActionSet = ActionSet;


/***/ },
/* 77 */
/***/ function(module, exports) {

	"use strict";
	var GambleActions = (function () {
	    function GambleActions() {
	    }
	    GambleActions.ActionGambleStart = "GAMBLE_START";
	    GambleActions.ActionGambleRed = "GAMBLE_RED";
	    GambleActions.ActionGambleBlack = "GAMBLE_BLACK";
	    GambleActions.ActionGambleHalve = "GAMBLE_HALVE";
	    GambleActions.ActionGambleCollect = "GAMBLE_COLLECT";
	    return GambleActions;
	}());
	exports.GambleActions = GambleActions;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Controller_1 = __webpack_require__(79);
	var GambleModel_1 = __webpack_require__(80);
	var GambleView_1 = __webpack_require__(81);
	var ComponentTypes_1 = __webpack_require__(14);
	var GambleController = (function (_super) {
	    __extends(GambleController, _super);
	    function GambleController() {
	        _super.call(this);
	    }
	    GambleController.prototype.startInitialization = function (view) {
	        if (false) {
	            this.log("startInitialization");
	        }
	        if (view instanceof GambleView_1.GambleView) {
	            this._view = view;
	        }
	        else {
	            this.log("ERROR view is not instance of GambleView");
	        }
	        this._model = new GambleModel_1.GambleModel(this);
	    };
	    GambleController.prototype.initReceived = function () {
	        this._view.initReceived(this);
	    };
	    GambleController.prototype.initIntro = function () {
	        this._view.initIntro();
	    };
	    GambleController.prototype.start = function () {
	        this._model.start();
	    };
	    GambleController.prototype.startReceived = function () {
	        this._view.startReceived();
	        this.emit(GambleController.StartReceived);
	    };
	    GambleController.prototype.select = function (color) {
	        this._model.select(color);
	    };
	    GambleController.prototype.selectReceived = function () {
	        this._view.selectReceived();
	        this.emit(GambleController.SelectReceived);
	    };
	    GambleController.prototype.halve = function () {
	        this._model.halve();
	    };
	    GambleController.prototype.halveReceived = function () {
	        this.emit(GambleController.HalveReceived);
	    };
	    GambleController.prototype.winCalculationFinished = function () {
	        this.emit(GambleController.WinCalculationFinished);
	    };
	    GambleController.prototype.allWinsFinished = function () {
	        this.emit(GambleController.AllWinsFinished);
	    };
	    GambleController.prototype.lose = function () {
	        this.emit(GambleController.Lose);
	    };
	    GambleController.prototype.intro = function () {
	        this._view.intro();
	    };
	    GambleController.prototype.introFinished = function () {
	        this.emit(GambleController.IntroFinished);
	    };
	    GambleController.prototype.outro = function () {
	        this._view.outro();
	    };
	    GambleController.prototype.outroFinished = function () {
	        this.emit(GambleController.OutroFinished);
	    };
	    GambleController.StartReceived = "eventStartReceived";
	    GambleController.HalveReceived = "eventHalveReceived";
	    GambleController.SelectReceived = "eventSelectReceived";
	    GambleController.WinCalculationFinished = "eventWinCalculationFinished";
	    GambleController.AllWinsFinished = "eventAllWinsFinished";
	    GambleController.Lose = "eventLose";
	    GambleController.IntroFinished = "eventIntroFinished";
	    GambleController.OutroFinished = "eventOutroFinished";
	    GambleController = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Controller)
	    ], GambleController);
	    return GambleController;
	}(Controller_1.Controller));
	exports.GambleController = GambleController;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var Controller = (function (_super) {
	    __extends(Controller, _super);
	    function Controller() {
	        _super.apply(this, arguments);
	    }
	    Controller.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    return Controller;
	}(PIXI.utils.EventEmitter));
	exports.Controller = Controller;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var DataManager_1 = __webpack_require__(26);
	var GameManager_1 = __webpack_require__(23);
	var MessageManager_1 = __webpack_require__(42);
	var GambleModel = (function () {
	    function GambleModel(controller) {
	        this.controller = controller;
	    }
	    GambleModel.prototype.start = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient.start(neo_games_1.Communication.Game.GameModules.Gamble).then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.startReceived.bind(_this), response);
	        });
	    };
	    GambleModel.prototype.select = function (color) {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient.gambleSelect(color).then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.selectReceived.bind(_this), response);
	        });
	    };
	    GambleModel.prototype.halve = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient.gambleHalve(neo_games_1.Communication.Game.GameModules.Gamble).then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.halveReceived.bind(_this), response);
	        });
	    };
	    GambleModel.prototype.startReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.startReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    GambleModel.prototype.selectReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.selectReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    GambleModel.prototype.halveReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.halveReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    return GambleModel;
	}());
	exports.GambleModel = GambleModel;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlController_1 = __webpack_require__(31);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var FrameTimer_1 = __webpack_require__(9);
	var ContainerElement_1 = __webpack_require__(82);
	var PlayList_1 = __webpack_require__(33);
	var GameManager_1 = __webpack_require__(23);
	var GambleView = (function (_super) {
	    __extends(GambleView, _super);
	    function GambleView() {
	        _super.call(this);
	        this._revealTimer = FrameTimer_1.CreateFrameTimer("revealTimer");
	        this._revealTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.reveal.bind(this));
	        this._revealBackTimer = FrameTimer_1.CreateFrameTimer("revealTimer");
	        this._revealBackTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.revealBack.bind(this));
	        this._winTimer = FrameTimer_1.CreateFrameTimer("revealTimer");
	        this._winTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.win.bind(this));
	        this._loseTimer = FrameTimer_1.CreateFrameTimer("revealTimer");
	        this._loseTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.lose.bind(this));
	        this._introDelayTimer = FrameTimer_1.CreateFrameTimer("introDelayTimer");
	        this._introDelayTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.introDelayed.bind(this));
	        this._introSoundTimer = FrameTimer_1.CreateFrameTimer("introSoundTimer");
	        this._introSoundTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.introSoundStart.bind(this));
	        this._outroDelayTimer = FrameTimer_1.CreateFrameTimer("revealTimer");
	        this._outroDelayTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.outroDelayed.bind(this));
	    }
	    GambleView.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	    };
	    GambleView.prototype.initReceived = function (controller) {
	        this._controller = controller;
	        this._gambleControls = document.getElementById("gamble");
	        if (this._gambleControls == null) {
	            if (false) {
	                this.log("ERROR no gamble controlls");
	            }
	        }
	        this._gambleActualCard = document.getElementById("gambleActualCard");
	        if (this._gambleActualCard == null) {
	            if (false) {
	                this.log("ERROR no gambleActualCard");
	            }
	        }
	        this._gambleCardBack = document.getElementById("gambleCardBack");
	        if (this._gambleCardBack == null) {
	            if (false) {
	                this.log("ERROR no gambleCardBack");
	            }
	        }
	        this._gambleWin = document.getElementById("gambleWin");
	        if (this._gambleWin == null) {
	            this._gambleWin = document.getElementById("winBox");
	            if (this._gambleWin == null) {
	                if (false) {
	                    this.log("ERROR no gambleWin");
	                }
	            }
	        }
	        this._gambleWin2 = document.getElementById("winBox2");
	        if (this._gambleWin2 == null) {
	            if (this._gambleWin2 == null) {
	                if (false) {
	                    this.log("ERROR no _gambleWin2");
	                }
	            }
	        }
	        this._gambleRedBtn = document.getElementById("gambleRedBtn");
	        this._gambleBlackBtn = document.getElementById("gambleBlackBtn");
	        if (this._gambleRedBtn != null && this._gambleBlackBtn != null) {
	            this._gambleRedBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.Over, this.onOver.bind(this));
	            this._gambleRedBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.TouchStart, this.onOver.bind(this));
	            this._gambleRedBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.Out, this.onOut.bind(this));
	            this._gambleRedBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.TouchEnd, this.onOut.bind(this));
	            this._gambleBlackBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.Over, this.onOver.bind(this));
	            this._gambleBlackBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.TouchStart, this.onOver.bind(this));
	            this._gambleBlackBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.Out, this.onOut.bind(this));
	            this._gambleBlackBtn.addEventListener(HtmlContainerElement_1.HtmlContainerElement.TouchEnd, this.onOut.bind(this));
	        }
	        this._previousCards = [];
	        for (var i = 0; i < 5; i++) {
	            var card = document.getElementById("previousCard" + i);
	            if (card != null) {
	                this._previousCards.push(card);
	            }
	        }
	    };
	    GambleView.prototype.initIntro = function () {
	        this.previousCards();
	        if (this._gambleControls != null && this._gambleControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._gambleControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	            this._gambleControls.style.display = "block";
	        }
	        PlayList_1.PlayList.loop("SND_GambleLoop");
	    };
	    GambleView.prototype.onOver = function () {
	        if (this._gambleRedBtn != null && !this._gambleRedBtn.classList.contains("_hover")) {
	            this._gambleRedBtn.classList.add("_hover");
	        }
	        if (this._gambleBlackBtn != null && !this._gambleBlackBtn.classList.contains("_hover")) {
	            this._gambleBlackBtn.classList.add("_hover");
	        }
	    };
	    GambleView.prototype.onOut = function () {
	        if (this._gambleRedBtn != null && this._gambleRedBtn.classList.contains("_hover")) {
	            this._gambleRedBtn.classList.remove("_hover");
	        }
	        if (this._gambleBlackBtn != null && this._gambleBlackBtn.classList.contains("_hover")) {
	            this._gambleBlackBtn.classList.remove("_hover");
	        }
	    };
	    GambleView.prototype.startReceived = function () {
	        this.previousCards();
	    };
	    GambleView.prototype.selectReceived = function () {
	        if (GameManager_1.GameManager.gambleResponse.currentCard != null) {
	            if (this._gambleActualCard != null && this._gambleCardBack != null) {
	                this._gambleCardBack.classList.remove("_CA");
	                this._gambleCardBack.classList.remove("_DA");
	                this._gambleCardBack.classList.remove("_HA");
	                this._gambleCardBack.classList.remove("_SA");
	                this._gambleCardBack.classList.remove("_JR");
	                this._gambleCardBack.classList.add("_" + GameManager_1.GameManager.gambleResponse.currentCard);
	                this._gambleActualCard.classList.add("_reveal");
	                if (GameManager_1.GameManager.gambleResponse != null && GameManager_1.GameManager.gambleResponse.currentWin > 0) {
	                    this._revealTimer.start(30);
	                }
	                else {
	                    this._revealTimer.start(60);
	                }
	                PlayList_1.PlayList.play("SND_GambleDraw");
	            }
	        }
	    };
	    GambleView.prototype.previousCards = function () {
	        if (this._previousCards != null && GameManager_1.GameManager.gambleResponse.previousCards != null) {
	            for (var i = 0; i < GameManager_1.GameManager.gambleResponse.previousCards.length; i++) {
	                var card = this._previousCards[i];
	                if (card != null) {
	                    card.classList.remove("_CA");
	                    card.classList.remove("_DA");
	                    card.classList.remove("_HA");
	                    card.classList.remove("_SA");
	                    card.classList.remove("_JR");
	                    if (GameManager_1.GameManager.gambleResponse.previousCards[i] != "XX") {
	                        card.classList.add("_" + GameManager_1.GameManager.gambleResponse.previousCards[i]);
	                    }
	                }
	            }
	        }
	    };
	    GambleView.prototype.reAnimate = function (color) {
	        if (this._gambleActualCard != null && this._gambleActualCard.classList.contains("_reveal")) {
	            this._actualColor = color;
	            this._gambleActualCard.classList.remove("_reveal");
	            PlayList_1.PlayList.play("SND_GambleDraw");
	            this._revealBackTimer.start(30);
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    GambleView.prototype.disabled = function () {
	        if (this._gambleControls != null && !this._gambleControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._gambleControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    GambleView.prototype.intro = function () {
	        this._introDelayTimer.start(1);
	        if (this._gambleControls != null) {
	            this._gambleControls.style.display = "block";
	        }
	    };
	    GambleView.prototype.introDelayed = function () {
	        this._introDelayTimer.stop();
	        if (this._gambleControls != null && this._gambleControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._gambleControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_transition");
	        this._introSoundTimer.start(30);
	    };
	    GambleView.prototype.introSoundStart = function () {
	        this._introSoundTimer.stop();
	        PlayList_1.PlayList.loop("SND_GambleLoop");
	        this._controller.introFinished();
	    };
	    GambleView.prototype.outro = function () {
	        this._outroDelayTimer.start(15);
	        if (this._gambleControls != null && !this._gambleControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._gambleControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        PlayList_1.PlayList.play("SND_GambleTransitionOut");
	        PlayList_1.PlayList.play("SND_transition");
	        PlayList_1.PlayList.stop("SND_GambleLoop");
	    };
	    GambleView.prototype.outroDelayed = function () {
	        this._outroDelayTimer.stop();
	        if (this._gambleControls != null) {
	            this._gambleControls.style.display = "none";
	        }
	        this._controller.outroFinished();
	    };
	    GambleView.prototype.reveal = function () {
	        this._revealTimer.stop();
	        this.previousCards();
	        this._controller.winCalculationFinished();
	        if (GameManager_1.GameManager.gambleResponse != null && GameManager_1.GameManager.gambleResponse.currentWin > 0) {
	            this._gambleActualCard.classList.remove("_reveal");
	            PlayList_1.PlayList.play("SND_GambleWin");
	            if (this._gambleWin != null && !this._gambleWin.classList.contains("winAnimation")) {
	                this._gambleWin.classList.add("winAnimation");
	            }
	            if (this._gambleWin2 != null && !this._gambleWin2.classList.contains("winAnimation")) {
	                this._gambleWin2.classList.add("winAnimation");
	            }
	            this._winTimer.start(15);
	        }
	        else {
	            this._gambleActualCard.classList.remove("_reveal");
	            this._revealBackTimer.start(30);
	            this._loseTimer.start(30);
	        }
	    };
	    GambleView.prototype.revealBack = function () {
	        this.onOut();
	        this._revealBackTimer.stop();
	    };
	    GambleView.prototype.win = function () {
	        this._winTimer.stop();
	        this._revealBackTimer.start(5);
	        if (this._gambleWin != null && this._gambleWin.classList.contains("winAnimation")) {
	            this._gambleWin.classList.remove("winAnimation");
	        }
	        if (this._gambleWin2 != null && this._gambleWin2.classList.contains("winAnimation")) {
	            this._gambleWin2.classList.remove("winAnimation");
	        }
	        this._controller.allWinsFinished();
	    };
	    GambleView.prototype.lose = function () {
	        this._loseTimer.stop();
	        this._controller.lose();
	    };
	    GambleView = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], GambleView);
	    return GambleView;
	}(ContainerElement_1.ContainerElement));
	exports.GambleView = GambleView;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var StyleManager_1 = __webpack_require__(20);
	var CanvasManager_1 = __webpack_require__(68);
	var HtmlManager_1 = __webpack_require__(71);
	var ComponentTypes_1 = __webpack_require__(14);
	var ContainerElement = (function (_super) {
	    __extends(ContainerElement, _super);
	    function ContainerElement() {
	        _super.call(this);
	    }
	    ContainerElement.prototype.internalDestroy = function (options) {
	        if (this.childs != null) {
	            for (var key in this.childs) {
	                if (this.childs.hasOwnProperty(key)) {
	                    if (this.childs[key] instanceof PIXI.DisplayObject) {
	                        this.childs[key].destroy(options);
	                    }
	                    this.childs[key] = null;
	                }
	            }
	            this.childs = null;
	        }
	    };
	    ContainerElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(ContainerElementAttributes.STYLE)) {
	            this.style = StyleManager_1.StyleManager.Styles[node.getAttribute(ContainerElementAttributes.STYLE)];
	            if (this.style != null) {
	                if (this.childs == null) {
	                    this.childs = CanvasManager_1.CanvasManager.parseElements(this.style.node, this);
	                    HtmlManager_1.HtmlManager.parseElements(this.style.node, null);
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name " + node.getAttribute(ContainerElementAttributes.STYLE));
	                }
	            }
	        }
	        else {
	            if (this.childs == null) {
	                this.childs = CanvasManager_1.CanvasManager.parseElements(node, this);
	                HtmlManager_1.HtmlManager.parseElements(node, null);
	            }
	        }
	        if (this.childs == null) {
	            if (false) {
	                this.log("WARNING container element with name " + node.nodeName + " has no children");
	            }
	        }
	    };
	    ContainerElement.prototype.clone = function () {
	        var element = new ContainerElement();
	        element.style = this.style;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        element.name = this.name;
	        element.childs = {};
	        element.removeChildren();
	        for (var key in this.childs) {
	            element.childs[key] = this.childs[key].clone();
	            element.addChild(element.childs[key]);
	        }
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        else if (this.maskGraphics != null) {
	            var elementMask = this.maskGraphics.clone();
	            elementMask.position.x = this.maskGraphics.position.x;
	            elementMask.position.y = this.maskGraphics.position.y;
	            element.maskGraphics = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    ContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ContainerElement);
	    return ContainerElement;
	}(BaseElement_1.BaseElement));
	exports.ContainerElement = ContainerElement;
	var ContainerElementAttributes = {
	    DEBUG: "Debug",
	    ROTATION: "Rotation",
	    STYLE: "Style",
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var BaseActions_1 = __webpack_require__(35);
	var UserControls_1 = __webpack_require__(73);
	var HtmlController_1 = __webpack_require__(31);
	var GameManager_1 = __webpack_require__(23);
	var Paytable_1 = __webpack_require__(56);
	var GameData_1 = __webpack_require__(24);
	var GameActions_1 = __webpack_require__(84);
	var BaseController_1 = __webpack_require__(85);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var BalanceManager_1 = __webpack_require__(27);
	var LimitDialog_1 = __webpack_require__(52);
	var ResponsibleDialog1_1 = __webpack_require__(49);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Jackpot_1 = __webpack_require__(36);
	var Languages_1 = __webpack_require__(28);
	var BuyFeature_1 = __webpack_require__(30);
	var CustomUtils_1 = __webpack_require__(22);
	var CashierDialog_1 = __webpack_require__(50);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var FreeRoundBonusIcon_1 = __webpack_require__(48);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var DesktopBaseUserControls = (function (_super) {
	    __extends(DesktopBaseUserControls, _super);
	    function DesktopBaseUserControls() {
	        _super.call(this, "base");
	        this._wasCalclulated = true;
	        this._unColectedWin = 0;
	        this._machineStopped = true;
	        this.longIntro = false;
	        this.spinBitmask = 31;
	    }
	    DesktopBaseUserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.registerActions();
	        this._afterWinDelay = FrameTimer_1.CreateFrameTimer("afterWinDelay");
	        this._afterWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));
	        this._autoplayDelay = FrameTimer_1.CreateFrameTimer("autoplayDelay");
	        this._autoplayDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));
	        this._unColectedWinDelay = FrameTimer_1.CreateFrameTimer("unColectedWinDelay");
	        this._unColectedWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.unColectedWinDelay.bind(this));
	        this._userControls = document.getElementById("userControls");
	        this._respinDelay = FrameTimer_1.CreateFrameTimer("respinDelay");
	        this._respinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.respin.bind(this));
	        this._gambleDelay = FrameTimer_1.CreateFrameTimer("gambleDelay");
	        this._gambleDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            ModuleManager_1.ModuleManager.enableGamble();
	        });
	    };
	    DesktopBaseUserControls.prototype.addController = function (controller) {
	        this._controller = controller;
	        this._controller.on(BaseController_1.BaseController.SpinReceived, this.spinReceived.bind(this));
	        this._controller.on(BaseController_1.BaseController.RespinReceived, this.respinReceived.bind(this));
	        this._controller.on(BaseController_1.BaseController.MachineStopped, this.machineStopped.bind(this));
	        this._controller.on(BaseController_1.BaseController.WinCalculationFinished, this.winCalculationFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.AllWinsFinished, this.allWinsFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.IntroFinished, this.introFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.OutroFinished, this.outroFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.MachineStoppedWithAnimation, this.machineStoppedWithAnimation.bind(this));
	        this._controller.on(BaseController_1.BaseController.QuickWinCalculationFinished, this.quickWinCalculationFinished.bind(this));
	    };
	    DesktopBaseUserControls.prototype.registerActions = function () {
	        this.actions.registerActions((_a = {},
	            _a[BaseActions_1.BaseActions.ActionAutoplay] = false,
	            _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	            _a[BaseActions_1.BaseActions.ActionBaseCollect] = false,
	            _a[BaseActions_1.BaseActions.ActionBetPlus] = false,
	            _a[BaseActions_1.BaseActions.ActionBetMinus] = false,
	            _a[BaseActions_1.BaseActions.ActionMaxBet] = false,
	            _a[BaseActions_1.BaseActions.ActionSpin] = false,
	            _a[BaseActions_1.BaseActions.ActionBuyFeature] = false,
	            _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = false,
	            _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	            _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	            _a
	        ));
	        var _a;
	    };
	    DesktopBaseUserControls.prototype.initReceived = function () {
	        this._userControls_supreme = document.getElementById("userControls_supreme");
	        _super.prototype.initReceived.call(this);
	        this._controller.initReceived();
	        this._paytable = new Paytable_1.Paytable();
	        this._paytable.initialize();
	        if (GameManager_1.GameManager.baseResponse != null) {
	            if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, GameManager_1.GameManager.gameResponse.totalWin.toString());
	            }
	        }
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls_supreme != null && !ModuleManager_1.ModuleManager.gambleActive()) {
	            this._userControls_supreme.style.display = "none";
	        }
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	            if (this._userControls_supreme != null &&
	                !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        else if (ModuleManager_1.ModuleManager.gambleActive()) {
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        DataManager_1.DataManager.updateDataElements();
	    };
	    DesktopBaseUserControls.prototype.collectReceived = function () {
	        FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        neo_games_1.Platforms.Platforms.roundEnded({
	            id: GameManager_1.GameManager.gameResponse.roundId,
	            win: this._unColectedWin,
	            balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	        });
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: GameManager_1.GameManager.gameResponse.balance.real });
	        _super.prototype.collectReceived.call(this);
	        this._wasCalclulated = true;
	        DataManager_1.DataManager.Collectable = true;
	        DataManager_1.DataManager.updateDataElements();
	        this.prepareNewGameRound();
	        if (AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin && this._unColectedWin > 0) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, this._unColectedWin.toString());
	            this.changeWinBox(true);
	        }
	        else {
	            if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            }
	            this.changeWinBox();
	        }
	        this._unColectedWinDelay.stop();
	        this._unColectedWin = 0;
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	            FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	            this.disableAllActions();
	            return;
	        }
	    };
	    DesktopBaseUserControls.prototype.restoreGameRound = function (collect) {
	        if (collect === void 0) { collect = false; }
	        _super.prototype.collectReceived.call(this);
	        this.changeWinBox(collect);
	        this._controller.changeBet();
	        FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        DataManager_1.DataManager.Collectable = true;
	        if (this._unColectedWin == 0) {
	            this._controller.resetWinAnimator();
	        }
	        this.prepareNewGameRound();
	    };
	    DesktopBaseUserControls.prototype.spinReceived = function () {
	        FreeRoundBonus_1.FreeRoundBonus.frbSpin();
	        var hasFRBRestriction = FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0;
	        if (DataManager_1.DataManager.quickspinEnabled() && !hasFRBRestriction) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop && !hasFRBRestriction);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    DesktopBaseUserControls.prototype.respinReceived = function () {
	        var hasFRBRestriction = FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0;
	        if (DataManager_1.DataManager.quickspinEnabled() && !hasFRBRestriction) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop && !hasFRBRestriction);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    DesktopBaseUserControls.prototype.dispatchAction = function (action) {
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	            return;
	        }
	        if (action === GameActions_1.GameActions.ActionSpinOrStop) {
	            if (this.actions.getActionState(BaseActions_1.BaseActions.ActionSpin)) {
	                action = BaseActions_1.BaseActions.ActionSpin;
	            }
	            else if (this.actions.getActionState(BaseActions_1.BaseActions.ActionSpinStop)) {
	                action = BaseActions_1.BaseActions.ActionSpinStop;
	            }
	            else {
	                return;
	            }
	        }
	        if (this.actions.getActionState(action)) {
	            if (action === BaseActions_1.BaseActions.ActionBaseCollect) {
	                this.changeWinBox(true);
	            }
	            else {
	                this.changeWinBox();
	            }
	            if (action != BaseActions_1.BaseActions.ActionSpin) {
	                PlayList_1.PlayList.play("SND_Click");
	            }
	            _super.prototype.dispatchAction.call(this, action);
	            switch (action) {
	                case BaseActions_1.BaseActions.ActionSpin:
	                    this.spin();
	                    break;
	                case BaseActions_1.BaseActions.ActionSpinStop:
	                    this.stop();
	                    break;
	                case BaseActions_1.BaseActions.ActionAutoplay:
	                    this.autoplay();
	                    break;
	                case BaseActions_1.BaseActions.ActionAutoplayStop:
	                    this.autoplayStop();
	                    break;
	                case BaseActions_1.BaseActions.ActionMaxBet:
	                    this.changeBet(false, true, false);
	                    break;
	                case BaseActions_1.BaseActions.ActionBetPlus:
	                    this.changeBet(false, false, false);
	                    break;
	                case BaseActions_1.BaseActions.ActionBetMinus:
	                    this.changeBet(true, false, false);
	                    break;
	                case BaseActions_1.BaseActions.ActionBaseCollect:
	                    this.collect();
	                    break;
	                case BaseActions_1.BaseActions.ActionBuyFeature:
	                    this.buyFeature();
	                    break;
	                case BaseActions_1.BaseActions.ActionBuyFeatureDialog:
	                    this.openBuyFeature();
	                    break;
	                case BaseActions_1.BaseActions.ActionSkipWin:
	                    this.skipWin();
	                    break;
	            }
	        }
	    };
	    DesktopBaseUserControls.prototype.collect = function () {
	        if (!this._wasCalclulated) {
	            if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0) {
	                neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	            }
	        }
	        _super.prototype.collect.call(this);
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.disable();
	        this.playCollectSound();
	        this._controller.collect();
	        LimitDialog_1.LimitDialog.closeDialog();
	        GameManager_1.GameManager.collect(GameModules.Base);
	        if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, !AppContext_1.AppContext.gameDefinition.Gamble ? "0" : this._unColectedWin.toString());
	        }
	    };
	    DesktopBaseUserControls.prototype.unColectedWinDelay = function () {
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	    };
	    DesktopBaseUserControls.prototype.spin = function () {
	        this._machineStopped = false;
	        this.spinBitmask = 31;
	        if (FreeRoundBonus_1.FreeRoundBonus.hasNewActiveOffer()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0 && !DataManager_1.DataManager.GameRoundClosed) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            }
	            return;
	        }
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        if (ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect &&
	            !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                    this._controller.collect();
	                }
	                GameManager_1.GameManager.canExit();
	                this.changeWinBox();
	            }
	            return;
	        }
	        if (BetHigherThanMinDialog_1.BetHigherThanMinDialog.canOpenDialog()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            BetHigherThanMinDialog_1.BetHigherThanMinDialog.openDialog();
	            return;
	        }
	        if (Paytable_1.Paytable.shouldOpen(true, true)) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                Paytable_1.Paytable.show();
	            }
	            return;
	        }
	        if (!DataManager_1.DataManager.Autoplay &&
	            !this._wasCalclulated &&
	            !DataManager_1.DataManager.GameRoundClosed &&
	            AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	            this.changeWinBox(true);
	            this.collect();
	            return;
	        }
	        else {
	            this.changeWinBox();
	            if (!this._wasCalclulated) {
	                if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0) {
	                    neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	                }
	            }
	        }
	        if (GameManager_1.GameManager.gameResponse.totalWin > 0 && !DataManager_1.DataManager.GameRoundClosed) {
	            var balanceTotal = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal));
	            var balanceAfter = parseFloat(neo_common_1.NumberUtils.add(GameManager_1.GameManager.gameResponse.totalWin, balanceTotal));
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: balanceAfter,
	                inSpin: true,
	            });
	        }
	        if (!neo_games_1.Platforms.Platforms.canSpinOnCollect) {
	            this.autoplayStop();
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                this.changeWinBox();
	                this.prepareNewGameRound();
	            }
	            return;
	        }
	        if (!BalanceManager_1.BalanceManager.hasCredit(false, true)) {
	            DataManager_1.DataManager.Autoplay = false;
	            ModuleManager_1.ModuleManager.disableGamble();
	            this.prepareNewGameRound();
	            return;
	        }
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (DataManager_1.DataManager.Autoplay) {
	            if (!DataManager_1.DataManager.AutoplayStarted &&
	                GameManager_1.GameManager.baseResponse != null &&
	                GameManager_1.GameManager.baseResponse.totalWin != null &&
	                GameManager_1.GameManager.baseResponse.totalWin > 0) {
	                DataManager_1.DataManager.updateLossLimit(GameManager_1.GameManager.baseResponse.totalWin);
	            }
	            DataManager_1.DataManager.updateLossLimit();
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this.playCollectSound();
	        DataManager_1.DataManager.updateTotalGain(true);
	        BalanceManager_1.BalanceManager.fixBalance();
	        if (!DataManager_1.DataManager.GameRoundClosed || (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        }
	        this._controller.spin(this.spinBitmask);
	        LimitDialog_1.LimitDialog.closeDialog();
	        this._wasCalclulated = false;
	        neo_games_1.Platforms.Platforms.roundStarted({
	            totalBet: BetManager_1.BetManager.Bet,
	            freeRound: FreeRoundBonus_1.FreeRoundBonus.inFrb,
	            userAction: DataManager_1.DataManager.getTrustedUserAction(BaseActions_1.BaseActions.ActionSpin),
	        });
	        neo_games_1.Platforms.Platforms.spinStarted();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)) });
	    };
	    DesktopBaseUserControls.prototype.respin = function () {
	        this._machineStopped = false;
	        this._respinDelay.stop();
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, true);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            if (GameManager_1.GameManager.baseResponse.hasOwnProperty("respin")) {
	                this.spinBitmask = GameManager_1.GameManager.baseResponse.respin;
	            }
	        }
	        this._controller.respin(this.spinBitmask);
	        neo_games_1.Platforms.Platforms.spinStarted();
	    };
	    DesktopBaseUserControls.prototype.stop = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        DataManager_1.DataManager.quickspinStopped();
	        this._controller.stop();
	    };
	    DesktopBaseUserControls.prototype.openBuyFeature = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        BuyFeature_1.BuyFeature.open();
	    };
	    DesktopBaseUserControls.prototype.buyFeature = function () {
	        this.spinBitmask = 31;
	        BuyFeature_1.BuyFeature.spin();
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        this._machineStopped = false;
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var buyfeatureOriginalBet = BuyFeature_1.BuyFeature.getBuyfeatureOriginalBet();
	        var buyFeatureBet = BuyFeature_1.BuyFeature.getBuyFeatureBet();
	        BetManager_1.BetManager.Bet = buyFeatureBet.totalBet;
	        if (!BalanceManager_1.BalanceManager.hasCredit(false, true)) {
	            BetManager_1.BetManager.changeBetByValue(buyfeatureOriginalBet);
	            this.prepareNewGameRound();
	            return;
	        }
	        DataManager_1.DataManager.updateTotalGain(true);
	        BalanceManager_1.BalanceManager.fixBalance();
	        BetManager_1.BetManager.changeBetByValue(buyfeatureOriginalBet);
	        this.initNewBet();
	        this._controller.buyFeature(this.spinBitmask);
	        LimitDialog_1.LimitDialog.closeDialog();
	        this._wasCalclulated = false;
	        neo_games_1.Platforms.Platforms.roundStarted({ totalBet: BuyFeature_1.BuyFeature.getBuyFeatureBet().totalBet });
	        neo_games_1.Platforms.Platforms.spinStarted();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)) });
	    };
	    DesktopBaseUserControls.prototype.autoplayDelayed = function () {
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	    };
	    DesktopBaseUserControls.prototype.prepareSkipWin = function () {
	        if (GameManager_1.GameManager.gameResponse.totalWin === 0 || !AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplaySkipWinAnimationsEnabled) {
	            this.skipWin();
	            return;
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSkipWin, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionSkipWin, true);
	    };
	    DesktopBaseUserControls.prototype.skipWin = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSkipWin, false);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionSkipWin, false);
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            if (!this._wasCalclulated &&
	                !DataManager_1.DataManager.GameRoundClosed &&
	                AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	                this.changeWinBox(true);
	                this.collect();
	                this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	                HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	                this._autoplayDelay.start(60);
	            }
	            else {
	                this.autoplay();
	            }
	        }
	        else {
	            this.spin();
	        }
	    };
	    DesktopBaseUserControls.prototype.autoplay = function () {
	        this._afterWinDelay.stop();
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayPaused) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayCount === "∞") {
	            DataManager_1.DataManager.Autoplay = true;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	            this.spin();
	        }
	        else {
	            DataManager_1.DataManager.AutoplayCount = (parseInt(DataManager_1.DataManager.AutoplayCount) - 1).toString();
	            if (parseInt(DataManager_1.DataManager.AutoplayCount) >= 0) {
	                DataManager_1.DataManager.Autoplay = true;
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	                this.spin();
	            }
	            else {
	                DataManager_1.DataManager.Autoplay = false;
	                this.prepareNewGameRound();
	            }
	        }
	    };
	    DesktopBaseUserControls.prototype.autoplayStop = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        neo_games_1.Platforms.Platforms.autoplayStop();
	        if (this._machineStopped) {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	                neo_games_1.Platforms.Platforms.roundEnded();
	                if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                    FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                    this.disableAllActions();
	                }
	            }
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, false);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, false);
	    };
	    DesktopBaseUserControls.prototype.changeBet = function (decrease, max, cycle) {
	        if (decrease === void 0) { decrease = false; }
	        if (max === void 0) { max = false; }
	        if (cycle === void 0) { cycle = false; }
	        if (!DataManager_1.DataManager.GameRoundClosed) {
	            this._unColectedWin = 0;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            this.changeWinBox();
	            this.collect();
	        }
	        else {
	            this._controller.collect();
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal);
	            LimitDialog_1.LimitDialog.closeDialog();
	        }
	        BetManager_1.BetManager.changeBet(decrease, max, cycle);
	        this._paytable.updateDataValues();
	        if (BetManager_1.BetManager.minBet) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, false);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, false);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, true);
	        }
	        else if (BetManager_1.BetManager.maxBet) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, false);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, false);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, true);
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, true);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, true);
	        }
	        if (AppContext_1.AppContext.gameConfiguration.ShowMaxBetMessage && max) {
	            var message = AppContext_1.AppContext.gameConfiguration.MaxButton
	                ? Languages_1.Languages.getRid("MAX_BET_MESSAGE_PL")
	                : Languages_1.Languages.getRid("MAX_BET_MESSAGE");
	            GameManager_1.GameManager.openConfirmationDialog(neo_games_1.Communication.Game.GameModules.Base, message);
	        }
	        this._controller.changeBet();
	    };
	    DesktopBaseUserControls.prototype.machineStoppedWithAnimation = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    DesktopBaseUserControls.prototype.quickWinCalculationFinished = function () {
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	    };
	    DesktopBaseUserControls.prototype.machineStopped = function (isHighWins) {
	        if (isHighWins === void 0) { isHighWins = false; }
	        this._machineStopped = true;
	        neo_games_1.Platforms.Platforms.spinEnded();
	        DataManager_1.DataManager.stopAutoplayIfLossLimit();
	        DataManager_1.DataManager.stopAutoplayIfWinLimit();
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	            });
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                this.disableAllActions();
	                return;
	            }
	        }
	        this._unColectedWinDelay.stop();
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this.disable();
	            if (DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, true);
	                HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            }
	            if (GameManager_1.GameManager.baseResponse.currentWin == 0) {
	                this.respin();
	            }
	            return;
	        }
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            FreeRoundBonus_1.FreeRoundBonus.disableUi();
	            this.disable();
	            return;
	        }
	        if (DataManager_1.DataManager.Autoplay) {
	            if (DataManager_1.DataManager.AutoplayCount === 0 + "") {
	                DataManager_1.DataManager.Autoplay = false;
	            }
	        }
	        if (GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            this._wasCalclulated = true;
	            DataManager_1.DataManager.Collectable = true;
	        }
	        else {
	            this._wasCalclulated = false;
	        }
	        if (!isHighWins) {
	            ModuleManager_1.ModuleManager.enableGamble();
	        }
	        else {
	            this._gambleDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration + 30);
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        if (GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (GameManager_1.GameManager.baseResponse.gameMultiplier > 2) {
	                this._afterWinDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration + 30);
	            }
	            else {
	                this._afterWinDelay.start(30);
	            }
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (DataManager_1.DataManager.Autoplay && GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            this._autoplayDelay.start(15);
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this.disableAllActions();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed &&
	                GameManager_1.GameManager.baseResponse.totalWin > 0 &&
	                GameManager_1.GameManager.baseResponse.currentWin === 0) {
	                this._controller.resetWinAnimator();
	                this.collect();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                GameManager_1.GameManager.canExit();
	            }
	        }
	    };
	    DesktopBaseUserControls.prototype.winCalculationFinished = function () {
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	            });
	        }
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isRespin() || ModuleManager_1.ModuleManager.bonusEnabled()) {
	            return;
	        }
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.GameRoundClosed && !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElements();
	        }
	        ModuleManager_1.ModuleManager.enableGamble();
	        DataManager_1.DataManager.Collectable = true;
	        this.prepareNewGameRound();
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (!ModuleManager_1.ModuleManager.gambleEnabled()) {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            }
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this.disableAllActions();
	                return;
	            }
	        }
	        else {
	            FreeRoundBonus_1.FreeRoundBonus.enableFrbExpiration();
	        }
	    };
	    DesktopBaseUserControls.prototype.allWinsFinished = function () {
	        FreeRoundBonus_1.FreeRoundBonus.enableFrbExpiration();
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            ModuleManager_1.ModuleManager.enableBonus();
	            return;
	        }
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this._respinDelay.start(30);
	            return;
	        }
	        this._afterWinDelay.stop();
	        this.prepareNewGameRound();
	        ModuleManager_1.ModuleManager.enableGamble();
	        if (DataManager_1.DataManager.Autoplay && this.actions.getActionState(BaseActions_1.BaseActions.ActionAutoplayStop)) {
	            this.autoplay();
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this._controller.resetWinAnimator();
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                ModuleManager_1.ModuleManager.disableBase();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	                this._controller.resetWinAnimator();
	                this.collect();
	                return;
	            }
	        }
	    };
	    DesktopBaseUserControls.prototype.initIntro = function () {
	        _super.prototype.initIntro.call(this);
	        this._controller.initIntro();
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this.disable();
	            this._respinDelay.start(30);
	            return;
	        }
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            ModuleManager_1.ModuleManager.enableBonus();
	            return;
	        }
	        this.prepareNewGameRound();
	        ModuleManager_1.ModuleManager.enableGamble();
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        BuyFeature_1.BuyFeature.showBuyFeatureIcon(true);
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                ModuleManager_1.ModuleManager.disableBase();
	            }
	            return;
	        }
	    };
	    DesktopBaseUserControls.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        this._wasCalclulated = true;
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        this.longIntro = long;
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal);
	            DataManager_1.DataManager.Collectable = true;
	        }
	        this._controller.intro(long, previousModule);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	    };
	    DesktopBaseUserControls.prototype.introFinished = function () {
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            neo_games_1.Platforms.Platforms.roundEnded();
	        }
	        if (!ResponsibleDialog1_1.ResponsibleDialog1.opened) {
	            DataManager_1.DataManager.Autoplay = DataManager_1.DataManager.AutoplayAfterGamble;
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this.longIntro &&
	            DataManager_1.DataManager.GameRoundClosed &&
	            (FreeRoundBonus_1.FreeRoundBonus.id != null || FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0)) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            this.longIntro = false;
	        }
	        ModuleManager_1.ModuleManager.enableGamble();
	        this.prepareNewGameRound();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && DataManager_1.DataManager.GameRoundClosed) {
	            FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	            ModuleManager_1.ModuleManager.disableBase();
	            return;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                if (!CustomUtils_1.CustomUtils.isRespinEnabled() && !CustomUtils_1.CustomUtils.isRespinActive()) {
	                    ModuleManager_1.ModuleManager.collect(GameModules.Base);
	                }
	            }
	        }
	    };
	    DesktopBaseUserControls.prototype.outro = function () {
	        if (!this._wasCalclulated) {
	            if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.gameResponse.totalWin);
	            }
	        }
	        BuyFeature_1.BuyFeature.disable();
	        this._afterWinDelay.stop();
	        this._autoplayDelay.stop();
	        DataManager_1.DataManager.AutoplayAfterGamble = DataManager_1.DataManager.Autoplay;
	        DataManager_1.DataManager.Autoplay = false;
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            DataManager_1.DataManager.AutoplayAfterGamble = false;
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	            if (this._userControls_supreme != null &&
	                !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        this._controller.outro();
	    };
	    DesktopBaseUserControls.prototype.outroFinished = function () {
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            ModuleManager_1.ModuleManager.introModule(GameModules.BonusRespins, true, GameModules.Base);
	        }
	        else {
	            ModuleManager_1.ModuleManager.introModule(GameModules.Gamble, true, GameModules.Base);
	        }
	    };
	    DesktopBaseUserControls.prototype.prepareNewGameRound = function () {
	        this._afterWinDelay.stop();
	        if (this.prepareJackpotMiniGame()) {
	            return;
	        }
	        if (ResponsibleDialog1_1.ResponsibleDialog1.opened) {
	            return;
	        }
	        if (BuyFeature_1.BuyFeature.isOpen()) {
	            var featureEnabled = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                !CashierDialog_1.CashierDialog.opened;
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, featureEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, featureEnabled);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, featureEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, featureEnabled);
	            return;
	        }
	        BuyFeature_1.BuyFeature.restore();
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.openDialog();
	        Paytable_1.Paytable.openAtStart(true);
	        if (BetHigherThanMinDialog_1.BetHigherThanMinDialog.canOpenDialog() && FreeRoundBonusDialog_1.FreeRoundBonusDialog.dialogActive()) {
	            return;
	        }
	        if (DataManager_1.DataManager.GameLimit) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.limit();
	        }
	        else {
	            if (!DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionStates((_a = {},
	                    _a[BaseActions_1.BaseActions.ActionAutoplay] = (DataManager_1.DataManager.GameRoundClosed ||
	                        (FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                            FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative" &&
	                            !FreeRoundBonus_1.FreeRoundBonus.isLastFrb)) &&
	                        AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                    _a[BaseActions_1.BaseActions.ActionBaseCollect] = FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative"
	                        ? false
	                        : !DataManager_1.DataManager.GameRoundClosed,
	                    _a[BaseActions_1.BaseActions.ActionBetPlus] = !BetManager_1.BetManager.maxBet,
	                    _a[BaseActions_1.BaseActions.ActionBetMinus] = !BetManager_1.BetManager.minBet,
	                    _a[BaseActions_1.BaseActions.ActionMaxBet] = !ModuleManager_1.ModuleManager.gambleEnabled() &&
	                        !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                        AppContext_1.AppContext.gameConfiguration.MaxBetEnabled,
	                    _a[BaseActions_1.BaseActions.ActionSpin] = !FreeRoundBonus_1.FreeRoundBonus.isLastFrb,
	                    _a[BaseActions_1.BaseActions.ActionBuyFeature] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                        !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                        !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                        !CashierDialog_1.CashierDialog.opened,
	                    _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                        !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                        !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                        !CashierDialog_1.CashierDialog.opened,
	                    _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                    _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                    _a
	                ));
	                if (DataManager_1.DataManager.GameRoundClosed) {
	                    if (!AppContext_1.AppContext.gameConfiguration.ShowPaytableAtStart || Paytable_1.Paytable.userClosedPaytableAtStart) {
	                        neo_games_1.Platforms.Platforms.roundInit();
	                    }
	                }
	            }
	            else {
	                this.prepareSkipWin();
	            }
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var _a;
	    };
	    DesktopBaseUserControls.prototype.prepareJackpotMiniGame = function () {
	        if (DataManager_1.DataManager.GameRoundClosed && Jackpot_1.Jackpot.hasMiniGame() && !FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            if (Jackpot_1.Jackpot.hasInitializedGame() && this._wasCalclulated) {
	                DataManager_1.DataManager.Autoplay = false;
	                this.resetWinAnimator();
	                this.disable();
	                FreeRoundBonus_1.FreeRoundBonus.disableUi();
	                Jackpot_1.Jackpot.startMiniGame();
	                return true;
	            }
	            else {
	                var self_1 = this;
	                if (this._wasCalclulated) {
	                    Jackpot_1.Jackpot.initMiniGame(true, function () {
	                        self_1.resetWinAnimator();
	                        self_1.disable();
	                        DataManager_1.DataManager.Autoplay = false;
	                        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	                    });
	                }
	                if (DataManager_1.DataManager.GameLimit) {
	                    DataManager_1.DataManager.Autoplay = false;
	                    this.limit();
	                }
	                if (Jackpot_1.Jackpot.waitForMiniGameInitialization()) {
	                    this.actions.disableAllActions();
	                    HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    DesktopBaseUserControls.prototype.checkJackpotMiniGame = function () {
	        if (!Jackpot_1.Jackpot.hasMiniGame() || FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            return false;
	        }
	        if (Jackpot_1.Jackpot.hasInitializedGame() || Jackpot_1.Jackpot.waitForMiniGameInitialization()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox();
	                this._wasCalclulated = true;
	                if (!DataManager_1.DataManager.GameRoundClosed) {
	                    this.collect();
	                }
	                else {
	                    this.playCollectSound();
	                    DataManager_1.DataManager.updateDataElements();
	                    this.prepareNewGameRound();
	                }
	            }
	            else {
	                this.prepareNewGameRound();
	            }
	            return true;
	        }
	        else {
	            Jackpot_1.Jackpot.initMiniGame(false, null);
	            Jackpot_1.Jackpot.disableMiniGameAutostart();
	            return false;
	        }
	    };
	    DesktopBaseUserControls.prototype.limit = function () {
	        LimitDialog_1.LimitDialog.openDialog();
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            this.actions.changeActionStates((_a = {},
	                _a[BaseActions_1.BaseActions.ActionAutoplay] = AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                _a[BaseActions_1.BaseActions.ActionBaseCollect] = false,
	                _a[BaseActions_1.BaseActions.ActionBetPlus] = !BetManager_1.BetManager.maxBet,
	                _a[BaseActions_1.BaseActions.ActionBetMinus] = !BetManager_1.BetManager.minBet,
	                _a[BaseActions_1.BaseActions.ActionMaxBet] = !FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.MaxBetEnabled,
	                _a[BaseActions_1.BaseActions.ActionSpin] = true,
	                _a[BaseActions_1.BaseActions.ActionBuyFeature] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                    !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                    !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                    !CashierDialog_1.CashierDialog.opened,
	                _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                    !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                    !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                    !CashierDialog_1.CashierDialog.opened,
	                _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                _a
	            ));
	        }
	        else {
	            this.actions.changeActionStates((_b = {},
	                _b[BaseActions_1.BaseActions.ActionAutoplay] = false,
	                _b[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                _b[BaseActions_1.BaseActions.ActionBaseCollect] = true,
	                _b[BaseActions_1.BaseActions.ActionBetPlus] = false,
	                _b[BaseActions_1.BaseActions.ActionBetMinus] = false,
	                _b[BaseActions_1.BaseActions.ActionMaxBet] = false,
	                _b[BaseActions_1.BaseActions.ActionSpin] = false,
	                _b[BaseActions_1.BaseActions.ActionBuyFeature] = false,
	                _b[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = false,
	                _b[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                _b[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                _b
	            ));
	        }
	        var _a, _b;
	    };
	    DesktopBaseUserControls.prototype.restoreActions = function () {
	        _super.prototype.restoreActions.call(this);
	        if (DataManager_1.DataManager.Autoplay &&
	            this._machineStopped &&
	            this.actions.getActionState(BaseActions_1.BaseActions.ActionAutoplayStop)) {
	            this._autoplayDelay.stop();
	            this._autoplayDelay.start(30);
	        }
	    };
	    DesktopBaseUserControls.prototype.disable = function () {
	        this._afterWinDelay.stop();
	        this.actions.disableAllActions();
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.disableActiveIcon();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (!CustomUtils_1.CustomUtils.isRespin()) {
	            this._controller.disableBase();
	        }
	    };
	    DesktopBaseUserControls.prototype.resetWinAnimator = function () {
	        this._controller.resetWinAnimator();
	    };
	    DesktopBaseUserControls.prototype.disableAllActions = function () {
	        this._afterWinDelay.stop();
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    DesktopBaseUserControls.prototype.enableBuyFeature = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	    };
	    DesktopBaseUserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], DesktopBaseUserControls);
	    return DesktopBaseUserControls;
	}(UserControls_1.UserControls));
	exports.DesktopBaseUserControls = DesktopBaseUserControls;


/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	var GameActions = (function () {
	    function GameActions() {
	    }
	    GameActions.ActionSpinOrStop = "SPIN_OR_STOP";
	    return GameActions;
	}());
	exports.GameActions = GameActions;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseModel_1 = __webpack_require__(43);
	var BaseView_1 = __webpack_require__(86);
	var Controller_1 = __webpack_require__(79);
	var ComponentTypes_1 = __webpack_require__(14);
	var Machine_1 = __webpack_require__(87);
	var BaseController = (function (_super) {
	    __extends(BaseController, _super);
	    function BaseController() {
	        _super.apply(this, arguments);
	    }
	    BaseController.prototype.startInitialization = function (view) {
	        if (false) {
	            this.log("startInitialization");
	        }
	        if (view instanceof BaseView_1.BaseView) {
	            this._view = view;
	        }
	        else {
	            if (false) {
	                this.log("ERROR view is not instance of BaseView");
	            }
	        }
	        this._model = new BaseModel_1.BaseModel(this);
	    };
	    BaseController.prototype.disableLogo = function () {
	        this._view.disableLogo();
	    };
	    BaseController.prototype.initReceived = function () {
	        this._view.initReceived(this);
	    };
	    BaseController.prototype.initIntro = function () {
	        this._view.initIntro();
	    };
	    BaseController.prototype.collect = function () {
	        this._view.collect();
	    };
	    BaseController.prototype.spin = function (reels) {
	        this._model.spin();
	        this._view.spin(reels);
	    };
	    BaseController.prototype.buyFeature = function (reels) {
	        this._model.buyFeature();
	        this._view.changeBet();
	        this._view.spin(reels);
	    };
	    BaseController.prototype.respin = function (reels) {
	        this._model.respin();
	        this._view.respin(reels);
	    };
	    BaseController.prototype.stop = function () {
	        this._view.stop();
	    };
	    BaseController.prototype.spinReceived = function () {
	        this._view.spinReceived();
	        this.emit(BaseController.SpinReceived);
	    };
	    BaseController.prototype.respinReceived = function () {
	        Machine_1.Machine.Respin = true;
	        this._view.spinReceived();
	        this.emit(BaseController.RespinReceived);
	    };
	    BaseController.prototype.machineStoppedWithAnimation = function () {
	        this.emit(BaseController.MachineStoppedWithAnimation);
	    };
	    BaseController.prototype.quickWinCalculationFinished = function () {
	        this.emit(BaseController.QuickWinCalculationFinished);
	    };
	    BaseController.prototype.machineStopped = function (isHighWins) {
	        if (isHighWins === void 0) { isHighWins = false; }
	        this.emit(BaseController.MachineStopped, isHighWins);
	    };
	    BaseController.prototype.winCalculationFinished = function () {
	        this.emit(BaseController.WinCalculationFinished);
	    };
	    BaseController.prototype.allWinsFinished = function () {
	        this.emit(BaseController.AllWinsFinished);
	    };
	    BaseController.prototype.resetWinAnimator = function () {
	        this._view.resetWinAnimator();
	    };
	    BaseController.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        this._view.intro(long, previousModule);
	    };
	    BaseController.prototype.introFinished = function () {
	        this.emit(BaseController.IntroFinished);
	    };
	    BaseController.prototype.outro = function () {
	        this._view.outro();
	    };
	    BaseController.prototype.outroFinished = function () {
	        this.emit(BaseController.OutroFinished);
	    };
	    BaseController.prototype.stickyAnimationFinished = function () {
	        this.emit(BaseController.StickyAnimationFinished);
	    };
	    BaseController.prototype.disableBase = function () {
	        this._view.disableBase();
	    };
	    BaseController.prototype.resetScreen = function () {
	        this._view.resetScreen();
	    };
	    BaseController.prototype.toggleSounds = function (enable) {
	        this._view.toggleSounds(enable);
	    };
	    BaseController.prototype.changeBet = function () {
	        this._view.changeBet();
	    };
	    BaseController.SpinReceived = "eventSpinReceived";
	    BaseController.RespinReceived = "eventRespinReceived";
	    BaseController.MachineStopped = "eventMachineStopped";
	    BaseController.WinCalculationFinished = "eventWinCalculationFinished";
	    BaseController.AllWinsFinished = "eventAllWinsFinished";
	    BaseController.OutroFinished = "eventOutroFinished";
	    BaseController.IntroFinished = "eventIntroFinished";
	    BaseController.MachineStoppedWithAnimation = "eventMachineStoppedWithAnimation";
	    BaseController.QuickWinCalculationFinished = "eventQuickWinCalculationFinished";
	    BaseController.StickyAnimationFinished = "eventStickyAnimationFinished";
	    BaseController = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Controller)
	    ], BaseController);
	    return BaseController;
	}(Controller_1.Controller));
	exports.BaseController = BaseController;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ContainerElement_1 = __webpack_require__(82);
	var FrameTimer_1 = __webpack_require__(9);
	var Machine_1 = __webpack_require__(87);
	var StageController_1 = __webpack_require__(6);
	var WinAnimator_1 = __webpack_require__(101);
	var GameManager_1 = __webpack_require__(23);
	var PlayList_1 = __webpack_require__(33);
	var Tweens_1 = __webpack_require__(15);
	var ShapeElement_1 = __webpack_require__(13);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var WinAnimatorExtended_1 = __webpack_require__(107);
	var CustomUtils_1 = __webpack_require__(22);
	var LayoutSwitchElement_1 = __webpack_require__(108);
	var LayoutManager_1 = __webpack_require__(109);
	var LayoutContainerElement_1 = __webpack_require__(110);
	var neo_games_1 = __webpack_require__(3);
	var AmbientBackground_1 = __webpack_require__(41);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var BaseView = (function (_super) {
	    __extends(BaseView, _super);
	    function BaseView() {
	        _super.call(this);
	        this._wasFinished = false;
	        this._introDelay = FrameTimer_1.CreateFrameTimer("introDelay");
	        this._introDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.introFinished.bind(this));
	        this._outroDelay = FrameTimer_1.CreateFrameTimer("outroDelay");
	        this._outroDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.outroStart.bind(this));
	        this._outroFinishDelay = FrameTimer_1.CreateFrameTimer("outroFinishDelay");
	        this._outroFinishDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.outroFinished.bind(this));
	        this._respinCounter = -1;
	    }
	    BaseView.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        BaseView.LayoutManager = new LayoutManager_1.LayoutManager();
	        if (this.childs["Symbols"] != null) {
	            this._symbols = this.childs["Symbols"];
	            this.removeChild(this._symbols);
	        }
	        this._machine = CustomUtils_1.CustomUtils.getObjectFrom("Machine", this.childs);
	        this._winAnimator = CustomUtils_1.CustomUtils.getObjectFrom("WinAnimator", this.childs);
	        if (this.childs["Background"] != null) {
	            this._background = this.childs["Background"];
	        }
	        if (this.childs["GambleTransition"] != null) {
	            this._gambleTransition = this.childs["GambleTransition"];
	            this._gambleTransitionSceneHolder = (this._gambleTransition.getChildElementByName("Scene"));
	        }
	        if (this.childs["BonusTransition"] != null) {
	            this._bonusTransition = this.childs["BonusTransition"];
	            this._bonusTransitionSceneHolder = this._bonusTransition.getChildElementByName("Scene");
	        }
	        if (this.childs["TopCounters"] instanceof ContainerElement_1.ContainerElement) {
	            var topCounters = this.childs["TopCounters"];
	            BaseView.BonusCounters = topCounters.childs["BonusCounters"];
	            BaseView.BonusCounters.goToCase("NORMAL");
	        }
	        BaseView.Messages = CustomUtils_1.CustomUtils.getObjectFrom("Messages", this.childs, LayoutSwitchElement_1.LayoutSwitchElement);
	        this.setupGambleTransitionSceneElement();
	        this.setupBonusTransitionSceneElement();
	    };
	    BaseView.prototype.disableLogo = function () {
	    };
	    BaseView.prototype.initReceived = function (controller) {
	        if (false) {
	            this.log("initReceived");
	        }
	        this._controller = controller;
	        if (BaseView.BonusCounters) {
	            BaseView.BonusCounters.updateCounters();
	        }
	        if (this._symbols != null) {
	            if (this._machine != null) {
	                if (GameManager_1.GameManager.baseResponse != null) {
	                    var baseInitDataReels = GameManager_1.GameManager.getBaseInitDataReels();
	                    if (baseInitDataReels != null) {
	                        this._machine.on(Machine_1.Machine.ReelStopped, this.onReelStopped.bind(this));
	                        this._machine.on(Machine_1.Machine.MachineStopped, this.machineStopped.bind(this));
	                        this._machine.initialize(this._symbols, baseInitDataReels, null, this.childs["Teasing"], GameManager_1.GameManager.baseResponse.initData.customData.respinReels, this._winAnimator);
	                        var baseInitDataCustomAdditionalReelSets = GameManager_1.GameManager.getBaseInitDataCustomAdditionalReelSets();
	                        if (baseInitDataCustomAdditionalReelSets != null) {
	                            this._machine.addAdditionalReelSets(baseInitDataCustomAdditionalReelSets);
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reels in initData");
	                        }
	                    }
	                    if (GameManager_1.GameManager.baseResponse.screen != null &&
	                        GameManager_1.GameManager.baseResponse.screen.reels != null &&
	                        GameManager_1.GameManager.baseResponse.screen.reels.length !== 0) {
	                        if (this._winAnimator != null) {
	                            this._winAnimator.on(WinAnimator_1.WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
	                            this._winAnimator.on(WinAnimator_1.WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
	                            this._winAnimator.on(WinAnimatorExtended_1.WinAnimatorExtended.FinishQuickWinCalculation, this.finishQuickWinCalculation.bind(this));
	                            this._winAnimator.on(WinAnimatorExtended_1.WinAnimatorExtended.StickyAnimationFinished, this.machineStoppedFinished.bind(this));
	                            this._winAnimator.initialize(this._symbols, this.childs["Paylines"], this.childs["NoWinContainer"], this.childs["WinContainer"], this._background, this.childs["PaylinesFields"]);
	                            this._winAnimator.initializeStickyContainer(this.childs["StickyContainer"]);
	                            this._winAnimator.initializeMultiplierContainer(this.childs["BigMultiplier"], this.childs["TopMultipliers"]);
	                            this._winAnimator.showSymbols(GameManager_1.GameManager.baseResponse.screen.reels);
	                        }
	                        this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.baseResponse.screen.reels);
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reels in response");
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no base reponse");
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no machine");
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no symbols");
	            }
	        }
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	            this._gambleTransition.goToCase("HIDE_GAMBLE_INIT");
	        }
	        else {
	            if (this._gambleTransition != null) {
	                this._gambleTransition.goToCase("HIDE_GAMBLE_HYPER_INIT");
	            }
	        }
	        if (this._bonusTransition != null) {
	            this._bonusTransition.goToCase("EMPTY");
	        }
	    };
	    BaseView.prototype.initIntro = function () {
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this._winAnimator.showStickySymbols();
	            PlayList_1.PlayList.loop("SND_BaseRespinLoop");
	        }
	        else {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                PlayList_1.PlayList.loop("SND_BaseRecapLoop");
	            }
	            else {
	                PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	                PlayList_1.PlayList.loop("SND_BaseLoop");
	            }
	            this._winAnimator.showStickySymbols();
	            this._winAnimator.showInitWins(GameManager_1.GameManager.baseResponse.wins, GameManager_1.GameManager.baseResponse.currentWin);
	        }
	        if (BaseView.Messages != null) {
	            if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	                PlayList_1.PlayList.play("SND_BaseMessage");
	                BaseView.Messages.goToCase("SHOW");
	            }
	        }
	    };
	    BaseView.prototype.collect = function () {
	        PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	        PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	        PlayList_1.PlayList.loop("SND_BaseLoop");
	        this._respinCounter = 0;
	        this._winAnimator.resetMultiplierContainer();
	        this._winAnimator.reset(true);
	    };
	    BaseView.prototype.spin = function (spinBitmask) {
	        PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	        PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	        PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	        PlayList_1.PlayList.loop("SND_BaseLoop");
	        BaseView.stickySymbolId = -1;
	        this._respinCounter = 0;
	        BaseView.isRespin = false;
	        this._winAnimator.resetMultiplierContainer();
	        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols, spinBitmask);
	    };
	    BaseView.prototype.respin = function (spinBitmask) {
	        this._respinCounter++;
	        BaseView.isRespin = true;
	        PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	        PlayList_1.PlayList.setVolume("SND_BaseLoop", 0);
	        if (this._respinCounter === 1) {
	            if (this._background) {
	                this._background.goToCase("RESPIN");
	            }
	            PlayList_1.PlayList.loop("SND_BaseRespinLoop");
	        }
	        this._winAnimator.resetStickySymbols();
	        this._machine.spinStart(this._winAnimator.reset(true, true), true, this._winAnimator.currentSymbols, spinBitmask);
	    };
	    BaseView.prototype.stop = function () {
	        this._machine.spinStop(null, true);
	    };
	    BaseView.prototype.spinReceived = function () {
	        this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.baseResponse.screen.reels);
	        this._machine.spinStop(null, false, true);
	    };
	    BaseView.prototype.onReelStopped = function (force) {
	        if (force === void 0) { force = false; }
	        this._winAnimator.onReelStopped(GameManager_1.GameManager.baseResponse.screen.reels, this._machine.actualReelStopped, this._gambleTransition, force);
	        if (BaseView.isRespin && this._winAnimator.hasStickySymbol(this._machine.actualReelStopped)) {
	            this._winAnimator.addStickySymbols(this._machine.actualReelStopped);
	        }
	    };
	    BaseView.prototype.machineStopped = function () {
	        if (CustomUtils_1.CustomUtils.isRespin() && this._winAnimator.hasSticky()) {
	            if (!BaseView.isRespin) {
	                for (var i = 0; i < this._winAnimator.getReelCount(); i++) {
	                    this._winAnimator.addStickySymbols(i);
	                }
	            }
	            this._winAnimator.startStickyDelay();
	            this._controller.machineStoppedWithAnimation();
	        }
	        else {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.machineStoppedFinished();
	            }
	            else {
	                this.machineStoppedFinished();
	            }
	        }
	    };
	    BaseView.prototype.machineStoppedFinished = function () {
	        this._wasFinished = false;
	        this._controller.machineStopped(this._winAnimator.showWins(GameManager_1.GameManager.baseResponse.wins, GameManager_1.GameManager.baseResponse.currentWin, this._bonusTransition));
	    };
	    BaseView.prototype.finishQuickWinCalculation = function () {
	        this._controller.quickWinCalculationFinished();
	    };
	    BaseView.prototype.finishWinCalculation = function () {
	        this._wasFinished = true;
	        this._controller.winCalculationFinished();
	    };
	    BaseView.prototype.finishWinAnimator = function () {
	        if (!DataManager_1.DataManager.Autoplay) {
	            PlayList_1.PlayList.setVolume("SND_BaseLoop", 0);
	            PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	            PlayList_1.PlayList.loop("SND_BaseRecapLoop");
	        }
	        else {
	            PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	            PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	            PlayList_1.PlayList.loop("SND_BaseLoop");
	        }
	        if (BaseView.Messages != null) {
	            if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	                PlayList_1.PlayList.play("SND_BaseMessage");
	                BaseView.Messages.goToCase("SHOW");
	            }
	        }
	        this._controller.allWinsFinished();
	    };
	    BaseView.prototype.resetWinAnimator = function () {
	        this._winAnimator.reset(true);
	    };
	    BaseView.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        this.visible = true;
	        if (BaseView.BonusCounters != null && this.childs["TopCounters"] != null) {
	            this.childs["TopCounters"].addChild(BaseView.BonusCounters);
	        }
	        if (long) {
	            if (previousModule === GameModules.Gamble && this._gambleTransition != null) {
	                this._gambleTransition.goToCase("SHOW");
	            }
	            else if (previousModule === GameModules.BonusRespins && this._bonusTransition != null) {
	                this._bonusTransition.goToCase("SHOW");
	            }
	            this._introDelay.start(15);
	        }
	        else {
	            this.introFinished();
	        }
	    };
	    BaseView.prototype.introFinished = function () {
	        if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	            PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	            PlayList_1.PlayList.loop("SND_BaseRecapLoop");
	        }
	        else {
	            PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	            PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	            PlayList_1.PlayList.loop("SND_BaseLoop");
	        }
	        if (BaseView.Messages != null) {
	            if (ModuleManager_1.ModuleManager.bonusActive()) {
	                PlayList_1.PlayList.play("SND_BaseMessage");
	                BaseView.Messages.goToCase("SHOW");
	            }
	        }
	        this._controller.introFinished();
	    };
	    BaseView.prototype.outro = function () {
	        StageController_1.StageController.baseStage = true;
	        PlayList_1.PlayList.stop("SND_BaseLoop", 5);
	        PlayList_1.PlayList.stop("SND_BaseRecapLoop", 5);
	        PlayList_1.PlayList.stop("SND_BaseRespinLoop", 15);
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            this.outroToBonus();
	        }
	        else {
	            this.outroToGamble();
	        }
	    };
	    BaseView.prototype.outroToBonus = function () {
	        PlayList_1.PlayList.stop("SND_BonusWait");
	        if (this._bonusTransition != null) {
	            this._bonusTransition.goToCase("BONUS_INTRO");
	            PlayList_1.PlayList.play("SND_BonusTransition");
	        }
	        this._outroDelay.start(30);
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            if (BaseView.Messages != null) {
	                BaseView.Messages.goToCase("HIDE");
	            }
	        }
	    };
	    BaseView.prototype.outroToGamble = function () {
	        var inHighWins = this._winAnimator.reset(true);
	        if (this._wasFinished) {
	            this.outroStart();
	        }
	        else {
	            if (inHighWins) {
	                this._outroDelay.start(60);
	            }
	            else {
	                this._outroDelay.start(30);
	            }
	        }
	    };
	    BaseView.prototype.outroStart = function () {
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            AmbientBackground_1.AmbientBackground.changeAmbientBackground("bonus", 180, 105);
	            this._outroFinishDelay.start(120);
	        }
	        else {
	            PlayList_1.PlayList.play("SND_GambleTransitionIn");
	            if (this._gambleTransition != null) {
	                this._gambleTransition.goToCase("HIDE_GAMBLE");
	            }
	            this._outroFinishDelay.start(30);
	        }
	    };
	    BaseView.prototype.outroFinished = function () {
	        this._outroFinishDelay.stop();
	        this._winAnimator.reset(true);
	        this._controller.outroFinished();
	    };
	    BaseView.prototype.selectPayline = function () { };
	    BaseView.prototype.disableBase = function () {
	        this._winAnimator.resetTimer();
	    };
	    BaseView.prototype.resetScreen = function () {
	        if (this._winAnimator) {
	            this._winAnimator.showSymbols(GameManager_1.GameManager.baseResponse.screen.reels);
	        }
	        if (this._machine) {
	            this._machine.spinReset();
	            this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.baseResponse.screen.reels);
	        }
	        var node = document.createElement("ResetOverlay");
	        node.setAttribute("width", StageController_1.StageController.Width.toString());
	        node.setAttribute("height", StageController_1.StageController.Height.toString());
	        node.setAttribute("color", "000000");
	        var resetOverlay = new ShapeElement_1.ShapeElement();
	        resetOverlay.create(node);
	        this.addChild(resetOverlay);
	        Tweens_1.Tweens.removeTweens(resetOverlay, "alpha");
	        Tweens_1.Tweens.alphaTween(resetOverlay, {
	            alphas: [1, 0],
	            tweenDuration: 10,
	            callbackFunction: function () {
	                resetOverlay.destroy();
	            },
	        });
	        PIXI.sound.unmuteAll();
	        PlayList_1.PlayList.stopAll();
	        this.initIntro();
	    };
	    BaseView.prototype.toggleSounds = function (enable) {
	        if (enable) {
	            PlayList_1.PlayList.loop("SND_BaseLoop");
	        }
	        else {
	            PlayList_1.PlayList.stop("SND_BaseLoop");
	            PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	        }
	    };
	    BaseView.prototype.changeBet = function () {
	        if (BaseView.BonusCounters != null) {
	            BaseView.BonusCounters.updateCounters();
	        }
	    };
	    BaseView.prototype.setupGambleTransitionSceneElement = function () {
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["Reels"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Reels"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["TopCounters"],
	            parent: this,
	            index: this.getChildIndex(this.childs["TopCounters"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["LineBottom"],
	            parent: this,
	            index: this.getChildIndex(this.childs["LineBottom"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["Machine"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Machine"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["NoWinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["NoWinContainer"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["Paylines"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Paylines"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["WinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["WinContainer"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["StickyContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["StickyContainer"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["PaylinesFields"],
	            parent: this,
	            index: this.getChildIndex(this.childs["PaylinesFields"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["TopMultipliers"],
	            parent: this,
	            index: this.getChildIndex(this.childs["TopMultipliers"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["BigMultiplier"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BigMultiplier"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["Teasing"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Teasing"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["Logo"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Logo"]),
	        });
	        this._gambleTransitionSceneHolder.addElement({
	            element: this.childs["WinAnimator"],
	            parent: this,
	            index: this.getChildIndex(this.childs["WinAnimator"]),
	        });
	    };
	    BaseView.prototype.setupBonusTransitionSceneElement = function () {
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Reels"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Reels"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["TopCounters"],
	            parent: this,
	            index: this.getChildIndex(this.childs["TopCounters"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["LineBottom"],
	            parent: this,
	            index: this.getChildIndex(this.childs["LineBottom"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Machine"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Machine"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["NoWinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["NoWinContainer"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Paylines"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Paylines"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["WinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["WinContainer"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["StickyContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["StickyContainer"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["PaylinesFields"],
	            parent: this,
	            index: this.getChildIndex(this.childs["PaylinesFields"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["TopMultipliers"],
	            parent: this,
	            index: this.getChildIndex(this.childs["TopMultipliers"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Logo"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Logo"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["BigMultiplier"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BigMultiplier"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Teasing"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Teasing"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["WinAnimator"],
	            parent: this,
	            index: this.getChildIndex(this.childs["WinAnimator"]),
	        });
	        this._bonusTransitionSceneHolder.addElement({
	            element: this.childs["Messages"],
	            parent: this,
	            index: this.getChildIndex(this.childs["Messages"]),
	        });
	    };
	    BaseView.GambleInTransitionDuration = 30;
	    BaseView = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], BaseView);
	    return BaseView;
	}(LayoutContainerElement_1.LayoutContainerElement));
	exports.BaseView = BaseView;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var FrameTimer_1 = __webpack_require__(9);
	var Configuration_1 = __webpack_require__(57);
	var ComponentTypes_1 = __webpack_require__(14);
	var PlayList_1 = __webpack_require__(33);
	var AppContext_1 = __webpack_require__(5);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var Reel_1 = __webpack_require__(88);
	var ReelExtended_1 = __webpack_require__(100);
	var CustomUtils_1 = __webpack_require__(22);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Machine = (function (_super) {
	    __extends(Machine, _super);
	    function Machine() {
	        _super.call(this);
	        this._reels = [];
	        this._stoppedSymbolsArray = [];
	        this._stoppedFromServer = false;
	        this._stoppedFromMachine = false;
	        this._stoppedFromLegal = false;
	        this._stoppedReelIndexes = 0;
	        this._stopTimer = FrameTimer_1.CreateFrameTimer("Machine");
	        this._stopTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.spinStop.bind(this));
	        this.actualReelStopped = -1;
	        this._symbolTopCount = 1;
	        this._symbolBottomCount = 1;
	        this._reelsContainer = new PIXI.Container();
	        this.addChild(this._reelsContainer);
	    }
	    Machine.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (this.maskSprite != null && this._reelsContainer != null) {
	            this._reelsContainer.addChild(this.maskSprite);
	            this._reelsContainer.mask = this.maskSprite;
	        }
	        if (node.hasAttribute(exports.MachineAttributes.CONFIGS)) {
	            var configs = node.getAttribute(exports.MachineAttributes.CONFIGS).split(";");
	            for (var i = 0; i < configs.length; i++) {
	                var config = Configuration_1.Configuration.Configurations[configs[i]];
	                if (config != null) {
	                    this.configurate(config);
	                }
	            }
	        }
	    };
	    Machine.prototype.configurate = function (node) {
	        if (node.hasAttribute("ReelCount")) {
	            this._reelCount = parseInt(node.getAttribute("ReelCount"));
	        }
	        if (node.hasAttribute("ReelX")) {
	            this._reelX = neo_common_1.ArrayUtils.numberArray(node.getAttribute("ReelX"));
	        }
	        if (node.hasAttribute("ReelY")) {
	            this._reelY = neo_common_1.ArrayUtils.numberArray(node.getAttribute("ReelY"));
	        }
	        if (node.hasAttribute("SymbolWidth")) {
	            this._symbolWidth = parseInt(node.getAttribute("SymbolWidth"));
	        }
	        if (node.hasAttribute("SymbolHeight")) {
	            this._symbolHeight = parseInt(node.getAttribute("SymbolHeight"));
	        }
	        if (node.hasAttribute("VisibleSymbolCount")) {
	            this._visibleSymbolCount = parseInt(node.getAttribute("VisibleSymbolCount"));
	        }
	        if (node.hasAttribute("SymbolTopCount")) {
	            this._symbolTopCount = parseInt(node.getAttribute("SymbolTopCount"));
	        }
	        if (node.hasAttribute("SymbolBottomCount")) {
	            this._symbolBottomCount = parseInt(node.getAttribute("SymbolBottomCount"));
	        }
	        if (node.hasAttribute("MinSpinRotation")) {
	            this._minSpinRotation = parseInt(node.getAttribute("MinSpinRotation"));
	        }
	        else {
	            this._minSpinRotation = 40;
	        }
	        if (node.hasAttribute("MinSpinRotationLong")) {
	            this._minSpinRotationLong = parseInt(node.getAttribute("MinSpinRotationLong"));
	        }
	        else {
	            this._minSpinRotationLong = 100;
	        }
	        if (node.hasAttribute("StartDelay")) {
	            this._startDelay = parseInt(node.getAttribute("StartDelay"));
	        }
	        else {
	            this._startDelay = 3;
	        }
	        if (node.hasAttribute("StopDelay")) {
	            this._stopDelay = parseInt(node.getAttribute("StopDelay"));
	        }
	        else {
	            this._stopDelay = 10;
	        }
	        if (node.hasAttribute("ReelConfiguration")) {
	            this._reelConfiguration = node.getAttribute("ReelConfiguration");
	        }
	    };
	    Machine.prototype.createReels = function (reels) {
	        for (var i = 0; i < this._reelCount; i++) {
	            this._reels.push(new ReelExtended_1.ReelExtended());
	        }
	        for (var i = 0; i < this._reelCount; i++) {
	            var reel = this._reels[i];
	            if (this._reelConfiguration != null) {
	                var configs = this._reelConfiguration.split(";");
	                for (var j = 0; j < configs.length; j++) {
	                    reel.configure(Configuration_1.Configuration.Configurations[configs[j]]);
	                }
	            }
	            reel.visible = false;
	            reel.initialize(i > 0 ? this._reels[i - 1] : null, i < this._reelCount - 1 ? this._reels[i + 1] : null, i, this._symbols, reels[i], this._reelX[i], this._reelY[i], this._visibleSymbolCount, this._symbolTopCount, this._symbolBottomCount, this._symbolWidth, this._symbolHeight, this._startDelay * i, this._stopDelay * i);
	            reel.on(Reel_1.Reel.ReelStopped, this.onReelStopped.bind(this));
	            this._reelsContainer.addChild(reel);
	        }
	        this._reelsContainer.visible = false;
	    };
	    Machine.prototype.initialize = function (symbols, reels) {
	        this._symbols = symbols;
	        this.createReels(reels);
	    };
	    Machine.prototype.setStoppedSymbolsArray = function (value) {
	        this._stoppedSymbolsArray = value;
	    };
	    Machine.prototype.showSymbols = function (reelsData) {
	        if (false) {
	            this.log("showSymbols");
	        }
	        this.actualReelStopped = -1;
	        if (this._reels != null) {
	            for (var i = 0; i < this._reelCount; i++) {
	                if (reelsData[i] != null) {
	                    if (this._reels[i] != null) {
	                        this._reels[i].visible = true;
	                        this._reels[i].setData(reelsData[i]);
	                        this._reels[i].showSymbols();
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reel with index: " + i);
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no reelsData with index: " + i);
	                    }
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no reels");
	            }
	        }
	    };
	    Machine.prototype.spinStart = function (longRotation) {
	        if (false) {
	            this.log("spinStart");
	        }
	        Machine.Respin = false;
	        this._stoppedFromServer = false;
	        this._stoppedFromMachine = false;
	        this._stoppedFromLegal = false;
	        this._startSpinTime = Date.now();
	        this.visible = true;
	        this._reelsContainer.visible = true;
	        this.actualReelStopped = -1;
	        this._stoppedReelIndexes = 0;
	        if (this._reels != null) {
	            for (var i = 0; i < this._reelCount; i++) {
	                if (this._reels[i] != null) {
	                    if (this._stoppedSymbolsArray.length > 0) {
	                        this._reels[i].visible = true;
	                        this._reels[i].setData(this._stoppedSymbolsArray[i]);
	                        this._reels[i].showSymbols();
	                        this._reels[i].spinStart();
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no stopped symbols");
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no reel with index: " + i);
	                    }
	                }
	            }
	            if (longRotation != null && longRotation) {
	                this._stopTimer.start(this._minSpinRotationLong);
	            }
	            else {
	                this._stopTimer.start(this._minSpinRotation);
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no reels");
	            }
	        }
	        PlayList_1.PlayList.play("SND_BaseRotationStart");
	        PlayList_1.PlayList.loop("SND_BaseRotation", 0, true);
	    };
	    Machine.prototype.verifyMinGameRoundDurationConditions = function () {
	        return ((AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration > 0 ||
	            AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan > 0 ||
	            (FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0)) &&
	            !CustomUtils_1.CustomUtils.isRespinActive() &&
	            !CustomUtils_1.CustomUtils.isRespinLast());
	    };
	    Machine.prototype.spinStop = function (event, force, fromServer, legal) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        if (fromServer === void 0) { fromServer = false; }
	        if (legal === void 0) { legal = false; }
	        if (fromServer) {
	            this._stoppedFromServer = true;
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            if (this.verifyMinGameRoundDurationConditions()) {
	                this._legalStopTimer = setTimeout(function () { return _this.spinStop(null, false, false, true); }, this.getLegalRemainingSpinDuration());
	            }
	            else {
	                this._stoppedFromLegal = true;
	            }
	        }
	        else if (legal) {
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stoppedFromLegal = true;
	        }
	        else {
	            this._stopTimer.stop();
	            this._stoppedFromMachine = true;
	        }
	        if (force) {
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stoppedFromLegal = true;
	            this._stopTimer.stop();
	            this._stoppedFromMachine = true;
	        }
	        if (false) {
	            this.log("spinStop: " + force);
	        }
	        if (this._stoppedFromServer && this._stoppedFromMachine && this._stoppedFromLegal) {
	            if (!Machine.Respin && !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWinDenom, "0");
	            }
	            if (this._reels != null) {
	                for (var i = 0; i < this._reelCount; i++) {
	                    if (this._reels[i] != null) {
	                        if (this._stoppedSymbolsArray.length !== 0) {
	                            this._reels[i].setData(this._stoppedSymbolsArray[i]);
	                            this._reels[i].spinStop(force);
	                        }
	                        else {
	                            if (false) {
	                                this.log("ERROR no stopped symbols");
	                            }
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reel with index: " + i);
	                        }
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no reels");
	                }
	            }
	        }
	    };
	    Machine.prototype.spinReset = function () {
	        if (this._reels != null) {
	            for (var i = 0; i < this._reelCount; i++) {
	                if (this._reels[i] != null) {
	                    this._reels[i].spinReset();
	                }
	            }
	        }
	        this._reelsContainer.visible = false;
	    };
	    Machine.prototype.getLegalRemainingSpinDuration = function () {
	        var duration = 0;
	        if (AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan > 0) {
	            duration = this.calculateRemainingSpinDuration(AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan);
	        }
	        if (AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration > 0) {
	            duration = AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration;
	        }
	        if (AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0 && FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            duration = this.calculateRemainingSpinDuration(Math.max(AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan, AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan));
	        }
	        return duration;
	    };
	    Machine.prototype.calculateRemainingSpinDuration = function (minTime) {
	        var now = Date.now();
	        var diff = now - this._startSpinTime;
	        var reelStopDuration = this.getReelStopDuration();
	        return Math.max(minTime - diff - reelStopDuration, 0);
	    };
	    Machine.prototype.getReelStopDuration = function () {
	        return (this._reels[this._reelCount - 1].getStopDuration() / 60) * 1000;
	    };
	    Machine.prototype.onReelStopped = function (reelIndex) {
	        if (false) {
	            this.log("reel stopped: " + reelIndex);
	        }
	        PlayList_1.PlayList.play("SND_BaseRotationEnd" + reelIndex);
	        this._stoppedReelIndexes++;
	        this.actualReelStopped = reelIndex;
	        this._reels[reelIndex].visible = false;
	        this.emit(Machine.ReelStopped);
	        if (this._stoppedReelIndexes === this._reelCount) {
	            PlayList_1.PlayList.stop("SND_BaseRotation", 10);
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stopTimer.stop();
	            if (false) {
	                var old = AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration;
	                var current = AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan;
	                var minDuration = current > 0 ? current : old > 0 ? old : 0;
	                var spinDuration = Date.now() - this._startSpinTime;
	                if (spinDuration > minDuration || !this.verifyMinGameRoundDurationConditions()) {
	                    this.log("Spin time duration: " + spinDuration + " ms");
	                }
	                else {
	                    console.log("%cError spin time duration:" + spinDuration + " ms", "color: #ff9900");
	                }
	            }
	            this.emit(Machine.MachineStopped);
	            this._reelsContainer.visible = false;
	        }
	    };
	    Machine.MachineStopped = "machineStopped";
	    Machine.ReelStopped = "onReelStopped";
	    Machine.Respin = false;
	    Machine = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Machine);
	    return Machine;
	}(BaseElement_1.BaseElement));
	exports.Machine = Machine;
	exports.MachineAttributes = {
	    CONFIGS: "Configs",
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Symbol_1 = __webpack_require__(89);
	var ComponentTypes_1 = __webpack_require__(14);
	var Tweens_1 = __webpack_require__(15);
	var BaseElement_1 = __webpack_require__(12);
	var FrameTimer_1 = __webpack_require__(9);
	var Configuration_1 = __webpack_require__(57);
	var Reel = (function (_super) {
	    __extends(Reel, _super);
	    function Reel() {
	        _super.apply(this, arguments);
	    }
	    Reel.prototype.configure = function (node) {
	        this.preRoll = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.PRE_ROLL)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.PRE_ROLL))
	            : 180;
	        this.preRollSpeed = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.PRE_ROLL_SPEED)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.PRE_ROLL_SPEED))
	            : 10;
	        this.postRoll = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.POST_ROLL)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.POST_ROLL))
	            : 180;
	        this.postRollSpeed = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.POST_ROLL_SPEED)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.POST_ROLL_SPEED))
	            : 5;
	        this.speed = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.SPEED)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.SPEED))
	            : 3;
	        this.forceSpeed = node.hasAttribute(Configuration_1.ReelConfigurationAttributes.FORCE_SPEED)
	            ? parseInt(node.getAttribute(Configuration_1.ReelConfigurationAttributes.FORCE_SPEED))
	            : 2;
	    };
	    Reel.prototype.initialize = function (previousReel, nextReel, index, symbols, strip, positionX, positionY, symbolCount, symbolTopCount, symbolBottomCount, symbolWidth, symbolHeight, startDelay, stopDelay) {
	        this.previousReel = previousReel;
	        this.nextReel = nextReel;
	        this.index = index;
	        this.symbols = symbols;
	        this.strip = strip;
	        this.originalStrip = this.strip;
	        this.positionX = positionX;
	        this.positionY = positionY;
	        this.symbolCount = symbolCount;
	        this.symbolTopCount = symbolTopCount;
	        this.symbolBottomCount = symbolBottomCount;
	        this.symbolWidth = symbolWidth;
	        this.symbolHeight = symbolHeight;
	        this.startDelay = startDelay;
	        this.stopDelay = stopDelay;
	        this.stopTimer = FrameTimer_1.CreateFrameTimer("reel");
	        this.stopTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.onStopTimerComplete.bind(this));
	        this.currentSymbols = [];
	    };
	    Reel.prototype.setData = function (data) {
	        this.data = data;
	    };
	    Reel.prototype.showSymbols = function () {
	        this.shouldBeStopping = false;
	        this.isStopping = false;
	        this.stoppingCounter = 0;
	        this.isTeasing = false;
	        this.teasingSymbols = [];
	        this.x = this.positionX;
	        this.y = this.positionY;
	        while (this.currentSymbols.length > 0) {
	            this.returnSymbol(this.currentSymbols.pop());
	        }
	        for (var i = 0; i < this.symbolBottomCount + this.symbolCount + this.symbolTopCount; i++) {
	            var symbolId = void 0;
	            var symbolCase = void 0;
	            if (i < this.symbolBottomCount) {
	                symbolId =
	                    this.strip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolCase = i === this.symbolBottomCount - 1 ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            else if (i < this.symbolBottomCount + this.symbolCount) {
	                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - i - 1];
	                symbolCase = Symbol_1.Symbol.CaseRotation;
	            }
	            else {
	                symbolId =
	                    this.strip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolCase = i === this.symbolBottomCount + this.symbolCount ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
	            this.addChild(this.currentSymbols[0]);
	        }
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            var symbol = this.currentSymbols[i];
	            symbol.x = -symbol.offsetX;
	            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
	        }
	    };
	    Reel.prototype.spinStart = function () {
	        this.shouldBeStopping = false;
	        this.isStopping = false;
	        this.stoppingCounter = 0;
	        this.isTeasing = false;
	        this.teasingSymbols = [];
	        this.rollSpeed = this.speed;
	        this.stripIndex = (this.data.index - this.symbolTopCount + this.strip.length) % this.strip.length;
	        this.inReset = false;
	        this.spinPreRoll();
	    };
	    Reel.prototype.spinStop = function (force, customDelay) {
	        if (force === void 0) { force = false; }
	        if (customDelay === void 0) { customDelay = 0; }
	        this.stopTimer.stop();
	        if (force) {
	            this.shouldBeStopping = true;
	            this.rollSpeed = this.forceSpeed;
	        }
	        else {
	            this.stopTimer.start(customDelay !== 0 ? customDelay : this.stopDelay);
	        }
	    };
	    Reel.prototype.onStopTimerComplete = function () {
	        this.shouldBeStopping = true;
	        this.isStopping = true;
	    };
	    Reel.prototype.getStopDuration = function () {
	        var stoppingSymbols = this.symbolTopCount + this.symbolCount + this.symbolBottomCount - 1;
	        return this.stopDelay + stoppingSymbols * this.speed + this.postRollSpeed * 2;
	    };
	    Reel.prototype.spinTease = function (symbols, customDelay) {
	        if (customDelay === void 0) { customDelay = 0; }
	        this.shouldBeStopping = false;
	        this.isStopping = false;
	        this.stoppingCounter = 0;
	        this.isTeasing = true;
	        this.teasingSymbols = symbols;
	        this.stopTimer.stop();
	        this.stopTimer.start(customDelay !== 0 ? customDelay : this.stopDelay);
	    };
	    Reel.prototype.spinPreRoll = function () {
	        Tweens_1.Tweens.removeTweens(this, "position");
	        Tweens_1.Tweens.positionTween(this, {
	            tweenX: [this.positionX, this.positionX, this.positionX],
	            tweenY: [this.positionY, this.positionY - this.preRoll, this.positionY],
	            tweenDuration: this.preRollSpeed * 2,
	            tweenDelay: this.startDelay,
	            callbackFunction: this.spinRoll,
	            callbackScope: this,
	        });
	    };
	    Reel.prototype.spinRoll = function () {
	        if (this.inReset) {
	            return;
	        }
	        Tweens_1.Tweens.removeTweens(this, "position");
	        Tweens_1.Tweens.positionTween(this, {
	            tweenX: [this.positionX, this.positionX],
	            tweenY: [this.positionY, this.positionY + this.symbolHeight],
	            tweenDuration: this.rollSpeed,
	            callbackFunction: this.updateReel,
	            callbackScope: this,
	        });
	    };
	    Reel.prototype.updateReel = function () {
	        this.returnSymbol(this.currentSymbols.pop());
	        if (this.shouldBeStopping && !this.isStopping) {
	            if (this.previousReel === null) {
	                this.isStopping = true;
	            }
	            else if (this.previousReel.isStopping) {
	                this.isStopping = true;
	            }
	        }
	        this.stripIndex = (this.stripIndex - 1 + this.strip.length) % this.strip.length;
	        var symbolId = this.strip[this.stripIndex];
	        var symbolCase = Symbol_1.Symbol.CaseBlur;
	        if (this.isStopping) {
	            if (this.stoppingCounter < this.symbolBottomCount) {
	                symbolId =
	                    this.strip[(this.data.index +
	                        this.symbolBottomCount +
	                        this.symbolCount -
	                        this.stoppingCounter -
	                        1 +
	                        this.strip.length) %
	                        this.strip.length];
	                symbolCase =
	                    this.stoppingCounter === this.symbolBottomCount - 1 ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            else if (this.stoppingCounter < this.symbolBottomCount + this.symbolCount) {
	                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
	                symbolCase = Symbol_1.Symbol.CaseRotation;
	            }
	            else {
	                symbolId =
	                    this.strip[(this.data.index +
	                        this.symbolBottomCount +
	                        this.symbolCount -
	                        this.stoppingCounter -
	                        1 +
	                        this.strip.length) %
	                        this.strip.length];
	                symbolCase =
	                    this.stoppingCounter === this.symbolBottomCount + this.symbolCount
	                        ? Symbol_1.Symbol.CaseRotation
	                        : Symbol_1.Symbol.CaseBlur;
	            }
	            this.stoppingCounter++;
	        }
	        this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase));
	        this.addChild(this.currentSymbols[0]);
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            var symbol = this.currentSymbols[i];
	            symbol.x = -symbol.offsetX;
	            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
	        }
	        if (this.isStopping &&
	            this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount) {
	            this.spinPostRoll();
	        }
	        else {
	            this.spinRoll();
	        }
	    };
	    Reel.prototype.spinPostRoll = function () {
	        Tweens_1.Tweens.removeTweens(this, "position");
	        Tweens_1.Tweens.positionTween(this, {
	            tweenX: [this.positionX, this.positionX, this.positionX],
	            tweenY: [this.positionY, this.positionY + this.postRoll, this.positionY],
	            tweenDuration: this.postRollSpeed * 2,
	            callbackFunction: this.spinComplete,
	            callbackScope: this,
	        });
	    };
	    Reel.prototype.spinComplete = function () {
	        Tweens_1.Tweens.removeTweens(this, "position");
	        while (this.currentSymbols.length > 0) {
	            this.returnSymbol(this.currentSymbols.pop());
	        }
	        this.emit(Reel.ReelStopped, this.index);
	    };
	    Reel.prototype.spinReset = function () {
	        this.inReset = true;
	        Tweens_1.Tweens.removeTweens(this, "position");
	        while (this.currentSymbols.length > 0) {
	            this.returnSymbol(this.currentSymbols.pop());
	        }
	    };
	    Reel.prototype.getSymbol = function (symbolId, symbolCase) {
	        return this.symbols.getSymbol(symbolId, symbolCase);
	    };
	    Reel.prototype.returnSymbol = function (symbol) {
	        this.symbols.returnSymbol(symbol);
	    };
	    Reel.ReelStopped = "reelStopped";
	    Reel = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Reel);
	    return Reel;
	}(BaseElement_1.BaseElement));
	exports.Reel = Reel;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var SwitchElement_1 = __webpack_require__(90);
	var ComponentTypes_1 = __webpack_require__(14);
	var Attributes_1 = __webpack_require__(21);
	var Configuration_1 = __webpack_require__(57);
	var Languages_1 = __webpack_require__(28);
	var ImageTextElement_1 = __webpack_require__(99);
	var Symbol = (function (_super) {
	    __extends(Symbol, _super);
	    function Symbol() {
	        _super.call(this);
	        this.zIndex = 0;
	        this.offsetX = 0;
	        this.offsetY = 0;
	        this.center = true;
	        this.usedInPool = false;
	        this.id = -1;
	        this.hasWinFrame = true;
	    }
	    Symbol.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        this.offsetX = Attributes_1.Attributes.assignFloatAttribute(node, exports.SymbolAttributes.OFFSET_X, this.offsetX);
	        this.offsetY = Attributes_1.Attributes.assignFloatAttribute(node, exports.SymbolAttributes.OFFSET_Y, this.offsetY);
	        if (node.hasAttribute(exports.SymbolAttributes.OFFSET)) {
	            this.offsetX = parseFloat(node.getAttribute(exports.SymbolAttributes.OFFSET));
	            this.offsetY = parseFloat(node.getAttribute(exports.SymbolAttributes.OFFSET));
	        }
	        this.zIndex = Attributes_1.Attributes.assignFloatAttribute(node, exports.SymbolAttributes.Z_INDEX, this.zIndex);
	        this.type = Attributes_1.Attributes.assignStringAttribute(node, exports.SymbolAttributes.TYPE, this.type);
	        this.hasWinFrame = Attributes_1.Attributes.assignBooleanAttribute(node, "HasWinFrame", this.hasWinFrame);
	        if (node.hasAttribute(exports.SymbolAttributes.ID)) {
	            this.id = parseInt(node.getAttribute(exports.SymbolAttributes.ID));
	        }
	    };
	    Symbol.prototype.configurate = function (node) {
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_WIDTH)) {
	            this.symbolWidth = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_WIDTH));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_HEIGHT)) {
	            this.symbolHeight = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_HEIGHT));
	        }
	    };
	    Symbol.prototype.clone = function () {
	        var element = new Symbol();
	        element.elements = this.elements.clone();
	        element.addChild(element.elements);
	        element.name = this.name;
	        element.id = this.id;
	        element.style = this.style;
	        element.offsetX = this.offsetX;
	        element.offsetY = this.offsetY;
	        element.symbolWidth = this.symbolWidth;
	        element.symbolHeight = this.symbolHeight;
	        element.visible = this.visible;
	        element.case = this.case;
	        element.style = this.style;
	        element.zIndex = this.zIndex;
	        element.type = this.type;
	        element.hasWinFrame = this.hasWinFrame;
	        element.markAsCloned();
	        return element;
	    };
	    Symbol.prototype.setAmount = function (value, prefixName) {
	        var amountElements = this.getAmountElements(prefixName);
	        for (var i = 0; i < amountElements.length; i++) {
	            amountElements[i].bitmapText.text = Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, value.toString());
	            amountElements[i].realign();
	        }
	    };
	    Symbol.prototype.resetAmount = function (prefixName) {
	        var amountElements = this.getAmountElements(prefixName);
	        for (var i = 0; i < amountElements.length; i++) {
	            amountElements[i].bitmapText.text = "";
	        }
	    };
	    Symbol.prototype.getAmountElements = function (prefixName) {
	        if (prefixName === void 0) { prefixName = "Amount"; }
	        var result = [];
	        if (this.elements != null && this.elements.childs != null) {
	            for (var key in this.elements.childs) {
	                if (key.indexOf(prefixName) > -1 && this.elements.childs[key] instanceof ImageTextElement_1.ImageTextElement) {
	                    result.push(this.elements.childs[key]);
	                }
	            }
	        }
	        return result;
	    };
	    Symbol.prototype.addChildElement = function (element) {
	        this.elements.addChild(element);
	    };
	    Symbol.CaseRotation = "ROTATION";
	    Symbol.CaseBlur = "BLUR";
	    Symbol.CaseEmpty = "EMPTY";
	    Symbol.CaseNormal = "NORMAL";
	    Symbol.CaseIdle = "IDLE";
	    Symbol.CaseIdle0 = "IDLE_0";
	    Symbol.CaseIdle1 = "IDLE_1";
	    Symbol.CaseIdle2 = "IDLE_2";
	    Symbol.CaseIdle3 = "IDLE_3";
	    Symbol.CaseBonus = "BONUS";
	    Symbol.CaseNowin = "NOWIN";
	    Symbol.CaseWin = "WIN";
	    Symbol.CaseCycle = "CYCLE";
	    Symbol = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Symbol);
	    return Symbol;
	}(SwitchElement_1.SwitchElement));
	exports.Symbol = Symbol;
	exports.SymbolAttributes = {
	    DEBUG: "Debug",
	    ID: "Id",
	    OFFSET_X: "OffsetX",
	    OFFSET_Y: "OffsetY",
	    OFFSET: "Offset",
	    Z_INDEX: "Zindex",
	    TYPE: "Type",
	};


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var SwitchStyle_1 = __webpack_require__(91);
	var StyleManager_1 = __webpack_require__(20);
	var AnimationElement_1 = __webpack_require__(93);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var ParticleElement_1 = __webpack_require__(95);
	var ProtonElement_1 = __webpack_require__(98);
	var Tweens_1 = __webpack_require__(15);
	var SwitchElement = (function (_super) {
	    __extends(SwitchElement, _super);
	    function SwitchElement() {
	        _super.call(this);
	        this.dynamicTime = 0;
	        this.case = "NONE";
	        this.center = false;
	        this.timer = FrameTimer_1.CreateFrameTimer("timer");
	    }
	    Object.defineProperty(SwitchElement.prototype, "symbolWidth", {
	        get: function () {
	            return this._symbolWidth;
	        },
	        set: function (value) {
	            this._symbolWidth = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SwitchElement.prototype, "symbolHeight", {
	        get: function () {
	            return this._symbolHeight;
	        },
	        set: function (value) {
	            this._symbolHeight = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SwitchElement.prototype, "hasElements", {
	        get: function () {
	            return this.elements != null && this.elements.childs != null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SwitchElement.prototype.getAllChildElements = function () {
	        if (this.hasElements) {
	            return this.elements.childs;
	        }
	        return null;
	    };
	    SwitchElement.prototype.getChildElementByName = function (name) {
	        if (this.hasElements) {
	            return this.elements.childs[name];
	        }
	        return null;
	    };
	    SwitchElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(exports.SwitchElementAttributes.STYLE)) {
	            this.style = StyleManager_1.StyleManager.Styles[node.getAttribute(exports.SwitchElementAttributes.STYLE)];
	            if (this.style != null) {
	                if (this.style.container != null) {
	                    if (node.hasAttribute(exports.SwitchElementAttributes.CLONE) &&
	                        neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.SwitchElementAttributes.CLONE))) {
	                        this.elements = this.style.container.clone();
	                    }
	                    else {
	                        this.elements = this.style.container;
	                    }
	                    this.addChild(this.elements);
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name: " + node.getAttribute(exports.SwitchElementAttributes.STYLE));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.SwitchElementAttributes.CASE)) {
	            this.goToCase(node.getAttribute(exports.SwitchElementAttributes.CASE));
	        }
	    };
	    SwitchElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        this.dynamicTime = 0;
	        if (node.hasAttribute(exports.SwitchElementAttributes.DYNAMIC_TIME)) {
	            this.setDynamicTime(parseInt(node.getAttribute(exports.SwitchElementAttributes.DYNAMIC_TIME)));
	        }
	        if (node.hasAttribute(exports.SwitchElementAttributes.CASE)) {
	            this.goToCase(node.getAttribute(exports.SwitchElementAttributes.CASE));
	        }
	        else if (node.hasAttribute(exports.SwitchElementAttributes.RANDOM_CASE)) {
	            this.goToCase(this.getRandomCase(node.getAttribute(exports.SwitchElementAttributes.RANDOM_CASE)));
	        }
	    };
	    SwitchElement.prototype.hasCase = function (s) {
	        return this.style != null && this.style.cases != null && this.style.cases[s];
	    };
	    SwitchElement.prototype.getCase = function (s) {
	        if (this.style != null && this.style.cases != null && this.style.cases[s]) {
	            return this.style.cases[s];
	        }
	        return null;
	    };
	    SwitchElement.prototype.getCurrentCase = function () {
	        return this.case;
	    };
	    SwitchElement.prototype.goToCase = function (s, emitEvent) {
	        if (emitEvent === void 0) { emitEvent = false; }
	        if (emitEvent) {
	            this.animationComplete();
	        }
	        if (this.style != null && this.style.cases != null && this.case !== s) {
	            if (this.timer != null) {
	                this.timer.removeAllListeners(FrameTimer_1.FrameTimerEvents.Complete);
	                this.timer.stop();
	            }
	            if (this.hasCase(s)) {
	                var node = this.style.cases[s];
	                if (node != null) {
	                    if (false) {
	                        if (node.hasAttribute("Debug") && node.getAttribute("Debug") === "true") {
	                            debugger;
	                        }
	                    }
	                    if (node.hasAttribute("FinishHandler")) {
	                        this.emit(SwitchElement.FinishAnimation);
	                    }
	                    var element = void 0;
	                    this.case = s;
	                    var next = node.firstElementChild;
	                    var arr = [];
	                    while (next != null) {
	                        arr.push(next.nodeName);
	                        element = this.elements.childs[next.nodeName];
	                        if (element != null) {
	                            element.visible = true;
	                            element.updateByNode(next);
	                        }
	                        else {
	                            if (false) {
	                                this.log("WARNING no element child with name: " +
	                                    next.nodeName +
	                                    " in case: " +
	                                    s +
	                                    " in style: " +
	                                    this.style.name);
	                            }
	                        }
	                        next = next.nextElementSibling;
	                    }
	                    for (var key in this.elements.childs) {
	                        var child = this.elements.childs[key];
	                        child.removeAllListeners();
	                        var found = false;
	                        for (var i = 0; i < arr.length; i++) {
	                            if (key === arr[i]) {
	                                found = true;
	                            }
	                        }
	                        if (!found) {
	                            if (child instanceof ParticleElement_1.ParticleElement) {
	                                child.stop();
	                            }
	                            else if (child instanceof SwitchElement) {
	                                child.visible = false;
	                                child.goToCase("EMPTY");
	                            }
	                            else if (child instanceof PIXI.DisplayObject) {
	                                child.visible = false;
	                            }
	                            if (child instanceof ProtonElement_1.ProtonElement) {
	                                child.stop();
	                            }
	                            Tweens_1.Tweens.removeTweens(child);
	                        }
	                    }
	                    var nextCase = null;
	                    if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.NEXT_CASE)) {
	                        nextCase = node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.NEXT_CASE);
	                    }
	                    else if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.NEXT_RANDOM_CASE)) {
	                        nextCase = this.getRandomCase(node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.NEXT_RANDOM_CASE));
	                    }
	                    if (nextCase != null && this.hasCase(nextCase)) {
	                        if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER)) {
	                            var multiplier = 1;
	                            if (node.hasAttribute(exports.SwitchElementAttributes.RANDOM)) {
	                                multiplier = this.getRandomDurationMultiplier(node);
	                            }
	                            this.timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.goToCase.bind(this, nextCase));
	                            if (node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER) === "dynamic") {
	                                this.timer.start(this.dynamicTime * multiplier);
	                            }
	                            else {
	                                this.timer.start(parseInt(node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER)) * multiplier);
	                            }
	                        }
	                        else if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.HANDLER)) {
	                            element = this.elements.childs[node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.HANDLER)];
	                            if (element) {
	                                element.on(AnimationElement_1.AnimationElement.AnimationComplete, this.goToCase.bind(this, nextCase, true));
	                            }
	                        }
	                        else {
	                            this.goToCase(nextCase);
	                        }
	                    }
	                    else {
	                        if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER)) {
	                            var multiplier = 1;
	                            if (node.hasAttribute(exports.SwitchElementAttributes.RANDOM)) {
	                                multiplier = this.getRandomDurationMultiplier(node);
	                            }
	                            this.timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.animationComplete.bind(this));
	                            if (node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER) === "dynamic") {
	                                this.timer.start(this.dynamicTime * multiplier);
	                            }
	                            else {
	                                this.timer.start(parseInt(node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.TIMER)) * multiplier);
	                            }
	                        }
	                        else if (node.hasAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.HANDLER)) {
	                            element = this.elements.childs[node.getAttribute(SwitchStyle_1.SwitchStyleCaseAttributes.HANDLER)];
	                            if (element) {
	                                element.on(AnimationElement_1.AnimationElement.AnimationComplete, this.animationComplete.bind(this));
	                            }
	                        }
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no case: " + s + " for " + this.name);
	                }
	            }
	        }
	        if (emitEvent) {
	            this.animationComplete();
	        }
	    };
	    SwitchElement.prototype.getRandomDurationMultiplier = function (node) {
	        var result = 1;
	        var dataArray = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.SwitchElementAttributes.RANDOM));
	        if (dataArray.length > 0) {
	            var max = dataArray[0];
	            var min = 1;
	            if (dataArray.length === 2) {
	                min = dataArray[0];
	                max = min > dataArray[1] ? min : dataArray[1];
	            }
	            result = Math.round(SwitchElement.getRandom(min, max));
	        }
	        return result;
	    };
	    SwitchElement.prototype.getRandomCase = function (s) {
	        var result = 0;
	        var dataArray = neo_common_1.ArrayUtils.stringArray(s);
	        if (dataArray.length > 0) {
	            var max = dataArray.length - 1;
	            var min = 0;
	            result = Math.round(SwitchElement.getRandom(min, max));
	        }
	        else {
	            return null;
	        }
	        return dataArray[result];
	    };
	    SwitchElement.prototype.setDynamicTime = function (time) {
	        this.dynamicTime = time;
	    };
	    SwitchElement.getRandom = function (min, max) {
	        return Math.random() * (max - min) + min;
	    };
	    SwitchElement.prototype.animationComplete = function () {
	        this.emit(SwitchElement.AnimationComplete);
	    };
	    SwitchElement.prototype.clone = function () {
	        var element = new SwitchElement();
	        element.name = this.name;
	        element.style = this.style;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        element.elements = this.elements.clone();
	        element.addChild(element.elements);
	        element.case = this.case;
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        else if (this.maskGraphics != null) {
	            var elementMask = this.maskGraphics.clone();
	            elementMask.position.x = this.maskGraphics.position.x;
	            elementMask.position.y = this.maskGraphics.position.y;
	            element.maskGraphics = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    SwitchElement.AnimationComplete = "animationComplete";
	    SwitchElement.FinishAnimation = "finishAnimation";
	    SwitchElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], SwitchElement);
	    return SwitchElement;
	}(BaseElement_1.BaseElement));
	exports.SwitchElement = SwitchElement;
	exports.SwitchElementAttributes = {
	    CASE: "Case",
	    CLONE: "Clone",
	    DEBUG_INFO: "DebugInfo",
	    DEBUG: "Debug",
	    STYLE: "Style",
	    RANDOM: "Random",
	    RANDOM_CASE: "RandomCase",
	    DYNAMIC_TIME: "DynamicTime",
	};


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ContainerElement_1 = __webpack_require__(82);
	var ComponentTypes_1 = __webpack_require__(14);
	var SwitchStyle = (function (_super) {
	    __extends(SwitchStyle, _super);
	    function SwitchStyle() {
	        _super.call(this);
	        this.cases = {};
	    }
	    SwitchStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        var next = node.firstElementChild;
	        while (next != null) {
	            switch (next.nodeName) {
	                case "Elements":
	                    this.container = new ContainerElement_1.ContainerElement();
	                    this.container.create(next);
	                    break;
	                case "Cases":
	                    var nextCase = next.firstElementChild;
	                    while (nextCase != null) {
	                        if (nextCase.hasAttribute(exports.SwitchStyleCaseAttributes.CASE)) {
	                            if (this.cases[nextCase.getAttribute(exports.SwitchStyleCaseAttributes.CASE)] !== null) {
	                                this.cases[nextCase.getAttribute(exports.SwitchStyleCaseAttributes.CASE)] = nextCase;
	                            }
	                            else {
	                                if (false) {
	                                    this.log("ERROR case " +
	                                        nextCase.getAttribute("Case") +
	                                        " already exist in switchStyle " +
	                                        node.nodeName);
	                                }
	                            }
	                        }
	                        nextCase = nextCase.nextElementSibling;
	                    }
	                    break;
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    SwitchStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], SwitchStyle);
	    return SwitchStyle;
	}(Style_1.Style));
	exports.SwitchStyle = SwitchStyle;
	var SwitchStyleAttributes = {};
	exports.SwitchStyleCaseAttributes = {
	    CASE: "Case",
	    HANDLER: "Handler",
	    NEXT_CASE: "NextCase",
	    NEXT_RANDOM_CASE: "NextRandomCase",
	    TIMER: "Timer",
	};


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Style = (function () {
	    function Style() {
	    }
	    Style.prototype.create = function (node) {
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	    };
	    Style.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    Style = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], Style);
	    return Style;
	}());
	exports.Style = Style;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var StyleManager_1 = __webpack_require__(20);
	var ComponentTypes_1 = __webpack_require__(14);
	var ShapeElement_1 = __webpack_require__(13);
	var Tweens_1 = __webpack_require__(15);
	var StageController_1 = __webpack_require__(6);
	var TextElement_1 = __webpack_require__(94);
	var Attributes_1 = __webpack_require__(21);
	var CustomUtils_1 = __webpack_require__(22);
	var AnimationElement = (function (_super) {
	    __extends(AnimationElement, _super);
	    function AnimationElement() {
	        var textureArray = [PIXI.Texture.EMPTY];
	        _super.call(this, textureArray, false);
	        PIXI.ticker.shared.add(this.update, this, PIXI.UPDATE_PRIORITY.HIGH);
	        this._startFrame = 0;
	        this._randomStartFrame = false;
	        this._cloned = false;
	        this.__destroyed = false;
	        this._uid = this.componentName + "_" + neo_common_1.Utils.generateUuid();
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                this._uid = PerfDebug.generateElementUID(this);
	                PerfDebug.newElement(this, this.getDebugInfo());
	            }
	        }
	    }
	    AnimationElement.prototype.update = function (deltaTime) {
	        if (this.playing) {
	            _super.prototype.update.call(this, deltaTime);
	        }
	    };
	    AnimationElement.prototype.create = function (node) {
	        this.createByNode(node);
	        this.updateByNode(node);
	    };
	    AnimationElement.prototype.createByNode = function (node) {
	        this.assertDestroyed("_create()");
	        if (false) {
	            if (node.hasAttribute(exports.AnimationElementAttributes.DEBUG) &&
	                node.getAttribute(exports.AnimationElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.STYLE) ||
	            node.hasAttribute(exports.AnimationElementAttributes.STYLE2)) {
	            if (node.hasAttribute(exports.AnimationElementAttributes.STYLE)) {
	                this._style = StyleManager_1.StyleManager.Styles[node.getAttribute(exports.AnimationElementAttributes.STYLE)];
	            }
	            else if (node.hasAttribute(exports.AnimationElementAttributes.STYLE2)) {
	                this._style = StyleManager_1.StyleManager.Styles[node.getAttribute(exports.AnimationElementAttributes.STYLE2)];
	            }
	            if (this._style != null) {
	                if (this._style.startFrame != null) {
	                    this._startFrame = this._style.startFrame;
	                }
	                else {
	                    this._startFrame = null;
	                }
	                if (this._style.endFrame != null) {
	                    this._endFrame = this._style.endFrame;
	                }
	                else {
	                    this._endFrame = null;
	                }
	                if (this._style.stop != null) {
	                    this._stop = this._style.stop;
	                }
	                if (this._style.animation !== "") {
	                    var texture = void 0;
	                    var textures = [];
	                    if (this._endFrame != null) {
	                        for (var i = this._startFrame; i <= this._endFrame; i++) {
	                            var val = this.zerosPad(i, 4);
	                            texture = PIXI.utils.TextureCache[this._style.animation + val];
	                            if (texture != null) {
	                                if (i == this._startFrame) {
	                                    this.texture = texture;
	                                }
	                                textures.push(texture);
	                            }
	                            else {
	                                if (false) {
	                                    this.log("WARNING: No texture " +
	                                        this._style.animation +
	                                        val +
	                                        " in TextureCache of AnimationElement!");
	                                }
	                            }
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING: animation has no endFrame number. Use ImageElement with attribute Animation instead AnimationElement!");
	                        }
	                        var frame = this.zerosPad(this._startFrame, 4);
	                        texture = PIXI.utils.TextureCache[this._style.animation + frame];
	                        if (texture != null) {
	                            this.texture = texture;
	                            textures.push(texture);
	                        }
	                    }
	                    this.textures = textures;
	                    if (this.textures.length > 0) {
	                        this.onComplete = this._movieClipComplete.bind(this);
	                        this.loop = false;
	                        this.animationSpeed = 1;
	                        this.blendMode = PIXI.BLEND_MODES.NORMAL;
	                        this.alpha = 1;
	                        this._reverse = false;
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no frames in " + this._style.animation);
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR animation in style is not defined");
	                    }
	                }
	                if (this._style.loop != null) {
	                    this.loop = this._style.loop;
	                }
	                if (this._style.reverse != null) {
	                    this._reverse = this._style.reverse;
	                }
	                if (this._style.speed != null) {
	                    this.animationSpeed = this._style.speed * (this._style.reverse ? -1 : 1);
	                }
	                if (this._style.tint != null) {
	                    this.tint = this._style.tint;
	                }
	                if (this._style.blendMode != null) {
	                    this.blendMode = CustomUtils_1.CustomUtils.getBlendMode(this._style.blendMode);
	                }
	                if (this._style.alpha != null) {
	                    this.alpha = this._style.alpha;
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR missing style: " + node.getAttribute(exports.AnimationElementAttributes.STYLE));
	                }
	            }
	        }
	        this._randomStartFrame = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.RANDOM_START_FRAME, this._randomStartFrame);
	        if (node.hasAttribute(exports.AnimationElementAttributes.MASK)) {
	            var next = node.parentElement.firstElementChild;
	            while (next != null) {
	                if (next.nodeName === node.getAttribute(exports.AnimationElementAttributes.MASK)) {
	                    var shapeElement = new ShapeElement_1.ShapeElement();
	                    shapeElement.create(next);
	                    this.mask = shapeElement;
	                }
	                next = next.nextElementSibling;
	            }
	            if (this.mask == null) {
	                if (false) {
	                    this.log("ERROR no element with name: " + node.getAttribute(exports.AnimationElementAttributes.MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.BITMAP_MASK)) {
	            var image = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.AnimationElementAttributes.BITMAP_MASK));
	            if (image != null) {
	                this.maskSprite = new PIXI.Sprite(image);
	                if (node.hasAttribute(exports.AnimationElementAttributes.BITMAP_MASK_X)) {
	                    this.maskSprite.position.x = parseFloat(node.getAttribute(exports.AnimationElementAttributes.BITMAP_MASK_X));
	                }
	                if (node.hasAttribute(exports.AnimationElementAttributes.BITMAP_MASK_Y)) {
	                    this.maskSprite.position.y = parseFloat(node.getAttribute(exports.AnimationElementAttributes.BITMAP_MASK_Y));
	                }
	                if (!node.hasAttribute(exports.AnimationElementAttributes.BITMAP_MASK_SHOW)) {
	                    this.addChild(this.maskSprite);
	                    this.mask = this.maskSprite;
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR" +
	                        this.componentName +
	                        " no image with name for mask: " +
	                        node.getAttribute(exports.AnimationElementAttributes.BITMAP_MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SPEED)) {
	            this.animationSpeed =
	                parseFloat(node.getAttribute(exports.AnimationElementAttributes.SPEED)) * (this._reverse ? -1 : 1);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.createElement(this, this.getDebugInfo());
	            }
	        }
	    };
	    AnimationElement.prototype.updateByNode = function (node) {
	        if (!node) {
	            this.logError("No node specified for element update!");
	            return;
	        }
	        if (false) {
	            if (node.hasAttribute(exports.AnimationElementAttributes.DEBUG) &&
	                node.getAttribute(exports.AnimationElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (!node.hasAttribute("RemoveTweens") ||
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute("RemoveTweens")) != false) {
	            Tweens_1.Tweens.removeTweens(this);
	        }
	        this.visible = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.VISIBLE, this.visible);
	        this.alpha = Attributes_1.Attributes.assignFloatAttribute(node, exports.AnimationElementAttributes.ALPHA, this.alpha);
	        this.pivot.x = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.PIVOT_X, this.pivot.x);
	        this.pivot.y = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.PIVOT_Y, this.pivot.y);
	        if (node.hasAttribute(exports.AnimationElementAttributes.ANCHOR)) {
	            this.anchor.x = parseFloat(node.getAttribute(exports.AnimationElementAttributes.ANCHOR));
	            this.anchor.y = parseFloat(node.getAttribute(exports.AnimationElementAttributes.ANCHOR));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.ROTATION)) {
	            this.rotation = this.degrees2radians(parseFloat(node.getAttribute(exports.AnimationElementAttributes.ROTATION)));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.START_ROTATION)) {
	            if (node.getAttribute(exports.AnimationElementAttributes.START_ROTATION) ===
	                exports.AnimationElementAttributes.START_ROTATION) {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        this.position.x = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.X, this.position.x);
	        this.position.y = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.Y, this.position.y);
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SKEW_X)) {
	            this.skew.x = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SKEW_X));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SKEW_Y)) {
	            this.skew.y = parseFloat(node.getAttribute(exports.AnimationElementAttributes.SKEW_Y));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.CONTINUE) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationElementAttributes.CONTINUE))) {
	            this._continue = true;
	            if (node.hasAttribute(exports.AnimationElementAttributes.SPEED)) {
	                this.animationSpeed =
	                    parseFloat(node.getAttribute(exports.AnimationElementAttributes.SPEED)) * (this._reverse ? -1 : 1);
	            }
	            this.playMe();
	        }
	        else {
	            this._continue = false;
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.PLAY) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationElementAttributes.PLAY))) {
	            this._stop = false;
	            this._reverse = false;
	            if (node.hasAttribute(exports.AnimationElementAttributes.REVERSE) &&
	                neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationElementAttributes.REVERSE))) {
	                this._reverse = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationElementAttributes.REVERSE));
	                this.animationSpeed = this.animationSpeed * (this._reverse ? -1 : 1);
	            }
	            if (node.hasAttribute(exports.AnimationElementAttributes.SPEED)) {
	                this.animationSpeed =
	                    parseFloat(node.getAttribute(exports.AnimationElementAttributes.SPEED)) * (this._reverse ? -1 : 1);
	            }
	            this.playMe();
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.STOP)) {
	            this.showMe(parseInt(node.getAttribute(exports.AnimationElementAttributes.STOP)));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SHOW_FRAME)) {
	            this.showMe(parseInt(node.getAttribute(exports.AnimationElementAttributes.SHOW_FRAME)));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.TINT)) {
	            var tint = node.getAttribute(exports.AnimationElementAttributes.TINT);
	            switch (tint) {
	                case "none":
	                    this.tint = 0xffffff;
	                    break;
	                case "dynamic":
	                    this.tint = parseInt(AnimationElement.DynamicTint, 16);
	                    break;
	                default:
	                    this.tint = parseInt(node.getAttribute(exports.AnimationElementAttributes.TINT), 16);
	                    break;
	            }
	        }
	        this.runPositionTween(node);
	        this.runScaleTween(node);
	        this.runRotationTween(node);
	        this.runAlphaTween(node);
	        this.runTween(node);
	        if (false) {
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    AnimationElement.prototype.playMe = function (frame) {
	        if (frame === void 0) { frame = -1; }
	        if (!this._continue || !this.playing) {
	            if (this._randomStartFrame && this._startFrame === 0 && this._endFrame != null) {
	                this._startFrame = Math.floor(Math.random() * this._endFrame);
	            }
	            if (this._reverse) {
	                this.gotoAndPlay(this._endFrame);
	            }
	            else {
	                this.gotoAndPlay(this._startFrame);
	            }
	        }
	    };
	    AnimationElement.prototype.showMe = function (frameNumber) {
	        if (frameNumber != null) {
	            this.gotoAndStop(frameNumber);
	        }
	        else {
	            if (this._reverse) {
	                this.gotoAndStop(this._endFrame);
	            }
	            else {
	                this.gotoAndStop(this._startFrame);
	            }
	        }
	    };
	    AnimationElement.prototype.getMovieClip = function () {
	        return this;
	    };
	    AnimationElement.prototype._movieClipComplete = function () {
	        this.emit(AnimationElement.AnimationComplete);
	    };
	    AnimationElement.prototype.runAlphaTween = function (node) {
	        if (!node.hasAttribute(exports.AnimationElementAttributes.ALPHA_TWEEN)) {
	            return false;
	        }
	        var alphaTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.ALPHA_TWEEN));
	        var alphas = alphaTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.AnimationElementAttributes.ALPHA_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.ALPHA_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.ALPHA_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.ALPHA_TWEEN_LOOP, null);
	        Tweens_1.Tweens.alphaTween(this, { alphas: alphas, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    AnimationElement.prototype.runPositionTween = function (node) {
	        var _this = this;
	        if (!node.hasAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_X) ||
	            !node.hasAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_Y)) {
	            return false;
	        }
	        var positionTweenX;
	        var positionTweenY;
	        var positionTweenPosition = Attributes_1.Attributes.assignStringAttribute(node, exports.AnimationElementAttributes.POSITION_TWEEN_POSITION, null);
	        if (positionTweenPosition == exports.AnimationElementAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_X)).map(function (value) { return value + _this.position.x; });
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_Y)).map(function (value) { return value + _this.position.y; });
	        }
	        else {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_X));
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_Y));
	        }
	        var bezierX = null;
	        var bezierY = null;
	        var bezier = null;
	        if (node.hasAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_BEZIER_X) &&
	            node.hasAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_BEZIER_Y)) {
	            bezierX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_BEZIER_X));
	            bezierY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.POSITION_TWEEN_BEZIER_Y));
	            bezier = { values: [] };
	            for (var i = 0; i < Math.min(bezierX.length, bezierY.length); i++) {
	                bezier.values.push({ x: bezierX[i], y: bezierY[i] });
	            }
	        }
	        var tweenX = positionTweenX || [];
	        var tweenY = positionTweenY || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.AnimationElementAttributes.POSITION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.POSITION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.POSITION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.POSITION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.positionTween(this, { tweenX: tweenX, tweenY: tweenY, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop, bezier: bezier });
	    };
	    AnimationElement.prototype.runRotationTween = function (node) {
	        if (!node.hasAttribute(exports.AnimationElementAttributes.ROTATION_TWEEN)) {
	            return false;
	        }
	        var rotationTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.ROTATION_TWEEN));
	        var degrees = rotationTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.AnimationElementAttributes.ROTATION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.ROTATION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.ROTATION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.ROTATION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.rotationTween(this, { degrees: degrees, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    AnimationElement.prototype.runScaleTween = function (node) {
	        var _this = this;
	        var scaleTweenX;
	        var scaleTweenY;
	        var scaleTween;
	        var tweenValues = [];
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE_TWEEN_X)) {
	            scaleTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.SCALE_TWEEN_X));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE_TWEEN_Y)) {
	            scaleTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.AnimationElementAttributes.SCALE_TWEEN_Y));
	        }
	        if (node.hasAttribute(exports.AnimationElementAttributes.SCALE_TWEEN)) {
	            scaleTween = AnimationElement._getPointsFromPointsAttribute(node.getAttribute(exports.AnimationElementAttributes.SCALE_TWEEN));
	        }
	        if (scaleTween && scaleTween.length) {
	            tweenValues = scaleTween;
	        }
	        else if (scaleTweenX && scaleTweenY) {
	            if (scaleTweenX.length === scaleTweenY.length) {
	                tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                    return {
	                        x: scaleXValue,
	                        y: scaleTweenY[i],
	                    };
	                });
	            }
	        }
	        else if (scaleTweenX) {
	            tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                return {
	                    x: scaleXValue,
	                    y: _this.scale.y,
	                };
	            });
	        }
	        else if (scaleTweenY) {
	            tweenValues = scaleTweenY.map(function (scaleYValue, i) {
	                return {
	                    x: _this.scale.x,
	                    y: scaleYValue,
	                };
	            });
	        }
	        else {
	            return false;
	        }
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.AnimationElementAttributes.SCALE_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.SCALE_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.AnimationElementAttributes.SCALE_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.AnimationElementAttributes.SCALE_TWEEN_LOOP, null);
	        Tweens_1.Tweens.scaleTween(this, { tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    AnimationElement.prototype.runTween = function (node) {
	        if (node.hasAttribute(Tweens_1.TweensAttributes.TWEEN)) {
	            var tweens = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN));
	            for (var i = 0; i < tweens.length; i++) {
	                if (!node.hasAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)) {
	                    return false;
	                }
	                var tween = tweens[i];
	                var tweenValues = this.formatTweenValues(tween, neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)));
	                var tweenDuration = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DURATION + i) || "120");
	                var tweenEase = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_EASE + i) || "linear");
	                var tweenDelay = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DELAY + i) || "0");
	                var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, Tweens_1.TweensAttributes.TWEEN_LOOP + i, null);
	                if (tween === "scale") {
	                    tween = "scale.x";
	                    tweens[i] = "scale.y";
	                    i--;
	                }
	                Tweens_1.Tweens.customTween(this, { tween: tween, tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	            }
	        }
	        return false;
	    };
	    AnimationElement.prototype.formatTweenValues = function (tween, values) {
	        var tweenValues = [];
	        if (tween === "scale") {
	            tween = "scale.x";
	        }
	        var property = tween.split(".");
	        var value;
	        for (var i = 0; i < values.length; i++) {
	            var current = values[i];
	            switch (current[current.length - 1]) {
	                case "c":
	                    if (property.length == 1) {
	                        value = this[property[0]];
	                        if (property[0] === "rotation") {
	                            value = this.radians2degrees(value);
	                        }
	                        tweenValues.push(value);
	                    }
	                    else if (property.length == 2) {
	                        tweenValues.push(this[property[0]][property[1]]);
	                    }
	                    break;
	                case "+":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] + value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                case "-":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] - value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                default:
	                    tweenValues.push(parseFloat(current));
	            }
	        }
	        return tweenValues;
	    };
	    AnimationElement._getPointsFromPointsAttribute = function (pointsString) {
	        return pointsString
	            .replace(/\s/g, "")
	            .split(";")
	            .map(function (valuesPair) {
	            return /\(|\)/.test(valuesPair) ? valuesPair.slice(1, -1).split(",") : [valuesPair, valuesPair];
	        })
	            .map(function (valuesPair) {
	            return { x: parseFloat(valuesPair[0]), y: parseFloat(valuesPair[1]) };
	        });
	    };
	    AnimationElement.prototype.zerosPad = function (num, size) {
	        var s = num + "";
	        while (s.length < size)
	            s = "0" + s;
	        return s;
	    };
	    AnimationElement.prototype.clone = function () {
	        var element = new AnimationElement();
	        element._style = this._style;
	        element._startFrame = this._startFrame;
	        element._endFrame = this._endFrame;
	        element._stop = this._stop;
	        element._randomStartFrame = this._randomStartFrame;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.tint = this.tint;
	        element.blendMode = this.blendMode;
	        element.name = this.name;
	        element.skew.x = this.skew.x;
	        element.skew.y = this.skew.y;
	        if (this.textures != null && this.textures.length > 0) {
	            element.texture = this.texture;
	            element.textures = this.textures;
	            element.onComplete = element._movieClipComplete.bind(element);
	            if (this._style != null && this._style.loop != null) {
	                element.loop = this._style.loop;
	            }
	            element.animationSpeed = this.animationSpeed;
	        }
	        element.playMe = this.playMe.bind(element);
	        element.showMe = this.showMe.bind(element);
	        element.stop = this.stop.bind(element);
	        element.markAsCloned();
	        return element;
	    };
	    AnimationElement.prototype.markAsCloned = function () {
	        this._markAsCloned();
	    };
	    AnimationElement.prototype._markAsCloned = function () {
	        this.assertDestroyed("_markAsCloned()");
	        this._cloned = true;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.clone(this);
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    AnimationElement.prototype.removeAndDestroyChildren = function () {
	        this._removeAndDestroyChildren();
	    };
	    AnimationElement.prototype._removeAndDestroyChildren = function () {
	        this.assertDestroyed("_removeAndDestroyChildren");
	        var destroyOptions = {
	            children: true,
	        };
	        if (this.children != null && this.children.length > 0) {
	            for (var i = this.children.length - 1; i >= 0; i--) {
	                if (this.children[i] != null) {
	                    this.children[i].destroy(destroyOptions);
	                }
	            }
	        }
	        this.removeChildren();
	    };
	    AnimationElement.prototype.assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    AnimationElement.prototype.destroy = function (options) {
	        this.assertDestroyed("destroy");
	        if (neo_common_1.Utils.isNullOrUndefined(options)) {
	            options = AnimationElement._destroyOptions;
	        }
	        this.internalDestroy(options);
	        if (!neo_common_1.Utils.isNullOrUndefined(this.children)) {
	            _super.prototype.destroy.call(this);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.destroy(this);
	            }
	        }
	        this.__destroyed = true;
	    };
	    AnimationElement.prototype.internalDestroy = function (options) {
	        this.onComplete = null;
	        this.textures = [PIXI.Texture.EMPTY];
	        Tweens_1.Tweens.removeTweens(this);
	    };
	    AnimationElement.prototype.getDebugInfo = function () {
	        if (false) {
	            var debugInfoFn = this.debugInfo;
	            return debugInfoFn ? debugInfoFn.call(this) : this.uid + "\nName: [" + this.name + "]";
	        }
	        return "";
	    };
	    AnimationElement.prototype.debugInfo = function () {
	        if (false) {
	            var result = this.uid + "\nName: [" + this.name + "]";
	            var animation = this._style ? this._style.animation : "";
	            if (!neo_common_1.StringUtils.isNullOrEmpty(animation)) {
	                result += "\nAnimation: " + animation;
	            }
	            return result;
	        }
	        return "";
	    };
	    Object.defineProperty(AnimationElement.prototype, "cloned", {
	        get: function () {
	            return this._cloned;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AnimationElement.prototype, "destroyed", {
	        get: function () {
	            return this.__destroyed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AnimationElement.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AnimationElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AnimationElement.prototype.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    AnimationElement.prototype.radians2degrees = function (radians) {
	        return radians * (180 / Math.PI);
	    };
	    AnimationElement.prototype.changeAnimationSpeed = function (speed) {
	        this.animationSpeed = speed;
	    };
	    AnimationElement.prototype._printDebugInfo = function (text, node) {
	        if (false) {
	            if (this.getChildByName(exports.AnimationElementAttributes.DEBUG_INFO) != null) {
	                this.removeChild(this.getChildByName(exports.AnimationElementAttributes.DEBUG_INFO));
	            }
	            if (node == undefined ||
	                (node.hasAttribute(exports.AnimationElementAttributes.DEBUG_INFO) &&
	                    node.getAttribute(exports.AnimationElementAttributes.DEBUG_INFO) === "true")) {
	                var textInfo = new TextElement_1.TextElement();
	                textInfo.name = exports.AnimationElementAttributes.DEBUG_INFO;
	                textInfo.x = textInfo.y = 0;
	                textInfo.style.fill = 0xffffff;
	                textInfo.style.fontSize = 12;
	                textInfo.text = JSON.stringify(text, null, 4);
	                this.addChild(textInfo);
	            }
	        }
	    };
	    AnimationElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    AnimationElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    AnimationElement.AnimationComplete = "animationComplete";
	    AnimationElement.DynamicTint = "000000";
	    AnimationElement._destroyOptions = {
	        children: true,
	    };
	    AnimationElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], AnimationElement);
	    return AnimationElement;
	}(PIXI.extras.AnimatedSprite));
	exports.AnimationElement = AnimationElement;
	exports.AnimationElementAttributes = {
	    ALPHA: "Alpha",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    ALPHA_TWEEN_LOOP: "AlphaTweenLoop",
	    ANCHOR: "Anchor",
	    BITMAP_MASK: "BitmapMask",
	    BITMAP_MASK_SHOW: "BitmapMaskShow",
	    BITMAP_MASK_X: "BitmapMaskX",
	    BITMAP_MASK_Y: "BitmapMaskY",
	    CONTINUE: "Continue",
	    DEBUG_INFO: "DebugInfo",
	    DEBUG: "Debug",
	    MASK: "Mask",
	    PIVOT_X: "PivotX",
	    PIVOT_Y: "PivotY",
	    PLAY: "Play",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_BEZIER_X: "PositionTweenBezierX",
	    POSITION_TWEEN_BEZIER_Y: "PositionTweenBezierY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_DELAY: "PositionTweenDelay",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    POSITION_TWEEN_LOOP: "PositionTweenLoop",
	    RANDOM_START_FRAME: "RandomStartFrame",
	    REVERSE: "Reverse",
	    ROTATION: "Rotation",
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    ROTATION_TWEEN_LOOP: "RotationTweenLoop",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_X: "ScaleTweenX",
	    SCALE_TWEEN_Y: "ScaleTweenY",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_DELAY: "ScaleTweenDelay",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    SCALE_TWEEN_LOOP: "ScaleTweenLoop",
	    SCALE_X: "ScaleX",
	    SCALE_Y: "ScaleY",
	    SCALE: "Scale",
	    SKEW_X: "SkewX",
	    SKEW_Y: "SkewY",
	    START_ROTATION: "StartRotation",
	    SHOW_FRAME: "ShowFrame",
	    SPEED: "Speed",
	    STOP: "Stop",
	    STYLE: "Style",
	    STYLE2: "Style2",
	    TINT: "Tint",
	    VISIBLE: "Visible",
	    X: "X",
	    Y: "Y",
	};


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var TextElement = (function (_super) {
	    __extends(TextElement, _super);
	    function TextElement() {
	        _super.call(this);
	        this.text = "";
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                this._uid = PerfDebug.generateElementUID(this);
	                PerfDebug.newElement(this, this.getDebugInfo());
	            }
	        }
	    }
	    TextElement.prototype.create = function (node) {
	        this.createByNode(node);
	        this.updateByNode(node);
	    };
	    TextElement.prototype.createByNode = function (node) {
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.FONT)) {
	            this.style.fontFamily = node.getAttribute(exports.TextElementAttributes.FONT);
	        }
	    };
	    TextElement.prototype.updateByNode = function (node) {
	        if (node.hasAttribute(exports.TextElementAttributes.TEXT)) {
	            this.text = node.getAttribute(exports.TextElementAttributes.TEXT);
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.TEXT_ALIGN)) {
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.TEXT_BASELINE)) {
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.SIZE)) {
	            this.style.fontSize = parseInt(node.getAttribute(exports.TextElementAttributes.SIZE));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.ALPHA)) {
	            this.alpha = parseFloat(node.getAttribute(exports.TextElementAttributes.ALPHA));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.ROTATION)) {
	            this.rotation = parseInt(node.getAttribute(exports.TextElementAttributes.ROTATION));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.START_ROTATION)) {
	            if (node.getAttribute(exports.TextElementAttributes.START_ROTATION) === exports.TextElementAttributes.START_ROTATION) {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.TextElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.TextElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.TextElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.TextElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.X)) {
	            this.position.x = parseInt(node.getAttribute(exports.TextElementAttributes.X));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.Y)) {
	            this.position.y = parseInt(node.getAttribute(exports.TextElementAttributes.Y));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.PIVOT_X)) {
	            this.pivot.x = parseInt(node.getAttribute(exports.TextElementAttributes.PIVOT_X));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.PIVOT_Y)) {
	            this.pivot.y = parseInt(node.getAttribute(exports.TextElementAttributes.PIVOT_Y));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.VISIBLE)) {
	            this.visible = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.TextElementAttributes.VISIBLE));
	        }
	        if (node.hasAttribute(exports.TextElementAttributes.TINT)) {
	            if (node.getAttribute(exports.TextElementAttributes.TINT) === "0") {
	                this.style.fill = null;
	            }
	            else {
	                this.style.fill = parseInt(node.getAttribute(exports.TextElementAttributes.TINT), 16);
	            }
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    TextElement.prototype.markAsCloned = function () {
	        this._markAsCloned();
	    };
	    TextElement.prototype._markAsCloned = function () {
	        this.assertDestroyed("markAsCloned()");
	        this._cloned = true;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.clone(this);
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    TextElement.prototype.assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    Object.defineProperty(TextElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TextElement.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TextElement.prototype.getDebugInfo = function () {
	        if (false) {
	            var debugInfoFn = this.debugInfo;
	            return debugInfoFn ? debugInfoFn.call(this) : this.uid + "\nName: [" + this.name + "]";
	        }
	        return "";
	    };
	    TextElement.prototype.debugInfo = function () {
	        if (false) {
	            var result = this.uid + "\nName: [" + this.name + "]";
	            return result;
	        }
	        return "";
	    };
	    TextElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], TextElement);
	    return TextElement;
	}(PIXI.Text));
	exports.TextElement = TextElement;
	exports.TextElementAttributes = {
	    TEXT: "Text",
	    FONT: "Font",
	    SIZE: "Size",
	    TEXT_ALIGN: "TextAlign",
	    TEXT_ALIGN_VALUE: {
	        LEFT: "left",
	        CENTER: "center",
	        RIGHT: "right",
	    },
	    TEXT_BASELINE: "TextBaseline",
	    TEXT_BASELINE_VALUE: {
	        MIDDLE: "middle",
	        BOTTOM: "bottom",
	    },
	    ALPHA: "Alpha",
	    ROTATION: "Rotation",
	    START_ROTATION: "StartRotation",
	    SCALE_X: "ScaleX",
	    SCALE_Y: "ScaleY",
	    SCALE: "Scale",
	    X: "X",
	    Y: "Y",
	    PIVOT_X: "PivotX",
	    PIVOT_Y: "PivotY",
	    VISIBLE: "Visible",
	    TINT: "Tint",
	};


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ImageElement_1 = __webpack_require__(96);
	var StageController_1 = __webpack_require__(6);
	var BaseElement_1 = __webpack_require__(12);
	var Tweens_1 = __webpack_require__(15);
	var StyleManager_1 = __webpack_require__(20);
	var ParticleStyle_1 = __webpack_require__(97);
	var FrameTimer_1 = __webpack_require__(9);
	var CustomUtils_1 = __webpack_require__(22);
	var AnimationElement_1 = __webpack_require__(93);
	var ParticleElement = (function (_super) {
	    __extends(ParticleElement, _super);
	    function ParticleElement() {
	        _super.call(this);
	        this._pool = [];
	        this._timer = FrameTimer_1.CreateFrameTimer("particleTimer");
	        this._timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.addParticles.bind(this));
	        this._blendMode = 0;
	        this._created = false;
	        this._stopping = false;
	        this._stop = true;
	        this._emitOnce = false;
	        this._preGenerate = false;
	        this._startType = "";
	        this._randomStartFrame = false;
	        this._maxEmit = 1;
	        this.visible = false;
	        this._target = this;
	    }
	    ParticleElement.prototype.createByNode = function (node) {
	        if (!this._created) {
	            _super.prototype.createByNode.call(this, node);
	            if (node.hasAttribute(exports.ParticleElementAttributes.EMIT_ONCE)) {
	                this._emitOnce = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.EMIT_ONCE));
	            }
	            if (node.hasAttribute(exports.ParticleElementAttributes.PRE_GENERATE)) {
	                this._preGenerate = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.PRE_GENERATE));
	            }
	            if (node.hasAttribute(exports.ParticleElementAttributes.BLEND_MODE)) {
	                this._blendMode = parseInt(node.getAttribute(exports.ParticleElementAttributes.BLEND_MODE));
	            }
	            if (node.hasAttribute(exports.ParticleElementAttributes.RANDOM_START_FRAME)) {
	                this._randomStartFrame = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.RANDOM_START_FRAME));
	            }
	            if (node.hasAttribute(exports.ParticleElementAttributes.STYLE) ||
	                node.hasAttribute(exports.ParticleElementAttributes.STYLE2)) {
	                if (node.hasAttribute(exports.ParticleElementAttributes.STYLE)) {
	                    this._style = (StyleManager_1.StyleManager.Styles[node.getAttribute(exports.ParticleElementAttributes.STYLE)]);
	                }
	                else {
	                    this._style = (StyleManager_1.StyleManager.Styles[node.getAttribute(exports.ParticleElementAttributes.STYLE2)]);
	                }
	                this._styleName = this._style.name;
	            }
	            this.createParticles();
	            this._created = true;
	        }
	    };
	    ParticleElement.prototype.updateByNode = function (node) {
	        if (false) {
	            if (node.hasAttribute(exports.ParticleElementAttributes.DEBUG) &&
	                node.getAttribute(exports.ParticleElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.ParticleElementAttributes.MAX_EMIT)) {
	            this._maxEmit = parseInt(node.getAttribute(exports.ParticleElementAttributes.MAX_EMIT));
	            this._maxEmit = this._maxEmit * 0.01;
	            if (this._maxEmit > 1) {
	                this._maxEmit = 1;
	            }
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.START_TYPE)) {
	            this._startType = node.getAttribute(exports.ParticleElementAttributes.START_TYPE);
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.START) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.START))) {
	            this.start(this._emitOnce, this._startType);
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.STOPPING) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.STOPPING))) {
	            this.stopping();
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.STOP) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.STOP))) {
	            this.stop();
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.RESET) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.RESET))) {
	            this.reset();
	        }
	        if (node.hasAttribute(exports.ParticleElementAttributes.CLEAR) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ParticleElementAttributes.CLEAR))) {
	            this.clear();
	        }
	    };
	    ParticleElement.prototype.createParticles = function () {
	        if (this._style != null) {
	            if (this._style.images != null && this._style.images.length > 0) {
	                var count = this._emitOnce ? this._style.count : this._style.calculateElements();
	                for (var i = 0; i < count; i++) {
	                    var particle = this.createParticle();
	                    this._pool.push(particle);
	                }
	            }
	        }
	    };
	    ParticleElement.prototype.createParticle = function () {
	        var particle;
	        particle = this.createParticleResource();
	        this.setupParticle(particle);
	        if (this._preGenerate) {
	            this.setupPosition(particle);
	            this.addBehaviour(particle);
	        }
	        this.addChild(particle);
	        return particle;
	    };
	    ParticleElement.prototype.createParticleResource = function () {
	        if (this._style != null) {
	            var resource = null;
	            var resourceId = this.getRandomResource();
	            if (resourceId.indexOf("GFX_") > -1) {
	                resource = new ImageElement_1.ImageElement(StageController_1.StageController.getTextureByResourceId(resourceId));
	                resource.blendMode = CustomUtils_1.CustomUtils.getBlendMode(this._blendMode);
	            }
	            else if (resourceId.indexOf("ANI_") > -1) {
	                var node = document.createElement("Animation");
	                node.setAttribute("Style2", resourceId);
	                node.setAttribute("RandomStartFrame", this._randomStartFrame.toString());
	                resource = new AnimationElement_1.AnimationElement();
	                resource.create(node);
	            }
	            var localBounds = resource.getLocalBounds();
	            resource.pivot.set(localBounds.width / 2, localBounds.height / 2);
	            return resource;
	        }
	        return null;
	    };
	    ParticleElement.prototype.getRandomResource = function () {
	        return this._style.images[Math.floor(Math.random() * this._style.images.length)];
	    };
	    ParticleElement.prototype.setupParticle = function (particle) {
	        this.setVisibility(particle, false);
	        particle.usedInPool = false;
	        return particle;
	    };
	    ParticleElement.prototype.setVisibility = function (particle, visible) {
	        particle.visible = visible;
	        if (particle instanceof AnimationElement_1.AnimationElement) {
	            if (visible) {
	                particle.playMe();
	            }
	            else {
	                particle.stop();
	            }
	        }
	    };
	    ParticleElement.prototype.setupPosition = function (particle) {
	        var startX = 0;
	        var startY = 0;
	        switch (this._style.positionZone.type) {
	            case ParticleStyle_1.ParticleStyle.ZoneRectangle:
	                startX = this._style.positionZone.x + Math.random() * this._style.positionZone.width;
	                startY = this._style.positionZone.y + Math.random() * this._style.positionZone.height;
	                if (this._style.positionZone.innerWidth != -1 && this._style.positionZone.innerHeight != -1) {
	                    var centerX = this._style.positionZone.x + this._style.positionZone.width / 2;
	                    var centerY = this._style.positionZone.y + this._style.positionZone.height / 2;
	                    var innerCenterX = this._style.positionZone.innerX + this._style.positionZone.innerWidth / 2;
	                    var innerCenterY = this._style.positionZone.innerY + this._style.positionZone.innerHeight / 2;
	                    var correctX = Math.random() > 0.5;
	                    if (correctX) {
	                        if (startX > centerX) {
	                            startX = this.getRandom(innerCenterX + this._style.positionZone.innerWidth * 0.5, centerX + this._style.positionZone.width * 0.5);
	                        }
	                        else {
	                            startX = this.getRandom(0, innerCenterX - this._style.positionZone.innerWidth * 0.5);
	                        }
	                    }
	                    else {
	                        if (startY > centerY) {
	                            startY = this.getRandom(innerCenterY + this._style.positionZone.innerHeight * 0.5, centerY + this._style.positionZone.height * 0.5);
	                        }
	                        else {
	                            startY = this.getRandom(0, innerCenterY - this._style.positionZone.innerHeight * 0.5);
	                        }
	                    }
	                }
	                particle.x = startX;
	                particle.y = startY;
	                break;
	            case ParticleStyle_1.ParticleStyle.ZoneTarget:
	                startX =
	                    this._target.x +
	                        Math.random() * this._style.positionZone.width -
	                        this._style.positionZone.width / 2;
	                startY =
	                    this._target.y +
	                        Math.random() * this._style.positionZone.height -
	                        this._style.positionZone.height / 2;
	                particle.x = startX;
	                particle.y = startY;
	                break;
	            case ParticleStyle_1.ParticleStyle.ZoneLine:
	                break;
	            case ParticleStyle_1.ParticleStyle.ZoneEllipse:
	                startX = this._style.positionZone.x;
	                startY = this._style.positionZone.y;
	                var radianDegrees = Math.floor(this.getRandom(this._style.positionZone.startAngle, this._style.positionZone.angle));
	                var radian = this.degrees2radians(radianDegrees);
	                if (this._style.positionZone.innerRadius > 0) {
	                    var radius = this.getRandom(this._style.positionZone.minInnerRadius, this._style.positionZone.innerRadius);
	                    var radiusB = this.getRandom(this._style.positionZone.minInnerRadiusB, this._style.positionZone.innerRadiusB);
	                    startX = Math.floor(this._style.positionZone.innerX + radius * Math.cos(radian));
	                    startY = Math.floor(this._style.positionZone.innerY + radiusB * Math.sin(radian));
	                }
	                particle.x = startX;
	                particle.y = startY;
	                particle.rotation = radian;
	                break;
	        }
	    };
	    ParticleElement.prototype.setTargetElement = function (element) {
	        this._target = element;
	    };
	    ParticleElement.prototype.addBehaviour = function (particle) {
	        var particleLife = Math.floor(Math.random() * (this._style.maxLife - this._style.minLife)) + this._style.minLife;
	        this.addPathBehaviour(particle, particleLife);
	        this.addScaleBehaviour(particle, particleLife);
	        this.addRotationBehaviour(particle, particleLife);
	        this.addAlphaBehaviour(particle, particleLife);
	    };
	    ParticleElement.prototype.addPathBehaviour = function (particle, life) {
	        switch (this._style.positionZone.type) {
	            case ParticleStyle_1.ParticleStyle.ZoneRectangle:
	            case ParticleStyle_1.ParticleStyle.ZoneTarget:
	                this.addRectanglePathBehavior(particle, life);
	                break;
	            case ParticleStyle_1.ParticleStyle.ZoneEllipse:
	                this.addEllipsePathBehavior(particle, life);
	                break;
	        }
	    };
	    ParticleElement.prototype.addRectanglePathBehavior = function (particle, life) {
	        if (this._style.pathValues != null) {
	            var points = [];
	            for (var i = 0; i < this._style.pathValues.length; i++) {
	                if (this._style.pathValues[i] != null &&
	                    this._style.pathValues[i].x != null &&
	                    this._style.pathValues[i].y != null) {
	                    var valueX = this._style.pathValues[i].x;
	                    var valueY = this._style.pathValues[i].y;
	                    if (this._style.pathValues[i].randomX != null) {
	                        valueX =
	                            Math.floor(Math.random() * (this._style.pathValues[i].randomX - this._style.pathValues[i].x)) + this._style.pathValues[i].x;
	                    }
	                    if (this._style.pathValues[i].randomY != null) {
	                        valueY =
	                            Math.floor(Math.random() * (this._style.pathValues[i].randomY - this._style.pathValues[i].y)) + this._style.pathValues[i].y;
	                    }
	                    points.push({ x: particle.x + valueX, y: particle.y + valueY });
	                }
	            }
	            if (points.length > 2) {
	                Tweens_1.Tweens.positionTween(particle, {
	                    bezier: {
	                        values: points,
	                    },
	                    tweenX: [particle.x, particle.x],
	                    tweenY: [particle.y, particle.y],
	                    tweenDuration: life,
	                    paused: false,
	                    callbackFunction: this.removeFromPool,
	                    callbackParams: [particle],
	                    callbackScope: null,
	                });
	            }
	            else if (points.length === 2) {
	                Tweens_1.Tweens.positionTween(particle, {
	                    tweenX: [points[0]["x"], points[1]["x"]],
	                    tweenY: [points[0]["y"], points[1]["y"]],
	                    tweenDuration: life,
	                    paused: false,
	                    callbackFunction: this.removeFromPool,
	                    callbackParams: [particle],
	                    callbackScope: null,
	                });
	            }
	        }
	    };
	    ParticleElement.prototype.addEllipsePathBehavior = function (particle, life) {
	        var radius = this.getRandom(this._style.positionZone.minRadius, this._style.positionZone.radius);
	        var radiusB = this.getRandom(this._style.positionZone.minRadiusB, this._style.positionZone.radiusB);
	        var finalX = Math.floor(this._style.positionZone.x + radius * Math.cos(particle.rotation));
	        var finalY = Math.floor(this._style.positionZone.y + radiusB * Math.sin(particle.rotation));
	        Tweens_1.Tweens.positionTween(particle, {
	            tweenX: [particle.x, finalX],
	            tweenY: [particle.y, finalY],
	            tweenDuration: life,
	            paused: false,
	            callbackFunction: this.removeFromPool,
	            callbackParams: [particle],
	            callbackScope: null,
	        });
	    };
	    ParticleElement.prototype.addScaleBehaviour = function (particle, life) {
	        if (this._style.scaleValues != null) {
	            var scalePoints = [];
	            for (var i = 0; i < this._style.scaleValues.length; i++) {
	                var scaleValue = void 0;
	                if (this._style.scaleValues[i].length > 1) {
	                    scaleValue =
	                        Math.random() * (this._style.scaleValues[i][1] - this._style.scaleValues[i][0]) +
	                            this._style.scaleValues[i][0];
	                }
	                else {
	                    scaleValue = this._style.scaleValues[i][0];
	                }
	                scalePoints.push(new PIXI.Point(scaleValue, scaleValue));
	            }
	            if (scalePoints.length === 1) {
	                particle.scale.x = scalePoints[0].x;
	                particle.scale.y = scalePoints[0].y;
	            }
	            else if (scalePoints.length > 1) {
	                Tweens_1.Tweens.scaleTween(particle, {
	                    tweenValues: scalePoints,
	                    tweenDuration: life,
	                    paused: false,
	                });
	            }
	        }
	    };
	    ParticleElement.prototype.addRotationBehaviour = function (particle, life) {
	        if (this._style.rotationValues != null && this._style.rotationValues.length > 1) {
	            Tweens_1.Tweens.rotationTween(particle, {
	                degrees: [this._style.rotationValues[0], this._style.rotationValues[1]],
	                tweenDuration: life,
	                paused: false,
	            });
	        }
	    };
	    ParticleElement.prototype.addAlphaBehaviour = function (particle, life) {
	        if (this._style.alphaValues != null) {
	            var alphas = [];
	            for (var i = 0; i < this._style.alphaValues.length; i++) {
	                alphas.push(this._style.alphaValues[i]);
	            }
	            Tweens_1.Tweens.alphaTween(particle, {
	                alphas: alphas,
	                tweenDuration: life,
	                paused: false,
	            });
	        }
	    };
	    ParticleElement.prototype.addParticles = function () {
	        if (!this._stop) {
	            var tabActive = true;
	            if (document.visibilityState != null && document.visibilityState === "hidden") {
	                tabActive = false;
	            }
	            if (tabActive) {
	                this.getFromPool();
	            }
	            if (!this._stopping) {
	                this._timer.start(this._style.time);
	            }
	        }
	    };
	    ParticleElement.prototype.getFreeParticleIndex = function () {
	        for (var i = 0; i < this._pool.length; i++) {
	            if (!this._pool[i].usedInPool) {
	                return i;
	            }
	        }
	        return -1;
	    };
	    ParticleElement.prototype.getFromPool = function () {
	        var count = Math.floor(this._style.count * this._maxEmit);
	        for (var i = 0; i < count; i++) {
	            var particle = void 0;
	            var index = this.getFreeParticleIndex();
	            if (index == -1) {
	                particle = this.createParticle();
	                this._pool.push(particle);
	            }
	            else {
	                particle = this._pool[index];
	            }
	            if (particle != null) {
	                particle.usedInPool = true;
	                this.setVisibility(particle, true);
	                if (this._preGenerate) {
	                    Tweens_1.Tweens.restartTweens(particle.uid);
	                }
	                else {
	                    Tweens_1.Tweens.removeTweens(particle);
	                    this.setupPosition(particle);
	                    this.addBehaviour(particle);
	                }
	            }
	        }
	    };
	    ParticleElement.prototype.start = function (emitOnce, startType) {
	        if (emitOnce === void 0) { emitOnce = false; }
	        if (startType === void 0) { startType = ""; }
	        this.visible = true;
	        if (this._style != null) {
	            this._timer.stop();
	            this._emitOnce = emitOnce;
	            this._startType = startType;
	            this._stopping = emitOnce;
	            this._stop = false;
	            if (!this._emitOnce) {
	                this._timer.start(this._style.time);
	                if (this._startType === "now") {
	                    this.addParticles();
	                }
	            }
	            else {
	                if (this._startType === "now") {
	                    this.addParticles();
	                }
	                else {
	                    this._timer.start(this._style.time);
	                }
	            }
	        }
	    };
	    ParticleElement.prototype.stopping = function () {
	        this._stopping = true;
	    };
	    ParticleElement.prototype.stop = function () {
	        this._stopping = false;
	        this._stop = true;
	        this._timer.stop();
	        this.visible = false;
	    };
	    ParticleElement.prototype.reset = function () {
	        for (var i = 0; i < this._pool.length; i++) {
	            this.setupPosition(this._pool[i]);
	            this.setVisibility(this._pool[i], false);
	        }
	    };
	    ParticleElement.prototype.clear = function () {
	        this._stopping = false;
	        this._stop = true;
	        this._timer.stop();
	        this.visible = false;
	        this.removeAllFromPool();
	    };
	    ParticleElement.prototype.removeFromPool = function (particle) {
	        particle.visible = false;
	        if (particle instanceof AnimationElement_1.AnimationElement) {
	            particle.stop();
	        }
	        particle.usedInPool = false;
	    };
	    ParticleElement.prototype.removeAllFromPool = function () {
	        for (var i = 0; i < this._pool.length; i++) {
	            this.setVisibility(this._pool[i], false);
	            Tweens_1.Tweens.removeTweens(this._pool[i]);
	            this._pool[i].usedInPool = false;
	        }
	    };
	    ParticleElement.prototype.getRandom = function (min, max) {
	        return Math.random() * (max - min) + min;
	    };
	    ParticleElement.prototype.clone = function () {
	        var element = new ParticleElement();
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.visible = this.visible;
	        element._target = this._target;
	        element._blendMode = this._blendMode;
	        element._emitOnce = this._emitOnce;
	        element._maxEmit = this._maxEmit;
	        element._preGenerate = this._preGenerate;
	        var node = document.createElement(this.name);
	        node.setAttribute("Style2", this._styleName);
	        element.create(node);
	        element._markAsCloned();
	        return element;
	    };
	    ParticleElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ParticleElement);
	    return ParticleElement;
	}(BaseElement_1.BaseElement));
	exports.ParticleElement = ParticleElement;
	exports.ParticleElementAttributes = {
	    BLEND_MODE: "BlendMode",
	    DEBUG: "Debug",
	    RANDOM_START_FRAME: "RandomStartFrame",
	    SPEED: "Speed",
	    EMIT_ONCE: "EmitOnce",
	    START_TYPE: "StartType",
	    PRE_GENERATE: "PreGenerate",
	    MAX_EMIT: "MaxEmit",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    STYLE: "Style",
	    STYLE2: "Style2",
	    EXTEND_STYLE: "ExtendStyle",
	    START: "Start",
	    STOPPING: "Stopping",
	    STOP: "Stop",
	    RESET: "Reset",
	    CLEAR: "Clear",
	    IMAGE: "Image",
	    TINT: "Tint",
	    ATTR_COUNT: "Count",
	    ATTR_TIME: "Time",
	    ATTR_MIN: "Min",
	    ATTR_MAX: "Max",
	    ATTR_FROM_FRAME: "FromFrame",
	    ATTR_IMAGES: "Images",
	    ATTR_TYPE: "Type",
	    ATTR_X: "X",
	    ATTR_Y: "Y",
	    ATTR_RANDOM_X: "RandomX",
	    ATTR_RANDOM_Y: "RandomY",
	    ATTR_WIDTH: "Width",
	    ATTR_HEIGHT: "Height",
	    ATTR_RADIUS: "Radius",
	    ATTR_POSITION_RADIUS: "PositionRadius",
	    ATTR_RANDOM_POSITION_ANGLE: "RandomPositionAngle",
	    ATTR_MIN_RADIUS: "MinRadius",
	    ATTR_INNER_RADIUS: "InnerRadius",
	    ATTR_ANGLE: "Angle",
	    ATTR_SHOW_ANGLE: "ShowAngle",
	    ATTR_VALUES: "Values",
	    ATTR_VALUE: "Value",
	    IMAGE_MASK: "ImageMask",
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var Tweens_1 = __webpack_require__(15);
	var ShapeElement_1 = __webpack_require__(13);
	var Attributes_1 = __webpack_require__(21);
	var TextElement_1 = __webpack_require__(94);
	var CustomUtils_1 = __webpack_require__(22);
	var ImageElement = (function (_super) {
	    __extends(ImageElement, _super);
	    function ImageElement(texture) {
	        _super.call(this, texture);
	        this.zIndex = 0;
	        this.usedInPool = false;
	        this._uid = this.componentName + "_" + neo_common_1.Utils.generateUuid();
	        this.tint = 0xffffff;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                this._uid = PerfDebug.generateElementUID(this);
	                PerfDebug.newElement(this, this.getDebugInfo());
	            }
	        }
	    }
	    Object.defineProperty(ImageElement.prototype, "tweenEngine", {
	        get: function () {
	            return this._tweenEngine;
	        },
	        set: function (engine) {
	            this._tweenEngine = engine;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ImageElement.prototype.create = function (node) {
	        this.createByNode(node);
	        this.updateByNode(node);
	    };
	    ImageElement.prototype.createByNode = function (node) {
	        if (false) {
	            if (node.hasAttribute(exports.ImageElementAttributes.DEBUG) &&
	                node.getAttribute(exports.ImageElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.IMAGE)) {
	            this.texture = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.ImageElementAttributes.IMAGE));
	        }
	        else if (node.hasAttribute(exports.ImageElementAttributes.FROM_FRAME)) {
	            if (node.hasAttribute(exports.ImageElementAttributes.FRAME)) {
	                var frame = parseInt(node.getAttribute(exports.ImageElementAttributes.FRAME));
	                var frameStr = frame < 10 ? "0" + frame : frame;
	                this.texture = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.ImageElementAttributes.FROM_FRAME) + "00" + frameStr);
	            }
	            else {
	                this.texture = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.ImageElementAttributes.FROM_FRAME));
	            }
	        }
	        else if (node.hasAttribute(exports.ImageElementAttributes.ANIMATION)) {
	            var frame = 0;
	            if (node.hasAttribute(exports.ImageElementAttributes.FRAME)) {
	                frame = parseInt(node.getAttribute(exports.ImageElementAttributes.FRAME));
	            }
	            var frameStr = frame < 10 ? "0" + frame : frame;
	            this.texture = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.ImageElementAttributes.ANIMATION) + "00" + frameStr);
	        }
	        if (this.texture) {
	            if (node.hasAttribute(exports.ImageElementAttributes.ANCHOR)) {
	                var anchorPoints = node.getAttribute(exports.ImageElementAttributes.ANCHOR).split(";");
	                if (anchorPoints.length === 1) {
	                    this.anchor.x = parseFloat(anchorPoints[0]);
	                    this.anchor.y = parseFloat(anchorPoints[0]);
	                }
	                else if (anchorPoints.length === 2) {
	                    this.anchor.x = parseFloat(anchorPoints[0]);
	                    this.anchor.y = parseFloat(anchorPoints[1]);
	                }
	            }
	        }
	        else {
	            if (false) {
	                if (!(this.texture && this.texture.baseTexture)) {
	                    this.log("ERROR Image has no texture");
	                }
	            }
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.TWEEN_ENGINE)) {
	            this._tweenEngine = node.getAttribute(exports.ImageElementAttributes.TWEEN_ENGINE);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.createElement(this, this.getDebugInfo());
	            }
	        }
	    };
	    ImageElement.prototype.updateByNode = function (node) {
	        if (!node) {
	            this.logError("No node specified for element update!");
	            return;
	        }
	        if (false) {
	            if (node.hasAttribute(exports.ImageElementAttributes.DEBUG) &&
	                node.getAttribute(exports.ImageElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (!node.hasAttribute(exports.ImageElementAttributes.TWEEN_PERSISTENT) ||
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ImageElementAttributes.TWEEN_PERSISTENT)) != true) {
	            Tweens_1.Tweens.removeTweens(this);
	        }
	        this.visible = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ImageElementAttributes.VISIBLE, this.visible);
	        this.alpha = Attributes_1.Attributes.assignFloatAttribute(node, exports.ImageElementAttributes.ALPHA, this.alpha);
	        this.blendMode = CustomUtils_1.CustomUtils.getBlendMode(this.getBlendModeByString(Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.BLEND_MODE, this.blendMode)));
	        this.pivot.x = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.PIVOT_X, this.pivot.x);
	        this.pivot.y = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.PIVOT_Y, this.pivot.y);
	        if (node.hasAttribute(exports.ImageElementAttributes.ROTATION)) {
	            this.rotation = this.degrees2radians(parseFloat(node.getAttribute(exports.ImageElementAttributes.ROTATION)));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.START_ROTATION)) {
	            if (node.getAttribute(exports.ImageElementAttributes.START_ROTATION) === exports.ImageElementAttributes.START_ROTATION) {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        this.position.x = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.X, this.position.x);
	        this.position.y = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.Y, this.position.y);
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE_X)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ImageElementAttributes.SCALE_X));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE_Y)) {
	            this.scale.y = parseFloat(node.getAttribute(exports.ImageElementAttributes.SCALE_Y));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE)) {
	            this.scale.x = parseFloat(node.getAttribute(exports.ImageElementAttributes.SCALE));
	            this.scale.y = parseFloat(node.getAttribute(exports.ImageElementAttributes.SCALE));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.MASK)) {
	            var next = node.parentElement.firstElementChild;
	            while (next != null) {
	                if (next.nodeName === node.getAttribute(exports.ImageElementAttributes.MASK)) {
	                    var shapeElement = new ShapeElement_1.ShapeElement();
	                    shapeElement.create(next);
	                    this.mask = shapeElement;
	                }
	                next = next.nextElementSibling;
	            }
	            if (this.mask == null) {
	                if (false) {
	                    this.log("ERROR no element with name: " + node.getAttribute(exports.ImageElementAttributes.MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.BITMAP_MASK)) {
	            var image = StageController_1.StageController.getTextureByResourceId(node.getAttribute(exports.ImageElementAttributes.BITMAP_MASK));
	            if (image != null) {
	                this.maskSprite = new PIXI.Sprite(image);
	                if (node.hasAttribute(exports.ImageElementAttributes.BITMAP_MASK_X)) {
	                    this.maskSprite.position.x = parseFloat(node.getAttribute(exports.ImageElementAttributes.BITMAP_MASK_X));
	                }
	                if (node.hasAttribute(exports.ImageElementAttributes.BITMAP_MASK_Y)) {
	                    this.maskSprite.position.y = parseFloat(node.getAttribute(exports.ImageElementAttributes.BITMAP_MASK_Y));
	                }
	                if (!node.hasAttribute(exports.ImageElementAttributes.BITMAP_MASK_SHOW)) {
	                    this.addChild(this.maskSprite);
	                    this.mask = this.maskSprite;
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR" +
	                        this.componentName +
	                        " no image with name for mask: " +
	                        node.getAttribute(exports.ImageElementAttributes.BITMAP_MASK));
	                }
	            }
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.TINT)) {
	            var spr = void 0;
	            if (node.getAttribute(exports.ImageElementAttributes.TINT) === "0") {
	                this.tint = null;
	            }
	            else if (node.getAttribute(exports.ImageElementAttributes.TINT) === "dynamic") {
	                this.tint = parseInt(ImageElement.DynamicTint, 16);
	            }
	            else {
	                this.tint = parseInt(node.getAttribute(exports.ImageElementAttributes.TINT), 16);
	                if (this.children != null && this.children[0] != null && this.children[0] instanceof PIXI.Sprite) {
	                    spr = this.children[0];
	                    spr.tint = this.tint;
	                }
	            }
	        }
	        this.runPositionTween(node);
	        this.runScaleTween(node);
	        this.runRotationTween(node);
	        this.runAlphaTween(node);
	        this.runTween(node);
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	        return this;
	    };
	    ImageElement.prototype.runAlphaTween = function (node) {
	        if (!node.hasAttribute(exports.ImageElementAttributes.ALPHA_TWEEN)) {
	            return false;
	        }
	        var alphaTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.ALPHA_TWEEN));
	        var alphas = alphaTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.ALPHA_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.ALPHA_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.ALPHA_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ImageElementAttributes.ALPHA_TWEEN_LOOP, null);
	        Tweens_1.Tweens.alphaTween(this, { alphas: alphas, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ImageElement.prototype.runPositionTween = function (node) {
	        var _this = this;
	        if ((!node.hasAttribute(exports.ImageElementAttributes.POSITION_TWEEN_X) ||
	            !node.hasAttribute(exports.ImageElementAttributes.POSITION_TWEEN_Y)) &&
	            (!node.hasAttribute("PositionTweenToX") || !node.hasAttribute("PositionTweenToY")) &&
	            (!node.hasAttribute("AbsolutePositionTweenToX") || !node.hasAttribute("AbsolutePositionTweenToY"))) {
	            return false;
	        }
	        var positionTweenX;
	        var positionTweenY;
	        if (node.hasAttribute(exports.ImageElementAttributes.POSITION_TWEEN_X) &&
	            node.hasAttribute(exports.ImageElementAttributes.POSITION_TWEEN_Y)) {
	            var positionTweenPosition = Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.POSITION_TWEEN_POSITION, null);
	            if (positionTweenPosition === exports.ImageElementAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
	                positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.POSITION_TWEEN_X)).map(function (value) { return value + _this.position.x; });
	                positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.POSITION_TWEEN_Y)).map(function (value) { return value + _this.position.y; });
	            }
	            else {
	                positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.POSITION_TWEEN_X));
	                positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.POSITION_TWEEN_Y));
	            }
	        }
	        else if (node.hasAttribute("PositionTweenToX") && node.hasAttribute("PositionTweenToY")) {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute("PositionTweenToX"));
	            positionTweenX.unshift(this.position.x);
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute("PositionTweenToY"));
	            positionTweenY.unshift(this.position.y);
	        }
	        else if (node.hasAttribute("AbsolutePositionTweenToX") && node.hasAttribute("AbsolutePositionTweenToY")) {
	            positionTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute("AbsolutePositionTweenToX")).map(function (value) { return _this.position.x + (value - _this.getGlobalPosition().x); });
	            positionTweenX.unshift(this.position.x);
	            positionTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute("AbsolutePositionTweenToY")).map(function (value) { return _this.position.y + (value - _this.getGlobalPosition().y); });
	            positionTweenY.unshift(this.position.y);
	        }
	        var tweenX = positionTweenX || [];
	        var tweenY = positionTweenY || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.POSITION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.POSITION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.POSITION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ImageElementAttributes.POSITION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.positionTween(this, { tweenX: tweenX, tweenY: tweenY, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ImageElement.prototype.runRotationTween = function (node) {
	        if (!node.hasAttribute(exports.ImageElementAttributes.ROTATION_TWEEN)) {
	            return false;
	        }
	        var rotationTween = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.ROTATION_TWEEN));
	        var degrees = rotationTween || [];
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.ROTATION_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.ROTATION_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.ROTATION_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ImageElementAttributes.ROTATION_TWEEN_LOOP, null);
	        Tweens_1.Tweens.rotationTween(this, { degrees: degrees, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ImageElement.prototype.runScaleTween = function (node) {
	        var _this = this;
	        var scaleTweenX;
	        var scaleTweenY;
	        var scaleTween;
	        var tweenValues = [];
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE_TWEEN_X)) {
	            scaleTweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.SCALE_TWEEN_X));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE_TWEEN_Y)) {
	            scaleTweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.ImageElementAttributes.SCALE_TWEEN_Y));
	        }
	        if (node.hasAttribute(exports.ImageElementAttributes.SCALE_TWEEN)) {
	            scaleTween = ImageElement._getPointsFromPointsAttribute(node.getAttribute(exports.ImageElementAttributes.SCALE_TWEEN));
	        }
	        if (scaleTween && scaleTween.length) {
	            tweenValues = scaleTween;
	        }
	        else if (scaleTweenX && scaleTweenY) {
	            if (scaleTweenX.length === scaleTweenY.length) {
	                tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                    return {
	                        x: scaleXValue,
	                        y: scaleTweenY[i],
	                    };
	                });
	            }
	        }
	        else if (scaleTweenX) {
	            tweenValues = scaleTweenX.map(function (scaleXValue, i) {
	                return {
	                    x: scaleXValue,
	                    y: _this.scale.y,
	                };
	            });
	        }
	        else if (scaleTweenY) {
	            tweenValues = scaleTweenY.map(function (scaleYValue, i) {
	                return {
	                    x: _this.scale.x,
	                    y: scaleYValue,
	                };
	            });
	        }
	        else {
	            return false;
	        }
	        var tweenEase = Attributes_1.Attributes.assignStringAttribute(node, exports.ImageElementAttributes.SCALE_TWEEN_EASE, null);
	        var tweenDuration = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.SCALE_TWEEN_DURATION, 120);
	        var tweenDelay = Attributes_1.Attributes.assignIntAttribute(node, exports.ImageElementAttributes.SCALE_TWEEN_DELAY, 0);
	        var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, exports.ImageElementAttributes.SCALE_TWEEN_LOOP, null);
	        Tweens_1.Tweens.scaleTween(this, { tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay, tweenLoop: tweenLoop });
	    };
	    ImageElement.prototype.runTween = function (node) {
	        if (node.hasAttribute(Tweens_1.TweensAttributes.TWEEN)) {
	            var tweens = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN));
	            for (var i = 0; i < tweens.length; i++) {
	                if (!node.hasAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)) {
	                    return false;
	                }
	                var tween = tweens[i];
	                var tweenValues = this.formatTweenValues(tween, neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_VALUES + i)));
	                var tweenDuration = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DURATION + i) || "120");
	                var tweenEase = neo_common_1.ArrayUtils.stringArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_EASE + i) || "linear");
	                var tweenDelay = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_DELAY + i) || "0");
	                var tweenLoop = Attributes_1.Attributes.assignBooleanAttribute(node, Tweens_1.TweensAttributes.TWEEN_LOOP + i, null);
	                var tweenProgress = parseFloat(node.getAttribute(Tweens_1.TweensAttributes.TWEEN_PROGRESS + i) || "0");
	                if (tween === "scale") {
	                    tween = "scale.x";
	                    tweens[i] = "scale.y";
	                    i--;
	                }
	                var customTween = Tweens_1.Tweens.customTween(this, {
	                    tween: tween,
	                    tweenValues: tweenValues,
	                    tweenEase: tweenEase,
	                    tweenDuration: tweenDuration,
	                    tweenDelay: tweenDelay,
	                    tweenLoop: tweenLoop,
	                });
	                if (tweenProgress > 0) {
	                    customTween.progress(tweenProgress);
	                }
	            }
	        }
	        return false;
	    };
	    ImageElement.prototype.formatTweenValues = function (tween, values) {
	        var tweenValues = [];
	        if (tween === "scale") {
	            tween = "scale.x";
	        }
	        var property = tween.split(".");
	        var value;
	        for (var i = 0; i < values.length; i++) {
	            var current = values[i];
	            switch (current[current.length - 1]) {
	                case "c":
	                    if (property.length == 1) {
	                        value = this[property[0]];
	                        if (property[0] === "rotation") {
	                            value = this.radians2degrees(value);
	                        }
	                        tweenValues.push(value);
	                    }
	                    else if (property.length == 2) {
	                        tweenValues.push(this[property[0]][property[1]]);
	                    }
	                    break;
	                case "+":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] + value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                case "-":
	                    value = parseFloat(current.slice(0, -1));
	                    if (tweenValues.length > 0) {
	                        value = tweenValues[tweenValues.length - 1] - value;
	                    }
	                    tweenValues.push(value);
	                    break;
	                default:
	                    tweenValues.push(parseFloat(current));
	            }
	        }
	        return tweenValues;
	    };
	    ImageElement.prototype.clone = function () {
	        var element = new ImageElement();
	        element.removeChildren();
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.anchor = this.anchor;
	        element.tint = this.tint;
	        element.blendMode = this.blendMode;
	        element.name = this.name;
	        element._tweenEngine = this._tweenEngine;
	        if (this.texture != null) {
	            element.texture = this.texture;
	        }
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    ImageElement.prototype.internalDestroy = function (options) {
	        Tweens_1.Tweens.removeTweens(this);
	        this.texture = null;
	    };
	    ImageElement.prototype.getDebugInfo = function () {
	        if (false) {
	            var debugInfoFn = this.debugInfo;
	            return debugInfoFn ? debugInfoFn.call(this) : this.uid + "\nName: [" + this.name + "]";
	        }
	        return "";
	    };
	    ImageElement.prototype.debugInfo = function () {
	        if (false) {
	            var result = this.uid + "\nName: [" + this.name + "]";
	            var imgurl = this.texture && this.texture.baseTexture ? this.texture.baseTexture.imageUrl : "";
	            if (!neo_common_1.StringUtils.isNullOrEmpty(imgurl)) {
	                result += "\nUrl: " + imgurl;
	            }
	            return result;
	        }
	        return "";
	    };
	    Object.defineProperty(ImageElement.prototype, "cloned", {
	        get: function () {
	            return this._cloned;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImageElement.prototype, "destroyed", {
	        get: function () {
	            return this.__destroyed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImageElement.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImageElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ImageElement.prototype.destroy = function (options) {
	        this.assertDestroyed("destroy");
	        if (neo_common_1.Utils.isNullOrUndefined(options)) {
	            options = ImageElement._destroyOptions;
	        }
	        this.internalDestroy(options);
	        if (!neo_common_1.Utils.isNullOrUndefined(this.children)) {
	            _super.prototype.destroy.call(this, options);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.destroy(this);
	            }
	        }
	        this.__destroyed = true;
	    };
	    ImageElement.prototype.assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    ImageElement._getPointsFromPointsAttribute = function (pointsString) {
	        if (!pointsString) {
	            return [];
	        }
	        return pointsString
	            .replace(/\s/g, "")
	            .split(";")
	            .map(function (valuesPair) {
	            return /\(|\)/.test(valuesPair) ? valuesPair.slice(1, -1).split(",") : [valuesPair, valuesPair];
	        })
	            .map(function (valuesPair) {
	            return { x: parseFloat(valuesPair[0]), y: parseFloat(valuesPair[1]) };
	        });
	    };
	    ImageElement.prototype._markAsCloned = function () {
	        this.markAsCloned();
	    };
	    ImageElement.prototype.markAsCloned = function () {
	        this._assertDestroyed("markAsCloned()");
	        this._cloned = true;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.clone(this);
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    ImageElement.prototype._assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    ImageElement.prototype.removeAndDestroyChildren = function () {
	        this._removeAndDestroyChildren();
	    };
	    ImageElement.prototype._removeAndDestroyChildren = function () {
	        this._assertDestroyed("_removeAndDestroyChildren");
	        var destroyOptions = {
	            children: true,
	        };
	        if (this.children != null && this.children.length > 0) {
	            for (var i = this.children.length - 1; i >= 0; i--) {
	                if (this.children[i] != null) {
	                    this.children[i].destroy(destroyOptions);
	                }
	            }
	        }
	        this.removeChildren();
	    };
	    ImageElement.prototype.degrees2radians = function (degrees) {
	        return degrees * (Math.PI / 180);
	    };
	    ImageElement.prototype.radians2degrees = function (radians) {
	        return radians * (180 / Math.PI);
	    };
	    ImageElement.prototype.getBlendModeByString = function (mode) {
	        mode = mode.toString();
	        switch (mode) {
	            case "0":
	            case "normal":
	                return PIXI.BLEND_MODES.NORMAL;
	            case "1":
	            case "add":
	                return PIXI.BLEND_MODES.ADD;
	            case "2":
	            case "multiply":
	                return PIXI.BLEND_MODES.MULTIPLY;
	            case "3":
	            case "screen":
	                return PIXI.BLEND_MODES.SCREEN;
	            case "4":
	            case "overlay":
	                return PIXI.BLEND_MODES.OVERLAY;
	            case "5":
	            case "darken":
	                return PIXI.BLEND_MODES.DARKEN;
	            case "6":
	            case "lighten":
	                return PIXI.BLEND_MODES.LIGHTEN;
	            case "7":
	            case "color_dodge":
	                return PIXI.BLEND_MODES.COLOR_DODGE;
	            case "8":
	            case "color_burn":
	                return PIXI.BLEND_MODES.COLOR_BURN;
	            case "9":
	            case "hard_light":
	                return PIXI.BLEND_MODES.HARD_LIGHT;
	            case "10":
	            case "soft_light":
	                return PIXI.BLEND_MODES.SOFT_LIGHT;
	            case "11":
	            case "difference":
	                return PIXI.BLEND_MODES.DIFFERENCE;
	            case "12":
	            case "exclusion":
	                return PIXI.BLEND_MODES.EXCLUSION;
	            case "13":
	            case "hue":
	                return PIXI.BLEND_MODES.HUE;
	            case "14":
	            case "saturation":
	                return PIXI.BLEND_MODES.SATURATION;
	            case "15":
	            case "color":
	                return PIXI.BLEND_MODES.COLOR;
	            case "16":
	            case "luminosity":
	                return PIXI.BLEND_MODES.LUMINOSITY;
	            default:
	                if (false) {
	                    this.log("ERROR Unknown blending mode " + mode + ". Used default mode NORMAL.");
	                }
	                return PIXI.BLEND_MODES.NORMAL;
	        }
	    };
	    ImageElement.prototype._printDebugInfo = function (text, node) {
	        if (false) {
	            if (this.getChildByName(exports.ImageElementAttributes.DEBUG_INFO) != null) {
	                this.removeChild(this.getChildByName(exports.ImageElementAttributes.DEBUG_INFO));
	            }
	            if (node == undefined ||
	                (node.hasAttribute(exports.ImageElementAttributes.DEBUG_INFO) &&
	                    node.getAttribute(exports.ImageElementAttributes.DEBUG_INFO) === "true")) {
	                var textInfo = new TextElement_1.TextElement();
	                textInfo.name = exports.ImageElementAttributes.DEBUG_INFO;
	                textInfo.x = textInfo.y = 0;
	                textInfo.style.fill = 0xff0000;
	                textInfo.style.fontSize = 10;
	                textInfo.text = JSON.stringify(text, null, 4);
	                this.addChild(textInfo);
	            }
	        }
	    };
	    ImageElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    ImageElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    ImageElement.DynamicTint = "ff0000";
	    ImageElement._destroyOptions = {
	        children: true,
	    };
	    ImageElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ImageElement);
	    return ImageElement;
	}(PIXI.Sprite));
	exports.ImageElement = ImageElement;
	exports.ImageElementAttributes = {
	    ALPHA: "Alpha",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    ALPHA_TWEEN_LOOP: "AlphaTweenLoop",
	    ANCHOR: "Anchor",
	    ANIMATION: "Animation",
	    BITMAP_MASK: "BitmapMask",
	    BITMAP_MASK_SHOW: "BitmapMaskShow",
	    BITMAP_MASK_X: "BitmapMaskX",
	    BITMAP_MASK_Y: "BitmapMaskY",
	    BLEND_MODE: "BlendMode",
	    DEBUG_INFO: "DebugInfo",
	    DEBUG: "Debug",
	    FRAME: "Frame",
	    FROM_FRAME: "FromFrame",
	    IMAGE: "Image",
	    MASK: "Mask",
	    PIVOT_X: "PivotX",
	    PIVOT_Y: "PivotY",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_DELAY: "PositionTweenDelay",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    POSITION_TWEEN_LOOP: "PositionTweenLoop",
	    ROTATION: "Rotation",
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    ROTATION_TWEEN_LOOP: "RotationTweenLoop",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_X: "ScaleTweenX",
	    SCALE_TWEEN_Y: "ScaleTweenY",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_DELAY: "ScaleTweenDelay",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    SCALE_TWEEN_LOOP: "ScaleTweenLoop",
	    SCALE: "Scale",
	    SCALE_X: "ScaleX",
	    SCALE_Y: "ScaleY",
	    START_ROTATION: "StartRotation",
	    TINT: "Tint",
	    TWEEN_ENGINE: "TweenEngine",
	    VISIBLE: "Visible",
	    TWEEN_PERSISTENT: "TweenPersistent",
	    X: "X",
	    Y: "Y",
	};


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var StyleManager_1 = __webpack_require__(20);
	var ParticleElement_1 = __webpack_require__(95);
	var ParticleStyle = (function (_super) {
	    __extends(ParticleStyle, _super);
	    function ParticleStyle() {
	        _super.call(this);
	        this._count = 1;
	        this._time = 60;
	        this._minLife = 60;
	        this._maxLife = 120;
	        this._images = [];
	        this._randomStartFrame = false;
	        this._subParticleStyle = "";
	        this._positionZone = {
	            type: ParticleStyle.ZoneRectangle,
	            x: 0,
	            y: 0,
	            innerX: 0,
	            innerY: 0,
	            width: StageController_1.StageController.Width,
	            height: StageController_1.StageController.Height,
	            innerWidth: -1,
	            innerHeight: -1,
	            radius: 0,
	            minRadius: 0,
	            radiusB: 0,
	            minRadiusB: 0,
	            innerRadius: 0,
	            minInnerRadius: 0,
	            innerRadiusB: 0,
	            minInnerRadiusB: 0,
	            angle: 360,
	            startAngle: 0,
	        };
	        this._pathValues = [];
	        this._scaleValues = [];
	        this._rotationValues = [];
	        this._alphaValues = [];
	    }
	    ParticleStyle.prototype.create = function (node) {
	        this.node = node;
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute(ParticleElement_1.ParticleElementAttributes.EXTEND_STYLE)) {
	            var extendStyle = (StyleManager_1.StyleManager.Styles[node.getAttribute(ParticleElement_1.ParticleElementAttributes.EXTEND_STYLE)]);
	            if (extendStyle != null && extendStyle.node != null) {
	                this.parseChildrenNodes(extendStyle.node);
	            }
	        }
	        this.parseChildrenNodes(node);
	    };
	    ParticleStyle.prototype.parseChildrenNodes = function (node) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            switch (next.nodeName) {
	                case ParticleStyle.NodeCount:
	                    this.initializeCount(next);
	                    break;
	                case ParticleStyle.NodeLife:
	                    this.initializeLife(next);
	                    break;
	                case ParticleStyle.NodeImages:
	                    this.initializeImages(next);
	                    break;
	                case ParticleStyle.NodePosition:
	                    this.initializePosition(next);
	                    break;
	                case ParticleStyle.NodePath:
	                    this.initializePath(next);
	                    break;
	                case ParticleStyle.NodeScale:
	                    this.initializeScale(next);
	                    break;
	                case ParticleStyle.NodeRotation:
	                    this.initializeRotation(next);
	                    break;
	                case ParticleStyle.NodeAlpha:
	                    this.initializeAlpha(next);
	                    break;
	                default:
	                    if (false) {
	                        this.log("WARNING unknown node in particle style " + next.nodeName);
	                    }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    Object.defineProperty(ParticleStyle.prototype, "count", {
	        get: function () {
	            return this._count;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "time", {
	        get: function () {
	            return this._time;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "minLife", {
	        get: function () {
	            return this._minLife;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "maxLife", {
	        get: function () {
	            return this._maxLife;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "images", {
	        get: function () {
	            return this._images;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "randomStartFrame", {
	        get: function () {
	            return this._randomStartFrame;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "subParticleStyle", {
	        get: function () {
	            return this._subParticleStyle;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "positionZone", {
	        get: function () {
	            return this._positionZone;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "pathValues", {
	        get: function () {
	            return this._pathValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "scaleValues", {
	        get: function () {
	            return this._scaleValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "rotationValues", {
	        get: function () {
	            return this._rotationValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ParticleStyle.prototype, "alphaValues", {
	        get: function () {
	            return this._alphaValues;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ParticleStyle.prototype.calculateElements = function () {
	        var elementsPerSecond = (StageController_1.StageController.FPS / this._time) * this._count;
	        var elementsWithLife = (this._maxLife / StageController_1.StageController.FPS) * elementsPerSecond;
	        return elementsWithLife;
	    };
	    ParticleStyle.prototype.initializeCount = function (node) {
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_COUNT)) {
	            this._count = parseInt(node.getAttribute(ParticleStyleAttributes.ATTR_COUNT));
	        }
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_TIME)) {
	            this._time = parseInt(node.getAttribute(ParticleStyleAttributes.ATTR_TIME));
	        }
	    };
	    ParticleStyle.prototype.initializeLife = function (node) {
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_MIN)) {
	            this._minLife = parseInt(node.getAttribute(ParticleStyleAttributes.ATTR_MIN));
	        }
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_MAX)) {
	            this._maxLife = parseInt(node.getAttribute(ParticleStyleAttributes.ATTR_MAX));
	        }
	        if (this._minLife > this._maxLife) {
	            this._maxLife = this._minLife;
	        }
	    };
	    ParticleStyle.prototype.initializeImages = function (node) {
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_FROM_FRAME)) {
	            this._images = node.getAttribute(ParticleStyleAttributes.ATTR_FROM_FRAME).split(";");
	            for (var i = 0; i < this._images.length; i++) {
	                this._images[i] = this._images[i] + "0000";
	            }
	        }
	        else if (node.hasAttribute(ParticleStyleAttributes.ATTR_IMAGES)) {
	            this._images = node.getAttribute(ParticleStyleAttributes.ATTR_IMAGES).split(";");
	        }
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_RANDOM_START_FRAME)) {
	            this._randomStartFrame = neo_common_1.StringUtils.parseBoolean(node.getAttribute(ParticleStyleAttributes.ATTR_RANDOM_START_FRAME));
	        }
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_SUB_PARTICLE_STYLE)) {
	            this._subParticleStyle = node.getAttribute(ParticleStyleAttributes.ATTR_SUB_PARTICLE_STYLE);
	        }
	    };
	    ParticleStyle.prototype.initializePosition = function (node) {
	        if (node.hasAttribute(ParticleStyleAttributes.ATTR_TYPE)) {
	            this._positionZone.type = node.getAttribute(ParticleStyleAttributes.ATTR_TYPE);
	            switch (this._positionZone.type) {
	                case ParticleStyle.ZoneRectangle:
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_X)) {
	                        this._positionZone.x = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_X));
	                        this._positionZone.innerX = this._positionZone.x;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_Y)) {
	                        this._positionZone.y = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_Y));
	                        this._positionZone.innerY = this._positionZone.y;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_X)) {
	                        this._positionZone.innerX = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_X));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_Y)) {
	                        this._positionZone.innerY = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_Y));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_WIDTH)) {
	                        this._positionZone.width = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_WIDTH));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_HEIGHT)) {
	                        this._positionZone.height = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_HEIGHT));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_WIDTH)) {
	                        this._positionZone.innerWidth = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_WIDTH));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_HEIGHT)) {
	                        this._positionZone.innerHeight = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_HEIGHT));
	                    }
	                    break;
	                case ParticleStyle.ZoneTarget:
	                    this._positionZone.width = 0;
	                    this._positionZone.height = 0;
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_WIDTH)) {
	                        this._positionZone.width = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_WIDTH));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_HEIGHT)) {
	                        this._positionZone.height = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_HEIGHT));
	                    }
	                    break;
	                case ParticleStyle.ZoneDynamic:
	                    break;
	                case ParticleStyle.ZoneLine:
	                    break;
	                case ParticleStyle.ZoneEllipse:
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_X)) {
	                        this._positionZone.x = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_X));
	                        this._positionZone.innerX = this._positionZone.x;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_Y)) {
	                        this._positionZone.y = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_Y));
	                        this._positionZone.innerY = this._positionZone.y;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_X)) {
	                        this._positionZone.innerX = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_X));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_Y)) {
	                        this._positionZone.innerY = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_Y));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_RADIUS)) {
	                        var radius = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_RADIUS));
	                        this._positionZone.radius = radius;
	                        this._positionZone.radiusB = radius;
	                        this._positionZone.minRadius = radius;
	                        this._positionZone.minRadiusB = radius;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_MIN_RADIUS)) {
	                        this._positionZone.minRadius = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_MIN_RADIUS));
	                        this._positionZone.minRadiusB = this._positionZone.minRadius;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_RADIUS_B)) {
	                        this._positionZone.radiusB = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_RADIUS_B));
	                        this._positionZone.minRadiusB = this._positionZone.radiusB;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_MIN_RADIUS_B)) {
	                        this._positionZone.minRadiusB = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_MIN_RADIUS_B));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_RADIUS)) {
	                        var innerRadius = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_RADIUS));
	                        this._positionZone.innerRadius = innerRadius;
	                        this._positionZone.innerRadiusB = innerRadius;
	                        this._positionZone.minInnerRadius = innerRadius;
	                        this._positionZone.minInnerRadiusB = innerRadius;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_MIN_INNER_RADIUS)) {
	                        this._positionZone.minInnerRadius = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_MIN_INNER_RADIUS));
	                        this._positionZone.minInnerRadiusB = this._positionZone.minInnerRadius;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_INNER_RADIUS_B)) {
	                        this._positionZone.innerRadiusB = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_INNER_RADIUS_B));
	                        this._positionZone.minInnerRadiusB = this._positionZone.innerRadiusB;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_MIN_INNER_RADIUS_B)) {
	                        this._positionZone.minInnerRadiusB = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_MIN_INNER_RADIUS_B));
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_START_ANGLE)) {
	                        var startAngle = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_START_ANGLE));
	                        this._positionZone.startAngle = startAngle;
	                    }
	                    if (node.hasAttribute(ParticleStyleAttributes.ATTR_ANGLE)) {
	                        var angle = parseFloat(node.getAttribute(ParticleStyleAttributes.ATTR_ANGLE));
	                        this._positionZone.angle = angle;
	                    }
	                    break;
	                default:
	                    if (false) {
	                        this.log("WARNING unknown zone " + this._positionZone.type);
	                    }
	            }
	        }
	    };
	    ParticleStyle.prototype.initializePath = function (node) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            if (next.nodeName === ParticleStyle.NodeValue) {
	                var path = {};
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_X)) {
	                    path.x = parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_X));
	                }
	                else {
	                    path.x = 0;
	                }
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_Y)) {
	                    path.y = parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_Y));
	                }
	                else {
	                    path.y = 0;
	                }
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_RANDOM_X)) {
	                    path.randomX = parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_RANDOM_X));
	                }
	                else {
	                    path.randomX = null;
	                }
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_RANDOM_Y)) {
	                    path.randomY = parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_RANDOM_Y));
	                }
	                else {
	                    path.randomY = null;
	                }
	                this._pathValues.push(path);
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ParticleStyle.prototype.initializeScale = function (node) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            if (next.nodeName === ParticleStyle.NodeValue) {
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_VALUES)) {
	                    this._scaleValues.push(neo_common_1.ArrayUtils.numberArray(next.getAttribute(ParticleStyleAttributes.ATTR_VALUES)));
	                }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ParticleStyle.prototype.initializeRotation = function (node) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            if (next.nodeName === ParticleStyle.NodeValue) {
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_VALUE)) {
	                    this._rotationValues.push(parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_VALUE)));
	                }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ParticleStyle.prototype.initializeAlpha = function (node) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            if (next.nodeName === ParticleStyle.NodeValue) {
	                if (next.hasAttribute(ParticleStyleAttributes.ATTR_VALUE)) {
	                    this._alphaValues.push(parseFloat(next.getAttribute(ParticleStyleAttributes.ATTR_VALUE)));
	                }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ParticleStyle.ElementsReserve = 0.5;
	    ParticleStyle.ZoneRectangle = "Rectangle";
	    ParticleStyle.ZoneLine = "Line";
	    ParticleStyle.ZoneEllipse = "Ellipse";
	    ParticleStyle.ZoneTarget = "Target";
	    ParticleStyle.ZoneDynamic = "Dynamic";
	    ParticleStyle.NodeCount = "Count";
	    ParticleStyle.NodeLife = "Life";
	    ParticleStyle.NodeImages = "Images";
	    ParticleStyle.NodePosition = "Position";
	    ParticleStyle.NodePath = "Path";
	    ParticleStyle.NodeScale = "Scale";
	    ParticleStyle.NodeRotation = "Rotation";
	    ParticleStyle.NodeAlpha = "Alpha";
	    ParticleStyle.NodeValue = "Value";
	    ParticleStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], ParticleStyle);
	    return ParticleStyle;
	}(Style_1.Style));
	exports.ParticleStyle = ParticleStyle;
	var ParticleStyleAttributes = {
	    ATTR_COUNT: "Count",
	    ATTR_TIME: "Time",
	    ATTR_MIN: "Min",
	    ATTR_MAX: "Max",
	    ATTR_FROM_FRAME: "FromFrame",
	    ATTR_IMAGES: "Images",
	    ATTR_TYPE: "Type",
	    ATTR_X: "X",
	    ATTR_Y: "Y",
	    ATTR_INNER_X: "InnerX",
	    ATTR_INNER_Y: "InnerY",
	    ATTR_RADIUS: "Radius",
	    ATTR_MIN_RADIUS: "MinRadius",
	    ATTR_RADIUS_B: "RadiusB",
	    ATTR_MIN_RADIUS_B: "MinRadiusB",
	    ATTR_INNER_RADIUS: "InnerRadius",
	    ATTR_MIN_INNER_RADIUS: "MinInnerRadius",
	    ATTR_INNER_RADIUS_B: "InnerRadiusB",
	    ATTR_MIN_INNER_RADIUS_B: "MinInnerRadiusB",
	    ATTR_ANGLE: "Angle",
	    ATTR_START_ANGLE: "StartAngle",
	    ATTR_RANDOM_X: "RandomX",
	    ATTR_RANDOM_Y: "RandomY",
	    ATTR_WIDTH: "Width",
	    ATTR_HEIGHT: "Height",
	    ATTR_INNER_WIDTH: "InnerWidth",
	    ATTR_INNER_HEIGHT: "InnerHeight",
	    ATTR_VALUES: "Values",
	    ATTR_VALUE: "Value",
	    ATTR_RANDOM_START_FRAME: "RandomStartFrame",
	    ATTR_SUB_PARTICLE_STYLE: "SubParticleStyle",
	};


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var StyleManager_1 = __webpack_require__(20);
	var ComponentTypes_1 = __webpack_require__(14);
	var AnimationFrame_1 = __webpack_require__(10);
	var StageController_1 = __webpack_require__(6);
	var CustomUtils_1 = __webpack_require__(22);
	var protonProto = window["Proton"];
	var ProtonElement = (function (_super) {
	    __extends(ProtonElement, _super);
	    function ProtonElement() {
	        _super.call(this);
	        this._animationName = "";
	        this._emitting = false;
	        this._stopping = true;
	        this._animationSpeed = 1;
	        this._animationLoop = true;
	        this._emitters = [];
	        this._proton = new protonProto();
	        this.onProtonUpdate = this.onProtonUpdate.bind(this);
	        this.onParticleCreated = this.onParticleCreated.bind(this);
	        this.onParticleUpdate = this.onParticleUpdate.bind(this);
	        this.onParticleDead = this.onParticleDead.bind(this);
	        this.transformSprite = this.transformSprite.bind(this);
	        this.alphaDead = this.alphaDead.bind(this);
	        this.scaleDead = this.scaleDead.bind(this);
	    }
	    ProtonElement.prototype.frame_onFrame = function () {
	        this._proton.update();
	    };
	    Object.defineProperty(ProtonElement.prototype, "frame_name", {
	        get: function () {
	            return this._styleName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProtonElement.prototype.updateByNode = function (node) {
	        this.create(node);
	        this.super2.runTween(node);
	    };
	    ProtonElement.prototype.create = function (node) {
	        this.super2.createByNode(node);
	        if (node.hasAttribute(ProtonElementAttributes.TINT)) {
	            this._tint = parseInt(node.getAttribute(ProtonElementAttributes.TINT), 16);
	        }
	        if (node.hasAttribute(ProtonElementAttributes.BLEND_MODE)) {
	            this._blendMode = parseInt(node.getAttribute(ProtonElementAttributes.BLEND_MODE));
	        }
	        if (node.hasAttribute(ProtonElementAttributes.STYLE) || node.hasAttribute(ProtonElementAttributes.STYLE_2)) {
	            if (node.hasAttribute(ProtonElementAttributes.STYLE)) {
	                this._style = StyleManager_1.StyleManager.Styles[node.getAttribute(ProtonElementAttributes.STYLE)];
	                this._styleName = this._style.node.nodeName;
	            }
	            else {
	                this._style = StyleManager_1.StyleManager.Styles[node.getAttribute(ProtonElementAttributes.STYLE_2)];
	                this._styleName = this._style.node.nodeName;
	            }
	            if (this._style != null) {
	                var next = this._style.node.firstElementChild;
	                while (next != null) {
	                    if (next.nodeName === "Emitter") {
	                        var emitter = new Proton.Emitter();
	                        this._emitters.push(emitter);
	                        var emitterNext = next.firstElementChild;
	                        while (emitterNext != null) {
	                            switch (emitterNext.nodeName) {
	                                case "Rate":
	                                    if (emitterNext.hasAttribute("Rate")) {
	                                        var rate = neo_common_1.ArrayUtils.numberArray(emitterNext.getAttribute("Rate"));
	                                        if (rate.length === 2) {
	                                            emitter.rate = new Proton.Rate(rate[0], rate[1]);
	                                        }
	                                        else {
	                                            if (false) {
	                                                this.log("WARNING Rate has different number of parameters. It has to have two parameters.");
	                                            }
	                                        }
	                                    }
	                                    else if (emitterNext.hasAttribute("RateStart") &&
	                                        emitterNext.hasAttribute("RateEnd")) {
	                                        var rateStart = neo_common_1.ArrayUtils.numberArray(emitterNext.getAttribute("RateStart"));
	                                        var rateEnd = neo_common_1.ArrayUtils.numberArray(emitterNext.getAttribute("RateEnd"));
	                                        emitter.rate = new Proton.Rate(new Proton.Span(rateStart[0], rateStart[1]), new Proton.Span(rateEnd[0], rateEnd[1]));
	                                    }
	                                    else if (emitterNext.hasAttribute("NumPan") &&
	                                        emitterNext.hasAttribute("TimePan")) {
	                                        var numPan = neo_common_1.ArrayUtils.numberArray(emitterNext.getAttribute("NumPan"));
	                                        var timePan = neo_common_1.ArrayUtils.numberArray(emitterNext.getAttribute("TimePan"));
	                                        emitter.rate = new Proton.Rate(new Proton.Span(numPan[0], numPan[1]), new Proton.Span(timePan[0], timePan[1]));
	                                    }
	                                    else {
	                                        if (false) {
	                                            this.log("WARNING Rate has wrong attributes");
	                                        }
	                                    }
	                                    break;
	                                case "Initializers":
	                                    this.createInitializers(emitterNext, this._emitters[this._emitters.length - 1]);
	                                    break;
	                                case "Behaviours":
	                                    this.createBehaviours(emitterNext, this._emitters[this._emitters.length - 1]);
	                                    break;
	                                default:
	                                    if (false) {
	                                        this.log("WARNING unknown type for emitter");
	                                    }
	                            }
	                            emitterNext = emitterNext.nextElementSibling;
	                        }
	                        if (next.hasAttribute("Emit")) {
	                            emitter.emit(next.getAttribute("Emit"));
	                        }
	                        else {
	                            emitter.emit();
	                        }
	                        if (next.hasAttribute("X")) {
	                            emitter["p"].x = parseInt(next.getAttribute("X"));
	                        }
	                        if (next.hasAttribute("Y")) {
	                            emitter["p"].y = parseInt(next.getAttribute("Y"));
	                        }
	                    }
	                    next = next.nextElementSibling;
	                }
	                if (this._emitters != null) {
	                    for (var i = 0; i < this._emitters.length; i++) {
	                        this._proton.addEmitter(this._emitters[i]);
	                    }
	                    this._renderer = new Proton.Renderer("other", this._proton);
	                    this._renderer.onProtonUpdate = this.onProtonUpdate;
	                    this._renderer.onParticleCreated = this.onParticleCreated;
	                    this._renderer.onParticleUpdate = this.onParticleUpdate;
	                    this._renderer.onParticleDead = this.onParticleDead;
	                    this._emitting = false;
	                    this.frame_stop();
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no emitters");
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name: " + node.getAttribute(ProtonElementAttributes.STYLE));
	                }
	            }
	        }
	        if (node.hasAttribute(ProtonElementAttributes.START)) {
	            if (this.isFrameStopped) {
	                if (this._renderer != null) {
	                    this._renderer.stop();
	                }
	                this.removeChilds();
	                if (this._emitters != null && this._emitters.length > 0) {
	                    if (node.hasAttribute(ProtonElementAttributes.EMIT)) {
	                        for (var i = 0; i < this._emitters.length; i++) {
	                            this._emitters[i].emit(node.getAttribute(ProtonElementAttributes.EMIT));
	                        }
	                    }
	                }
	                if (this._renderer != null) {
	                    this._renderer.start();
	                    this._stopping = false;
	                    this._emitting = true;
	                    this.frame_start();
	                }
	            }
	            else if (this._stopping) {
	                this._emitting = true;
	                this._stopping = false;
	            }
	        }
	        if (node.hasAttribute(ProtonElementAttributes.STOPPING)) {
	            this._emitting = false;
	            this._stopping = true;
	        }
	        if (node.hasAttribute(ProtonElementAttributes.STOP)) {
	            this.stop();
	        }
	    };
	    ProtonElement.prototype.start = function (emit) {
	        if (emit === void 0) { emit = ""; }
	        if (this.isFrameStopped) {
	            this.removeChilds();
	            if (this._emitters != null && this._emitters.length > 0) {
	                if (emit != "") {
	                    for (var i = 0; i < this._emitters.length; i++) {
	                        this._emitters[i].emit(emit);
	                    }
	                }
	            }
	            if (this._renderer != null) {
	                this._renderer.start();
	                this._stopping = false;
	                this._emitting = true;
	                this.frame_start();
	            }
	        }
	    };
	    ProtonElement.prototype.onProtonUpdate = function () {
	        var emmiter0 = this._emitters[0];
	        if (emmiter0["emitTotalTimes"] === "none" && emmiter0["particles"].length === 0) {
	            this._emitting = false;
	            this.frame_stop();
	            this._renderer.stop();
	            this.removeChilds();
	        }
	    };
	    ProtonElement.prototype.onParticleCreated = function (particle) {
	        if (this._stopping === false) {
	            particle.sprite = null;
	            if (particle.sprite != null) {
	                if (this._textures != null && this._textures.length > 0) {
	                    ProtonElement.Pool[this._animationName].push(particle.sprite);
	                    this.super2.removeChild(particle.sprite);
	                }
	                else {
	                    ProtonElement.Pool[particle.target.textureCacheIds[0]].push(particle.sprite);
	                    this.super2.removeChild(particle.sprite);
	                }
	            }
	            var particleSprite = void 0;
	            if (this._textures != null && this._textures.length > 0) {
	                if (ProtonElement.Pool[this._animationName] == null) {
	                    ProtonElement.Pool[this._animationName] = [];
	                }
	                if (ProtonElement.Pool[this._animationName].length === 0) {
	                    particleSprite = new PIXI.extras.AnimatedSprite(this._textures);
	                    particleSprite.name = this._animationName;
	                }
	                else {
	                    particleSprite = ProtonElement.Pool[this._animationName].shift();
	                }
	                particleSprite.loop = this._animationLoop;
	                particleSprite.animationSpeed = this._animationSpeed;
	                if (!this._animationLoop) {
	                    particleSprite.gotoAndStop(0);
	                }
	                particleSprite.play();
	            }
	            else {
	                if (ProtonElement.Pool[particle.target.textureCacheIds[0]] == null) {
	                    ProtonElement.Pool[particle.target.textureCacheIds[0]] = [];
	                }
	                if (ProtonElement.Pool[particle.target.textureCacheIds[0]].length === 0) {
	                    particleSprite = new PIXI.Sprite(particle.target);
	                    particleSprite.name = particle.target.textureCacheIds[0];
	                }
	                else {
	                    particleSprite = ProtonElement.Pool[particle.target.textureCacheIds[0]].shift();
	                }
	            }
	            if (this._tint != null) {
	                particleSprite.tint = this._tint;
	            }
	            if (this._blendMode != null) {
	                particleSprite.blendMode = CustomUtils_1.CustomUtils.getBlendMode(this._blendMode);
	            }
	            particleSprite.visible = true;
	            particle.sprite = particleSprite;
	            this.super2.addChild(particleSprite);
	        }
	    };
	    ProtonElement.prototype.onParticleUpdate = function (particle) {
	        if (particle != null && particle.sprite != null) {
	            this.transformSprite(particle.sprite, particle);
	        }
	    };
	    ProtonElement.prototype.onParticleDead = function (particle) {
	        if (particle.sprite != null) {
	            particle.sprite.visible = false;
	            if (particle.sprite instanceof PIXI.extras.AnimatedSprite) {
	                particle.sprite.stop();
	            }
	            this.super2.removeChild(particle.sprite);
	        }
	        particle.sprite = null;
	        particle.dead = true;
	        particle = null;
	    };
	    ProtonElement.prototype.transformSprite = function (particleSprite, particle) {
	        if (particleSprite.transform != null &&
	            !neo_common_1.Utils.isNullOrUndefined(particleSprite) &&
	            !neo_common_1.Utils.isNullOrUndefined(particle)) {
	            particleSprite.position.x = particle.p.x;
	            particleSprite.position.y = particle.p.y;
	            particleSprite.scale.x = particle.scale;
	            particleSprite.scale.y = particle.scale;
	            particleSprite.anchor.x = 0.5;
	            particleSprite.anchor.y = 0.5;
	            particleSprite.alpha = particle.alpha;
	            particleSprite.rotation = (particle.rotation * Math.PI) / 180;
	        }
	        else {
	            particle.dead = true;
	        }
	    };
	    ProtonElement.prototype.stop = function () {
	        this._emitting = false;
	        this._stopping = true;
	        this.frame_stop();
	        for (var i = 0; i < this._emitters.length; i++) {
	            this._emitters[i].resetParticles();
	        }
	        if (this._renderer != null) {
	            this._renderer.stop();
	        }
	        this.removeChilds();
	    };
	    ProtonElement.prototype.removeChilds = function () {
	        if (this.super2.children != null) {
	            var i = 0;
	            while (this.super2.children.length !== 0) {
	                if (this.super2.children[0] != null) {
	                    if (this._textures != null && this._textures.length > 0) {
	                        this.super2.children[0].stop();
	                        ProtonElement.Pool[this._animationName].push(this.super2.children[0]);
	                    }
	                    else {
	                        ProtonElement.Pool[this.super2.children[0].name].push(this.super2.children[0]);
	                    }
	                    this.super2.removeChild(this.super2.children[0]);
	                }
	            }
	        }
	    };
	    ProtonElement.prototype.internalDestroy = function (options) {
	        this._emitting = false;
	        this._stopping = true;
	        this.frame_stop();
	        this._textures = null;
	        if (this._emitters != null && this._emitters.length > 0) {
	            for (var i = 0; i < this._emitters.length; i++) {
	                if (this._emitters[i] != null) {
	                    this._proton.removeEmitter(this._emitters[i]);
	                    this._emitters[i].destroy();
	                    this._emitters[i] = null;
	                }
	            }
	        }
	        if (this._renderer != null) {
	            this._renderer.stop();
	            this._renderer = null;
	        }
	        this._proton.destroy();
	        this._proton = null;
	        this.removeChilds();
	    };
	    ProtonElement.prototype.createInitializers = function (node, emitter) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            switch (next.nodeName) {
	                case "ImageTarget":
	                    var imageTarget = this.addImageTarget(next);
	                    if (imageTarget != null) {
	                        emitter.addInitialize(imageTarget);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING ImageTarget is null");
	                        }
	                    }
	                    break;
	                case "AnimationTarget":
	                    this.addAnimationTarget(next);
	                    break;
	                case "Radius":
	                    var radius = this.addRadius(next);
	                    if (radius != null) {
	                        emitter.addInitialize(radius);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Radius is null");
	                        }
	                    }
	                    break;
	                case "Mass":
	                    var mass = this.addMass(next);
	                    if (mass != null) {
	                        emitter.addInitialize(mass);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Mass is null");
	                        }
	                    }
	                    break;
	                case "Life":
	                    var life = this.addLife(next);
	                    if (life != null) {
	                        emitter.addInitialize(life);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Life is null");
	                        }
	                    }
	                    break;
	                case "Position":
	                    var position = this.addPosition(next);
	                    if (position != null) {
	                        emitter.addInitialize(position);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Position is null");
	                        }
	                    }
	                    break;
	                case "Velocity":
	                    var velocity = this.addVelocity(next);
	                    if (velocity != null) {
	                        emitter.addInitialize(velocity);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Velocity is null");
	                        }
	                    }
	                    break;
	                default:
	                    if (false) {
	                        this.log("WARNING unknown initializer");
	                    }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ProtonElement.prototype.addImageTarget = function (node) {
	        if (node.hasAttribute("Image")) {
	            var arr = node.getAttribute("Image").split(";");
	            var arrTextures = [];
	            for (var i = 0; i < arr.length; i++) {
	                var resourceId = arr[i];
	                var texture = StageController_1.StageController.getTextureByResourceId(resourceId);
	                if (texture != null) {
	                    arrTextures.push(texture);
	                }
	            }
	            if (arrTextures != null && arrTextures.length > 0) {
	                return new Proton.ImageTarget(arrTextures);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING Image target has no attribute Image");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addAnimationTarget = function (node) {
	        if (node.hasAttribute("Animation") && node.hasAttribute("Frames")) {
	            if (node.hasAttribute("Speed")) {
	                this._animationSpeed = parseFloat(node.getAttribute("Speed"));
	            }
	            if (node.hasAttribute("Loop")) {
	                this._animationLoop = neo_common_1.StringUtils.parseBoolean(node.getAttribute("Loop"));
	            }
	            this._animationName = node.getAttribute("Animation");
	            this._textures = [];
	            for (var i = 0; i < parseInt(node.getAttribute("Frames")); i++) {
	                var val = i < 10 ? "0" + i : i;
	                var texture = PIXI.Texture.fromFrame(node.getAttribute("Animation") + "00" + val);
	                this._textures.push(texture);
	            }
	        }
	    };
	    ProtonElement.prototype.addMass = function (node) {
	        if (node.hasAttribute("Mass")) {
	            var arr = neo_common_1.ArrayUtils.numberArray(node.getAttribute("Mass"));
	            if (arr.length === 3) {
	                return new Proton.Mass(arr[0], arr[1], arr[2]);
	            }
	            else if (arr.length === 2) {
	                return new Proton.Mass(arr[0], arr[1]);
	            }
	            else if (arr.length === 1) {
	                return new Proton.Mass(arr[0]);
	            }
	            else {
	                if (false) {
	                    this.log("WARNING Mass attribute doesnt have parameters");
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING no attribute Mass in Mass initializer");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addRadius = function (node) {
	        if (node.hasAttribute("Radius")) {
	            var arr = neo_common_1.ArrayUtils.numberArray(node.getAttribute("Radius"));
	            if (arr.length === 3) {
	                return new Proton.Radius(arr[0], arr[1], arr[2]);
	            }
	            else if (arr.length === 2) {
	                return new Proton.Radius(arr[0], arr[1]);
	            }
	            else if (arr.length === 1) {
	                return new Proton.Radius(arr[0]);
	            }
	            else {
	                if (false) {
	                    this.log("WARNING Radius attribute doesnt have parameters");
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING no attribute Radius in Radius initializer");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addLife = function (node) {
	        if (node.hasAttribute("Life")) {
	            var arr = neo_common_1.ArrayUtils.numberArray(node.getAttribute("Life"));
	            if (arr.length === 3) {
	                return new Proton.Life(arr[0], arr[1], arr[2]);
	            }
	            else if (arr.length === 2) {
	                return new Proton.Life(arr[0], arr[1]);
	            }
	            else if (arr.length === 1) {
	                return new Proton.Life(arr[0]);
	            }
	            else {
	                if (false) {
	                    this.log("WARNING Life attribute doesnt have parameters");
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING no attribute Life in Life initializer");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addPosition = function (node) {
	        var zone = node.firstElementChild;
	        if (zone != null) {
	            return new Proton.Position(this.getZone(zone));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Position has no zone");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addVelocity = function (node) {
	        var rpan;
	        var thapan;
	        var type;
	        if (node.getAttribute("RPan")) {
	            rpan = neo_common_1.ArrayUtils.numberArray(node.getAttribute("RPan"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING no attribute RPan in Velocity");
	            }
	        }
	        if (node.getAttribute("ThaPan")) {
	            thapan = neo_common_1.ArrayUtils.numberArray(node.getAttribute("ThaPan"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING no attribute ThaPan in Velocity");
	            }
	        }
	        if (node.getAttribute("Type")) {
	            type = node.getAttribute("Type");
	        }
	        if (rpan != null && thapan != null) {
	            var rpanSpan;
	            if (rpan.length === 2) {
	                rpanSpan = new Proton.Span(rpan[0], rpan[1]);
	            }
	            else {
	                rpanSpan = rpan[0];
	            }
	            var thapanSpan;
	            if (thapan.length === 2) {
	                thapanSpan = new Proton.Span(thapan[0], thapan[1]);
	            }
	            else {
	                thapanSpan = thapan[0];
	            }
	            if (type != null) {
	                return new Proton.Velocity(rpanSpan, thapanSpan, type);
	            }
	            else {
	                return new Proton.Velocity(rpanSpan, thapanSpan);
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING missing some attribute in Velocity");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.getZone = function (node) {
	        switch (node.nodeName) {
	            case "RectZone":
	                var rectZoneX;
	                var rectZoneY;
	                var rectZoneWidth;
	                var rectZoneHeight;
	                if (node.hasAttribute("X")) {
	                    rectZoneX = parseInt(node.getAttribute("X"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute X in RectZone");
	                    }
	                }
	                if (node.hasAttribute("Y")) {
	                    rectZoneY = parseInt(node.getAttribute("Y"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Y in RectZone");
	                    }
	                }
	                if (node.hasAttribute("Width")) {
	                    rectZoneWidth = parseInt(node.getAttribute("Width"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Width in RectZone");
	                    }
	                }
	                if (node.hasAttribute("Height")) {
	                    rectZoneHeight = parseInt(node.getAttribute("Height"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Height in RectZone");
	                    }
	                }
	                if (rectZoneX != null && rectZoneY != null && rectZoneWidth != null && rectZoneHeight != null) {
	                    return new Proton.RectZone(rectZoneX, rectZoneY, rectZoneWidth, rectZoneHeight);
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING missing some attributes in RectZone");
	                    }
	                }
	                break;
	            case "LineZone":
	                var lineZoneX;
	                var lineZoneY;
	                var lineZoneWidth;
	                var lineZoneHeight;
	                var lineZoneDirection;
	                if (node.hasAttribute("X")) {
	                    lineZoneX = parseInt(node.getAttribute("X"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute X in LineZone");
	                    }
	                }
	                if (node.hasAttribute("Y")) {
	                    lineZoneY = parseInt(node.getAttribute("Y"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Y in LineZone");
	                    }
	                }
	                if (node.hasAttribute("Width")) {
	                    lineZoneWidth = parseInt(node.getAttribute("Width"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Width in LineZone");
	                    }
	                }
	                if (node.hasAttribute("Height")) {
	                    lineZoneHeight = parseInt(node.getAttribute("Height"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Height in LineZone");
	                    }
	                }
	                if (node.hasAttribute("Direction")) {
	                    lineZoneDirection = node.getAttribute("Direction");
	                }
	                if (lineZoneX != null && lineZoneY != null && lineZoneWidth != null && lineZoneHeight != null) {
	                    if (lineZoneDirection != null) {
	                        return new Proton.LineZone(lineZoneX, lineZoneY, lineZoneWidth, lineZoneHeight, lineZoneDirection);
	                    }
	                    else {
	                        return new Proton.LineZone(lineZoneX, lineZoneY, lineZoneWidth, lineZoneHeight);
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING missing some attributes in LineZone");
	                    }
	                }
	                break;
	            case "CircleZone":
	                var circleZoneX;
	                var circleZoneY;
	                var circleZoneRadius;
	                if (node.hasAttribute("X")) {
	                    circleZoneX = parseInt(node.getAttribute("X"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute X in CircleZone");
	                    }
	                }
	                if (node.hasAttribute("Y")) {
	                    circleZoneY = parseInt(node.getAttribute("Y"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Y in CircleZone");
	                    }
	                }
	                if (node.hasAttribute("Radius")) {
	                    circleZoneRadius = parseInt(node.getAttribute("Radius"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Radius in CircleZone");
	                    }
	                }
	                if (circleZoneX != null && circleZoneY != null && circleZoneRadius != null) {
	                    return new Proton.CircleZone(circleZoneX, circleZoneY, circleZoneRadius);
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING missing some attributes in CircleZone");
	                    }
	                }
	                break;
	            case "PointZone":
	                var pointZoneX = void 0;
	                var pointZoneY = void 0;
	                if (node.hasAttribute("X")) {
	                    pointZoneX = parseInt(node.getAttribute("X"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute X in PointZone");
	                    }
	                }
	                if (node.hasAttribute("Y")) {
	                    pointZoneY = parseInt(node.getAttribute("Y"));
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no attribute Y in PointZone");
	                    }
	                }
	                if (pointZoneX != null && pointZoneY != null) {
	                    return new Proton.PointZone(pointZoneX, pointZoneY);
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING missing some attributes in PointZone");
	                    }
	                }
	                break;
	            case "ImageZone":
	                if (node.hasAttribute("Image")) {
	                    var texture = StageController_1.StageController.getTextureByResourceId(node.getAttribute("Image"));
	                    var particleSprite = new PIXI.Sprite(texture);
	                    var pixelData = StageController_1.StageController.Renderer.extract.pixels(particleSprite);
	                    return new Proton.ImageZone({ data: pixelData, width: particleSprite.width, height: particleSprite.height }, 0, 0);
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING missing some attributes in ImageZone");
	                    }
	                }
	                break;
	            default:
	                if (false) {
	                    this.log("WARNING unknown type zone: " + node.nodeName);
	                }
	        }
	        return null;
	    };
	    ProtonElement.prototype.createBehaviours = function (node, emitter) {
	        var next = node.firstElementChild;
	        while (next != null) {
	            switch (next.nodeName) {
	                case "AlphaDead":
	                    if (next.hasAttribute("Age")) {
	                        emitter.addBehaviour(this.alphaDead(parseFloat(next.getAttribute("Age"))));
	                    }
	                    else {
	                        emitter.addBehaviour(this.alphaDead(1));
	                    }
	                    break;
	                case "ScaleDead":
	                    emitter.addBehaviour(this.scaleDead());
	                    break;
	                case "Alpha":
	                    var alpha = this.addAlpha(next);
	                    if (alpha != null) {
	                        emitter.addBehaviour(alpha);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Alpha is null");
	                        }
	                    }
	                    break;
	                case "Scale":
	                    var scale = this.addScale(next);
	                    if (scale != null) {
	                        emitter.addBehaviour(scale);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Scale is null");
	                        }
	                    }
	                    break;
	                case "Rotate":
	                    var rotate = this.addRotate(next);
	                    if (rotate != null) {
	                        emitter.addBehaviour(rotate);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Rotate is null");
	                        }
	                    }
	                    break;
	                case "Color":
	                    var color = this.addColor(next);
	                    if (color != null) {
	                        emitter.addBehaviour(color);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Color is null");
	                        }
	                    }
	                    break;
	                case "CrossZone":
	                    var crossZone = this.addCrossZone(next);
	                    if (crossZone != null) {
	                        emitter.addBehaviour(crossZone);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING CrossZone is null");
	                        }
	                    }
	                    break;
	                case "RandomDrift":
	                    var randomDrift = this.addRandomDrift(next);
	                    if (randomDrift != null) {
	                        emitter.addBehaviour(randomDrift);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING RandomDrift is null");
	                        }
	                    }
	                    break;
	                case "Gravity":
	                    var gravity = this.addGravity(next);
	                    if (gravity != null) {
	                        emitter.addBehaviour(gravity);
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING Gravity is null");
	                        }
	                    }
	                    break;
	                default:
	                    if (false) {
	                        this.log("WARNING unknown behaviour");
	                    }
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    ProtonElement.prototype.alphaDead = function (age) {
	        var self = this;
	        return {
	            initialize: function (particle) { },
	            applyBehaviour: function (particle) {
	                if (particle.age >= age) {
	                    particle["transform"]["alphaA"] = 1;
	                    particle["transform"]["alphaB"] = 0;
	                }
	                if (particle.age >= particle.life) {
	                    if (particle.sprite != null) {
	                        if (self._textures != null && self._textures.length > 0) {
	                            ProtonElement.Pool[self._animationName].push(particle.sprite);
	                        }
	                        else {
	                            ProtonElement.Pool[particle.target.textureCacheIds[0]].push(particle.sprite);
	                        }
	                        self.super2.removeChild(particle.sprite);
	                    }
	                    particle.sprite = null;
	                    particle.dead = true;
	                    particle = null;
	                }
	            },
	        };
	    };
	    ProtonElement.prototype.scaleDead = function () {
	        var self = this;
	        return {
	            initialize: function (particle) {
	                particle.scale = 0;
	            },
	            applyBehaviour: function (particle) {
	                if (particle.energy >= 2 / 3) {
	                    particle.scale = particle.scale * (1 - particle.energy) * 3;
	                }
	                else if (particle.energy <= 1 / 3) {
	                    particle.scale = particle.scale * (particle.energy * 3);
	                }
	                if (particle.scale < 0) {
	                    if (particle.sprite != null) {
	                        if (this._textures != null && this._textures.length > 0) {
	                            ProtonElement.Pool[this._animationName].push(particle.sprite);
	                        }
	                        else {
	                            ProtonElement.Pool[particle.target.textureCacheIds[0]].push(particle.sprite);
	                        }
	                        self.super2.removeChild(particle.sprite);
	                    }
	                    particle.sprite = null;
	                    particle.dead = true;
	                    particle = null;
	                }
	            },
	        };
	    };
	    ProtonElement.prototype.addAlpha = function (node) {
	        var start;
	        var end;
	        var life;
	        if (node.hasAttribute("Start")) {
	            start = parseFloat(node.getAttribute("Start"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Alpha has no attribute Start");
	            }
	        }
	        if (node.hasAttribute("End")) {
	            end = parseFloat(node.getAttribute("End"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Alpha has no attribute End");
	            }
	        }
	        if (node.hasAttribute("Life")) {
	            life = new Proton.Life(parseFloat(node.getAttribute("Life")));
	        }
	        if (start != null && end != null) {
	            if (life != null) {
	                return new Proton.Alpha(start, end, life);
	            }
	            else {
	                return new Proton.Alpha(start, end);
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING Alpha has no Start or End attribute");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addScale = function (node) {
	        var start;
	        var end;
	        var life;
	        if (node.hasAttribute("Start")) {
	            start = neo_common_1.ArrayUtils.numberArray(node.getAttribute("Start"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Scale has no attribute Start");
	            }
	        }
	        if (node.hasAttribute("End")) {
	            end = neo_common_1.ArrayUtils.numberArray(node.getAttribute("End"));
	        }
	        if (node.hasAttribute("Life")) {
	            life = new Proton.Life(parseFloat(node.getAttribute("Life")));
	        }
	        if (start != null) {
	            var startSpan;
	            if (start.length === 2) {
	                startSpan = new Proton.Span(start[0], start[1]);
	            }
	            else {
	                startSpan = start[0];
	            }
	            var endSpan;
	            if (end != null) {
	                if (end.length === 2) {
	                    endSpan = new Proton.Span(end[0], end[1]);
	                }
	                else {
	                    endSpan = end[0];
	                }
	            }
	            if (startSpan != null && endSpan != null && life != null) {
	                return new Proton.Scale(startSpan, endSpan, life);
	            }
	            else if (startSpan != null && endSpan != null) {
	                return new Proton.Scale(startSpan, endSpan);
	            }
	            else {
	                return new Proton.Scale(startSpan);
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING Scale has no Start or End attribute");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addRotate = function (node) {
	        var start;
	        var end;
	        var style;
	        if (node.hasAttribute("Start")) {
	            start = neo_common_1.ArrayUtils.numberArray(node.getAttribute("Start"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Rotate has no attribute Start");
	            }
	        }
	        if (node.hasAttribute("End")) {
	            end = neo_common_1.ArrayUtils.numberArray(node.getAttribute("End"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Rotate has no attribute End");
	            }
	        }
	        if (node.hasAttribute("Style")) {
	            style = node.getAttribute("Style");
	        }
	        else {
	            if (false) {
	                this.log("WARNING Style has no attribute End");
	            }
	        }
	        if (start != null && end != null && style != null) {
	            var startSpan;
	            if (start.length === 2) {
	                startSpan = new Proton.Span(start[0], start[1]);
	            }
	            else {
	                startSpan = start[0];
	            }
	            var endSpan;
	            if (end.length === 2) {
	                endSpan = new Proton.Span(end[0], end[1]);
	            }
	            else {
	                endSpan = start[0];
	            }
	            return new Proton.Rotate(startSpan, endSpan, style);
	        }
	        else {
	            if (false) {
	                this.log("WARNING Rotate has no Start or End attribute");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addRandomDrift = function (node) {
	        var driftX;
	        var driftY;
	        var delay;
	        if (node.hasAttribute("DriftX")) {
	            driftX = parseFloat(node.getAttribute("DriftX"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING RandomDrift has no attribute DriftX");
	            }
	        }
	        if (node.hasAttribute("DriftY")) {
	            driftY = parseFloat(node.getAttribute("DriftY"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING RandomDrift has no attribute DriftY");
	            }
	        }
	        if (node.hasAttribute("Delay")) {
	            delay = parseFloat(node.getAttribute("Delay"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING RandomDrift has no attribute Delay");
	            }
	        }
	        if (driftX != null && driftY != null && delay != null) {
	            return new Proton.RandomDrift(driftX, driftY, delay);
	        }
	        else {
	            if (false) {
	                this.log("WARNING RandomDrift has no valid attributes");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addGravity = function (node) {
	        var gravity;
	        if (node.hasAttribute("Gravity")) {
	            gravity = parseFloat(node.getAttribute("Gravity"));
	        }
	        else {
	            if (false) {
	                this.log("WARNING Gravity has no attribute Gravity");
	            }
	        }
	        if (gravity != null) {
	            return new Proton.Gravity(gravity);
	        }
	        else {
	            if (false) {
	                this.log("WARNING Gravity has no valid attributes");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addColor = function (node) {
	        var i;
	        var arr;
	        var endArr;
	        var color = [];
	        var endColor = [];
	        if (node.hasAttribute("Color")) {
	            arr = node.getAttribute("Color").split(";");
	            for (i = 0; i < arr.length; i++) {
	                color.push(neo_common_1.StringUtils.hexColor(arr[i]));
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING Color has no attribute Color");
	            }
	        }
	        if (node.hasAttribute("EndColor")) {
	            endArr = node.getAttribute("EndColor").split(";");
	            for (i = 0; i < endArr.length; i++) {
	                endColor.push(neo_common_1.StringUtils.hexColor(endArr[i]));
	            }
	        }
	        if (color.length > 0) {
	            if (endColor.length > 0) {
	                return new Proton.Color(color, endColor);
	            }
	            else {
	                return new Proton.Color(color);
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING Color has no Color attribute");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.addCrossZone = function (node) {
	        var zone;
	        var type;
	        if (node.firstElementChild != null) {
	            zone = this.getZone(node.firstElementChild);
	        }
	        else {
	            if (false) {
	                this.log("WARNING no zone in CrossZone");
	            }
	        }
	        if (node.hasAttribute("Type")) {
	            type = node.getAttribute("Type");
	        }
	        if (zone != null) {
	            if (type != null) {
	                return new Proton.CrossZone(zone, type);
	            }
	            else {
	                return new Proton.CrossZone(zone);
	            }
	        }
	        else {
	            if (false) {
	                this.log("WARNING no zone in CrossZone");
	            }
	        }
	        return null;
	    };
	    ProtonElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    ProtonElement.prototype.clone = function () {
	        var element = new ProtonElement();
	        element.super2.position.x = this.super2.position.x;
	        element.super2.position.y = this.super2.position.y;
	        element.super2.pivot.x = this.super2.pivot.x;
	        element.super2.pivot.y = this.super2.pivot.y;
	        element.super2.scale.x = this.super2.scale.x;
	        element.super2.scale.y = this.super2.scale.y;
	        element.super2.visible = this.super2.visible;
	        var node = document.createElement("particle");
	        node.setAttribute(ProtonElementAttributes.STYLE_2, this._styleName);
	        if (this._blendMode != null) {
	            node.setAttribute(ProtonElementAttributes.BLEND_MODE, this._blendMode.toString());
	        }
	        element.create(node);
	        element.super2._markAsCloned();
	        return element;
	    };
	    ProtonElement.Pool = {};
	    ProtonElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ProtonElement);
	    return ProtonElement;
	}(AnimationFrame_1.AnimationFrameBaseElement));
	exports.ProtonElement = ProtonElement;
	var ProtonElementAttributes = {
	    EMIT: "Emit",
	    TINT: "Tint",
	    BLEND_MODE: "BlendMode",
	    STYLE: "Style",
	    STYLE_2: "Style2",
	    START: "Start",
	    STOPPING: "Stopping",
	    STOP: "Stop",
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var ComponentTypes_1 = __webpack_require__(14);
	var FrameTimer_1 = __webpack_require__(9);
	var ImageTextElement = (function (_super) {
	    __extends(ImageTextElement, _super);
	    function ImageTextElement() {
	        _super.call(this);
	        this.fontScale = 1;
	        this.textTimer = FrameTimer_1.CreateFrameTimer("timer");
	        this.textAlign = exports.ImageTextElementAttributes.TEXT_ALIGN_VALUE.LEFT;
	        this.textBaseline = exports.ImageTextElementAttributes.TEXT_BASELINE_VALUE.TOP;
	        this.text = "";
	    }
	    ImageTextElement.prototype.createByNode = function (node) {
	        if (node.hasAttribute(exports.ImageTextElementAttributes.FONT_SCALE)) {
	            this.fontScale = parseFloat(node.getAttribute(exports.ImageTextElementAttributes.FONT_SCALE));
	            if (this.bitmapText) {
	                this.bitmapText.scale.x = this.fontScale;
	                this.bitmapText.scale.y = this.fontScale;
	            }
	        }
	        _super.prototype.createByNode.call(this, node);
	        if (this.bitmapText == null) {
	            if (node.hasAttribute(exports.ImageTextElementAttributes.FONT)) {
	                if (node.hasAttribute(exports.ImageTextElementAttributes.TEXT)) {
	                    this.text = node.getAttribute(exports.ImageTextElementAttributes.TEXT);
	                }
	                this.font = node.getAttribute(exports.ImageTextElementAttributes.FONT);
	                this.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
	                this.bitmapText.scale.x = this.fontScale;
	                this.bitmapText.scale.y = this.fontScale;
	                this.addChild(this.bitmapText);
	            }
	        }
	    };
	    ImageTextElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.ImageTextElementAttributes.TEXT)) {
	            if (node.hasAttribute(exports.ImageTextElementAttributes.DELAY)) {
	                this.textTimer.once(FrameTimer_1.FrameTimerEvents.Complete, this.setText.bind(this, node.getAttribute(exports.ImageTextElementAttributes.TEXT)));
	                this.textTimer.start(parseInt(node.getAttribute(exports.ImageTextElementAttributes.DELAY)));
	            }
	            else {
	                this.setText(node.getAttribute(exports.ImageTextElementAttributes.TEXT));
	            }
	        }
	        if (node.hasAttribute(exports.ImageTextElementAttributes.TEXT_ALIGN)) {
	            this.textAlign = node.getAttribute(exports.ImageTextElementAttributes.TEXT_ALIGN);
	            this.realign();
	        }
	        if (node.hasAttribute(exports.ImageTextElementAttributes.TEXT_BASELINE)) {
	            this.textBaseline = node.getAttribute(exports.ImageTextElementAttributes.TEXT_BASELINE);
	            this.realign();
	        }
	        if (node.hasAttribute(exports.ImageTextElementAttributes.TINT)) {
	            var val = parseInt(node.getAttribute(exports.ImageTextElementAttributes.TINT), 16);
	            if (!isNaN(val)) {
	                this.bitmapText.tint = val;
	            }
	        }
	        if (node.hasAttribute(exports.ImageTextElementAttributes.FONT_SCALE)) {
	            this.fontScale = parseFloat(node.getAttribute(exports.ImageTextElementAttributes.FONT_SCALE));
	            this.bitmapText.scale.x = this.fontScale;
	            this.bitmapText.scale.y = this.fontScale;
	        }
	    };
	    ImageTextElement.prototype.realign = function () {
	        switch (this.textAlign) {
	            case exports.ImageTextElementAttributes.TEXT_ALIGN_VALUE.RIGHT:
	                this.bitmapText.position.x = -this.bitmapText.width;
	                break;
	            case exports.ImageTextElementAttributes.TEXT_ALIGN_VALUE.CENTER:
	                this.bitmapText.position.x = -this.bitmapText.width * 0.5;
	                break;
	            default:
	                this.bitmapText.position.x = 0;
	                break;
	        }
	        switch (this.textBaseline) {
	            case exports.ImageTextElementAttributes.TEXT_BASELINE_VALUE.BOTTOM:
	                this.bitmapText.position.y = -this.bitmapText.height;
	                break;
	            case exports.ImageTextElementAttributes.TEXT_BASELINE_VALUE.MIDDLE:
	                this.bitmapText.position.y = -this.bitmapText.height * 0.5;
	                break;
	            default:
	                this.bitmapText.position.y = 0;
	                break;
	        }
	        this.bitmapText.scale.x = this.fontScale;
	        this.bitmapText.scale.y = this.fontScale;
	    };
	    ImageTextElement.prototype.setText = function (value) {
	        this.removeChild(this.bitmapText);
	        this.text = value;
	        this.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
	        this.addChild(this.bitmapText);
	        this.realign();
	    };
	    ImageTextElement.prototype.clone = function () {
	        var element = new ImageTextElement();
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.font = this.font;
	        element.fontScale = this.fontScale;
	        element.text = this.text;
	        element.textAlign = this.textAlign;
	        element.textBaseline = this.textBaseline;
	        element.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
	        element.addChild(element.bitmapText);
	        element.realign();
	        element.markAsCloned();
	        return element;
	    };
	    ImageTextElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ImageTextElement);
	    return ImageTextElement;
	}(BaseElement_1.BaseElement));
	exports.ImageTextElement = ImageTextElement;
	exports.ImageTextElementAttributes = {
	    TEXT: "Text",
	    DELAY: "Delay",
	    FONT: "Font",
	    FONT_SCALE: "FontScale",
	    TEXT_ALIGN: "TextAlign",
	    TEXT_ALIGN_VALUE: {
	        LEFT: "left",
	        CENTER: "center",
	        RIGHT: "right",
	    },
	    TEXT_BASELINE: "TextBaseline",
	    TEXT_BASELINE_VALUE: {
	        TOP: "top",
	        MIDDLE: "middle",
	        BOTTOM: "bottom",
	    },
	    TINT: "Tint",
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Reel_1 = __webpack_require__(88);
	var Symbol_1 = __webpack_require__(89);
	var CustomUtils_1 = __webpack_require__(22);
	var Tweens_1 = __webpack_require__(15);
	var BaseView_1 = __webpack_require__(86);
	var ReelExtended = (function (_super) {
	    __extends(ReelExtended, _super);
	    function ReelExtended() {
	        _super.call(this);
	        this.customData = {};
	        this.valuesStrip = [];
	        this.respinStrip = [];
	        this.isBonusReel = false;
	    }
	    ReelExtended.prototype.setValuesStrip = function (strip) {
	        this.valuesStrip = strip;
	    };
	    ReelExtended.prototype.setRespinStrip = function (respinStrip) {
	        this.respinStrip = respinStrip;
	    };
	    ReelExtended.prototype.setBaseRespinStrip = function (isRespin) {
	        if (isRespin) {
	            this.setStrip(this.respinStrip);
	        }
	        else {
	            this.setStrip(this.originalStrip);
	        }
	    };
	    ReelExtended.prototype.updateReelSettings = function (previousReel, nextReel, startDelay, stopDelay, isBonusReel) {
	        if (isBonusReel === void 0) { isBonusReel = false; }
	        this.previousReel = previousReel;
	        this.nextReel = nextReel;
	        this.startDelay = startDelay;
	        this.stopDelay = stopDelay;
	        this.isBonusReel = isBonusReel;
	    };
	    ReelExtended.prototype.showSymbols = function (useTransform) {
	        if (useTransform === void 0) { useTransform = false; }
	        this.shouldBeStopping = false;
	        this.isStopping = false;
	        this.stoppingCounter = 0;
	        this.isTeasing = false;
	        this.teasingSymbols = [];
	        this.x = this.positionX;
	        this.y = this.positionY;
	        if (!useTransform) {
	            while (this.currentSymbols.length > 0) {
	                this.returnSymbol(this.currentSymbols.pop());
	            }
	        }
	        var bottomSymbols = [];
	        var topSymbols = [];
	        for (var i = 0; i < this.symbolBottomCount + this.symbolCount + this.symbolTopCount; i++) {
	            var symbolId = void 0;
	            var symbolCase = void 0;
	            var symbolValue = 0;
	            var useMultiplier = true;
	            if (i < this.symbolBottomCount) {
	                symbolId =
	                    this.strip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolValue =
	                    this.valuesStrip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolCase = i === this.symbolBottomCount - 1 ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            else if (i < this.symbolBottomCount + this.symbolCount) {
	                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - i - 1];
	                if (this.data.customData) {
	                    if (this.isBonusReel) {
	                        symbolValue = this.data.customData;
	                    }
	                    else {
	                        symbolValue = this.data.customData[this.symbolBottomCount + this.symbolCount - i - 1];
	                    }
	                }
	                symbolCase = Symbol_1.Symbol.CaseRotation;
	                useMultiplier = false;
	            }
	            else {
	                symbolId =
	                    this.strip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolValue =
	                    this.valuesStrip[(this.data.index + this.symbolBottomCount + this.symbolCount - i - 1 + this.strip.length) %
	                        this.strip.length];
	                symbolCase = i === this.symbolBottomCount + this.symbolCount ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            if (!useTransform) {
	                this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase, symbolValue, useMultiplier));
	            }
	            else {
	                if (i < this.symbolBottomCount) {
	                    bottomSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase, symbolValue, useMultiplier));
	                }
	                else if (i > this.symbolBottomCount + this.symbolCount - 1) {
	                    topSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase, symbolValue, useMultiplier));
	                }
	            }
	        }
	        if (useTransform) {
	            while (bottomSymbols.length > 0) {
	                this.currentSymbols.push(bottomSymbols.shift());
	            }
	            while (topSymbols.length > 0) {
	                this.currentSymbols.unshift(topSymbols.shift());
	            }
	        }
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            if (this.currentSymbols[i] == null) {
	                continue;
	            }
	            this.addChild(this.currentSymbols[i]);
	            var symbol = this.currentSymbols[i];
	            symbol.x = -symbol.offsetX;
	            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
	            if (BaseView_1.BaseView.isRespin) {
	                var symbolCase = symbol.getCurrentCase();
	                if (symbol.id === BaseView_1.BaseView.stickySymbolId) {
	                    symbolCase = "STICKY_NORMAL";
	                }
	                else if (symbolCase === Symbol_1.Symbol.CaseBlur) {
	                    symbolCase = "TEASING_BLUR";
	                }
	                else {
	                    symbolCase = "TEASING_ROTATION";
	                }
	                symbol.goToCase(symbolCase);
	            }
	        }
	    };
	    ReelExtended.prototype.updateReel = function () {
	        var popSymbol = this.currentSymbols.pop();
	        if (popSymbol != null) {
	            this.returnSymbol(popSymbol);
	        }
	        if (this.shouldBeStopping && !this.isStopping) {
	            if (this.previousReel === null) {
	                this.isStopping = true;
	            }
	            else if (this.previousReel.isStopping) {
	                this.isStopping = true;
	            }
	        }
	        this.stripIndex = (this.stripIndex - 1 + this.strip.length) % this.strip.length;
	        var symbolId = this.strip[this.stripIndex];
	        var symbolCase = Symbol_1.Symbol.CaseBlur;
	        var symbolValue = this.valuesStrip[this.stripIndex];
	        var useMultiplier = true;
	        if (this.isStopping) {
	            if (this.stoppingCounter < this.symbolBottomCount) {
	                symbolId =
	                    this.strip[(this.data.index +
	                        this.symbolBottomCount +
	                        this.symbolCount -
	                        this.stoppingCounter -
	                        1 +
	                        this.strip.length) %
	                        this.strip.length];
	                symbolCase =
	                    this.stoppingCounter === this.symbolBottomCount - 1 ? Symbol_1.Symbol.CaseRotation : Symbol_1.Symbol.CaseBlur;
	            }
	            else if (this.stoppingCounter < this.symbolBottomCount + this.symbolCount) {
	                symbolId = this.data.symbols[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
	                if (this.data.customData) {
	                    if (this.isBonusReel) {
	                        symbolValue = this.data.customData;
	                    }
	                    else {
	                        symbolValue =
	                            this.data.customData[this.symbolBottomCount + this.symbolCount - this.stoppingCounter - 1];
	                    }
	                }
	                symbolCase = Symbol_1.Symbol.CaseRotation;
	                useMultiplier = false;
	            }
	            else {
	                symbolId =
	                    this.strip[(this.data.index +
	                        this.symbolBottomCount +
	                        this.symbolCount -
	                        this.stoppingCounter -
	                        1 +
	                        this.strip.length) %
	                        this.strip.length];
	                symbolCase =
	                    this.stoppingCounter === this.symbolBottomCount + this.symbolCount
	                        ? Symbol_1.Symbol.CaseRotation
	                        : Symbol_1.Symbol.CaseBlur;
	            }
	            this.stoppingCounter++;
	        }
	        this.currentSymbols.unshift(this.getSymbol(symbolId - 1, symbolCase, symbolValue, useMultiplier));
	        this.addChild(this.currentSymbols[0]);
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            if (this.currentSymbols[i] == null) {
	                continue;
	            }
	            var symbol = this.currentSymbols[i];
	            symbol.x = -symbol.offsetX;
	            symbol.y = this.symbolHeight * (i - this.symbolTopCount) - symbol.offsetY;
	            var symbolCase_1 = symbol.getCurrentCase();
	            if ((ReelExtended.Tease >= 0 || BaseView_1.BaseView.isRespin) &&
	                (symbolCase_1 === Symbol_1.Symbol.CaseBlur || symbolCase_1 === Symbol_1.Symbol.CaseRotation)) {
	                if (symbol.id === BaseView_1.BaseView.stickySymbolId) {
	                    symbolCase_1 = "STICKY_NORMAL";
	                }
	                else {
	                    symbolCase_1 = "TEASING_" + symbolCase_1;
	                }
	                symbol.goToCase(symbolCase_1);
	            }
	        }
	        if (this.isStopping &&
	            this.stoppingCounter === this.symbolBottomCount + this.symbolCount + this.symbolTopCount) {
	            this.spinPostRoll();
	        }
	        else {
	            this.spinRoll();
	        }
	    };
	    ReelExtended.prototype.spinStart = function () {
	        this.skipSpin = false;
	        if (this.hasBonusSymbol()) {
	            this.skipReelSpin();
	        }
	        else {
	            _super.prototype.spinStart.call(this);
	        }
	    };
	    ReelExtended.prototype.spinStop = function (force, customDelay) {
	        if (force === void 0) { force = false; }
	        if (customDelay === void 0) { customDelay = 0; }
	        if (!this.skipSpin) {
	            _super.prototype.spinStop.call(this, force, customDelay);
	        }
	    };
	    ReelExtended.prototype.spinTease = function (symbols, customDelay) {
	        if (customDelay === void 0) { customDelay = 0; }
	        if (!this.skipSpin) {
	            _super.prototype.spinTease.call(this, symbols, customDelay);
	        }
	    };
	    ReelExtended.prototype.getSymbol = function (symbolId, symbolCase, amount, useMultiplier) {
	        if (amount === void 0) { amount = 0; }
	        if (useMultiplier === void 0) { useMultiplier = true; }
	        var isBonusSymbol = CustomUtils_1.CustomUtils.isBonusSymbol(symbolId + 1);
	        if (this.isBonusReel && !isBonusSymbol) {
	            symbolId = CustomUtils_1.CustomUtils.SymbolEmpty - 1;
	        }
	        return _super.prototype.getSymbol.call(this, symbolId, symbolCase);
	    };
	    ReelExtended.prototype.spinComplete = function () {
	        Tweens_1.Tweens.removeTweens(this, "position");
	        while (this.currentSymbols.length > 0) {
	            var symbol = this.currentSymbols.pop();
	            if (symbol != null) {
	                this.returnSymbol(symbol);
	            }
	        }
	        this.emit(Reel_1.Reel.ReelStopped, this.index);
	    };
	    ReelExtended.prototype.skipReelSpin = function () {
	        this.shouldBeStopping = true;
	        this.isStopping = true;
	        this.skipSpin = true;
	        this.spinComplete();
	    };
	    ReelExtended.prototype.hasBonusSymbol = function () {
	        return ((this.data.transform != null && CustomUtils_1.CustomUtils.isBonusSymbol(this.data.transform[0])) ||
	            (this.data.overlay != null && CustomUtils_1.CustomUtils.isBonusSymbol(this.data.overlay[0])));
	    };
	    ReelExtended.prototype.setStopDelay = function (stopDelay) {
	        this.stopDelay = stopDelay;
	    };
	    ReelExtended.prototype.setStartDelay = function (startDelay) {
	        this.startDelay = startDelay;
	    };
	    ReelExtended.prototype.isSkipped = function () {
	        return this.skipSpin;
	    };
	    ReelExtended.prototype.setStrip = function (strip) {
	        this.strip = strip;
	    };
	    ReelExtended.prototype.addCustomData = function (data) {
	        this.customData[Object.keys(data)[0]] = data[Object.keys(data)[0]];
	    };
	    ReelExtended.prototype.getCustomData = function (name) {
	        if (this.customData[name] != null) {
	            return this.customData[name];
	        }
	        return null;
	    };
	    ReelExtended.prototype.sortChildrenByZindex = function (holder) {
	        if (!neo_common_1.Utils.isNullOrUndefined(holder)) {
	            holder.children
	                .sort(function (a, b) {
	                a.x = a.x || 0;
	                b.x = b.x || 0;
	                return a.x - b.x;
	            })
	                .sort(function (a, b) {
	                a.y = a.y || 0;
	                b.y = b.y || 0;
	                return a.y - b.y;
	            })
	                .sort(function (a, b) {
	                if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
	                    a.zIndex = a.zIndex || 0;
	                    b.zIndex = b.zIndex || 0;
	                    return a.zIndex - b.zIndex;
	                }
	                return 0;
	            });
	        }
	    };
	    ReelExtended.TeaseingSymbols = [];
	    ReelExtended.Tease = -1;
	    ReelExtended = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ReelExtended);
	    return ReelExtended;
	}(Reel_1.Reel));
	exports.ReelExtended = ReelExtended;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var Payline_1 = __webpack_require__(102);
	var PaylinesDefinitions_1 = __webpack_require__(103);
	var Symbol_1 = __webpack_require__(89);
	var ComponentTypes_1 = __webpack_require__(14);
	var Configuration_1 = __webpack_require__(57);
	var ContainerElement_1 = __webpack_require__(82);
	var TimelineElement_1 = __webpack_require__(104);
	var FrameTimer_1 = __webpack_require__(9);
	var Languages_1 = __webpack_require__(28);
	var BetManager_1 = __webpack_require__(25);
	var ImageTextCounterElement_1 = __webpack_require__(105);
	var AppContext_1 = __webpack_require__(5);
	var PlayList_1 = __webpack_require__(33);
	var WinAnimator = (function (_super) {
	    __extends(WinAnimator, _super);
	    function WinAnimator() {
	        _super.apply(this, arguments);
	    }
	    WinAnimator.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(exports.WinAnimatorAttributes.CONFIGS)) {
	            var configs = node.getAttribute(exports.WinAnimatorAttributes.CONFIGS).split(";");
	            for (var i = 0; i < configs.length; i++) {
	                this.configure(Configuration_1.Configuration.Configurations[configs[i]]);
	            }
	        }
	    };
	    WinAnimator.prototype.configure = function (node) {
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_COUNT)) {
	            this.reelCount = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_COUNT));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_X)) {
	            this.reelX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_X));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_Y)) {
	            this.reelY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.REEL_Y));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT)) {
	            this.symbolCount = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.VISIBLE_SYMBOL_COUNT));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_WIDTH)) {
	            this.symbolWidth = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_WIDTH));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_HEIGHT)) {
	            this.symbolHeight = parseInt(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.SYMBOL_HEIGHT));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.WINS_MULTIPLIERS)) {
	            this.multipliers = neo_common_1.ArrayUtils.numberArray(node.getAttribute(Configuration_1.GeneralConfigurationAttributes.WINS_MULTIPLIERS));
	        }
	        if (node.hasAttribute(Configuration_1.GeneralConfigurationAttributes.WINS_ANIMATIONS)) {
	            this.animationNames = node.getAttribute(Configuration_1.GeneralConfigurationAttributes.WINS_ANIMATIONS).split(";");
	        }
	    };
	    WinAnimator.prototype.initialize = function (symbols, paylines, noWinSymbolsContainer, symbolsContainer) {
	        this.createTimer();
	        this.createSymbols(symbols, noWinSymbolsContainer, symbolsContainer);
	        this.createPaylines(paylines);
	        this.createAnimations();
	    };
	    WinAnimator.prototype.onReelStopped = function (reelsData, reelIndex, reelsTransition) {
	        this.currentReels = reelsData;
	        for (var i = 0; i < reelsData[reelIndex].symbols.length; i++) {
	            this.removeCurrentSymbol(reelIndex, i);
	        }
	        for (var i = reelsData[reelIndex].symbols.length - 1; i >= 0; i--) {
	            this.addCurrentSymbol(reelIndex, i);
	        }
	    };
	    WinAnimator.prototype.showSymbols = function (reelsData) {
	        this.currentReels = reelsData;
	        for (var i = 0; i < reelsData.length; i++) {
	            for (var j = 0; j < reelsData[i].symbols.length; j++) {
	                this.removeCurrentSymbol(i, j);
	            }
	        }
	        for (var i = 0; i < reelsData.length; i++) {
	            for (var j = reelsData[i].symbols.length - 1; j >= 0; j--) {
	                this.addCurrentSymbol(i, j);
	            }
	        }
	    };
	    WinAnimator.prototype.showWins = function (wins, win) {
	        this.currentWins = wins;
	        this.currentWin = win;
	        this.resetAnimations();
	        if (wins != null && wins.length > 0) {
	            this.currentMultiplierIndex = 0;
	            for (var i = 0; i < this.multipliers.length; i++) {
	                if (this.currentWin / BetManager_1.BetManager.Bet >= this.multipliers[i]) {
	                    this.currentMultiplierIndex = i;
	                }
	            }
	            if (!this.showCustomWin()) {
	                this.showFirstWins();
	            }
	            return this.currentMultiplierIndex >= 3;
	        }
	        else {
	            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
	            return false;
	        }
	    };
	    WinAnimator.prototype.showCustomWin = function () {
	        return false;
	    };
	    WinAnimator.prototype.showFirstWins = function () {
	        this.allSymbolsGoToCase(Symbol_1.Symbol.CaseNowin, true);
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseWin, false);
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseWin);
	        }
	        this.startAnimation();
	    };
	    WinAnimator.prototype.finishFirstWins = function () {
	        this.emit(WinAnimator.FinishWinAnimator);
	        this.currentCycle = 0;
	        this.cycleWins();
	    };
	    WinAnimator.prototype.showInitWins = function (wins, win) {
	        this.currentWins = wins;
	        this.currentWin = win;
	        this.resetAnimations();
	        if (wins != null && wins.length > 0) {
	            this.showCustomInitWin();
	            this.showFirstInitWins();
	            this.finishFirstInitWins();
	        }
	        else {
	            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
	        }
	    };
	    WinAnimator.prototype.showCustomInitWin = function () { };
	    WinAnimator.prototype.showFirstInitWins = function () {
	        this.allSymbolsGoToCase(Symbol_1.Symbol.CaseNowin, true);
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseWin, false);
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseWin);
	        }
	    };
	    WinAnimator.prototype.finishFirstInitWins = function () {
	        this.currentCycle = 0;
	        this.cycleWins();
	    };
	    WinAnimator.prototype.cycleWins = function () {
	        if (this.currentWins == null) {
	            return;
	        }
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        PlayList_1.PlayList.play("SND_BaseWinline");
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseNormal);
	        }
	        this.winSymbolsGoToCase(this.currentCycle, Symbol_1.Symbol.CaseCycle, true);
	        this.winPaylineGoToCase(this.currentCycle, Payline_1.Payline.CaseCycle);
	        this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;
	        this.startTimer(WinAnimator.CycleWins, this.getCycleWinsDelay());
	    };
	    WinAnimator.prototype.getCycleWinsDelay = function () {
	        return 120;
	    };
	    WinAnimator.prototype.reset = function (showLastSymbols) {
	        this.stopTimer();
	        if (showLastSymbols) {
	            this.allSymbolsGoToReset();
	        }
	        else {
	            this.allSymbolsGoToCase(Symbol_1.Symbol.CaseEmpty, false);
	        }
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNormal);
	        if (showLastSymbols) {
	            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
	        }
	        this.value.visible = false;
	        var lastMultiplierIndex = this.currentMultiplierIndex;
	        this.currentMultiplierIndex = -1;
	        if (this.currentAnimationIndex != null) {
	            if (this.currentAnimationFinished) {
	                this.resetAnimations();
	                this.currentWins = null;
	                this.currentWin = null;
	                return false;
	            }
	            else {
	                this.stopAnimation();
	                this.currentWins = null;
	                this.currentWin = null;
	                return lastMultiplierIndex >= 3;
	            }
	        }
	        else {
	            this.currentWins = null;
	            this.currentWin = null;
	            return lastMultiplierIndex >= 3;
	        }
	    };
	    WinAnimator.prototype.createTimer = function () {
	        this.timerStatus = "";
	        this.timer = FrameTimer_1.CreateFrameTimer("timer");
	        this.timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.onTimerComplete.bind(this));
	    };
	    WinAnimator.prototype.startTimer = function (status, duration) {
	        this.timerStatus = status;
	        this.timer.start(duration);
	    };
	    WinAnimator.prototype.stopTimer = function () {
	        if (this.timer != null) {
	            this.timer.stop();
	        }
	    };
	    WinAnimator.prototype.resetTimer = function () {
	        this.stopTimer();
	        if (!this.currentAnimationFinished) {
	            this.stopAnimation();
	        }
	    };
	    WinAnimator.prototype.onTimerComplete = function () {
	        this.timer.stop();
	        switch (this.timerStatus) {
	            case WinAnimator.Idle:
	                this.idle();
	                break;
	            case WinAnimator.CycleWins:
	                this.cycleWins();
	                break;
	        }
	    };
	    WinAnimator.prototype.createSymbols = function (symbols, noWinSymbolsContainer, symbolsContainer) {
	        this.symbols = symbols;
	        if (noWinSymbolsContainer != null) {
	            this.noWinSymbolsContainer = noWinSymbolsContainer;
	        }
	        else {
	            this.noWinSymbolsContainer = new ContainerElement_1.ContainerElement();
	            this.noWinSymbolsContainer.name = "NoWinSymbols";
	            this.addChild(this.noWinSymbolsContainer);
	        }
	        if (symbolsContainer != null) {
	            this.symbolsContainer = symbolsContainer;
	        }
	        else {
	            this.symbolsContainer = new ContainerElement_1.ContainerElement();
	            this.symbolsContainer.name = "Symbols";
	            this.addChild(this.symbolsContainer);
	        }
	        this.currentSymbols = [];
	        for (var i = 0; i < this.reelCount; i++) {
	            this.currentSymbols.push([]);
	            for (var j = 0; j < this.symbolCount; j++) {
	                this.currentSymbols[i].push(null);
	            }
	        }
	    };
	    WinAnimator.prototype.addCurrentSymbol = function (reelIndex, symbolIndex) {
	        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
	            var id = this.currentReels[reelIndex].symbols[symbolIndex];
	            var symbol = this.symbols.getSymbol(id - 1, Symbol_1.Symbol.CaseNormal);
	            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
	            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;
	            this.symbolsContainer.addChild(symbol);
	            this.currentSymbols[reelIndex][symbolIndex] = symbol;
	        }
	    };
	    WinAnimator.prototype.removeCurrentSymbol = function (reelIndex, symbolIndex) {
	        if (this.currentSymbols[reelIndex][symbolIndex] !== null) {
	            this.symbols.returnSymbol(this.currentSymbols[reelIndex][symbolIndex]);
	            this.currentSymbols[reelIndex][symbolIndex] = null;
	        }
	    };
	    WinAnimator.prototype.allSymbolsGoToReset = function () {
	        var caseType = Symbol_1.Symbol.CaseNormal;
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            for (var j = this.currentSymbols[i].length - 1; j >= 0; j--) {
	                var symbol = this.currentSymbols[i][j];
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    var currentCaseType = symbol.getCurrentCase();
	                    if (caseType !== currentCaseType && currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle) === -1) {
	                        symbol.goToCase(caseType);
	                    }
	                    this.symbolsContainer.addChild(symbol);
	                }
	            }
	        }
	    };
	    WinAnimator.prototype.allSymbolsGoToCase = function (caseType, noWin) {
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            for (var j = this.currentSymbols[i].length - 1; j >= 0; j--) {
	                var symbol = this.currentSymbols[i][j];
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    symbol.goToCase(caseType);
	                    if (noWin) {
	                        this.noWinSymbolsContainer.addChild(symbol);
	                    }
	                    else {
	                        this.symbolsContainer.addChild(symbol);
	                    }
	                }
	            }
	        }
	    };
	    WinAnimator.prototype.winSymbolsGoToCase = function (winIndex, caseType, useValue) {
	        var win = this.currentWins[winIndex];
	        var symbols = [];
	        switch (win.trigger) {
	            case neo_games_1.Communication.Game.WinTrigger.Payline:
	                symbols = this.winSymbolsGoToCaseAsPayline(winIndex, caseType);
	                break;
	            case neo_games_1.Communication.Game.WinTrigger.Scatter:
	                symbols = this.winSymbolsGoToCaseAsScatter(winIndex, caseType);
	                break;
	            case neo_games_1.Communication.Game.WinTrigger.Way:
	                symbols = this.winSymbolsGoToCaseAsWay(winIndex, caseType);
	                break;
	            default:
	                symbols = this.winSymbolsGoToCaseAsCustom(winIndex, caseType);
	                break;
	        }
	        if (useValue && symbols.length > 0 && win.amount > 0) {
	            this.value.visible = true;
	            this.value.position.x = symbols[0].position.x + symbols[0].offsetX;
	            this.value.position.y = symbols[0].position.y + symbols[0].offsetY;
	            if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	                this.value.play(parseInt(neo_common_1.NumberUtils.devide(win.amount, BetManager_1.BetManager.CoinSize).toString()));
	            }
	            else {
	                ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	                this.value.play(parseFloat(Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, win.amount.toString())));
	            }
	        }
	        else {
	            this.value.visible = false;
	        }
	        return symbols;
	    };
	    WinAnimator.prototype.winSymbolsGoToCaseAsPayline = function (winIndex, caseType) {
	        var win = this.currentWins[winIndex];
	        var symbols = [];
	        if (this.paylines != null) {
	            var definition = PaylinesDefinitions_1.PaylinesDefinitions.getPaylineDefinitionsById(win.paylineId, this.paylines.paylineDefinition);
	            for (var i = 0; i < definition.length; i++) {
	                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
	                    var symbol = this.currentSymbols[i][definition[i]];
	                    symbol.goToCase(caseType);
	                    this.symbolsContainer.addChild(symbol);
	                    symbols.push(symbol);
	                }
	            }
	        }
	        return symbols;
	    };
	    WinAnimator.prototype.winSymbolsGoToCaseAsScatter = function (winIndex, caseType) {
	        var win = this.currentWins[winIndex];
	        var symbols = [];
	        for (var i = 0; i < this.reelCount; i++) {
	            for (var j = 0; j < this.symbolCount; j++) {
	                if ((win.mask[i] & (1 << j)) !== 0 && this.allowSymbolGoToCase(i, j, caseType)) {
	                    var symbol = this.currentSymbols[i][j];
	                    symbol.goToCase(caseType);
	                    this.symbolsContainer.addChild(symbol);
	                    symbols.push(symbol);
	                }
	            }
	        }
	        return symbols;
	    };
	    WinAnimator.prototype.winSymbolsGoToCaseAsWay = function (winIndex, caseType) {
	        var win = this.currentWins[winIndex];
	        var symbols = [];
	        for (var i = 0; i < this.reelCount; i++) {
	            for (var j = 0; j < this.symbolCount; j++) {
	                if ((win.mask[i] & (1 << j)) !== 0 && this.allowSymbolGoToCase(i, j, caseType)) {
	                    var symbol = this.currentSymbols[i][j];
	                    symbol.goToCase(caseType);
	                    this.symbolsContainer.addChild(symbol);
	                    symbols.push(symbol);
	                }
	            }
	        }
	        return symbols;
	    };
	    WinAnimator.prototype.winSymbolsGoToCaseAsCustom = function (winIndex, caseType) {
	        return [];
	    };
	    WinAnimator.prototype.allowSymbolGoToCase = function (reelIndex, symbolIndex, caseType) {
	        return true;
	    };
	    WinAnimator.prototype.createPaylines = function (paylines) {
	        this.paylines = paylines;
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNormal);
	    };
	    WinAnimator.prototype.allPaylinesGoToCase = function (caseType) {
	        if (this.paylines != null) {
	            this.paylines.goToCase(caseType);
	        }
	    };
	    WinAnimator.prototype.winPaylineGoToCase = function (winIndex, caseType) {
	        if (this.paylines != null) {
	            var win = this.currentWins[winIndex];
	            if (win.trigger === neo_games_1.Communication.Game.WinTrigger.Payline) {
	                if (caseType === Payline_1.Payline.CaseCycle && this.currentWins.length === 1) {
	                    this.paylines.goToCase(Payline_1.Payline.CaseSingleCycle, win.paylineId);
	                }
	                else {
	                    this.paylines.goToCase(caseType, win.paylineId);
	                }
	            }
	        }
	    };
	    WinAnimator.prototype.createAnimations = function () {
	        this.animationsContainer = new ContainerElement_1.ContainerElement();
	        this.animationsContainer.name = "Animations";
	        this.addChild(this.animationsContainer);
	        if (this.childs["Value"]) {
	            this.value = this.childs["Value"];
	            this.animationsContainer.addChild(this.value);
	        }
	        this.animations = [];
	        for (var i = 0; i < this.animationNames.length; i++) {
	            if (this.childs[this.animationNames[i]]) {
	                var animation = this.childs[this.animationNames[i]];
	                animation.visible = false;
	                animation.on("finished", this.onAnimationFinished.bind(this));
	                animation.on(TimelineElement_1.TimelineElement.AnimationComplete, this.onAnimationComplete.bind(this));
	                this.animations.push(animation);
	                this.animationsContainer.addChild(animation);
	            }
	        }
	        this.currentAnimationIndex = null;
	        this.currentAnimationFinished = true;
	    };
	    WinAnimator.prototype.resetAnimations = function () {
	        this.currentAnimationIndex = null;
	        this.currentAnimationFinished = true;
	        for (var i = 0; i < this.animations.length; i++) {
	            var animation = this.animations[i];
	            animation.visible = false;
	            animation.stop();
	        }
	    };
	    WinAnimator.prototype.startAnimation = function () {
	        this.currentAnimationIndex = this.getAnimationIndex();
	        this.currentAnimationFinished = false;
	        var animation = this.animations[this.currentAnimationIndex];
	        animation.visible = true;
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	            animation.play(parseInt(neo_common_1.NumberUtils.devide(this.currentWin, BetManager_1.BetManager.CoinSize).toString()));
	        }
	        else {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	            animation.play(this.currentWin);
	        }
	    };
	    WinAnimator.prototype.stopAnimation = function () {
	        if (this.currentAnimationIndex != null) {
	            var animation = this.animations[this.currentAnimationIndex];
	            animation.visible = true;
	            if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	                animation.goToOutro(parseInt(neo_common_1.NumberUtils.devide(this.currentWin, BetManager_1.BetManager.CoinSize).toString()));
	            }
	            else {
	                ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	                animation.goToOutro(this.currentWin);
	            }
	            this.currentAnimationIndex = null;
	            this.currentAnimationFinished = true;
	        }
	    };
	    WinAnimator.prototype.getAnimationIndex = function () {
	        return this.currentMultiplierIndex;
	    };
	    WinAnimator.prototype.onAnimationFinished = function () {
	        this.currentAnimationFinished = true;
	        this.emit(WinAnimator.FinishWinCalculation);
	    };
	    WinAnimator.prototype.onAnimationComplete = function () {
	        this.currentAnimationIndex = null;
	        this.currentMultiplierIndex = -1;
	        this.finishFirstWins();
	    };
	    WinAnimator.prototype.idle = function () {
	        for (var i = 0; i < this.getIdleActiveElementsCount(); i++) {
	            var symbol = this.currentSymbols[Math.floor(Math.random() * this.reelCount)][Math.floor(Math.random() * this.symbolCount)];
	            if (symbol.getCurrentCase() === Symbol_1.Symbol.CaseNormal) {
	                if (symbol.hasCase(Symbol_1.Symbol.CaseIdle)) {
	                    symbol.goToCase(Symbol_1.Symbol.CaseIdle);
	                }
	            }
	        }
	        this.startTimer(WinAnimator.Idle, this.getIdleDelay());
	    };
	    WinAnimator.prototype.getInitialIdleDelay = function () {
	        return 60;
	    };
	    WinAnimator.prototype.getIdleDelay = function () {
	        return 60;
	    };
	    WinAnimator.prototype.getIdleActiveElementsCount = function () {
	        return 2;
	    };
	    WinAnimator.FinishWinCalculation = "eventFinishWinCalculation";
	    WinAnimator.FinishWinAnimator = "eventFinishWinAnimator";
	    WinAnimator.Idle = "idle";
	    WinAnimator.CycleWins = "cycleWins";
	    WinAnimator = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], WinAnimator);
	    return WinAnimator;
	}(ContainerElement_1.ContainerElement));
	exports.WinAnimator = WinAnimator;
	exports.WinAnimatorAttributes = {
	    CONFIGS: "Configs",
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var SwitchElement_1 = __webpack_require__(90);
	var ComponentTypes_1 = __webpack_require__(14);
	var Attributes_1 = __webpack_require__(21);
	var Payline = (function (_super) {
	    __extends(Payline, _super);
	    function Payline() {
	        _super.call(this);
	        this.zIndex = 0;
	    }
	    Payline.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        this.zIndex = Attributes_1.Attributes.assignFloatAttribute(node, exports.PaylineAttributes.Z_INDEX, this.zIndex);
	    };
	    Payline.CaseSelect = "SELECT";
	    Payline.CaseNormal = "NORMAL";
	    Payline.CaseNowin = "NOWIN";
	    Payline.CaseWin = "WIN";
	    Payline.CaseSingleCycle = "SINGLE_CYCLE";
	    Payline.CaseCycle = "CYCLE";
	    Payline = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Payline);
	    return Payline;
	}(SwitchElement_1.SwitchElement));
	exports.Payline = Payline;
	exports.PaylineAttributes = {
	    Z_INDEX: "Zindex",
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var PaylinesDefinitions = (function () {
	    function PaylinesDefinitions() {
	    }
	    PaylinesDefinitions.initializePaylineDefinitions = function (paylineGroupId) {
	        var definition = {};
	        switch (paylineGroupId) {
	            case "5x3":
	                definition[1] = [1, 1, 1, 1, 1];
	                definition[2] = [0, 0, 0, 0, 0];
	                definition[3] = [2, 2, 2, 2, 2];
	                definition[4] = [0, 1, 2, 1, 0];
	                definition[5] = [2, 1, 0, 1, 2];
	                definition[6] = [1, 2, 2, 2, 1];
	                definition[7] = [1, 0, 0, 0, 1];
	                definition[8] = [2, 2, 1, 0, 0];
	                definition[9] = [0, 0, 1, 2, 2];
	                definition[10] = [2, 1, 1, 1, 0];
	                definition[11] = [0, 1, 1, 1, 2];
	                definition[12] = [1, 2, 1, 0, 1];
	                definition[13] = [1, 0, 1, 2, 1];
	                definition[14] = [0, 1, 0, 1, 0];
	                definition[15] = [2, 1, 2, 1, 2];
	                definition[16] = [1, 1, 0, 1, 1];
	                definition[17] = [1, 1, 2, 1, 1];
	                definition[18] = [0, 2, 0, 2, 0];
	                definition[19] = [2, 0, 2, 0, 2];
	                definition[20] = [2, 0, 1, 0, 2];
	                break;
	            default:
	                if (false) {
	                    this.log("ERROR no definition for " + paylineGroupId);
	                }
	                return;
	        }
	        this._paylineGroupsDefinitions[paylineGroupId] = definition;
	    };
	    PaylinesDefinitions.getPaylineDefinitionsById = function (paylineId, paylineGroupId) {
	        if (this._paylineGroupsDefinitions != null) {
	            if (this._paylineGroupsDefinitions[paylineGroupId] != null) {
	                if (this._paylineGroupsDefinitions[paylineGroupId][paylineId] != null) {
	                    return this._paylineGroupsDefinitions[paylineGroupId][paylineId];
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no paylineId: " + paylineId + " in " + paylineGroupId);
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no definition for " + paylineGroupId);
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no paylines definitions");
	            }
	        }
	        return null;
	    };
	    PaylinesDefinitions.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("PaylineDefinitions", s);
	        }
	    };
	    PaylinesDefinitions._paylineGroupsDefinitions = {};
	    return PaylinesDefinitions;
	}());
	exports.PaylinesDefinitions = PaylinesDefinitions;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var StyleManager_1 = __webpack_require__(20);
	var ImageTextCounterElement_1 = __webpack_require__(105);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var PlayList_1 = __webpack_require__(33);
	var Song_1 = __webpack_require__(106);
	var Tweens_1 = __webpack_require__(15);
	var ProtonElement_1 = __webpack_require__(98);
	var SwitchElement_1 = __webpack_require__(90);
	var TimelineElement = (function (_super) {
	    __extends(TimelineElement, _super);
	    function TimelineElement() {
	        _super.call(this);
	        this._frameCounter = 0;
	        this._loop = false;
	        this._timer = FrameTimer_1.CreateFrameTimer("TimelineElement");
	        this._timer.on(FrameTimer_1.FrameTimerEvents.Complete, this.animate.bind(this));
	    }
	    TimelineElement.prototype.internalDestroy = function (options) {
	        this._timer.stop();
	        if (this._elements.childs != null) {
	            for (var key in this._elements.childs) {
	                if (this._elements.childs.hasOwnProperty(key)) {
	                    if (this._elements.childs[key] instanceof PIXI.DisplayObject) {
	                        this._elements.childs[key].destroy(options);
	                    }
	                    this._elements.childs[key] = null;
	                }
	            }
	            this._elements.childs = null;
	        }
	    };
	    TimelineElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(exports.TimelineElementAttributes.LOOP)) {
	            this._loop = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.TimelineElementAttributes.LOOP));
	        }
	        if (node.hasAttribute(exports.TimelineElementAttributes.STYLE)) {
	            this._style = StyleManager_1.StyleManager.Styles[node.getAttribute(exports.TimelineElementAttributes.STYLE)];
	            if (this._style != null) {
	                if (this._style.container != null) {
	                    if (node.hasAttribute(exports.TimelineElementAttributes.CLONE) &&
	                        neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.TimelineElementAttributes.CLONE))) {
	                        this._elements = this._style.container.clone();
	                    }
	                    else {
	                        this._elements = this._style.container;
	                    }
	                    this.addChild(this._elements);
	                    if (this._style.frames != null) {
	                        this._framesArray = [];
	                        for (var key in this._style.frames) {
	                            this._framesArray.push(parseInt(key));
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("WARNING no timeline");
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("WARNING no children");
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name: " + node.getAttribute(exports.TimelineElementAttributes.STYLE));
	                }
	            }
	        }
	    };
	    TimelineElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.TimelineElementAttributes.TINT)) {
	            if (this._elements != null && this._elements.children != null && this._elements.children.length > 0) {
	                for (var i = 0; i < this._elements.children.length; i++) {
	                    var child = this._elements.children[i];
	                    if (child instanceof PIXI.DisplayObject) {
	                        if (child.children != null && child.children.length > 0) {
	                            for (var j = 0; j < child.children.length; j++) {
	                                var childOfChild = child.children[j];
	                                if (childOfChild instanceof PIXI.Sprite ||
	                                    childOfChild instanceof PIXI.extras.AnimatedSprite) {
	                                    if (node.getAttribute(exports.TimelineElementAttributes.TINT) === "0") {
	                                        childOfChild.tint = 0xffffff;
	                                    }
	                                    else {
	                                        childOfChild.tint = parseInt(node.getAttribute(exports.TimelineElementAttributes.TINT), 16);
	                                    }
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        }
	        if (node.hasAttribute(exports.TimelineElementAttributes.PLAY) &&
	            neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.TimelineElementAttributes.PLAY))) {
	            if (this._framesArray != null) {
	                this.startAnimate();
	            }
	            else {
	                if (false) {
	                    this.log("WARNING can't play because movieClip is null");
	                }
	            }
	        }
	        if (node.hasAttribute("GoToOutro") && neo_common_1.StringUtils.parseBoolean(node.getAttribute("GoToOutro"))) {
	            this.goToOutro();
	        }
	    };
	    TimelineElement.prototype.play = function (winValue) {
	        if (winValue != null) {
	            this._winValue = winValue;
	        }
	        if (this._framesArray != null) {
	            this.startAnimate();
	        }
	    };
	    TimelineElement.prototype.stop = function () {
	        if (this._elements.childs != null) {
	            for (var key in this._elements.childs) {
	                if (this._elements.childs.hasOwnProperty(key)) {
	                    Tweens_1.Tweens.removeTweens(this._elements.childs[key], "all");
	                    this._elements.childs[key].visible = false;
	                    if (this._elements.childs[key] instanceof ImageTextCounterElement_1.ImageTextCounterElement) {
	                        this._elements.childs[key].stop();
	                    }
	                    if (this._elements.childs[key] instanceof ProtonElement_1.ProtonElement) {
	                        this._elements.childs[key].stop();
	                    }
	                    if (this._elements.childs[key] instanceof SwitchElement_1.SwitchElement) {
	                        this._elements.childs[key].goToCase("EMPTY");
	                    }
	                }
	            }
	        }
	        this.stopAnimate();
	    };
	    TimelineElement.prototype.goToOutro = function (winValue) {
	        if (winValue != null) {
	            this._winValue = winValue;
	        }
	        this._timer.stop();
	        if (this._style != null && this._style.outro != null) {
	            var node = this._style.outro;
	            if (node != null) {
	                var next = node.firstElementChild;
	                if (next != null) {
	                    while (next != null) {
	                        var element = this._elements.childs[next.nodeName];
	                        if (element != null) {
	                            element.updateByNode(next);
	                            if (element instanceof ImageTextCounterElement_1.ImageTextCounterElement) {
	                                if (this._winValue != null) {
	                                    element.start(0, this._winValue, 0);
	                                }
	                                else {
	                                    element.force();
	                                }
	                            }
	                        }
	                        next = next.nextElementSibling;
	                    }
	                }
	            }
	            if (this._style != null && this._style.outroSounds != null) {
	                var node2 = this._style.outroSounds;
	                if (node2 != null) {
	                    var next = node2.firstElementChild;
	                    if (next != null) {
	                        while (next != null) {
	                            if (next.hasAttribute(Song_1.SongAttributes.SONG)) {
	                                if (next.hasAttribute(Song_1.SongAttributes.PLAY)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEIN)) {
	                                        PlayList_1.PlayList.play(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEIN)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.play(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                                if (next.hasAttribute(Song_1.SongAttributes.LOOP)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEIN)) {
	                                        PlayList_1.PlayList.loop(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEIN)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.loop(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                                if (next.hasAttribute(Song_1.SongAttributes.STOP)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEOUT)) {
	                                        PlayList_1.PlayList.stop(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEOUT)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.stop(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                            }
	                            next = next.nextElementSibling;
	                        }
	                    }
	                }
	            }
	        }
	    };
	    TimelineElement.prototype.startAnimate = function () {
	        this._timer.stop();
	        this._frameCounter = 0;
	        if (this.children != null) {
	            if (this._framesArray[0] === 0) {
	                this.animate();
	            }
	            else {
	                this._timer.start(this._framesArray[0]);
	            }
	        }
	    };
	    TimelineElement.prototype.reset = function () {
	        this.startAnimate();
	    };
	    TimelineElement.prototype.stopAnimate = function () {
	        this._timer.stop();
	    };
	    TimelineElement.prototype.animate = function () {
	        if (this._framesArray != null) {
	            if (this._framesArray[this._frameCounter] != null) {
	                this.goToFrame(this._framesArray[this._frameCounter]);
	            }
	            else {
	                this._timer.stop();
	                if (this._loop) {
	                    this.reset();
	                }
	            }
	        }
	        this._frameCounter++;
	        if (this._framesArray[this._frameCounter] != null) {
	            this._timer.stop();
	            this._timer.start(this._framesArray[this._frameCounter] - this._framesArray[this._frameCounter - 1]);
	        }
	        else {
	            this.emit(TimelineElement.AnimationComplete);
	            this._timer.stop();
	            if (this._loop) {
	                this.reset();
	            }
	        }
	    };
	    TimelineElement.prototype.goToFrame = function (frame) {
	        if (this._style != null && this._style.frames != null) {
	            var node = this._style.frames[frame.toString()];
	            if (node.hasAttribute("Emit")) {
	                this.emit(node.getAttribute("Emit"));
	            }
	            if (node != null && node.childElementCount > 0) {
	                var next = node.firstElementChild;
	                if (next != null) {
	                    while (next != null) {
	                        var element = this._elements.childs[next.nodeName];
	                        if (element != null) {
	                            element.updateByNode(next);
	                            if (element instanceof ImageTextCounterElement_1.ImageTextCounterElement && this._winValue != null) {
	                                if (element.visible) {
	                                    element.start(0, this._winValue);
	                                    this._winValue = null;
	                                }
	                            }
	                        }
	                        next = next.nextElementSibling;
	                    }
	                }
	            }
	            if (this._style != null && this._style.framesSounds != null) {
	                var node2 = this._style.framesSounds[frame.toString()];
	                if (node2 != null) {
	                    var next = node2.firstElementChild;
	                    if (next != null) {
	                        while (next != null) {
	                            if (next.hasAttribute(Song_1.SongAttributes.SONG)) {
	                                if (next.hasAttribute(Song_1.SongAttributes.PLAY)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEIN)) {
	                                        PlayList_1.PlayList.play(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEIN)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.play(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                                if (next.hasAttribute(Song_1.SongAttributes.LOOP)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEIN)) {
	                                        PlayList_1.PlayList.loop(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEIN)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.loop(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                                if (next.hasAttribute(Song_1.SongAttributes.STOP)) {
	                                    if (next.hasAttribute(Song_1.SongAttributes.FADEOUT)) {
	                                        PlayList_1.PlayList.stop(next.getAttribute(Song_1.SongAttributes.SONG), parseInt(next.getAttribute(Song_1.SongAttributes.FADEOUT)));
	                                    }
	                                    else {
	                                        PlayList_1.PlayList.stop(next.getAttribute(Song_1.SongAttributes.SONG));
	                                    }
	                                }
	                            }
	                            next = next.nextElementSibling;
	                        }
	                    }
	                }
	            }
	        }
	    };
	    TimelineElement.prototype.getElements = function () {
	        return this._elements;
	    };
	    TimelineElement.prototype.destroy = function (options) {
	        this._timer.stop();
	        _super.prototype.destroy.call(this, options);
	    };
	    TimelineElement.prototype.clone = function () {
	        var element = new TimelineElement();
	        element._elements = this._elements.clone();
	        element.addChild(element._elements);
	        element._style = this._style;
	        element._framesArray = this._framesArray;
	        element._loop = this._loop;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    TimelineElement.AnimationComplete = "animationComplete";
	    TimelineElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], TimelineElement);
	    return TimelineElement;
	}(BaseElement_1.BaseElement));
	exports.TimelineElement = TimelineElement;
	exports.TimelineElementAttributes = {
	    CLONE: "Clone",
	    DEBUG: "Debug",
	    EMIT: "Emit",
	    LOOP: "Loop",
	    PLAY: "Play",
	    SOUNDS: "Sounds",
	    STYLE: "Style",
	    TINT: "Tint",
	};


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ImageTextElement_1 = __webpack_require__(99);
	var ComponentTypes_1 = __webpack_require__(14);
	var Tweens_1 = __webpack_require__(15);
	var AppContext_1 = __webpack_require__(5);
	var ImageTextCounterElement = (function (_super) {
	    __extends(ImageTextCounterElement, _super);
	    function ImageTextCounterElement() {
	        _super.call(this);
	        this.from = 0;
	        this.to = 0;
	        this.duration = 0;
	        this.round = false;
	        this.currentValue = 0;
	        this.finalValue = 0;
	    }
	    ImageTextCounterElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.ImageTextCounterElementAttributes.FROM)) {
	            this.from = parseFloat(node.getAttribute(exports.ImageTextCounterElementAttributes.FROM));
	        }
	        if (node.hasAttribute(exports.ImageTextCounterElementAttributes.TO)) {
	            this.to = parseFloat(node.getAttribute(exports.ImageTextCounterElementAttributes.TO));
	        }
	        if (node.hasAttribute(exports.ImageTextCounterElementAttributes.DURATION)) {
	            this.duration = parseInt(node.getAttribute(exports.ImageTextCounterElementAttributes.DURATION));
	        }
	        if (node.hasAttribute(exports.ImageTextCounterElementAttributes.ROUND)) {
	            this.round = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.ImageTextCounterElementAttributes.ROUND));
	        }
	        if (node.hasAttribute(exports.ImageTextCounterElementAttributes.ACTION)) {
	            switch (node.getAttribute(exports.ImageTextCounterElementAttributes.ACTION)) {
	                case exports.ImageTextCounterElementAttributes.ACTION_VALUE.START:
	                    this.start(this.from, this.to, this.duration);
	                    break;
	                case exports.ImageTextCounterElementAttributes.ACTION_VALUE.STOP:
	                    this.stop();
	                    break;
	                case exports.ImageTextCounterElementAttributes.ACTION_VALUE.FORCE:
	                    this.force();
	                    break;
	            }
	        }
	    };
	    ImageTextCounterElement.prototype.start = function (from, to, duration) {
	        var d = duration != null ? duration : this.duration;
	        if (d <= 0 || from === to) {
	            this.currentValue = to;
	            this.finalValue = to;
	            this.onCountTo();
	        }
	        else {
	            this.currentValue = from;
	            this.finalValue = from;
	            this.onCountTo();
	            this.finalValue = to;
	            Tweens_1.Tweens.customTween(this, {
	                tween: "currentValue",
	                tweenValues: [this.currentValue, this.finalValue],
	                tweenDuration: [d],
	                callbackType: "onUpdate",
	                callbackFunction: this.onCountTo,
	                callbackScope: this,
	            });
	        }
	    };
	    ImageTextCounterElement.prototype.onCountTo = function () {
	        if (this.currentValue === this.finalValue) {
	            Tweens_1.Tweens.removeTweens(this, "currentValue");
	        }
	        this.bitmapText.text = neo_common_1.NumberUtils.valueToNumber(this.currentValue, this.round || ImageTextCounterElement.Round ? 0 : AppContext_1.AppContext.gameConfiguration.ShowDecimalPlaces);
	        this.realign();
	    };
	    ImageTextCounterElement.prototype.stop = function () {
	        Tweens_1.Tweens.removeTweens(this, "currentValue");
	    };
	    ImageTextCounterElement.prototype.force = function () {
	        this.currentValue = this.finalValue;
	        this.onCountTo();
	    };
	    ImageTextCounterElement.prototype.clone = function () {
	        var element = new ImageTextCounterElement();
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.font = this.font;
	        element.text = this.text;
	        element.textAlign = this.textAlign;
	        element.textBaseline = this.textBaseline;
	        element.fontScale = this.fontScale;
	        element.from = this.from;
	        element.to = this.to;
	        element.duration = this.duration;
	        element.round = this.round;
	        element.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
	        element.addChild(element.bitmapText);
	        element.realign();
	        element.markAsCloned();
	        return element;
	    };
	    ImageTextCounterElement.Round = false;
	    ImageTextCounterElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ImageTextCounterElement);
	    return ImageTextCounterElement;
	}(ImageTextElement_1.ImageTextElement));
	exports.ImageTextCounterElement = ImageTextCounterElement;
	exports.ImageTextCounterElementAttributes = {
	    ROUND: "Round",
	    DURATION: "Duration",
	    FROM: "From",
	    TO: "To",
	    ACTION: "Action",
	    ACTION_VALUE: {
	        START: "Start",
	        STOP: "Stop",
	        FORCE: "Force",
	    },
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var AppContext_1 = __webpack_require__(5);
	var DataManager_1 = __webpack_require__(26);
	var Song = (function () {
	    function Song() {
	    }
	    Object.defineProperty(Song.prototype, "originalVolume", {
	        get: function () {
	            return this._originalVolume;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Song.prototype.create = function (node) {
	        this.id = node.nodeName;
	        this.alias = node.hasAttribute(exports.SongAttributes.ALIAS) ? node.getAttribute(exports.SongAttributes.ALIAS) : null;
	        this.instance = null;
	        this.group = node.hasAttribute(exports.SongAttributes.GROUP) ? node.getAttribute(exports.SongAttributes.GROUP) : null;
	        this._originalVolume = this.volume = node.hasAttribute(exports.SongAttributes.VOLUME)
	            ? parseFloat(node.getAttribute(exports.SongAttributes.VOLUME))
	            : 1;
	        this.pan = node.hasAttribute(exports.SongAttributes.PAN) ? parseFloat(node.getAttribute(exports.SongAttributes.PAN)) : 0;
	        this.fade = 0;
	        this.fadeStartTime = 0;
	        this.fadeEndTime = 0;
	        if (node.hasAttribute(exports.SongAttributes.SONG)) {
	            if (PIXI.sound.exists(node.getAttribute(exports.SongAttributes.SONG))) {
	                this.sound = PIXI.sound.find(node.getAttribute(exports.SongAttributes.SONG));
	            }
	            else {
	                this.sound = null;
	                if (false) {
	                    this.log("ERROR no sound with id: " + node.getAttribute("Song"));
	                }
	            }
	        }
	        else {
	            this.sound = null;
	            if (false) {
	                this.log("ERROR no attribute: Song");
	            }
	        }
	    };
	    Song.prototype.isPlaying = function () {
	        return !!this.instance;
	    };
	    Song.prototype.play = function (loop, fadeIn, reset) {
	        if (this.group === "BackgroundMusic" && !AppContext_1.AppContext.current.isBackgroundMusicEnabled) {
	            return;
	        }
	        if (this.sound !== null && (reset || this.instance === null)) {
	            this.sound.filters = this.pan === 0 ? null : [new PIXI.sound.filters.StereoFilter(this.pan)];
	            if (fadeIn > 0) {
	                this.fade = 1;
	                this.fadeStartTime = new Date().getTime();
	                this.fadeEndTime = this.fadeStartTime + fadeIn * 16.7;
	            }
	            else {
	                this.fade = 0;
	                this.fadeStartTime = 0;
	                this.fadeEndTime = 0;
	            }
	            this.playInstance(loop);
	        }
	    };
	    Song.prototype.playInstance = function (loop) {
	        if (loop === void 0) { loop = true; }
	        this.stopInstance();
	        var volume = this.volume;
	        if (this.group === "BackgroundMusic" && !DataManager_1.DataManager.BackSoundsPlayingFromGame) {
	            volume = 0;
	        }
	        else if (this.fade > 0) {
	            volume = this.getFadeInVolume();
	        }
	        else if (this.fade < 0) {
	            volume = this.getFadeOutVolume();
	        }
	        this.instance = (this.sound.play(this.alias !== null ? { sprite: this.alias, volume: volume } : { volume: volume }));
	        this.instance.on("end", loop ? this.playInstance : this.stopInstance, this);
	        if (this.fade !== 0) {
	            this.instance.on("progress", this.fade === 1 ? this.onFadeIn : this.onFadeOut, this);
	        }
	    };
	    Song.prototype.onFadeIn = function () {
	        var volume = this.getFadeInVolume();
	        try {
	            this.instance.volume =
	                this.group === "BackgroundMusic" && !DataManager_1.DataManager.BackSoundsPlayingFromGame ? 0 : volume;
	        }
	        catch (e) { }
	        if (volume === this.volume) {
	            this.instance.off("progress", this.onFadeIn, this);
	        }
	    };
	    Song.prototype.getFadeInVolume = function () {
	        var duration = this.fadeEndTime - this.fadeStartTime;
	        var progress = new Date().getTime() - this.fadeStartTime;
	        return this.volume * Math.min(progress / duration, 1);
	    };
	    Song.prototype.stop = function (fadeOut) {
	        if (this.instance != null) {
	            if (fadeOut > 0) {
	                this.fade = -1;
	                this.fadeStartTime = new Date().getTime();
	                this.fadeEndTime = this.fadeStartTime + fadeOut * 16.7;
	                this.instance.off("progress", this.onFadeIn, this);
	                this.instance.on("progress", this.onFadeOut, this);
	            }
	            else {
	                this.stopInstance();
	            }
	        }
	    };
	    Song.prototype.stopInstance = function () {
	        if (this.instance != null) {
	            this.instance.off("progress", this.onFadeIn, this);
	            this.instance.off("progress", this.onFadeOut, this);
	            this.instance.off("end", this.playInstance, this);
	            this.instance.off("end", this.stopInstance, this);
	            this.instance.stop();
	            this.instance = null;
	        }
	    };
	    Song.prototype.onFadeOut = function () {
	        var volume = this.getFadeOutVolume();
	        try {
	            this.instance.volume =
	                this.group === "BackgroundMusic" && !DataManager_1.DataManager.BackSoundsPlayingFromGame ? 0 : volume;
	        }
	        catch (e) { }
	        if (volume === 0) {
	            this.stopInstance();
	        }
	    };
	    Song.prototype.getFadeOutVolume = function () {
	        var duration = this.fadeEndTime - this.fadeStartTime;
	        var progress = new Date().getTime() - this.fadeStartTime;
	        return this.volume - this.volume * Math.min(progress / duration, 1);
	    };
	    Song.prototype.toggleGroup = function (group, toggle) {
	        if (toggle === void 0) { toggle = false; }
	        if (this.group === group && this.instance != null) {
	            try {
	                this.instance.volume = toggle ? this.volume : 0;
	            }
	            catch (e) { }
	        }
	    };
	    Song.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    Song.prototype.setVolume = function (volume) {
	        this.volume = volume;
	        if (this.instance != null) {
	            this.instance.volume = volume;
	        }
	    };
	    Song.prototype.resetVolume = function (fadeDuration) {
	        this.setVolume(this.originalVolume);
	    };
	    Song.prototype.setPan = function (pan) {
	        if (pan === void 0) { pan = 0; }
	        if (this.sound !== null) {
	            this.pan = pan;
	            this.sound.filters = [new PIXI.sound.filters.StereoFilter(this.pan)];
	            if (false) {
	                this.log("set song " + this.id + " pan " + this.pan);
	            }
	        }
	    };
	    Song = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Song)
	    ], Song);
	    return Song;
	}());
	exports.Song = Song;
	exports.SongAttributes = {
	    SONG: "Song",
	    ALIAS: "Alias",
	    GROUP: "Group",
	    VOLUME: "Volume",
	    PAN: "Pan",
	    PLAY: "Play",
	    LOOP: "Loop",
	    STOP: "Stop",
	    FADEIN: "FadeIn",
	    FADEOUT: "FadeOut",
	};


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Payline_1 = __webpack_require__(102);
	var ComponentTypes_1 = __webpack_require__(14);
	var WinAnimator_1 = __webpack_require__(101);
	var Symbol_1 = __webpack_require__(89);
	var PaylinesDefinitions_1 = __webpack_require__(103);
	var CustomUtils_1 = __webpack_require__(22);
	var GameManager_1 = __webpack_require__(23);
	var neo_games_1 = __webpack_require__(3);
	var PlayList_1 = __webpack_require__(33);
	var BaseView_1 = __webpack_require__(86);
	var FrameTimer_1 = __webpack_require__(9);
	var WinAnimatorExtended = (function (_super) {
	    __extends(WinAnimatorExtended, _super);
	    function WinAnimatorExtended() {
	        _super.apply(this, arguments);
	        this._bonusCounter = 0;
	        this._symbolIdleCounter = [
	            [0, 0, 0],
	            [0, 0, 0],
	            [0, 0, 0],
	            [0, 0, 0],
	            [0, 0, 0],
	        ];
	        this.fullReels = [0, 0, 0, 0, 0];
	        this.multiplierTeasingIndex = -1;
	        this.multiplierReelIndex = -1;
	    }
	    WinAnimatorExtended.prototype.startTimer = function (status, duration) {
	        this.stopTimer();
	        _super.prototype.startTimer.call(this, status, duration);
	    };
	    WinAnimatorExtended.prototype.onReelStopped = function (reelsData, reelIndex, reelsTransition, force) {
	        if (force === void 0) { force = false; }
	        _super.prototype.onReelStopped.call(this, reelsData, reelIndex, reelsTransition);
	        var bonusCounterActualReel = 0;
	        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
	            bonusCounterActualReel = this.checkBonusOnReel(reelsData, reelIndex);
	            for (var i = 0; i < reelsData[reelIndex].symbols.length; i++) {
	                var symbolId = reelsData[reelIndex].symbols[i];
	                if (BaseView_1.BaseView.isRespin && symbolId - 1 !== BaseView_1.BaseView.stickySymbolId) {
	                    this.currentSymbols[reelIndex][i].goToCase(Symbol_1.Symbol.CaseNowin);
	                }
	                if (CustomUtils_1.CustomUtils.isBonusSymbol(symbolId) && this.currentSymbols[reelIndex][i] != null) {
	                    if (reelIndex <= 2 ||
	                        (reelIndex === 3 && this._bonusCounter + bonusCounterActualReel >= 3) ||
	                        (reelIndex === 4 && this._bonusCounter + bonusCounterActualReel >= 6)) {
	                        this.currentSymbols[reelIndex][i].goToCase("IMPACT");
	                        if (force === false) {
	                            PlayList_1.PlayList.setPan("SND_BaseBonusHit" + reelIndex, this.reelCount, reelIndex);
	                            PlayList_1.PlayList.play("SND_BaseBonusHit" + reelIndex, 0, false);
	                        }
	                        else {
	                            PlayList_1.PlayList.play("SND_BaseBonusHit2", 0, false);
	                        }
	                    }
	                }
	            }
	            this._bonusCounter += bonusCounterActualReel;
	        }
	        this.onSameSymbolsOnReelTeasingStop(reelIndex);
	    };
	    WinAnimatorExtended.prototype.checkBonusOnReel = function (reelsData, reelIndex) {
	        var bonusCounter = 0;
	        for (var i = 0; i < reelsData[reelIndex].symbols.length; i++) {
	            var symbolId = reelsData[reelIndex].symbols[i];
	            if (CustomUtils_1.CustomUtils.isBonusSymbol(symbolId) && this.currentSymbols[reelIndex][i] != null) {
	                bonusCounter++;
	            }
	        }
	        return bonusCounter;
	    };
	    WinAnimatorExtended.prototype.multiplierGoToCase = function (multiplier, multiplierCase) {
	        if (multiplier != null && multiplier.getCurrentCase() !== multiplierCase) {
	            multiplier.goToCase(multiplierCase);
	        }
	    };
	    WinAnimatorExtended.prototype.onSameSymbolsOnReel = function () {
	        if (this.topMultipliersContainer != null) {
	            if (this.fullReels[0] >= 3 && this.fullReels[1] >= 3 && this.fullReels[2] >= 3) {
	                if (this.fullReels[3] >= 3) {
	                    if (this.fullReels[4] >= 3) {
	                        this.multiplierGoToCase(this.topMultiplier5x, "ACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    }
	                    else {
	                        this.multiplierGoToCase(this.topMultiplier4x, "ACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    }
	                }
	                else {
	                    this.multiplierGoToCase(this.topMultiplier3x, "ACTIVE");
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.onSameSymbolsOnReelTeasingStart = function (multiplier, reelIndex) {
	        if (this.topMultipliersContainer != null) {
	            if (multiplier > this.multiplierTeasingIndex) {
	                if (multiplier === 5) {
	                    this.multiplierGoToCase(this.topMultiplier5x, "BOUNCING");
	                }
	                else if (multiplier === 4) {
	                    this.multiplierGoToCase(this.topMultiplier4x, "BOUNCING");
	                }
	                else if (multiplier === 3) {
	                    this.multiplierGoToCase(this.topMultiplier3x, "BOUNCING");
	                }
	            }
	            this.multiplierTeasingIndex = multiplier;
	            this.multiplierReelIndex = reelIndex;
	        }
	    };
	    WinAnimatorExtended.prototype.onSameSymbolsOnReelTeasingStop = function (reelIndex) {
	        if (this.topMultipliersContainer != null) {
	            if (this.multiplierTeasingIndex > -1 && reelIndex === this.multiplierReelIndex) {
	                if (this.multiplierTeasingIndex === 5 && this.topMultiplier5x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	                }
	                else if (this.multiplierTeasingIndex === 4 && this.topMultiplier4x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                }
	                else if (this.multiplierTeasingIndex === 3 && this.topMultiplier3x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                }
	                this.multiplierTeasingIndex = -1;
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.initialize = function (symbols, paylines, noWinSymbolsContainer, symbolsContainer, background, paylinesFields) {
	        _super.prototype.initialize.call(this, symbols, paylines, noWinSymbolsContainer, symbolsContainer);
	        this._background = background;
	        this._paylines = paylines;
	        this._paylinesFields = paylinesFields;
	        if (this._paylines != null) {
	            this._paylines.reset();
	        }
	        if (this._paylinesFields != null) {
	            this._paylinesFields.reset();
	        }
	        this.showFirstWinsDelay = FrameTimer_1.CreateFrameTimer("showFirstWinsDelayTimer");
	        this.showFirstWinsDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.showFirstWins.bind(this));
	    };
	    WinAnimatorExtended.prototype.initializeStickyContainer = function (stickyContainer) {
	        this.stickyContainer = stickyContainer;
	        this.currentStickySymbols = [];
	        for (var i = 0; i < this.reelCount; i++) {
	            this.currentStickySymbols.push([]);
	            for (var j = 0; j < this.symbolCount; j++) {
	                this.currentStickySymbols[i].push(null);
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.initializeMultiplierContainer = function (multiplierContainer, topMultipliersContainer) {
	        this.multiplierContainer = multiplierContainer;
	        this.topMultipliersContainer = topMultipliersContainer;
	        this.topMultiplier3x = this.topMultipliersContainer.getChildElementByName("X3");
	        this.topMultiplier4x = this.topMultipliersContainer.getChildElementByName("X4");
	        this.topMultiplier5x = this.topMultipliersContainer.getChildElementByName("X5");
	    };
	    WinAnimatorExtended.prototype.resetMultiplierContainer = function () {
	        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	        this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	        this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	        this.multiplierTeasingIndex = -1;
	        this.multiplierReelIndex = -1;
	    };
	    WinAnimatorExtended.prototype.showCustomWin = function () {
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.gameMultiplier > 2) {
	            if (this.multiplierContainer != null) {
	                this.multiplierContainer.goToCase("MULTIPLIER_" + GameManager_1.GameManager.baseResponse.gameMultiplier);
	            }
	            if (this.currentMultiplierIndex === 1) {
	                this.currentMultiplierIndex = 2;
	            }
	            this.stopTimer();
	            this.showFirstWinsDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration - 60);
	            return true;
	        }
	        else if (this.currentWins.length == 1 && this.currentWins[0].type == neo_games_1.Communication.Game.WinType.Feature) {
	            PlayList_1.PlayList.play("SND_BaseBonusShake");
	            this._transition.goToCase("BONUS_WIN");
	            this.stopTimer();
	            this.showFirstWinsDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration);
	            return true;
	        }
	        return false;
	    };
	    WinAnimatorExtended.prototype.showFirstWins = function () {
	        this.checkCurrentWins();
	        this.allSymbolsGoToCase(Symbol_1.Symbol.CaseNowin, true);
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        if (this._background) {
	            this._background.goToCase("EMPTY");
	        }
	        PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	        PlayList_1.PlayList.resetVolume("SND_BaseLoop");
	        PlayList_1.PlayList.loop("SND_BaseLoop");
	        for (var i = 0; i < this.currentWins.length; i++) {
	            if (this.skipWin(i)) {
	                if (this.currentWins[i].type == neo_games_1.Communication.Game.WinType.Feature) {
	                    this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseBonus, false);
	                    this.updateActiveBonusCounters(this.currentSymbols);
	                }
	                continue;
	            }
	            this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseWin, false);
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseWin);
	        }
	        if (this.currentWins.length == 1 && this.hasFeatureWin) {
	            PlayList_1.PlayList.play("SND_BaseBonusWin");
	            this.stopTimer();
	            this.startTimer(WinAnimatorExtended.messageTimer, 70);
	            return;
	        }
	        this.startAnimation();
	    };
	    WinAnimatorExtended.prototype.finishFirstWins = function () {
	        this.emit(WinAnimator_1.WinAnimator.FinishWinAnimator);
	        this.currentCycle = 0;
	        if (!this.hasFeatureWin && (CustomUtils_1.CustomUtils.isRespinLast() || !CustomUtils_1.CustomUtils.isRespin())) {
	            this.cycleWins();
	        }
	    };
	    WinAnimatorExtended.prototype.showWins = function (wins, win, transition) {
	        this._transition = transition;
	        var result = _super.prototype.showWins.call(this, wins, win);
	        return result;
	    };
	    WinAnimatorExtended.prototype.showFirstInitWins = function () {
	        this.checkCurrentWins();
	        this.allSymbolsGoToCase(Symbol_1.Symbol.CaseNowin, true);
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        for (var i = 0; i < this.currentWins.length; i++) {
	            if (this.skipWin(i)) {
	                if (this.currentWins[i].type == neo_games_1.Communication.Game.WinType.Feature) {
	                    this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseBonus, false);
	                    this.updateActiveBonusCounters(this.currentSymbols);
	                }
	                continue;
	            }
	            this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseWin, false);
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseWin);
	        }
	    };
	    WinAnimatorExtended.prototype.updateActiveBonusCounters = function (symbols) {
	        for (var i = 0; i < this.reelCount; i++) {
	            for (var j = 0; j < symbols[i].length; j++) {
	                var symbol = symbols[i][j];
	                if (symbol && CustomUtils_1.CustomUtils.isBonusSymbol(symbols[i][j].id + 1)) {
	                    var topCounterIndex = symbols[i][j].id + 1 - CustomUtils_1.CustomUtils.SymbolBonus - 1;
	                    if (topCounterIndex != 3 && BaseView_1.BaseView.BonusCounters != null) {
	                        BaseView_1.BaseView.BonusCounters.counterGoToCase(topCounterIndex, "POP");
	                    }
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.finishFirstInitWins = function () {
	        this.currentCycle = 0;
	        if (!this.hasFeatureWin) {
	            this.cycleWins();
	        }
	    };
	    WinAnimatorExtended.prototype.allPaylinesGoToCase = function (caseType) {
	        if (this.paylines != null) {
	            this.paylines.goToCase(caseType);
	        }
	        if (this._paylinesFields != null) {
	            this._paylinesFields.goToCase(caseType);
	        }
	    };
	    WinAnimatorExtended.prototype.winPaylineGoToCase = function (winIndex, caseType) {
	        if (this.paylines != null && this._paylinesFields != null) {
	            var win = this.currentWins[winIndex];
	            if (win.trigger === neo_games_1.Communication.Game.WinTrigger.Payline) {
	                if (caseType === Payline_1.Payline.CaseCycle && this.currentWins.length === 1) {
	                    this.paylines.goToCase(Payline_1.Payline.CaseSingleCycle, win.paylineId);
	                    this._paylinesFields.goToCase(Payline_1.Payline.CaseSingleCycle, win.paylineId);
	                }
	                else {
	                    this.paylines.goToCase(caseType, win.paylineId);
	                    this._paylinesFields.goToCase(caseType, win.paylineId);
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.cycleWins = function () {
	        if (this.currentWins == null) {
	            return;
	        }
	        if (this.skipWin(this.currentCycle)) {
	            this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;
	            this.cycleWins();
	            return;
	        }
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNowin);
	        PlayList_1.PlayList.play("SND_BaseWinline");
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseNormal, false);
	            this.winPaylineGoToCase(i, Payline_1.Payline.CaseNormal);
	        }
	        this.winSymbolsGoToCase(this.currentCycle, Symbol_1.Symbol.CaseCycle, true);
	        if (this.isSingleCashWin) {
	            this.winPaylineGoToCase(this.currentCycle, Payline_1.Payline.CaseSingleCycle);
	            return;
	        }
	        this.winPaylineGoToCase(this.currentCycle, Payline_1.Payline.CaseCycle);
	        this.currentCycle = (this.currentCycle + 1) % this.currentWins.length;
	        this.startTimer(WinAnimator_1.WinAnimator.CycleWins, this.getCycleWinsDelay());
	    };
	    WinAnimatorExtended.prototype.onTimerComplete = function () {
	        _super.prototype.onTimerComplete.call(this);
	        switch (this.timerStatus) {
	            case WinAnimatorExtended.StickyAnimationTimer:
	                this.addStickySymbolsFinished();
	                break;
	            case WinAnimatorExtended.messageTimer:
	                this.finishFirstWins();
	                break;
	            case WinAnimatorExtended.MultiplierAnimationTimer:
	                this.showFirstWins();
	                break;
	        }
	    };
	    WinAnimatorExtended.prototype.reset = function (showLastSymbols, spin) {
	        if (spin === void 0) { spin = false; }
	        this.stopTimer();
	        this._bonusCounter = 0;
	        if (!CustomUtils_1.CustomUtils.isRespin()) {
	            this.returnStickySymbols();
	        }
	        if (showLastSymbols) {
	            this.allSymbolsGoToReset();
	        }
	        else {
	            this.allSymbolsGoToCase(Symbol_1.Symbol.CaseEmpty, false);
	        }
	        this.allPaylinesGoToCase(Payline_1.Payline.CaseNormal);
	        if (showLastSymbols && !spin) {
	            this.startTimer(WinAnimator_1.WinAnimator.Idle, this.getInitialIdleDelay());
	        }
	        this.value.visible = false;
	        var lastMultiplierIndex = this.currentMultiplierIndex;
	        this.currentMultiplierIndex = -1;
	        if (this.currentAnimationIndex != null) {
	            if (this.currentAnimationFinished) {
	                this.resetAnimations();
	                this.currentWins = null;
	                this.currentWin = null;
	                return false;
	            }
	            else {
	                this.stopAnimation();
	                this.currentWins = null;
	                this.currentWin = null;
	                return lastMultiplierIndex >= 3;
	            }
	        }
	        else {
	            this.currentWins = null;
	            this.currentWin = null;
	            return lastMultiplierIndex >= 3;
	        }
	    };
	    WinAnimatorExtended.prototype.addCurrentSymbol = function (reelIndex, symbolIndex) {
	        _super.prototype.addCurrentSymbol.call(this, reelIndex, symbolIndex);
	        var symbol = this.currentSymbols[reelIndex][symbolIndex];
	        if (this.currentReels[reelIndex].customData != null) {
	            if (this.currentReels[reelIndex].customData[symbolIndex] != null &&
	                this.currentReels[reelIndex].customData[symbolIndex] > 0) {
	                var amount = this.currentReels[reelIndex].customData[symbolIndex];
	                if (amount > 0) {
	                    symbol.setAmount(amount);
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.allSymbolsGoToReset = function () {
	        var caseType = Symbol_1.Symbol.CaseNormal;
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            for (var j = this.currentSymbols[i].length - 1; j >= 0; j--) {
	                var symbol = this.currentSymbols[i][j];
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    var currentCaseType = symbol.getCurrentCase();
	                    if (caseType !== currentCaseType &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle0) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle1) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle2) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle3) === -1) {
	                        symbol.goToCase(caseType);
	                    }
	                    this.symbolsContainer.addChild(symbol);
	                }
	                symbol = this.currentStickySymbols[i][j];
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    var currentCaseType = symbol.getCurrentCase();
	                    var caseTypeSticky = "STICKY_" + caseType;
	                    if (caseTypeSticky !== currentCaseType &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle0) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle1) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle2) === -1 &&
	                        currentCaseType.indexOf(Symbol_1.Symbol.CaseIdle3) === -1) {
	                        symbol.goToCase(caseTypeSticky);
	                    }
	                    this.stickyContainer.addChild(symbol);
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.allSymbolsGoToCase = function (caseType, noWin) {
	        for (var i = 0; i < this.currentSymbols.length; i++) {
	            for (var j = 0; j < this.currentSymbols[i].length; j++) {
	                var symbol = this.currentSymbols[i][j];
	                var currentCaseType = caseType;
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    symbol.goToCase(currentCaseType);
	                    if (noWin) {
	                        this.noWinSymbolsContainer.addChild(symbol);
	                    }
	                    else {
	                        this.symbolsContainer.addChild(symbol);
	                    }
	                }
	                symbol = this.currentStickySymbols[i][j];
	                if (symbol !== null && this.allowSymbolGoToCase(i, j, caseType)) {
	                    currentCaseType = "STICKY_" + caseType;
	                    symbol.goToCase(currentCaseType);
	                    if (noWin) {
	                        this.noWinSymbolsContainer.addChild(symbol);
	                    }
	                    else {
	                        this.stickyContainer.addChild(symbol);
	                    }
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.winSymbolsGoToCaseAsPayline = function (winIndex, caseType) {
	        var win = this.currentWins[winIndex];
	        var symbols = [];
	        if (this.paylines != null) {
	            var definition = PaylinesDefinitions_1.PaylinesDefinitions.getPaylineDefinitionsById(win.paylineId, this.paylines.paylineDefinition);
	            for (var i = 0; i < definition.length; i++) {
	                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
	                    var symbol = this.currentStickySymbols[i][definition[i]];
	                    var currentCaseType = caseType;
	                    if (symbol == null) {
	                        symbol = this.currentSymbols[i][definition[i]];
	                    }
	                    else {
	                        currentCaseType = "STICKY_" + caseType;
	                    }
	                    symbol.goToCase(currentCaseType);
	                    this.symbolsContainer.addChild(symbol);
	                    symbols.push(symbol);
	                }
	            }
	        }
	        return symbols;
	    };
	    WinAnimatorExtended.prototype.createAnimations = function () {
	        _super.prototype.createAnimations.call(this);
	        for (var i = 0; i < this.animationNames.length; i++) {
	            if (this.childs[this.animationNames[i]]) {
	                var animation = this.childs[this.animationNames[i]];
	                animation.on("calculationFinished", this.onCalculationFinished.bind(this));
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.onCalculationFinished = function () {
	        this.emit(WinAnimatorExtended.FinishQuickWinCalculation);
	    };
	    WinAnimatorExtended.prototype.stopAnimation = function () {
	        _super.prototype.stopAnimation.call(this);
	    };
	    WinAnimatorExtended.prototype.onAnimationFinished = function () {
	        _super.prototype.onAnimationFinished.call(this);
	    };
	    WinAnimatorExtended.prototype.idle = function () {
	        for (var i = 0; i < this.getIdleActiveElementsCount(); i++) {
	            var indexI = Math.floor(Math.random() * this.reelCount);
	            var indexJ = Math.floor(Math.random() * this.symbolCount);
	            var symbol = this.currentSymbols[indexI][indexJ];
	            if (symbol != null && symbol.getCurrentCase() === Symbol_1.Symbol.CaseNormal) {
	                if (symbol.hasCase(Symbol_1.Symbol.CaseIdle + "_" + this._symbolIdleCounter[indexI][indexJ])) {
	                    symbol.goToCase(Symbol_1.Symbol.CaseIdle + "_" + this._symbolIdleCounter[indexI][indexJ]);
	                    this._symbolIdleCounter[indexI][indexJ]++;
	                }
	                else {
	                    this._symbolIdleCounter[indexI][indexJ] = 0;
	                    if (symbol.hasCase(Symbol_1.Symbol.CaseIdle + "_" + this._symbolIdleCounter[indexI][indexJ])) {
	                        symbol.goToCase(Symbol_1.Symbol.CaseIdle + "_" + this._symbolIdleCounter[indexI][indexJ]);
	                        this._symbolIdleCounter[indexI][indexJ]++;
	                    }
	                }
	            }
	        }
	        this.startTimer(WinAnimator_1.WinAnimator.Idle, this.getIdleDelay());
	    };
	    WinAnimatorExtended.prototype.getIdleActiveElementsCount = function () {
	        return 3;
	    };
	    WinAnimatorExtended.prototype.getInitialIdleDelay = function () {
	        return 120;
	    };
	    WinAnimatorExtended.prototype.getIdleDelay = function () {
	        return 120;
	    };
	    WinAnimatorExtended.prototype.checkCurrentWins = function () {
	        this.isSingleCashWin = false;
	        this.hasFeatureWin = false;
	        var wins = 0;
	        for (var i = 0; i < this.currentWins.length; i++) {
	            if (this.currentWins[i].type == neo_games_1.Communication.Game.WinType.Cash) {
	                wins++;
	            }
	            if (this.currentWins[i].type == neo_games_1.Communication.Game.WinType.Feature) {
	                this.hasFeatureWin = true;
	            }
	        }
	        this.isSingleCashWin = wins > 0 && wins == 1;
	    };
	    WinAnimatorExtended.prototype.skipWin = function (currentWinIndex) {
	        if (this.currentWins != null && this.currentWins[currentWinIndex] != null) {
	            var win = this.currentWins[currentWinIndex];
	            if (win.type == neo_games_1.Communication.Game.WinType.Feature) {
	                return true;
	            }
	        }
	        return false;
	    };
	    WinAnimatorExtended.prototype.hasStickySymbol = function (reelIndex) {
	        if (this.currentReels[reelIndex].transform != null) {
	            return true;
	        }
	        return false;
	    };
	    WinAnimatorExtended.prototype.hasSticky = function () {
	        for (var i = 0; i < this.reelCount; i++) {
	            if (this.hasStickySymbol(i)) {
	                return true;
	            }
	        }
	        return false;
	    };
	    WinAnimatorExtended.prototype.showStickySymbols = function () {
	        for (var i = 0; i < this.reelCount; i++) {
	            if (this.currentReels[i].overlay != null) {
	                for (var j = 0; j < this.symbolCount; j++) {
	                    if (this.currentReels[i].overlay[j] != -1) {
	                        this.addStickySymbol(i, j, this.currentReels[i].overlay[j], true);
	                    }
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.addStickySymbols = function (reelIndex) {
	        if (this.currentReels[reelIndex].transform != null) {
	            for (var j = 0; j < this.symbolCount; j++) {
	                if (this.currentReels[reelIndex].transform[j] != -1) {
	                    this.addStickySymbol(reelIndex, j, this.currentReels[reelIndex].transform[j]);
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.getReelCount = function () {
	        return this.reelCount;
	    };
	    WinAnimatorExtended.prototype.startStickyDelay = function () {
	        this.stopTimer();
	        this.startTimer(WinAnimatorExtended.StickyAnimationTimer, WinAnimatorExtended.StickyAnimationDuration);
	    };
	    WinAnimatorExtended.prototype.addStickySymbolsFinished = function () {
	        this.emit(WinAnimatorExtended.StickyAnimationFinished);
	    };
	    WinAnimatorExtended.prototype.addStickySymbol = function (reelIndex, symbolIndex, symbolId, init) {
	        if (init === void 0) { init = false; }
	        if (this.currentStickySymbols[reelIndex][symbolIndex] == null) {
	            if (this.currentSymbols[reelIndex][symbolIndex] != null) {
	                var symbol = this.currentSymbols[reelIndex][symbolIndex];
	                if (symbol != null) {
	                    var stickySymbol = this.symbols.getSymbol(symbolId - 1, "STICKY_NORMAL");
	                    if (stickySymbol != null) {
	                        stickySymbol.x = symbol.x;
	                        stickySymbol.y = symbol.y;
	                        if (!init) {
	                            stickySymbol.goToCase("TO_STICKY");
	                            PlayList_1.PlayList.play("SND_BaseStick");
	                        }
	                        this.currentStickySymbols[reelIndex][symbolIndex] = stickySymbol;
	                        this.stickyContainer.addChild(stickySymbol);
	                        if (BaseView_1.BaseView.stickySymbolId === -1) {
	                            BaseView_1.BaseView.stickySymbolId = stickySymbol.id;
	                        }
	                        this.fullReels[reelIndex % 5]++;
	                        if (this.fullReels[reelIndex % 5] > 3) {
	                            this.fullReels[reelIndex % 5] = 3;
	                        }
	                        this.onSameSymbolsOnReel();
	                    }
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.returnStickySymbols = function () {
	        for (var i = 0; i < this.reelCount; i++) {
	            for (var j = 0; j < this.symbolCount; j++) {
	                if (this.currentStickySymbols[i][j] != null) {
	                    this.symbols.returnSymbol(this.currentSymbols[i][j]);
	                    this.currentSymbols[i][j] = this.currentStickySymbols[i][j];
	                    this.currentStickySymbols[i][j] = null;
	                    this.fullReels[i % 5]--;
	                    if (this.fullReels[i % 5] < 0) {
	                        this.fullReels[i % 5] = 0;
	                    }
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.prototype.resetStickySymbols = function () {
	        for (var i = 0; i < this.reelCount; i++) {
	            for (var j = 0; j < this.symbolCount; j++) {
	                if (this.currentStickySymbols[i][j] != null) {
	                    this.currentStickySymbols[i][j].goToCase("STICKY_NORMAL");
	                }
	            }
	        }
	    };
	    WinAnimatorExtended.StickyAnimationFinished = "eventStickyAnimationFinished";
	    WinAnimatorExtended.FinishQuickWinCalculation = "eventFinishQuickWinCalculation";
	    WinAnimatorExtended.StickyAnimationTimer = "stickyAnimationTimer";
	    WinAnimatorExtended.messageTimer = "messageTimer";
	    WinAnimatorExtended.MultiplierAnimationTimer = "multiplierAnimationTimer";
	    WinAnimatorExtended.StickyAnimationDuration = 45;
	    WinAnimatorExtended = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], WinAnimatorExtended);
	    return WinAnimatorExtended;
	}(WinAnimator_1.WinAnimator));
	exports.WinAnimatorExtended = WinAnimatorExtended;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var SwitchElement_1 = __webpack_require__(90);
	var ComponentTypes_1 = __webpack_require__(14);
	var LayoutManager_1 = __webpack_require__(109);
	var StyleManager_1 = __webpack_require__(20);
	var Tweens_1 = __webpack_require__(15);
	var StageController_1 = __webpack_require__(6);
	var LayoutSwitchElement = (function (_super) {
	    __extends(LayoutSwitchElement, _super);
	    function LayoutSwitchElement() {
	        _super.call(this);
	        this.inPortraitMode = false;
	        LayoutManager_1.LayoutManager.addLayoutElement(this);
	    }
	    LayoutSwitchElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(LayoutSwitchElementAttributes.PORTRAIT_STYLE)) {
	            this.portraitStyle = (StyleManager_1.StyleManager.Styles[node.getAttribute(LayoutSwitchElementAttributes.PORTRAIT_STYLE)]);
	        }
	        if (this.style != null) {
	            this.baseStyle = this.style;
	        }
	    };
	    LayoutSwitchElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute("Width")) {
	            this.sizeWidth = parseInt(node.getAttribute("Width"));
	            this.updateSize();
	        }
	        if (node.hasAttribute("Height")) {
	            this.sizeHeight = parseInt(node.getAttribute("Height"));
	            this.updateSize();
	        }
	        if (node.hasAttribute("Size")) {
	            this.size = node.getAttribute("Size");
	            this.updateSize();
	        }
	    };
	    LayoutSwitchElement.prototype.updateSize = function () {
	        if (this.size != null) {
	            switch (this.size) {
	                case "cover":
	                    this.calculateCoverScale();
	                    break;
	            }
	        }
	    };
	    LayoutSwitchElement.prototype.calculateCoverScale = function () {
	        if (this.sizeWidth > 0 && this.sizeHeight > 0) {
	            var screenWidth = StageController_1.StageController.Renderer.screen.width;
	            var screenHeight = StageController_1.StageController.Renderer.screen.height;
	            var screenWRatio = screenWidth / this.sizeWidth;
	            var screenHRatio = screenHeight / this.sizeHeight;
	            if (screenWRatio > screenHRatio) {
	                this.scale.set(screenWRatio);
	            }
	            else {
	                this.scale.set(screenHRatio);
	            }
	        }
	    };
	    LayoutSwitchElement.prototype.onLayoutChange = function (isPortrait) {
	        this.updateSize();
	        if (isPortrait == this.inPortraitMode) {
	            return;
	        }
	        var currentCase = this.clearCaseLayoutPrefix(this.getCurrentCase());
	        var style = isPortrait ? this.portraitStyle : this.baseStyle;
	        if (style != null) {
	            var caseType = LayoutManager_1.LayoutManager.getSwitchPrefix() + currentCase;
	            this.case = "";
	            this.style = style;
	            this.storeData(caseType);
	            this.goToCase(caseType);
	            this.restoreData(caseType);
	            this.inPortraitMode = isPortrait;
	        }
	    };
	    LayoutSwitchElement.prototype.clearCaseLayoutPrefix = function (caseType) {
	        if (!neo_common_1.StringUtils.isNullOrEmpty(LayoutManager_1.LayoutManager.getSwitchPrefix())) {
	            caseType = caseType.replace(LayoutManager_1.LayoutManager.getPreviousSwitchPrefix(), "");
	        }
	        return caseType;
	    };
	    LayoutSwitchElement.prototype.storeData = function (caseType) {
	        this.tweenProgress = {};
	        var node = this.style.cases[caseType];
	        if (node != null) {
	            var next = node.firstElementChild;
	            while (next != null) {
	                var elem = this.elements.childs[next.nodeName];
	                if (elem != null) {
	                    var tweensArray = Tweens_1.Tweens.getRegisteredTweens(elem.uid);
	                    if (tweensArray != null && tweensArray.length > 0) {
	                        this.tweenProgress[elem.uid] = [];
	                        for (var i = 0; i < tweensArray.length; i++) {
	                            this.tweenProgress[elem.uid].push(tweensArray["tweens"][i].progress());
	                        }
	                    }
	                }
	                next = next.nextElementSibling;
	            }
	        }
	        this.tempTimer = this.timer;
	        this.timer = null;
	        if (this.style.cases[caseType].hasAttribute("NextCase")) {
	            this.tempNextCase = this.style.cases[caseType].getAttribute("NextCase");
	            this.style.cases[caseType].removeAttribute("NextCase");
	        }
	        if (this.style.cases[caseType].hasAttribute("Timer")) {
	            this.tempTimerData = this.style.cases[caseType].getAttribute("Timer");
	            this.style.cases[caseType].removeAttribute("Timer");
	        }
	    };
	    LayoutSwitchElement.prototype.restoreData = function (caseType) {
	        if (this.tweenProgress != null) {
	            for (var key in this.tweenProgress) {
	                var tweensArray = Tweens_1.Tweens.getRegisteredTweens(key);
	                if (tweensArray != null && tweensArray.length > 0) {
	                    for (var i = 0; i < tweensArray.length; i++) {
	                        if (tweensArray["tweens"][i] != null) {
	                            tweensArray["tweens"][i].progress(this.tweenProgress[key][i]);
	                        }
	                    }
	                }
	            }
	            this.tweenProgress = null;
	        }
	        this.timer = this.tempTimer;
	        this.tempTimer = null;
	        if (this.tempNextCase != null) {
	            this.style.cases[caseType].setAttribute("NextCase", this.tempNextCase);
	            this.tempNextCase = null;
	        }
	        if (this.tempTimerData != null) {
	            this.style.cases[caseType].setAttribute("Timer", this.tempTimerData);
	            this.tempTimerData = null;
	        }
	    };
	    LayoutSwitchElement.prototype.clone = function () {
	        var element = new LayoutSwitchElement();
	        element.style = this.style;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        element.name = this.name;
	        element.elements = this.elements.clone();
	        element.addChild(element.elements);
	        element.case = this.case;
	        element.baseStyle = this.baseStyle;
	        element.portraitStyle = this.portraitStyle;
	        element.inPortraitMode = this.inPortraitMode;
	        element.size = this.size;
	        element.sizeWidth = this.sizeWidth;
	        element.sizeHeight = this.sizeHeight;
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        else if (this.maskGraphics != null) {
	            var elementMask = this.maskGraphics.clone();
	            elementMask.position.x = this.maskGraphics.position.x;
	            elementMask.position.y = this.maskGraphics.position.y;
	            element.maskGraphics = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    LayoutSwitchElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], LayoutSwitchElement);
	    return LayoutSwitchElement;
	}(SwitchElement_1.SwitchElement));
	exports.LayoutSwitchElement = LayoutSwitchElement;
	var LayoutSwitchElementAttributes = {
	    PORTRAIT_STYLE: "PortraitStyle",
	};


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var Configuration_1 = __webpack_require__(57);
	var Scaling_1 = __webpack_require__(8);
	var StageController_1 = __webpack_require__(6);
	var LayoutManager = (function () {
	    function LayoutManager() {
	        this.usePlatform = false;
	        this.configured = false;
	        this.ratioIntervals = [];
	        var config = Configuration_1.Configuration.Configurations["LayoutManagerConfiguration"];
	        if (config != null) {
	            this.configurate(config);
	            this.configured = true;
	        }
	        if (Scaling_1.Scaling.Emitter != null) {
	            Scaling_1.Scaling.Emitter.on(Scaling_1.Scaling.EventResize, this.onLayoutChange.bind(this));
	        }
	    }
	    LayoutManager.addLayoutElement = function (layoutElement) {
	        LayoutManager.LayoutElements.push(layoutElement);
	    };
	    LayoutManager.getSwitchPrefix = function () {
	        return LayoutManager.SwitchPrefix;
	    };
	    LayoutManager.getPreviousSwitchPrefix = function () {
	        return LayoutManager.PreviousSwitchPrefix;
	    };
	    LayoutManager.prototype.configurate = function (node) {
	        this.platform =
	            window["CHANNEL"] == "mobile" ? exports.LayoutManagerAttributes.MOBILE : exports.LayoutManagerAttributes.DESKTOP;
	        if (node.hasAttribute(exports.LayoutManagerConfigurationAttributes.USE_PLATFORM)) {
	            this.usePlatform = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.LayoutManagerConfigurationAttributes.USE_PLATFORM));
	        }
	        if (node.hasAttribute(exports.LayoutManagerConfigurationAttributes.WIDTH)) {
	            this.width = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.LayoutManagerConfigurationAttributes.WIDTH));
	        }
	        if (node.hasAttribute(exports.LayoutManagerConfigurationAttributes.HEIGHT)) {
	            this.height = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.LayoutManagerConfigurationAttributes.HEIGHT));
	        }
	        if (node.hasAttribute(exports.LayoutManagerConfigurationAttributes.RATIO_INTERVALS)) {
	            var intervals = neo_common_1.ArrayUtils.stringArray(node.getAttribute(exports.LayoutManagerConfigurationAttributes.RATIO_INTERVALS), "|");
	            for (var i = 0; i < intervals.length; i++) {
	                this.ratioIntervals.push(neo_common_1.ArrayUtils.numberArray(intervals[i]));
	            }
	        }
	    };
	    LayoutManager.prototype.onLayoutChange = function (isPortrait, ratio, screenWidth, screenHeight, ratioWidth, ratioHeight) {
	        if (!this.configured) {
	            return;
	        }
	        isPortrait = this.allowedPortraitLayout(isPortrait, ratio);
	        LayoutManager.SwitchPrefix = "";
	        if (this.usePlatform) {
	            LayoutManager.SwitchPrefix = this.platform + "_";
	        }
	        if (isPortrait) {
	            document.body.classList.add(LayoutManager.ExtraPortraitClass);
	        }
	        else {
	            document.body.classList.remove(LayoutManager.ExtraPortraitClass);
	        }
	        this.changeCanvasSize(isPortrait, screenWidth, screenHeight, ratioWidth, ratioHeight);
	        this.updateLayoutElements(isPortrait);
	        LayoutManager.PreviousSwitchPrefix = LayoutManager.SwitchPrefix;
	    };
	    LayoutManager.prototype.allowedPortraitLayout = function (isPortrait, ratio) {
	        if (isPortrait) {
	            for (var i = 0; i < this.ratioIntervals.length; i++) {
	                if (ratio > this.ratioIntervals[i][0] && ratio < this.ratioIntervals[i][1]) {
	                    return true;
	                }
	            }
	            return false;
	        }
	        return false;
	    };
	    LayoutManager.prototype.changeCanvasSize = function (isPortrait, screenWidth, screenHeight, ratioWidth, ratioHeight) {
	        var screen = document.getElementById("screen");
	        if (isPortrait) {
	            var offset = parseInt(window.getComputedStyle(screen).top);
	            var height = (screenHeight * (1 / ratioWidth) - offset) * (1920 / 1080);
	            StageController_1.StageController.Renderer.resize(this.width[1], height);
	        }
	        else {
	            StageController_1.StageController.Renderer.resize(this.width[0], this.height[0]);
	        }
	        StageController_1.StageController.Renderer.render(StageController_1.StageController.Stage);
	    };
	    LayoutManager.prototype.updateLayoutElements = function (isPortrait) {
	        for (var i = 0; i < LayoutManager.LayoutElements.length; i++) {
	            LayoutManager.LayoutElements[i].onLayoutChange(isPortrait);
	        }
	    };
	    LayoutManager.ExtraPortraitClass = "extendPortrait";
	    LayoutManager.SwitchPrefix = "";
	    LayoutManager.PreviousSwitchPrefix = "";
	    LayoutManager.LayoutElements = [];
	    return LayoutManager;
	}());
	exports.LayoutManager = LayoutManager;
	exports.LayoutManagerConfigurationAttributes = {
	    USE_ORIENTATION: "UseOrientation",
	    USE_PLATFORM: "UsePlatform",
	    HEIGHT: "Height",
	    WIDTH: "Width",
	    RATIO_INTERVALS: "RatioIntervals",
	};
	exports.LayoutManagerAttributes = {
	    PORTRAIT: "PORTRAIT",
	    LANDSCAPE: "LANDSCAPE",
	    DESKTOP: "DESKTOP",
	    MOBILE: "MOBILE",
	};


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var LayoutManager_1 = __webpack_require__(109);
	var ContainerElement_1 = __webpack_require__(82);
	var StyleManager_1 = __webpack_require__(20);
	var LayoutContainerElement = (function (_super) {
	    __extends(LayoutContainerElement, _super);
	    function LayoutContainerElement() {
	        _super.call(this);
	        LayoutManager_1.LayoutManager.addLayoutElement(this);
	    }
	    LayoutContainerElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE)) {
	            this.portraitStyle = (StyleManager_1.StyleManager.Styles[node.getAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE)]);
	            if (this.portraitStyle != null) {
	                this.portraitStyleNodeList = this.getNodesList(this.portraitStyle.node.firstElementChild);
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no style with name " +
	                        node.getAttribute(LayoutContainerElementAttributes.PORTRAIT_STYLE));
	                }
	            }
	        }
	        if (this.style != null) {
	            this.styleNodeList = this.getNodesList(this.style.node.firstElementChild);
	        }
	    };
	    LayoutContainerElement.prototype.onLayoutChange = function (isPortrait) {
	        if (isPortrait) {
	            this.updateChildElements(this.portraitStyleNodeList, this.styleNodeList);
	        }
	        else {
	            this.updateChildElements(this.styleNodeList, this.portraitStyleNodeList);
	        }
	    };
	    LayoutContainerElement.prototype.updateChildElements = function (styleNodeList, previousStyleNodeList) {
	        if (styleNodeList != null && previousStyleNodeList != null) {
	            if (styleNodeList.length === previousStyleNodeList.length) {
	                for (var i = 0; i < styleNodeList.length; i++) {
	                    var elementStyle = styleNodeList[i];
	                    var previousElementStyle = previousStyleNodeList[i];
	                    if (this.childs[elementStyle.nodeName] != null) {
	                        this.childs[elementStyle.nodeName].updateByNode(this.updateDefaultValues(elementStyle, previousElementStyle));
	                    }
	                }
	            }
	        }
	    };
	    LayoutContainerElement.prototype.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = this.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    LayoutContainerElement.prototype.updateDefaultValues = function (node, previousNode) {
	        if (!node.hasAttribute("X") && previousNode.hasAttribute("X")) {
	            node.setAttribute("X", "0");
	        }
	        if (!node.hasAttribute("Y") && previousNode.hasAttribute("Y")) {
	            node.setAttribute("Y", "0");
	        }
	        if (!node.hasAttribute("PivotX") && previousNode.hasAttribute("PivotX")) {
	            node.setAttribute("PivotX", "0");
	        }
	        if (!node.hasAttribute("PivotY") && previousNode.hasAttribute("PivotY")) {
	            node.setAttribute("PivotY", "0");
	        }
	        if (!node.hasAttribute("Scale") &&
	            !(node.hasAttribute("ScaleX") || node.hasAttribute("ScaleY")) &&
	            previousNode.hasAttribute("Scale")) {
	            node.setAttribute("Scale", "1");
	        }
	        if (!node.hasAttribute("Visible") && previousNode.hasAttribute("Visible")) {
	            node.setAttribute("Visible", "true");
	        }
	        if (!node.hasAttribute("RemoveTweens")) {
	            node.setAttribute("RemoveTweens", "false");
	        }
	        if (node.hasAttribute("Case")) {
	            node.removeAttribute("Case");
	        }
	        return node;
	    };
	    LayoutContainerElement.prototype.clone = function () {
	        var element = new LayoutContainerElement();
	        element.style = this.style;
	        element.portraitStyle = this.portraitStyle;
	        element.styleNodeList = this.styleNodeList;
	        element.portraitStyleNodeList = this.portraitStyleNodeList;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        element.name = this.name;
	        element.childs = {};
	        element.removeChildren();
	        for (var key in this.childs) {
	            element.childs[key] = this.childs[key].clone();
	            element.addChild(element.childs[key]);
	        }
	        if (this.maskSprite != null) {
	            var elementMask = new PIXI.Sprite(this.maskSprite.texture);
	            elementMask.position.x = this.maskSprite.position.x;
	            elementMask.position.y = this.maskSprite.position.y;
	            element.maskSprite = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        else if (this.maskGraphics != null) {
	            var elementMask = this.maskGraphics.clone();
	            elementMask.position.x = this.maskGraphics.position.x;
	            elementMask.position.y = this.maskGraphics.position.y;
	            element.maskGraphics = elementMask;
	            element.addChild(elementMask);
	            element.mask = elementMask;
	        }
	        element.markAsCloned();
	        return element;
	    };
	    LayoutContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], LayoutContainerElement);
	    return LayoutContainerElement;
	}(ContainerElement_1.ContainerElement));
	exports.LayoutContainerElement = LayoutContainerElement;
	var LayoutContainerElementAttributes = {
	    PORTRAIT_STYLE: "PortraitStyle",
	};


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var BaseActions_1 = __webpack_require__(35);
	var UserControls_1 = __webpack_require__(73);
	var HtmlController_1 = __webpack_require__(31);
	var GameManager_1 = __webpack_require__(23);
	var Paytable_1 = __webpack_require__(56);
	var GameData_1 = __webpack_require__(24);
	var GameActions_1 = __webpack_require__(84);
	var BaseController_1 = __webpack_require__(85);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var BalanceManager_1 = __webpack_require__(27);
	var LimitDialog_1 = __webpack_require__(52);
	var ResponsibleDialog1_1 = __webpack_require__(49);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var Jackpot_1 = __webpack_require__(36);
	var BuyFeature_1 = __webpack_require__(30);
	var CustomUtils_1 = __webpack_require__(22);
	var BonusActions_1 = __webpack_require__(112);
	var CashierDialog_1 = __webpack_require__(50);
	var BetHigherThanMinDialog_1 = __webpack_require__(47);
	var FreeRoundBonusDialog_1 = __webpack_require__(45);
	var FreeRoundBonusIcon_1 = __webpack_require__(48);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var MobileBaseUserControls = (function (_super) {
	    __extends(MobileBaseUserControls, _super);
	    function MobileBaseUserControls() {
	        _super.call(this, "base");
	        this._wasCalclulated = true;
	        this._unColectedWin = 0;
	        this._machineStopped = true;
	        this.longIntro = false;
	        this.spinBitmask = 31;
	    }
	    MobileBaseUserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.registerActions();
	        this._afterWinDelay = FrameTimer_1.CreateFrameTimer("afterWinDelay");
	        this._afterWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));
	        this._autoplayDelay = FrameTimer_1.CreateFrameTimer("autoplayDelay");
	        this._autoplayDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));
	        this._unColectedWinDelay = FrameTimer_1.CreateFrameTimer("unColectedWinDelay");
	        this._unColectedWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.unColectedWinDelay.bind(this));
	        this._userControls = document.getElementById("userControls");
	        this._respinDelay = FrameTimer_1.CreateFrameTimer("respinDelay");
	        this._respinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.respin.bind(this));
	        this._gambleDelay = FrameTimer_1.CreateFrameTimer("gambleDelay");
	        this._gambleDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            ModuleManager_1.ModuleManager.enableGamble();
	        });
	        this._betSettings = document.getElementById("betSettings");
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    MobileBaseUserControls.prototype.addController = function (controller) {
	        this._controller = controller;
	        this._controller.on(BaseController_1.BaseController.SpinReceived, this.spinReceived.bind(this));
	        this._controller.on(BaseController_1.BaseController.RespinReceived, this.respinReceived.bind(this));
	        this._controller.on(BaseController_1.BaseController.MachineStopped, this.machineStopped.bind(this));
	        this._controller.on(BaseController_1.BaseController.WinCalculationFinished, this.winCalculationFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.AllWinsFinished, this.allWinsFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.IntroFinished, this.introFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.OutroFinished, this.outroFinished.bind(this));
	        this._controller.on(BaseController_1.BaseController.MachineStoppedWithAnimation, this.machineStoppedWithAnimation.bind(this));
	        this._controller.on(BaseController_1.BaseController.QuickWinCalculationFinished, this.quickWinCalculationFinished.bind(this));
	    };
	    MobileBaseUserControls.prototype.registerActions = function () {
	        this.actions.registerActions((_a = {},
	            _a[BaseActions_1.BaseActions.ActionAutoplay] = false,
	            _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	            _a[BaseActions_1.BaseActions.ActionBaseCollect] = false,
	            _a[BaseActions_1.BaseActions.ActionBetCycle] = false,
	            _a[BaseActions_1.BaseActions.ActionBetPlus] = false,
	            _a[BaseActions_1.BaseActions.ActionBetMinus] = false,
	            _a[BaseActions_1.BaseActions.ActionSpin] = false,
	            _a[BaseActions_1.BaseActions.ActionBuyFeature] = false,
	            _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = false,
	            _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	            _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	            _a
	        ));
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        var _a;
	    };
	    MobileBaseUserControls.prototype.initReceived = function () {
	        this._userControls_supreme = document.getElementById("userControls_supreme");
	        _super.prototype.initReceived.call(this);
	        this._controller.initReceived();
	        this._paytable = new Paytable_1.Paytable();
	        this._paytable.initialize();
	        if (GameManager_1.GameManager.baseResponse != null) {
	            if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataTotalWin, GameManager_1.GameManager.gameResponse.totalWin.toString());
	            }
	        }
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls_supreme != null && !ModuleManager_1.ModuleManager.gambleActive()) {
	            this._userControls_supreme.style.display = "none";
	        }
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	            if (this._userControls_supreme != null &&
	                !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        else if (ModuleManager_1.ModuleManager.gambleActive()) {
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        DataManager_1.DataManager.updateDataElements();
	    };
	    MobileBaseUserControls.prototype.collectReceived = function () {
	        FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        neo_games_1.Platforms.Platforms.roundEnded({
	            id: GameManager_1.GameManager.gameResponse.roundId,
	            win: this._unColectedWin,
	            balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	        });
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: GameManager_1.GameManager.gameResponse.balance.real });
	        _super.prototype.collectReceived.call(this);
	        this._wasCalclulated = true;
	        DataManager_1.DataManager.Collectable = true;
	        DataManager_1.DataManager.updateDataElements();
	        this.prepareNewGameRound();
	        if (AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin && this._unColectedWin > 0) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, this._unColectedWin.toString());
	            this.changeWinBox(true);
	        }
	        else {
	            if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            }
	            this.changeWinBox();
	        }
	        this._unColectedWinDelay.stop();
	        this._unColectedWin = 0;
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	            FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	            this.disableAllActions();
	            return;
	        }
	    };
	    MobileBaseUserControls.prototype.restoreGameRound = function (collect) {
	        if (collect === void 0) { collect = false; }
	        _super.prototype.collectReceived.call(this);
	        this.changeWinBox(collect);
	        this._controller.changeBet();
	        FreeRoundBonus_1.FreeRoundBonus.enableUi();
	        DataManager_1.DataManager.Collectable = true;
	        if (this._unColectedWin == 0) {
	            this._controller.resetWinAnimator();
	        }
	        this.prepareNewGameRound();
	    };
	    MobileBaseUserControls.prototype.spinReceived = function () {
	        FreeRoundBonus_1.FreeRoundBonus.frbSpin();
	        var hasFRBRestriction = FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0;
	        if (DataManager_1.DataManager.quickspinEnabled() && !hasFRBRestriction) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop && !hasFRBRestriction);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    MobileBaseUserControls.prototype.respinReceived = function () {
	        var hasFRBRestriction = FreeRoundBonus_1.FreeRoundBonus.inFrb && AppContext_1.AppContext.gameConfiguration.FRBGameRoundMinSpan > 0;
	        if (DataManager_1.DataManager.quickspinEnabled() && !hasFRBRestriction) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop && !hasFRBRestriction);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    MobileBaseUserControls.prototype.dispatchAction = function (action) {
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	            return;
	        }
	        if (action === GameActions_1.GameActions.ActionSpinOrStop) {
	            if (this.actions.getActionState(BaseActions_1.BaseActions.ActionSpin)) {
	                action = BaseActions_1.BaseActions.ActionSpin;
	            }
	            else if (this.actions.getActionState(BaseActions_1.BaseActions.ActionSpinStop)) {
	                action = BaseActions_1.BaseActions.ActionSpinStop;
	            }
	            else {
	                return;
	            }
	        }
	        if (this.actions.getActionState(action)) {
	            if (action === BaseActions_1.BaseActions.ActionBaseCollect) {
	                this.changeWinBox(true);
	            }
	            else {
	                this.changeWinBox();
	            }
	            if (action != BaseActions_1.BaseActions.ActionSpin) {
	                PlayList_1.PlayList.play("SND_Click");
	            }
	            _super.prototype.dispatchAction.call(this, action);
	            switch (action) {
	                case BaseActions_1.BaseActions.ActionSpin:
	                    this.spin();
	                    break;
	                case BaseActions_1.BaseActions.ActionSpinStop:
	                    this.stop();
	                    break;
	                case BaseActions_1.BaseActions.ActionAutoplay:
	                    this.autoplay();
	                    break;
	                case BaseActions_1.BaseActions.ActionAutoplayStop:
	                    this.autoplayStop();
	                    break;
	                case BaseActions_1.BaseActions.ActionBetCycle:
	                    this.changeBet(false, false, true);
	                    break;
	                case BaseActions_1.BaseActions.ActionBetPlus:
	                    this.changeBet(false, false, false);
	                    break;
	                case BaseActions_1.BaseActions.ActionBetMinus:
	                    this.changeBet(true, false, false);
	                    break;
	                case BaseActions_1.BaseActions.ActionSkipWin:
	                    this.skipWin();
	                    break;
	                case BaseActions_1.BaseActions.ActionBaseCollect:
	                    this.collect();
	                    break;
	                case BaseActions_1.BaseActions.ActionBuyFeature:
	                    this.buyFeature();
	                    break;
	                case BaseActions_1.BaseActions.ActionBuyFeatureDialog:
	                    this.openBuyFeature();
	                    break;
	            }
	        }
	    };
	    MobileBaseUserControls.prototype.collect = function () {
	        if (!this._wasCalclulated) {
	            if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0) {
	                neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	            }
	        }
	        _super.prototype.collect.call(this);
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.disable();
	        this.playCollectSound();
	        this._controller.collect();
	        LimitDialog_1.LimitDialog.closeDialog();
	        GameManager_1.GameManager.collect(GameModules.Base);
	        if (!(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, !AppContext_1.AppContext.gameDefinition.Gamble ? "0" : this._unColectedWin.toString());
	        }
	    };
	    MobileBaseUserControls.prototype.unColectedWinDelay = function () {
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	    };
	    MobileBaseUserControls.prototype.spin = function () {
	        this._machineStopped = false;
	        this.spinBitmask = 31;
	        if (FreeRoundBonus_1.FreeRoundBonus.hasNewActiveOffer()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0 && !DataManager_1.DataManager.GameRoundClosed) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            }
	            return;
	        }
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        if (ResponsibleDialog1_1.ResponsibleDialog1.showResponsibleDialog1OnCollect &&
	            !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                    this._controller.collect();
	                }
	                GameManager_1.GameManager.canExit();
	                this.changeWinBox();
	            }
	            return;
	        }
	        if (BetHigherThanMinDialog_1.BetHigherThanMinDialog.canOpenDialog()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            BetHigherThanMinDialog_1.BetHigherThanMinDialog.openDialog();
	            return;
	        }
	        if (Paytable_1.Paytable.shouldOpen(true, true)) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                Paytable_1.Paytable.show();
	            }
	            return;
	        }
	        if (!DataManager_1.DataManager.Autoplay &&
	            !this._wasCalclulated &&
	            !DataManager_1.DataManager.GameRoundClosed &&
	            AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	            this.changeWinBox(true);
	            this.collect();
	            return;
	        }
	        else {
	            this.changeWinBox();
	            if (!this._wasCalclulated) {
	                if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0) {
	                    neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	                }
	            }
	        }
	        if (GameManager_1.GameManager.gameResponse.totalWin > 0 && !DataManager_1.DataManager.GameRoundClosed) {
	            var balanceTotal = parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal));
	            var balanceAfter = parseFloat(neo_common_1.NumberUtils.add(GameManager_1.GameManager.gameResponse.totalWin, balanceTotal));
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: balanceAfter,
	                inSpin: true,
	            });
	        }
	        if (!neo_games_1.Platforms.Platforms.canSpinOnCollect) {
	            this.autoplayStop();
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox(true);
	                this.collect();
	            }
	            else {
	                this.changeWinBox();
	                this.prepareNewGameRound();
	            }
	            return;
	        }
	        if (!BalanceManager_1.BalanceManager.hasCredit(false, true)) {
	            DataManager_1.DataManager.Autoplay = false;
	            ModuleManager_1.ModuleManager.disableGamble();
	            this.prepareNewGameRound();
	            return;
	        }
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (DataManager_1.DataManager.Autoplay) {
	            if (!DataManager_1.DataManager.AutoplayStarted &&
	                GameManager_1.GameManager.baseResponse != null &&
	                GameManager_1.GameManager.baseResponse.totalWin != null &&
	                GameManager_1.GameManager.baseResponse.totalWin > 0) {
	                DataManager_1.DataManager.updateLossLimit(GameManager_1.GameManager.baseResponse.totalWin);
	            }
	            DataManager_1.DataManager.updateLossLimit();
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this.playCollectSound();
	        DataManager_1.DataManager.updateTotalGain(true);
	        BalanceManager_1.BalanceManager.fixBalance();
	        if (!DataManager_1.DataManager.GameRoundClosed || (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        }
	        this._controller.spin(this.spinBitmask);
	        LimitDialog_1.LimitDialog.closeDialog();
	        this._wasCalclulated = false;
	        neo_games_1.Platforms.Platforms.roundStarted({
	            totalBet: BetManager_1.BetManager.Bet,
	            freeRound: FreeRoundBonus_1.FreeRoundBonus.inFrb,
	            userAction: DataManager_1.DataManager.getTrustedUserAction(BaseActions_1.BaseActions.ActionSpin),
	        });
	        neo_games_1.Platforms.Platforms.spinStarted();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)) });
	    };
	    MobileBaseUserControls.prototype.respin = function () {
	        this._machineStopped = false;
	        this._respinDelay.stop();
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, true);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            if (GameManager_1.GameManager.baseResponse.hasOwnProperty("respin")) {
	                this.spinBitmask = GameManager_1.GameManager.baseResponse.respin;
	            }
	        }
	        this._controller.respin(this.spinBitmask);
	        neo_games_1.Platforms.Platforms.spinStarted();
	    };
	    MobileBaseUserControls.prototype.openBuyFeature = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        BuyFeature_1.BuyFeature.open();
	    };
	    MobileBaseUserControls.prototype.buyFeature = function () {
	        this.spinBitmask = 31;
	        BuyFeature_1.BuyFeature.spin();
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        this._machineStopped = false;
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        var buyfeatureOriginalBet = BuyFeature_1.BuyFeature.getBuyfeatureOriginalBet();
	        var buyFeatureBet = BuyFeature_1.BuyFeature.getBuyFeatureBet();
	        BetManager_1.BetManager.Bet = buyFeatureBet.totalBet;
	        if (!BalanceManager_1.BalanceManager.hasCredit(false, true)) {
	            BetManager_1.BetManager.changeBetByValue(buyfeatureOriginalBet);
	            this.prepareNewGameRound();
	            return;
	        }
	        DataManager_1.DataManager.updateTotalGain(true);
	        BalanceManager_1.BalanceManager.fixBalance();
	        BetManager_1.BetManager.changeBetByValue(buyfeatureOriginalBet);
	        this.initNewBet();
	        this._controller.buyFeature(this.spinBitmask);
	        LimitDialog_1.LimitDialog.closeDialog();
	        this._wasCalclulated = false;
	        neo_games_1.Platforms.Platforms.roundStarted({ totalBet: BuyFeature_1.BuyFeature.getBuyFeatureBet().totalBet });
	        neo_games_1.Platforms.Platforms.spinStarted();
	        neo_games_1.Platforms.Platforms.balanceUpdated({ amount: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)) });
	    };
	    MobileBaseUserControls.prototype.stop = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        DataManager_1.DataManager.quickspinStopped();
	        this._controller.stop();
	    };
	    MobileBaseUserControls.prototype.autoplayDelayed = function () {
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	    };
	    MobileBaseUserControls.prototype.prepareSkipWin = function () {
	        if (GameManager_1.GameManager.gameResponse.totalWin === 0 || !AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplaySkipWinAnimationsEnabled) {
	            this.skipWin();
	            return;
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSkipWin, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionSkipWin, true);
	    };
	    MobileBaseUserControls.prototype.skipWin = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSkipWin, false);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionSkipWin, false);
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            if (!this._wasCalclulated &&
	                !DataManager_1.DataManager.GameRoundClosed &&
	                AppContext_1.AppContext.gameConfiguration.CollectOnUnCalculatedWin) {
	                this.changeWinBox(true);
	                this.collect();
	                this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	                HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	                this._autoplayDelay.start(60);
	            }
	            else {
	                this.autoplay();
	            }
	        }
	        else {
	            this.spin();
	        }
	    };
	    MobileBaseUserControls.prototype.autoplay = function () {
	        this._afterWinDelay.stop();
	        if (this.checkJackpotMiniGame()) {
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayPaused) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayCount === "∞") {
	            DataManager_1.DataManager.Autoplay = true;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	            this.spin();
	        }
	        else {
	            DataManager_1.DataManager.AutoplayCount = (parseInt(DataManager_1.DataManager.AutoplayCount) - 1).toString();
	            if (parseInt(DataManager_1.DataManager.AutoplayCount) >= 0) {
	                DataManager_1.DataManager.Autoplay = true;
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	                this.spin();
	            }
	            else {
	                DataManager_1.DataManager.Autoplay = false;
	                this.prepareNewGameRound();
	            }
	        }
	    };
	    MobileBaseUserControls.prototype.autoplayStop = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        neo_games_1.Platforms.Platforms.autoplayStop();
	        if (this._machineStopped) {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	                neo_games_1.Platforms.Platforms.roundEnded();
	                if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                    FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                    this.disableAllActions();
	                }
	            }
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, false);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionAutoplayStop, false);
	    };
	    MobileBaseUserControls.prototype.changeBet = function (decrease, max, cycle) {
	        if (decrease === void 0) { decrease = false; }
	        if (max === void 0) { max = false; }
	        if (cycle === void 0) { cycle = false; }
	        if (!DataManager_1.DataManager.GameRoundClosed) {
	            this._unColectedWin = 0;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            this.changeWinBox();
	            this.collect();
	        }
	        else {
	            this._controller.collect();
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal);
	            LimitDialog_1.LimitDialog.closeDialog();
	        }
	        BetManager_1.BetManager.changeBet(decrease, max, cycle);
	        this._paytable.updateDataValues();
	        if (BetManager_1.BetManager.minBet) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, false);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, false);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, true);
	        }
	        else if (BetManager_1.BetManager.maxBet) {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, false);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, false);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, true);
	        }
	        else {
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetPlus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetPlus, true);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBetMinus, true);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBetMinus, true);
	        }
	        this._controller.changeBet();
	    };
	    MobileBaseUserControls.prototype.machineStoppedWithAnimation = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBaseUserControls.prototype.quickWinCalculationFinished = function () {
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	    };
	    MobileBaseUserControls.prototype.machineStopped = function (isHighWins) {
	        if (isHighWins === void 0) { isHighWins = false; }
	        this._machineStopped = true;
	        neo_games_1.Platforms.Platforms.spinEnded();
	        DataManager_1.DataManager.stopAutoplayIfLossLimit();
	        DataManager_1.DataManager.stopAutoplayIfWinLimit();
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	            });
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                this.disableAllActions();
	                return;
	            }
	        }
	        this._unColectedWinDelay.stop();
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this.disable();
	            if (DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionState(BaseActions_1.BaseActions.ActionAutoplayStop, true);
	                HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            }
	            if (GameManager_1.GameManager.baseResponse.currentWin == 0) {
	                this.respin();
	            }
	            return;
	        }
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            FreeRoundBonus_1.FreeRoundBonus.disableUi();
	            this.disable();
	            return;
	        }
	        if (DataManager_1.DataManager.Autoplay) {
	            if (DataManager_1.DataManager.AutoplayCount === 0 + "") {
	                DataManager_1.DataManager.Autoplay = false;
	            }
	        }
	        if (GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            this._wasCalclulated = true;
	            DataManager_1.DataManager.Collectable = true;
	        }
	        else {
	            this._wasCalclulated = false;
	        }
	        if (!isHighWins) {
	            if (GameManager_1.GameManager.baseResponse.gameMultiplier > 2) {
	                this._gambleDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration + 30);
	            }
	            else {
	                ModuleManager_1.ModuleManager.enableGamble();
	            }
	        }
	        else {
	            this._gambleDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration + 30);
	        }
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionSpinStop, false);
	        if (GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (GameManager_1.GameManager.baseResponse.gameMultiplier > 2) {
	                this._afterWinDelay.start(CustomUtils_1.CustomUtils.MultiplierAnimationDuration + 30);
	            }
	            else {
	                this._afterWinDelay.start(30);
	            }
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (DataManager_1.DataManager.Autoplay && GameManager_1.GameManager.baseResponse.totalWin === 0) {
	            this._autoplayDelay.start(15);
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this.disableAllActions();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed &&
	                GameManager_1.GameManager.baseResponse.totalWin > 0 &&
	                GameManager_1.GameManager.baseResponse.currentWin === 0) {
	                this._controller.resetWinAnimator();
	                this.collect();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                GameManager_1.GameManager.canExit();
	            }
	        }
	    };
	    MobileBaseUserControls.prototype.winAnimatorTotalStart = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, true);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBaseUserControls.prototype.winCalculationFinished = function () {
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            neo_games_1.Platforms.Platforms.roundEnded({
	                id: GameManager_1.GameManager.gameResponse.roundId,
	                win: GameManager_1.GameManager.gameResponse.totalWin,
	                balanceAfter: parseFloat(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBalanceTotal)),
	            });
	        }
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isRespin() || ModuleManager_1.ModuleManager.bonusEnabled()) {
	            return;
	        }
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.GameRoundClosed && !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	            DataManager_1.DataManager.updateDataElements();
	        }
	        ModuleManager_1.ModuleManager.enableGamble();
	        DataManager_1.DataManager.Collectable = true;
	        this.prepareNewGameRound();
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (!ModuleManager_1.ModuleManager.gambleEnabled()) {
	                FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            }
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this.disableAllActions();
	                return;
	            }
	        }
	        else {
	            FreeRoundBonus_1.FreeRoundBonus.enableFrbExpiration();
	        }
	    };
	    MobileBaseUserControls.prototype.allWinsFinished = function () {
	        FreeRoundBonus_1.FreeRoundBonus.enableFrbExpiration();
	        if (GameManager_1.GameManager.baseResponse != null && GameManager_1.GameManager.baseResponse.currentWin > 0 && !this._wasCalclulated) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.baseResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        this._afterWinDelay.stop();
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            ModuleManager_1.ModuleManager.enableBonus();
	            return;
	        }
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this._respinDelay.start(30);
	            return;
	        }
	        this.prepareNewGameRound();
	        ModuleManager_1.ModuleManager.enableGamble();
	        if (DataManager_1.DataManager.Autoplay && this.actions.getActionState(BaseActions_1.BaseActions.ActionAutoplayStop)) {
	            this.autoplay();
	        }
	        if (DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	            if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb) {
	                this._controller.resetWinAnimator();
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                ModuleManager_1.ModuleManager.disableBase();
	                return;
	            }
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.baseResponse.totalWin > 0) {
	                this._controller.resetWinAnimator();
	                this.collect();
	                return;
	            }
	        }
	    };
	    MobileBaseUserControls.prototype.initIntro = function () {
	        _super.prototype.initIntro.call(this);
	        this._controller.initIntro();
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (CustomUtils_1.CustomUtils.isRespin()) {
	            this.disable();
	            this._respinDelay.start(30);
	            return;
	        }
	        if (ModuleManager_1.ModuleManager.bonusEnabled()) {
	            ModuleManager_1.ModuleManager.enableBonus();
	            return;
	        }
	        this.prepareNewGameRound();
	        ModuleManager_1.ModuleManager.enableGamble();
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        BuyFeature_1.BuyFeature.showBuyFeatureIcon(true);
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (DataManager_1.DataManager.GameRoundClosed) {
	                FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	                ModuleManager_1.ModuleManager.disableBase();
	            }
	            return;
	        }
	    };
	    MobileBaseUserControls.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        this._wasCalclulated = true;
	        this._unColectedWin = GameManager_1.GameManager.gameResponse.totalWin;
	        this.longIntro = long;
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceBonus);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceReal);
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBalanceTotal);
	            DataManager_1.DataManager.Collectable = true;
	        }
	        this._controller.intro(long, previousModule);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	    };
	    MobileBaseUserControls.prototype.introFinished = function () {
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            neo_games_1.Platforms.Platforms.roundEnded();
	        }
	        if (!ResponsibleDialog1_1.ResponsibleDialog1.opened) {
	            DataManager_1.DataManager.Autoplay = DataManager_1.DataManager.AutoplayAfterGamble;
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this.longIntro &&
	            DataManager_1.DataManager.GameRoundClosed &&
	            (FreeRoundBonus_1.FreeRoundBonus.id != null || FreeRoundBonus_1.FreeRoundBonus.otherOfferes.length > 0)) {
	            FreeRoundBonus_1.FreeRoundBonus.enableUi();
	            this.longIntro = false;
	        }
	        ModuleManager_1.ModuleManager.enableGamble();
	        this.prepareNewGameRound();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && DataManager_1.DataManager.GameRoundClosed) {
	            FreeRoundBonus_1.FreeRoundBonus.endFreeRounds();
	            ModuleManager_1.ModuleManager.disableBase();
	            return;
	        }
	        if (FreeRoundBonus_1.FreeRoundBonus.isLastFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative") {
	            if (!DataManager_1.DataManager.GameRoundClosed && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                if (!CustomUtils_1.CustomUtils.isRespinEnabled() && !CustomUtils_1.CustomUtils.isRespinActive()) {
	                    ModuleManager_1.ModuleManager.collect(GameModules.Base);
	                }
	            }
	        }
	    };
	    MobileBaseUserControls.prototype.outro = function () {
	        if (!this._wasCalclulated) {
	            if (GameManager_1.GameManager.gameResponse != null && GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.gameResponse.totalWin);
	            }
	        }
	        BuyFeature_1.BuyFeature.disable();
	        this._afterWinDelay.stop();
	        this._autoplayDelay.stop();
	        DataManager_1.DataManager.AutoplayAfterGamble = DataManager_1.DataManager.Autoplay;
	        DataManager_1.DataManager.Autoplay = false;
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            DataManager_1.DataManager.AutoplayAfterGamble = false;
	            if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	            if (this._userControls_supreme != null &&
	                !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        this._controller.outro();
	    };
	    MobileBaseUserControls.prototype.outroFinished = function () {
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (ModuleManager_1.ModuleManager.bonusActive()) {
	            ModuleManager_1.ModuleManager.introModule(GameModules.BonusRespins, true, GameModules.Base);
	        }
	        else {
	            ModuleManager_1.ModuleManager.introModule(GameModules.Gamble, true, GameModules.Base);
	        }
	    };
	    MobileBaseUserControls.prototype.prepareNewGameRound = function () {
	        this._afterWinDelay.stop();
	        if (this.prepareJackpotMiniGame()) {
	            return;
	        }
	        if (ResponsibleDialog1_1.ResponsibleDialog1.opened) {
	            return;
	        }
	        BetHigherThanMinDialog_1.BetHigherThanMinDialog.openDialog();
	        Paytable_1.Paytable.openAtStart(true);
	        if (BetHigherThanMinDialog_1.BetHigherThanMinDialog.canOpenDialog() && FreeRoundBonusDialog_1.FreeRoundBonusDialog.dialogActive()) {
	            return;
	        }
	        if (BuyFeature_1.BuyFeature.isOpen()) {
	            var featureEnabled = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                !CashierDialog_1.CashierDialog.opened;
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, featureEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, featureEnabled);
	            this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, featureEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, featureEnabled);
	            return;
	        }
	        BuyFeature_1.BuyFeature.restore();
	        if (DataManager_1.DataManager.GameLimit) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.limit();
	        }
	        else {
	            if (!DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionStates((_a = {},
	                    _a[BaseActions_1.BaseActions.ActionAutoplay] = (DataManager_1.DataManager.GameRoundClosed ||
	                        (FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                            FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative" &&
	                            !FreeRoundBonus_1.FreeRoundBonus.isLastFrb)) &&
	                        AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                    _a[BaseActions_1.BaseActions.ActionBaseCollect] = FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative"
	                        ? false
	                        : !DataManager_1.DataManager.GameRoundClosed,
	                    _a[BaseActions_1.BaseActions.ActionBetCycle] = !ModuleManager_1.ModuleManager.gambleEnabled(),
	                    _a[BaseActions_1.BaseActions.ActionBetPlus] = !BetManager_1.BetManager.maxBet,
	                    _a[BaseActions_1.BaseActions.ActionBetMinus] = !BetManager_1.BetManager.minBet,
	                    _a[BaseActions_1.BaseActions.ActionSpin] = !FreeRoundBonus_1.FreeRoundBonus.isLastFrb,
	                    _a[BaseActions_1.BaseActions.ActionBuyFeature] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                        !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                        !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                        !CashierDialog_1.CashierDialog.opened,
	                    _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                        !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                        !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                        !CashierDialog_1.CashierDialog.opened,
	                    _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                    _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                    _a
	                ));
	                if (this._betSettings != null) {
	                    if (!ModuleManager_1.ModuleManager.gambleEnabled()) {
	                        if (this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                            this._betSettings.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	                        }
	                    }
	                    else {
	                        if (!this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                        }
	                    }
	                    if (FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	                        if (!this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                        }
	                    }
	                }
	                if (DataManager_1.DataManager.GameRoundClosed) {
	                    if (!AppContext_1.AppContext.gameConfiguration.ShowPaytableAtStart || Paytable_1.Paytable.userClosedPaytableAtStart) {
	                        neo_games_1.Platforms.Platforms.roundInit();
	                    }
	                }
	            }
	            else {
	                this.prepareSkipWin();
	            }
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var _a;
	    };
	    MobileBaseUserControls.prototype.prepareJackpotMiniGame = function () {
	        if (DataManager_1.DataManager.GameRoundClosed && Jackpot_1.Jackpot.hasMiniGame() && !FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            if (Jackpot_1.Jackpot.hasInitializedGame() && this._wasCalclulated) {
	                DataManager_1.DataManager.Autoplay = false;
	                this.resetWinAnimator();
	                this.disable();
	                FreeRoundBonus_1.FreeRoundBonus.disableUi();
	                Jackpot_1.Jackpot.startMiniGame();
	                return true;
	            }
	            else {
	                var self_1 = this;
	                if (this._wasCalclulated) {
	                    Jackpot_1.Jackpot.initMiniGame(true, function () {
	                        self_1.resetWinAnimator();
	                        self_1.disable();
	                        DataManager_1.DataManager.Autoplay = false;
	                        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	                    });
	                }
	                if (DataManager_1.DataManager.GameLimit) {
	                    DataManager_1.DataManager.Autoplay = false;
	                    this.limit();
	                }
	                if (Jackpot_1.Jackpot.waitForMiniGameInitialization()) {
	                    this.actions.disableAllActions();
	                    HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    MobileBaseUserControls.prototype.checkJackpotMiniGame = function () {
	        if (!Jackpot_1.Jackpot.hasMiniGame() || FreeRoundBonus_1.FreeRoundBonus.inFrb) {
	            return false;
	        }
	        if (Jackpot_1.Jackpot.hasInitializedGame() || Jackpot_1.Jackpot.waitForMiniGameInitialization()) {
	            if (GameManager_1.GameManager.gameResponse.totalWin > 0) {
	                this.changeWinBox();
	                this._wasCalclulated = true;
	                if (!DataManager_1.DataManager.GameRoundClosed) {
	                    this.collect();
	                }
	                else {
	                    this.playCollectSound();
	                    DataManager_1.DataManager.updateDataElements();
	                    this.prepareNewGameRound();
	                }
	            }
	            else {
	                this.prepareNewGameRound();
	            }
	            return true;
	        }
	        else {
	            Jackpot_1.Jackpot.initMiniGame(false, null);
	            Jackpot_1.Jackpot.disableMiniGameAutostart();
	            return false;
	        }
	    };
	    MobileBaseUserControls.prototype.limit = function () {
	        LimitDialog_1.LimitDialog.openDialog();
	        if (DataManager_1.DataManager.GameRoundClosed) {
	            this.actions.changeActionStates((_a = {},
	                _a[BaseActions_1.BaseActions.ActionAutoplay] = AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                _a[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                _a[BaseActions_1.BaseActions.ActionBaseCollect] = false,
	                _a[BaseActions_1.BaseActions.ActionBetCycle] = true,
	                _a[BaseActions_1.BaseActions.ActionBetPlus] = !BetManager_1.BetManager.maxBet,
	                _a[BaseActions_1.BaseActions.ActionBetMinus] = !BetManager_1.BetManager.minBet,
	                _a[BaseActions_1.BaseActions.ActionSpin] = true,
	                _a[BaseActions_1.BaseActions.ActionBuyFeature] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                    !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                    !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                    !CashierDialog_1.CashierDialog.opened,
	                _a[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = BuyFeature_1.BuyFeature.buyFeatureBtnEnabled(this._wasCalclulated) &&
	                    !FreeRoundBonus_1.FreeRoundBonus.isLastFrb &&
	                    !FreeRoundBonus_1.FreeRoundBonus.inFrb &&
	                    !CashierDialog_1.CashierDialog.opened,
	                _a[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                _a[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                _a
	            ));
	            if (this._betSettings != null && this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._betSettings.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        else {
	            this.actions.changeActionStates((_b = {},
	                _b[BaseActions_1.BaseActions.ActionAutoplay] = false,
	                _b[BaseActions_1.BaseActions.ActionAutoplayStop] = false,
	                _b[BaseActions_1.BaseActions.ActionBaseCollect] = true,
	                _b[BaseActions_1.BaseActions.ActionBetCycle] = false,
	                _b[BaseActions_1.BaseActions.ActionBetPlus] = false,
	                _b[BaseActions_1.BaseActions.ActionBetMinus] = false,
	                _b[BaseActions_1.BaseActions.ActionSpin] = false,
	                _b[BaseActions_1.BaseActions.ActionBuyFeature] = false,
	                _b[BaseActions_1.BaseActions.ActionBuyFeatureDialog] = false,
	                _b[BaseActions_1.BaseActions.ActionSpinStop] = false,
	                _b[BaseActions_1.BaseActions.ActionSkipWin] = false,
	                _b
	            ));
	            if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        var _a, _b;
	    };
	    MobileBaseUserControls.prototype.disableActions = function () {
	        _super.prototype.disableActions.call(this);
	        this._betSettings.style.display = "none";
	    };
	    MobileBaseUserControls.prototype.restoreActions = function () {
	        _super.prototype.restoreActions.call(this);
	        if (DataManager_1.DataManager.Autoplay &&
	            this._machineStopped &&
	            this.actions.getActionState(BaseActions_1.BaseActions.ActionAutoplayStop)) {
	            this._autoplayDelay.stop();
	            this._autoplayDelay.start(30);
	        }
	        this._betSettings.style.display = "";
	    };
	    MobileBaseUserControls.prototype.disable = function () {
	        this._afterWinDelay.stop();
	        this.actions.disableAllActions();
	        FreeRoundBonusIcon_1.FreeRoundBonusIcon.disableActiveIcon();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (!CustomUtils_1.CustomUtils.isRespin()) {
	            this._controller.disableBase();
	        }
	        if (this._betSettings != null && !this._betSettings.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._betSettings.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    MobileBaseUserControls.prototype.resetWinAnimator = function () {
	        this._controller.resetWinAnimator();
	    };
	    MobileBaseUserControls.prototype.disableAllActions = function () {
	        this._afterWinDelay.stop();
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBaseUserControls.prototype.enableBuyFeature = function () {
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        this.actions.changeActionState(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeature, true);
	        HtmlController_1.HtmlController.updateActionElement(BaseActions_1.BaseActions.ActionBuyFeatureDialog, true);
	    };
	    MobileBaseUserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], MobileBaseUserControls);
	    return MobileBaseUserControls;
	}(UserControls_1.UserControls));
	exports.MobileBaseUserControls = MobileBaseUserControls;


/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	var BonusActions = (function () {
	    function BonusActions() {
	    }
	    BonusActions.ActionStart = "BONUS_START";
	    BonusActions.ActionBack = "BONUS_BACK_TO_GAME";
	    BonusActions.ActionSpin = "BONUS_SPIN";
	    BonusActions.ActionSpinStop = "BONUS_SPIN_STOP";
	    BonusActions.ActionAutoplay = "BONUS_AUTOPLAY";
	    BonusActions.ActionAutoplayStop = "BONUS_AUTOPLAY_STOP";
	    BonusActions.ActionSkipWin = "BONUS_SKIP_WIN";
	    return BonusActions;
	}());
	exports.BonusActions = BonusActions;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var UserControls_1 = __webpack_require__(73);
	var HtmlController_1 = __webpack_require__(31);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var GameActions_1 = __webpack_require__(84);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var LimitDialog_1 = __webpack_require__(52);
	var BonusActions_1 = __webpack_require__(112);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var BonusController_1 = __webpack_require__(114);
	var CustomUtils_1 = __webpack_require__(22);
	var PlayList_1 = __webpack_require__(33);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var WinType = neo_games_1.Communication.Game.WinType;
	var DesktopBonusUserControls = (function (_super) {
	    __extends(DesktopBonusUserControls, _super);
	    function DesktopBonusUserControls() {
	        _super.call(this, "bonus");
	        this._wasCalclulated = true;
	        this._machineStopped = true;
	        this.spinBitmask = 31;
	    }
	    DesktopBonusUserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.registerActions();
	        this._afterWinDelay = FrameTimer_1.CreateFrameTimer("afterWinDelay");
	        this._afterWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));
	        this._autoplayDelay = FrameTimer_1.CreateFrameTimer("autoplayDelay");
	        this._autoplayDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));
	        this._playButtonDelay = FrameTimer_1.CreateFrameTimer("_playButtonDelay");
	        this._playButtonDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionStart, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }.bind(this));
	        this._backButtonDelay = FrameTimer_1.CreateFrameTimer("_backButtonDelay");
	        this._backButtonDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionBack, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }.bind(this));
	        this._counterDelay = FrameTimer_1.CreateFrameTimer("counterDelay");
	        this._counterDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.updateCounter.bind(this));
	        this._userControls = document.getElementById("bonusUserControls");
	        this._counter = document.getElementById("bonusCounter");
	    };
	    DesktopBonusUserControls.prototype.addController = function (controller) {
	        this._controller = controller;
	        this._controller.on(BonusController_1.BonusController.StartReceived, this.startReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.SpinReceived, this.spinReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.RespinReceived, this.respinReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.EndReceived, this.endReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.MachineStopped, this.machineStopped.bind(this));
	        this._controller.on(BonusController_1.BonusController.WinCalculationFinished, this.winCalculationFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.WinAnimatorTotalStart, this.winAnimatorTotalStart.bind(this));
	        this._controller.on(BonusController_1.BonusController.AllWinsFinished, this.allWinsFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.IntroFinished, this.introFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.OutroFinished, this.outroFinished.bind(this));
	    };
	    DesktopBonusUserControls.prototype.registerActions = function () {
	        this.actions.registerActions((_a = {},
	            _a[BonusActions_1.BonusActions.ActionStart] = false,
	            _a[BonusActions_1.BonusActions.ActionBack] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplay] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplayStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSpin] = false,
	            _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	            _a
	        ));
	        var _a;
	    };
	    DesktopBonusUserControls.prototype.initReceived = function () {
	        this._userControls_supreme = document.getElementById("userControls_supreme");
	        _super.prototype.initReceived.call(this);
	        this._controller.initReceived();
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    DesktopBonusUserControls.prototype.restoreGameRound = function () {
	        this.prepareNewGameRound();
	    };
	    DesktopBonusUserControls.prototype.startReceived = function () {
	        ModuleManager_1.ModuleManager.outroModule(GameModules.Base);
	    };
	    DesktopBonusUserControls.prototype.spinReceived = function () {
	        if (DataManager_1.DataManager.quickspinEnabled()) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }
	    };
	    DesktopBonusUserControls.prototype.respinReceived = function () {
	        if (DataManager_1.DataManager.quickspinEnabled()) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    DesktopBonusUserControls.prototype.endReceived = function () {
	        ModuleManager_1.ModuleManager.outroModule(GameModules.BonusRespins);
	    };
	    DesktopBonusUserControls.prototype.dispatchAction = function (action) {
	        if (action === GameActions_1.GameActions.ActionSpinOrStop) {
	            if (this.actions.getActionState(BonusActions_1.BonusActions.ActionStart)) {
	                action = BonusActions_1.BonusActions.ActionStart;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionBack)) {
	                action = BonusActions_1.BonusActions.ActionBack;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionSpin)) {
	                action = BonusActions_1.BonusActions.ActionSpin;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionSpinStop)) {
	                action = BonusActions_1.BonusActions.ActionSpinStop;
	            }
	            else {
	                return;
	            }
	        }
	        if (this.actions.getActionState(action)) {
	            _super.prototype.dispatchAction.call(this, action);
	            switch (action) {
	                case BonusActions_1.BonusActions.ActionStart:
	                    this.start();
	                    break;
	                case BonusActions_1.BonusActions.ActionBack:
	                    this.back();
	                    break;
	                case BonusActions_1.BonusActions.ActionSpin:
	                    this.spin();
	                    break;
	                case BonusActions_1.BonusActions.ActionSpinStop:
	                    this.stop();
	                    break;
	                case BonusActions_1.BonusActions.ActionSkipWin:
	                    this.skipWin();
	                    break;
	                case BonusActions_1.BonusActions.ActionAutoplay:
	                    this.autoplay();
	                    break;
	                case BonusActions_1.BonusActions.ActionAutoplayStop:
	                    this.autoplayStop();
	                    break;
	            }
	        }
	    };
	    DesktopBonusUserControls.prototype.start = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this._controller.start();
	    };
	    DesktopBonusUserControls.prototype.spin = function () {
	        this._machineStopped = false;
	        this.respin();
	    };
	    DesktopBonusUserControls.prototype.respin = function () {
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (this._counter != null) {
	            this._counter.classList.remove("bounce1");
	            this._counter.classList.remove("bounce2");
	            this._counter.classList.remove("bounce3");
	        }
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString());
	        if (DataManager_1.DataManager.Autoplay) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        this.spinBitmask = 32767;
	        this._controller.respin(this.spinBitmask);
	        neo_games_1.Platforms.Platforms.spinStarted();
	    };
	    DesktopBonusUserControls.prototype.back = function () {
	        this.disable();
	        ModuleManager_1.ModuleManager.endBonus();
	    };
	    DesktopBonusUserControls.prototype.stop = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        DataManager_1.DataManager.quickspinStopped();
	        this._controller.stop();
	    };
	    DesktopBonusUserControls.prototype.end = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null && GameManager_1.GameManager.bonusRespinsResponse.totalWin > 0) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.bonusRespinsResponse.totalWin);
	        }
	        this._controller.end();
	    };
	    DesktopBonusUserControls.prototype.autoplayDelayed = function () {
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	    };
	    DesktopBonusUserControls.prototype.prepareSkipWin = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0 ||
	            !AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	            return;
	        }
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSkipWin, true);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionSkipWin, true);
	    };
	    DesktopBonusUserControls.prototype.skipWin = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSkipWin, false);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionSkipWin, false);
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.spin();
	        }
	    };
	    DesktopBonusUserControls.prototype.autoplay = function () {
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.AutoplayPaused) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayCount === "∞") {
	            DataManager_1.DataManager.Autoplay = true;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	            this.spin();
	        }
	        else {
	            DataManager_1.DataManager.AutoplayCount = (parseInt(DataManager_1.DataManager.AutoplayCount) - 1).toString();
	            if (parseInt(DataManager_1.DataManager.AutoplayCount) >= 0) {
	                DataManager_1.DataManager.Autoplay = true;
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	                this.spin();
	            }
	            else {
	                DataManager_1.DataManager.Autoplay = false;
	                this.prepareNewGameRound();
	            }
	        }
	    };
	    DesktopBonusUserControls.prototype.autoplayStop = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, false);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionAutoplayStop, false);
	    };
	    DesktopBonusUserControls.prototype.machineStopped = function () {
	        this._machineStopped = true;
	        neo_games_1.Platforms.Platforms.spinEnded();
	        this._wasCalclulated = GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0;
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        if (CustomUtils_1.CustomUtils.isBonusRespin()) {
	            if (GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0) {
	                this._counterDiff =
	                    GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount -
	                        parseInt(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBonusSpinRemainingCount));
	                if (this._counterDiff > 0) {
	                    if (this._counter != null) {
	                        this._counter.classList.add("bounce" + this._counterDiff);
	                    }
	                    this.updateCounter();
	                }
	                else {
	                    this.machineStopFinished();
	                }
	            }
	        }
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            this.actions.disableAllActions();
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    DesktopBonusUserControls.prototype.machineStopFinished = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        this.prepareNewGameRound();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (GameManager_1.GameManager.bonusRespinsResponse.currentWin > 0) {
	            this._afterWinDelay.start(30);
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	        if (DataManager_1.DataManager.Autoplay && GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0) {
	            this._autoplayDelay.start(15);
	        }
	    };
	    DesktopBonusUserControls.prototype.winAnimatorTotalStart = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    DesktopBonusUserControls.prototype.winCalculationFinished = function () {
	        this._afterWinDelay.stop();
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isBonusRespin()) {
	            this.disable();
	            if (DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, true);
	                HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            }
	            return;
	        }
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.actions.disableAllActions();
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    DesktopBonusUserControls.prototype.allWinsFinished = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null && GameManager_1.GameManager.bonusRespinsResponse.currentWin > 0) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.bonusRespinsResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        this._afterWinDelay.stop();
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.actions.disableAllActions();
	            this._backButtonDelay.stop();
	            this._backButtonDelay.start(90);
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    DesktopBonusUserControls.prototype.updateCounter = function () {
	        if (this._counterDiff > 0) {
	            var remainingCount = parseInt(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBonusSpinRemainingCount));
	            remainingCount++;
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, remainingCount.toString());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, remainingCount.toString());
	            this._counterDiff--;
	            PlayList_1.PlayList.play("SND_BonusRespinCounter");
	            this._counterDelay.start(15);
	        }
	        else {
	            this._counter.classList.remove("bounce1");
	            this._counter.classList.remove("bounce2");
	            this._counter.classList.remove("bounce3");
	            this.machineStopFinished();
	        }
	    };
	    DesktopBonusUserControls.prototype.initIntro = function () {
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.add("bonus");
	        }
	        _super.prototype.initIntro.call(this);
	        this._controller.initIntro();
	        neo_games_1.Platforms.Platforms.featureInit({ type: neo_games_1.Communication.Game.GameModules.BonusRespins });
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            this.actions.disableAllActions();
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionBack, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    DesktopBonusUserControls.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        this._controller.intro(long, previousModule);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.add("bonus");
	        }
	    };
	    DesktopBonusUserControls.prototype.introFinished = function () {
	        this.prepareNewGameRound();
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    DesktopBonusUserControls.prototype.outro = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        this._controller.outro();
	        if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    DesktopBonusUserControls.prototype.outroFinished = function () {
	        ModuleManager_1.ModuleManager.introModule(GameModules.Base, true, GameModules.BonusRespins);
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls_supreme != null && this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.remove("bonus");
	        }
	    };
	    DesktopBonusUserControls.prototype.prepareNewGameRound = function () {
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.GameLimit) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.limit();
	        }
	        else {
	            if (!DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionStates((_a = {},
	                    _a[BonusActions_1.BonusActions.ActionStart] = false,
	                    _a[BonusActions_1.BonusActions.ActionBack] = false,
	                    _a[BonusActions_1.BonusActions.ActionAutoplay] = !DataManager_1.DataManager.Autoplay && AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BonusActions_1.BonusActions.ActionAutoplayStop] = DataManager_1.DataManager.Autoplay && AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BonusActions_1.BonusActions.ActionSpin] = true,
	                    _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	                    _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	                    _a
	                ));
	            }
	            else {
	                this.prepareSkipWin();
	            }
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var _a;
	    };
	    DesktopBonusUserControls.prototype.limit = function () {
	        LimitDialog_1.LimitDialog.openDialog();
	        this.actions.changeActionStates((_a = {},
	            _a[BonusActions_1.BonusActions.ActionStart] = false,
	            _a[BonusActions_1.BonusActions.ActionBack] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplay] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplayStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSpin] = false,
	            _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	            _a
	        ));
	        var _a;
	    };
	    DesktopBonusUserControls.prototype.enable = function () {
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.totalCount.toString());
	        this._playButtonDelay.stop();
	        this._playButtonDelay.start(30);
	        this._controller.enable();
	    };
	    DesktopBonusUserControls.prototype.restoreActions = function () {
	        _super.prototype.restoreActions.call(this);
	        if (DataManager_1.DataManager.Autoplay &&
	            this._machineStopped &&
	            this.actions.getActionState(BonusActions_1.BonusActions.ActionAutoplayStop)) {
	            this._autoplayDelay.stop();
	            this._autoplayDelay.start(30);
	        }
	    };
	    DesktopBonusUserControls.prototype.disable = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    DesktopBonusUserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], DesktopBonusUserControls);
	    return DesktopBonusUserControls;
	}(UserControls_1.UserControls));
	exports.DesktopBonusUserControls = DesktopBonusUserControls;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Controller_1 = __webpack_require__(79);
	var ComponentTypes_1 = __webpack_require__(14);
	var BonusView_1 = __webpack_require__(115);
	var BonusModel_1 = __webpack_require__(118);
	var Machine_1 = __webpack_require__(87);
	var BonusController = (function (_super) {
	    __extends(BonusController, _super);
	    function BonusController() {
	        _super.call(this);
	    }
	    BonusController.prototype.startInitialization = function (view) {
	        if (false) {
	            this.log("startInitialization");
	        }
	        if (view instanceof BonusView_1.BonusView) {
	            this._view = view;
	        }
	        else {
	            if (false) {
	                this.log("ERROR view is not instance of BaseView");
	            }
	        }
	        this._model = new BonusModel_1.BonusModel(this);
	    };
	    BonusController.prototype.initReceived = function () {
	        this._view.initReceived(this);
	    };
	    BonusController.prototype.disableLogo = function () {
	        this._view.disableLogo();
	    };
	    BonusController.prototype.initIntro = function () {
	        this._view.initIntro();
	    };
	    BonusController.prototype.start = function () {
	        this._model.start();
	    };
	    BonusController.prototype.spin = function () {
	        this._model.spin();
	        this._view.spin();
	    };
	    BonusController.prototype.respin = function (reels) {
	        this._model.respin();
	        this._view.respin(reels);
	    };
	    BonusController.prototype.end = function () {
	        this._model.end();
	    };
	    BonusController.prototype.stop = function () {
	        this._view.stop();
	    };
	    BonusController.prototype.startReceived = function () {
	        this._view.startReceived();
	        this.emit(BonusController.StartReceived);
	    };
	    BonusController.prototype.spinReceived = function () {
	        this._view.spinReceived();
	        this.emit(BonusController.SpinReceived);
	    };
	    BonusController.prototype.respinReceived = function () {
	        Machine_1.Machine.Respin = true;
	        this._view.spinReceived();
	        this.emit(BonusController.RespinReceived);
	    };
	    BonusController.prototype.endReceived = function () {
	        this._view.endReceived();
	        this.emit(BonusController.EndReceived);
	    };
	    BonusController.prototype.machineStopped = function () {
	        this.emit(BonusController.MachineStopped);
	    };
	    BonusController.prototype.winCalculationFinished = function () {
	        this.emit(BonusController.WinCalculationFinished);
	    };
	    BonusController.prototype.winAnimatorTotalStart = function () {
	        this.emit(BonusController.WinAnimatorTotalStart);
	    };
	    BonusController.prototype.allWinsFinished = function () {
	        this.emit(BonusController.AllWinsFinished);
	    };
	    BonusController.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        this._view.intro(long, previousModule);
	    };
	    BonusController.prototype.introFinished = function () {
	        this.emit(BonusController.IntroFinished);
	    };
	    BonusController.prototype.outro = function () {
	        this._view.outro();
	    };
	    BonusController.prototype.outroFinished = function () {
	        this.emit(BonusController.OutroFinished);
	    };
	    BonusController.prototype.enable = function () {
	        this._view.enable();
	    };
	    BonusController.StartReceived = "eventStartReceived";
	    BonusController.SpinReceived = "eventSpinReceived";
	    BonusController.RespinReceived = "eventRespinReceived";
	    BonusController.EndReceived = "eventEndReceived";
	    BonusController.MachineStopped = "eventMachineStopped";
	    BonusController.WinCalculationFinished = "eventWinCalculationFinished";
	    BonusController.WinAnimatorTotalStart = "eventWinAnimatorTotalStart";
	    BonusController.AllWinsFinished = "eventAllWinsFinished";
	    BonusController.IntroFinished = "eventIntroFinished";
	    BonusController.OutroFinished = "eventOutroFinished";
	    BonusController = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Controller)
	    ], BonusController);
	    return BonusController;
	}(Controller_1.Controller));
	exports.BonusController = BonusController;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var FrameTimer_1 = __webpack_require__(9);
	var Symbols_1 = __webpack_require__(116);
	var Machine_1 = __webpack_require__(87);
	var SwitchElement_1 = __webpack_require__(90);
	var StageController_1 = __webpack_require__(6);
	var WinAnimator_1 = __webpack_require__(101);
	var GameManager_1 = __webpack_require__(23);
	var PlayList_1 = __webpack_require__(33);
	var HtmlController_1 = __webpack_require__(31);
	var AmbientBackground_1 = __webpack_require__(41);
	var WinAnimatorBonus_1 = __webpack_require__(117);
	var CustomUtils_1 = __webpack_require__(22);
	var BaseView_1 = __webpack_require__(86);
	var LayoutContainerElement_1 = __webpack_require__(110);
	var BonusView = (function (_super) {
	    __extends(BonusView, _super);
	    function BonusView() {
	        _super.call(this);
	        this._respinCounter = 0;
	        this._introDelay = FrameTimer_1.CreateFrameTimer("introDelay");
	        this._introDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.introFinished.bind(this));
	        this._outroDelay = FrameTimer_1.CreateFrameTimer("outroDelay");
	        this._outroDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.outroFinished.bind(this));
	        StageController_1.StageController.bonusStageContainer = this;
	    }
	    BonusView.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (this.childs != null) {
	            for (var key in this.childs) {
	                if (this.childs[key] instanceof Symbols_1.Symbols) {
	                    this._symbols = this.childs[key];
	                    this.removeChild(this._symbols);
	                }
	                if (this.childs[key] instanceof Machine_1.Machine) {
	                    this._machine = this.childs[key];
	                }
	                if (this.childs[key] instanceof WinAnimatorBonus_1.WinAnimatorBonus) {
	                    this._winAnimator = this.childs[key];
	                }
	                if (key === "BonusTransition" && this.childs[key] instanceof SwitchElement_1.SwitchElement) {
	                    this._transition = this.childs[key];
	                    this._transitionSceneHolder = this._transition.getChildElementByName("Scene");
	                }
	            }
	            this._bonusMessageStart = document.getElementById("bonusMessageStart");
	            if (this.childs["Background"] != null) {
	                this._background = this.childs["Background"];
	            }
	            if (false) {
	                if (this._symbols == null) {
	                    this.log("ERROR no symbols");
	                }
	                if (this._machine == null) {
	                    this.log("ERROR no machine");
	                }
	                if (this._winAnimator == null) {
	                    this.log("WARNING no winAnimator");
	                }
	                if (this._bonusMessageStart == null) {
	                    this.log("ERROR no bonusMessageStart");
	                }
	            }
	        }
	        this.setupTransitionSceneElement();
	    };
	    BonusView.prototype.disableLogo = function () {
	    };
	    BonusView.prototype.initReceived = function (controller) {
	        if (false) {
	            this.log("initReceived");
	        }
	        this._controller = controller;
	        if (this._symbols != null) {
	            if (this._machine != null) {
	                if (GameManager_1.GameManager.bonusRespinsResponse != null) {
	                    if (GameManager_1.GameManager.bonusRespinsResponse.initData != null &&
	                        GameManager_1.GameManager.bonusRespinsResponse.initData.reels !== null) {
	                        if (GameManager_1.GameManager.bonusRespinsResponse.initData.customData &&
	                            GameManager_1.GameManager.bonusRespinsResponse.initData.customData["symbolValues"]) {
	                            var bonusReels = GameManager_1.GameManager.bonusRespinsResponse.initData.customData["symbolValues"];
	                            this._machine.on(Machine_1.Machine.ReelStopped, this.onReelStopped.bind(this));
	                            this._machine.on(Machine_1.Machine.MachineStopped, this.machineStopped.bind(this));
	                            this._machine.initialize(this._symbols, GameManager_1.GameManager.bonusRespinsResponse.initData.reels, bonusReels, this.childs["BonusTeasing"], null, null, this._winAnimator);
	                        }
	                    }
	                    if (this._winAnimator != null) {
	                        this._winAnimator.on(WinAnimator_1.WinAnimator.FinishWinCalculation, this.finishWinCalculation.bind(this));
	                        this._winAnimator.on(WinAnimator_1.WinAnimator.FinishWinAnimator, this.finishWinAnimator.bind(this));
	                        this._winAnimator.on(WinAnimatorBonus_1.WinAnimatorBonus.WinAnimatorPrepared, this.winAnimatorScenePrepared.bind(this));
	                        this._winAnimator.on(WinAnimatorBonus_1.WinAnimatorBonus.TotalWinCountFinished, this.totalWinCountFinished.bind(this));
	                        this._winAnimator.on(WinAnimatorBonus_1.WinAnimatorBonus.WinAnimatorTotalStart, this.winAnimatorTotalStart.bind(this));
	                        this._winAnimator.initialize(this._symbols, null, this.childs["BonusNoWinContainer"], this.childs["BonusWinContainer"], this.childs["BonusStickyContainer"], this.childs["BonusCountingBlast"], this._background);
	                        this._winAnimator.initializeMultiplierContainer(this.childs["BigMultiplier"], this.childs["TopMultipliers"]);
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no bonus reponse");
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no machine");
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no symbols");
	            }
	        }
	        this.visible = false;
	    };
	    BonusView.prototype.initIntro = function () {
	        StageController_1.StageController.baseStage = false;
	        StageController_1.StageController.bonusStage = true;
	        this.visible = true;
	        AmbientBackground_1.AmbientBackground.changeAmbientBackground("bonus", 0);
	        if (BaseView_1.BaseView.BonusCounters != null && this.childs["BonusTopCounters"] != null) {
	            this.childs["BonusTopCounters"].addChild(BaseView_1.BaseView.BonusCounters);
	            BaseView_1.BaseView.BonusCounters.goToCase("BONUS");
	        }
	        this._winAnimator.initIntroSameSymbolsOnReel(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	        this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	        this._winAnimator.showInitSymbols(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	        this._winAnimator.showInitWins(GameManager_1.GameManager.bonusRespinsResponse.wins, GameManager_1.GameManager.bonusRespinsResponse.currentWin);
	        this._winAnimator.setRemainingCountToGrand(GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.customData["countOfBonusSymbols"]);
	        this._winAnimator.activateMultiplier(GameManager_1.GameManager.bonusRespinsResponse.gameMultiplier);
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin()) {
	            PlayList_1.PlayList.loop("SND_BonusWait");
	        }
	        else {
	            PlayList_1.PlayList.loop("SND_BonusLoop");
	            this._winAnimator.openVaults(true);
	        }
	    };
	    BonusView.prototype.spin = function () {
	        StageController_1.StageController.baseStage = false;
	        StageController_1.StageController.bonusStage = true;
	        this._respinCounter = 0;
	        PlayList_1.PlayList.loop("SND_BonusLoop");
	        if (this._bonusMessageStart != null &&
	            !this._bonusMessageStart.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._bonusMessageStart.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols);
	    };
	    BonusView.prototype.respin = function (spinBitmask) {
	        this._respinCounter++;
	        if (this._bonusMessageStart != null &&
	            !this._bonusMessageStart.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._bonusMessageStart.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        this._machine.spinStart(this._winAnimator.reset(true), true, this._winAnimator.currentSymbols, spinBitmask);
	    };
	    BonusView.prototype.stop = function () {
	        if (this._winAnimator.interruptAnimation()) {
	            this._machine.spinStop(null, true);
	        }
	    };
	    BonusView.prototype.startReceived = function () {
	        if (this._bonusMessageStart != null &&
	            !this._bonusMessageStart.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._bonusMessageStart.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	        this._winAnimator.showSymbols(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	    };
	    BonusView.prototype.spinReceived = function () {
	        this._machine.setStoppedSymbolsArray(GameManager_1.GameManager.bonusRespinsResponse.screen.reels);
	        this._machine.spinStop(null, false, true);
	    };
	    BonusView.prototype.endReceived = function () { };
	    BonusView.prototype.onReelStopped = function () {
	        this._winAnimator.onReelStopped(GameManager_1.GameManager.bonusRespinsResponse.screen.reels, this._machine.actualReelStopped);
	    };
	    BonusView.prototype.machineStopped = function () {
	        this._winAnimator.openVaults();
	        this.winAnimatorScenePrepared();
	    };
	    BonusView.prototype.winAnimatorScenePrepared = function () {
	        this._controller.machineStopped();
	        if (this._winAnimator.showWins(GameManager_1.GameManager.bonusRespinsResponse.wins, GameManager_1.GameManager.bonusRespinsResponse.currentWin, this._transition)) {
	            PlayList_1.PlayList.stop("SND_BonusLoop", 30);
	        }
	    };
	    BonusView.prototype.totalWinCountFinished = function () {
	        if (this._transition != null) {
	            this._transition.goToCase("FROM_TOTAL_COUNT");
	        }
	    };
	    BonusView.prototype.finishWinCalculation = function () {
	        this._controller.winCalculationFinished();
	    };
	    BonusView.prototype.finishWinAnimator = function () {
	        this._controller.allWinsFinished();
	        PlayList_1.PlayList.loop("SND_BonusWait", 30);
	    };
	    BonusView.prototype.winAnimatorTotalStart = function () {
	        this._controller.winAnimatorTotalStart();
	    };
	    BonusView.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        StageController_1.StageController.baseStage = false;
	        StageController_1.StageController.bonusStage = true;
	        this.visible = true;
	        this._transition.goToCase("BONUS_INTRO");
	        if (BaseView_1.BaseView.BonusCounters != null && this.childs["BonusTopCounters"] != null) {
	            this.childs["BonusTopCounters"].addChild(BaseView_1.BaseView.BonusCounters);
	            BaseView_1.BaseView.BonusCounters.goToCase("BONUS");
	            if (this._winAnimator != null) {
	                this._winAnimator.setRemainingCountToGrand(GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.customData["countOfBonusSymbols"]);
	                for (var i = 0; i < GameManager_1.GameManager.bonusRespinsResponse.screen.reels.length; i++) {
	                    if (GameManager_1.GameManager.bonusRespinsResponse.screen.reels[i].overlay != null) {
	                        this._winAnimator.updateActiveBonusCounters(GameManager_1.GameManager.bonusRespinsResponse.screen.reels[i].overlay);
	                    }
	                }
	            }
	        }
	        this._winAnimator.resetMultiplierContainer();
	        this._winAnimator.openVaults();
	        this._introDelay.start(30);
	    };
	    BonusView.prototype.introFinished = function () {
	        PlayList_1.PlayList.loop("SND_BonusLoop");
	        this._controller.introFinished();
	    };
	    BonusView.prototype.outro = function () {
	        StageController_1.StageController.bonusStage = true;
	        this.visible = true;
	        PlayList_1.PlayList.stop("SND_BonusLoop");
	        PlayList_1.PlayList.stop("SND_BonusWait");
	        this.outroToBase();
	    };
	    BonusView.prototype.outroToBase = function () {
	        this._winAnimator.resetAnimations();
	        if (this._transition != null) {
	            this._transition.goToCase("BONUS_OUTRO");
	        }
	        PlayList_1.PlayList.play("SND_BonusTransition");
	        this._outroDelay.start(90);
	    };
	    BonusView.prototype.outroFinished = function () {
	        StageController_1.StageController.bonusStage = false;
	        this.visible = false;
	        BaseView_1.BaseView.BonusCounters.goToCase("NORMAL");
	        AmbientBackground_1.AmbientBackground.changeAmbientBackground("base", 180, 60);
	        if (this._transition != null) {
	            this._transition.goToCase("RESET");
	        }
	        if (this.childs["TopMultipliers"]) {
	            this.childs["TopMultipliers"].goToCase("FADEOUT");
	        }
	        this._winAnimator.reset(true);
	        this._controller.outroFinished();
	    };
	    BonusView.prototype.enable = function () {
	        PlayList_1.PlayList.setVolume("SND_BaseLoop", 0);
	        PlayList_1.PlayList.stop("SND_BaseRespinLoop");
	        PlayList_1.PlayList.stop("SND_BaseRecapLoop");
	        PlayList_1.PlayList.play("SND_BonusMessage");
	        PlayList_1.PlayList.loop("SND_BonusWait");
	        if (this._bonusMessageStart != null &&
	            this._bonusMessageStart.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._bonusMessageStart.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    BonusView.prototype.setupTransitionSceneElement = function () {
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusReelsBg"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusReelsBg"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusTopCounters"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusTopCounters"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["TopMultipliers"],
	            parent: this,
	            index: this.getChildIndex(this.childs["TopMultipliers"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusNoWinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusNoWinContainer"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusWinContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusWinContainer"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusStickyContainer"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusStickyContainer"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BigMultiplier"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BigMultiplier"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusLogo"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusLogo"]),
	        });
	        this._transitionSceneHolder.addElement({
	            element: this.childs["BonusWinAnimator"],
	            parent: this,
	            index: this.getChildIndex(this.childs["BonusWinAnimator"]),
	        });
	    };
	    BonusView = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], BonusView);
	    return BonusView;
	}(LayoutContainerElement_1.LayoutContainerElement));
	exports.BonusView = BonusView;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ContainerElement_1 = __webpack_require__(82);
	var Symbol_1 = __webpack_require__(89);
	var StyleManager_1 = __webpack_require__(20);
	var Configuration_1 = __webpack_require__(57);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var Symbols = (function (_super) {
	    __extends(Symbols, _super);
	    function Symbols() {
	        _super.call(this);
	        this.symbols = [];
	        this.symbolsData = [];
	    }
	    Symbols.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        var configs;
	        if (node.hasAttribute(SymbolsAttributes.CONFIGS)) {
	            configs = node.getAttribute(SymbolsAttributes.CONFIGS).split(";");
	        }
	        if (this.childs != null) {
	            for (var key in this.childs) {
	                if (this.childs[key] instanceof Symbol_1.Symbol) {
	                    if (configs != null) {
	                        for (var i = 0; i < configs.length; i++) {
	                            this.childs[key].configurate(Configuration_1.Configuration.Configurations[configs[i]]);
	                        }
	                    }
	                    this.symbols.push(this.childs[key]);
	                }
	            }
	        }
	        if (this.symbols != null) {
	            this.createSymbolsData();
	        }
	        else {
	            if (false) {
	                this.log("ERROR no symbols");
	            }
	        }
	        this.removeChildren();
	        this.visible = false;
	        this.createObjectPool();
	    };
	    Symbols.prototype.createSymbolsData = function () {
	        if (false) {
	            this.log("createSymbolsData");
	        }
	        for (var i = 1; i <= this.symbols.length; i++) {
	            if (this.symbols[i - 1].hasElements) {
	                var caseElement = void 0;
	                var rotationBitmap = null;
	                var blurBitmap = null;
	                if (this.symbols[i - 1].hasCase(Symbol_1.Symbol.CaseRotation)) {
	                    caseElement = this.symbols[i - 1].getCase(Symbol_1.Symbol.CaseRotation);
	                }
	                else {
	                    if (this.symbols[i - 1].hasCase(Symbol_1.Symbol.CaseBlur)) {
	                        caseElement = this.symbols[i - 1].getCase(Symbol_1.Symbol.CaseBlur);
	                    }
	                    else {
	                        if (this.symbols[i - 1].hasCase(Symbol_1.Symbol.CaseNormal)) {
	                            caseElement = this.symbols[i - 1].getCase(Symbol_1.Symbol.CaseNormal);
	                        }
	                        else {
	                            if (false) {
	                                this.log("ERROR Symbol has no CaseRotation, CaseBlur nor CaseNormal. Symbol ID: " + i);
	                            }
	                        }
	                    }
	                }
	                rotationBitmap = this._getBitmapByCaseElement(caseElement);
	                if (rotationBitmap == null) {
	                    if (false) {
	                        this.log("ERROR no style, animation or image of symbol with ID: " +
	                            i +
	                            " case: " +
	                            Symbol_1.Symbol.CaseRotation);
	                    }
	                }
	                if (this.symbols[i - 1].hasCase(Symbol_1.Symbol.CaseBlur)) {
	                    caseElement = this.symbols[i - 1].getCase(Symbol_1.Symbol.CaseBlur);
	                }
	                blurBitmap = this._getBitmapByCaseElement(caseElement);
	                if (blurBitmap == null) {
	                    if (false) {
	                        this.log("ERROR no style, animation or image of symbol with ID: " + i + " case: " + Symbol_1.Symbol.CaseBlur);
	                    }
	                }
	                var object = {};
	                if (rotationBitmap != null) {
	                    object[Symbol_1.Symbol.CaseRotation] = rotationBitmap;
	                }
	                if (blurBitmap != null) {
	                    object[Symbol_1.Symbol.CaseBlur] = blurBitmap;
	                }
	                else {
	                    if (rotationBitmap != null) {
	                        object[Symbol_1.Symbol.CaseBlur] = rotationBitmap;
	                    }
	                }
	                if (object != null) {
	                    object["zIndex"] = this.symbols[i - 1].zIndex;
	                    this.symbolsData.push(object);
	                }
	            }
	        }
	    };
	    Symbols.prototype._getBitmapByCaseElement = function (caseElement) {
	        if (caseElement != null) {
	            if (caseElement.firstElementChild.hasAttribute("Style")) {
	                if (false) {
	                    this.log("WARNING Please use Animation attribute! Node: " +
	                        caseElement.parentNode.parentNode.nodeName +
	                        ", Case: " +
	                        caseElement.getAttribute("Case"));
	                }
	                if (StyleManager_1.StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")] != null) {
	                    if ((StyleManager_1.StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")].animation) != null) {
	                        return StageController_1.StageController.getTextureByResourceId((StyleManager_1.StyleManager.Styles[caseElement.firstElementChild.getAttribute("Style")].animation) + "0000");
	                    }
	                }
	            }
	            else if (caseElement.firstElementChild.hasAttribute("FromFrame")) {
	                if (caseElement.firstElementChild.getAttribute("FromFrame") != null) {
	                    return StageController_1.StageController.getTextureByResourceId(caseElement.firstElementChild.getAttribute("FromFrame"));
	                }
	            }
	            else if (caseElement.firstElementChild.hasAttribute("Image")) {
	                return StageController_1.StageController.getTextureByResourceId(caseElement.firstElementChild.getAttribute("Image"));
	            }
	            else {
	                return null;
	            }
	        }
	        return null;
	    };
	    Symbols.prototype.createObjectPool = function () {
	        this.objectPool = [];
	        for (var i = 0; i < this.symbols.length; i++) {
	            this.objectPool.push([]);
	        }
	        this.objectContainer = new ContainerElement_1.ContainerElement();
	        this.objectContainer.name = "ObjectContainer";
	    };
	    Symbols.prototype.getSymbol = function (id, caseType) {
	        var symbol;
	        if (this.objectPool[id].length === 0) {
	            symbol = this.symbols[id].clone();
	            symbol.name = "Symbol" + id;
	            symbol.id = id;
	        }
	        else {
	            symbol = this.objectPool[id].pop();
	        }
	        symbol.visible = true;
	        symbol.goToCase(caseType);
	        return symbol;
	    };
	    Symbols.prototype.returnSymbol = function (symbol) {
	        symbol.visible = false;
	        symbol.goToCase(Symbol_1.Symbol.CaseEmpty);
	        this.objectContainer.addChild(symbol);
	        this.objectPool[symbol.id].push(symbol);
	    };
	    Symbols = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Symbols);
	    return Symbols;
	}(ContainerElement_1.ContainerElement));
	exports.Symbols = Symbols;
	var SymbolsAttributes = {
	    CONFIGS: "Configs",
	};


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var WinAnimator_1 = __webpack_require__(101);
	var neo_games_1 = __webpack_require__(3);
	var Symbol_1 = __webpack_require__(89);
	var CustomUtils_1 = __webpack_require__(22);
	var Languages_1 = __webpack_require__(28);
	var BaseView_1 = __webpack_require__(86);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var ImageTextCounterElement_1 = __webpack_require__(105);
	var PlayList_1 = __webpack_require__(33);
	var GameManager_1 = __webpack_require__(23);
	var WinAnimatorBonus = (function (_super) {
	    __extends(WinAnimatorBonus, _super);
	    function WinAnimatorBonus() {
	        _super.apply(this, arguments);
	        this.reelsOrder = [0, 3, 6, 9, 12, 1, 4, 7, 10, 13, 2, 5, 8, 11, 14];
	        this.fullReels = [0, 0, 0, 0, 0];
	        this.multiplierTeasingIndex = -1;
	        this.multiplierReelIndex = -1;
	        this.blastForce = 0;
	    }
	    WinAnimatorBonus.prototype.initialize = function (symbols, paylines, noWinSymbolsContainer, symbolsContainer, stickyContainer, countingBlast, background) {
	        _super.prototype.initialize.call(this, symbols, paylines, noWinSymbolsContainer, symbolsContainer);
	        this.initializeStickyContainer(stickyContainer);
	        this.countingBlast = countingBlast;
	        this._background = background;
	    };
	    WinAnimatorBonus.prototype.initializeStickyContainer = function (stickyContainer) {
	        if (stickyContainer != null) {
	            this.stickyContainer = stickyContainer;
	            this.currentStickySymbols = [];
	            for (var i = 0; i < this.reelCount; i++) {
	                this.currentStickySymbols.push([]);
	                for (var j = 0; j < this.symbolCount; j++) {
	                    this.currentStickySymbols[i].push(null);
	                }
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.setRemainingCountToGrand = function (value) {
	        if (value != null) {
	            this.remainingCountToGrand = this.reelCount - value;
	            if (BaseView_1.BaseView.BonusCounters != null) {
	                BaseView_1.BaseView.BonusCounters.updateGrandCountToValue(this.remainingCountToGrand.toString(), this.remainingCountToGrand == 0 ? "EMPTY" : "SHOW");
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.decrementRemainingCount = function () {
	        if (this.remainingCountToGrand > 0) {
	            this.remainingCountToGrand--;
	            if (BaseView_1.BaseView.BonusCounters != null) {
	                if (this.remainingCountToGrand == 0) {
	                    BaseView_1.BaseView.BonusCounters.counterGoToCase(3, "POP");
	                }
	                else {
	                    BaseView_1.BaseView.BonusCounters.updateGrandCountToValue(this.remainingCountToGrand.toString(), "POP");
	                }
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.initializeMultiplierContainer = function (multiplierContainer, topMultipliersContainer) {
	        this.multiplierContainer = multiplierContainer;
	        this.topMultipliersContainer = topMultipliersContainer;
	        this.topMultiplier3x = this.topMultipliersContainer.getChildElementByName("X3");
	        this.topMultiplier4x = this.topMultipliersContainer.getChildElementByName("X4");
	        this.topMultiplier5x = this.topMultipliersContainer.getChildElementByName("X5");
	    };
	    WinAnimatorBonus.prototype.resetMultiplierContainer = function () {
	        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	        this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	        this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	        this.multiplierTeasingIndex = -1;
	        this.multiplierReelIndex = -1;
	    };
	    WinAnimatorBonus.prototype.onReelStopped = function (reelsData, reelIndex) {
	        if (this.currentStickySymbols[reelIndex][0] != null) {
	            return;
	        }
	        _super.prototype.onReelStopped.call(this, reelsData, reelIndex);
	        if (this.currentReels[reelIndex].transform) {
	            var stickySymbol = this.addStickySymbol(reelIndex);
	            if (stickySymbol.getCurrentCase() != "STICKY") {
	                stickySymbol.goToCase("TO_STICKY");
	                this.decrementRemainingCount();
	                switch (stickySymbol.id + 1) {
	                    case 9:
	                        PlayList_1.PlayList.play("SND_BonusMiniHit");
	                        break;
	                    case 10:
	                        PlayList_1.PlayList.play("SND_BonusMinorHit");
	                        break;
	                    case 11:
	                        PlayList_1.PlayList.play("SND_BonusMajorHit");
	                        break;
	                    default:
	                        PlayList_1.PlayList.play("SND_BaseStick");
	                        break;
	                }
	            }
	            this.updateActiveBonusCounters(this.currentReels[reelIndex].transform);
	        }
	        else {
	            this.currentSymbols[reelIndex][0].goToCase(Symbol_1.Symbol.CaseNowin);
	            this.noWinSymbolsContainer.addChild(this.currentSymbols[reelIndex][0]);
	        }
	        this.sortSymbols();
	        this.onSameSymbolsOnReelTeasingStop(reelIndex);
	    };
	    WinAnimatorBonus.prototype.openVaults = function (init) {
	        if (init === void 0) { init = false; }
	        var playSound = false;
	        for (var i = 0; i < this.reelCount; i++) {
	            if ((this.currentReels[i].transform || (init && this.currentReels[i].overlay)) &&
	                this.currentStickySymbols[i][0]) {
	                var symbol = this.currentStickySymbols[i][0];
	                init ? symbol.goToCase("STICKY_3") : symbol.goToCase("STICKY");
	                playSound = true;
	            }
	        }
	        if (!init && playSound) {
	            PlayList_1.PlayList.play("SND_BonusVaultOpen");
	        }
	    };
	    WinAnimatorBonus.prototype.initIntroSameSymbolsOnReel = function (reelsData) {
	        for (var i = 0; i < this.reelCount; i++) {
	            this.onSameSymbolsOnReel();
	        }
	    };
	    WinAnimatorBonus.prototype.multiplierGoToCase = function (multiplier, multiplierCase) {
	        if (multiplier != null && multiplier.getCurrentCase() !== multiplierCase) {
	            multiplier.goToCase(multiplierCase);
	        }
	    };
	    WinAnimatorBonus.prototype.onSameSymbolsOnReel = function () {
	        if (this.topMultipliersContainer != null) {
	            if (this.fullReels[0] >= 3 && this.fullReels[1] >= 3 && this.fullReels[2] >= 3) {
	                if (this.fullReels[3] >= 3) {
	                    if (this.fullReels[4] >= 3) {
	                        this.multiplierGoToCase(this.topMultiplier5x, "ACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    }
	                    else {
	                        this.multiplierGoToCase(this.topMultiplier4x, "ACTIVE");
	                        this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    }
	                }
	                else {
	                    this.multiplierGoToCase(this.topMultiplier3x, "ACTIVE");
	                }
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.activateMultiplier = function (multiplier) {
	        if (this.topMultipliersContainer != null) {
	            switch (multiplier) {
	                case 3:
	                    this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier3x, "ACTIVE");
	                    break;
	                case 4:
	                    this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier4x, "ACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    break;
	                case 5:
	                    this.multiplierGoToCase(this.topMultiplier5x, "ACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    break;
	                default:
	                    this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                    this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                    break;
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.onSameSymbolsOnReelTeasingStart = function (multiplier, reelIndex) {
	        if (this.topMultipliersContainer != null) {
	            if (multiplier > this.multiplierTeasingIndex) {
	                if (multiplier === 5) {
	                    this.multiplierGoToCase(this.topMultiplier5x, "BOUNCING");
	                }
	                else if (multiplier === 4) {
	                    this.multiplierGoToCase(this.topMultiplier4x, "BOUNCING");
	                }
	                else if (multiplier === 3) {
	                    this.multiplierGoToCase(this.topMultiplier3x, "BOUNCING");
	                }
	            }
	            this.multiplierTeasingIndex = multiplier;
	            this.multiplierReelIndex = reelIndex;
	        }
	    };
	    WinAnimatorBonus.prototype.onSameSymbolsOnReelTeasingStop = function (reelIndex) {
	        if (this.topMultipliersContainer != null) {
	            if (this.multiplierTeasingIndex > -1 && reelIndex === this.multiplierReelIndex) {
	                if (this.multiplierTeasingIndex === 5 && this.topMultiplier5x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier5x, "INACTIVE");
	                }
	                else if (this.multiplierTeasingIndex === 4 && this.topMultiplier4x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier4x, "INACTIVE");
	                }
	                else if (this.multiplierTeasingIndex === 3 && this.topMultiplier3x.getCurrentCase() === "BOUNCING") {
	                    this.multiplierGoToCase(this.topMultiplier3x, "INACTIVE");
	                }
	                this.multiplierTeasingIndex = -1;
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.showSymbols = function (reelsData) {
	        _super.prototype.showSymbols.call(this, reelsData);
	        for (var i = 0; i < this.reelCount; i++) {
	            if (this.currentReels[i].overlay) {
	                var stickySymbol = this.addStickySymbol(i);
	                stickySymbol.goToCase("INIT");
	            }
	            else {
	                this.currentSymbols[i][0].goToCase(Symbol_1.Symbol.CaseNowin);
	                this.noWinSymbolsContainer.addChild(this.currentSymbols[i][0]);
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.showInitSymbols = function (reelsData) {
	        _super.prototype.showSymbols.call(this, reelsData);
	        for (var i = 0; i < this.reelCount; i++) {
	            if (this.currentReels[i].overlay) {
	                var stickySymbol = this.addStickySymbol(i);
	                stickySymbol.goToCase("INIT");
	                this.updateActiveBonusCounters(this.currentReels[i].overlay);
	            }
	            else {
	                this.currentSymbols[i][0].goToCase(Symbol_1.Symbol.CaseNowin);
	                this.noWinSymbolsContainer.addChild(this.currentSymbols[i][0]);
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.showWins = function (wins, win, transition) {
	        this.currentWins = wins;
	        this.currentWin = win;
	        this._transition = transition;
	        this.resetAnimations();
	        if (wins != null && wins.length > 0) {
	            this.currentMultiplierIndex = 0;
	            for (var i = 0; i < this.multipliers.length; i++) {
	                if (this.currentWin / BetManager_1.BetManager.Bet >= this.multipliers[i]) {
	                    this.currentMultiplierIndex = i;
	                }
	            }
	            if (!this.showCustomWin()) {
	            }
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    WinAnimatorBonus.prototype.showCustomWin = function () {
	        var _this = this;
	        this.stopTimer();
	        this.currentCycle = -1;
	        var hasGrandWin = this.hasGrandWin();
	        if (hasGrandWin) {
	            this.currentWins = this.currentWins.slice();
	            var grandWin = this.currentWins.pop();
	            this.currentWins.unshift(grandWin);
	        }
	        this.reorderCurrentWins = [];
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.reorderCurrentWins.push(this.currentWins[i]);
	        }
	        this.reorderCurrentWins.sort(function (a, b) {
	            return _this.reelsOrder[a.mask.indexOf(1)] - _this.reelsOrder[b.mask.indexOf(1)];
	        });
	        if (hasGrandWin) {
	            if (this._transition != null) {
	                this._transition.goToCase("TO_TOTAL_COUNT_GRAND");
	            }
	            this.startAnimation(true);
	            return true;
	        }
	        if (this._transition != null) {
	            this._transition.goToCase("TO_TOTAL_COUNT");
	        }
	        this.startCountingTotalWin(hasGrandWin);
	    };
	    WinAnimatorBonus.prototype.startCountingTotalWin = function (hasGrandWin) {
	        PlayList_1.PlayList.play("SND_BonusWin");
	        for (var i = 0; i < this.reorderCurrentWins.length; i++) {
	            var topCounterIndex = -1;
	            if (this.reorderCurrentWins[i].symbols != null) {
	                topCounterIndex = this.reorderCurrentWins[i].symbols[0] - CustomUtils_1.CustomUtils.SymbolBonus - 1;
	            }
	            else {
	                topCounterIndex = 3;
	            }
	        }
	        this.startTimer(WinAnimatorBonus.ShowBigMultiplierTimer, hasGrandWin ? 20 : 80);
	        return true;
	    };
	    WinAnimatorBonus.prototype.showBigMultiplier = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null && GameManager_1.GameManager.bonusRespinsResponse.gameMultiplier > 2) {
	            if (this.multiplierContainer != null) {
	                this.multiplierContainer.goToCase("MULTIPLIER_" + GameManager_1.GameManager.bonusRespinsResponse.gameMultiplier);
	            }
	            this.stopTimer();
	            this.startTimer(WinAnimatorBonus.MultiplierAnimationTimer, CustomUtils_1.CustomUtils.MultiplierAnimationDuration - 15);
	            return;
	        }
	        this.emit(WinAnimatorBonus.WinAnimatorTotalStart);
	        this.showNextTotalWinStep();
	    };
	    WinAnimatorBonus.prototype.multiplyAmounts = function () {
	        for (var i = 0; i < this.currentWins.length; i++) {
	            this.winSymbolsGoToCase(i, "MULTIPLY", false);
	        }
	        this.stopTimer();
	        this.startTimer(WinAnimatorBonus.MultiplierAnimationTimerDelay, 15);
	    };
	    WinAnimatorBonus.prototype.showNextTotalWinStep = function () {
	        if (this.currentWins == null) {
	            return;
	        }
	        if (this.currentCycle == -1) {
	            this.currentCycle = 0;
	            PlayList_1.PlayList.loop("SND_BonusBlasts");
	            if (this._background) {
	                var casePart = this._background.getCurrentCase().substring(0, 6);
	                if (casePart != "CIRCLE") {
	                    this._background.goToCase("CIRCLE");
	                }
	            }
	            for (var i = 0; i < this.currentWins.length; i++) {
	                this.winSymbolsGoToCase(i, Symbol_1.Symbol.CaseWin, false);
	            }
	        }
	        if (this.currentCycle == this.reorderCurrentWins.length) {
	            this.startTimer(WinAnimatorBonus.TotalWinCountFinishTimer, 20);
	            return;
	        }
	        PlayList_1.PlayList.play("SND_BonusCountingBox");
	        this.winSymbolsGoToCase(this.currentCycle, "TO_TOTAL_WIN", false);
	        var delay;
	        if (this.blastForce > 0) {
	            if (this.blastForce === 1 &&
	                this.countingBlast != null &&
	                this.countingBlast.getChildElementByName("Blast")) {
	                this.countingBlast.getChildElementByName("Blast").setSpeed(1.2);
	                this.blastForce = 2;
	            }
	            delay = WinAnimatorBonus.SymbolTotalWinStepForcedAnimationDuration;
	        }
	        else {
	            delay = WinAnimatorBonus.SymbolTotalWinStepAnimationDuration;
	        }
	        this.currentCycle++;
	        this.startTimer(WinAnimatorBonus.SymbolTotalWinStepAnimationTimer, delay);
	    };
	    WinAnimatorBonus.prototype.updateTotalWinCount = function () {
	        if (this.currentCycle > 0 && this.totalWinCounter != null) {
	            if (this.currentCycle > 1) {
	                this.totalWinCounter.goToCase("POP");
	            }
	            else {
	                var hasGrandWin = this.hasGrandWin();
	                this.currentTotalWin = 0;
	                this.updateTotalWinCounterValue(-1);
	                this.totalWinCounter.goToCase("SHOW" + (hasGrandWin ? "_GRAND" : ""));
	            }
	            this.currentTotalWin = parseFloat(neo_common_1.NumberUtils.add(this.currentTotalWin.toString(), this.reorderCurrentWins[this.currentCycle - 1].amount.toString()));
	            this.updateTotalWinCounterValue(this.currentTotalWin);
	        }
	        var delay;
	        if (this.blastForce > 0) {
	            delay = WinAnimatorBonus.TotalWinStepUpdateDuration;
	        }
	        else {
	            delay = WinAnimatorBonus.TotalWinStepUpdateForcedDuration;
	        }
	        this.startTimer(WinAnimatorBonus.TotalWinStepUpdateTimer, delay);
	    };
	    WinAnimatorBonus.prototype.totalWinCountFinished = function () {
	        this.emit(WinAnimatorBonus.TotalWinCountFinished);
	        if (this.totalWinCounter != null) {
	            this.totalWinCounter.goToCase("HIDE");
	        }
	        this.startAnimation();
	        this.emit(WinAnimatorBonus.WinAnimatorTotalStart);
	    };
	    WinAnimatorBonus.prototype.finishFirstWins = function () {
	        this.emit(WinAnimator_1.WinAnimator.FinishWinAnimator);
	    };
	    WinAnimatorBonus.prototype.showInitWins = function (wins, win) {
	        this.currentWins = wins;
	        this.currentWin = win;
	        this.resetAnimations();
	        if (wins != null && wins.length > 0) {
	            this.currentMultiplierIndex = 0;
	            for (var i = 0; i < this.multipliers.length; i++) {
	                if (this.currentWin / BetManager_1.BetManager.Bet >= this.multipliers[i]) {
	                    this.currentMultiplierIndex = i;
	                }
	            }
	            this.showCustomInitWin();
	        }
	        else {
	        }
	    };
	    WinAnimatorBonus.prototype.showCustomInitWin = function () {
	        if (this.currentWins != null) {
	            this.reorderCurrentWins = [];
	            for (var i = 0; i < this.currentWins.length; i++) {
	                this.reorderCurrentWins.push(this.currentWins[i]);
	            }
	            for (var i = 0; i < this.currentWins.length; i++) {
	                this.winSymbolsGoToCase(i, "TO_TOTAL_WIN_NOWIN", false);
	            }
	            if (this.totalWinCounter != null) {
	                this.totalWinCounter.goToCase("EMPTY");
	            }
	            this.currentAnimationIndex = 0;
	            this.showAnimationEnd();
	        }
	    };
	    WinAnimatorBonus.prototype.reset = function (showLastSymbols) {
	        this.resetAnimations();
	        if (this.blastForce > 0) {
	            if (this.countingBlast != null && this.countingBlast.getChildElementByName("Blast")) {
	                this.countingBlast.getChildElementByName("Blast").setSpeed(0.7);
	            }
	            this.blastForce = 0;
	        }
	        return _super.prototype.reset.call(this, showLastSymbols);
	    };
	    WinAnimatorBonus.prototype.onTimerComplete = function () {
	        this.timer.stop();
	        switch (this.timerStatus) {
	            case WinAnimatorBonus.MultiplierAnimationTimer:
	                this.multiplyAmounts();
	                break;
	            case WinAnimatorBonus.MultiplierAnimationTimerDelay:
	                this.emit(WinAnimatorBonus.WinAnimatorTotalStart);
	                this.showNextTotalWinStep();
	                break;
	            case WinAnimatorBonus.ShowBigMultiplierTimer:
	                this.showBigMultiplier();
	                break;
	            case WinAnimatorBonus.StickyBonusTimer:
	                this.winAnimatorPrepared();
	                break;
	            case WinAnimatorBonus.SymbolTotalWinStepAnimationTimer:
	                this.updateTotalWinCount();
	                break;
	            case WinAnimatorBonus.TotalWinStepUpdateTimer:
	                this.showNextTotalWinStep();
	                break;
	            case WinAnimatorBonus.TotalWinCountFinishTimer:
	                this.totalWinCountFinished();
	                break;
	            default:
	                _super.prototype.onTimerComplete.call(this);
	        }
	    };
	    WinAnimatorBonus.prototype.sortSymbols = function () {
	        var _this = this;
	        var addQueue = [];
	        this.stickyContainer.children.forEach(function (symbol) {
	            addQueue.push(symbol);
	        });
	        this.stickyContainer.removeChildren();
	        addQueue.sort(function (a, b) { return a.reelIndex - b.reelIndex; });
	        addQueue.forEach(function (symbol) {
	            _this.stickyContainer.addChild(symbol);
	        });
	    };
	    WinAnimatorBonus.prototype.addCurrentSymbol = function (reelIndex, symbolIndex) {
	        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
	            var id = this.currentReels[reelIndex].symbols[symbolIndex];
	            var caseType = Symbol_1.Symbol.CaseNormal;
	            if (this.currentReels[reelIndex].overlay) {
	                id = this.currentReels[reelIndex].overlay[symbolIndex];
	            }
	            if (!CustomUtils_1.CustomUtils.isBonusSymbol(id)) {
	                id = CustomUtils_1.CustomUtils.SymbolEmpty;
	                caseType = Symbol_1.Symbol.CaseEmpty;
	            }
	            var symbol = this.symbols.getSymbol(id - 1, caseType);
	            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
	            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;
	            if (this.currentReels[reelIndex].customData != null && this.currentReels[reelIndex].customData > 0) {
	                var amount = this.currentReels[reelIndex].customData;
	                if (amount > 0) {
	                    symbol.setAmount(amount);
	                }
	            }
	            this.symbolsContainer.addChild(symbol);
	            this.currentSymbols[reelIndex][symbolIndex] = symbol;
	        }
	    };
	    WinAnimatorBonus.prototype.removeCurrentSymbol = function (reelIndex, symbolIndex) {
	        _super.prototype.removeCurrentSymbol.call(this, reelIndex, symbolIndex);
	        if (this.currentStickySymbols != null) {
	            if (this.currentStickySymbols[reelIndex][symbolIndex] !== null) {
	                this.symbols.returnSymbol(this.currentStickySymbols[reelIndex][symbolIndex]);
	                this.currentStickySymbols[reelIndex][symbolIndex] = null;
	                this.fullReels[reelIndex % 5]--;
	                if (this.fullReels[reelIndex % 5] < 0) {
	                    this.fullReels[reelIndex % 5] = 0;
	                }
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.allSymbolsGoToReset = function () {
	        _super.prototype.allSymbolsGoToReset.call(this);
	        for (var i = 0; i < this.reelCount; i++) {
	            if (this.currentSymbols[i][0] != null) {
	                this.currentSymbols[i][0].goToCase(Symbol_1.Symbol.CaseNowin);
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.winSymbolsGoToCaseAsScatter = function (winIndex, caseType) {
	        if (caseType == "TO_TOTAL_WIN") {
	            var topCounterIndex = 3;
	            if (BaseView_1.BaseView.BonusCounters != null) {
	                BaseView_1.BaseView.BonusCounters.counterGoToCase(topCounterIndex, "TOTAL_POP");
	            }
	            this.showBlast(-1, topCounterIndex);
	        }
	        return [];
	    };
	    WinAnimatorBonus.prototype.winSymbolsGoToCaseAsCustom = function (winIndex, caseType) {
	        var win = this.reorderCurrentWins[winIndex];
	        var symbols = [];
	        var reelIndex = win.mask.indexOf(1);
	        if (reelIndex < this.currentStickySymbols.length) {
	            var symbol = this.currentStickySymbols[reelIndex][0];
	            var topCounterIndex = win.symbols[0] - CustomUtils_1.CustomUtils.SymbolBonus - 1;
	            if (symbol != null) {
	                if (caseType == "TO_TOTAL_WIN") {
	                    this.showBlast(reelIndex, topCounterIndex);
	                }
	                symbol.setAmount(win.amount);
	                symbol.goToCase(caseType);
	                symbols.push(symbol);
	            }
	        }
	        return symbols;
	    };
	    WinAnimatorBonus.prototype.showBlast = function (reelIndex, topCounterIndex) {
	        if (this.countingBlast != null) {
	            var caseType = "SYMBOL_" + reelIndex;
	            if (topCounterIndex === 3) {
	                caseType = "COUNTER_" + topCounterIndex;
	            }
	            this.countingBlast.goToCase(caseType);
	        }
	    };
	    WinAnimatorBonus.prototype.createAnimations = function () {
	        _super.prototype.createAnimations.call(this);
	        if (this.childs["TotalWinCounter"]) {
	            this.totalWinCounter = this.childs["TotalWinCounter"];
	            this.totalWinCounter.goToCase("EMPTY");
	            this.animationsContainer.addChild(this.value);
	        }
	    };
	    WinAnimatorBonus.prototype.startAnimation = function (grandWin) {
	        if (grandWin === void 0) { grandWin = false; }
	        var win = this.currentWin;
	        if (grandWin) {
	            this.currentAnimationIndex = 1;
	            win = this.reorderCurrentWins[0].amount;
	            if (this._background) {
	                this._background.goToCase("CIRCLE");
	            }
	        }
	        else {
	            this.currentAnimationIndex = 0;
	            PlayList_1.PlayList.stop("SND_BonusBlasts", 30);
	            if (this._background) {
	                this._background.goToCase("EMPTY");
	            }
	        }
	        var animation = this.animations[this.currentAnimationIndex];
	        animation.visible = true;
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	            animation.play(parseInt(neo_common_1.NumberUtils.devide(win, BetManager_1.BetManager.CoinSize).toString()));
	        }
	        else {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	            animation.play(win);
	        }
	    };
	    WinAnimatorBonus.prototype.onAnimationFinished = function () {
	        if (this.currentAnimationIndex == 0) {
	            _super.prototype.onAnimationFinished.call(this);
	        }
	    };
	    WinAnimatorBonus.prototype.onAnimationComplete = function () {
	        if (this.currentAnimationIndex == 0) {
	            _super.prototype.onAnimationComplete.call(this);
	        }
	        else {
	            var hasGrandWin = this.hasGrandWin();
	            this.startCountingTotalWin(hasGrandWin);
	        }
	    };
	    WinAnimatorBonus.prototype.showAnimationEnd = function () {
	        this.currentAnimationFinished = true;
	        var animation = this.animations[this.currentAnimationIndex];
	        animation.visible = true;
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	            animation.goToOutro(parseInt(neo_common_1.NumberUtils.devide(this.currentWin, BetManager_1.BetManager.CoinSize).toString()));
	        }
	        else {
	            ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	            animation.goToOutro(this.currentWin);
	        }
	    };
	    WinAnimatorBonus.prototype.winAnimatorPrepared = function () {
	        this.stopTimer();
	        this.emit(WinAnimatorBonus.WinAnimatorPrepared);
	    };
	    WinAnimatorBonus.prototype.interruptAnimation = function () {
	        if (this.currentCycle > -1 && this.currentCycle < this.reorderCurrentWins.length) {
	            this.blastForce = 1;
	            return false;
	        }
	        else {
	            if (this.currentAnimationIndex != null) {
	                var animation = this.animations[this.currentAnimationIndex];
	                animation.visible = true;
	                if (AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.CoinSize != null) {
	                    ImageTextCounterElement_1.ImageTextCounterElement.Round = true;
	                    animation.goToOutro(parseInt(neo_common_1.NumberUtils.devide(this.currentWin, BetManager_1.BetManager.CoinSize).toString()));
	                }
	                else {
	                    ImageTextCounterElement_1.ImageTextCounterElement.Round = false;
	                    animation.goToOutro(this.currentWin);
	                }
	                this.currentAnimationIndex = null;
	                this.currentAnimationFinished = true;
	                this.emit(WinAnimator_1.WinAnimator.FinishWinAnimator);
	                this.emit(WinAnimator_1.WinAnimator.FinishWinCalculation);
	            }
	            return true;
	        }
	    };
	    WinAnimatorBonus.prototype.idle = function () {
	        for (var i = 0; i < this.getIdleActiveElementsCount(); i++) {
	            var symbol = this.currentSymbols[Math.floor(Math.random() * this.reelCount)][Math.floor(Math.random() * this.symbolCount)];
	            if (symbol != null && symbol.getCurrentCase() === Symbol_1.Symbol.CaseNormal) {
	                if (symbol.hasCase(Symbol_1.Symbol.CaseIdle)) {
	                    symbol.goToCase(Symbol_1.Symbol.CaseIdle);
	                }
	            }
	        }
	        this.startTimer(WinAnimator_1.WinAnimator.Idle, this.getIdleDelay());
	    };
	    WinAnimatorBonus.prototype.getInitialIdleDelay = function () {
	        return 120;
	    };
	    WinAnimatorBonus.prototype.getIdleDelay = function () {
	        return 120;
	    };
	    WinAnimatorBonus.prototype.isGrandWin = function (index) {
	        if (this.currentWins != null && index < this.currentWins.length) {
	            if (this.currentWins[index].trigger == neo_games_1.Communication.Game.WinTrigger.Scatter) {
	                return true;
	            }
	        }
	        return false;
	    };
	    WinAnimatorBonus.prototype.hasGrandWin = function () {
	        if (this.currentWins != null) {
	            for (var i = 0; i < this.currentWins.length; i++) {
	                if (this.isGrandWin(i)) {
	                    return true;
	                }
	            }
	        }
	        return false;
	    };
	    WinAnimatorBonus.prototype.updateTotalWinCounterValue = function (value) {
	        if (this.totalWinCounter != null) {
	            this.updateElementValue(this.totalWinCounter.getChildElementByName("Amount"), value);
	            this.updateElementValue(this.totalWinCounter.getChildElementByName("AmountGlow"), value);
	        }
	    };
	    WinAnimatorBonus.prototype.updateElementValue = function (element, value) {
	        if (element != null) {
	            element.bitmapText.text = value > -1 ? Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, value.toString()) : "";
	            element.realign();
	        }
	    };
	    WinAnimatorBonus.prototype.updateActiveBonusCounters = function (symbols) {
	        for (var i = 0; i < symbols.length; i++) {
	            if (CustomUtils_1.CustomUtils.isBonusSymbol(symbols[i])) {
	                var topCounterIndex = symbols[i] - CustomUtils_1.CustomUtils.SymbolBonus - 1;
	                if (topCounterIndex != 3) {
	                    BaseView_1.BaseView.BonusCounters.counterGoToCase(topCounterIndex, "POP");
	                }
	            }
	        }
	    };
	    WinAnimatorBonus.prototype.addStickySymbol = function (reelIndex) {
	        var stickySymbol = this.currentSymbols[reelIndex][0];
	        if (stickySymbol != null) {
	            stickySymbol.reelIndex = reelIndex;
	            this.currentStickySymbols[reelIndex][0] = stickySymbol;
	            this.currentSymbols[reelIndex][0] = null;
	            this.stickyContainer.addChild(stickySymbol);
	            this.fullReels[reelIndex % 5]++;
	            if (this.fullReels[reelIndex % 5] > 3) {
	                this.fullReels[reelIndex % 5] = 3;
	            }
	            this.onSameSymbolsOnReel();
	        }
	        return stickySymbol;
	    };
	    WinAnimatorBonus.WinAnimatorPrepared = "eventWinAnimatorPrepared";
	    WinAnimatorBonus.TotalWinCountFinished = "eventTotalWinCountFinished";
	    WinAnimatorBonus.WinAnimatorTotalStart = "eventWinAnimatorTotalStart";
	    WinAnimatorBonus.MultiplierAnimationTimer = "multiplierAnimationTimer";
	    WinAnimatorBonus.MultiplierAnimationTimerDelay = "multiplierAnimationTimerDelay";
	    WinAnimatorBonus.ShowBigMultiplierTimer = "showBigMultiplierTimer";
	    WinAnimatorBonus.StickyBonusTimer = "stickyBonusTimer";
	    WinAnimatorBonus.SymbolTotalWinStepAnimationTimer = "symbolTotalWinStepAnimationTimer";
	    WinAnimatorBonus.TotalWinStepUpdateTimer = "totalWinStepUpdateTimer";
	    WinAnimatorBonus.TotalWinCountFinishTimer = "totalWinCountFinishTimer";
	    WinAnimatorBonus.SymbolTotalWinStepAnimationDuration = 30;
	    WinAnimatorBonus.SymbolTotalWinStepForcedAnimationDuration = 10;
	    WinAnimatorBonus.TotalWinStepUpdateDuration = 10;
	    WinAnimatorBonus.TotalWinStepUpdateForcedDuration = 3;
	    WinAnimatorBonus = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], WinAnimatorBonus);
	    return WinAnimatorBonus;
	}(WinAnimator_1.WinAnimator));
	exports.WinAnimatorBonus = WinAnimatorBonus;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var DataManager_1 = __webpack_require__(26);
	var GameManager_1 = __webpack_require__(23);
	var MessageManager_1 = __webpack_require__(42);
	var BonusModel = (function () {
	    function BonusModel(controller) {
	        this.controller = controller;
	    }
	    BonusModel.prototype.start = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient.bonusRespinsStart().then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.startReceived.bind(_this), response);
	        });
	    };
	    BonusModel.prototype.spin = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient
	            .bonusRespinsSpin(neo_games_1.Communication.Game.GameModules.BonusRespins)
	            .then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.spinReceived.bind(_this), response);
	        });
	    };
	    BonusModel.prototype.end = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient.endBonusRespins().then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.endReceived.bind(_this), response);
	        });
	    };
	    BonusModel.prototype.respin = function () {
	        var _this = this;
	        if (GameManager_1.GameManager.requestSend) {
	            return;
	        }
	        GameManager_1.GameManager.requestSend = true;
	        DataManager_1.DataManager.controlAutoplay();
	        GameManager_1.GameManager.gameClient
	            .respin(neo_games_1.Communication.Game.GameModules.BonusRespins, GameManager_1.GameManager.bonusRespinsResponse.respin)
	            .then(function (response) {
	            MessageManager_1.MessageManager.postpone(_this.respinReceived.bind(_this), response);
	        });
	    };
	    BonusModel.prototype.startReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            neo_games_1.Platforms.Platforms.featureStarted({ type: neo_games_1.Communication.Game.GameModules.BonusRespins });
	            this.controller.startReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    BonusModel.prototype.spinReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.spinReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    BonusModel.prototype.endReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            neo_games_1.Platforms.Platforms.featureFinished({ type: neo_games_1.Communication.Game.GameModules.BonusRespins });
	            this.controller.endReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    BonusModel.prototype.respinReceived = function (response) {
	        if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	            GameManager_1.GameManager.parseResponses(response);
	            DataManager_1.DataManager.updateResponseData();
	            this.controller.respinReceived();
	        }
	        GameManager_1.GameManager.requestSend = false;
	    };
	    return BonusModel;
	}());
	exports.BonusModel = BonusModel;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var FrameTimer_1 = __webpack_require__(9);
	var ComponentTypes_1 = __webpack_require__(14);
	var UserControls_1 = __webpack_require__(73);
	var HtmlController_1 = __webpack_require__(31);
	var GameManager_1 = __webpack_require__(23);
	var GameData_1 = __webpack_require__(24);
	var GameActions_1 = __webpack_require__(84);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var DataManager_1 = __webpack_require__(26);
	var LimitDialog_1 = __webpack_require__(52);
	var BonusActions_1 = __webpack_require__(112);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var BonusController_1 = __webpack_require__(114);
	var CustomUtils_1 = __webpack_require__(22);
	var PlayList_1 = __webpack_require__(33);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var WinType = neo_games_1.Communication.Game.WinType;
	var MobileBonusUserControls = (function (_super) {
	    __extends(MobileBonusUserControls, _super);
	    function MobileBonusUserControls() {
	        _super.call(this, "bonus");
	        this._wasCalclulated = true;
	        this._machineStopped = true;
	        this.spinBitmask = 31;
	    }
	    MobileBonusUserControls.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.registerActions();
	        this._afterWinDelay = FrameTimer_1.CreateFrameTimer("afterWinDelay");
	        this._afterWinDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.prepareNewGameRound.bind(this));
	        this._autoplayDelay = FrameTimer_1.CreateFrameTimer("autoplayDelay");
	        this._autoplayDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.autoplayDelayed.bind(this));
	        this._counterDelay = FrameTimer_1.CreateFrameTimer("counterDelay");
	        this._counterDelay.on(FrameTimer_1.FrameTimerEvents.Complete, this.updateCounter.bind(this));
	        this._userControls = document.getElementById("bonusUserControls");
	        this._counter = document.getElementById("bonusCounter");
	        this._playButtonDelay = FrameTimer_1.CreateFrameTimer("_playButtonDelay");
	        this._playButtonDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionStart, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }.bind(this));
	        this._backButtonDelay = FrameTimer_1.CreateFrameTimer("_backButtonDelay");
	        this._backButtonDelay.on(FrameTimer_1.FrameTimerEvents.Complete, function () {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionBack, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }.bind(this));
	    };
	    MobileBonusUserControls.prototype.addController = function (controller) {
	        this._controller = controller;
	        this._controller.on(BonusController_1.BonusController.StartReceived, this.startReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.SpinReceived, this.spinReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.RespinReceived, this.respinReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.EndReceived, this.endReceived.bind(this));
	        this._controller.on(BonusController_1.BonusController.MachineStopped, this.machineStopped.bind(this));
	        this._controller.on(BonusController_1.BonusController.WinCalculationFinished, this.winCalculationFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.WinAnimatorTotalStart, this.winAnimatorTotalStart.bind(this));
	        this._controller.on(BonusController_1.BonusController.AllWinsFinished, this.allWinsFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.IntroFinished, this.introFinished.bind(this));
	        this._controller.on(BonusController_1.BonusController.OutroFinished, this.outroFinished.bind(this));
	    };
	    MobileBonusUserControls.prototype.registerActions = function () {
	        this.actions.registerActions((_a = {},
	            _a[BonusActions_1.BonusActions.ActionStart] = false,
	            _a[BonusActions_1.BonusActions.ActionBack] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplay] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplayStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSpin] = false,
	            _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	            _a
	        ));
	        var _a;
	    };
	    MobileBonusUserControls.prototype.initReceived = function () {
	        this._userControls_supreme = document.getElementById("userControls_supreme");
	        _super.prototype.initReceived.call(this);
	        this._controller.initReceived();
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    MobileBonusUserControls.prototype.restoreGameRound = function () {
	        this.prepareNewGameRound();
	    };
	    MobileBonusUserControls.prototype.startReceived = function () {
	        ModuleManager_1.ModuleManager.outroModule(GameModules.Base);
	    };
	    MobileBonusUserControls.prototype.spinReceived = function () {
	        if (DataManager_1.DataManager.quickspinEnabled()) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        }
	    };
	    MobileBonusUserControls.prototype.respinReceived = function () {
	        if (DataManager_1.DataManager.quickspinEnabled()) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            this._controller.stop();
	        }
	        else {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataRoundId);
	        }
	    };
	    MobileBonusUserControls.prototype.endReceived = function () {
	        ModuleManager_1.ModuleManager.outroModule(GameModules.BonusRespins);
	    };
	    MobileBonusUserControls.prototype.dispatchAction = function (action) {
	        if (action === GameActions_1.GameActions.ActionSpinOrStop) {
	            if (this.actions.getActionState(BonusActions_1.BonusActions.ActionStart)) {
	                action = BonusActions_1.BonusActions.ActionStart;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionBack)) {
	                action = BonusActions_1.BonusActions.ActionBack;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionSpin)) {
	                action = BonusActions_1.BonusActions.ActionSpin;
	            }
	            else if (this.actions.getActionState(BonusActions_1.BonusActions.ActionSpinStop)) {
	                action = BonusActions_1.BonusActions.ActionSpinStop;
	            }
	            else {
	                return;
	            }
	        }
	        if (this.actions.getActionState(action)) {
	            _super.prototype.dispatchAction.call(this, action);
	            switch (action) {
	                case BonusActions_1.BonusActions.ActionStart:
	                    this.start();
	                    break;
	                case BonusActions_1.BonusActions.ActionBack:
	                    this.back();
	                    break;
	                case BonusActions_1.BonusActions.ActionSpin:
	                    this.spin();
	                    break;
	                case BonusActions_1.BonusActions.ActionSpinStop:
	                    this.stop();
	                    break;
	                case BonusActions_1.BonusActions.ActionSkipWin:
	                    this.skipWin();
	                    break;
	                case BonusActions_1.BonusActions.ActionAutoplay:
	                    this.autoplay();
	                    break;
	                case BonusActions_1.BonusActions.ActionAutoplayStop:
	                    this.autoplayStop();
	                    break;
	            }
	        }
	    };
	    MobileBonusUserControls.prototype.start = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        this._controller.start();
	    };
	    MobileBonusUserControls.prototype.spin = function () {
	        this._machineStopped = false;
	        this.respin();
	    };
	    MobileBonusUserControls.prototype.respin = function () {
	        DataManager_1.DataManager.Collectable = false;
	        ModuleManager_1.ModuleManager.disableGamble();
	        this.actions.disableAllActions();
	        if (this._counter != null) {
	            this._counter.classList.remove("bounce1");
	            this._counter.classList.remove("bounce2");
	            this._counter.classList.remove("bounce3");
	        }
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, (GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount - 1).toString());
	        if (DataManager_1.DataManager.Autoplay) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	        }
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        this.spinBitmask = 32767;
	        this._controller.respin(this.spinBitmask);
	        neo_games_1.Platforms.Platforms.spinStarted();
	    };
	    MobileBonusUserControls.prototype.back = function () {
	        this.disable();
	        ModuleManager_1.ModuleManager.endBonus();
	    };
	    MobileBonusUserControls.prototype.stop = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        HtmlController_1.HtmlController.dispatchUiAction("");
	        DataManager_1.DataManager.quickspinStopped();
	        this._controller.stop();
	    };
	    MobileBonusUserControls.prototype.end = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null && GameManager_1.GameManager.bonusRespinsResponse.totalWin > 0) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.bonusRespinsResponse.totalWin);
	        }
	        this._controller.end();
	    };
	    MobileBonusUserControls.prototype.autoplayDelayed = function () {
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	    };
	    MobileBonusUserControls.prototype.prepareSkipWin = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0 ||
	            !AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	            return;
	        }
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSkipWin, true);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionSkipWin, true);
	    };
	    MobileBonusUserControls.prototype.skipWin = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSkipWin, false);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionSkipWin, false);
	        this._autoplayDelay.stop();
	        if (DataManager_1.DataManager.Autoplay) {
	            this.autoplay();
	        }
	        else {
	            this.spin();
	        }
	    };
	    MobileBonusUserControls.prototype.autoplay = function () {
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.AutoplayPaused) {
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionAutoplayStop, AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled);
	            return;
	        }
	        if (DataManager_1.DataManager.AutoplayCount === "∞") {
	            DataManager_1.DataManager.Autoplay = true;
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	            this.spin();
	        }
	        else {
	            DataManager_1.DataManager.AutoplayCount = (parseInt(DataManager_1.DataManager.AutoplayCount) - 1).toString();
	            if (parseInt(DataManager_1.DataManager.AutoplayCount) >= 0) {
	                DataManager_1.DataManager.Autoplay = true;
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataAutoplayCount, DataManager_1.DataManager.AutoplayCount);
	                this.spin();
	            }
	            else {
	                DataManager_1.DataManager.Autoplay = false;
	                this.prepareNewGameRound();
	            }
	        }
	    };
	    MobileBonusUserControls.prototype.autoplayStop = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, false);
	        HtmlController_1.HtmlController.updateActionElement(BonusActions_1.BonusActions.ActionAutoplayStop, false);
	    };
	    MobileBonusUserControls.prototype.machineStopped = function () {
	        this._machineStopped = true;
	        neo_games_1.Platforms.Platforms.spinEnded();
	        this._wasCalclulated = GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0;
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        if (CustomUtils_1.CustomUtils.isBonusRespin()) {
	            if (GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0) {
	                this._counterDiff =
	                    GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount -
	                        parseInt(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBonusSpinRemainingCount));
	                if (this._counterDiff > 0) {
	                    if (this._counter != null) {
	                        this._counter.classList.add("bounce" + this._counterDiff);
	                    }
	                    this.updateCounter();
	                }
	                else {
	                    this.machineStopFinished();
	                }
	            }
	        }
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            if (this._userControls != null) {
	                this._userControls.classList.add("_totalCount");
	            }
	            this.actions.disableAllActions();
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBonusUserControls.prototype.machineStopFinished = function () {
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, false);
	        this.prepareNewGameRound();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        if (GameManager_1.GameManager.bonusRespinsResponse.currentWin > 0) {
	            this._afterWinDelay.start(30);
	        }
	        else {
	            this.prepareNewGameRound();
	        }
	        if (DataManager_1.DataManager.Autoplay && GameManager_1.GameManager.bonusRespinsResponse.currentWin === 0) {
	            this._autoplayDelay.start(15);
	        }
	    };
	    MobileBonusUserControls.prototype.winAnimatorTotalStart = function () {
	        this._counter.classList.add("_hidden");
	        this.actions.changeActionState(BonusActions_1.BonusActions.ActionSpinStop, AppContext_1.AppContext.gameConfiguration.GameEnableReelsStop);
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBonusUserControls.prototype.winCalculationFinished = function () {
	        this._afterWinDelay.stop();
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (CustomUtils_1.CustomUtils.isBonusRespin()) {
	            this.disable();
	            if (DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionState(BonusActions_1.BonusActions.ActionAutoplayStop, true);
	                HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            }
	            return;
	        }
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.actions.disableAllActions();
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    MobileBonusUserControls.prototype.allWinsFinished = function () {
	        if (GameManager_1.GameManager.bonusRespinsResponse != null && GameManager_1.GameManager.bonusRespinsResponse.currentWin > 0) {
	            neo_games_1.Platforms.Platforms.win(GameManager_1.GameManager.bonusRespinsResponse.currentWin);
	        }
	        this._wasCalclulated = true;
	        this._afterWinDelay.stop();
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.actions.disableAllActions();
	            this._backButtonDelay.stop();
	            this._backButtonDelay.start(90);
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    MobileBonusUserControls.prototype.updateCounter = function () {
	        if (this._counterDiff > 0) {
	            var remainingCount = parseInt(DataManager_1.DataManager.getDataById(GameData_1.GameData.DataBonusSpinRemainingCount));
	            remainingCount++;
	            DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, remainingCount.toString());
	            DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, remainingCount.toString());
	            this._counterDiff--;
	            PlayList_1.PlayList.play("SND_BonusRespinCounter");
	            this._counterDelay.start(15);
	        }
	        else {
	            this._counter.classList.remove("bounce1");
	            this._counter.classList.remove("bounce2");
	            this._counter.classList.remove("bounce3");
	            this.machineStopFinished();
	        }
	    };
	    MobileBonusUserControls.prototype.initIntro = function () {
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.add("bonus");
	        }
	        _super.prototype.initIntro.call(this);
	        this._controller.initIntro();
	        neo_games_1.Platforms.Platforms.featureInit({ type: neo_games_1.Communication.Game.GameModules.BonusRespins });
	        if (CustomUtils_1.CustomUtils.isLastBonusSpin(this.limit.bind(this))) {
	            if (this._userControls != null) {
	                this._userControls.classList.add("_totalCount");
	            }
	            this._counter.classList.add("_hidden");
	            this.actions.disableAllActions();
	            this.actions.changeActionState(BonusActions_1.BonusActions.ActionBack, true);
	            HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	            return;
	        }
	        this.prepareNewGameRound();
	    };
	    MobileBonusUserControls.prototype.intro = function (long, previousModule) {
	        if (long === void 0) { long = false; }
	        FreeRoundBonus_1.FreeRoundBonus.disableUi();
	        DataManager_1.DataManager.updateGameDataFromModule(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        this._controller.intro(long, previousModule);
	        if (this._userControls != null) {
	            this._userControls.style.display = "block";
	        }
	        if (this._userControls_supreme != null) {
	            this._userControls_supreme.style.display = "block";
	        }
	        if (this._userControls_supreme != null && !this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.add("bonus");
	        }
	        this._counter.classList.remove("_hidden");
	    };
	    MobileBonusUserControls.prototype.introFinished = function () {
	        this.prepareNewGameRound();
	        if (this._userControls != null && this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    MobileBonusUserControls.prototype.outro = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        this._controller.outro();
	        if (this._userControls != null && !this._userControls.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	        if (this._userControls_supreme != null &&
	            !this._userControls_supreme.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            this._userControls_supreme.classList.add(HtmlController_1.HtmlController.DisabledClass);
	        }
	    };
	    MobileBonusUserControls.prototype.outroFinished = function () {
	        ModuleManager_1.ModuleManager.introModule(GameModules.Base, true, GameModules.BonusRespins);
	        if (this._userControls != null) {
	            this._userControls.classList.remove("_totalCount");
	        }
	        if (this._userControls != null) {
	            this._userControls.style.display = "none";
	        }
	        if (this._userControls_supreme != null && this._userControls_supreme.classList.contains("bonus")) {
	            this._userControls_supreme.classList.remove("bonus");
	        }
	    };
	    MobileBonusUserControls.prototype.prepareNewGameRound = function () {
	        this._afterWinDelay.stop();
	        if (DataManager_1.DataManager.GameLimit) {
	            DataManager_1.DataManager.Autoplay = false;
	            this.limit();
	        }
	        else {
	            if (!DataManager_1.DataManager.Autoplay) {
	                this.actions.changeActionStates((_a = {},
	                    _a[BonusActions_1.BonusActions.ActionStart] = false,
	                    _a[BonusActions_1.BonusActions.ActionBack] = false,
	                    _a[BonusActions_1.BonusActions.ActionAutoplay] = !DataManager_1.DataManager.Autoplay && AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BonusActions_1.BonusActions.ActionAutoplayStop] = DataManager_1.DataManager.Autoplay && AppContext_1.AppContext.gameConfiguration.AutoplayModeEnabled,
	                    _a[BonusActions_1.BonusActions.ActionSpin] = true,
	                    _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	                    _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	                    _a
	                ));
	            }
	            else {
	                this.prepareSkipWin();
	            }
	        }
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	        var _a;
	    };
	    MobileBonusUserControls.prototype.limit = function () {
	        LimitDialog_1.LimitDialog.openDialog();
	        this.actions.changeActionStates((_a = {},
	            _a[BonusActions_1.BonusActions.ActionStart] = false,
	            _a[BonusActions_1.BonusActions.ActionBack] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplay] = false,
	            _a[BonusActions_1.BonusActions.ActionAutoplayStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSpin] = false,
	            _a[BonusActions_1.BonusActions.ActionSpinStop] = false,
	            _a[BonusActions_1.BonusActions.ActionSkipWin] = false,
	            _a
	        ));
	        var _a;
	    };
	    MobileBonusUserControls.prototype.enable = function () {
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinRemainingCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.remainingCount.toString());
	        DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataBonusSpinCount, GameManager_1.GameManager.bonusRespinsResponse.bonusRespins.totalCount.toString());
	        this._playButtonDelay.stop();
	        this._playButtonDelay.start(30);
	        this._controller.enable();
	    };
	    MobileBonusUserControls.prototype.restoreActions = function () {
	        _super.prototype.restoreActions.call(this);
	        if (DataManager_1.DataManager.Autoplay &&
	            this._machineStopped &&
	            this.actions.getActionState(BonusActions_1.BonusActions.ActionAutoplayStop)) {
	            this._autoplayDelay.stop();
	            this._autoplayDelay.start(30);
	        }
	    };
	    MobileBonusUserControls.prototype.disable = function () {
	        this.actions.disableAllActions();
	        HtmlController_1.HtmlController.updateActionElements(this.getAllActions());
	    };
	    MobileBonusUserControls = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], MobileBonusUserControls);
	    return MobileBonusUserControls;
	}(UserControls_1.UserControls));
	exports.MobileBonusUserControls = MobileBonusUserControls;


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ActionManager = (function () {
	    function ActionManager() {
	    }
	    ActionManager.parseActionSets = function (startNode) {
	        if (!startNode) {
	            return;
	        }
	        ActionManager.getNodesList(startNode.firstElementChild)
	            .reverse()
	            .filter(function (node) {
	            return node.hasAttribute("Class") &&
	                node.getAttribute("Class") === "ActionSet" &&
	                neo_common_1.EngineComponentFactory.isTypeOf("ActionSet", ComponentTypes_1.ComponentTypes.ActionSet);
	        })
	            .forEach(function (node) { return neo_common_1.EngineComponentFactory.get("ActionSet").RegisterActionSet(node); });
	    };
	    ActionManager.getNodesList = function (node, nodeList) {
	        if (nodeList === void 0) { nodeList = []; }
	        if (!node) {
	            return nodeList;
	        }
	        if (node.nextElementSibling) {
	            nodeList = ActionManager.getNodesList(node.nextElementSibling, nodeList);
	        }
	        return nodeList.concat(node);
	    };
	    ActionManager.log = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("ActionManager", data);
	        }
	    };
	    return ActionManager;
	}());
	exports.ActionManager = ActionManager;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var BaseElement_1 = __webpack_require__(12);
	var ComponentTypes_1 = __webpack_require__(14);
	var CustomUtils_1 = __webpack_require__(22);
	var SpineElement = (function (_super) {
	    __extends(SpineElement, _super);
	    function SpineElement() {
	        _super.call(this);
	        this.spine = null;
	        this.mixes = [];
	        PIXI.ticker.shared.add(this.update, this, PIXI.UPDATE_PRIORITY.HIGH);
	    }
	    Object.defineProperty(SpineElement.prototype, "speed", {
	        get: function () {
	            return this.spine.state.timeScale;
	        },
	        set: function (value) {
	            this.spine.state.timeScale = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SpineElement.prototype.update = function (deltaTime) {
	        if (this.visible && this.spine) {
	            this.spine.update((deltaTime / PIXI.ticker.shared.speed / PIXI.settings.TARGET_FPMS) * 0.001);
	        }
	    };
	    SpineElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        var spine = node.hasAttribute(exports.SpineElementAttributes.SPINE)
	            ? node.getAttribute(exports.SpineElementAttributes.SPINE)
	            : "spine";
	        var mixes = node.hasAttribute(exports.SpineElementAttributes.MIXES)
	            ? neo_common_1.ArrayUtils.stringArray(node.getAttribute(exports.SpineElementAttributes.MIXES), "|")
	            : [];
	        for (var i = 0; i < mixes.length; i++) {
	            var mix = neo_common_1.ArrayUtils.stringArray(mixes[i]);
	            this.mixes.push({ from: mix[0].trim(), to: mix[1].trim(), duration: parseFloat(mix[2]) });
	        }
	        this.createSpine(spine);
	        this.setMixes();
	    };
	    SpineElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.SpineElementAttributes.SPEED)) {
	            this.spine.state.timeScale = parseFloat(node.getAttribute(exports.SpineElementAttributes.SPEED));
	        }
	        else if (node.hasAttribute(exports.SpineElementAttributes.RANDOM_SPEED)) {
	            this.spine.state.timeScale = SpineElement.getRandomSpeed(node);
	        }
	        if (node.hasAttribute(exports.SpineElementAttributes.TINT)) {
	            var tint = node.getAttribute(exports.SpineElementAttributes.TINT);
	            switch (tint) {
	                case "none":
	                    this.spine.tint = 0xffffff;
	                    break;
	                case "dynamic":
	                    this.spine.tint = parseInt(SpineElement.DynamicTint, 16);
	                    break;
	                default:
	                    this.spine.tint = parseInt(node.getAttribute(exports.SpineElementAttributes.TINT), 16);
	                    break;
	            }
	        }
	        if (node.hasAttribute(exports.SpineElementAttributes.SKIN)) {
	            var skin = node.getAttribute(exports.SpineElementAttributes.SKIN);
	            if (skin != null) {
	                this.setSkin(skin);
	            }
	        }
	        if (node.hasAttribute(exports.SpineElementAttributes.ANIMATIONS)) {
	            var animations = neo_common_1.ArrayUtils.stringArray(node.getAttribute(exports.SpineElementAttributes.ANIMATIONS), "|");
	            var tracks = [];
	            for (var i = 0; i < animations.length; i++) {
	                var animation = neo_common_1.ArrayUtils.stringArray(animations[i]);
	                var track = {
	                    name: animation[0].trim(),
	                };
	                if (animation.length > 1) {
	                    track.loop = neo_common_1.StringUtils.parseBoolean(animation[1]);
	                }
	                if (animation.length > 2) {
	                    track.delay = parseInt(animation[2]);
	                }
	                if (animation.length > 3) {
	                    track.track = parseInt(animation[3]);
	                }
	                tracks.push(track);
	            }
	            this.animate(tracks);
	        }
	    };
	    SpineElement.prototype.createSpine = function (key) {
	        var textureAtlas = new PIXI.spine.core.TextureAtlas(SpineElement.Atlas.data, function (line, callback) {
	            line = line.replace(/\.png/g, "");
	            callback(PIXI.BaseTexture.from(line));
	        });
	        var atlasAttachmentLoader = new PIXI.spine.core.AtlasAttachmentLoader(textureAtlas);
	        var skeletonJson = new PIXI.spine.core.SkeletonJson(atlasAttachmentLoader);
	        var skeletonData = skeletonJson.readSkeletonData(CustomUtils_1.CustomUtils.updateSpineData(SpineElement.Data.data[key]));
	        this.spine = new PIXI.spine.Spine(skeletonData);
	        this.spine.autoUpdate = false;
	        this.addChild(this.spine);
	    };
	    SpineElement.prototype.setMixes = function () {
	        for (var i = 0; i < this.mixes.length; i++) {
	            this.spine.stateData.setMix(this.mixes[i].from, this.mixes[i].to, this.mixes[i].duration / 60);
	        }
	    };
	    SpineElement.prototype.animate = function (animations) {
	        var _this = this;
	        var tracks = [];
	        animations.forEach(function (animation) {
	            var track = neo_common_1.Utils.isNullOrUndefined(animation.track) ? 0 : animation.track;
	            while (tracks.length < track + 1) {
	                tracks.push([]);
	            }
	            tracks[track].push(animation);
	        });
	        tracks.forEach(function (track, i) {
	            track.forEach(function (animation, j) {
	                var name = animation.name.trim();
	                var loop = neo_common_1.Utils.isNullOrUndefined(animation.loop) ? false : animation.loop;
	                var delay = neo_common_1.Utils.isNullOrUndefined(animation.delay) ? 0 : animation.delay / 60;
	                if (j === 0) {
	                    if (name === "Empty") {
	                        _this.spine.state.setEmptyAnimation(i, 0);
	                    }
	                    else {
	                        _this.spine.state.setAnimation(i, name, loop);
	                    }
	                }
	                else {
	                    if (name === "Empty") {
	                        _this.spine.state.addEmptyAnimation(i, 0, delay);
	                    }
	                    else {
	                        _this.spine.state.addAnimation(i, name, loop, delay);
	                    }
	                }
	            });
	        });
	    };
	    SpineElement.prototype.setSkin = function (skinName) {
	        if (skinName != null) {
	            this.skin = skinName;
	            if (this.spine.skeleton.data.findSkin(skinName)) {
	                this.spine.skeleton.setSkinByName(skinName);
	            }
	        }
	    };
	    SpineElement.getRandomSpeed = function (node) {
	        var result = 1;
	        var dataArray = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.SpineElementAttributes.RANDOM_SPEED));
	        if (dataArray.length === 2) {
	            var min = dataArray[0];
	            var max = min > dataArray[1] ? min : dataArray[1];
	            result = SpineElement.getRandom(min, max);
	        }
	        return result;
	    };
	    SpineElement.getRandom = function (min, max) {
	        return Math.random() * (max - min) + min;
	    };
	    SpineElement.prototype.clone = function () {
	        var element = new SpineElement();
	        element.alpha = this.alpha;
	        element.name = this.name;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.rotation = this.rotation;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.visible = this.visible;
	        if (this.maskSprite != null) {
	            var maskElement = new PIXI.Sprite(this.maskSprite.texture);
	            maskElement.position.x = this.maskSprite.position.x;
	            maskElement.position.y = this.maskSprite.position.y;
	            element.maskSprite = maskElement;
	            element.addChild(maskElement);
	            element.mask = maskElement;
	        }
	        element.spine = new PIXI.spine.Spine(this.spine.spineData);
	        element.spine.autoUpdate = false;
	        element.spine.tint = this.spine.tint;
	        if (this.skin != null) {
	            element.spine.skeleton.setSkinByName(this.skin);
	        }
	        element.addChild(element.spine);
	        element.mixes = this.mixes;
	        element.setMixes();
	        element.markAsCloned();
	        return element;
	    };
	    SpineElement.DynamicTint = "000000";
	    SpineElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], SpineElement);
	    return SpineElement;
	}(BaseElement_1.BaseElement));
	exports.SpineElement = SpineElement;
	exports.SpineElementAttributes = {
	    ANIMATIONS: "Animations",
	    MIXES: "Mixes",
	    RANDOM_SPEED: "RandomSpeed",
	    SKIN: "Skin",
	    SPEED: "Speed",
	    SPINE: "Spine",
	    TINT: "Tint",
	};


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var neo_games_1 = __webpack_require__(3);
	var Dialog_1 = __webpack_require__(51);
	var GameManager_1 = __webpack_require__(23);
	var BalanceManager_1 = __webpack_require__(27);
	var ModuleManager_1 = __webpack_require__(29);
	var BetManager_1 = __webpack_require__(25);
	var DataManager_1 = __webpack_require__(26);
	var Languages_1 = __webpack_require__(28);
	var HtmlController_1 = __webpack_require__(31);
	var SplashScreen_1 = __webpack_require__(59);
	var GameClientHostConsumer = (function (_super) {
	    __extends(GameClientHostConsumer, _super);
	    function GameClientHostConsumer(app) {
	        _super.call(this, app);
	    }
	    Object.defineProperty(GameClientHostConsumer.prototype, "dialog", {
	        get: function () {
	            if (neo_common_1.Utils.isNullOrUndefined(this._dialog)) {
	                this._dialog = new Dialog_1.Dialog(this._app);
	            }
	            return this._dialog;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameClientHostConsumer.prototype.handleAction = function (actionGroup, action) {
	        if (!HtmlController_1.HtmlController.dispatchActionAllowed) {
	            return;
	        }
	        if (actionGroup === neo_games_1.ClientHost.Types.ClientHostActionGroup.Default.toString()) {
	            if (false) {
	                neo_common_1.Logger.debugGroup("GameClientHostConsumer", "Received action \"" + action + "\" (group: '" + actionGroup + "'), dispatching to controller.dispatchAction() ...");
	            }
	            DataManager_1.DataManager.addTrustedUserAction(action);
	            ModuleManager_1.ModuleManager.dispatchAction(action);
	        }
	        else if (actionGroup === neo_games_1.ClientHost.Types.ClientHostActionGroup.Terminal.toString()) {
	            if (false) {
	                neo_common_1.Logger.debugGroup("GameClientHostConsumer", "Received action \"" + action + "\" (group: '" + actionGroup + "'), dispatching to controller.dispatchTerminalAction() ...");
	            }
	            DataManager_1.DataManager.addTrustedUserAction(action);
	            ModuleManager_1.ModuleManager.dispatchAction(action);
	        }
	    };
	    GameClientHostConsumer.prototype.handleShowDialog = function (request) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("GameClientHostConsumer", "inside handleShowDialog(), request: ", request);
	        }
	        if (request.type === neo_games_1.ClientHost.Types.ClientHostDialogType.Responsible1) {
	            this.showResponsibleDialog1(request.data);
	        }
	        else {
	            var dialogData = neo_common_1.Utils.isNullOrUndefined(request.data) ? null : request.data;
	            var special = false;
	            var gameRoundId = "0";
	            var errorId = "";
	            if (!neo_common_1.Utils.isNullOrUndefined(dialogData)) {
	                special = dialogData.special;
	                gameRoundId = dialogData.gameRoundId;
	                errorId = dialogData.errorId;
	            }
	            var isError = request.type === neo_games_1.ClientHost.Types.ClientHostDialogType.Error;
	            var code = request.error ? request.error.errorCode : "";
	            SplashScreen_1.SplashScreen.hideSplashScreen();
	            this.dialog.openDialog(request.text, code, errorId, isError, special, gameRoundId, request);
	        }
	    };
	    GameClientHostConsumer.prototype.handleShowEndGameDialog = function () {
	        var customData = {
	            data: {
	                actions: [null],
	            },
	        };
	        this.dialog.openDialog(Languages_1.Languages.getRid("DLG_ENDGAME"), "", "", false, true, "", customData);
	        PIXI.sound.removeAll();
	        var dialog = document.getElementById("dialog");
	        var root = document.getElementById("root");
	        if (root != null && dialog != null) {
	            root.innerHTML = dialog.outerHTML;
	            document.body.innerHTML = "";
	            document.body.appendChild(root);
	        }
	    };
	    GameClientHostConsumer.prototype.handleCloseDialog = function () {
	        this.dialog.closeDialog();
	    };
	    GameClientHostConsumer.prototype.handleRefreshAccount = function () {
	        BalanceManager_1.BalanceManager.refreshBalance();
	    };
	    GameClientHostConsumer.prototype.handleError = function (error, data) {
	        this.dialog.openDialog(error, null, "", true);
	    };
	    GameClientHostConsumer.prototype.handleBlockRequest = function (blocked) {
	        if (blocked) {
	            if (DataManager_1.DataManager.Autoplay) {
	                DataManager_1.DataManager.gameState("AutoPlayEnded");
	            }
	            DataManager_1.DataManager.Autoplay = false;
	            DataManager_1.DataManager.AutoplayCount = "∞";
	            DataManager_1.DataManager.AutoplayLossLimit = "∞";
	            DataManager_1.DataManager.AutoplayWinLimit = "∞";
	        }
	    };
	    GameClientHostConsumer.prototype.handlePaytableRequest = function (request) { };
	    GameClientHostConsumer.prototype.handleAccountUpdate = function (balance, forceShow) {
	        if (forceShow) {
	            BetManager_1.BetManager.unHideValues(true);
	        }
	        BalanceManager_1.BalanceManager.balanceReceived(balance);
	    };
	    GameClientHostConsumer.prototype.handleAutoplayAction = function (action) {
	        switch (action) {
	            case neo_games_1.ClientHost.Types.AutoplayAction.Stop: {
	                if (DataManager_1.DataManager.Autoplay) {
	                    DataManager_1.DataManager.gameState("AutoPlayEnded");
	                }
	                DataManager_1.DataManager.Autoplay = false;
	                DataManager_1.DataManager.AutoplayCount = "∞";
	                DataManager_1.DataManager.AutoplayLossLimit = "∞";
	                DataManager_1.DataManager.AutoplayWinLimit = "∞";
	                break;
	            }
	            case neo_games_1.ClientHost.Types.AutoplayAction.Enable: {
	                DataManager_1.DataManager.AutoplayEnabled = true;
	                break;
	            }
	            case neo_games_1.ClientHost.Types.AutoplayAction.Disable: {
	                if (DataManager_1.DataManager.Autoplay) {
	                    DataManager_1.DataManager.gameState("AutoPlayEnded");
	                }
	                DataManager_1.DataManager.Autoplay = false;
	                DataManager_1.DataManager.AutoplayCount = "∞";
	                DataManager_1.DataManager.AutoplayLossLimit = "∞";
	                DataManager_1.DataManager.AutoplayWinLimit = "∞";
	                DataManager_1.DataManager.AutoplayEnabled = false;
	                break;
	            }
	            default: {
	                if (false) {
	                    neo_common_1.Logger.errorGroup("GameClientHostConsumer", "Unknown autoplay action '" + action + "'");
	                }
	                break;
	            }
	        }
	    };
	    GameClientHostConsumer.prototype.handleGameplayAction = function (action) {
	        switch (action) {
	            case neo_games_1.ClientHost.Types.GamePlayAction.Enable: {
	                GameManager_1.GameManager.enablePlay();
	                break;
	            }
	            case neo_games_1.ClientHost.Types.GamePlayAction.Disable: {
	                GameManager_1.GameManager.disablePlay();
	                break;
	            }
	            default: {
	                if (false) {
	                    neo_common_1.Logger.errorGroup("GameClientHostConsumer", "Unknown gameplay action '" + action + "'");
	                }
	                break;
	            }
	        }
	    };
	    GameClientHostConsumer.prototype.terminateOnCollect = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup("GameClientHostConsumer", "inside terminateOnCollect()");
	        }
	        return GameManager_1.GameManager.canExit(true);
	    };
	    GameClientHostConsumer.prototype.showResponsibleDialog1 = function (data) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("GameClientHostConsumer", "showResponsibleDialog1(), data: ", data);
	        }
	        GameManager_1.GameManager.showResponsibleDialog1(data);
	    };
	    return GameClientHostConsumer;
	}(neo_games_1.GameEngine.GameClientHostConsumerBase));
	exports.GameClientHostConsumer = GameClientHostConsumer;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_games_1 = __webpack_require__(3);
	var GameDefinition = (function (_super) {
	    __extends(GameDefinition, _super);
	    function GameDefinition() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(GameDefinition.prototype, "Gamble", {
	        get: function () {
	            return this.getValue("Gamble", true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GameDefinition;
	}(neo_games_1.GameEngine.GameDefinitionBase));
	exports.GameDefinition = GameDefinition;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_games_1 = __webpack_require__(3);
	var GameManager_1 = __webpack_require__(23);
	var key_GameEnableReelsStop = "GameEnableReelsStop";
	var key_GameEnableQuickSpin = "GameEnableQuickSpin";
	var key_QuickSpinDialogCount = "QuickSpinDialogCount";
	var key_QuickSpinDecayDelay = "QuickSpinDecayDelay";
	var key_MinGameRoundDuration = "MinGameRoundDuration";
	var key_GameRoundMinSpan = "GameRoundMinSpan";
	var key_FRBGameRoundMinSpan = "FRBGameRoundMinSpan";
	var key_UIShowTime = "UIShowTime";
	var key_GUIShowSessionTime = "GUI_ShowSessionTime";
	var key_GUIShowSessionTimeStartValue = "GUI_ShowSessionTimeStartValue";
	var key_UseServerTime = "UseServerTime";
	var key_UseHtmlAudio = "UseHtmlAudio";
	var key_FullscreenOnClick = "FullscreenOnClick";
	var key_UseCoins = "UseCoins";
	var key_AutoplayGambleEnabled = "AutoplayGambleEnabled";
	var key_AutoplayMode = "AutoplayMode";
	var key_AutoplayCounts = "AutoplayCounts";
	var key_AutoplayLossLimit = "AutoplayLossLimit";
	var key_AutoplaySingleWinLimit = "AutoplaySingleWinLimit";
	var key_HelpShowGameLimit = "HelpShowGameLimit";
	var key_HelpShowRTP = "HelpShowRTP";
	var key_ShowGameRoundsHistory = "ShowGameRoundsHistory";
	var key_ExpirationResolveHours = "ExpirationResolveHours";
	var key_AutoplayModeSpeed = "AutoplayModeSpeed";
	var key_HideAmountsEnabled = "HideAmountsEnabled";
	var key_AutoplayModeEnabled = "AutoplayModeEnabled";
	var key_ResetCoinCountOnDenomChange = "ResetCoinCountOnDenomChange";
	var key_CollectOnUnCalculatedWin = "CollectOnUnCalculatedWin";
	var key_PluginUrl = "PluginUrl";
	var key_PluginOrigin = "PluginOrigin";
	var key_Platform = "Platform";
	var key_PollCredit = "PollCredit";
	var key_ShowDecimalPlaces = "ShowDecimalPlaces";
	var key_SelectorRolloutDuration = "SelectorRolloutDuration";
	var key_DisplayCurrencies = "DisplayCurrencies";
	var key_CanvasFallback = "CanvasFallback";
	var key_GameRoundIdVisible = "GameRoundIdVisible";
	var key_MuteOnLostFocus = "MuteOnLostFocus";
	var key_ShowCashierMessage = "ShowCashierMessage";
	var key_CashierMessageShowRefreshBalanceButton = "CashierMessageShowRefreshBalanceButton";
	var key_CashierUrl = "CashierUrl";
	var key_DisableUntrustedClicks = "DisableUntrustedClicks";
	var key_PlayerSessionReconnectionInterval = "PlayerSessionReconnectionInterval";
	var key_ApplicationGatewayUrl = "ApplicationGatewayUrl";
	var key_EventTrackerEnabled = "EventTrackerEnabled";
	var key_GameEnableVibration = "GameEnableVibration";
	var key_AutoplaySkipWinAnimationsEnabled = "AutoplaySkipWinAnimationsEnabled";
	var key_SplashScreen = "SplashScreen";
	var key_PaytableUseValue = "PaytableUseValue";
	var key_AllowPlayFromRules = "AllowPlayFromRules";
	var key_GUI_HistoryUrl = "GUI_HistoryUrl";
	var key_RCI_HistoryUrl = "RCI_HistoryUrl";
	var key_RCI_Info = "RCI_Info";
	var key_RCI_IntervalInfo = "RCI_IntervalInfo";
	var key_RCI_ShowHistoryButton = "RCI_ShowHistoryButton";
	var key_FeatureAutoPlay = "FeatureAutoPlay";
	var key_FeatureAutoPick = "FeatureAutoPick";
	var key_ShowSimilarGames = "ShowSimilarGames";
	var key_SimilarGamesList = "SimilarGamesList";
	var key_ShowExitGameButton = "ShowExitGameButton";
	var key_StaticContentUrl = "StaticContentUrl";
	var key_ShowHomeButton = "ShowHomeButton";
	var key_UsePortraitMode = "UsePortraitMode";
	var key_FRBShowDenyButton = "FRBShowDenyButton";
	var key_FRBShowPostponeButton = "FRBShowPostponeButton";
	var key_StatusBar = "StatusBar";
	var key_StatusBarData = "StatusBarData";
	var key_BuyFeatureEnabled = "BuyFeatureEnabled";
	var key_BuyFeatureConfirmEnabled = "BuyFeatureConfirmEnabled";
	var key_ProgressiveBonusId = "ProgressiveBonusId";
	var key_ProgressiveBonusContributeOnlyQualified = "ProgressiveBonusContributeOnlyQualified";
	var key_ProgressiveBonusMinQualifyingBet = "ProgressiveBonusMinQualifyingBet";
	var key_ProgressiveBonusMaxQualifyingBet = "ProgressiveBonusMaxQualifyingBet";
	var key_ProgressiveBonusVisibleMax = "ProgressiveBonusVisibleMax";
	var key_ProgressiveBonusHelpShowMaxVisibleLimit = "ProgressiveBonusHelpShowMaxVisibleLimit";
	var key_ProgressiveBonusHelpShowCumulativeWinLimit = "ProgressiveBonusHelpShowCumulativeWinLimit";
	var key_ProgressiveBonusTicketConstraint = "ProgressiveBonusTicketConstraint";
	var key_UseJackpotLocalization = "UseJackpotLocalization";
	var key_ProgressiveBonusTheme = "ProgressiveBonusTheme";
	var key_SessionBalance = "SessionBalance";
	var key_TotalBet = "TotalBet";
	var key_TotalWin = "TotalWin";
	var key_PlayerTokenId = "PlayerTokenId";
	var key_ClientToken = "ClientToken";
	var key_MaxBetEnabled = "MaxBetEnabled";
	var key_ShowMaxBetMessage = "ShowMaxBetMessage";
	var key_HelpShowGameModuleVersion = "HelpShowGameModuleVersion";
	var key_NotifyBetHigherThanMin = "NotifyBetHigherThanMin";
	var key_ShowPaytableAtStart = "ShowPaytableAtStart";
	var key_HelpShowMaxPayoutProbability = "HelpShowMaxPayoutProbability";
	var key_HelpShowMaxPayoutProbabilityFrequency = "HelpShowMaxPayoutProbabilityFrequency";
	var GameConfiguration = (function (_super) {
	    __extends(GameConfiguration, _super);
	    function GameConfiguration() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(GameConfiguration.prototype, "GameEnableReelsStop", {
	        get: function () {
	            return this.getValue(key_GameEnableReelsStop, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GameEnableQuickSpin", {
	        get: function () {
	            return this.getValue(key_GameEnableQuickSpin, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "QuickSpinDialogCount", {
	        get: function () {
	            return this.getValue(key_QuickSpinDialogCount, 3);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "QuickSpinDecayDelay", {
	        get: function () {
	            return this.getValue(key_QuickSpinDecayDelay, 30);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "MinGameRoundDuration", {
	        get: function () {
	            return this.getValue(key_MinGameRoundDuration, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GameRoundMinSpan", {
	        get: function () {
	            return this.getValue(key_GameRoundMinSpan, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FRBGameRoundMinSpan", {
	        get: function () {
	            return this.getValue(key_FRBGameRoundMinSpan, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UIShowTime", {
	        get: function () {
	            return this.getValue(key_UIShowTime, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GUIShowSessionTime", {
	        get: function () {
	            return this.getValue(key_GUIShowSessionTime, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GUIShowSessionTimeStartValue", {
	        get: function () {
	            return this.getValue(key_GUIShowSessionTimeStartValue, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UseServerTime", {
	        get: function () {
	            return this.getValue(key_UseServerTime, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UseHtmlAudio", {
	        get: function () {
	            return this.getValue(key_UseHtmlAudio, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FullscreenOnClick", {
	        get: function () {
	            return this.getValue(key_FullscreenOnClick, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UseCoins", {
	        get: function () {
	            return this.getValue(key_UseCoins, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayGambleEnabled", {
	        get: function () {
	            return this.getValue(key_AutoplayGambleEnabled, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "MaxBetEnabled", {
	        get: function () {
	            return this.getValue(key_MaxBetEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowMaxBetMessage", {
	        get: function () {
	            return this.getValue(key_ShowMaxBetMessage, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayMode", {
	        get: function () {
	            return this.getValue(key_AutoplayMode, "simple");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayCounts", {
	        get: function () {
	            return this.getValue(key_AutoplayCounts, [-1, 1000, 750, 500, 250, 100, 75, 50, 25, 10]);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayLossLimit", {
	        get: function () {
	            return this.getValue(key_AutoplayLossLimit, [-1, 5, 20, 50]);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplaySingleWinLimit", {
	        get: function () {
	            return this.getValue(key_AutoplaySingleWinLimit, [-1, 10, 20, 75]);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HelpShowGameLimit", {
	        get: function () {
	            return this.getValue(key_HelpShowGameLimit, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HelpShowRTP", {
	        get: function () {
	            return this.getValue(key_HelpShowRTP, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowGameRoundsHistory", {
	        get: function () {
	            return GameManager_1.GameManager.gameResponse.roundId > -1 && this.getValue(key_ShowGameRoundsHistory, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ExpirationResolveHours", {
	        get: function () {
	            return this.getValue(key_ExpirationResolveHours, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayModeSpeed", {
	        get: function () {
	            return this.getValue(key_AutoplayModeSpeed, "standard");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HideAmountsEnabled", {
	        get: function () {
	            return this.getValue(key_HideAmountsEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplayModeEnabled", {
	        get: function () {
	            return this.getValue(key_AutoplayModeEnabled, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ResetCoinCountOnDenomChange", {
	        get: function () {
	            return this.getValue(key_ResetCoinCountOnDenomChange, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "CollectOnUnCalculatedWin", {
	        get: function () {
	            return this.getValue(key_CollectOnUnCalculatedWin, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PluginUrl", {
	        get: function () {
	            return this.getValue(key_PluginUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PluginOrigin", {
	        get: function () {
	            return this.getValue(key_PluginOrigin, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "Platform", {
	        get: function () {
	            return this.getValue(key_Platform, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PollCredit", {
	        get: function () {
	            return this.getValue(key_PollCredit, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowDecimalPlaces", {
	        get: function () {
	            return this.getValue(key_ShowDecimalPlaces, 2);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "SelectorRolloutDuration", {
	        get: function () {
	            return this.getValue(key_SelectorRolloutDuration, 5);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "DisplayCurrencies", {
	        get: function () {
	            return this.getValue(key_DisplayCurrencies, []);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "CanvasFallback", {
	        get: function () {
	            return this.getValue(key_CanvasFallback, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GameRoundIdVisible", {
	        get: function () {
	            return this.getValue(key_GameRoundIdVisible, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "MuteOnLostFocus", {
	        get: function () {
	            return this.getValue(key_MuteOnLostFocus, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowCashierMessage", {
	        get: function () {
	            return this.getValue(key_ShowCashierMessage, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "CashierMessageShowRefreshBalanceButton", {
	        get: function () {
	            return this.getValue(key_CashierMessageShowRefreshBalanceButton, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "CashierUrl", {
	        get: function () {
	            return this.getValue(key_CashierUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "DisableUntrustedClicks", {
	        get: function () {
	            return this.getValue(key_DisableUntrustedClicks, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "SplashScreen", {
	        get: function () {
	            return this.getValue(key_SplashScreen, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GUIHistoryUrl", {
	        get: function () {
	            return this.getValue(key_GUI_HistoryUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "RCIHistoryUrl", {
	        get: function () {
	            return this.getValue(key_RCI_HistoryUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "RCIInfo", {
	        get: function () {
	            return this.getValue(key_RCI_Info, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "RCIIntervalInfo", {
	        get: function () {
	            return this.getValue(key_RCI_IntervalInfo, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "RCIShowHistoryButton", {
	        get: function () {
	            return this.getValue(key_RCI_ShowHistoryButton, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FeatureAutoPlay", {
	        get: function () {
	            return (this.getValue(key_FeatureAutoPlay, 0) / 1000) * 60;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FeatureAutoPick", {
	        get: function () {
	            return this.getValue(key_FeatureAutoPick, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowSimilarGames", {
	        get: function () {
	            return this.getValue(key_ShowSimilarGames, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "SimilarGamesList", {
	        get: function () {
	            return this.getValue(key_SimilarGamesList, []);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowExitGameButton", {
	        get: function () {
	            return this.getValue(key_ShowExitGameButton, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "StaticContentUrl", {
	        get: function () {
	            return this.getValue(key_StaticContentUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowHomeButton", {
	        get: function () {
	            return this.getValue(key_ShowHomeButton, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UsePortraitMode", {
	        get: function () {
	            return this.getValue(key_UsePortraitMode, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FRBShowDenyButton", {
	        get: function () {
	            return this.getValue(key_FRBShowDenyButton, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "FRBShowPostponeButton", {
	        get: function () {
	            return this.getValue(key_FRBShowPostponeButton, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "StatusBar", {
	        get: function () {
	            return this.getValue(key_StatusBar, []);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "StatusBarData", {
	        get: function () {
	            return this.getValue(key_StatusBarData, {});
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "BuyFeatureEnabled", {
	        get: function () {
	            return this.getValue(key_BuyFeatureEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "BuyFeatureConfirmEnabled", {
	        get: function () {
	            return this.getValue(key_BuyFeatureConfirmEnabled, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusId", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusId, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusContributeOnlyQualified", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusContributeOnlyQualified, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusMinQualifyingBet", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusMinQualifyingBet, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusMaxQualifyingBet", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusMaxQualifyingBet, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusVisibleMax", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusVisibleMax, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusHelpShowMaxVisibleLimit", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusHelpShowMaxVisibleLimit, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusHelpShowCumulativeWinLimit", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusHelpShowCumulativeWinLimit, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusTicketConstraint", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusTicketConstraint, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "UseJackpotLocalization", {
	        get: function () {
	            return this.getValue(key_UseJackpotLocalization, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ProgressiveBonusTheme", {
	        get: function () {
	            return this.getValue(key_ProgressiveBonusTheme, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "SessionBalance", {
	        get: function () {
	            return this.getValue(key_SessionBalance, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "TotalBet", {
	        get: function () {
	            return this.getValue(key_TotalBet, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "TotalWin", {
	        get: function () {
	            return this.getValue(key_TotalWin, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PlayerTokenId", {
	        get: function () {
	            return this.getValue(key_PlayerTokenId, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ClientToken", {
	        get: function () {
	            return this.getValue(key_ClientToken, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PlayerSessionReconnectionInterval", {
	        get: function () {
	            return this.getValue(key_PlayerSessionReconnectionInterval, 0);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ApplicationGatewayUrl", {
	        get: function () {
	            return this.getValue(key_ApplicationGatewayUrl, "");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "GameEnableVibration", {
	        get: function () {
	            return this.getValue(key_GameEnableVibration, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HelpShowGameModuleVersion", {
	        get: function () {
	            return this.getValue(key_HelpShowGameModuleVersion, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "NotifyBetHigherThanMin", {
	        get: function () {
	            return this.getValue(key_NotifyBetHigherThanMin, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HelpShowMaxPayoutProbability", {
	        get: function () {
	            return this.getValue(key_HelpShowMaxPayoutProbability, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "HelpShowMaxPayoutProbabilityFrequency", {
	        get: function () {
	            return this.getValue(key_HelpShowMaxPayoutProbabilityFrequency, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "ShowPaytableAtStart", {
	        get: function () {
	            return this.getValue(key_ShowPaytableAtStart, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "PaytableUseValue", {
	        get: function () {
	            return this.getValue(key_PaytableUseValue, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AllowPlayFromRules", {
	        get: function () {
	            return this.getValue(key_AllowPlayFromRules, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "EventTrackerEnabled", {
	        get: function () {
	            return this.getValue(key_EventTrackerEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfiguration.prototype, "AutoplaySkipWinAnimationsEnabled", {
	        get: function () {
	            return this.GameRoundMinSpan == 0 && this.getValue(key_AutoplaySkipWinAnimationsEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GameConfiguration;
	}(neo_games_1.GameEngine.GameConfigurationBase));
	exports.GameConfiguration = GameConfiguration;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_games_1 = __webpack_require__(3);
	var DataManager_1 = __webpack_require__(26);
	var Scaling_1 = __webpack_require__(8);
	var BalanceManager_1 = __webpack_require__(27);
	var HtmlController_1 = __webpack_require__(31);
	var AppContext_1 = __webpack_require__(5);
	var UserAction_1 = __webpack_require__(32);
	var GameApp_1 = __webpack_require__(1);
	var RetentionPanel_1 = __webpack_require__(46);
	var ModuleManager_1 = __webpack_require__(29);
	var PageVisibilityHandler_1 = __webpack_require__(55);
	var NotificationManager_1 = __webpack_require__(60);
	var GameModules = neo_games_1.Communication.Game.GameModules;
	var PlatformsManager = (function () {
	    function PlatformsManager() {
	    }
	    PlatformsManager.create = function () {
	        var pluginOrigin = "*";
	        if (AppContext_1.AppContext != null && AppContext_1.AppContext.gameConfiguration != null) {
	            if (AppContext_1.AppContext.gameConfiguration.PluginOrigin != "") {
	                pluginOrigin = AppContext_1.AppContext.gameConfiguration.PluginOrigin;
	            }
	            neo_games_1.Platforms.Platforms.getTimeDataFnc = DataManager_1.DataManager.getTimeData;
	            neo_games_1.Platforms.Platforms.getGameTimeFnc = DataManager_1.DataManager.getGameTime;
	            neo_games_1.Platforms.Platforms.createEmitter();
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.AutoplayStop, PlatformsManager.stopAutoplay);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.RestoreAutoplay, function (autoplayData) {
	                PlatformsManager.restoreAutoplay(autoplayData);
	            });
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.ResizeGame, PlatformsManager.resizeGame);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.RefreshBalance, PlatformsManager.refreshBalance);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GamePlayStop, function (disableChannel) {
	                PlatformsManager.gamePlayStop(disableChannel);
	            });
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GamePlayResume, PlatformsManager.gamePlayResume);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GamePlayFreeze, PlatformsManager.gamePlayFreeze);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GamePlayUnfreeze, PlatformsManager.gamePlayUnfreeze);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GameAudioEnable, PlatformsManager.gameAudioEnable);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GameAudioMute, PlatformsManager.gameAudioMute);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GameAudioSet, function (level) {
	                PlatformsManager.gameAudioSet(level);
	            });
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.GameQuickSpin, function (enabled) {
	                PlatformsManager.gameQuickSpin(enabled);
	            });
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.ShowHelp, PlatformsManager.showHelp);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.HideHelp, PlatformsManager.hideHelp);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.ToggleHelp, PlatformsManager.toggleHelp);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.ShowPaytable, PlatformsManager.showPaytable);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.HidePaytable, PlatformsManager.hidePaytable);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.TogglePaytable, PlatformsManager.togglePaytable);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.PlatformCloseMenu, PlatformsManager.platformCloseMenu);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.PlatformCloseGame, PlatformsManager.platformCloseGame);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.PlatformUpdateUI, PlatformsManager.platformUpdateUI);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.PlatformErrorMessageDismissed, PlatformsManager.platformErrorMessageDismissed);
	            neo_games_1.Platforms.Platforms.eventEmitter.on(neo_games_1.Platforms.Platforms.CreateNotification, function (events) {
	                PlatformsManager.createNotification(events);
	            });
	            neo_games_1.Platforms.Platforms.create(AppContext_1.AppContext.gameConfiguration.Platform, AppContext_1.AppContext.gameConfiguration.PluginUrl, pluginOrigin, { gameKey: GameApp_1.GameApp.key, lang: GameApp_1.GameApp.language, clientHub: NotificationManager_1.NotificationManager });
	        }
	    };
	    PlatformsManager.stopAutoplay = function () {
	        DataManager_1.DataManager.Autoplay = false;
	        DataManager_1.DataManager.AutoplayAfterGamble = false;
	        DataManager_1.DataManager.AutoplayCount = "∞";
	        DataManager_1.DataManager.AutoplayLossLimit = "∞";
	        DataManager_1.DataManager.AutoplayWinLimit = "∞";
	    };
	    PlatformsManager.restoreAutoplay = function (autoplayData) {
	        DataManager_1.DataManager.Autoplay = true;
	        DataManager_1.DataManager.AutoplayCount = autoplayData.autoplayCount;
	        DataManager_1.DataManager.AutoplayLossLimit = autoplayData.autoplayLossLimit;
	        DataManager_1.DataManager.AutoplayWinLimit = autoplayData.autoplayWinLimit;
	        HtmlController_1.HtmlController.dispatchAction("AUTOPLAY");
	    };
	    PlatformsManager.resizeGame = function () {
	        Scaling_1.Scaling.resizeRoot();
	    };
	    PlatformsManager.refreshBalance = function () {
	        BalanceManager_1.BalanceManager.refreshBalance(true);
	    };
	    PlatformsManager.gamePlayStop = function (disableChannel) {
	        if (disableChannel === void 0) { disableChannel = false; }
	        PlatformsManager.stopAutoplay();
	        if (disableChannel) {
	            if (ModuleManager_1.ModuleManager.gambleActive()) {
	            }
	            else if (ModuleManager_1.ModuleManager["freespinsActive"] && ModuleManager_1.ModuleManager["freespinsActive"]()) {
	            }
	            else {
	                ModuleManager_1.ModuleManager.disableChannelModule(GameModules.Base);
	            }
	        }
	    };
	    PlatformsManager.gamePlayResume = function () {
	        if (ModuleManager_1.ModuleManager.gambleActive()) {
	        }
	        else if (ModuleManager_1.ModuleManager["freespinsActive"] && ModuleManager_1.ModuleManager["freespinsActive"]()) {
	        }
	        else {
	            ModuleManager_1.ModuleManager.restoreGameRound(GameModules.Base);
	        }
	    };
	    PlatformsManager.gamePlayFreeze = function () {
	        if (!neo_games_1.Platforms.Platforms.canSpinOnCollect) {
	            PlatformsManager.stopAutoplay();
	        }
	        PageVisibilityHandler_1.PageVisibilityHandler.Enabled = false;
	        PageVisibilityHandler_1.PageVisibilityHandler.pauseAll();
	        HtmlController_1.HtmlController.dispatchActionAllowed = false;
	        document.body.classList.add("freeze");
	    };
	    PlatformsManager.gamePlayUnfreeze = function () {
	        document.body.classList.remove("freeze");
	        HtmlController_1.HtmlController.dispatchActionAllowed = true;
	        PageVisibilityHandler_1.PageVisibilityHandler.resumeAll();
	        PageVisibilityHandler_1.PageVisibilityHandler.Enabled = true;
	    };
	    PlatformsManager.gameAudioEnable = function () {
	        HtmlController_1.HtmlController.setSound(3);
	    };
	    PlatformsManager.gameAudioMute = function () {
	        HtmlController_1.HtmlController.setSound(0);
	    };
	    PlatformsManager.gameAudioSet = function (level) {
	        HtmlController_1.HtmlController.setSound(level);
	    };
	    PlatformsManager.showHelp = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionHelpOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionHelpOn);
	                }
	            }
	        }
	    };
	    PlatformsManager.hideHelp = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionHelpOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (!dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionHelpOff);
	                }
	            }
	        }
	    };
	    PlatformsManager.toggleHelp = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionHelpOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionHelpOn);
	                }
	                else {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionHelpOff);
	                }
	            }
	        }
	    };
	    PlatformsManager.showPaytable = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionPaytableOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionPaytableOn);
	                }
	            }
	        }
	    };
	    PlatformsManager.hidePaytable = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionPaytableOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (!dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionPaytableOff);
	                }
	            }
	        }
	    };
	    PlatformsManager.togglePaytable = function () {
	        var dipatchElementId = UserAction_1.UserAction.ActionPaytableOn;
	        if (HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId]) {
	            var dipatchElement = HtmlController_1.HtmlController.UiDispatchElements[dipatchElementId][0];
	            if (dipatchElement != null) {
	                if (dipatchElement.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionPaytableOn);
	                }
	                else {
	                    HtmlController_1.HtmlController.dispatchUiAction(UserAction_1.UserAction.ActionPaytableOff);
	                }
	            }
	        }
	    };
	    PlatformsManager.gameQuickSpin = function (enabled) {
	        if (DataManager_1.DataManager["quickspinSet"]) {
	            DataManager_1.DataManager["quickspinSet"](enabled);
	        }
	    };
	    PlatformsManager.platformCloseMenu = function () {
	        HtmlController_1.HtmlController.dispatchUiAction("");
	    };
	    PlatformsManager.platformCloseGame = function () {
	        neo_games_1.Platforms.Platforms.exitHandler = "platformsManager";
	        GameApp_1.GameApp.exit();
	    };
	    PlatformsManager.platformUpdateUI = function () {
	        RetentionPanel_1.RetentionPanel.revalidate();
	    };
	    PlatformsManager.platformErrorMessageDismissed = function () {
	    };
	    PlatformsManager.createNotification = function (events) {
	        if (AppContext_1.AppContext.gameConfiguration.EventTrackerEnabled) {
	            NotificationManager_1.NotificationManager.sendMessage({
	                application: "EventTrackingServer",
	                service: "EventTracker",
	                action: "event/log",
	                data: { events: events },
	            });
	        }
	    };
	    return PlatformsManager;
	}());
	exports.PlatformsManager = PlatformsManager;


/***/ },
/* 126 */
/***/ function(module, exports) {

	"use strict";
	var TerminalActions = (function () {
	    function TerminalActions() {
	    }
	    Object.defineProperty(TerminalActions, "Payout", {
	        get: function () {
	            return "Payout";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "BackToLobby", {
	        get: function () {
	            return "BackToLobby";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "StartWithCollect", {
	        get: function () {
	            return "StartWithCollect";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "Autoplay", {
	        get: function () {
	            return "Autoplay";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "BetOrGamble", {
	        get: function () {
	            return "BetOrGamble";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "ActionLeft", {
	        get: function () {
	            return "ActionLeft";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TerminalActions, "ActionRight", {
	        get: function () {
	            return "ActionRight";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return TerminalActions;
	}());
	exports.TerminalActions = TerminalActions;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ShapeElement_1 = __webpack_require__(13);
	var ComponentTypes_1 = __webpack_require__(14);
	var StageController_1 = __webpack_require__(6);
	var Tweens_1 = __webpack_require__(15);
	var BaseElementParticle = (function (_super) {
	    __extends(BaseElementParticle, _super);
	    function BaseElementParticle() {
	        _super.call(this);
	        this._cloned = false;
	        this.__destroyed = false;
	        this._uid = this.componentName + "_" + neo_common_1.Utils.generateUuid();
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                this._uid = PerfDebug.generateElementUID(this);
	                PerfDebug.newElement(this, this.getDebugInfo());
	            }
	        }
	    }
	    Object.defineProperty(BaseElementParticle.prototype, "tweenEngine", {
	        get: function () {
	            return this._tweenEngine;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseElementParticle.prototype._create = function (node) {
	        this.assertDestroyed("_create()");
	        Tweens_1.Tweens.removeTweens(this);
	        if (this.name == null) {
	            this.name = node.nodeName;
	        }
	        if (node.hasAttribute("Alpha")) {
	            this.alpha = parseFloat(node.getAttribute("Alpha"));
	        }
	        if (node.hasAttribute("Rotation")) {
	            this.rotation = parseInt(node.getAttribute("Rotation"));
	        }
	        if (node.hasAttribute("StartRotation")) {
	            if (node.getAttribute("StartRotation") === "random") {
	                this.rotation = Math.floor(Math.random() * 360) / 100;
	            }
	        }
	        if (node.hasAttribute("ScaleX")) {
	            this.scale.x = parseFloat(node.getAttribute("scaleX"));
	        }
	        if (node.hasAttribute("ScaleY")) {
	            this.scale.y = parseFloat(node.getAttribute("ScaleY"));
	        }
	        if (node.hasAttribute("Scale")) {
	            this.scale.x = parseFloat(node.getAttribute("Scale"));
	            this.scale.y = parseFloat(node.getAttribute("Scale"));
	        }
	        if (node.hasAttribute("X")) {
	            this.position.x = parseInt(node.getAttribute("X"));
	        }
	        if (node.hasAttribute("Y")) {
	            this.position.y = parseInt(node.getAttribute("Y"));
	        }
	        if (node.hasAttribute("PivotX")) {
	            this.pivot.x = parseInt(node.getAttribute("PivotX"));
	        }
	        if (node.hasAttribute("PivotY")) {
	            this.pivot.y = parseInt(node.getAttribute("PivotY"));
	        }
	        if (node.hasAttribute("Visible")) {
	            this.visible = neo_common_1.StringUtils.parseBoolean(node.getAttribute("Visible"));
	        }
	        if (node.hasAttribute("Mask")) {
	            var next = node.parentElement.firstElementChild;
	            while (next != null) {
	                if (next.nodeName === node.getAttribute("Mask")) {
	                    var shapeElement = new ShapeElement_1.ShapeElement();
	                    shapeElement.create(next);
	                    this.mask = shapeElement;
	                }
	                next = next.nextElementSibling;
	            }
	            if (this.mask == null) {
	                if (false) {
	                    this.log("ERROR no element with name: " + node.getAttribute("Mask"));
	                }
	            }
	        }
	        if (node.hasAttribute("BitmapMask")) {
	            var image = StageController_1.StageController.getTextureByResourceId(node.getAttribute("BitmapMask"));
	            if (image != null) {
	                this.maskSprite = new PIXI.Sprite(image);
	                if (node.hasAttribute("BitmapMaskX")) {
	                    this.maskSprite.position.x = parseFloat(node.getAttribute("BitmapMaskX"));
	                }
	                if (node.hasAttribute("BitmapMaskY")) {
	                    this.maskSprite.position.y = parseFloat(node.getAttribute("BitmapMaskY"));
	                }
	                if (!node.hasAttribute("BitmapMaskShow")) {
	                    this.addChild(this.maskSprite);
	                    this.mask = this.maskSprite;
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no image with name for mask: " + node.getAttribute("BitmapMask"));
	                }
	            }
	        }
	        this._positionTweenOnCreate(node);
	        this._scaleTweenOnCreate(node);
	        this._rotationTweenOnCreate(node);
	        this._alphaTweenOnCreate(node);
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.createElement(this, this.getDebugInfo());
	            }
	        }
	    };
	    BaseElementParticle.prototype._positionTweenOnCreate = function (node) {
	        var _this = this;
	        if (!node.hasAttribute(BaseElementParticleAttributes.POSITION_TWEEN_X) ||
	            !node.hasAttribute(BaseElementParticleAttributes.POSITION_TWEEN_Y)) {
	            return;
	        }
	        var tweenX = neo_common_1.ArrayUtils.numberArray(node.getAttribute(BaseElementParticleAttributes.POSITION_TWEEN_X));
	        var tweenY = neo_common_1.ArrayUtils.numberArray(node.getAttribute(BaseElementParticleAttributes.POSITION_TWEEN_Y));
	        if (tweenX == null || tweenY == null) {
	            if (false) {
	                this.log("WARNING wrong parameters for PositionTween");
	            }
	            return;
	        }
	        var tweenDuration = node.hasAttribute(BaseElementParticleAttributes.POSITION_TWEEN_DURATION)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.POSITION_TWEEN_DURATION))
	            : 120;
	        var tweenEase = node.hasAttribute(BaseElementParticleAttributes.POSITION_TWEEN_EASE)
	            ? node.getAttribute(BaseElementParticleAttributes.POSITION_TWEEN_EASE)
	            : null;
	        var position = node.hasAttribute(BaseElementParticleAttributes.POSITION_TWEEN_POSITION)
	            ? node.getAttribute(BaseElementParticleAttributes.POSITION_TWEEN_POSITION)
	            : null;
	        if (position == BaseElementParticleAttributes.POSITION_TWEEN_POSITION_VALUE.RELATIVE) {
	            tweenX = tweenX.map(function (value) {
	                return value + _this.position.x;
	            });
	            tweenY = tweenY.map(function (value) {
	                return value + _this.position.y;
	            });
	        }
	        Tweens_1.Tweens.positionTween(this, { tweenX: tweenX, tweenY: tweenY, tweenEase: tweenEase, tweenDuration: tweenDuration });
	    };
	    BaseElementParticle.prototype._scaleTweenOnCreate = function (node) {
	        if (!node.hasAttribute(BaseElementParticleAttributes.SCALE_TWEEN)) {
	            return;
	        }
	        var tweenValues = BaseElementParticle._getPointsFromPointsAttribute(node.getAttribute(BaseElementParticleAttributes.SCALE_TWEEN));
	        var tweenDuration = node.hasAttribute(BaseElementParticleAttributes.SCALE_TWEEN_DURATION)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.SCALE_TWEEN_DURATION))
	            : 120;
	        var tweenEase = node.hasAttribute(BaseElementParticleAttributes.SCALE_TWEEN_EASE)
	            ? node.getAttribute(BaseElementParticleAttributes.SCALE_TWEEN_EASE)
	            : null;
	        Tweens_1.Tweens.scaleTween(this, { tweenValues: tweenValues, tweenEase: tweenEase, tweenDuration: tweenDuration });
	    };
	    BaseElementParticle.prototype._rotationTweenOnCreate = function (node) {
	        if (!node.hasAttribute(BaseElementParticleAttributes.ROTATION_TWEEN)) {
	            return;
	        }
	        var degrees = neo_common_1.ArrayUtils.numberArray(node.getAttribute(BaseElementParticleAttributes.ROTATION_TWEEN));
	        if (degrees == null) {
	            if (false) {
	                this.log("WARNING wrong parameters for RotationTween");
	            }
	            return;
	        }
	        var tweenDuration = node.hasAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_DURATION)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_DURATION))
	            : 120;
	        var tweenEase = node.hasAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_EASE)
	            ? node.getAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_EASE)
	            : null;
	        var tweenDelay = node.hasAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_DELAY)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.ROTATION_TWEEN_DELAY))
	            : 0;
	        Tweens_1.Tweens.rotationTween(this, { degrees: degrees, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay });
	    };
	    BaseElementParticle.prototype._alphaTweenOnCreate = function (node) {
	        if (!node.hasAttribute(BaseElementParticleAttributes.ALPHA_TWEEN)) {
	            return;
	        }
	        var alphas = neo_common_1.ArrayUtils.numberArray(node.getAttribute(BaseElementParticleAttributes.ALPHA_TWEEN));
	        if (alphas == null) {
	            if (false) {
	                this.log("WARNING wrong parameters for RotationTween");
	            }
	            return;
	        }
	        var tweenDuration = node.hasAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_DURATION)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_DURATION))
	            : 120;
	        var tweenDelay = node.hasAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_DELAY)
	            ? parseInt(node.getAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_DELAY))
	            : 0;
	        var tweenEase = node.hasAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_EASE)
	            ? node.getAttribute(BaseElementParticleAttributes.ALPHA_TWEEN_EASE)
	            : null;
	        Tweens_1.Tweens.alphaTween(this, { alphas: alphas, tweenEase: tweenEase, tweenDuration: tweenDuration, tweenDelay: tweenDelay });
	    };
	    BaseElementParticle._getPointsFromPointsAttribute = function (pointsString) {
	        return pointsString
	            .replace(/\s/g, "")
	            .split(";")
	            .map(function (valuesPair) {
	            return /\(|\)/.test(valuesPair) ? valuesPair.slice(1, -1).split(",") : [valuesPair, valuesPair];
	        })
	            .map(function (valuesPair) {
	            return { x: parseFloat(valuesPair[0]), y: parseFloat(valuesPair[1]) };
	        });
	    };
	    BaseElementParticle.prototype.create = function (node) {
	        this._create(node);
	    };
	    BaseElementParticle.prototype.getDebugInfo = function () {
	        if (false) {
	            var debugInfoFn = this.debugInfo;
	            return debugInfoFn ? debugInfoFn.call(this) : this.uid + "\nName: [" + this.name + "]";
	        }
	        return "";
	    };
	    Object.defineProperty(BaseElementParticle.prototype, "cloned", {
	        get: function () {
	            return this._cloned;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElementParticle.prototype, "destroyed", {
	        get: function () {
	            return this.__destroyed;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElementParticle.prototype, "uid", {
	        get: function () {
	            return this._uid;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BaseElementParticle.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BaseElementParticle.prototype.destroy = function (options) {
	        this.assertDestroyed("destroy");
	        if (neo_common_1.Utils.isNullOrUndefined(options)) {
	            options = BaseElementParticle._destroyOptions;
	        }
	        this.internalDestroy(options);
	        if (!neo_common_1.Utils.isNullOrUndefined(this.children)) {
	            _super.prototype.destroy.call(this, options);
	        }
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.destroy(this);
	            }
	        }
	        this.__destroyed = true;
	    };
	    BaseElementParticle.prototype.internalDestroy = function (options) {
	        Tweens_1.Tweens.removeTweens(this);
	    };
	    BaseElementParticle.prototype.clone = function () {
	        throw new Error("Not implemented");
	    };
	    BaseElementParticle.prototype.removeAndDestroyChildren = function () {
	        this._removeAndDestroyChildren();
	    };
	    BaseElementParticle.prototype._removeAndDestroyChildren = function () {
	        this.assertDestroyed("_removeAndDestroyChildren");
	        var destroyOptions = {
	            children: true,
	        };
	        if (this.children != null && this.children.length > 0) {
	            for (var i = this.children.length - 1; i >= 0; i--) {
	                if (this.children[i] != null) {
	                    this.children[i].destroy(destroyOptions);
	                }
	            }
	        }
	        this.removeChildren();
	    };
	    BaseElementParticle.prototype.assertDestroyed = function (method) {
	        if (false) {
	            if (this.__destroyed) {
	                throw new Error(this.componentName + "[" + this.uid + "] was already destroyed, calling method '" + method + "'");
	            }
	        }
	    };
	    BaseElementParticle.prototype.markAsCloned = function () {
	        this._markAsCloned();
	    };
	    BaseElementParticle.prototype._markAsCloned = function () {
	        this.assertDestroyed("markAsCloned()");
	        this._cloned = true;
	        if (false) {
	            if (PERFDEBUG_ENABLED) {
	                PerfDebug.clone(this);
	                PerfDebug.updateDebugInfo(this, this.getDebugInfo());
	            }
	        }
	    };
	    BaseElementParticle.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    BaseElementParticle.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    BaseElementParticle._destroyOptions = {
	        children: true,
	    };
	    BaseElementParticle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], BaseElementParticle);
	    return BaseElementParticle;
	}(PIXI.particles.ParticleContainer));
	exports.BaseElementParticle = BaseElementParticle;
	var BaseElementParticleAttributes = {
	    BLEND_MODE: "BlendMode",
	    EMIT: "Emit",
	    ALPHA_TWEEN: "AlphaTween",
	    ALPHA_TWEEN_EASE: "AlphaTweenEase",
	    ALPHA_TWEEN_DELAY: "AlphaTweenDelay",
	    ALPHA_TWEEN_DURATION: "AlphaTweenDuration",
	    POSITION_TWEEN_X: "PositionTweenX",
	    POSITION_TWEEN_Y: "PositionTweenY",
	    POSITION_TWEEN_EASE: "PositionTweenEase",
	    POSITION_TWEEN_DURATION: "PositionTweenDuration",
	    POSITION_TWEEN_POSITION: "PositionTweenPosition",
	    POSITION_TWEEN_POSITION_VALUE: {
	        ABSOLUTE: "absolute",
	        RELATIVE: "relative",
	    },
	    ROTATION_TWEEN: "RotationTween",
	    ROTATION_TWEEN_EASE: "RotationTweenEase",
	    ROTATION_TWEEN_DURATION: "RotationTweenDuration",
	    ROTATION_TWEEN_DELAY: "RotationTweenDelay",
	    SCALE_TWEEN: "ScaleTween",
	    SCALE_TWEEN_EASE: "ScaleTweenEase",
	    SCALE_TWEEN_DURATION: "ScaleTweenDuration",
	    STYLE: "Style",
	    STYLE2: "Style2",
	    START: "Start",
	    STOPPING: "Stopping",
	    STOP: "Stop",
	    TINT: "Tint",
	};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var ActionSet_1 = __webpack_require__(69);
	var LinkedElement = (function () {
	    function LinkedElement() {
	    }
	    LinkedElement.prototype.create = function (node, nodeAttributes) {
	        if (node.hasAttribute(exports.LinkedElementAttributes.LINKED_TO_ID)) {
	            if (ActionSet_1.ActionSet.ElementsToLink != null &&
	                ActionSet_1.ActionSet.ElementsToLink[node.getAttribute(exports.LinkedElementAttributes.LINKED_TO_ID)] != null) {
	                var mainElement = ActionSet_1.ActionSet.ElementsToLink[node.getAttribute(exports.LinkedElementAttributes.LINKED_TO_ID)];
	                if (nodeAttributes != null) {
	                    mainElement.updateByNode(nodeAttributes);
	                }
	                else {
	                    mainElement.updateByNode(node);
	                }
	            }
	        }
	    };
	    Object.defineProperty(LinkedElement.prototype, "componentName", {
	        get: function () {
	            return this.__componentName__;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LinkedElement.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    LinkedElement.prototype.logError = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.errorGroup(compName, s);
	        }
	    };
	    LinkedElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.LinkedElement)
	    ], LinkedElement);
	    return LinkedElement;
	}());
	exports.LinkedElement = LinkedElement;
	exports.LinkedElementAttributes = {
	    LINKED_TO_ID: "LinkedToId",
	};


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var BaseElement_1 = __webpack_require__(12);
	var Vibration_1 = __webpack_require__(130);
	var VibrationElement = (function (_super) {
	    __extends(VibrationElement, _super);
	    function VibrationElement() {
	        _super.apply(this, arguments);
	    }
	    VibrationElement.prototype.createByNode = function (node) {
	    };
	    VibrationElement.prototype.updateByNode = function (node) {
	        if (node.hasAttribute(exports.VibrationElementAttributes.PATTERN)) {
	            var pattern = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.VibrationElementAttributes.PATTERN));
	            Vibration_1.Vibration.vibrate(pattern);
	        }
	    };
	    VibrationElement.prototype.clone = function () {
	        var element = new VibrationElement();
	        return element;
	    };
	    VibrationElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], VibrationElement);
	    return VibrationElement;
	}(BaseElement_1.BaseElement));
	exports.VibrationElement = VibrationElement;
	exports.VibrationElementAttributes = {
	    PATTERN: "Pattern",
	};


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var DataManager_1 = __webpack_require__(26);
	var Vibration = (function () {
	    function Vibration() {
	    }
	    Vibration.vibrate = function (pattern) {
	        if (pattern === void 0) { pattern = 0; }
	        if (!DataManager_1.DataManager.VibrationEnabled) {
	            return;
	        }
	        if (navigator.vibrate == null) {
	            return;
	        }
	        navigator.vibrate(pattern);
	    };
	    return Vibration;
	}());
	exports.Vibration = Vibration;


/***/ },
/* 131 */
/***/ function(module, exports) {

	"use strict";


/***/ },
/* 132 */
131,
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ComponentTypes_1 = __webpack_require__(14);
	var CustomUtils_1 = __webpack_require__(22);
	var AnimationStyle = (function (_super) {
	    __extends(AnimationStyle, _super);
	    function AnimationStyle() {
	        _super.call(this);
	        this.animation = "";
	        this.startFrame = 0;
	        this.speed = 1;
	        this.loop = false;
	        this.stop = false;
	    }
	    AnimationStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.node = node;
	        if (node.hasAttribute(exports.AnimationStyleAttributes.ANIMATION)) {
	            this.animation = node.getAttribute(exports.AnimationStyleAttributes.ANIMATION);
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.START_FRAME)) {
	            this.startFrame = parseInt(node.getAttribute(exports.AnimationStyleAttributes.START_FRAME));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.END_FRAME)) {
	            this.endFrame = parseInt(node.getAttribute(exports.AnimationStyleAttributes.END_FRAME));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.LOOP)) {
	            this.loop = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationStyleAttributes.LOOP));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.STOP)) {
	            this.stop = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationStyleAttributes.STOP));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.SPEED)) {
	            this.speed = parseFloat(node.getAttribute(exports.AnimationStyleAttributes.SPEED));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.ALPHA)) {
	            this.alpha = parseFloat(node.getAttribute(exports.AnimationStyleAttributes.ALPHA));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.TINT)) {
	            this.tint = parseInt(node.getAttribute(exports.AnimationStyleAttributes.TINT), 16);
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.BLEND_MODE)) {
	            this.blendMode = CustomUtils_1.CustomUtils.getBlendMode(parseInt(node.getAttribute(exports.AnimationStyleAttributes.BLEND_MODE)));
	        }
	        if (node.hasAttribute(exports.AnimationStyleAttributes.REVERSE)) {
	            this.reverse = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.AnimationStyleAttributes.REVERSE));
	        }
	    };
	    AnimationStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], AnimationStyle);
	    return AnimationStyle;
	}(Style_1.Style));
	exports.AnimationStyle = AnimationStyle;
	exports.AnimationStyleAttributes = {
	    ANIMATION: "Animation",
	    START_FRAME: "StartFrame",
	    END_FRAME: "EndFrame",
	    LOOP: "Loop",
	    STOP: "Stop",
	    SPEED: "Speed",
	    ALPHA: "Alpha",
	    TINT: "Tint",
	    BLEND_MODE: "BlendMode",
	    REVERSE: "Reverse",
	};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ComponentTypes_1 = __webpack_require__(14);
	var ContainerStyle = (function (_super) {
	    __extends(ContainerStyle, _super);
	    function ContainerStyle() {
	        _super.call(this);
	    }
	    ContainerStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.node = node;
	    };
	    ContainerStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], ContainerStyle);
	    return ContainerStyle;
	}(Style_1.Style));
	exports.ContainerStyle = ContainerStyle;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ComponentTypes_1 = __webpack_require__(14);
	var ProtonStyle = (function (_super) {
	    __extends(ProtonStyle, _super);
	    function ProtonStyle() {
	        _super.call(this);
	    }
	    ProtonStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.node = node;
	    };
	    ProtonStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], ProtonStyle);
	    return ProtonStyle;
	}(Style_1.Style));
	exports.ProtonStyle = ProtonStyle;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ComponentTypes_1 = __webpack_require__(14);
	var ShapeStyle = (function (_super) {
	    __extends(ShapeStyle, _super);
	    function ShapeStyle() {
	        _super.call(this);
	    }
	    ShapeStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.node = node;
	        if (node.hasAttribute(ShapeStyleAttributes.LINE_WIDTH)) {
	            this.lineWidth = parseInt(node.getAttribute(ShapeStyleAttributes.LINE_WIDTH));
	        }
	    };
	    ShapeStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], ShapeStyle);
	    return ShapeStyle;
	}(Style_1.Style));
	exports.ShapeStyle = ShapeStyle;
	var ShapeStyleAttributes = {
	    LINE_WIDTH: "LineWidth",
	};


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var Style_1 = __webpack_require__(92);
	var ContainerElement_1 = __webpack_require__(82);
	var ComponentTypes_1 = __webpack_require__(14);
	var TimelineStyle = (function (_super) {
	    __extends(TimelineStyle, _super);
	    function TimelineStyle() {
	        _super.call(this);
	        this.frames = {};
	        this.framesSounds = {};
	    }
	    TimelineStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        var next = node.firstElementChild;
	        while (next != null) {
	            switch (next.nodeName) {
	                case "Elements":
	                    this.container = new ContainerElement_1.ContainerElement();
	                    this.container.create(next);
	                    break;
	                case "TimeLine":
	                    var nextCase = next.firstElementChild;
	                    while (nextCase != null) {
	                        if (nextCase.hasAttribute("Frame")) {
	                            if (this.frames[nextCase.getAttribute("Frame")] !== null) {
	                                this.frames[nextCase.getAttribute("Frame")] = nextCase;
	                            }
	                            else {
	                                if (false) {
	                                    this.log("ERROR frame " +
	                                        nextCase.getAttribute("Frame") +
	                                        " already exist in TimelineStyle " +
	                                        node.nodeName);
	                                }
	                            }
	                        }
	                        if (nextCase.nodeName === "Outro") {
	                            this.outro = nextCase;
	                        }
	                        nextCase = nextCase.nextElementSibling;
	                    }
	                    break;
	                case "SoundTimeline":
	                    var nextCase = next.firstElementChild;
	                    while (nextCase != null) {
	                        if (nextCase.hasAttribute("Frame")) {
	                            if (this.framesSounds[nextCase.getAttribute("Frame")] !== null) {
	                                this.framesSounds[nextCase.getAttribute("Frame")] = nextCase;
	                            }
	                            else {
	                                if (false) {
	                                    this.log("ERROR frame " +
	                                        nextCase.getAttribute("Frame") +
	                                        " already exist in TimelineStyle " +
	                                        node.nodeName);
	                                }
	                            }
	                        }
	                        if (nextCase.nodeName === "Outro") {
	                            this.outroSounds = nextCase;
	                        }
	                        nextCase = nextCase.nextElementSibling;
	                    }
	                    break;
	            }
	            next = next.nextElementSibling;
	        }
	    };
	    TimelineStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.Style)
	    ], TimelineStyle);
	    return TimelineStyle;
	}(Style_1.Style));
	exports.TimelineStyle = TimelineStyle;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(2);
	var AnimationScriptManager = (function () {
	    function AnimationScriptManager() {
	    }
	    AnimationScriptManager.cleanup = function () {
	        AnimationScriptManager.Scripts = null;
	    };
	    AnimationScriptManager.addScript = function (id, factory, baseUrl, loadAssetCallback) {
	        var item = AnimationScriptManager.Scripts[id];
	        if (!neo_common_1.Utils.isNullOrUndefined(item)) {
	            if (false) {
	                neo_common_1.Logger.errorGroup("AnimationScriptManager", "Animation script with id '" + id + "' already exist. Please choose unique id!");
	            }
	            return;
	        }
	        try {
	            AnimationScriptManager.Scripts[id] = factory;
	            var assets = factory.assets || {};
	            if (assets && Object.keys(assets).length) {
	                for (var id_1 in assets) {
	                    var assetPath = assets[id_1];
	                    assetPath = neo_common_1.UriHelper.resolveUrl(baseUrl, assetPath);
	                    loadAssetCallback(id_1, assetPath);
	                }
	            }
	        }
	        finally {
	            loadAssetCallback(null, null);
	        }
	    };
	    AnimationScriptManager.createInstance = function (id) {
	        var item = AnimationScriptManager.Scripts[id];
	        if (neo_common_1.Utils.isNullOrUndefined(item)) {
	            if (false) {
	                neo_common_1.Logger.errorGroup("AnimationScriptManager", "Animation script with id '" + id + "' does not exist!");
	            }
	            return null;
	        }
	        var cachedInstance = AnimationScriptManager._cachedInstances[id];
	        if (neo_common_1.Utils.isNullOrUndefined(cachedInstance)) {
	            cachedInstance = new item();
	            AnimationScriptManager._cachedInstances[id] = cachedInstance;
	            if (false) {
	                var cacheSize = neo_common_1.ObjectUtils.keyCount(AnimationScriptManager._cachedInstances);
	                neo_common_1.Logger.debugGroup("AnimationScriptManager", "Created new instance of '" + id + "' and added to cache, caching so far " + cacheSize + " instances.");
	            }
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.debugGroup("AnimationScriptManager", "Returns cached instance of '" + id + "'.");
	            }
	        }
	        return cachedInstance;
	    };
	    AnimationScriptManager.Scripts = {};
	    AnimationScriptManager._cachedInstances = {};
	    return AnimationScriptManager;
	}());
	exports.AnimationScriptManager = AnimationScriptManager;
	window["AnimationScriptManager"] = AnimationScriptManager;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(2);
	var Resource_1 = __webpack_require__(67);
	var SndResource = (function (_super) {
	    __extends(SndResource, _super);
	    function SndResource() {
	        _super.apply(this, arguments);
	    }
	    SndResource.getSongById = function (id) {
	        if (this.Sounds != null) {
	            return this.Sounds[id];
	        }
	        else {
	            if (false) {
	                this.log("ERROR no sounds");
	            }
	        }
	        if (false) {
	            this.log("ERROR no song: " + id);
	        }
	        return null;
	    };
	    SndResource.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup("SndResource", s);
	        }
	    };
	    SndResource.Sounds = {};
	    return SndResource;
	}(Resource_1.Resource));
	exports.SndResource = SndResource;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var BetManager_1 = __webpack_require__(25);
	var Languages_1 = __webpack_require__(28);
	var LayoutSwitchElement_1 = __webpack_require__(108);
	var BonusCounters = (function (_super) {
	    __extends(BonusCounters, _super);
	    function BonusCounters() {
	        _super.apply(this, arguments);
	    }
	    BonusCounters.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(exports.BonusCountersAttributes.MULTIPLIERS)) {
	            this.multipliers = neo_common_1.ArrayUtils.numberArray(node.getAttribute(exports.BonusCountersAttributes.MULTIPLIERS));
	        }
	        this.counters = [];
	        if (this.elements.childs["Mini"] != null) {
	            this.counters.push(this.elements.childs["Mini"]);
	        }
	        if (this.elements.childs["Minor"] != null) {
	            this.counters.push(this.elements.childs["Minor"]);
	        }
	        if (this.elements.childs["Major"] != null) {
	            this.counters.push(this.elements.childs["Major"]);
	        }
	        if (this.elements.childs["Grand"] != null) {
	            this.counters.push(this.elements.childs["Grand"]);
	        }
	    };
	    BonusCounters.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	    };
	    BonusCounters.prototype.updateCounters = function () {
	        if (this.counters != null && this.multipliers != null && BetManager_1.BetManager.Bet) {
	            for (var i = 0; i < this.counters.length; i++) {
	                var value = neo_common_1.NumberUtils.multiply(this.multipliers[i], BetManager_1.BetManager.Bet);
	                this.updateLevelValue(this.counters[i], value);
	            }
	        }
	    };
	    BonusCounters.prototype.updateLevelValue = function (level, value) {
	        if (level != null) {
	            this.setAmount(level.getChildElementByName("Amount"), value, true);
	            this.setAmount(level.getChildElementByName("AmountGlow"), value, true);
	        }
	    };
	    BonusCounters.prototype.setAmount = function (textElement, value, format) {
	        if (textElement != null) {
	            textElement.bitmapText.text = format ? Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, value) : value;
	            textElement.realign();
	        }
	    };
	    BonusCounters.prototype.counterGoToCase = function (counterIndex, caseType) {
	        if (this.counters[counterIndex] != null) {
	            if (!this.allowCounterGoToCase(counterIndex, this.counters[counterIndex].getCurrentCase(), caseType)) {
	                return;
	            }
	            this.counters[counterIndex].goToCase(caseType);
	        }
	    };
	    BonusCounters.prototype.allCounterGoToCase = function (caseType) {
	        for (var i = 0; i < this.counters.length; i++) {
	            if (this.counters[i] != null) {
	                this.counters[i].goToCase(caseType);
	            }
	        }
	    };
	    BonusCounters.prototype.allowCounterGoToCase = function (counterIndex, currentCase, nextCase) {
	        if (currentCase == nextCase) {
	            return false;
	        }
	        if (counterIndex == 3) {
	            if (currentCase == "TEASE_POPPING" && nextCase == "TEASE_POP") {
	                return false;
	            }
	        }
	        return true;
	    };
	    BonusCounters.prototype.updateGrandCountToPosition = function () {
	        var grandLevel = this.counters[this.counters.length - 1];
	        if (grandLevel != null) {
	            var textElement = grandLevel.getChildElementByName("Amount");
	            var counterElement = grandLevel.getChildElementByName("CounterTo");
	            counterElement.x = textElement.x + textElement.bitmapText.x;
	        }
	    };
	    BonusCounters.prototype.updateGrandCountToValue = function (value, caseType) {
	        var grandLevel = this.counters[this.counters.length - 1];
	        if (grandLevel != null) {
	            var counterElement = grandLevel.getChildElementByName("CounterTo");
	            if (counterElement != null) {
	                var textElement = counterElement.getChildElementByName("Amount");
	                if (textElement != null) {
	                    textElement.goToCase(value);
	                }
	                counterElement.goToCase(caseType);
	            }
	        }
	    };
	    BonusCounters = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], BonusCounters);
	    return BonusCounters;
	}(LayoutSwitchElement_1.LayoutSwitchElement));
	exports.BonusCounters = BonusCounters;
	exports.BonusCountersAttributes = {
	    MULTIPLIERS: "Multipliers",
	};


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var PreloaderProvider_1 = __webpack_require__(65);
	var SplashScreen_1 = __webpack_require__(59);
	var Strings_1 = __webpack_require__(4);
	var Languages_1 = __webpack_require__(28);
	var HtmlSplashScreen = (function (_super) {
	    __extends(HtmlSplashScreen, _super);
	    function HtmlSplashScreen() {
	        _super.apply(this, arguments);
	    }
	    HtmlSplashScreen.prototype.create = function (node) {
	        if (!PreloaderProvider_1.PreloaderProvider.isGroupLoaded(HtmlSplashScreen.RequiredLoadGroup)) {
	            return;
	        }
	        _super.prototype.create.call(this, node);
	        PreloaderProvider_1.PreloaderProvider.addLoadingElementFunction(this);
	        this._initialize();
	        this.instance.offsetWidth;
	        this.instance.classList.remove("_disabled");
	        HtmlSplashScreen.suspendInit = true;
	        HtmlSplashScreen.instance = this;
	        SplashScreen_1.SplashScreen.createSplashScreen(this);
	    };
	    HtmlSplashScreen.prototype._initialize = function () {
	        this._gameProgressBar = document.getElementById("splashProgressBar");
	        this._gameProgressNumber = document.getElementById("splashProgressNumber");
	        this._gameContinueButton = document.getElementById("splashScreen");
	        if (this._gameProgressBar != null) {
	            var progressBar = document.getElementById("progressBar");
	            if (progressBar != null) {
	                this._gameProgressBar.style.width = progressBar.style.width;
	            }
	        }
	        if (this._gameProgressNumber != null) {
	            var progressNumber = document.getElementById("progressNumber");
	            if (progressNumber != null) {
	                this._gameProgressNumber.textContent = progressNumber.textContent;
	            }
	        }
	    };
	    HtmlSplashScreen.prototype.showContinueButton = function (callback) {
	        this._callback = callback;
	        if (this._callback != null) {
	            if (this._gameContinueButton != null) {
	                this._gameContinueButton.addEventListener("click", this._callback);
	            }
	            this._keyboardEvent = this.onKeyUp.bind(this);
	            document.addEventListener("keyup", this._keyboardEvent);
	        }
	        this.instance.classList.add("_loaded");
	    };
	    HtmlSplashScreen.prototype.onKeyUp = function (event) {
	        if (event.keyCode == 32) {
	            document.removeEventListener("keyup", this._keyboardEvent);
	            if (this._callback != null) {
	                this._callback();
	            }
	        }
	    };
	    HtmlSplashScreen.prototype.hideSplashScreen = function () {
	        if (this.instance.parentElement) {
	            document.removeEventListener("keyup", this._keyboardEvent);
	            this.instance.parentElement.removeChild(this.instance);
	        }
	    };
	    HtmlSplashScreen.prototype.showError = function () {
	        this.instance.classList.add("_error");
	        var progressNumber = document.getElementById("splashProgressBar");
	        progressNumber.innerHTML = Strings_1.Strings.loaded
	            ? Languages_1.Languages.getRid("ERROR_404")
	            : "Internal error. Please contact support.";
	    };
	    HtmlSplashScreen.prototype.onLoadCompleted = function (success) {
	    };
	    HtmlSplashScreen.prototype.onProgressUpdate = function (progress) {
	        if (this._gameProgressBar != null) {
	            this._gameProgressBar.style.width = progress + "%";
	        }
	        if (this._gameProgressNumber != null) {
	            this._gameProgressNumber.textContent = progress + "%";
	        }
	    };
	    HtmlSplashScreen.RequiredLoadGroup = "SPLASH";
	    HtmlSplashScreen.suspendInit = false;
	    HtmlSplashScreen.instance = null;
	    HtmlSplashScreen = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlSplashScreen);
	    return HtmlSplashScreen;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlSplashScreen = HtmlSplashScreen;


/***/ },
/* 142 */
131,
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var BetManager_1 = __webpack_require__(25);
	var ImageTextCounterElement_1 = __webpack_require__(105);
	var BaseElement_1 = __webpack_require__(12);
	var ImageTextElement_1 = __webpack_require__(99);
	var ImageTextElementAdaptive = (function (_super) {
	    __extends(ImageTextElementAdaptive, _super);
	    function ImageTextElementAdaptive() {
	        _super.call(this);
	        this.fixedDigitCount = false;
	        this.maxWidth = -1;
	        this.maxMultiplier = -1;
	        this.currentScale = -1;
	        this.originScale = 1;
	    }
	    ImageTextElementAdaptive.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute(exports.ImageTextElementAdaptiveAttributes.MAX_WIDTH)) {
	            this.maxWidth = parseInt(node.getAttribute(exports.ImageTextElementAdaptiveAttributes.MAX_WIDTH));
	        }
	        if (node.hasAttribute(exports.ImageTextElementAdaptiveAttributes.MAX_MULTIPLIER)) {
	            this.maxMultiplier = parseInt(node.getAttribute(exports.ImageTextElementAdaptiveAttributes.MAX_MULTIPLIER));
	        }
	        if (node.hasAttribute(BaseElement_1.BaseElementAttributes.SCALE)) {
	            this.originScale = parseFloat(node.getAttribute("Scale"));
	        }
	        if (node.getAttribute("FixedDigitCount") == "true") {
	            this.fixedDigitCount = true;
	        }
	    };
	    ImageTextElementAdaptive.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.ImageTextElementAdaptiveAttributes.TINT)) {
	            this.bitmapText.tint = parseInt(node.getAttribute(exports.ImageTextElementAdaptiveAttributes.TINT), 16);
	        }
	    };
	    ImageTextElementAdaptive.prototype.realign = function () {
	        if (this.fixedDigitCount) {
	            var oldValue = this.bitmapText.text;
	            this.bitmapText.scale.set(this.originScale);
	            this.bitmapText.scale.set(this.getAdaptiveScale());
	            this.bitmapText.text = oldValue;
	        }
	        else if (this.maxMultiplier > -1 && this.scale.x != this.currentScale) {
	            if (this.currentScale == -1) {
	                this.currentScale = this.getScaleByMaxMultiplier();
	            }
	            this.bitmapText.scale.set(this.currentScale);
	        }
	        else if (this.maxWidth > -1) {
	            this.bitmapText.scale.set(this.originScale);
	            if (this.bitmapText.width > 0) {
	                this.bitmapText.scale.set(this.getAdaptiveScale());
	            }
	        }
	        switch (this.textAlign) {
	            case ImageTextElement_1.ImageTextElementAttributes.TEXT_ALIGN_VALUE.RIGHT:
	                this.bitmapText.position.x = -this.bitmapText.width;
	                break;
	            case ImageTextElement_1.ImageTextElementAttributes.TEXT_ALIGN_VALUE.CENTER:
	                this.bitmapText.position.x = -this.bitmapText.width * 0.5;
	                break;
	            default:
	                this.bitmapText.position.x = 0;
	                break;
	        }
	        switch (this.textBaseline) {
	            case ImageTextElement_1.ImageTextElementAttributes.TEXT_BASELINE_VALUE.BOTTOM:
	                this.bitmapText.position.y = -this.bitmapText.height;
	                break;
	            case ImageTextElement_1.ImageTextElementAttributes.TEXT_BASELINE_VALUE.MIDDLE:
	                this.bitmapText.position.y = -this.bitmapText.height * 0.5;
	                break;
	            default:
	                this.bitmapText.position.y = 0;
	                break;
	        }
	    };
	    ImageTextElementAdaptive.prototype.getScaleByMaxMultiplier = function () {
	        if (BetManager_1.BetManager.Coins == null) {
	            return -1;
	        }
	        var originText = this.bitmapText.text;
	        var scale = this.originScale;
	        if (this.maxWidth != null) {
	            this.bitmapText.text = originText;
	            scale = this.getAdaptiveScale();
	        }
	        return scale;
	    };
	    ImageTextElementAdaptive.prototype.getAdaptiveScale = function () {
	        var scale = (this.maxWidth * this.fontScale) / this.bitmapText.width;
	        return scale < this.originScale * this.fontScale
	            ? scale
	            : scale > this.originScale * this.fontScale
	                ? this.originScale * this.fontScale
	                : this.originScale * scale;
	    };
	    ImageTextElementAdaptive.prototype.clone = function () {
	        var element = new ImageTextElementAdaptive();
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element.fontScale = this.fontScale;
	        element.font = this.font;
	        element.text = this.text;
	        element.textAlign = this.textAlign;
	        element.textBaseline = this.textBaseline;
	        element.maxWidth = this.maxWidth;
	        element.currentScale = this.currentScale;
	        element.originScale = this.originScale;
	        element.maxMultiplier = this.maxMultiplier;
	        element.fixedDigitCount = this.fixedDigitCount;
	        element.bitmapText = new PIXI.extras.BitmapText(this.text, { font: this.font });
	        element.addChild(element.bitmapText);
	        element.realign();
	        element.markAsCloned();
	        return element;
	    };
	    ImageTextElementAdaptive = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], ImageTextElementAdaptive);
	    return ImageTextElementAdaptive;
	}(ImageTextCounterElement_1.ImageTextCounterElement));
	exports.ImageTextElementAdaptive = ImageTextElementAdaptive;
	exports.ImageTextElementAdaptiveAttributes = {
	    MAX_WIDTH: "MaxWidth",
	    MAX_MULTIPLIER: "MaxMultiplier",
	    TINT: "Tint",
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Machine_1 = __webpack_require__(87);
	var ShapeElement_1 = __webpack_require__(13);
	var MachineExtended_1 = __webpack_require__(145);
	var PlayList_1 = __webpack_require__(33);
	var CustomUtils_1 = __webpack_require__(22);
	var AppContext_1 = __webpack_require__(5);
	var ModuleManager_1 = __webpack_require__(29);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var DataManager_1 = __webpack_require__(26);
	var GameData_1 = __webpack_require__(24);
	var BaseView_1 = __webpack_require__(86);
	var FrameTimer_1 = __webpack_require__(9);
	var MachineBonus = (function (_super) {
	    __extends(MachineBonus, _super);
	    function MachineBonus() {
	        _super.call(this);
	        this.offsetX = 1;
	        this.offsetY = 8;
	        this.fullReels = [0, 0, 0, 0, 0];
	        this.multiplierIndex = [0, 0, 0, 0, 0];
	        this.canTease = [];
	        this.shapeElementNode = null;
	        this._machineStopTimer = FrameTimer_1.CreateFrameTimer("BonusMachineStoppedDelay");
	        this._machineStopTimer.on(FrameTimer_1.FrameTimerEvents.Complete, this.onMachineStoppedDelayed.bind(this));
	        this.spinBitmask = 32767;
	    }
	    MachineBonus.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute(exports.MachineExtendedAttributes.REEL_MASK)) {
	            if (node.firstElementChild != null &&
	                node.firstElementChild.nodeName == node.getAttribute(exports.MachineExtendedAttributes.REEL_MASK)) {
	                this.shapeElementNode = node.firstElementChild;
	            }
	        }
	    };
	    MachineBonus.prototype.createReels = function (reels, reelValues) {
	        _super.prototype.createReels.call(this, reels, reelValues);
	        for (var i = 0; i < this._reelCount; i++) {
	            var reel = this._reels[i];
	            var orderIndex = MachineBonus.ReelsOrder.indexOf(i);
	            var nextReel = orderIndex < this._reelCount - 1 ? this._reels[MachineBonus.ReelsOrder[orderIndex + 1]] : null;
	            var previousReel = orderIndex > 0 ? this._reels[MachineBonus.ReelsOrder[orderIndex - 1]] : null;
	            if (reel != null) {
	                reel.updateReelSettings(previousReel, nextReel, this._startDelay * orderIndex, this._stopDelay * orderIndex, true);
	                if (this.shapeElementNode != null) {
	                    var maskElement = new ShapeElement_1.ShapeElement();
	                    maskElement.createByNode(this.shapeElementNode);
	                    maskElement.x = this._reelX[i] + this.offsetX + 1;
	                    maskElement.y = this._reelY[i] + this.offsetY - (window["QUALITY"] === "QHD" ? 2 : 0);
	                    reel.mask = maskElement;
	                    this.addChild(reel.mask);
	                }
	            }
	        }
	    };
	    MachineBonus.prototype.initialize = function (symbols, reels, reelValues, teasing, reelsRespin, winAnimator, winAnimatorBonus) {
	        _super.prototype.initialize.call(this, symbols, reels, reelValues, teasing);
	        this.teasingContainer = teasing;
	        this._winAnimatorBonus = winAnimatorBonus;
	    };
	    MachineBonus.prototype.spinStart = function (longRotation, useTransform, currentSymbols, spinBitmask) {
	        if (useTransform === void 0) { useTransform = false; }
	        if (spinBitmask === void 0) { spinBitmask = 0; }
	        this.activeReelsOrder = [];
	        this.canTease = [];
	        this.breakTeasing = false;
	        this.remainingRespins = CustomUtils_1.CustomUtils.getRemainingRespins() - 1;
	        this.fullReels = [0, 0, 0, 0, 0];
	        this.multiplierIndex = [0, 0, 0, 0, 0];
	        this._winAnimatorBonus.multiplierTeasingIndex = -1;
	        _super.prototype.spinStart.call(this, longRotation, useTransform, currentSymbols, spinBitmask);
	        var reelIndex = 0;
	        var firstReel = -1;
	        if (this._reels != null) {
	            var delayIndex = 0;
	            for (var i = 0; i < this._reelCount; i++) {
	                var reel = this._reels[MachineBonus.ReelsOrder[i]];
	                if (i % 3 === 0 && i > 0) {
	                    reelIndex++;
	                }
	                if (!reel.isSkipped()) {
	                    this.activeReelsOrder.push(MachineBonus.ReelsOrder[i]);
	                    reel.setStopDelay(this._stopDelay * delayIndex);
	                    delayIndex++;
	                    if (firstReel === -1) {
	                        firstReel = i;
	                    }
	                }
	                else {
	                    this.fullReels[reelIndex]++;
	                }
	            }
	        }
	        if (firstReel !== -1) {
	            this.canTease = this.checkTeasingAllReels(false, this.activeReelsOrder);
	            if (this.canTease[0] != null) {
	                this.tease(-1);
	            }
	        }
	    };
	    MachineBonus.prototype.spinStop = function (event, force, fromServer, legal) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        if (fromServer === void 0) { fromServer = false; }
	        if (legal === void 0) { legal = false; }
	        if (fromServer) {
	            this._stoppedFromServer = true;
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            if (this.verifyMinGameRoundDurationConditions()) {
	                this._legalStopTimer = setTimeout(function () { return _this.spinStop(null, false, false, true); }, this.getLegalRemainingSpinDuration());
	            }
	            else {
	                this._stoppedFromLegal = true;
	            }
	        }
	        else if (legal) {
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stoppedFromLegal = true;
	        }
	        else {
	            this._stopTimer.stop();
	            this._stoppedFromMachine = true;
	        }
	        if (force) {
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stoppedFromLegal = true;
	            this._stopTimer.stop();
	            this._stoppedFromMachine = true;
	        }
	        if (false) {
	            this.log("spinStop " + force);
	        }
	        if (this._stoppedFromServer && this._stoppedFromMachine && this._stoppedFromLegal) {
	            if (!ModuleManager_1.ModuleManager.bonusActive() &&
	                !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	                DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWinDenom, "0");
	            }
	            this._forceStop = force;
	            this.canTease = this.checkTeasingAllReels(force, this.activeReelsOrder);
	            var wasTease = false;
	            var wasFirstReel = false;
	            var teasingDelay = 0;
	            if (this._reels != null) {
	                for (var i = 0; i < this._reelCount; i++) {
	                    var index = MachineBonus.ReelsOrder[i];
	                    if (this._reels[index] != null) {
	                        if (this._stoppedSymbolsArray.length !== 0) {
	                            this._stoppingReelsCounter++;
	                            this._reels[index].setData(this._stoppedSymbolsArray[index]);
	                            var activeReelIndex = this.activeReelsOrder.indexOf(index);
	                            if (activeReelIndex != -1) {
	                                if (this.canTease[activeReelIndex] == null) {
	                                    if (wasFirstReel) {
	                                        teasingDelay += this._stopDelay;
	                                    }
	                                    wasFirstReel = true;
	                                }
	                                else {
	                                    teasingDelay += MachineBonus.BonusGrandTeasingDuration;
	                                }
	                            }
	                            if (activeReelIndex === -1) {
	                                this._reels[index].spinStop(force, teasingDelay);
	                            }
	                            else if (this.canTease[activeReelIndex] == null && wasTease === false) {
	                                this._reels[index].spinStop(force, teasingDelay);
	                            }
	                            else {
	                                wasTease = true;
	                                if (this.canTease[activeReelIndex] == null) {
	                                    this._reels[index].spinStop(force, teasingDelay);
	                                }
	                                else {
	                                    this._reels[index].spinTease(this.canTease[activeReelIndex], teasingDelay);
	                                }
	                            }
	                        }
	                        else {
	                            if (false) {
	                                this.log("ERROR no stopped symbols");
	                            }
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reel with index: " + i);
	                        }
	                    }
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no reels");
	                }
	            }
	        }
	    };
	    MachineBonus.prototype.onReelStopped = function (reelIndex) {
	        if (!this._reels[reelIndex].isSkipped()) {
	            PlayList_1.PlayList.setPan("SND_BaseRotationEnd" + (reelIndex % 5), 5, reelIndex % 5);
	            PlayList_1.PlayList.play("SND_BaseRotationEnd" + (reelIndex % 5));
	            this.tease(reelIndex);
	        }
	        this._stoppedReelIndexes++;
	        this.actualReelStopped = reelIndex;
	        this._reels[reelIndex].visible = false;
	        this.emit(Machine_1.Machine.ReelStopped);
	        if (this._stoppedReelIndexes === this._reelCount) {
	            if (CustomUtils_1.CustomUtils.isBonusSymbol(this._stoppedSymbolsArray[reelIndex].symbols[0])) {
	                this._machineStopTimer.start(MachineBonus.StickyLastReelStopDelay);
	            }
	            else {
	                this.onMachineStoppedDelayed();
	            }
	        }
	    };
	    MachineBonus.prototype.onMachineStoppedDelayed = function () {
	        this._machineStopTimer.stop();
	        PlayList_1.PlayList.stop("SND_BaseRotation", 10);
	        if (this._legalStopTimer != null) {
	            clearTimeout(this._legalStopTimer);
	        }
	        this._stopTimer.stop();
	        if (false) {
	            var old = AppContext_1.AppContext.gameConfiguration.MinGameRoundDuration;
	            var current = AppContext_1.AppContext.gameConfiguration.GameRoundMinSpan;
	            var minDuration = current > 0 ? current : old > 0 ? old : 0;
	            var spinDuration = Date.now() - this._startSpinTime;
	            if (spinDuration > minDuration || !this.verifyMinGameRoundDurationConditions()) {
	                this.log("Spin time duration: " + spinDuration + " ms");
	            }
	            else {
	                console.log("%cError spin time duration:" + spinDuration + " ms", "color: #ff9900");
	            }
	        }
	        this.emit(Machine_1.Machine.MachineStopped);
	        this._reelsContainer.visible = false;
	    };
	    MachineBonus.prototype.checkTeasingAllReels = function (force, activeReels) {
	        var canTease = [];
	        if (activeReels != null) {
	            for (var i = 0; i < activeReels.length; i++) {
	                var currentReelIndex = activeReels[i];
	                var result = force ? null : this.checkTeasingBonus(currentReelIndex, activeReels);
	                canTease.push(result);
	            }
	        }
	        return canTease;
	    };
	    MachineBonus.prototype.checkTeasingBonus = function (reelIndex, activeReels) {
	        if (activeReels === void 0) { activeReels = []; }
	        var canTease = false;
	        var index = reelIndex % 5;
	        if (index === 0 && this.fullReels[0] === 2 && this.fullReels[1] === 3 && this.fullReels[2] === 3) {
	            canTease = true;
	        }
	        else if (index === 1 && this.fullReels[0] === 3 && this.fullReels[1] === 2 && this.fullReels[2] === 3) {
	            canTease = true;
	        }
	        else if (index === 2 && this.fullReels[0] === 3 && this.fullReels[1] === 3 && this.fullReels[2] === 2) {
	            canTease = true;
	        }
	        else if (index === 3 &&
	            this.fullReels[0] === 3 &&
	            this.fullReels[1] === 3 &&
	            this.fullReels[2] === 3 &&
	            this.fullReels[3] === 2) {
	            canTease = true;
	        }
	        else if (index === 4 &&
	            this.fullReels[0] === 3 &&
	            this.fullReels[1] === 3 &&
	            this.fullReels[2] === 3 &&
	            this.fullReels[3] === 3 &&
	            this.fullReels[4] === 2) {
	            canTease = true;
	        }
	        if (canTease) {
	            if (index <= 2) {
	                if (this.fullReels[3] === 3 && this.fullReels[4] === 3) {
	                    this.multiplierIndex[index] = 5;
	                }
	                else if (this.fullReels[3] === 3) {
	                    this.multiplierIndex[index] = 4;
	                }
	                else {
	                    this.multiplierIndex[index] = 3;
	                }
	            }
	            else if (index === 3) {
	                if (this.fullReels[4] === 3) {
	                    this.multiplierIndex[index] = 5;
	                }
	                else {
	                    this.multiplierIndex[index] = 4;
	                }
	            }
	            else {
	                this.multiplierIndex[index] = 5;
	            }
	        }
	        if (this.fullReels[index] < 3 && this._stoppedSymbolsArray[reelIndex].overlay) {
	            this.fullReels[index]++;
	        }
	        if (canTease) {
	            return MachineBonus.BonusSymbolIds;
	        }
	        if (activeReels.length == 1) {
	            return MachineBonus.BonusSymbolIds;
	        }
	        if (activeReels.indexOf(reelIndex) == activeReels.length - 1) {
	            canTease = true;
	            for (var i = 0; i < activeReels.length - 1; i++) {
	                var currentIndex = activeReels[i];
	                if (!CustomUtils_1.CustomUtils.isBonusSymbol(this._stoppedSymbolsArray[currentIndex].symbols[0])) {
	                    canTease = false;
	                    break;
	                }
	            }
	        }
	        return canTease ? MachineBonus.BonusSymbolIds : null;
	    };
	    MachineBonus.prototype.tease = function (reelIndex) {
	        if (reelIndex == -1) {
	            if (this.activeReelsOrder.length == 1) {
	                this.reelTeasingGoToCase(this.activeReelsOrder[0], "TEASE");
	                if (BaseView_1.BaseView.BonusCounters != null) {
	                    BaseView_1.BaseView.BonusCounters.counterGoToCase(3, "TEASE_POP");
	                }
	            }
	            else {
	                this.reelTeasingGoToCase(this.activeReelsOrder[0], "TEASE");
	            }
	            PlayList_1.PlayList.play("SND_BaseTeaser");
	            this._winAnimatorBonus.onSameSymbolsOnReelTeasingStart(this.multiplierIndex[this.activeReelsOrder[0] % 5], this.activeReelsOrder[0]);
	        }
	        else {
	            if (this.activeReelsOrder.indexOf(reelIndex) > -1) {
	                if (this.activeReelsOrder.indexOf(reelIndex) == this.activeReelsOrder.length - 1) {
	                    this.allTeasingGoToCase("HIDE");
	                    PlayList_1.PlayList.stop("SND_BaseTeaser", 10);
	                    if (CustomUtils_1.CustomUtils.isLastBonusSpin() &&
	                        !CustomUtils_1.CustomUtils.isBonusSymbol(this._stoppedSymbolsArray[reelIndex].symbols[0])) {
	                        if (BaseView_1.BaseView.BonusCounters != null) {
	                            BaseView_1.BaseView.BonusCounters.counterGoToCase(3, "BONUS");
	                        }
	                    }
	                }
	                else {
	                    var indexOfNextActiveReel = this.activeReelsOrder.indexOf(reelIndex) + 1;
	                    var nextReelIndex = this.activeReelsOrder[indexOfNextActiveReel];
	                    var nextTeasingSymbols = this.canTease[indexOfNextActiveReel];
	                    this.reelTeasingGoToCase(reelIndex, "HIDE");
	                    PlayList_1.PlayList.stop("SND_BaseTeaser", 10);
	                    if (nextTeasingSymbols != null) {
	                        this.reelTeasingGoToCase(nextReelIndex, "TEASE");
	                        PlayList_1.PlayList.play("SND_BaseTeaser");
	                        this._winAnimatorBonus.onSameSymbolsOnReelTeasingStart(this.multiplierIndex[nextReelIndex % 5], nextReelIndex);
	                        if (nextTeasingSymbols != null && indexOfNextActiveReel == this.activeReelsOrder.length - 1) {
	                            if (BaseView_1.BaseView.BonusCounters != null) {
	                                BaseView_1.BaseView.BonusCounters.counterGoToCase(3, "TEASE_POP");
	                            }
	                        }
	                    }
	                }
	            }
	        }
	    };
	    MachineBonus.prototype.allTeasingGoToCase = function (caseType, onlyActive) {
	        if (onlyActive === void 0) { onlyActive = false; }
	        for (var i = 0; i < MachineBonus.ReelsOrder.length; i++) {
	            var reelIndex = MachineBonus.ReelsOrder[i];
	            if (onlyActive && this.activeReelsOrder.indexOf(reelIndex) == -1) {
	                continue;
	            }
	            this.reelTeasingGoToCase(reelIndex, caseType);
	        }
	    };
	    MachineBonus.prototype.reelTeasingGoToCase = function (reelIndex, caseType) {
	        if (this.teasingContainer != null) {
	            var teasingElement = this.teasingContainer.childs["Teasing_" + reelIndex];
	            if (caseType == "HIDE" &&
	                (teasingElement.getCurrentCase() == "EMPTY" || teasingElement.getCurrentCase() == "SHOW_2")) {
	                return;
	            }
	            teasingElement.goToCase(caseType);
	        }
	    };
	    MachineBonus.ReelsOrder = [0, 5, 10, 1, 6, 11, 2, 7, 12, 3, 8, 13, 4, 9, 14];
	    MachineBonus.StickyLastReelStopDelay = 20;
	    MachineBonus.BonusSymbolIds = [12, 13, 14, 15];
	    MachineBonus.BonusGrandTeasingDuration = 180;
	    MachineBonus = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], MachineBonus);
	    return MachineBonus;
	}(MachineExtended_1.MachineExtended));
	exports.MachineBonus = MachineBonus;
	exports.MachineExtendedAttributes = {
	    REEL_MASK: "ReelMask",
	};


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var Machine_1 = __webpack_require__(87);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var ModuleManager_1 = __webpack_require__(29);
	var CustomUtils_1 = __webpack_require__(22);
	var ReelExtended_1 = __webpack_require__(100);
	var FreeRoundBonus_1 = __webpack_require__(44);
	var MachineExtended = (function (_super) {
	    __extends(MachineExtended, _super);
	    function MachineExtended() {
	        _super.call(this);
	        this._spinnedReelsCounter = 0;
	        this._stoppingReelsCounter = 0;
	        this._lastTeasing = "";
	        this._teasingSymbol = [0, 0, 0, 0, 0];
	        this._fullStackedReel = [false, false, false, false, false];
	        this.multiplierIndex = [0, 0, 0, 0, 0];
	        this._canTease = [false, false, false, false, false];
	        this._wasRespin = false;
	        this._stackedSymbols = [
	            [false, false, false],
	            [false, false, false],
	            [false, false, false],
	            [false, false, false],
	            [false, false, false],
	        ];
	        this._clonedReelIndex = -1;
	        this._clonedReelCount = -1;
	        this._skipStopDelayReelIndex = [];
	        this._reelIndexOffsetStopDelay = -1;
	        this.spinBitmask = 31;
	    }
	    MachineExtended.prototype.createReels = function (reels, reelValues, respinValues) {
	        _super.prototype.createReels.call(this, reels);
	        if (reelValues != null && reelValues.length > 0) {
	            var index = 0;
	            for (var i = 0; i < this._reelCount; i++) {
	                var reel = this._reels[i];
	                if (this._skipStopDelayReelIndex.indexOf(i) == -1) {
	                    if (this._reelIndexOffsetStopDelay > 0) {
	                        reel.setStartDelay(this._startDelay * (index + this._reelIndexOffsetStopDelay));
	                        reel.setStopDelay(this._stopDelay * (index + this._reelIndexOffsetStopDelay));
	                        index++;
	                    }
	                }
	                reel.setValuesStrip(reelValues[i]);
	            }
	        }
	        if (respinValues != null && respinValues.length > 0) {
	            for (var i = 0; i < this._reelCount; i++) {
	                var reel = this._reels[i];
	                reel.setRespinStrip(respinValues[i]);
	            }
	        }
	    };
	    MachineExtended.prototype.configurate = function (node) {
	        _super.prototype.configurate.call(this, node);
	        if (node.hasAttribute("ClonedReelIndex")) {
	            this._clonedReelIndex = parseInt(node.getAttribute("ClonedReelIndex"));
	        }
	        if (node.hasAttribute("ClonedReelCount")) {
	            this._clonedReelCount = parseInt(node.getAttribute("ClonedReelCount"));
	        }
	        if (node.hasAttribute("SkipStopDelayReelIndex")) {
	            this._skipStopDelayReelIndex = neo_common_1.ArrayUtils.numberArray(node.getAttribute("SkipStopDelayReelIndex"));
	        }
	        if (node.hasAttribute("ReelIndexOffsetStopDelay")) {
	            this._reelIndexOffsetStopDelay = parseInt(node.getAttribute("ReelIndexOffsetStopDelay"));
	        }
	    };
	    MachineExtended.prototype.initialize = function (symbols, reels, reelValues, teasing, reelsRespin, winAnimator) {
	        this._symbols = symbols;
	        this._teasing = teasing;
	        this._winAnimator = winAnimator;
	        reels = this.createClonedReels(reels);
	        reelValues = this.createClonedReels(reelValues);
	        this.createReels(reels, reelValues, reelsRespin);
	    };
	    MachineExtended.prototype.spinStart = function (longRotation, useTransform, currentSymbols, spinBitmask) {
	        if (useTransform === void 0) { useTransform = false; }
	        if (spinBitmask === void 0) { spinBitmask = 0; }
	        this.spinBitmask = spinBitmask;
	        if (this.spinBitmask !== 0) {
	            if (false) {
	                this.log("spinStart");
	            }
	            ReelExtended_1.ReelExtended.Tease = -1;
	            Machine_1.Machine.Respin = false;
	            ReelExtended_1.ReelExtended.TeaseingSymbols = [];
	            if (!CustomUtils_1.CustomUtils.isRespin()) {
	                this._stackedSymbols = [
	                    [false, false, false],
	                    [false, false, false],
	                    [false, false, false],
	                    [false, false, false],
	                    [false, false, false],
	                ];
	                this._fullStackedReel = [false, false, false, false, false];
	                this._wasRespin = false;
	                this._canTease = [false, false, false, false, false];
	            }
	            else {
	                this._wasRespin = true;
	            }
	            this._stoppedFromServer = false;
	            this._stoppedFromMachine = false;
	            this._stoppedFromLegal = false;
	            this._startSpinTime = Date.now();
	            this._forceStop = false;
	            this.visible = true;
	            this._reelsContainer.visible = true;
	            this.actualReelStopped = -1;
	            this._stoppedReelIndexes = 0;
	            this._spinnedReelsCounter = 0;
	            this._stoppingReelsCounter = 0;
	            if (this._reels != null) {
	                for (var i = 0; i < this._reelCount; i++) {
	                    if (this._reels[i] != null) {
	                        if ((spinBitmask & (1 << i)) !== 0) {
	                            if (this._stoppedSymbolsArray.length > 0) {
	                                this._reels[i].visible = true;
	                                this._reels[i].setData(this._stoppedSymbolsArray[i]);
	                                this._reels[i].currentSymbols = [];
	                                for (var j = 0; j < this._visibleSymbolCount; j++) {
	                                    this._reels[i].currentSymbols.push(currentSymbols[i][j]);
	                                    currentSymbols[i][j] = null;
	                                }
	                                this._reels[i].setBaseRespinStrip(CustomUtils_1.CustomUtils.isRespin());
	                                this._reels[i].showSymbols(useTransform);
	                                this._reels[i].spinStart();
	                                this.setTeasing(i);
	                                if (this._canTease[i] && this._spinnedReelsCounter === 0) {
	                                    this.tease(i);
	                                }
	                                this._spinnedReelsCounter++;
	                            }
	                            else {
	                                if (false) {
	                                    this.log("ERROR no stopped symbols");
	                                }
	                            }
	                        }
	                    }
	                    else {
	                        if (false) {
	                            this.log("ERROR no reel with index: " + i);
	                        }
	                    }
	                }
	                if (longRotation != null && longRotation) {
	                    this._stopTimer.start(this._minSpinRotationLong);
	                }
	                else {
	                    this._stopTimer.start(this._minSpinRotation);
	                }
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no reels");
	                }
	            }
	            PlayList_1.PlayList.play("SND_BaseRotationStart");
	            PlayList_1.PlayList.loop("SND_BaseRotation", 0, true);
	        }
	    };
	    MachineExtended.prototype.spinStop = function (event, force, fromServer, legal) {
	        var _this = this;
	        if (force === void 0) { force = false; }
	        if (fromServer === void 0) { fromServer = false; }
	        if (legal === void 0) { legal = false; }
	        if (this.spinBitmask !== 0) {
	            if (fromServer) {
	                this._stoppedFromServer = true;
	                if (this._legalStopTimer != null) {
	                    clearTimeout(this._legalStopTimer);
	                }
	                if (this.verifyMinGameRoundDurationConditions()) {
	                    this._legalStopTimer = setTimeout(function () { return _this.spinStop(null, false, false, true); }, this.getLegalRemainingSpinDuration());
	                }
	                else {
	                    this._stoppedFromLegal = true;
	                }
	            }
	            else if (legal) {
	                if (this._legalStopTimer != null) {
	                    clearTimeout(this._legalStopTimer);
	                }
	                this._stoppedFromLegal = true;
	            }
	            else {
	                this._stopTimer.stop();
	                this._stoppedFromMachine = true;
	            }
	            if (force) {
	                this._forceStop = true;
	                if (this._legalStopTimer != null) {
	                    clearTimeout(this._legalStopTimer);
	                }
	                this._stoppedFromLegal = true;
	                this._stopTimer.stop();
	                this._stoppedFromMachine = true;
	                PlayList_1.PlayList.stop("SND_BaseTeaser", 10);
	            }
	            if (false) {
	                this.log("spinStop " + force);
	            }
	            if (this._stoppedFromServer && this._stoppedFromMachine && this._stoppedFromLegal) {
	                if (!ModuleManager_1.ModuleManager.bonusActive() &&
	                    !(FreeRoundBonus_1.FreeRoundBonus.inFrb && FreeRoundBonus_1.FreeRoundBonus.winPayMethod === "cumulative")) {
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWin, "0");
	                    DataManager_1.DataManager.updateDataElement(GameData_1.GameData.DataTotalWinDenom, "0");
	                }
	                if (force && this._teasing != null && this._lastTeasing != "") {
	                    var teasing = this._teasing.childs[this._lastTeasing];
	                    if (teasing) {
	                        teasing.goToCase("STOPPING");
	                    }
	                    this._lastTeasing = "";
	                }
	                this._canTease = [false, false, false, false, false];
	                if (this._wasRespin || CustomUtils_1.CustomUtils.isRespin()) {
	                    this.checkTeasing(force);
	                }
	                if (this._reels != null) {
	                    var teasingDelay = 0;
	                    var reelDelay = 0;
	                    var customTeasingDelay = 130;
	                    var firstReel = true;
	                    for (var i = 0; i < this._reelCount; i++) {
	                        if (this._reels[i] != null) {
	                            if ((this.spinBitmask & (1 << i)) !== 0) {
	                                if (this._stoppedSymbolsArray.length !== 0) {
	                                    this._stoppingReelsCounter++;
	                                    this._reels[i].setData(this._stoppedSymbolsArray[i]);
	                                    if (force ||
	                                        (!this._canTease[0] &&
	                                            !this._canTease[1] &&
	                                            !this._canTease[2] &&
	                                            !this._canTease[3] &&
	                                            !this._canTease[4])) {
	                                        this._reels[i].spinStop(force);
	                                    }
	                                    else {
	                                        if (this._canTease[0]) {
	                                            if (i === 0) {
	                                                teasingDelay += customTeasingDelay;
	                                                this._reels[i].spinTease([], teasingDelay);
	                                            }
	                                            else if (i === 1 || i === 2) {
	                                                this._reels[i].spinStop(force);
	                                            }
	                                        }
	                                        else if (this._canTease[1]) {
	                                            if (i === 1) {
	                                                teasingDelay += customTeasingDelay;
	                                                this._reels[i].spinTease([], teasingDelay);
	                                            }
	                                            else if (i === 0 || i === 2) {
	                                                reelDelay += this._stopDelay;
	                                                this._reels[i].spinStop(force, reelDelay);
	                                            }
	                                        }
	                                        else if (this._canTease[2]) {
	                                            if (i === 2) {
	                                                teasingDelay += customTeasingDelay;
	                                                this._reels[i].spinTease([], teasingDelay);
	                                            }
	                                            else if (i === 0 || i === 1) {
	                                                reelDelay += this._stopDelay;
	                                                this._reels[i].spinStop(force, reelDelay);
	                                            }
	                                        }
	                                        if (i === 3) {
	                                            if (this._canTease[3]) {
	                                                teasingDelay += customTeasingDelay;
	                                                this._reels[i].spinTease([], teasingDelay);
	                                            }
	                                            else {
	                                                reelDelay += this._stopDelay;
	                                                this._reels[i].spinStop(force, teasingDelay + reelDelay);
	                                            }
	                                        }
	                                        if (i === 4) {
	                                            if (this._canTease[4]) {
	                                                teasingDelay += customTeasingDelay;
	                                                this._reels[i].spinTease([], teasingDelay);
	                                            }
	                                            else {
	                                                reelDelay += this._stopDelay;
	                                                this._reels[i].spinStop(force, teasingDelay + reelDelay);
	                                            }
	                                        }
	                                    }
	                                }
	                                else {
	                                    if (false) {
	                                        this.log("ERROR no stopped symbols");
	                                    }
	                                }
	                                firstReel = false;
	                            }
	                        }
	                        else {
	                            if (false) {
	                                this.log("ERROR no reel with index: " + i);
	                            }
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        this.log("ERROR no reels");
	                    }
	                }
	            }
	        }
	        else {
	            this.emit(Machine_1.Machine.MachineStopped);
	        }
	    };
	    MachineExtended.prototype.checkTeasing = function (force) {
	        if (this._teasing == null) {
	            return;
	        }
	        for (var i = 0; i < this._reelCount; i++) {
	            this.setTeasing(i, force);
	            if (!this._fullStackedReel[i]) {
	                for (var j = 0; j < this._stoppedSymbolsArray[i].symbols.length; j++) {
	                    if (this._stoppedSymbolsArray[i].overlay && this._stoppedSymbolsArray[i].overlay[j] >= 1) {
	                        this._stackedSymbols[i][j] = true;
	                    }
	                }
	                this._fullStackedReel[i] = this._stackedSymbols[i].indexOf(false) === -1;
	            }
	        }
	    };
	    MachineExtended.prototype.setTeasing = function (i, force) {
	        if (force === void 0) { force = false; }
	        switch (i) {
	            case 0:
	                if (this._fullStackedReel[1] && this._fullStackedReel[2] && this.stackSymbolsCountOnReel(i) === 2) {
	                    this._canTease[0] = force ? false : true;
	                }
	                break;
	            case 1:
	                if (this._fullStackedReel[0] && this._fullStackedReel[2] && this.stackSymbolsCountOnReel(i) === 2) {
	                    this._canTease[1] = force ? false : true;
	                }
	                break;
	            case 2:
	                if (this._fullStackedReel[0] && this._fullStackedReel[1] && this.stackSymbolsCountOnReel(i) === 2) {
	                    this._canTease[2] = force ? false : true;
	                }
	                break;
	            case 3:
	                if (this._fullStackedReel[0] &&
	                    this._fullStackedReel[1] &&
	                    this._fullStackedReel[2] &&
	                    this.stackSymbolsCountOnReel(i) === 2) {
	                    this._canTease[3] = force ? false : true;
	                }
	                break;
	            case 4:
	                if (this._fullStackedReel[0] &&
	                    this._fullStackedReel[1] &&
	                    this._fullStackedReel[2] &&
	                    this._fullStackedReel[3] &&
	                    this.stackSymbolsCountOnReel(i) === 2) {
	                    this._canTease[4] = force ? false : true;
	                }
	                break;
	        }
	        if (this._canTease[i]) {
	            if (i <= 2) {
	                if (this._fullStackedReel[3] && this._fullStackedReel[4]) {
	                    this.multiplierIndex[i] = 5;
	                }
	                else if (this._fullStackedReel[3]) {
	                    this.multiplierIndex[i] = 4;
	                }
	                else {
	                    this.multiplierIndex[i] = 3;
	                }
	            }
	            else if (i === 3) {
	                if (this._fullStackedReel[4]) {
	                    this.multiplierIndex[i] = 5;
	                }
	                else {
	                    this.multiplierIndex[i] = 4;
	                }
	            }
	            else {
	                this.multiplierIndex[i] = 5;
	            }
	            this._teasingSymbol[i] = this._stackedSymbols[i].indexOf(false);
	        }
	    };
	    MachineExtended.prototype.stackSymbolsCountOnReel = function (reelIndex) {
	        var symbolCounter = 0;
	        for (var i = 0; i < this._stackedSymbols[reelIndex].length; i++) {
	            if (this._stackedSymbols[reelIndex][i]) {
	                symbolCounter++;
	            }
	        }
	        return symbolCounter;
	    };
	    MachineExtended.prototype.onReelStopped = function (reelIndex) {
	        if (!this._reels[reelIndex].isSkipped()) {
	            PlayList_1.PlayList.setPan("SND_BaseRotationEnd" + reelIndex, this._reelCount, reelIndex);
	            PlayList_1.PlayList.play("SND_BaseRotationEnd" + reelIndex);
	        }
	        if (this._wasRespin || CustomUtils_1.CustomUtils.isRespin()) {
	            this.tease(reelIndex, true);
	        }
	        this._stoppedReelIndexes++;
	        this.actualReelStopped = reelIndex;
	        this._reels[reelIndex].visible = false;
	        this.emit(Machine_1.Machine.ReelStopped, this._forceStop);
	        if (this._stoppedReelIndexes === this._spinnedReelsCounter) {
	            PlayList_1.PlayList.stop("SND_BaseRotation", 10);
	            this.stopTease();
	            if (this._legalStopTimer != null) {
	                clearTimeout(this._legalStopTimer);
	            }
	            this._stopTimer.stop();
	            this.emit(Machine_1.Machine.MachineStopped);
	            this._reelsContainer.visible = false;
	        }
	    };
	    MachineExtended.prototype.tease = function (reelIndex, onReelStop) {
	        if (onReelStop === void 0) { onReelStop = false; }
	        var index = reelIndex;
	        if (onReelStop) {
	            index = reelIndex + 1;
	            if (reelIndex < this._reelCount - 1) {
	                for (var i = reelIndex + 1; i < this._reelCount; i++) {
	                    if ((this.spinBitmask & (1 << i)) !== 0) {
	                        index = i;
	                        break;
	                    }
	                }
	            }
	        }
	        if (this._teasing != null && index < this._reelCount) {
	            if (this._lastTeasing != "") {
	                var teasingStop = this._teasing.childs[this._lastTeasing];
	                if (teasingStop) {
	                    teasingStop.goToCase("STOPPING");
	                    PlayList_1.PlayList.stop("SND_BaseTeaser", 10);
	                    PlayList_1.PlayList.play("SND_BaseLoop", 10);
	                }
	                this._lastTeasing = "";
	                ReelExtended_1.ReelExtended.Tease = -1;
	            }
	            if (this._canTease[index]) {
	                ReelExtended_1.ReelExtended.Tease = index;
	                this._lastTeasing = "Teasing_" + index + "_" + this._teasingSymbol[index];
	                var teasing = this._teasing.childs[this._lastTeasing];
	                if (teasing) {
	                    teasing.goToCase("START");
	                }
	                PlayList_1.PlayList.play("SND_BaseTeaser");
	                PlayList_1.PlayList.stop("SND_BaseLoop");
	                this._winAnimator.onSameSymbolsOnReelTeasingStart(this.multiplierIndex[index], index);
	            }
	        }
	    };
	    MachineExtended.prototype.stopTease = function () {
	        if (this._teasing) {
	            var teasing = this._teasing.childs[this._lastTeasing];
	            if (teasing) {
	                teasing.goToCase("STOPPING");
	                PlayList_1.PlayList.stop("SND_BaseTeaser", 10);
	                PlayList_1.PlayList.play("SND_BaseLoop", 10);
	            }
	            this._lastTeasing = "";
	        }
	        ReelExtended_1.ReelExtended.Tease = -1;
	    };
	    MachineExtended.prototype.createClonedReels = function (reels) {
	        if (reels != null && this._clonedReelIndex > -1 && this._clonedReelCount > -1) {
	            var reelToClone = reels[this._clonedReelIndex];
	            if (reelToClone != null) {
	                for (var i = 0; i < this._clonedReelCount - 1; i++) {
	                    reels.splice(this._clonedReelIndex, 0, reelToClone);
	                }
	            }
	        }
	        return reels;
	    };
	    MachineExtended.prototype.addAdditionalReelSets = function (reelSets) {
	        for (var reelIndex = 0; reelIndex < this._reelCount; reelIndex++) {
	            var reelSetsForReel = [];
	            for (var i = 0; i < reelSets.length; i++) {
	                reelSetsForReel.push({
	                    id: reelSets[i].id,
	                    reel: reelSets[i].reels[reelIndex],
	                });
	            }
	            this._reels[reelIndex].addCustomData({ reelSets: reelSetsForReel });
	        }
	    };
	    MachineExtended = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], MachineExtended);
	    return MachineExtended;
	}(Machine_1.Machine));
	exports.MachineExtended = MachineExtended;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var gsap_1 = __webpack_require__(17);
	var BaseElement_1 = __webpack_require__(12);
	var StageController_1 = __webpack_require__(6);
	var StyleManager_1 = __webpack_require__(20);
	var Tweens_1 = __webpack_require__(15);
	var CustomUtils_1 = __webpack_require__(22);
	var RopeElement = (function (_super) {
	    __extends(RopeElement, _super);
	    function RopeElement() {
	        _super.call(this);
	        this._noWebGL = false;
	        this._rope = null;
	        this._pointsCount = 100;
	        this._bezierPoints = [];
	        this._pointsData = [];
	        this._pointsDataBuffer = [];
	        this._blendMode = 0;
	        this._animationStyle = null;
	        this._frame = 0;
	        this._tint = null;
	        this._curviness = 1;
	        this._continue = false;
	        this._isPlaying = false;
	        this._randomStartFrame = false;
	        this._time = -1;
	        this.count = 0;
	        this._ropeLength = 0;
	        this._increment = 0;
	        this._parts = [];
	        this._strength = [];
	        this._smooth = [];
	        this._created = false;
	        if (StageController_1.StageController.Renderer instanceof PIXI.CanvasRenderer) {
	            this._noWebGL = true;
	        }
	    }
	    RopeElement.prototype.createByNode = function (node) {
	        if (!this._created) {
	            _super.prototype.createByNode.call(this, node);
	            if (node.hasAttribute(RopeElementAttributes.POINTS_COUNT)) {
	                this._pointsCount = parseInt(node.getAttribute(RopeElementAttributes.POINTS_COUNT));
	            }
	            if (node.hasAttribute(RopeElementAttributes.BLEND_MODE)) {
	                this._blendMode = CustomUtils_1.CustomUtils.getBlendMode(parseInt(node.getAttribute(RopeElementAttributes.BLEND_MODE)));
	            }
	            if (node.hasAttribute(RopeElementAttributes.CURVINESS)) {
	                this._curviness = parseFloat(node.getAttribute(RopeElementAttributes.CURVINESS));
	            }
	            if (node.hasAttribute(RopeElementAttributes.RANDOM_START_FRAME)) {
	                this._randomStartFrame = neo_common_1.StringUtils.parseBoolean(node.getAttribute(RopeElementAttributes.RANDOM_START_FRAME));
	            }
	            if (node.hasAttribute(RopeElementAttributes.TIME)) {
	                this._randomStartFrame = false;
	                this._time = parseFloat(node.getAttribute(RopeElementAttributes.TIME));
	            }
	            if (node.hasAttribute(RopeElementAttributes.TINT)) {
	                if (node.getAttribute(RopeElementAttributes.TINT) === "0") {
	                    this._tint = null;
	                }
	                else {
	                    this._tint = parseInt(node.getAttribute(RopeElementAttributes.TINT), 16);
	                }
	            }
	            if (node.hasAttribute(RopeElementAttributes.POINTS)) {
	                var pointsData = this.formatPoints(node.getAttribute(RopeElementAttributes.POINTS));
	                var bezierData = gsap_1.BezierPlugin.bezierThrough(pointsData);
	                this._bezierPoints = this.getBezierStepPoints(bezierData, this._pointsCount);
	            }
	            if (node.hasAttribute(RopeElementAttributes.IMAGE)) {
	                var textureName = node.getAttribute(RopeElementAttributes.IMAGE);
	                if (textureName.indexOf("ANI_") === 0) {
	                    this._animationStyle = StyleManager_1.StyleManager.Styles[textureName];
	                    if (this._animationStyle != null) {
	                        textureName = this._animationStyle.animation + "0000";
	                    }
	                }
	                this._texture = StageController_1.StageController.getTextureByResourceId(textureName);
	                if (this._texture != null) {
	                    if (this._bezierPoints.length == 0) {
	                        for (var i = 0; i < this._pointsCount; i++) {
	                            this._bezierPoints.push(new PIXI.Point(Math.round(this._texture.width / (this._pointsCount - 1)) * i, 0));
	                        }
	                    }
	                    this._rope = new PIXI.mesh.Rope(this._texture, this._bezierPoints);
	                    if (this._noWebGL) {
	                        this._rope.canvasPadding = 5;
	                    }
	                    this._rope.blendMode = CustomUtils_1.CustomUtils.getBlendMode(this._blendMode);
	                    if (this._tint != null) {
	                        this._rope.tint = this._tint;
	                    }
	                    this.addChild(this._rope);
	                }
	            }
	            this._created = true;
	        }
	    };
	    RopeElement.prototype.addPoints = function (points) {
	        this._pointsDataBuffer = this._pointsDataBuffer.concat(points);
	    };
	    RopeElement.prototype.getPoints = function () {
	        return this._pointsData;
	    };
	    RopeElement.prototype.updateByNode = function (node) {
	        if (this._created) {
	            _super.prototype.updateByNode.call(this, node);
	            if (node.hasAttribute(RopeElementAttributes.POINTS)) {
	                var XMLpointsData = this.formatPoints(node.getAttribute(RopeElementAttributes.POINTS));
	                this._pointsData = [];
	                if (node.hasAttribute(RopeElementAttributes.REVERSE_POINTS) &&
	                    neo_common_1.StringUtils.parseBoolean(node.getAttribute(RopeElementAttributes.REVERSE_POINTS))) {
	                    this._pointsData = XMLpointsData.concat(this._pointsDataBuffer).reverse();
	                }
	                else {
	                    this._pointsData = this._pointsDataBuffer.concat(XMLpointsData);
	                }
	                this._pointsDataBuffer = [];
	                this.updatePoints(this._pointsData);
	            }
	            if (node.hasAttribute(RopeElementAttributes.GLOBAL_POINTS)) {
	                this._pointsData = this.formatPoints(node.getAttribute(RopeElementAttributes.POINTS), true);
	                this.updatePoints(this._pointsData);
	            }
	            if (node.hasAttribute(RopeElementAttributes.TINT)) {
	                if (this._rope != null) {
	                    if (node.getAttribute(RopeElementAttributes.TINT) === "0") {
	                        this._tint = null;
	                    }
	                    else {
	                        this._tint = parseInt(node.getAttribute(RopeElementAttributes.TINT), 16);
	                    }
	                    this._rope.tint = this._tint;
	                }
	            }
	            if (node.hasAttribute(RopeElementAttributes.IMAGE)) {
	                var textureName = node.getAttribute(RopeElementAttributes.IMAGE);
	                if (textureName.indexOf("ANI_") === 0) {
	                    this._animationStyle = StyleManager_1.StyleManager.Styles[textureName];
	                    if (this._animationStyle != null) {
	                        textureName = this._animationStyle.animation + "0000";
	                    }
	                }
	                this._texture = StageController_1.StageController.getTextureByResourceId(textureName);
	                if (this._texture != null) {
	                    if (this._rope != null) {
	                        this._rope.texture = this._texture;
	                    }
	                }
	            }
	            if (node.hasAttribute(RopeElementAttributes.ROPE_LENGTH)) {
	                this._ropeLength = parseInt(node.getAttribute(RopeElementAttributes.ROPE_LENGTH));
	            }
	            if (node.hasAttribute(RopeElementAttributes.INCREMENT)) {
	                this._increment = parseFloat(node.getAttribute(RopeElementAttributes.INCREMENT));
	            }
	            if (node.hasAttribute(RopeElementAttributes.PARTS)) {
	                this._parts = neo_common_1.ArrayUtils.numberArray(node.getAttribute(RopeElementAttributes.PARTS));
	            }
	            if (node.hasAttribute(RopeElementAttributes.STRENGTH)) {
	                var strength = neo_common_1.ArrayUtils.numberArray(node.getAttribute(RopeElementAttributes.STRENGTH));
	                for (var i = 0; i < this._parts.length; i++) {
	                    if (strength.length == 2) {
	                        this._strength.push([strength[0], strength[1]]);
	                    }
	                    else {
	                        this._strength.push([strength[i * 2], strength[i * 2 + 1]]);
	                    }
	                }
	            }
	            if (node.hasAttribute(RopeElementAttributes.SMOOTH)) {
	                var smooth = neo_common_1.ArrayUtils.numberArray(node.getAttribute(RopeElementAttributes.SMOOTH));
	                for (var i = 0; i < this._parts.length; i++) {
	                    if (smooth.length == 2) {
	                        this._smooth.push([smooth[0], smooth[1]]);
	                    }
	                    else {
	                        this._smooth.push([smooth[i * 2], smooth[i * 2 + 1]]);
	                    }
	                }
	            }
	            if (node.hasAttribute(RopeElementAttributes.CONTINUE) &&
	                neo_common_1.StringUtils.parseBoolean(node.getAttribute(RopeElementAttributes.CONTINUE))) {
	                this._continue = true;
	            }
	            if (node.hasAttribute(RopeElementAttributes.PLAY) &&
	                neo_common_1.StringUtils.parseBoolean(node.getAttribute(RopeElementAttributes.PLAY))) {
	                this.play();
	            }
	            if (node.hasAttribute(RopeElementAttributes.STOP) &&
	                neo_common_1.StringUtils.parseBoolean(node.getAttribute(RopeElementAttributes.STOP))) {
	                this.stop();
	            }
	        }
	    };
	    RopeElement.prototype.play = function () {
	        if (this._animationStyle != null) {
	            if (!this._continue || !this._isPlaying) {
	                Tweens_1.Tweens.removeTweens(this, "_frame");
	                this.count = 0;
	                var tweenDuration = (this._animationStyle.endFrame + 1) / this._animationStyle.speed;
	                var tl = Tweens_1.Tweens.customTween(this, {
	                    tween: "_frame",
	                    tweenValues: [0, this._animationStyle.endFrame],
	                    tweenDuration: [tweenDuration],
	                    tweenEase: ["linear"],
	                    tweenLoop: this._animationStyle.loop,
	                    callbackType: "onUpdate",
	                    callbackFunction: this.updateTexture,
	                    callbackScope: this,
	                    callbackParams: ["{self}"],
	                });
	                tl.pause();
	                if (this._randomStartFrame) {
	                    tl.time(Math.random() * (tweenDuration / 60));
	                }
	                if (this._time > 0) {
	                    tl.time(this._time);
	                }
	                tl.play();
	                this._isPlaying = true;
	            }
	        }
	        else {
	            Tweens_1.Tweens.removeTweens(this, "rope");
	            Tweens_1.Tweens.customTween(this, {
	                tween: "rope",
	                tweenValues: [0, 0],
	                tweenDuration: [120],
	                tweenEase: ["linear"],
	                tweenLoop: true,
	                callbackType: "onUpdate",
	                callbackFunction: this.updateTexture,
	                callbackScope: this,
	                callbackParams: ["{self}"],
	            });
	            this._isPlaying = true;
	        }
	    };
	    RopeElement.prototype.stop = function () {
	        Tweens_1.Tweens.removeTweens(this, "rope");
	        this._isPlaying = false;
	        this.count = 0;
	    };
	    RopeElement.prototype.setSpeed = function (speed) {
	        if (this._animationStyle != null) {
	            this._animationStyle.speed = speed;
	        }
	    };
	    RopeElement.prototype.updateTexture = function (self) {
	        if (this._rope != null) {
	            this.count += this._increment;
	            for (var i = 0; i < this._pointsCount; i++) {
	                for (var j = 0; j < this._parts.length; j++) {
	                    if (i > this._parts[j]) {
	                        this._rope.points[i].y = Math.sin(i * this._smooth[j][0] + this.count) * this._strength[j][0];
	                        this._rope.points[i].x =
	                            i * this._ropeLength + Math.cos(i * this._smooth[j][1] + this.count) * this._strength[j][1];
	                    }
	                }
	            }
	        }
	        if (this._animationStyle != null) {
	            var currentFrame = Math.round(this._frame);
	            if (currentFrame > self.previousValue || currentFrame == 0) {
	                this._rope.texture = StageController_1.StageController.getTextureByResourceId(this._animationStyle.animation + this.zerosPad(currentFrame, 4));
	            }
	            self.previousValue = currentFrame;
	        }
	    };
	    RopeElement.prototype.zerosPad = function (num, size) {
	        var s = num + "";
	        while (s.length < size)
	            s = "0" + s;
	        return s;
	    };
	    RopeElement.prototype.updateMeshPoints = function (points) {
	        if (this._rope != null) {
	            for (var i = 0; i < this._pointsCount; i++) {
	                this._rope.points[i].x = points[i].x;
	                this._rope.points[i].y = points[i].y;
	            }
	        }
	    };
	    RopeElement.prototype.updatePoints = function (points) {
	        var bezierData = gsap_1.BezierPlugin.bezierThrough(points, this._curviness);
	        this._bezierPoints = this.getBezierStepPoints(bezierData, this._pointsCount);
	        this.updateMeshPoints(this._bezierPoints);
	    };
	    RopeElement.prototype.formatPoints = function (points, useGlobal) {
	        if (useGlobal === void 0) { useGlobal = false; }
	        var result = [];
	        var regex = /\[(.*?)\]/g;
	        var data = points.match(regex);
	        for (var i = 0; i < data.length; i++) {
	            var pointArray = data[i].substring(1, data[i].length - 1).split(",");
	            if (pointArray.length == 2) {
	                var x = this.formatPoint(pointArray[0], "x", useGlobal);
	                var y = this.formatPoint(pointArray[1], "y", useGlobal);
	                result.push(new PIXI.Point(x, y));
	            }
	        }
	        return result;
	    };
	    RopeElement.prototype.formatPoint = function (value, id, useGlobal) {
	        if (useGlobal === void 0) { useGlobal = false; }
	        var result;
	        if (value == "c") {
	            result = this[id];
	        }
	        else {
	            if (useGlobal) {
	                result = this[id] + (parseInt(value) - this.getGlobalPosition()[id]);
	            }
	            else {
	                result = parseInt(value);
	            }
	        }
	        return result;
	    };
	    RopeElement.prototype.getBezierStepPoints = function (data, length) {
	        var segmentLength = length / data.x.length;
	        var pointPerSegment = [];
	        var bezierStepPoints = [];
	        if (data.x.length > 1) {
	            segmentLength = Math.round(segmentLength);
	            var sum = 0;
	            for (var i = 0; i < data.x.length - 1; i++) {
	                pointPerSegment.push(segmentLength);
	                sum += segmentLength;
	            }
	            pointPerSegment.push(length - sum);
	        }
	        else {
	            pointPerSegment = [segmentLength];
	        }
	        var time = 0;
	        for (var i = 0; i < data.x.length; i++) {
	            for (var j = 0; j < pointPerSegment[i]; j++) {
	                if (i + 1 < data.x.length) {
	                    time = j / pointPerSegment[i];
	                }
	                else {
	                    time = j / (pointPerSegment[i] - 1);
	                }
	                bezierStepPoints.push(this.bezier(time, data.x[i], data.y[i]));
	            }
	        }
	        return bezierStepPoints;
	    };
	    RopeElement.prototype.bezier = function (t, dataX, dataY) {
	        var cX = 3 * dataX.ba, bX = 3 * (dataX.c - dataX.b) - cX, aX = dataX.da - cX - bX;
	        var cY = 3 * dataY.ba, bY = 3 * (dataY.c - dataY.b) - cY, aY = dataY.da - cY - bY;
	        var x = aX * Math.pow(t, 3) + bX * Math.pow(t, 2) + cX * t + dataX.a;
	        var y = aY * Math.pow(t, 3) + bY * Math.pow(t, 2) + cY * t + dataY.a;
	        return new PIXI.Point(x, y);
	    };
	    RopeElement.prototype.clone = function () {
	        var element = new RopeElement();
	        element._created = this._created;
	        element.visible = this.visible;
	        element.alpha = this.alpha;
	        element.position.x = this.position.x;
	        element.position.y = this.position.y;
	        element.pivot.x = this.pivot.x;
	        element.pivot.y = this.pivot.y;
	        element.scale.x = this.scale.x;
	        element.scale.y = this.scale.y;
	        element.rotation = this.rotation;
	        element._pointsCount = this._pointsCount;
	        element._texture = this._texture;
	        element._blendMode = this._blendMode;
	        element._animationStyle = this._animationStyle;
	        element._frame = this._frame;
	        element._tint = this._tint;
	        element._randomStartFrame = this._randomStartFrame;
	        element._increment = this._increment;
	        element._parts = this._parts;
	        element._smooth = this._smooth;
	        element._strength = this._strength;
	        element._ropeLength = this._ropeLength;
	        element._bezierPoints = [];
	        for (var i = 0; i < this._bezierPoints.length; i++) {
	            element._bezierPoints.push(new PIXI.Point(this._bezierPoints[i].x, this._bezierPoints[i].y));
	        }
	        element._rope = new PIXI.mesh.Rope(element._texture, element._bezierPoints);
	        element._rope.canvasPadding = this._rope.canvasPadding;
	        element._rope.blendMode = element._blendMode;
	        element.addChild(element._rope);
	        element.markAsCloned();
	        return element;
	    };
	    RopeElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], RopeElement);
	    return RopeElement;
	}(BaseElement_1.BaseElement));
	exports.RopeElement = RopeElement;
	var RopeElementAttributes = {
	    BLEND_MODE: "BlendMode",
	    CURVINESS: "Curviness",
	    RANDOM_START_FRAME: "RandomStartFrame",
	    TIME: "Time",
	    GLOBAL_POINTS: "GlobalPoints",
	    ROPE_LENGTH: "RopeLength",
	    INCREMENT: "Increment",
	    PARTS: "Parts",
	    STRENGTH: "Strength",
	    SMOOTH: "Smooth",
	    IMAGE: "Image",
	    PLAY: "Play",
	    CONTINUE: "Continue",
	    POINTS: "Points",
	    POINTS_COUNT: "PointsCount",
	    REVERSE_POINTS: "ReversePoints",
	    STOP: "Stop",
	    TINT: "Tint",
	};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var BaseElement_1 = __webpack_require__(12);
	var SceneHolderElement = (function (_super) {
	    __extends(SceneHolderElement, _super);
	    function SceneHolderElement() {
	        _super.apply(this, arguments);
	        this.elementsHolder = [];
	        this.parentContainer = null;
	    }
	    SceneHolderElement.prototype.updateByNode = function (node) {
	        _super.prototype.updateByNode.call(this, node);
	        if (node.hasAttribute(exports.HighWinSceneAttributes.USE_PARENT)) {
	            if (this.parentContainer) {
	                this.parentContainer.addChild(this);
	            }
	        }
	        this.blackList = [];
	        if (node.hasAttribute(exports.HighWinSceneAttributes.BLACK_LIST)) {
	            this.blackList = neo_common_1.ArrayUtils.stringArray(node.getAttribute(exports.HighWinSceneAttributes.BLACK_LIST));
	        }
	        if (node.hasAttribute(exports.HighWinSceneAttributes.ADD_CHILDS)) {
	            this.addChildsToElement();
	        }
	        if (node.hasAttribute(exports.HighWinSceneAttributes.RETURN_CHILDS)) {
	            this.addChildsToOriginalParent();
	        }
	    };
	    SceneHolderElement.prototype.addChildsToElement = function () {
	        if (!this.hasAdded) {
	            for (var i = 0; i < this.elementsHolder.length; i++) {
	                var elem = this.elementsHolder[i];
	                if (elem != null) {
	                    if (this.blackList.indexOf(elem["element"]["name"]) == -1) {
	                        this.addChild(elem["element"]);
	                    }
	                }
	            }
	            this.hasAdded = true;
	        }
	    };
	    SceneHolderElement.prototype.addElement = function (elem) {
	        this.elementsHolder.push(elem);
	    };
	    SceneHolderElement.prototype.addChildsToOriginalParent = function () {
	        if (this.hasAdded) {
	            for (var i = 0; i < this.elementsHolder.length; i++) {
	                var elem = this.elementsHolder[i];
	                if (elem != null) {
	                    var origElement = elem["parent"];
	                    var element = elem["element"];
	                    origElement.addChildAt(element, elem["index"]);
	                }
	            }
	            this.hasAdded = false;
	        }
	    };
	    SceneHolderElement.prototype.setHolderParent = function (elem) {
	        this.parentContainer = elem;
	    };
	    SceneHolderElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], SceneHolderElement);
	    return SceneHolderElement;
	}(BaseElement_1.BaseElement));
	exports.SceneHolderElement = SceneHolderElement;
	exports.HighWinSceneAttributes = {
	    ADD_CHILDS: "AddChilds",
	    BLACK_LIST: "BlackList",
	    RETURN_CHILDS: "ReturnChilds",
	    USE_PARENT: "UseParent",
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var BaseElement_1 = __webpack_require__(12);
	var FrameTimer_1 = __webpack_require__(9);
	var PlayList_1 = __webpack_require__(33);
	var SoundElement = (function (_super) {
	    __extends(SoundElement, _super);
	    function SoundElement() {
	        _super.call(this);
	        this.soundName = null;
	        this._loop = false;
	        this._reset = false;
	        this._playing = false;
	        this._scheduledPlay = false;
	        this._scheduledStop = false;
	        this._fadeInTime = 0;
	        this._fadeOutTime = 0;
	        this._startTimer = FrameTimer_1.CreateFrameTimer("SoundElementStart");
	        this._stopTimer = FrameTimer_1.CreateFrameTimer("SoundElementStop");
	    }
	    SoundElement.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	    };
	    SoundElement.prototype.updateByNode = function (node) {
	        if (!node) {
	            this.logError("No node specified for element update!");
	            return;
	        }
	        if (false) {
	            if (node.hasAttribute(exports.SoundElementAttributes.DEBUG) &&
	                node.getAttribute(exports.SoundElementAttributes.DEBUG) === "true") {
	                debugger;
	            }
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.LOOP)) {
	            var value = node.getAttribute(exports.SoundElementAttributes.LOOP);
	            var intValue = parseInt(value);
	            this._loop = true;
	            if (value === "true") {
	                this.schedulePlay(0);
	            }
	            else if (!isNaN(intValue)) {
	                this.schedulePlay(intValue);
	            }
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.RESET)) {
	            this._reset = neo_common_1.StringUtils.parseBoolean(node.getAttribute(exports.SoundElementAttributes.RESET));
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.FADE_IN)) {
	            this._fadeInTime = parseInt(node.getAttribute(exports.SoundElementAttributes.FADE_IN));
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.FADE_OUT)) {
	            this._fadeOutTime = parseInt(node.getAttribute(exports.SoundElementAttributes.FADE_OUT));
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.NAME)) {
	            var newName = node.getAttribute(exports.SoundElementAttributes.NAME);
	            if (this.soundName != newName) {
	                this.stop();
	                this.soundName = node.getAttribute(exports.SoundElementAttributes.NAME);
	            }
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.STOP)) {
	            var value = node.getAttribute(exports.SoundElementAttributes.STOP);
	            var intValue = parseInt(value);
	            if (value === "true") {
	                this.scheduleStop(0);
	            }
	            else if (!isNaN(intValue)) {
	                this.scheduleStop(intValue);
	            }
	        }
	        if (node.hasAttribute(exports.SoundElementAttributes.PLAY)) {
	            var value = node.getAttribute(exports.SoundElementAttributes.PLAY);
	            var intValue = parseInt(value);
	            if (value === "true") {
	                this.schedulePlay(0);
	            }
	            else if (!isNaN(intValue)) {
	                this.schedulePlay(intValue);
	            }
	        }
	    };
	    SoundElement.prototype.internalDestroy = function (options) { };
	    SoundElement.prototype.clone = function () {
	        var element = new SoundElement();
	        element.soundName = this.soundName;
	        element._fadeInTime = this._fadeInTime;
	        element._fadeOutTime = this._fadeOutTime;
	        element._loop = this._loop;
	        element._reset = this._reset;
	        element._playing = this._playing;
	        element._scheduledPlay = this._scheduledPlay;
	        element._scheduledStop = this._scheduledStop;
	        element.markAsCloned();
	        return element;
	    };
	    SoundElement.prototype.schedulePlay = function (delay) {
	        if (delay === void 0) { delay = 0; }
	        this._startTimer.stop();
	        this._startTimer.removeAllListeners();
	        if (delay > 0) {
	            this._scheduledPlay = true;
	            this._startTimer.once(FrameTimer_1.FrameTimerEvents.Complete, this.play.bind(this));
	            this._startTimer.start(delay);
	        }
	        else {
	            this.play();
	        }
	    };
	    SoundElement.prototype.scheduleStop = function (delay) {
	        if (delay === void 0) { delay = 0; }
	        this._stopTimer.stop();
	        this._stopTimer.removeAllListeners();
	        if (delay > 0) {
	            this._scheduledStop = true;
	            this._stopTimer.once(FrameTimer_1.FrameTimerEvents.Complete, this.stop.bind(this));
	            this._stopTimer.start(delay);
	        }
	        else {
	            this.stop();
	        }
	    };
	    SoundElement.prototype.play = function () {
	        if (this.soundName == null) {
	            return;
	        }
	        if (PlayList_1.PlayList.isPlaying(this.soundName)) {
	            if (this._reset) {
	                this.stop();
	            }
	            else {
	                return;
	            }
	        }
	        this._startTimer.stop();
	        this._startTimer.removeAllListeners();
	        this._playing = true;
	        this._scheduledPlay = false;
	        if (this._loop) {
	            PlayList_1.PlayList.loop(this.soundName, this._fadeInTime, this._reset);
	        }
	        else {
	            PlayList_1.PlayList.play(this.soundName, this._fadeInTime, this._reset);
	        }
	    };
	    SoundElement.prototype.stop = function () {
	        if (this.soundName == null) {
	            return;
	        }
	        this._stopTimer.stop();
	        this._stopTimer.removeAllListeners();
	        PlayList_1.PlayList.stop(this.soundName, this._fadeOutTime);
	        if (this._fadeOutTime) {
	            this._stopTimer.once(FrameTimer_1.FrameTimerEvents.Complete, this.reset.bind(this));
	            this._stopTimer.start(this._fadeOutTime);
	        }
	        else {
	            this.reset();
	        }
	    };
	    SoundElement.prototype.reset = function () {
	        this._startTimer.stop();
	        this._startTimer.removeAllListeners();
	        this._stopTimer.stop();
	        this._stopTimer.removeAllListeners();
	        this._playing = false;
	        this._scheduledPlay = false;
	        this._scheduledStop = false;
	        if (this.soundName && PlayList_1.PlayList.isPlaying(this.soundName)) {
	            PlayList_1.PlayList.stop(this.soundName);
	        }
	    };
	    SoundElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], SoundElement);
	    return SoundElement;
	}(BaseElement_1.BaseElement));
	exports.SoundElement = SoundElement;
	exports.SoundElementAttributes = {
	    DEBUG: "Debug",
	    NAME: "Name",
	    LOOP: "Loop",
	    RESET: "Reset",
	    FADE_IN: "FadeIn",
	    FADE_OUT: "FadeOut",
	    PLAY: "Play",
	    STOP: "Stop",
	};


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ContainerElement_1 = __webpack_require__(82);
	var PaylinesDefinitions_1 = __webpack_require__(103);
	var Payline_1 = __webpack_require__(102);
	var Configuration_1 = __webpack_require__(57);
	var ComponentTypes_1 = __webpack_require__(14);
	var Paylines = (function (_super) {
	    __extends(Paylines, _super);
	    function Paylines() {
	        _super.call(this);
	        this._paylines = [];
	    }
	    Paylines.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute("Configs")) {
	            var configs = node.getAttribute("Configs").split(";");
	            for (var i = 0; i < configs.length; i++) {
	                var config = Configuration_1.Configuration.Configurations[configs[i]];
	                if (config != null) {
	                    this.configurate(config);
	                }
	            }
	        }
	        if (this.childs != null) {
	            for (var key in this.childs) {
	                if (this.childs[key] instanceof Payline_1.Payline) {
	                    this._paylines.push(this.childs[key]);
	                }
	            }
	            this.children.sort(function (a, b) {
	                if (a.hasOwnProperty("zIndex") && b.hasOwnProperty("zIndex")) {
	                    a.zIndex = a.zIndex || 0;
	                    b.zIndex = b.zIndex || 0;
	                    return a.zIndex - b.zIndex;
	                }
	                return 0;
	            });
	        }
	    };
	    Paylines.prototype.setSpecialContainer = function (container) {
	        this._specialContainer = container;
	    };
	    Paylines.prototype.configurate = function (node) {
	        if (node.hasAttribute("PaylineIDs")) {
	            this._paylineIDs = neo_common_1.ArrayUtils.numberArray(node.getAttribute("PaylineIDs"));
	        }
	        if (node.hasAttribute("PaylineDefinition")) {
	            this.paylineDefinition = node.getAttribute("PaylineDefinition");
	            PaylinesDefinitions_1.PaylinesDefinitions.initializePaylineDefinitions(node.getAttribute("PaylineDefinition"));
	        }
	    };
	    Paylines.prototype.showPaylinesLabel = function () { };
	    Paylines.prototype.goToWin = function (id) {
	        if (this._paylines[id - 1] != null) {
	            this.addChild(this._paylines[id - 1]);
	            this._paylines[id - 1].goToCase(Payline_1.Payline.CaseWin);
	        }
	        else {
	            if (false) {
	                this.log("ERROR no payline with id: " + (id - 1));
	            }
	        }
	    };
	    Paylines.prototype.reset = function () {
	        for (var i = 0; i < this._paylines.length; i++) {
	            if (this._specialContainer != null) {
	                this._specialContainer.addChild(this._paylines[i]);
	            }
	            this._paylines[i].goToCase(Payline_1.Payline.CaseNormal);
	        }
	    };
	    Paylines.prototype.getPaylines = function () {
	        return this._paylines;
	    };
	    Paylines.prototype.goToCase = function (caseType, id) {
	        if (id) {
	            if (this._paylines[id - 1] != null) {
	                if (caseType === Payline_1.Payline.CaseWin) {
	                    this.addChild(this._paylines[id - 1]);
	                }
	                else {
	                    if (this._specialContainer != null) {
	                        this._specialContainer.addChild(this._paylines[id - 1]);
	                    }
	                }
	                this._paylines[id - 1].goToCase(caseType);
	            }
	            else {
	                if (false) {
	                    this.log("ERROR no payline with id: " + (id - 1));
	                }
	            }
	        }
	        else {
	            for (var i = 0; i < this._paylines.length; i++) {
	                if (caseType === Payline_1.Payline.CaseWin) {
	                    this.addChild(this._paylines[i]);
	                }
	                else {
	                    if (this._specialContainer != null) {
	                        this._specialContainer.addChild(this._paylines[i]);
	                    }
	                }
	                this._paylines[i].goToCase(caseType);
	            }
	        }
	    };
	    Paylines = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], Paylines);
	    return Paylines;
	}(ContainerElement_1.ContainerElement));
	exports.Paylines = Paylines;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ContainerElement_1 = __webpack_require__(82);
	var Payline_1 = __webpack_require__(102);
	var Configuration_1 = __webpack_require__(57);
	var ComponentTypes_1 = __webpack_require__(14);
	var PaylinesSelector = (function (_super) {
	    __extends(PaylinesSelector, _super);
	    function PaylinesSelector() {
	        _super.call(this);
	        this._paylines = [];
	    }
	    PaylinesSelector.prototype.createByNode = function (node) {
	        _super.prototype.createByNode.call(this, node);
	        if (node.hasAttribute("Configs")) {
	            var configs = node.getAttribute("Configs").split(";");
	            for (var i = 0; i < configs.length; i++) {
	                var config = Configuration_1.Configuration.Configurations[configs[i]];
	                if (config != null) {
	                    this.configurate(config);
	                }
	            }
	        }
	        if (this.childs != null) {
	            for (var key in this.childs) {
	                if (this.childs[key] instanceof Payline_1.Payline) {
	                    this._paylines.push(this.childs[key]);
	                }
	            }
	        }
	    };
	    PaylinesSelector.prototype.configurate = function (node) {
	        if (node.hasAttribute("PaylineIDs")) {
	            this._paylineIDs = neo_common_1.ArrayUtils.numberArray(node.getAttribute("PaylineIDs"));
	        }
	    };
	    PaylinesSelector.prototype.reset = function () {
	        this.visible = false;
	    };
	    PaylinesSelector.prototype.select = function () {
	        this.visible = true;
	        for (var i = 0; i < this._paylines.length; i++) {
	            this._paylines[i].goToCase(Payline_1.Payline.CaseSelect);
	        }
	    };
	    PaylinesSelector = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.DisplayObject)
	    ], PaylinesSelector);
	    return PaylinesSelector;
	}(ContainerElement_1.ContainerElement));
	exports.PaylinesSelector = PaylinesSelector;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var BetManager_1 = __webpack_require__(25);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var BaseActions_1 = __webpack_require__(35);
	var HtmlBetSelectorContainerElement = (function (_super) {
	    __extends(HtmlBetSelectorContainerElement, _super);
	    function HtmlBetSelectorContainerElement() {
	        _super.call(this);
	        BetManager_1.BetManager.CoinCountContainer = this;
	    }
	    HtmlBetSelectorContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this._popup = document.createElement("div");
	        this._popup.classList.add("display");
	        this._popup.classList.add("popupBig");
	        if (this.instance != null) {
	            this.instance.appendChild(this._popup);
	        }
	        this.block = true;
	        this.createTimeout();
	    };
	    HtmlBetSelectorContainerElement.prototype.addValues = function () {
	        if (AppContext_1.AppContext.gameConfiguration.UseCoins &&
	            BetManager_1.BetManager.Coins != null &&
	            BetManager_1.BetManager.CoinSize != null &&
	            this._popup != null) {
	            this._values = [];
	            this._popup.innerHTML = "";
	            var i = 0;
	            for (var key in BetManager_1.BetManager.Coins) {
	                if (BetManager_1.BetManager.CoinSize === parseFloat(key)) {
	                    for (var j = 0; j < BetManager_1.BetManager.Coins[key].length; j++) {
	                        BetManager_1.BetManager.Coins[key].sort(BetManager_1.BetManager.sortNumber);
	                        BetManager_1.BetManager.Coins[key].reverse();
	                        var popupItem = document.createElement("div");
	                        popupItem.classList.add("popupItem");
	                        popupItem.onclick = this.onValueClick.bind(this);
	                        popupItem.setAttribute("CoinCount", BetManager_1.BetManager.Coins[key][j].toString());
	                        if (BetManager_1.BetManager.CoinCount != null && BetManager_1.BetManager.CoinCount == BetManager_1.BetManager.Coins[key][j]) {
	                            popupItem.classList.add("_active");
	                        }
	                        var popupItemValue = document.createElement("div");
	                        popupItemValue.classList.add("popupValue");
	                        popupItemValue.innerText = BetManager_1.BetManager.Coins[key][j].toString();
	                        popupItem.appendChild(popupItemValue);
	                        this._values.push(popupItem);
	                        this._popup.appendChild(popupItem);
	                        i++;
	                    }
	                }
	            }
	            this._height = 60 * i + 48 + "px";
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.onValueClick = function (e) {
	        if (this.block) {
	            return;
	        }
	        this.setTimeout();
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("CoinCount") &&
	            BetManager_1.BetManager.CoinCount != null) {
	            var coinCount = parseFloat(e.currentTarget.getAttribute("CoinCount"));
	            if (coinCount === BetManager_1.BetManager.CoinCount) {
	                this.disable();
	            }
	            else {
	                if (this._values != null) {
	                    for (var i = 0; i < this._values.length; i++) {
	                        if (this._values[i].hasAttribute("CoinCount")) {
	                            if (parseFloat(this._values[i].getAttribute("CoinCount")) === coinCount) {
	                                this._values[i].classList.add("_active");
	                            }
	                            else {
	                                this._values[i].classList.remove("_active");
	                            }
	                        }
	                    }
	                    HtmlController_1.HtmlController.dispatchAction(BaseActions_1.BaseActions.ActionCoinCountSelectValue + coinCount);
	                    this.disable();
	                }
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.changeValue = function () {
	        if (this._values != null) {
	            for (var i = 0; i < this._values.length; i++) {
	                if (this._values[i].hasAttribute("CoinCount")) {
	                    if (parseFloat(this._values[i].getAttribute("CoinCount")) === BetManager_1.BetManager.CoinCount) {
	                        this._values[i].classList.add("_active");
	                    }
	                    else {
	                        this._values[i].classList.remove("_active");
	                    }
	                }
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.toggle = function () {
	        if (this._values != null && this._values.length <= 1) {
	            return;
	        }
	        if (this.instance != null) {
	            if (this.instance.classList.contains("_disabled")) {
	                this.block = false;
	                this.setTimeout();
	                if (this._height != null) {
	                    this.instance.style.height = this._height;
	                }
	                this.instance.classList.remove("_disabled");
	            }
	            else {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.disable = function () {
	        if (this.instance != null) {
	            if (!this.instance.classList.contains("_disabled")) {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.createTimeout = function () {
	        this.timeout = null;
	    };
	    HtmlBetSelectorContainerElement.prototype.setTimeout = function () {
	        var _this = this;
	        this.clearTimeOut();
	        var duration = AppContext_1.AppContext.gameConfiguration.SelectorRolloutDuration;
	        if (duration > 0) {
	            this.timeout = setTimeout(function () {
	                _this.disable();
	            }, duration * 1000);
	        }
	    };
	    HtmlBetSelectorContainerElement.prototype.clearTimeOut = function () {
	        if (!neo_common_1.Utils.isNullOrUndefined(this.timeout)) {
	            clearTimeout(this.timeout);
	            this.timeout = null;
	        }
	    };
	    HtmlBetSelectorContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlBetSelectorContainerElement);
	    return HtmlBetSelectorContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlBetSelectorContainerElement = HtmlBetSelectorContainerElement;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var BetManager_1 = __webpack_require__(25);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var BaseActions_1 = __webpack_require__(35);
	var Languages_1 = __webpack_require__(28);
	var HtmlBetSelectorContainerElement2 = (function (_super) {
	    __extends(HtmlBetSelectorContainerElement2, _super);
	    function HtmlBetSelectorContainerElement2() {
	        _super.call(this);
	        BetManager_1.BetManager.BetContainer = this;
	    }
	    HtmlBetSelectorContainerElement2.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this._popup = document.createElement("div");
	        this._popup.classList.add("display");
	        this._popup.classList.add("popupBig");
	        if (this.instance != null) {
	            this.instance.appendChild(this._popup);
	        }
	        this.block = true;
	        this.createTimeout();
	    };
	    HtmlBetSelectorContainerElement2.prototype.addValues = function () {
	        if (!AppContext_1.AppContext.gameConfiguration.UseCoins && BetManager_1.BetManager.TotalBets != null && this._popup != null) {
	            this._values = [];
	            this._popup.innerHTML = "";
	            var count = 0;
	            for (var i = BetManager_1.BetManager.TotalBets.length - 1; i >= 0; i--) {
	                var popupItem = document.createElement("div");
	                popupItem.classList.add("popupItem");
	                popupItem.onclick = this.onValueClick.bind(this);
	                popupItem.setAttribute("Bet", BetManager_1.BetManager.TotalBets[i].toString());
	                if (BetManager_1.BetManager.Bet != null && BetManager_1.BetManager.Bet == BetManager_1.BetManager.TotalBets[i]) {
	                    popupItem.classList.add("_active");
	                }
	                var popupItemValue = document.createElement("div");
	                popupItemValue.classList.add("popupValue");
	                popupItemValue.innerText = Languages_1.Languages.formatText(Languages_1.Languages.FormatMoney, BetManager_1.BetManager.TotalBets[i].toString());
	                popupItem.appendChild(popupItemValue);
	                this._values.push(popupItem);
	                this._popup.appendChild(popupItem);
	                count++;
	            }
	            this._height = 60 * count + 48 + "px";
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.onValueClick = function (e) {
	        if (this.block) {
	            return;
	        }
	        this.setTimeout();
	        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Bet") && BetManager_1.BetManager.Bet != null) {
	            var bet = parseFloat(e.currentTarget.getAttribute("Bet"));
	            if (bet === BetManager_1.BetManager.Bet) {
	                this.disable();
	            }
	            else {
	                if (this._values != null) {
	                    for (var i = 0; i < this._values.length; i++) {
	                        if (this._values[i].hasAttribute("Bet")) {
	                            if (parseFloat(this._values[i].getAttribute("Bet")) === bet) {
	                                this._values[i].classList.add("_active");
	                            }
	                            else {
	                                this._values[i].classList.remove("_active");
	                            }
	                        }
	                    }
	                    HtmlController_1.HtmlController.dispatchAction(BaseActions_1.BaseActions.ActionBetSelectValue + bet);
	                    this.disable();
	                }
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.changeValue = function () {
	        if (this._values != null) {
	            for (var i = 0; i < this._values.length; i++) {
	                if (this._values[i].hasAttribute("Bet")) {
	                    if (parseFloat(this._values[i].getAttribute("Bet")) === BetManager_1.BetManager.Bet) {
	                        this._values[i].classList.add("_active");
	                    }
	                    else {
	                        this._values[i].classList.remove("_active");
	                    }
	                }
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.toggle = function () {
	        if (this._values != null && this._values.length <= 1) {
	            return;
	        }
	        if (this.instance != null) {
	            if (this.instance.classList.contains("_disabled")) {
	                this.block = false;
	                this.setTimeout();
	                if (this._height != null) {
	                    this.instance.style.height = this._height;
	                }
	                this.instance.classList.remove("_disabled");
	            }
	            else {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.disable = function () {
	        if (this.instance != null) {
	            if (!this.instance.classList.contains("_disabled")) {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.createTimeout = function () {
	        this.timeout = null;
	    };
	    HtmlBetSelectorContainerElement2.prototype.setTimeout = function () {
	        var _this = this;
	        this.clearTimeOut();
	        var duration = AppContext_1.AppContext.gameConfiguration.SelectorRolloutDuration;
	        if (duration > 0) {
	            this.timeout = setTimeout(function () {
	                _this.disable();
	            }, duration * 1000);
	        }
	    };
	    HtmlBetSelectorContainerElement2.prototype.clearTimeOut = function () {
	        if (!neo_common_1.Utils.isNullOrUndefined(this.timeout)) {
	            clearTimeout(this.timeout);
	            this.timeout = null;
	        }
	    };
	    HtmlBetSelectorContainerElement2 = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlBetSelectorContainerElement2);
	    return HtmlBetSelectorContainerElement2;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlBetSelectorContainerElement2 = HtmlBetSelectorContainerElement2;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var BetManager_1 = __webpack_require__(25);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var BaseActions_1 = __webpack_require__(35);
	var HtmlDenomContainerElement = (function (_super) {
	    __extends(HtmlDenomContainerElement, _super);
	    function HtmlDenomContainerElement() {
	        _super.call(this);
	        BetManager_1.BetManager.DenomContainer = this;
	    }
	    HtmlDenomContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this._popup = document.createElement("div");
	        this._popup.classList.add("display");
	        this._popup.classList.add("popupBig");
	        if (this.instance != null) {
	            this.instance.appendChild(this._popup);
	        }
	        this.block = true;
	        this.createTimeout();
	    };
	    HtmlDenomContainerElement.prototype.addValues = function () {
	        if (this._values == null &&
	            AppContext_1.AppContext.gameConfiguration.UseCoins &&
	            BetManager_1.BetManager.Coins != null &&
	            this._popup != null) {
	            this._values = [];
	            var i = 0;
	            var coinSizes = [];
	            for (var key in BetManager_1.BetManager.Coins) {
	                coinSizes.push(key);
	            }
	            coinSizes.sort(BetManager_1.BetManager.sortNumber);
	            coinSizes.reverse();
	            for (i = 0; i < coinSizes.length; i++) {
	                var popupItem = document.createElement("div");
	                popupItem.classList.add("popupItem");
	                popupItem.onclick = this.onValueClick.bind(this);
	                popupItem.setAttribute("CoinSize", coinSizes[i]);
	                if (BetManager_1.BetManager.CoinSize != null && BetManager_1.BetManager.CoinSize == parseFloat(coinSizes[i])) {
	                    popupItem.classList.add("_active");
	                }
	                var popupItemValue = document.createElement("div");
	                popupItemValue.classList.add("popupValue");
	                popupItemValue.innerText = coinSizes[i];
	                popupItem.appendChild(popupItemValue);
	                this._values.push(popupItem);
	                this._popup.appendChild(popupItem);
	            }
	            this._height = 60 * i + 48 + "px";
	        }
	    };
	    HtmlDenomContainerElement.prototype.onValueClick = function (e) {
	        if (this.block) {
	            return;
	        }
	        this.setTimeout();
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("CoinSize") &&
	            BetManager_1.BetManager.CoinSize != null) {
	            var coinSize = parseFloat(e.currentTarget.getAttribute("CoinSize"));
	            if (coinSize === BetManager_1.BetManager.CoinSize) {
	                this.disable();
	            }
	            else {
	                if (this._values != null) {
	                    for (var i = 0; i < this._values.length; i++) {
	                        if (this._values[i].hasAttribute("CoinSize")) {
	                            if (parseFloat(this._values[i].getAttribute("CoinSize")) === coinSize) {
	                                this._values[i].classList.add("_active");
	                            }
	                            else {
	                                this._values[i].classList.remove("_active");
	                            }
	                        }
	                    }
	                    HtmlController_1.HtmlController.dispatchAction(BaseActions_1.BaseActions.ActionDenomSelectValue + coinSize);
	                    this.disable();
	                }
	            }
	        }
	    };
	    HtmlDenomContainerElement.prototype.toggle = function () {
	        if (this._values != null && this._values.length <= 1) {
	            return;
	        }
	        if (this.instance != null) {
	            if (this.instance.classList.contains("_disabled")) {
	                this.block = false;
	                this.setTimeout();
	                if (this._height != null) {
	                    this.instance.style.height = this._height;
	                }
	                this.instance.classList.remove("_disabled");
	            }
	            else {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlDenomContainerElement.prototype.disable = function () {
	        if (this.instance != null) {
	            if (!this.instance.classList.contains("_disabled")) {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlDenomContainerElement.prototype.createTimeout = function () {
	        this.timeout = null;
	    };
	    HtmlDenomContainerElement.prototype.setTimeout = function () {
	        var _this = this;
	        this.clearTimeOut();
	        var duration = AppContext_1.AppContext.gameConfiguration.SelectorRolloutDuration;
	        if (duration > 0) {
	            this.timeout = setTimeout(function () {
	                _this.disable();
	            }, duration * 1000);
	        }
	    };
	    HtmlDenomContainerElement.prototype.clearTimeOut = function () {
	        if (!neo_common_1.Utils.isNullOrUndefined(this.timeout)) {
	            clearTimeout(this.timeout);
	            this.timeout = null;
	        }
	    };
	    HtmlDenomContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlDenomContainerElement);
	    return HtmlDenomContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlDenomContainerElement = HtmlDenomContainerElement;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlButtonElement_1 = __webpack_require__(155);
	var PlayList_1 = __webpack_require__(33);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var HtmlHideButtonElement = (function (_super) {
	    __extends(HtmlHideButtonElement, _super);
	    function HtmlHideButtonElement() {
	        _super.call(this);
	        this._hideClass = "";
	    }
	    HtmlHideButtonElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        HtmlController_1.HtmlController.HideButtons.push(this);
	        if (node.hasAttribute("HideClass")) {
	            this._hideClass = node.getAttribute("HideClass");
	            if (HtmlHideButtonElement.Buttons[this._hideClass] == null) {
	                HtmlHideButtonElement.Buttons[this._hideClass] = [];
	            }
	            HtmlHideButtonElement.Buttons[this._hideClass].push(this);
	        }
	        if (this.instance != null) {
	            if (!AppContext_1.AppContext.gameConfiguration.HideAmountsEnabled) {
	                this.instance.classList.add("_hidden");
	            }
	            this.instance.onclick = this.toggle.bind(this);
	        }
	    };
	    HtmlHideButtonElement.prototype.unHide = function (credit) {
	        if (credit === void 0) { credit = false; }
	        if (this.instance != null &&
	            this._hideClass != "" &&
	            (this._hideClass === "_hideBet" || (credit && this._hideClass === "_hideCredit"))) {
	            var elements = document.getElementsByClassName(this._hideClass);
	            var display = "block";
	            if (HtmlHideButtonElement.Buttons[this._hideClass] != null &&
	                HtmlHideButtonElement.Buttons[this._hideClass].length > 0) {
	                for (var j = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
	                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
	                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")) {
	                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_off");
	                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
	                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_on");
	                            }
	                        }
	                    }
	                }
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                if (element != null) {
	                    element.style.display = display;
	                }
	            }
	            if (this._hideClass === "_hideCredit") {
	                if (display === "block") {
	                    AppContext_1.AppContext.current.setHideAmounts(false);
	                }
	                else {
	                    AppContext_1.AppContext.current.setHideAmounts(true);
	                }
	            }
	        }
	    };
	    HtmlHideButtonElement.prototype.hide = function (credit) {
	        if (credit === void 0) { credit = false; }
	        if (this.instance != null &&
	            this._hideClass != "" &&
	            (this._hideClass === "_hideBet" || (credit && this._hideClass === "_hideCredit"))) {
	            var elements = document.getElementsByClassName(this._hideClass);
	            var display = "none";
	            if (HtmlHideButtonElement.Buttons[this._hideClass] != null &&
	                HtmlHideButtonElement.Buttons[this._hideClass].length > 0) {
	                for (var j = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
	                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
	                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
	                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_on");
	                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")) {
	                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_off");
	                            }
	                        }
	                    }
	                }
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                if (element != null) {
	                    element.style.display = display;
	                }
	            }
	            if (this._hideClass === "_hideCredit") {
	                if (display === "block") {
	                    AppContext_1.AppContext.current.setHideAmounts(false);
	                }
	                else {
	                    AppContext_1.AppContext.current.setHideAmounts(true);
	                }
	            }
	        }
	    };
	    HtmlHideButtonElement.prototype.toggle = function () {
	        if (this.instance != null && this._hideClass != "") {
	            PlayList_1.PlayList.play("SND_Click");
	            var elements = document.getElementsByClassName(this._hideClass);
	            var display = "none";
	            if (HtmlHideButtonElement.Buttons[this._hideClass] != null &&
	                HtmlHideButtonElement.Buttons[this._hideClass].length > 0) {
	                for (var j = 0; j < HtmlHideButtonElement.Buttons[this._hideClass].length; j++) {
	                    if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance != null) {
	                        if (HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
	                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_on");
	                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_off")) {
	                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_off");
	                            }
	                        }
	                        else {
	                            HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.remove("_off");
	                            if (!HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.contains("_on")) {
	                                HtmlHideButtonElement.Buttons[this._hideClass][j].instance.classList.add("_on");
	                                display = "block";
	                            }
	                        }
	                    }
	                }
	            }
	            for (var i = 0; i < elements.length; i++) {
	                var element = elements[i];
	                if (element != null) {
	                    element.style.display = display;
	                }
	            }
	            if (this._hideClass === "_hideCredit") {
	                if (display === "block") {
	                    AppContext_1.AppContext.current.setHideAmounts(false);
	                }
	                else {
	                    AppContext_1.AppContext.current.setHideAmounts(true);
	                }
	            }
	        }
	    };
	    HtmlHideButtonElement.Buttons = {};
	    HtmlHideButtonElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlHideButtonElement);
	    return HtmlHideButtonElement;
	}(HtmlButtonElement_1.HtmlButtonElement));
	exports.HtmlHideButtonElement = HtmlHideButtonElement;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var HtmlController_1 = __webpack_require__(31);
	var ComponentTypes_1 = __webpack_require__(14);
	var Scaling_1 = __webpack_require__(8);
	var AppContext_1 = __webpack_require__(5);
	var DataManager_1 = __webpack_require__(26);
	var HtmlButtonElement = (function (_super) {
	    __extends(HtmlButtonElement, _super);
	    function HtmlButtonElement() {
	        _super.call(this);
	    }
	    HtmlButtonElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute("UIAction")) {
	            this.uiaction = node.getAttribute("UIAction").split(";");
	            if (!node.hasAttribute("Test")) {
	                this.setTestAttributes(node.getAttribute("UIAction"));
	            }
	            else {
	                this.instance.dataset["test"] = node.getAttribute("Test");
	            }
	            for (var i = 0; i < this.uiaction.length; i++) {
	                HtmlController_1.HtmlController.registerUiActionElement(this.uiaction[i], this);
	            }
	        }
	        if (node.hasAttribute("Action")) {
	            this.action = node.getAttribute("Action");
	            this.setTestAttributes(node.getAttribute("Action"));
	            HtmlController_1.HtmlController.registerActionElement(node.getAttribute("Action"), this);
	        }
	        if (node.hasAttribute("Test")) {
	            this.instance.dataset["test"] = node.getAttribute("Test");
	        }
	        if (this.action != null || this.uiaction != null) {
	            this.instance.addEventListener(HtmlButtonElement.Click, this.onClick.bind(this));
	            if (this.action != null) {
	                this.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	            this.instance.addEventListener(HtmlButtonElement.TouchStart, this.onTouchStart.bind(this));
	            this.instance.addEventListener(HtmlButtonElement.TouchEnd, this.onTouchEnd.bind(this));
	            this.instance.addEventListener("gesturestart", Scaling_1.Scaling.preventPropagation);
	            this.instance.addEventListener("gesturechange", Scaling_1.Scaling.preventPropagation);
	            this.instance.addEventListener("gestureend", Scaling_1.Scaling.preventPropagation);
	            this.instance.addEventListener("touchmove", Scaling_1.Scaling.preventPropagation);
	            if (AppContext_1.AppContext.gameDefinition.ClientHostType !== "Mobile") {
	                this.instance.addEventListener(HtmlButtonElement.MouseOver, this.onMouseOver.bind(this));
	            }
	        }
	    };
	    HtmlButtonElement.prototype.setTestAttributes = function (action) {
	        this.instance.dataset["test"] = this.renameTestAttributeValue(action);
	    };
	    HtmlButtonElement.prototype.renameTestAttributeValue = function (action) {
	        var isGamblePortraitButton = action.indexOf("GAMBLE_") != -1 && this.instance.classList.contains("btnGamble");
	        action = isGamblePortraitButton ? action + "_PORTRAIT" : action;
	        switch (action) {
	            case "QUICKSPIN_DIALOG_OFF":
	                if (this.instance.classList.contains("smallCloseBtn"))
	                    return "QUICKSPIN_DIALOG_CLOSE";
	                return "QUICKSPIN_DIALOG_NO";
	            case "QUICKSPIN_TOGGLE;QUICKSPIN_DIALOG_OFF":
	                return "QUICKSPIN_DIALOG_YES";
	            case "SETTINGS_OFF":
	                if (this.instance.classList.contains("smallCloseBtn"))
	                    return "SETTINGS_CLOSE";
	                if (this.instance.classList.contains("dialogBtn") ||
	                    this.instance.classList.contains("settingsPageBtn"))
	                    return "SETTINGS_OK";
	                return "SETTINGS_BACK";
	            case "QUICKSPIN_TOGGLE":
	                return "SETTINGS_TOGGLE";
	            case "EMPTY":
	                return "SIMILAR_GAMES_EXIT";
	            case "EXIT2":
	                return "EXIT_GAME";
	            case "EXIT":
	                return "HOME";
	            case "HELP_OFF":
	                if (this.instance.classList.contains("closeBtn"))
	                    return "HELP_CLOSE";
	                return "HELP_BACK";
	            case "PAYTABLE_OFF":
	                if (this.instance.classList.contains("closeBtn"))
	                    return "PAYTABLE_CLOSE";
	                return "PAYTABLE_BACK";
	            case "SETTINGS_ON":
	                return "SETTINGS";
	            case "HELP_ON":
	                return "HELP";
	            case "PAYTABLE_ON":
	                return "PAYTABLE";
	            default:
	                return action;
	        }
	    };
	    HtmlButtonElement.prototype.registerEvents = function () {
	        if (this.action != null || this.uiaction != null) {
	            this.instance.addEventListener(HtmlButtonElement.Click, this.onClick.bind(this));
	            if (this.action != null) {
	                this.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	    };
	    HtmlButtonElement.prototype.onClick = function (e) {
	        if (false) {
	            this.log("onClick action: " + this.action + " uiaction: " + this.uiaction);
	        }
	        if (this.instance != null && !this.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            if (e && !e.isTrusted && AppContext_1.AppContext.gameConfiguration.DisableUntrustedClicks) {
	                if (AppContext_1.AppContext.gameDefinition.ClientHostType !== "Mobile") {
	                    this.log("Untrusted action: " + this.action + ", ui: " + this.action);
	                    return;
	                }
	            }
	            if (e && e.isTrusted) {
	                DataManager_1.DataManager.addTrustedUserAction(this.action);
	            }
	            if (this.action != null) {
	                HtmlController_1.HtmlController.dispatchAction(this.action);
	            }
	            if (this.uiaction != null) {
	                for (var i = 0; i < this.uiaction.length; i++) {
	                    HtmlController_1.HtmlController.dispatchUiAction(this.uiaction[i]);
	                }
	            }
	        }
	    };
	    HtmlButtonElement.prototype.onTouchStart = function () {
	        clearTimeout(this.touchLockTimer);
	        this.touchLock = true;
	        if (this.instance != null && !this.instance.classList.contains("noHover")) {
	            this.instance.classList.add("noHover");
	        }
	    };
	    HtmlButtonElement.prototype.onTouchEnd = function () {
	        var _this = this;
	        this.touchLockTimer = setTimeout(function () {
	            _this.touchLock = false;
	        }, 20);
	    };
	    HtmlButtonElement.prototype.onMouseOver = function () {
	        if (this.instance != null && this.instance.classList.contains("noHover") && !this.touchLock) {
	            this.instance.classList.remove("noHover");
	        }
	    };
	    HtmlButtonElement.prototype.changeState = function (value) {
	        if (this.instance != null) {
	            if (value) {
	                this.instance.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	            }
	            else {
	                this.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no instance");
	            }
	        }
	    };
	    HtmlButtonElement.Click = "click";
	    HtmlButtonElement.TouchStart = "touchstart";
	    HtmlButtonElement.TouchEnd = "touchend";
	    HtmlButtonElement.MouseOver = "mouseover";
	    HtmlButtonElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlButtonElement);
	    return HtmlButtonElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlButtonElement = HtmlButtonElement;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var PlayList_1 = __webpack_require__(33);
	var DataManager_1 = __webpack_require__(26);
	var HtmlLanuageContainerElement = (function (_super) {
	    __extends(HtmlLanuageContainerElement, _super);
	    function HtmlLanuageContainerElement() {
	        _super.call(this);
	        this._flags = {};
	        this._values = {};
	        DataManager_1.DataManager.LangContainer = this;
	    }
	    HtmlLanuageContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.addValues();
	    };
	    HtmlLanuageContainerElement.prototype.addValues = function () {
	        var languages = AppContext_1.AppContext.current.getAllowedLanguages();
	        if (this.instance != null && languages != null) {
	            for (var i = 0; i < languages.length; i++) {
	                var flag = document.createElement("div");
	                flag.classList.add("flag");
	                flag.classList.add(languages[i]);
	                flag.style.display = "none";
	                flag.setAttribute("Lng", languages[i]);
	                flag.onclick = this.onValueClick.bind(this);
	                var value = document.createElement("div");
	                value.classList.add("value");
	                value.style.display = "none";
	                value.setAttribute("Lng", languages[i]);
	                value.onclick = this.onValueClick.bind(this);
	                if (AppContext_1.AppContext.current.getCurrentLanguage() != null &&
	                    languages[i] == AppContext_1.AppContext.current.getCurrentLanguage()) {
	                    flag.style.display = "block";
	                    value.style.display = "block";
	                }
	                this._flags[languages[i]] = flag;
	                this._values[languages[i]] = value;
	                this.instance.appendChild(flag);
	                this.instance.appendChild(value);
	            }
	        }
	    };
	    HtmlLanuageContainerElement.prototype.onValueClick = function (e) {
	        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Lng")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var lang = e.currentTarget.getAttribute("Lng");
	            if (this._flags != null) {
	                for (var key in this._flags) {
	                    this._flags[key].style.display = "none";
	                }
	            }
	            if (this._values != null) {
	                for (var key in this._values) {
	                    this._values[key].style.display = "none";
	                }
	            }
	            HtmlController_1.HtmlController.dispatchUiAction("");
	            this.changeLanguage();
	        }
	    };
	    HtmlLanuageContainerElement.prototype.changeLanguage = function (remote) {
	        if (remote === void 0) { remote = false; }
	        if (remote) {
	            PlayList_1.PlayList.play("SND_Click");
	            if (this._flags != null) {
	                for (var key in this._flags) {
	                    this._flags[key].style.display = "none";
	                }
	            }
	            if (this._values != null) {
	                for (var key in this._values) {
	                    this._values[key].style.display = "none";
	                }
	            }
	            HtmlController_1.HtmlController.dispatchUiAction("");
	        }
	        var actual = AppContext_1.AppContext.current.getCurrentLanguage();
	        var languages = AppContext_1.AppContext.current.getAllowedLanguages();
	        var next = "";
	        if (actual != null && languages != null) {
	            var index = 0;
	            for (var i = 0; i < languages.length; i++) {
	                if (languages[i] === actual) {
	                    index = i;
	                }
	            }
	            if (languages[index + 1] != null) {
	                next = languages[index + 1];
	            }
	            else {
	                next = languages[0];
	            }
	        }
	        if (this._flags[next] != null) {
	            this._flags[next].style.display = "block";
	        }
	        if (this._values[next] != null) {
	            this._values[next].style.display = "block";
	        }
	        AppContext_1.AppContext.current.setLanguage(next);
	    };
	    HtmlLanuageContainerElement.prototype.disable = function () {
	        if (this.instance != null) {
	            if (!this.instance.classList.contains("_disabled")) {
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlLanuageContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlLanuageContainerElement);
	    return HtmlLanuageContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlLanuageContainerElement = HtmlLanuageContainerElement;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var HtmlController_1 = __webpack_require__(31);
	var AppContext_1 = __webpack_require__(5);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var HtmlSoundContainerElement = (function (_super) {
	    __extends(HtmlSoundContainerElement, _super);
	    function HtmlSoundContainerElement() {
	        _super.call(this);
	        this._levels = ["", "", "", ""];
	        this._levelsClasses = ["_off", "_on1", "_on2", "_on3"];
	        this._index = 3;
	        HtmlController_1.HtmlController.SoundContainer = this;
	    }
	    HtmlSoundContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this._soundButton = document.getElementById("soundButton");
	        this._popup = document.createElement("div");
	        this._popup.classList.add("display");
	        this._popup.classList.add("popupSmall");
	        if (AppContext_1.AppContext.current.isBackgroundMusicEnabled) {
	            this._backgroundSound = document.createElement("div");
	            this._backgroundSound.classList.add("popupItem");
	            var backgroundSoundChild = document.createElement("div");
	            backgroundSoundChild.classList.add("popupValue");
	            backgroundSoundChild.classList.add("bgSound");
	            if (AppContext_1.AppContext.current.getBackgroundMusic()) {
	                backgroundSoundChild.classList.add("_on");
	            }
	            else {
	                backgroundSoundChild.classList.add("_off");
	                DataManager_1.DataManager.BackSoundsPlayingFromGame = false;
	                PlayList_1.PlayList.stopAllInGroup("BackgroundMusic");
	            }
	            backgroundSoundChild.onclick = this.onBackgroundClick.bind(this);
	            this._backgroundSound.appendChild(backgroundSoundChild);
	        }
	        if (this.instance != null) {
	            this.instance.appendChild(this._popup);
	            if (this._backgroundSound != null) {
	                this._popup.appendChild(this._backgroundSound);
	            }
	            if (AppContext_1.AppContext.current.isBackgroundMusicEnabled) {
	                this._popup.parentElement.classList.add("bgOn");
	            }
	        }
	        this.addValues();
	        this.block = true;
	        this.createTimeout();
	    };
	    HtmlSoundContainerElement.prototype.addValues = function () {
	        if (this._values == null && this._popup != null) {
	            this._values = [];
	            for (var i = 0; i < this._levels.length; i++) {
	                var popupItem = document.createElement("div");
	                popupItem.classList.add("popupItem");
	                popupItem.onclick = this.onValueClick.bind(this);
	                popupItem.setAttribute("Level", i.toString());
	                var popupItemValue = document.createElement("div");
	                popupItemValue.classList.add("popupValue");
	                popupItemValue.innerText = this._levels[i];
	                popupItem.appendChild(popupItemValue);
	                if (i == 0 && !AppContext_1.AppContext.current.isMuteVolumeAllowed) {
	                    popupItem.style.display = "none";
	                }
	                this._values.push(popupItem);
	                this._popup.appendChild(popupItem);
	            }
	            if (!AppContext_1.AppContext.current.isMuteVolumeAllowed) {
	                if (AppContext_1.AppContext.current.isBackgroundMusicEnabled) {
	                    this._height = 60 + ((this._levels.length - 1) * 60 + 48) + "px";
	                }
	                else {
	                    this._height = (this._levels.length - 1) * 60 + 48 + "px";
	                }
	            }
	            else {
	                if (AppContext_1.AppContext.current.isBackgroundMusicEnabled) {
	                    this._height = 60 + (this._levels.length * 60 + 48) + "px";
	                }
	                else {
	                    this._height = this._levels.length * 60 + 48 + "px";
	                }
	            }
	        }
	    };
	    HtmlSoundContainerElement.prototype.onValueClick = function (e) {
	        if (this.block) {
	            return;
	        }
	        this.setTimeout();
	        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Level")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var level = parseFloat(e.currentTarget.getAttribute("Level"));
	            if (level === this._index) {
	            }
	            else {
	                this._index = level;
	                if (this._values != null) {
	                    for (var i = 0; i < this._values.length; i++) {
	                        if (this._values[i].hasAttribute("Level")) {
	                            if (parseFloat(this._values[i].getAttribute("Level")) === level) {
	                                this._values[i].classList.add("_active");
	                            }
	                            else {
	                                this._values[i].classList.remove("_active");
	                            }
	                        }
	                    }
	                }
	                AppContext_1.AppContext.current.setVolume(level);
	            }
	        }
	        this.changeSoundButton();
	    };
	    HtmlSoundContainerElement.prototype.onBackgroundClick = function (e) {
	        if (this.block) {
	            return;
	        }
	        this.setTimeout();
	        if (e != null && e.currentTarget != null) {
	            PlayList_1.PlayList.play("SND_Click");
	            if (e.currentTarget.classList.contains("_on")) {
	                e.currentTarget.classList.remove("_on");
	                if (!e.currentTarget.classList.contains("_off")) {
	                    e.currentTarget.classList.add("_off");
	                }
	                DataManager_1.DataManager.BackSoundsPlayingFromGame = false;
	                AppContext_1.AppContext.current.setBackgroundMusic(false);
	                PlayList_1.PlayList.stopAllInGroup("BackgroundMusic");
	            }
	            else {
	                e.currentTarget.classList.remove("_off");
	                if (!e.currentTarget.classList.contains("_on")) {
	                    e.currentTarget.classList.add("_on");
	                }
	                DataManager_1.DataManager.BackSoundsPlayingFromGame = true;
	                AppContext_1.AppContext.current.setBackgroundMusic(true);
	                PlayList_1.PlayList.stopAllInGroup("BackgroundMusic", true);
	            }
	        }
	    };
	    HtmlSoundContainerElement.prototype.setLevel = function (level) {
	        this._index = level;
	        if (this._values != null) {
	            for (var i = 0; i < this._values.length; i++) {
	                if (i === level) {
	                    if (!this._values[i].classList.contains("_active")) {
	                        this._values[i].classList.add("_active");
	                    }
	                }
	                else {
	                    this._values[i].classList.remove("_active");
	                }
	            }
	        }
	        this.changeSoundButton();
	    };
	    HtmlSoundContainerElement.prototype.changeSoundButton = function () {
	        if (this._soundButton != null) {
	            if (this._levelsClasses[this._index] != null) {
	                for (var i = 0; i < this._levelsClasses.length; i++) {
	                    this._soundButton.classList.remove(this._levelsClasses[i]);
	                }
	                this._soundButton.classList.add(this._levelsClasses[this._index]);
	            }
	        }
	    };
	    HtmlSoundContainerElement.prototype.toggle = function () {
	        if (this.instance != null) {
	            if (this.instance.classList.contains("_disabled")) {
	                this.block = false;
	                this.setTimeout();
	                if (this._height != null) {
	                    this.instance.style.height = this._height;
	                }
	                this.instance.classList.remove("_disabled");
	            }
	            else {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlSoundContainerElement.prototype.disable = function () {
	        if (this.instance != null) {
	            if (!this.instance.classList.contains("_disabled")) {
	                this.block = true;
	                this.clearTimeOut();
	                this.instance.removeAttribute("style");
	                this.instance.classList.add("_disabled");
	            }
	        }
	    };
	    HtmlSoundContainerElement.prototype.createTimeout = function () {
	        this.timeout = null;
	    };
	    HtmlSoundContainerElement.prototype.setTimeout = function () {
	        var _this = this;
	        this.clearTimeOut();
	        var duration = AppContext_1.AppContext.gameConfiguration.SelectorRolloutDuration;
	        if (duration > 0) {
	            this.timeout = setTimeout(function () {
	                _this.disable();
	            }, duration * 1000);
	        }
	    };
	    HtmlSoundContainerElement.prototype.clearTimeOut = function () {
	        if (!neo_common_1.Utils.isNullOrUndefined(this.timeout)) {
	            clearTimeout(this.timeout);
	            this.timeout = null;
	        }
	    };
	    HtmlSoundContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlSoundContainerElement);
	    return HtmlSoundContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlSoundContainerElement = HtmlSoundContainerElement;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlButtonElement_1 = __webpack_require__(155);
	var AppContext_1 = __webpack_require__(5);
	var HtmlController_1 = __webpack_require__(31);
	var HtmlAutoplayItemButtonElement_1 = __webpack_require__(159);
	var HtmlAutoplayButtonElement = (function (_super) {
	    __extends(HtmlAutoplayButtonElement, _super);
	    function HtmlAutoplayButtonElement() {
	        _super.call(this);
	    }
	    HtmlAutoplayButtonElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (AppContext_1.AppContext.gameConfiguration.AutoplayMode === "basic") {
	            this.createBasicMode();
	        }
	        else if (AppContext_1.AppContext.gameConfiguration.AutoplayMode === "simple") {
	            this.createSimpleMode();
	        }
	        else if (AppContext_1.AppContext.gameConfiguration.AutoplayMode === "advanced") {
	            this.createAdvancedMode();
	        }
	        else {
	            this.createBasicMode();
	        }
	        if (this.instance != null) {
	            this.instance.parentElement.removeChild(this.instance);
	        }
	    };
	    HtmlAutoplayButtonElement.prototype.createBasicMode = function () {
	        this.removeOtherMode("simpleAutoplayButton");
	        this.removeOtherMode("advancedAutoplayButton");
	    };
	    HtmlAutoplayButtonElement.prototype.createSimpleMode = function () {
	        this.removeOtherMode("basicAutoplayButton");
	        this.removeOtherMode("advancedAutoplayButton");
	        this._simpleAutoplayCounts = [];
	        var holder = document.getElementById("autoplaySelectorHolder");
	        if (holder != null) {
	            if (AppContext_1.AppContext.gameConfiguration.AutoplayCounts != null &&
	                AppContext_1.AppContext.gameConfiguration.AutoplayCounts.length > 0) {
	                AppContext_1.AppContext.gameConfiguration.AutoplayCounts.reverse();
	                for (var i = 0; i < AppContext_1.AppContext.gameConfiguration.AutoplayCounts.length; i++) {
	                    var button = new HtmlAutoplayItemButtonElement_1.HtmlAutoplayItemButtonElement();
	                    var text = document.createElement("div");
	                    button.action = "AUTOPLAY";
	                    button.registerEvents();
	                    text.classList.add("autoplayCnt");
	                    if (AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] == -1) {
	                        text.innerText = "∞";
	                        button.autoplayCount = "∞";
	                    }
	                    else {
	                        text.innerText = AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] + "";
	                        button.autoplayCount = AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] + "";
	                    }
	                    button.instance.dataset["test"] = "AUTOPLAY_WIN_CNT_" + (i + 1);
	                    if (button.instance != null) {
	                        button.instance.classList.add("autoplayItem");
	                        button.instance.appendChild(text);
	                        HtmlController_1.HtmlController.registerActionElement("AUTOPLAY", button);
	                        if (holder != null) {
	                            holder.appendChild(button.instance);
	                        }
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayButtonElement.prototype.createAdvancedMode = function () {
	        this.removeOtherMode("basicAutoplayButton");
	        this.removeOtherMode("simpleAutoplayButton");
	    };
	    HtmlAutoplayButtonElement.prototype.removeOtherMode = function (cls) {
	        var elements = document.getElementsByClassName(cls);
	        for (var i = 0; i < elements.length; i++) {
	            var element = elements[i];
	            if (element != null) {
	                element.remove();
	            }
	        }
	    };
	    HtmlAutoplayButtonElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlAutoplayButtonElement);
	    return HtmlAutoplayButtonElement;
	}(HtmlButtonElement_1.HtmlButtonElement));
	exports.HtmlAutoplayButtonElement = HtmlAutoplayButtonElement;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlButtonElement_1 = __webpack_require__(155);
	var PlayList_1 = __webpack_require__(33);
	var DataManager_1 = __webpack_require__(26);
	var HtmlAutoplayItemButtonElement = (function (_super) {
	    __extends(HtmlAutoplayItemButtonElement, _super);
	    function HtmlAutoplayItemButtonElement() {
	        _super.call(this);
	        this.autoplayCount = "∞";
	    }
	    HtmlAutoplayItemButtonElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute("AUTOPLAY_COUNT")) {
	            this.autoplayCount = node.getAttribute("AUTOPLAY_COUNT");
	        }
	    };
	    HtmlAutoplayItemButtonElement.prototype.onClick = function () {
	        if (this.autoplayCount != null) {
	            DataManager_1.DataManager.AutoplayCount = this.autoplayCount;
	        }
	        PlayList_1.PlayList.play("SND_Click");
	        _super.prototype.onClick.call(this);
	    };
	    HtmlAutoplayItemButtonElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlAutoplayItemButtonElement);
	    return HtmlAutoplayItemButtonElement;
	}(HtmlButtonElement_1.HtmlButtonElement));
	exports.HtmlAutoplayItemButtonElement = HtmlAutoplayItemButtonElement;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var HtmlController_1 = __webpack_require__(31);
	var AppContext_1 = __webpack_require__(5);
	var BetManager_1 = __webpack_require__(25);
	var GameData_1 = __webpack_require__(24);
	var DataManager_1 = __webpack_require__(26);
	var PlayList_1 = __webpack_require__(33);
	var Languages_1 = __webpack_require__(28);
	var ModuleManager_1 = __webpack_require__(29);
	var BaseActions_1 = __webpack_require__(35);
	var BonusActions_1 = __webpack_require__(112);
	var HtmlAutoplayDialogContainerElement = (function (_super) {
	    __extends(HtmlAutoplayDialogContainerElement, _super);
	    function HtmlAutoplayDialogContainerElement() {
	        _super.call(this);
	        this._autoplayDialogCounts = [];
	        this._autoplayDialogLossLimit = [];
	        this._autoplayDialogWinLimit = [];
	        this._autoplayDialogSkipWin = [];
	        this._count = "∞";
	        this._loss = "∞";
	        this._win = "∞";
	    }
	    HtmlAutoplayDialogContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.createCounts();
	        this.createLossLimits();
	        this.createWinLimits();
	        this.createSkipWinButtons();
	        this._lossValueElement = document.getElementById("autoplayDialogLossLimitValue");
	        this._winValueElement = document.getElementById("autoplayDialogWinLimitValue");
	        this._button = document.getElementById("autoplayDialogButton");
	        this._button.onclick = this.runAutoplay.bind(this);
	        this.reset();
	    };
	    HtmlAutoplayDialogContainerElement.prototype.createCounts = function () {
	        if (HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogCounts"] != null) {
	            var element = HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogCounts"];
	            if (element != null && element.instance != null) {
	                if (AppContext_1.AppContext.gameConfiguration.AutoplayCounts != null &&
	                    AppContext_1.AppContext.gameConfiguration.AutoplayCounts.length > 0) {
	                    for (var i = 0; i < AppContext_1.AppContext.gameConfiguration.AutoplayCounts.length; i++) {
	                        var item = document.createElement("div");
	                        var itemValue = document.createElement("span");
	                        item.classList.add("settingItem");
	                        itemValue.classList.add("settingValue");
	                        if (AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] == -1) {
	                            itemValue.innerText = "∞";
	                            item.setAttribute("Val", "∞");
	                        }
	                        else {
	                            itemValue.innerText = AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] + "";
	                            item.setAttribute("Val", AppContext_1.AppContext.gameConfiguration.AutoplayCounts[i] + "");
	                        }
	                        item.dataset["test"] = "AUTOPLAY_CNT_" + (i + 1);
	                        item.appendChild(itemValue);
	                        item.onclick = this.onCountClick.bind(this);
	                        element.instance.appendChild(item);
	                        this._autoplayDialogCounts.push(item);
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.createLossLimits = function () {
	        if (HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogLossLimit"] != null) {
	            var element = HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogLossLimit"];
	            if (element != null && element.instance != null) {
	                if (AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit != null &&
	                    AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit.length > 0) {
	                    for (var i = 0; i < AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit.length; i++) {
	                        var item = document.createElement("div");
	                        var itemValue = document.createElement("span");
	                        item.classList.add("settingItem");
	                        itemValue.classList.add("settingValue");
	                        if (AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit[i] == -1) {
	                            itemValue.innerText = "∞";
	                            item.setAttribute("Val", "∞");
	                        }
	                        else {
	                            itemValue.innerText = "x" + AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit[i] + "";
	                            item.setAttribute("Val", AppContext_1.AppContext.gameConfiguration.AutoplayLossLimit[i] + "");
	                        }
	                        item.dataset["test"] = "AUTOPLAY_LOSS_CNT_" + (i + 1);
	                        item.appendChild(itemValue);
	                        item.onclick = this.onLossClick.bind(this);
	                        element.instance.appendChild(item);
	                        this._autoplayDialogLossLimit.push(item);
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.createWinLimits = function () {
	        if (HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogWinLimit"] != null) {
	            var element = HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogWinLimit"];
	            if (element != null && element.instance != null) {
	                if (AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit != null &&
	                    AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit.length > 0) {
	                    for (var i = 0; i < AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit.length; i++) {
	                        var item = document.createElement("div");
	                        var itemValue = document.createElement("span");
	                        item.classList.add("settingItem");
	                        itemValue.classList.add("settingValue");
	                        if (AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit[i] == -1) {
	                            itemValue.innerText = "∞";
	                            item.setAttribute("Val", "∞");
	                        }
	                        else {
	                            itemValue.innerText = "x" + AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit[i] + "";
	                            item.setAttribute("Val", AppContext_1.AppContext.gameConfiguration.AutoplaySingleWinLimit[i] + "");
	                        }
	                        item.dataset["test"] = "AUTOPLAY_WIN_CNT_" + (i + 1);
	                        item.appendChild(itemValue);
	                        item.onclick = this.onWinClick.bind(this);
	                        element.instance.appendChild(item);
	                        this._autoplayDialogWinLimit.push(item);
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.createSkipWinButtons = function () {
	        if (HtmlController_1.HtmlController.ContainerElementsById["autoplaySkipWinOption"] != null) {
	            var element = HtmlController_1.HtmlController.ContainerElementsById["autoplaySkipWinOption"];
	            if (element != null && element.instance != null) {
	                if (AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	                    neo_common_1.KeyboardUtils.bindKeyRelease("space", this.handleSkipWinSpaceBar);
	                    for (var i = 0; i < 2; i++) {
	                        var item = document.createElement("div");
	                        var itemValue = document.createElement("span");
	                        item.classList.add("settingItem");
	                        itemValue.classList.add("settingValue");
	                        itemValue.innerText = Languages_1.Languages.getRid(i == 0 ? "YES" : "NO");
	                        item.setAttribute("Val", i == 0 ? "true" : "false");
	                        item.appendChild(itemValue);
	                        item.onclick = this.onSkipWinClick.bind(this);
	                        element.instance.appendChild(item);
	                        this._autoplayDialogSkipWin.push(item);
	                    }
	                }
	                else {
	                    if (HtmlController_1.HtmlController.ContainerElementsById["autoplaySkipWinOption"] != null) {
	                        HtmlController_1.HtmlController.ContainerElementsById["autoplaySkipWinOption"].instance.style.display = "none";
	                    }
	                    if (HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogSkipWinOptionView"] != null) {
	                        HtmlController_1.HtmlController.ContainerElementsById["autoplayDialogSkipWinOptionView"].instance.style.display =
	                            "none";
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.handleSkipWinSpaceBar = function () {
	        if (HtmlController_1.HtmlController.ActionElements[BaseActions_1.BaseActions.ActionSkipWin] != null) {
	            var skipWinBtn = HtmlController_1.HtmlController.ActionElements[BaseActions_1.BaseActions.ActionSkipWin][0];
	            if (skipWinBtn != null && !skipWinBtn.instance.classList.contains("_disabled")) {
	                ModuleManager_1.ModuleManager.dispatchAction(BaseActions_1.BaseActions.ActionSkipWin);
	            }
	            var fsSkipWinBtn = HtmlController_1.HtmlController.ActionElements[BonusActions_1.BonusActions.ActionSkipWin][0];
	            if (fsSkipWinBtn != null && !fsSkipWinBtn.instance.classList.contains("_disabled")) {
	                ModuleManager_1.ModuleManager.dispatchAction(BonusActions_1.BonusActions.ActionSkipWin);
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.reset = function () {
	        this.resetCounts();
	        this.resetLossLimits();
	        this.resetWinLimits();
	        this.enableCounts();
	        this.resetSkipWin();
	        if (this._lossValueElement != null) {
	            this._lossValueElement.innerText = "";
	        }
	        if (this._winValueElement != null) {
	            this._winValueElement.innerText = "";
	        }
	        if (this._button != null && !this._button.classList.contains("_disabled")) {
	            this._button.classList.add("_disabled");
	        }
	        this._count = "∞";
	        this._loss = "∞";
	        this._win = "∞";
	        DataManager_1.DataManager.AutoplayCount = "∞";
	        DataManager_1.DataManager.AutoplayLossLimit = "∞";
	        DataManager_1.DataManager.AutoplayWinLimit = "∞";
	    };
	    HtmlAutoplayDialogContainerElement.prototype.resetCounts = function () {
	        if (this._autoplayDialogCounts != null && this._autoplayDialogCounts.length > 0) {
	            for (var i = 0; i < this._autoplayDialogCounts.length; i++) {
	                if (this._autoplayDialogCounts[i].classList.contains("_active")) {
	                    this._autoplayDialogCounts[i].classList.remove("_active");
	                }
	                if (!this._autoplayDialogCounts[i].classList.contains("_disabled")) {
	                    this._autoplayDialogCounts[i].classList.add("_disabled");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.resetLossLimits = function () {
	        if (this._autoplayDialogLossLimit != null && this._autoplayDialogLossLimit.length > 0) {
	            for (var i = 0; i < this._autoplayDialogLossLimit.length; i++) {
	                if (this._autoplayDialogLossLimit[i].classList.contains("_active")) {
	                    this._autoplayDialogLossLimit[i].classList.remove("_active");
	                }
	                if (!this._autoplayDialogLossLimit[i].classList.contains("_disabled")) {
	                    this._autoplayDialogLossLimit[i].classList.add("_disabled");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.resetSkipWin = function () {
	        DataManager_1.DataManager.AutoplaySkipWinAnimationsEnabled = false;
	        for (var i = 0; i < this._autoplayDialogSkipWin.length; i++) {
	            var item = this._autoplayDialogSkipWin[i];
	            item.classList.remove("_active");
	            if (item.hasAttribute("Val")) {
	                if (item.getAttribute("Val") == "false") {
	                    item.classList.add("_active");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.resetWinLimits = function () {
	        if (this._autoplayDialogWinLimit != null && this._autoplayDialogWinLimit.length > 0) {
	            for (var i = 0; i < this._autoplayDialogWinLimit.length; i++) {
	                if (this._autoplayDialogWinLimit[i].classList.contains("_active")) {
	                    this._autoplayDialogWinLimit[i].classList.remove("_active");
	                }
	                if (!this._autoplayDialogWinLimit[i].classList.contains("_disabled")) {
	                    this._autoplayDialogWinLimit[i].classList.add("_disabled");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.enableCounts = function () {
	        if (this._autoplayDialogCounts != null && this._autoplayDialogCounts.length > 0) {
	            for (var i = 0; i < this._autoplayDialogCounts.length; i++) {
	                if (this._autoplayDialogCounts[i].classList.contains("_disabled")) {
	                    this._autoplayDialogCounts[i].classList.remove("_disabled");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.enableLossLimits = function () {
	        if (this._autoplayDialogLossLimit != null && this._autoplayDialogLossLimit.length > 0) {
	            for (var i = 0; i < this._autoplayDialogLossLimit.length; i++) {
	                if (this._autoplayDialogLossLimit[i].classList.contains("_disabled")) {
	                    this._autoplayDialogLossLimit[i].classList.remove("_disabled");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.enableWinLimits = function (removeNoLimit) {
	        if (removeNoLimit === void 0) { removeNoLimit = false; }
	        var enabledNoLimit = true;
	        var noLimit;
	        if (this._autoplayDialogWinLimit != null && this._autoplayDialogWinLimit.length > 0) {
	            for (var i = 0; i < this._autoplayDialogWinLimit.length; i++) {
	                if (this._autoplayDialogWinLimit[i].classList.contains("_active")) {
	                    enabledNoLimit = false;
	                }
	                if (this._autoplayDialogWinLimit[i].getAttribute("Val") == "∞") {
	                    noLimit = this._autoplayDialogWinLimit[i];
	                }
	                if (this._autoplayDialogWinLimit[i].classList.contains("_disabled")) {
	                    this._autoplayDialogWinLimit[i].classList.remove("_disabled");
	                }
	            }
	        }
	        if (enabledNoLimit && !removeNoLimit) {
	            if (noLimit != null) {
	                if (!noLimit.classList.contains("_active")) {
	                    noLimit.classList.add("_active");
	                    if (this._winValueElement != null) {
	                        this._winValueElement.innerText = "∞";
	                    }
	                }
	            }
	        }
	        if (removeNoLimit) {
	            if (noLimit != null) {
	                if (noLimit.classList.contains("_active")) {
	                    noLimit.classList.remove("_active");
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.onCountClick = function (e) {
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("Val") &&
	            !e.currentTarget.classList.contains("_disabled")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var val = e.currentTarget.getAttribute("Val");
	            this.resetCounts();
	            this.enableCounts();
	            if (!e.currentTarget.classList.contains("_active")) {
	                e.currentTarget.classList.add("_active");
	            }
	            if (e.currentTarget.classList.contains("_disabled")) {
	                e.currentTarget.classList.remove("_disabled");
	            }
	            this._count = val;
	            this.enableLossLimits();
	            if (document.getElementById("autoplayDialogLossLimitView") != null) {
	                document.getElementById("autoplayDialogLossLimitView").scrollIntoView(true);
	                if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	                    document.getElementById("screen").scrollTop = 0;
	                    document.getElementById("root").scrollTop = 0;
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.onLossClick = function (e) {
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("Val") &&
	            !e.currentTarget.classList.contains("_disabled")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var val = e.currentTarget.getAttribute("Val");
	            if (this._lossValueElement != null) {
	                if (val != "∞" && BetManager_1.BetManager.Bet != null) {
	                    var calculatedValue = neo_common_1.NumberUtils.multiply(val, BetManager_1.BetManager.Bet);
	                    this._lossValueElement.innerText =
	                        calculatedValue + " " + DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	                }
	                else {
	                    this._lossValueElement.innerText = "∞";
	                }
	            }
	            this.resetLossLimits();
	            this.enableLossLimits();
	            if (!e.currentTarget.classList.contains("_active")) {
	                e.currentTarget.classList.add("_active");
	            }
	            if (e.currentTarget.classList.contains("_disabled")) {
	                e.currentTarget.classList.remove("_disabled");
	            }
	            if (this._button != null && this._button.classList.contains("_disabled")) {
	                this._button.classList.remove("_disabled");
	            }
	            this._loss = val;
	            this.enableWinLimits();
	            if (document.getElementById("autoplayDialogWinLimitView") != null) {
	                document.getElementById("autoplayDialogWinLimitView").scrollIntoView(true);
	            }
	            if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	                document.getElementById("screen").scrollTop = 0;
	                document.getElementById("root").scrollTop = 0;
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.onWinClick = function (e) {
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("Val") &&
	            !e.currentTarget.classList.contains("_disabled")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var val = e.currentTarget.getAttribute("Val");
	            if (this._winValueElement != null) {
	                if (val != "∞" && BetManager_1.BetManager.Bet != null) {
	                    var calculatedValue = neo_common_1.NumberUtils.multiply(val, BetManager_1.BetManager.Bet);
	                    this._winValueElement.innerText =
	                        calculatedValue + " " + DataManager_1.DataManager.getDataById(GameData_1.GameData.DataCurrency);
	                }
	                else {
	                    this._winValueElement.innerText = "∞";
	                }
	            }
	            this.resetWinLimits();
	            this.enableWinLimits(true);
	            if (!e.currentTarget.classList.contains("_active")) {
	                e.currentTarget.classList.add("_active");
	            }
	            if (e.currentTarget.classList.contains("_disabled")) {
	                e.currentTarget.classList.remove("_disabled");
	            }
	            this._win = val;
	            if (AppContext_1.AppContext.gameConfiguration.AutoplaySkipWinAnimationsEnabled) {
	                if (document.getElementById("autoplaySkipWinOption") != null) {
	                    document.getElementById("autoplaySkipWinOption").scrollIntoView(true);
	                }
	                if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	                    document.getElementById("screen").scrollTop = 0;
	                    document.getElementById("root").scrollTop = 0;
	                }
	            }
	            else {
	                if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	                    if (document.getElementById("autoplayDialogButton") != null) {
	                        document.getElementById("autoplayDialogButton").scrollIntoView(true);
	                        document.getElementById("screen").scrollTop = 0;
	                        document.getElementById("root").scrollTop = 0;
	                    }
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.onSkipWinClick = function (e) {
	        if (e != null &&
	            e.currentTarget != null &&
	            e.currentTarget.hasAttribute("Val") &&
	            !e.currentTarget.classList.contains("_disabled")) {
	            PlayList_1.PlayList.play("SND_Click");
	            var val = e.currentTarget.getAttribute("Val");
	            DataManager_1.DataManager.AutoplaySkipWinAnimationsEnabled = val == "true";
	            for (var i = 0; i < this._autoplayDialogSkipWin.length; i++) {
	                var item = this._autoplayDialogSkipWin[i];
	                item.classList.remove("_active");
	            }
	            e.currentTarget.classList.add("_active");
	            if (AppContext_1.AppContext.gameDefinition.ClientHostType === "Mobile") {
	                if (document.getElementById("autoplayDialogButton") != null) {
	                    document.getElementById("autoplayDialogButton").scrollIntoView(true);
	                    document.getElementById("screen").scrollTop = 0;
	                    document.getElementById("root").scrollTop = 0;
	                }
	            }
	        }
	    };
	    HtmlAutoplayDialogContainerElement.prototype.runAutoplay = function (e) {
	        if (e != null && e.currentTarget != null && !e.currentTarget.classList.contains("_disabled")) {
	            if (document.getElementById("autoPlayDialogTop") != null) {
	                document.getElementById("autoPlayDialogTop").scrollTop = 0;
	            }
	            if (this._count != null) {
	                DataManager_1.DataManager.AutoplayCount = this._count;
	            }
	            if (this._loss != null && BetManager_1.BetManager.Bet != null) {
	                if (this._loss == "∞") {
	                    DataManager_1.DataManager.AutoplayLossLimit = this._loss;
	                }
	                else {
	                    DataManager_1.DataManager.AutoplayLossLimit = neo_common_1.NumberUtils.multiply(this._loss, BetManager_1.BetManager.Bet);
	                }
	            }
	            if (this._win != null && BetManager_1.BetManager.Bet != null) {
	                if (this._win == "∞") {
	                    DataManager_1.DataManager.AutoplayWinLimit = this._win;
	                }
	                else {
	                    DataManager_1.DataManager.AutoplayWinLimit = neo_common_1.NumberUtils.multiply(this._win, BetManager_1.BetManager.Bet);
	                }
	            }
	            HtmlController_1.HtmlController.dispatchAction("AUTOPLAY");
	        }
	    };
	    HtmlAutoplayDialogContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlAutoplayDialogContainerElement);
	    return HtmlAutoplayDialogContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlAutoplayDialogContainerElement = HtmlAutoplayDialogContainerElement;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlElement_1 = __webpack_require__(75);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlCanvasElement = (function (_super) {
	    __extends(HtmlCanvasElement, _super);
	    function HtmlCanvasElement() {
	        _super.call(this, "");
	    }
	    HtmlCanvasElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute("CanvasId")) {
	            this.instance = document.getElementById(node.getAttribute("CanvasId"));
	            if (this.instance == null) {
	                if (false) {
	                    this.log("ERROR no element with id: " + node.getAttribute("CanvasId"));
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no CanvasId");
	            }
	        }
	    };
	    HtmlCanvasElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlCanvasElement);
	    return HtmlCanvasElement;
	}(HtmlElement_1.HtmlElement));
	exports.HtmlCanvasElement = HtmlCanvasElement;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var HtmlButtonElement_1 = __webpack_require__(155);
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlController_1 = __webpack_require__(31);
	var HtmlCheckboxElement = (function (_super) {
	    __extends(HtmlCheckboxElement, _super);
	    function HtmlCheckboxElement() {
	        _super.call(this);
	        this.checkbox = null;
	    }
	    HtmlCheckboxElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.createCheckBox();
	    };
	    HtmlCheckboxElement.prototype.createCheckBox = function () {
	        this.checkbox = document.createElement("input");
	        this.checkbox.type = "checkbox";
	        this.checkbox.classList.add("checkbox");
	        this.checkbox.addEventListener("input", this.onCheckbox.bind(this));
	        if (this.instance != null) {
	            this.instance.appendChild(this.checkbox);
	        }
	        this.instance.classList.add("checkboxButton");
	    };
	    HtmlCheckboxElement.prototype.onClick = function () {
	    };
	    HtmlCheckboxElement.prototype.onCheckbox = function () {
	        if (false) {
	            this.log("onClick action: " + this.action + " uiaction: " + this.uiaction);
	        }
	        if (this.instance != null && !this.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	            if (this.action != null) {
	                HtmlController_1.HtmlController.dispatchAction(this.action);
	            }
	            if (this.uiaction != null) {
	                for (var i = 0; i < this.uiaction.length; i++) {
	                    HtmlController_1.HtmlController.dispatchUiAction(this.uiaction[i]);
	                }
	            }
	        }
	    };
	    HtmlCheckboxElement.prototype.setText = function (value) {
	        if (value === undefined || value === null) {
	            this.checkbox.checked = !this.checkbox.checked;
	            return;
	        }
	        if (value == "true") {
	            if (this.checkbox.checked) {
	                return;
	            }
	            this.checkbox.checked = true;
	        }
	        else {
	            if (!this.checkbox.checked) {
	                return;
	            }
	            this.checkbox.checked = false;
	        }
	    };
	    HtmlCheckboxElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlCheckboxElement);
	    return HtmlCheckboxElement;
	}(HtmlButtonElement_1.HtmlButtonElement));
	exports.HtmlCheckboxElement = HtmlCheckboxElement;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlController_1 = __webpack_require__(31);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerElement_1 = __webpack_require__(74);
	var AppContext_1 = __webpack_require__(5);
	var DataManager_1 = __webpack_require__(26);
	var HtmlCustomContainerElement = (function (_super) {
	    __extends(HtmlCustomContainerElement, _super);
	    function HtmlCustomContainerElement() {
	        _super.call(this);
	    }
	    HtmlCustomContainerElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	    };
	    HtmlCustomContainerElement.prototype.changeState = function (value) {
	        if (this._withGamble == null) {
	            this._withGamble = document.getElementById("withGamble");
	        }
	        if (this._withoutGamble == null) {
	            this._withoutGamble = document.getElementById("withoutGamble");
	        }
	        if (this.instance != null) {
	            if (value && DataManager_1.DataManager.Autoplay) {
	                this.instance.classList.remove(HtmlController_1.HtmlController.DisabledClass);
	                if (AppContext_1.AppContext.gameDefinition.Gamble) {
	                    if (this._withGamble != null) {
	                        this._withGamble.style.display = "block";
	                    }
	                    if (this._withoutGamble != null) {
	                        this._withoutGamble.style.display = "none";
	                    }
	                }
	                else {
	                    if (this._withGamble != null) {
	                        this._withGamble.style.display = "none";
	                    }
	                    if (this._withoutGamble != null) {
	                        this._withoutGamble.style.display = "block";
	                    }
	                }
	            }
	            else {
	                if (!this.instance.classList.contains(HtmlController_1.HtmlController.DisabledClass)) {
	                    this.instance.classList.add(HtmlController_1.HtmlController.DisabledClass);
	                }
	            }
	        }
	        else {
	            if (false) {
	                this.log("ERROR no instance");
	            }
	        }
	    };
	    HtmlCustomContainerElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlCustomContainerElement);
	    return HtmlCustomContainerElement;
	}(HtmlContainerElement_1.HtmlContainerElement));
	exports.HtmlCustomContainerElement = HtmlCustomContainerElement;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlElement_1 = __webpack_require__(75);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlDataSliderElement = (function (_super) {
	    __extends(HtmlDataSliderElement, _super);
	    function HtmlDataSliderElement() {
	        _super.call(this);
	    }
	    HtmlDataSliderElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	    };
	    HtmlDataSliderElement.prototype.setText = function (value) {
	        if (value != null) {
	            var parsedValue = value.split("/");
	            if (this.instance != null && parsedValue.length === 2) {
	                this.instance.style.width = (parseInt(parsedValue[0]) / parseInt(parsedValue[1])) * 100 + "%";
	            }
	        }
	    };
	    HtmlDataSliderElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlDataSliderElement);
	    return HtmlDataSliderElement;
	}(HtmlElement_1.HtmlElement));
	exports.HtmlDataSliderElement = HtmlDataSliderElement;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlElement_1 = __webpack_require__(75);
	var HtmlLabelElement = (function (_super) {
	    __extends(HtmlLabelElement, _super);
	    function HtmlLabelElement() {
	        _super.call(this);
	    }
	    HtmlLabelElement.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        if (node.hasAttribute("For")) {
	            this.for = node.getAttribute("For");
	        }
	        this.createLabel();
	        if (this.instance != null) {
	            this.instance.parentElement.removeChild(this.instance);
	        }
	    };
	    HtmlLabelElement.prototype.createLabel = function () {
	        var holder = this.instance.parentElement;
	        var toggleSwitch = document.createElement("div");
	        var label = document.createElement("label");
	        toggleSwitch.classList.add("toggleSwitch");
	        label.htmlFor = this.for;
	        label.innerHTML = this.instance.innerHTML;
	        toggleSwitch.appendChild(label);
	        if (this.instance != null) {
	            holder.firstChild.appendChild(toggleSwitch);
	        }
	    };
	    HtmlLabelElement = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlLabelElement);
	    return HtmlLabelElement;
	}(HtmlElement_1.HtmlElement));
	exports.HtmlLabelElement = HtmlLabelElement;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlElement_1 = __webpack_require__(75);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlText = (function (_super) {
	    __extends(HtmlText, _super);
	    function HtmlText() {
	        _super.call(this, "");
	    }
	    HtmlText.prototype.create = function (node) {
	        this.instance = document.createElement(node.nodeName);
	        if (node.textContent != null) {
	            this.instance.textContent = node.textContent;
	        }
	        if (node.hasAttribute("Prefix")) {
	            this._prefix = node.getAttribute("Prefix");
	        }
	        if (node.hasAttribute("Test")) {
	            this.instance.dataset["test"] = node.getAttribute("Test");
	        }
	        _super.prototype.create.call(this, node);
	    };
	    HtmlText.prototype.setText = function (value) {
	        _super.prototype.setText.call(this, value);
	        if (this._prefix != null && this.instance.innerHTML != null && this.instance.innerHTML != "") {
	            this.instance.innerHTML = "+" + this.instance.innerHTML;
	        }
	    };
	    HtmlText = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlElement)
	    ], HtmlText);
	    return HtmlText;
	}(HtmlElement_1.HtmlElement));
	exports.HtmlText = HtmlText;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var HtmlStyle_1 = __webpack_require__(168);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlContainerStyle = (function (_super) {
	    __extends(HtmlContainerStyle, _super);
	    function HtmlContainerStyle() {
	        _super.call(this);
	    }
	    HtmlContainerStyle.prototype.create = function (node) {
	        _super.prototype.create.call(this, node);
	        this.node = node;
	    };
	    HtmlContainerStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlStyle)
	    ], HtmlContainerStyle);
	    return HtmlContainerStyle;
	}(HtmlStyle_1.HtmlStyle));
	exports.HtmlContainerStyle = HtmlContainerStyle;


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(2);
	var ComponentTypes_1 = __webpack_require__(14);
	var HtmlStyle = (function () {
	    function HtmlStyle() {
	    }
	    HtmlStyle.prototype.create = function (node) { };
	    HtmlStyle.prototype.log = function (s) {
	        if (false) {
	            var compName = this.__componentName__;
	            neo_common_1.Logger.debugGroup(compName, s);
	        }
	    };
	    HtmlStyle = __decorate([
	        neo_common_1.engineComponent(ComponentTypes_1.ComponentTypes.HtmlStyle)
	    ], HtmlStyle);
	    return HtmlStyle;
	}());
	exports.HtmlStyle = HtmlStyle;


/***/ },
/* 169 */
/***/ function(module, exports) {

	console.log("pixiInitialize");
	var ios = !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
	if (ios) {
	    PIXI.settings.PRECISION = PIXI.PRECISION.HIGH;
	}
	PIXI.settings.GC_MODE = PIXI.GC_MODES.AUTO;


/***/ }
/******/ ])))));


/** WEBPACK FOOTER **
 ** ./wwwroot/scripts/neo-moneyVaults.min.js
 **/